const COMMON_CONSTANTS_NUMBERS = {
    N0: 0,
    N1: 1,
    N2: 2,
    N3: 3,
    N4: 4,
    N5: 5,
    N6: 6,
    N7: 7,
    N8: 8,
    N9: 9,
    N320: 320,
    N578: 578,
    N1024: 1024,
    N1280: 1280,
    N1440: 1440,
    N10: 10,
    Negative25: -25,
    N100: 100,
};
class BcCommonConstants {
}
BcCommonConstants.PREFIX_LIB = 'bc';
BcCommonConstants.ID = 'id';
BcCommonConstants.DISABLED = 'disabled';
BcCommonConstants.INDETERMINATED = 'indeterminate';
BcCommonConstants.DISABLE_CLASS = 'bc-disable';
BcCommonConstants.HIDDEN = 'hidden';
BcCommonConstants.TEXT_GRAY = 'text-gray';
BcCommonConstants.INVISIBLE_CLASS = 'bc-invisible';
BcCommonConstants.X_SMALL_CLASS = 'bc-xs';
BcCommonConstants.SMALL = 'small';
BcCommonConstants.X_SMALL = 'xSmall';
BcCommonConstants.EVENT_CANCEL = 'cancelSelection';
BcCommonConstants.EVENT_RANGE = 'selectRange';
BcCommonConstants.EVENT_SELECT = 'selectDate';
BcCommonConstants.EVENT_CLICK = 'click';
BcCommonConstants.EVENT_FOCUS = 'focus';
BcCommonConstants.EVENT_FOCUSOUT = 'focusout';
BcCommonConstants.EVENT_BLUR = 'blur';
BcCommonConstants.EVENT_RESIZE = 'resize';
BcCommonConstants.ICONS_CLASS = 'bc-icon';
BcCommonConstants.ICON_XL_CLASS = 'bc-xl';
BcCommonConstants.ICON_SM_CLASS = 'bc-sm';
BcCommonConstants.ICON_XS_CLASS = 'bc-xs';
BcCommonConstants.ICON_ARROW_DOWN = 'arrow2-down';
BcCommonConstants.ICON_ARROW_LEFT = 'arrow2-left';
BcCommonConstants.ICON_ARROW_RIGHT = 'arrow2-right';
BcCommonConstants.ICON_ARROW_UP = 'arrow2-up';
BcCommonConstants.ICON_ERROR = 'error';
BcCommonConstants.FADE_OUT_OPACITY = 'fade-out-opacity';
BcCommonConstants.SLIDE_UP_REVERSE = 'slide-up-reverse';
BcCommonConstants.BC_BTN_CLASS = 'bc-button';
BcCommonConstants.BC_LINK_CLASS = 'bc-link';
BcCommonConstants.BC_BUTTON_ICON_CLASS = 'bc-button-icon';
BcCommonConstants.BC_TOOLTIP_CLASS = 'bc-tooltip';
BcCommonConstants.BC_TOOLTIP_TEXT = 'bctooltiptext';
BcCommonConstants.BC_ALIGN_ITEMS_CENTER_CLASS = 'bc-align-items-center';
BcCommonConstants.BC_ALIGN_ITEMS_BASELINE_CLASS = 'bc-align-items-baseline';
BcCommonConstants.BC_TEXT_DECORATION_UNDERLINE = 'bc-text-decoration-underline';
BcCommonConstants.BTN_PRIMARY_CLASS = 'bc-button-primary';
BcCommonConstants.BTN_SECONDARY_CLASS = 'bc-button-secondary';
BcCommonConstants.BTN_TERCIARY_CLASS = 'bc-button-terciary';
BcCommonConstants.BUTTON_SMALL_CLASS = 'bc-button-small';
BcCommonConstants.BUTTON_FAB_CLASS = 'bc-fab-button';
BcCommonConstants.BUTTON_FAB_MINI_CLASS = 'bc-fab-button-mini';
BcCommonConstants.CONTAINER_CHECKBOX_CLASS = 'bc-container-checkbox';
BcCommonConstants.CHECKBOX_CLASS = 'bc-checkbox';
BcCommonConstants.STYLE = 'style';
BcCommonConstants.DISPLAY = 'display';
BcCommonConstants.CHECKED = 'checked';
BcCommonConstants.NONE = 'none';
BcCommonConstants.BLOCK = 'block';
BcCommonConstants.FLEX = 'flex';
BcCommonConstants.OPEN = 'open';
BcCommonConstants.EVENT_MOUSEDOWN = 'mousedown';
BcCommonConstants.EVENT_MOUSEOVER = 'mouseover';
BcCommonConstants.EVENT_MOUSEOUT = 'mouseout';
BcCommonConstants.EVENT_MOUSEENTER = 'mouseenter';
BcCommonConstants.EVENT_MOUSELEAVE = 'mouseleave';
BcCommonConstants.EVENT_MOUSEUP = 'mouseup';
BcCommonConstants.EVENT_MEMU_ITEMS = 'itemsEvent';
BcCommonConstants.EVENT_HEADER_TOGGLE_MENU = 'toggleMenu';
BcCommonConstants.EVENT_HEADER_EXIST = 'headerReady';
BcCommonConstants.EVENT_MENU_EXIST = 'menuReady';
BcCommonConstants.EVENT_MENU_ITEM_OPENED = 'itemOpened';
BcCommonConstants.EVENT_KEY_DOWN = 'keydown';
BcCommonConstants.EVENT_KEY_UP = 'keyup';
BcCommonConstants.EVENT_KEY_PRESS = 'keypress';
BcCommonConstants.EVENT_INPUT = 'input';
BcCommonConstants.EVENT_CHANGE = 'change';
BcCommonConstants.EVENT_LOAD = 'load';
BcCommonConstants.EVENT_SCROLL = 'scroll';
BcCommonConstants.EVENT_COPY = 'copy';
BcCommonConstants.EVENT_PASTE = 'paste';
BcCommonConstants.EVENT_CUT = 'cut';
BcCommonConstants.KEY_EVENT_ARROW_DOWN = 'ArrowDown';
BcCommonConstants.KEY_EVENT_ARROW_UP = 'ArrowUp';
BcCommonConstants.KEY_EVENT_ENTER = 'Enter';
BcCommonConstants.KEY_EVENT_ESCAPE = 'Escape';
BcCommonConstants.KEY_EVENT_SPACE = 'Space';
BcCommonConstants.KEY_EVENT_ARROW_RIGHT = 'ArrowRight';
BcCommonConstants.KEY_EVENT_ARROW_LEFT = 'ArrowLeft';
BcCommonConstants.KEY_EVENT_HOME = 'Home';
BcCommonConstants.KEY_EVENT_END = 'End';
BcCommonConstants.KEY_EVENT_PAGE_UP = 'PageUp';
BcCommonConstants.KEY_EVENT_ALT = 'Alt';
BcCommonConstants.KEY_EVENT_PAGE_DOWN = 'PageDown';
BcCommonConstants.CLOSE_ALERT_EVENT = 'onCloseAlert';
BcCommonConstants.CLOSE_NOTIFICATION_EVENT = 'onCloseNotification';
BcCommonConstants.ARIA_CONTROL = 'aria-controls';
BcCommonConstants.ARIA_LABEL = 'aria-label';
BcCommonConstants.ARIA_CURRENT = 'aria-current';
BcCommonConstants.ARIA_EXPANDED = "aria-expanded";
BcCommonConstants.ARIA_ACTION_ID = 'aria-action-id';
BcCommonConstants.BUTTON_TAG = 'button';
BcCommonConstants.TAG_CLASS = 'bc-tag';
BcCommonConstants.DIV_TAG = 'div';
BcCommonConstants.TAG_TAG = 'tag';
BcCommonConstants.ASIDE_TAG = 'aside';
BcCommonConstants.SECTION_TAG = 'section';
BcCommonConstants.OUTLINE_ELEMENT = 'outline-element';
BcCommonConstants.ARTICLE_TAG = 'article';
BcCommonConstants.INPUT_TAG = 'input';
BcCommonConstants.SPAN_TAG = 'span';
BcCommonConstants.LABEL_TAG = 'label';
BcCommonConstants.IMG_TAG = 'img';
BcCommonConstants.EM_TAG = 'em';
BcCommonConstants.UL_TAG = 'ul';
BcCommonConstants.LI_TAG = 'li';
BcCommonConstants.P_TAG = 'p';
BcCommonConstants.I_TAG = 'i';
BcCommonConstants.H1_TAG = 'h1';
BcCommonConstants.H2_TAG = 'h2';
BcCommonConstants.H3_TAG = 'h3';
BcCommonConstants.H4_TAG = 'h4';
BcCommonConstants.H5_TAG = 'h5';
BcCommonConstants.H6_TAG = 'h6';
BcCommonConstants.TH_TAG = 'th';
BcCommonConstants.HREF_TAG = 'a';
BcCommonConstants.TEXTAREA_TAG = 'textarea';
BcCommonConstants.ATTR_HREF = 'href';
BcCommonConstants.CUSTOM_CELL = 'bc-custom-cell';
BcCommonConstants.BREAKPOINT_XS = COMMON_CONSTANTS_NUMBERS.N320;
BcCommonConstants.BREAKPOINT_SM = COMMON_CONSTANTS_NUMBERS.N578;
BcCommonConstants.BREAKPOINT_MD = COMMON_CONSTANTS_NUMBERS.N1024;
BcCommonConstants.BREAKPOINT_LG = COMMON_CONSTANTS_NUMBERS.N1280;
BcCommonConstants.BREAKPOINT_XL = COMMON_CONSTANTS_NUMBERS.N1440;
BcCommonConstants.BC_DROPDOWN_CLASS = 'bc-dropdown';
BcCommonConstants.BC_DROPDOWN_CUSTOM_CLASS = 'bc-dropdown-custom';
BcCommonConstants.BC_DROPDOWN_UNDISMISS_CLASS = 'bc-dropdown-undismiss';
BcCommonConstants.BC_DROPDOWN_CLOSE_BTN_CLASS = 'bc-dropdown-close-button';
BcCommonConstants.BC_ARROW_DOWN_ICON = 'arrow-down';
BcCommonConstants.BC_ARROW_UP_ICON = 'arrow-up';
BcCommonConstants.INPUT_TEXT_TYPE = 'text';
BcCommonConstants.CURSOR_POINTER = 'pointer';
BcCommonConstants.MARGIN_LEFT = 'margin-left';
BcCommonConstants.MARGIN_RIGHT = 'margin-right';
BcCommonConstants.BORDER_LEFT_WIDTH = 'border-left-width';
BcCommonConstants.BORDER_RIGHT_WIDTH = 'border-right-width';
BcCommonConstants.PADDING_LEFT = 'padding-left';
BcCommonConstants.PADDING_RIGHT = 'padding-right';
BcCommonConstants.ARIA_SELECTED = 'aria-selected';
BcCommonConstants.ARIA_POSINSET = 'aria-posinset';
BcCommonConstants.AFTER_BEGIN = 'afterbegin';
BcCommonConstants.AFTER_END = 'afterend';
BcCommonConstants.ROLE = 'role';
BcCommonConstants.SCROLL = 'scroll';
BcCommonConstants.KEY_EVENT_ENTER_NUM = '13';
BcCommonConstants.KEY_EVENT_SPACE_NUM = '32';
BcCommonConstants.KEY_TAB = 'tab';
BcCommonConstants.TR_TAG = 'tr';
BcCommonConstants.TD_TAG = 'td';
BcCommonConstants.FALSE = false;
BcCommonConstants.TRUE = true;
BcCommonConstants.NULL = null;
BcCommonConstants.UNDEFINED = undefined;

const METHOD_NOT_IMPLEMENTED = 'Method not implemented.';
const ID_NOT_FOUND = 'The given id is not present in the DOM';
const ELEMENT_IS_INVALID = 'The element inside in object is not valid.';
class BcDefaultBehavior {
    constructor() {
        this.disabled = false;
        this.isReady = false;
    }
    _setUp() {
        if (this.mySelf === undefined || this.mySelf === null) {
            throw new Error(ELEMENT_IS_INVALID);
        }
    }
    setId(id) {
        this._id = id;
        this.mySelf = document.getElementById(this._id);
        if (this.mySelf === null) {
            throw new Error(ID_NOT_FOUND);
        }
        this.setPlaceHolder();
        return this.mySelf;
    }
    setElement(element) {
        this.mySelf = element;
        this.setPlaceHolder();
    }
    getMySelf() {
        return this.mySelf;
    }
    setUp(force = false) {
        if (!this.isReady || force) {
            try {
                this._setUp();
                this.isReady = true;
            }
            catch (error) {
                this.isReady = false;
            }
        }
    }
    setDisable(status) {
        if (status) {
            this.mySelf.classList.add(BcCommonConstants.DISABLE_CLASS);
        }
        else {
            this.mySelf.classList.remove(BcCommonConstants.DISABLE_CLASS);
        }
    }
    setPlaceHolder() {
        const el = this.mySelf;
        const placeHolder = el?.placeholder;
        if (!placeHolder) {
            el.placeholder = " ";
        }
    }
}

const CHECKBOX_CLASS = `${BcCommonConstants.PREFIX_LIB}-container-checkbox`;
class BcCheckboxConstants {
}
BcCheckboxConstants.CHECKBOX_CLASS = `${BcCommonConstants.PREFIX_LIB}-container-checkbox`;
BcCheckboxConstants.CHECKBOX_CLASS_DISABLED = `${BcCommonConstants.PREFIX_LIB}-container-checkbox-disabled`;
BcCheckboxConstants.CHECKBOX_SPAN_CLASS = `${BcCommonConstants.PREFIX_LIB}-checkbox`;
BcCheckboxConstants.MIXED = "mixed";
BcCheckboxConstants.CHECKBOX = 'checkbox';
BcCheckboxConstants.EVT_CLICK = 'click';
BcCheckboxConstants.ATTR_ID = "id";
BcCheckboxConstants.ATTR_CHECKED = "checked";
BcCheckboxConstants.ATTR_ARIA_CHECKED = "aria-checked";
BcCheckboxConstants.ATTR_ARIA_LABELLEDBY = "aria-labelledby";
BcCheckboxConstants.ATTR_ARIA_DESCRIBEDBY = "aria-describedby";

class BcCheckboxBehavior extends BcDefaultBehavior {
    constructor() {
        super();
        this.isChecked = false;
    }
    /**
     * Inicializa los elementos checkbox
     * @returns elements
     * @memberof BcCheckboxBehavior
     */
    static setUpAll() {
        const checkboxElements = Array.from(document.querySelectorAll(`[class^='${BcCheckboxConstants.CHECKBOX_CLASS}'] > input[type=${BcCheckboxConstants.CHECKBOX}]`));
        return checkboxElements.map((element) => {
            const bc = new BcCheckboxBehavior();
            bc.setElement(element);
            bc.setUp();
            return bc;
        });
    }
    /**
     * Inicializa cada elemento
     * @memberof BcCheckboxBehavior
     */
    _setUp() {
        this.setAccesibility();
        this.setStates();
        this.setHandlers();
    }
    /**
     * Captura el evento click en cada elemento checkbox y setea el valor correspondiente
     * @param element
     * @memberof BcCheckboxBehavior
     */
    elementClick(element) {
        this.isChecked = !this.isChecked;
        element.checked = this.isChecked;
        element.setAttribute(BcCheckboxConstants.ATTR_ARIA_CHECKED, String(this.isChecked));
        if (this.isChecked) {
            element.setAttribute(BcCheckboxConstants.ATTR_CHECKED, BcCheckboxConstants.ATTR_CHECKED);
        }
        else {
            element.removeAttribute(BcCheckboxConstants.ATTR_CHECKED);
        }
    }
    /**
     * Captura el estado del elemento y si coincide lo setea en indeterminado o desabilitado
     * @param element
     * @memberof BcCheckboxBehavior
     */
    setStates() {
        const element = this.mySelf;
        const isIndeterminate = element.getAttribute(BcCommonConstants.INDETERMINATED) !== null;
        if (isIndeterminate) {
            element.indeterminate = true;
            element.setAttribute(BcCheckboxConstants.ATTR_ARIA_CHECKED, BcCheckboxConstants.MIXED);
        }
        const isDisabled = element.getAttribute(BcCommonConstants.DISABLED) !== null;
        if (isDisabled) {
            element.parentElement.classList.add(BcCheckboxConstants.CHECKBOX_CLASS_DISABLED);
        }
    }
    /**
     * Al elemento le agrega los atributos para la accesibilidad
     * @memberof BcCheckboxBehavior
     */
    setAccesibility() {
        if (this.mySelf.parentElement != null) {
            const parentId = this.mySelf.parentElement.id;
            if (parentId) {
                this.mySelf.setAttribute(BcCheckboxConstants.ATTR_ARIA_DESCRIBEDBY, parentId);
                this.mySelf.setAttribute(BcCheckboxConstants.ATTR_ARIA_LABELLEDBY, parentId);
            }
        }
        this.isChecked = this.mySelf.hasAttribute(BcCheckboxConstants.ATTR_CHECKED);
        this.mySelf.setAttribute(BcCheckboxConstants.ATTR_ARIA_CHECKED, String(this.isChecked));
        this.mySelf.setAttribute(BcCommonConstants.ROLE, BcCheckboxConstants.CHECKBOX);
        this.mySelf.setAttribute(BcCommonConstants.ARIA_LABEL, this.mySelf.parentElement.childNodes[0].textContent.trim());
    }
    /**
     * Configura los handlers para el componente
     * @param element
     * @memberof BcCheckboxBehavior
     */
    setHandlers() {
        this.mySelf.addEventListener(BcCheckboxConstants.EVT_CLICK, this.elementClick.bind(this, this.mySelf));
    }
}

const OUTLINE_ELEMENT_CLASS = 'outline-element';
function isFirstChildFocusable(component) {
    return (component.firstElementChild != null &&
        component.firstElementChild.getAttribute('disabled') !== null &&
        component.firstElementChild.getAttribute('disabled') !== undefined);
}
function isParentFocusable(component) {
    return (component.parentElement != null &&
        component.parentElement.getAttribute('disabled') !== null &&
        component.parentElement.getAttribute('disabled') !== undefined);
}
function validateFocusable(component) {
    let isFocusable = false;
    if (component != null && component.getAttribute('disabled') === null) {
        isFocusable = true;
        const firstChildFocusable = isFirstChildFocusable(component);
        const parentFocusable = isParentFocusable(component);
        if (firstChildFocusable || parentFocusable) {
            isFocusable = false;
        }
    }
    return isFocusable;
}
function addFocusable(component, ariaOptions, action, children, force) {
    if (force || validateFocusable(component)) {
        validateAriaOptions(ariaOptions, component);
        component.addEventListener('focusout', function (event) {
            component.classList.remove(OUTLINE_ELEMENT_CLASS);
            if (children) {
                for (const e of children) {
                    e.classList.remove(OUTLINE_ELEMENT_CLASS);
                }
            }
        });
        addKeyFocusableEvents(component, children, action);
    }
}
function validateAriaOptions(ariaOptions, component) {
    if (ariaOptions) {
        if (ariaOptions.tabindex) {
            if (ariaOptions.tabindex !== '-1') {
                component.setAttribute('tabindex', ariaOptions.tabindex);
            }
        }
        delete ariaOptions.tabindex;
        for (const key of Object.keys(ariaOptions)) {
            addFocusableAttributes(key, ariaOptions, component);
        }
    }
}
function addFocusableAttributes(key, ariaOptions, component) {
    let prefix = '';
    if (key !== 'role') {
        if (ariaOptions[key]) {
            prefix = 'aria-';
        }
    }
    component.setAttribute(prefix + key, ariaOptions[key]);
}
function addKeyFocusableEvents(component, children, action) {
    component.addEventListener('keyup', function (event) {
        if (action && action.preventDefault) {
            event.preventDefault();
        }
        const keyEvent = event.key?.toLowerCase();
        validateTabKeyEvent(keyEvent, component, children);
        validateEscapeKeyEvent(keyEvent, component, children);
        const availableKeys = ['enter', ' ', 'space', 'End', 'Home', 'ArrowRight', 'ArrowLeft', 'ArrowDown', 'ArrowUp'];
        if (action && availableKeys.includes(keyEvent)) {
            action.event();
        }
    });
}
function validateEscapeKeyEvent(keyEvent, component, children) {
    if (keyEvent === 'escape') {
        component.classList.remove(OUTLINE_ELEMENT_CLASS);
        if (children) {
            for (const e of children) {
                e.classList.remove(OUTLINE_ELEMENT_CLASS);
            }
        }
    }
}
function validateTabKeyEvent(keyEvent, component, children) {
    if (keyEvent === 'tab') {
        component.classList.add(OUTLINE_ELEMENT_CLASS);
        if (children) {
            for (const e of children) {
                e.classList.add(OUTLINE_ELEMENT_CLASS);
            }
        }
    }
}
function toArray(nodeList) {
    const array = [];
    nodeList.forEach((item) => {
        array.push(item);
    });
    return array;
}
function replaceClass(element, oldClass, newClass, strict = false) {
    if (element) {
        let isPresent = true;
        if (strict) {
            isPresent = element.classList.contains(oldClass);
        }
        if (isPresent) {
            element.classList.remove(oldClass);
            element.classList.add(newClass);
        }
    }
}
function isMobileDevice() {
    return navigator.userAgent.indexOf('Mobile') !== -1;
}
function changeAriaExpandedValue(element, state) {
    const newState = typeof state == 'undefined' ? !element.getAttribute('aria-expanded') : state;
    element.setAttribute('aria-expanded', String(newState));
}
function changeAriaControlsValue(element, value) {
    element.setAttribute('aria-controls', value);
}
function createElement(_) {
    const el = document.createElement(_.element);
    _.classList && _.classList.forEach((c) => el.classList.add(c));
    _.props && Object.keys(_.props).forEach((key) => el.setAttribute(key, _.props[key]));
    _.innerText && (el.innerText = _.innerText);
    _.children && _.children.forEach((child) => el.appendChild(child));
    return el;
}
function getStyleValue(e, styleName) {
    let styleValue = "";
    if (document.defaultView && document.defaultView.getComputedStyle) {
        styleValue = document.defaultView.getComputedStyle(e, "").getPropertyValue(styleName);
    }
    else if (e.currentStyle) {
        styleName = styleName.replace(/\-(\w)/g, function (strMatch, p1) {
            return p1.toUpperCase();
        });
        styleValue = e.currentStyle[styleName];
    }
    return styleValue;
}
function getOffsetWidth(el) {
    return parseInt(getStyleValue(el, BcCommonConstants.MARGIN_LEFT), 10)
        + parseInt(getStyleValue(el, BcCommonConstants.MARGIN_RIGHT), 10)
        + parseInt(getStyleValue(el, BcCommonConstants.BORDER_LEFT_WIDTH), 10)
        + parseInt(getStyleValue(el, BcCommonConstants.BORDER_RIGHT_WIDTH), 10)
        + parseInt(getStyleValue(el, BcCommonConstants.PADDING_LEFT), 10)
        + parseInt(getStyleValue(el, BcCommonConstants.PADDING_RIGHT), 10);
}
function getId(classRef) {
    const prefix = classRef.constructor.name;
    const array = new Uint32Array(1);
    const randomNumber = window.crypto.getRandomValues(array);
    return `${prefix}.${randomNumber[0]}`;
}

const SLIDER_N90 = 90;
const SLIDER_N14 = 14;
const SLIDER_N12 = 12;
const SLIDER_N24 = 24;
const SLIDER_N10 = 10;
const GROUP_SLIDER_SUFIX = `${BcCommonConstants.PREFIX_LIB}-slider`;
const THUMB_SLIDER_CLASS = `${BcCommonConstants.PREFIX_LIB}-slider-thumb`;
const TAG_NAME_SLIDER_EXPECTED = `INPUT`;
const SLIDER_N100 = 100;
const GROUP_SLIDER_DOUBLE_SUFIX = `${BcCommonConstants.PREFIX_LIB}-slider-double-container`;
const GROUP_SUFIX_LEFT = `input-left`;
const GROUP_SUFIX_RIGHT = `input-right`;
const THUMB_LEFT_SLIDER_CLASS = `${BcCommonConstants.PREFIX_LIB}-slider-thumb-left`;
const THUMB_RIGHT_SLIDER_CLASS = `${BcCommonConstants.PREFIX_LIB}-slider-thumb-right`;
const SLIDER_PERCENTAGE = 100;

class BcSliderBehavior extends BcDefaultBehavior {
    constructor() {
        super();
    }
    static setUpAll() {
        const tabsElements = Array.from(document.querySelectorAll(`input[class^='${GROUP_SLIDER_SUFIX}']`));
        const elements = [];
        for (let value of tabsElements) {
            const bc = new BcSliderBehavior();
            bc.setElement(value);
            bc.setUp();
            elements.push(bc);
        }
        return elements;
    }
    /**
     * Setea el elemnto slider en mySelf para su posterior uso
     * Configura la accesibilidad ARIA del mismo
     * @param element Es el elemento html
     * @memberof BcSliderBehavior
     */
    setElement(element) {
        this.isReady = false;
        this.mySelf = element;
        if (this.mySelf.tagName != TAG_NAME_SLIDER_EXPECTED) {
            this.mySelf = this.mySelf.querySelector(`input[class^='${GROUP_SLIDER_SUFIX}']`);
        }
        this.thumb = this.mySelf.parentElement.querySelector(`[class='${THUMB_SLIDER_CLASS}']`);
        addFocusable(this.mySelf, null, null, [this.thumb]);
    }
    setValue(value) {
        const input = this.mySelf;
        input.value = value;
        this.updateInput();
    }
    _setUp() {
        this.mySelf.addEventListener('input', (evt) => {
            this.updateInput();
        });
        this.updateInput();
    }
    /**
      * Obtiene los paramétros de rango del slider para calcular el tamaño de los pasos
      * @memberof BcSliderBehavior
      */
    updateInput() {
        const left = this.mySelf;
        const inputMin = parseInt(this.mySelf.getAttribute('min'));
        const inputMax = parseInt(this.mySelf.getAttribute('max'));
        const inputVal = parseInt(this.mySelf.value);
        const unidad = (inputMax - inputMin);
        const total = (inputVal - inputMin) * SLIDER_N100 / unidad;
        this.mySelf.style.setProperty('--value', total.toString());
        if (this.outputFunction) {
            this.outputFunction(total);
        }
        if (!this.thumb) {
            this.thumb = this.mySelf.parentElement.querySelector(`[class='${THUMB_SLIDER_CLASS}']`);
        }
        this.thumb.style.left =
            (parseInt(((total / SLIDER_N100) * (left.offsetWidth - SLIDER_N24)).toString()) + left.offsetLeft).toString() +
                'px';
    }
}

class BcSliderDoubleBehavior extends BcDefaultBehavior {
    constructor() {
        super();
    }
    static setUpAll() {
        const tabsElements = Array.from(document.querySelectorAll(`div[class^='${GROUP_SLIDER_DOUBLE_SUFIX}']`));
        const elements = [];
        for (const element of tabsElements) {
            const bc = new BcSliderDoubleBehavior();
            bc.setElement(element);
            bc.setUp();
            elements.push(bc);
        }
        return elements;
    }
    _setUp() {
        this.inputL = this.mySelf.querySelector(`input[class='bc-slider-dual ${GROUP_SUFIX_LEFT}']`);
        this.inputR = this.mySelf.querySelector(`input[class='bc-slider-dual ${GROUP_SUFIX_RIGHT}']`);
        this.inputL.addEventListener('input', (evt) => {
            this.setLeftValue();
            this.returnValue();
        });
        this.thumbLeft = this.mySelf.querySelector(`[class='${THUMB_LEFT_SLIDER_CLASS}']`);
        addFocusable(this.inputL, null, null, [this.thumbLeft]);
        this.setLeftValue();
        this.inputR.addEventListener('input', (evt) => {
            this.setRightValue();
            this.returnValue();
        });
        this.thumbRight = this.mySelf.querySelector(`[class='${THUMB_RIGHT_SLIDER_CLASS}']`);
        addFocusable(this.inputR, null, null, [this.thumbRight]);
        this.setRightValue();
    }
    setValue(value) {
        if (value.min && value.max) {
            const auxRight = this.mySelf.querySelector('.input-right');
            const auxLeft = this.mySelf.querySelector('.input-left');
            auxLeft.value = value.min;
            auxRight.value = value.max;
            this.setLeftValue();
            this.setRightValue();
        }
    }
    returnValue() {
        if (this.valueL && this.valueR) {
            if (this.outputFunction) {
                this.outputFunction({
                    min: this.valueL,
                    max: this.valueR
                });
            }
        }
    }
    setLeftValue() {
        const auxRight = this.mySelf.querySelector('.input-right');
        const self = this.inputL;
        const min = parseInt(self.min);
        const max = parseInt(self.max);
        const newValue = Math.min(parseInt(self.value), parseInt(auxRight.value));
        self.value = newValue.toString();
        const percent = ((newValue - min) / (max - min)) * SLIDER_PERCENTAGE;
        const thumbLeft = this.mySelf.querySelector('.slider > .thumb.left');
        const range = this.mySelf.querySelector('.slider > .range');
        thumbLeft.style.left = percent + '%';
        range.style.left = percent + '%';
        this.inputL.style.zIndex = percent > SLIDER_N90 ? '4' : '3';
        if (this.thumbLeft) {
            const value = parseInt(`${(parseInt(thumbLeft.style.left.replace('%', '')) /
                SLIDER_PERCENTAGE) *
                (this.inputL.offsetWidth - SLIDER_N24)}`);
            this.valueL = value;
            this.thumbLeft.style.left = `${value}px`;
        }
    }
    setRightValue() {
        const auxLeft = this.mySelf.querySelector('.input-left');
        const _this = this.inputR, min = parseInt(_this.min), max = parseInt(_this.max);
        const newValue = Math.max(parseInt(_this.value), parseInt(auxLeft.value));
        _this.value = newValue.toString();
        const percent = ((newValue - min) / (max - min)) * SLIDER_PERCENTAGE;
        const thumbRight = this.mySelf.querySelector('.slider > .thumb.right');
        const range = this.mySelf.querySelector('.slider > .range');
        thumbRight.style.right = SLIDER_PERCENTAGE - percent + '%';
        range.style.right = SLIDER_PERCENTAGE - percent + '%';
        this.inputR.style.zIndex = percent < SLIDER_N10 ? '4' : '3';
        if (this.thumbRight) {
            const value = parseInt(`${(parseInt(thumbRight.style.right.replace('%', '')) /
                SLIDER_PERCENTAGE) *
                (this.inputR.offsetWidth - SLIDER_N24)}`);
            this.valueR = value;
            this.thumbRight.style.right = `${value - SLIDER_N14}px`;
        }
    }
}

const STEPPER_NAME = `${BcCommonConstants.PREFIX_LIB}-stepper`;
const STEPPER_HEADER = `${BcCommonConstants.PREFIX_LIB}-stepper-header`;
const STEPPER_VERTICAL = `${BcCommonConstants.PREFIX_LIB}-stepper-vertical`;
const STEPPER_HORIZONTAL = `${BcCommonConstants.PREFIX_LIB}-stepper-horizontal`;
const STEPPER_PROGRESS_STEP = `${BcCommonConstants.PREFIX_LIB}-stepper-step`;
const STEPPER_PROGRESS_TRACK = `${BcCommonConstants.PREFIX_LIB}-stepper-track`;
const STEPPER_INNER_BULLET = `${BcCommonConstants.PREFIX_LIB}-stepper-inner-bullet`;
const STEPPER_INNER_BULLET_ACTIVE = `${BcCommonConstants.PREFIX_LIB}-stepper-inner-bullet-active`;
const STEPPER_INNER_BULLET_ACTIVE_LIGHT = `${BcCommonConstants.PREFIX_LIB}-stepper-inner-bullet-active-light`;
const STEPPER_INNER_NUMBER = `${BcCommonConstants.PREFIX_LIB}-stepper-inner-number`;
const STEPPER_STATUS = `${BcCommonConstants.PREFIX_LIB}-stepper-status`;
const STEPPER_LABEL = `${BcCommonConstants.PREFIX_LIB}-stepper-label`;
const STEPPER_TITLE = `stepper-title`;
const STEPPER_CONTENT = `stepper-content`;
const STEPPER_ACTIVE_STEP = 'is-active';
const STEPPER_DEFAULT_STEP = 'is-default';
const STEPPER_COMPLETE_STEP = 'is-complete';
const STEPPER_IS_ACTIVE = 'is-active';
const STEPPER_IS_DEFAULT = 'is-default';
const STEPPER_IS_COMPLETE = 'is-complete';
const STEPPER_HORIZONTAL_DIRECTION = 'horizontal';
const STEPPER_VERTICAL_DIRECTION = 'vertical';
const STEPPER_N100 = 100;
const STEPPER_RESOLUTION_MOBILE = 768;
const STEPPER_N360 = 360;
const STEPPER_N50 = 50;
const STEPPER_N180 = 180;

var ThemeCircles;
(function (ThemeCircles) {
    ThemeCircles[ThemeCircles["LIGHT"] = 0] = "LIGHT";
    ThemeCircles[ThemeCircles["DARK"] = 1] = "DARK";
})(ThemeCircles || (ThemeCircles = {}));
class BcStepperBehavior extends BcDefaultBehavior {
    constructor() {
        super();
        this.maxStep = 0;
        this.currentStep = 0;
        this.initialStep = 0;
        this.progressHeader = 0;
        this.status = [];
        this.labels = [];
        this.isTop = false;
        this.themeCircles = ThemeCircles.DARK;
    }
    _setUp() {
        this.isMobile = this.checkCurrentWidth();
        this.createBulletSteps();
        this.addClickEvent();
        this.addClickEventHeader();
        this.addResizeEvent();
        this.getElement();
        this.setInitState();
        this.setIndexStatus();
        this.setBulletStatus();
        this.checkStepperDirection();
        this.accessibility();
        this.scrollEventHeader();
    }
    /**
     * Define el tema, es decir el color de los círculos de los steps aún no activos,
     * estos son grises de defecto pero también se les puede asignar color blanco.
     * @param {string} themeCircles
     * @memberof BcStepperBehavior
     */
    setThemeCircles(themeCircles) {
        this.themeCircles = themeCircles;
    }
    /**
     * Define la dirección del stepper, si es vertical u horizontal de acuerdo al atributo STEPPER_VERTICAL.
     * @memberof BcStepperBehavior
     */
    setDirection() {
        if (this.mySelf.classList.contains(STEPPER_VERTICAL)) {
            this.direction = STEPPER_VERTICAL_DIRECTION;
        }
        else {
            this.direction = STEPPER_HORIZONTAL_DIRECTION;
        }
        this.checkStepperDirection();
    }
    /**
     * Define el número de pasos del stepper.
     * @param {number} numSteps
     * @memberof BcStepperBehavior
     */
    setNumStep(numSteps) {
        this.numSteps = numSteps;
        this.maxStep = numSteps;
        if (this.direction === STEPPER_HORIZONTAL_DIRECTION) {
            this.setProgressHorizontal();
        }
        else {
            this.setProgressVertical();
        }
    }
    /**
     * Progreso de la barra horizontal.
     * @memberof BcStepperBehavior
     */
    setProgressHorizontal() {
        this.width = STEPPER_N100 / (this.numSteps - 1);
    }
    /**
     * Progreso de la barra vertical.
     * @memberof BcStepperBehavior
     */
    setProgressVertical() {
        this.height = STEPPER_N100 / (this.numSteps - 1);
    }
    /**
     * Setea el array de labels de cada paso del stepper.
     * @param {string[]} labels
     * @memberof BcStepperBehavior
     */
    setLabels(labels) {
        this.setDirection();
        this.labels = labels;
        this.setNumStep(this.labels.length);
    }
    /**
     * Selector de los elementos del stepper.
     * @memberof BcStepperBehavior
     */
    getElement() {
        this.progressStepArray = Array.from(this.mySelf.querySelectorAll(`.${STEPPER_PROGRESS_STEP}`));
        this.progressBulletArray = Array.from(this.mySelf.querySelectorAll(`.${STEPPER_INNER_BULLET}`));
        this.progressTrack = this.mySelf.querySelector(`.${STEPPER_PROGRESS_TRACK}`);
    }
    /**
     * Define la posición inicial del stepper.
     * @param {number} index
     * @memberof BcStepperBehavior
     */
    setInitIndexPosition(index) {
        if (index >= 0 && index < this.labels.length) {
            this.setCurrentStep(index);
        }
    }
    /**
     * Inicializa el stepper.
     * @memberof BcStepperBehavior
     */
    setInitState() {
        this.status[this.currentStep] = STEPPER_IS_ACTIVE;
        this.setProgressHeader();
    }
    /**
     * Activar el paso de la posición index.
     * @param {number} index
     * @memberof BcStepperBehavior
     */
    click(index) {
        {
            if (index < this.currentStep) {
                this.status[this.currentStep] = STEPPER_IS_DEFAULT;
                this.setCurrentStep(index);
                this.status[this.currentStep] = STEPPER_IS_ACTIVE;
                this.setBulletStatus();
            }
        }
    }
    /**
     * Registra el evento click que va permitir avanzar de paso.
     * @memberof BcStepperBehavior
     */
    addClickEvent() {
        this.mySelf.querySelectorAll(`.${STEPPER_PROGRESS_STEP}`).forEach((element, index) => {
            element.addEventListener(BcCommonConstants.EVENT_CLICK, () => {
                this.click(index);
            });
        });
    }
    /**
     * Registra el evento resize de la pantalla para chequear resoluciones.
     * @memberof BcStepperBehavior
     */
    addResizeEvent() {
        window.addEventListener(BcCommonConstants.EVENT_RESIZE, (event) => {
            this.checkStepperDirection();
        });
    }
    /**
     * Cambia la direccion del stepper a vertical en resoluciones mobile.
     * @memberof BcStepperBehavior
     */
    checkStepperDirection() {
        this.isMobile = this.checkCurrentWidth();
        if (this.isMobile && this.mySelf.classList.contains(`${STEPPER_HORIZONTAL}`)) {
            this.mySelf.classList.remove(`${STEPPER_HORIZONTAL}`);
            this.mySelf.classList.add(`${STEPPER_VERTICAL}`);
        }
        else if (!this.isMobile && this.direction === STEPPER_HORIZONTAL_DIRECTION && this.mySelf.classList.contains(`${STEPPER_VERTICAL}`)) {
            this.mySelf.classList.remove(`${STEPPER_VERTICAL}`);
            this.mySelf.classList.add(`${STEPPER_HORIZONTAL}`);
            const elements = this.mySelf.querySelectorAll(`section.${STEPPER_NAME}-step`);
            elements.forEach(e => e.setAttribute('tabindex', '5'));
        }
    }
    /**
     * Permite avanzar o retroceder un paso según el valor de value con respecto a la posición actual.
     * @param {number} value
     * @memberof BcStepperBehavior
     */
    setValue(value) {
        const currentState = this.getCurrentState();
        const diference = value - currentState;
        if (diference > 0) {
            for (let i = 0; i < diference; i++) {
                this.next();
            }
        }
        else {
            for (let i = 0; i < diference * -1; i++) {
                this.back();
            }
        }
    }
    /**
     * Chequeo de resolución para capturar el tamaño de la pantalla.
     * @memberof BcStepperBehavior
     */
    checkCurrentWidth() {
        let isMobile = false;
        if (window.innerWidth <= STEPPER_RESOLUTION_MOBILE) {
            isMobile = true;
        }
        return isMobile;
    }
    /**
     * Creación de los Bullets del Stepper.
     * @memberof BcStepperBehavior
     */
    createBulletSteps() {
        this.mySelf.classList.add(STEPPER_NAME);
        this.mySelf.setAttribute(BcCommonConstants.ARIA_EXPANDED, 'true');
        const bulletChild = document.createElement('header');
        bulletChild.classList.add(STEPPER_HEADER);
        bulletChild.innerHTML = `
        <div class="${STEPPER_NAME}-header-left " tabindex="3" aria-labelledby="${STEPPER_NAME}-number" aria-posinset="3" >
          <div class="${STEPPER_NAME}-number" id="${STEPPER_NAME}-number">${this.currentStep + 1} de ${this.maxStep}</div>
          <div class="${STEPPER_NAME}-circle">
            <div class="${STEPPER_NAME}-bar left"><div class="${STEPPER_NAME}-progress"></div></div>
            <div class="${STEPPER_NAME}-bar right"><div class="${STEPPER_NAME}-progress"></div></div>
          </div>
        </div>
        <div class="${STEPPER_NAME}-header-center">
          <h6 tabindex="1" aria-posinset="1" aria-label="paso actual">${this.labels[this.currentStep]}</h6>
          <p tabindex="2" aria-posinset="2" aria-label="paso siguiente">Siguiente: ${this.labels[this.currentStep + 1]}</p>
        </div>
        <div class="${STEPPER_NAME}-header-right" tabindex="4" aria-posinset="4" aria-label="mostrar u ocultar pasos" >
        <em class="bc-icon" alt="Arrow down">${BcCommonConstants.ICON_ARROW_DOWN}</em>
      </div>`;
        this.mySelf.appendChild(bulletChild);
        this.settingAtributes();
    }
    /**
     * Seteando los bullets del Stepper.
     * @memberof BcStepperBehavior
     */
    settingAtributes() {
        let stepperBulletColor = '';
        for (let i = 1; i <= this.labels.length; i++) {
            const bulletChild = document.createElement('section');
            bulletChild.classList.add(STEPPER_PROGRESS_STEP);
            bulletChild.setAttribute(BcCommonConstants.ROLE, 'tab');
            bulletChild.setAttribute(BcCommonConstants.ARIA_POSINSET, i.toString());
            bulletChild.setAttribute(BcCommonConstants.ARIA_SELECTED, 'false');
            if (this.themeCircles == ThemeCircles.DARK) {
                stepperBulletColor = STEPPER_INNER_BULLET_ACTIVE;
            }
            else {
                stepperBulletColor = STEPPER_INNER_BULLET_ACTIVE_LIGHT;
            }
            bulletChild.innerHTML = `<section class="${STEPPER_INNER_BULLET}"></section>
      <section class="${stepperBulletColor}"></section>
      <label class="${STEPPER_INNER_NUMBER}" aria-hidden="true">${i}</label>
      <section class="${STEPPER_STATUS}"><em class="bc-icon" alt="Paso completado">ok</em></section>
      <section class="${STEPPER_LABEL}" aria-hidden="true"><label>${this.labels[i - 1]}</label></section>`;
            this.mySelf.appendChild(bulletChild);
            const bulletItem = bulletChild.querySelector(`.${STEPPER_INNER_BULLET}`);
            addFocusable(bulletItem, { label: this.labels[i - 1] }, { event: () => this.click(i - 1) });
        }
    }
    /**
     * Accesibilidad de foco y soporte por teclado.
     * @memberof BcStepperBehavior
     */
    accessibility() {
        this.mySelf.querySelectorAll(`*[class*="${STEPPER_PROGRESS_STEP}"]`).forEach((element, index) => {
            addFocusable(element, { tabindex: '5' }, { event: () => this.decide(element, index) });
            this.screenReader(element, index);
        });
        const arrowHeader = this.mySelf.querySelector(`.${STEPPER_NAME}-header-right`);
        addFocusable(arrowHeader, {}, { event: () => this.openSteps(arrowHeader) });
    }
    /**
       * ejecuta el metodo click del dropdown
       * @param {HTMLElement} element
       */
    openSteps(element) {
        element.click();
    }
    /**
       * Metodo que permite elegir si al enfocar el elemento se avanza o se retrocedes en los steps.
       * @param {number} index
       * @memberof BcStepperBehavior
       */
    decide(element, index) {
        if (element.classList.contains(BcCommonConstants.OUTLINE_ELEMENT)) {
            if (index === this.currentStep + 1) {
                this.next();
            }
            else if (index === this.currentStep - 1) {
                this.back();
            }
        }
    }
    /**
       * Verifica que tecla ha sido activada por el usuario en el componente
       * @param {number} index
       * @memberof BcStepperBehavior
       */
    screenReader(element, index) {
        element.addEventListener(BcCommonConstants.EVENT_KEY_UP, (event) => {
            if (event.key === BcCommonConstants.KEY_EVENT_ARROW_RIGHT) {
                this.focusNext(index);
            }
            else if (event.key === BcCommonConstants.KEY_EVENT_ARROW_LEFT) {
                this.focusBack(index);
            }
            else if (event.key === BcCommonConstants.KEY_EVENT_HOME) {
                this.focusHomeEnd(index, true);
            }
            else if (event.key === BcCommonConstants.KEY_EVENT_END) {
                this.focusHomeEnd(index);
            }
        });
    }
    /**
     * Metodo que permite enfocar el ultimo elemento del stepper
     * @param {number} index
     * @memberof BcStepperBehavior
     */
    focusHomeEnd(index, key = false) {
        if (this.getCurrentElement(index) !== null) {
            this.getCurrentElement(index).classList.remove(BcCommonConstants.OUTLINE_ELEMENT);
            if (key) {
                index = this.initialStep;
            }
            else {
                index = this.labels.length - 1;
            }
            this.getCurrentElement(index).classList.add(BcCommonConstants.OUTLINE_ELEMENT);
            this.getCurrentElement(index).focus();
        }
    }
    /**
      * Metodo que permite enfocar el siguiente elemento del stepper
      * @param {number} index
      * @memberof BcStepperBehavior
      */
    focusNext(index) {
        if (this.getCurrentElement(index) !== null) {
            this.getCurrentElement(index).classList.remove(BcCommonConstants.OUTLINE_ELEMENT);
            if (index < this.labels.length - 1) {
                index++;
            }
            else {
                index = this.initialStep;
            }
            this.getCurrentElement(index).classList.add(BcCommonConstants.OUTLINE_ELEMENT);
            this.getCurrentElement(index).focus();
            this.getStatus(index);
        }
    }
    /**
    * Metodo que permite enfocar el step anterior al que se encuentra situado
    * @param {number} index
    * @memberof BcStepperBehavior
    */
    focusBack(index) {
        if (this.getCurrentElement(index) !== null) {
            this.getCurrentElement(index).classList.remove(BcCommonConstants.OUTLINE_ELEMENT);
            if (index > 0) {
                index--;
            }
            else {
                index = this.labels.length - 1;
            }
            this.getCurrentElement(index).classList.add(BcCommonConstants.OUTLINE_ELEMENT);
            this.getCurrentElement(index).focus();
            this.getStatus(index);
        }
    }
    /**
      * Metodo que permite conocer el estado del stepper
      * @param {number} index
      * @memberof BcStepperBehavior
      */
    getStatus(index) {
        if (this.status[index] === STEPPER_IS_ACTIVE) {
            this.currentStep = index;
        }
    }
    /**
      * Metodo que permite obtener el current element
      * @param {number} index
      * @memberof BcStepperBehavior
      */
    getCurrentElement(index) {
        return this.mySelf.querySelectorAll(`*[class*="${STEPPER_PROGRESS_STEP}"]`)[index];
    }
    /**
     * Muestra la barra de progreso horizontal.
     * @memberof BcStepperBehavior
     */
    progressHorizontal() {
        const currentStepStr = this.currentStep.toString();
        this.progressTrack.style.width = typeof (this.currentStep) === 'string' && this.currentStep != 0
            ? this.commonProgress(this.width, currentStepStr, 0)
            : this.commonProgress(this.width, currentStepStr, 1);
    }
    /**
     * Muestra la barra de progreso vertical.
     * @memberof BcStepperBehavior
     */
    progressVertical() {
        const currentStepStr = this.currentStep.toString();
        this.progressTrack.style.height = typeof (this.currentStep) === 'string' && this.currentStep != 0
            ? this.commonProgress(this.height, currentStepStr, 0)
            : this.commonProgress(this.height, currentStepStr, 1);
    }
    /**
     * Progreso comun de las barras.
     * @memberof BcStepperBehavior
     */
    commonProgress(size, currentStep, step) {
        return size * (parseInt(currentStep) + step) + '%';
    }
    /**
     * Establece el estado del stepper de acuerdo al paso actual activo.
     * @memberof BcStepperBehavior
     */
    setIndexStatus() {
        const maxLength = this.currentStep;
        for (let index = 0; index < maxLength; index++) {
            this.next(index, false);
        }
    }
    /**
     * Permite avanzar al siguiente paso del stepper, para lo cual validá la horientación y el progreso.
     * @memberof BcStepperBehavior
     */
    next(index = this.currentStep, notify = true, accesibility = false) {
        if (index < this.labels.length - 1) {
            this.status[index] = STEPPER_IS_COMPLETE;
            index++;
            if (index > this.maxStep) {
                this.maxStep = index;
            }
            this.status[index] = STEPPER_IS_ACTIVE;
            if (this.direction === STEPPER_HORIZONTAL_DIRECTION) {
                this.progressHorizontal();
            }
            else {
                this.progressVertical();
            }
            this.setBulletStatus(accesibility);
        }
        if (notify) {
            this.setCurrentStep(index);
        }
        else {
            this.currentStep = index;
        }
        this.setProgressHeader();
        this.setCurrentStepHeader();
    }
    /**
     * Se regresa un paso del stepper.
     * @memberof BcStepperBehavior
     */
    back(accesibility = false) {
        if (this.currentStep > 0) {
            this.status[this.currentStep] = STEPPER_IS_COMPLETE;
            this.setCurrentStep(this.currentStep - 1);
            this.status[this.currentStep] = STEPPER_IS_ACTIVE;
            this.setBulletStatus(accesibility);
            this.setProgressHeader();
            this.setCurrentStepHeader();
        }
    }
    setBulletStatus(accesibility = false) {
        this.status.forEach((element, index) => {
            const defaultCase = () => {
                this.progressBulletArray[index].classList.remove(STEPPER_ACTIVE_STEP);
                this.progressBulletArray[index].classList.add(STEPPER_DEFAULT_STEP);
                this.progressStepArray[index].classList.remove(STEPPER_ACTIVE_STEP);
            };
            switch (element) {
                case STEPPER_IS_ACTIVE:
                    this.progressBulletArray[index].classList.remove(STEPPER_DEFAULT_STEP, STEPPER_COMPLETE_STEP);
                    this.progressBulletArray[index].classList.add(STEPPER_ACTIVE_STEP);
                    this.progressStepArray[index].classList.add(STEPPER_ACTIVE_STEP);
                    this.progressStepArray[index].setAttribute(BcCommonConstants.ARIA_SELECTED, 'true');
                    break;
                case STEPPER_IS_DEFAULT:
                    defaultCase();
                    break;
                case STEPPER_IS_COMPLETE:
                    this.progressBulletArray[index].classList.remove(STEPPER_ACTIVE_STEP);
                    this.progressBulletArray[index].classList.add(STEPPER_COMPLETE_STEP);
                    this.progressStepArray[index].classList.remove(STEPPER_ACTIVE_STEP);
                    this.progressStepArray[index].setAttribute(BcCommonConstants.ARIA_SELECTED, 'false');
                    break;
                default:
                    defaultCase();
            }
        });
    }
    setCurrentStep(index) {
        this.currentStep = index;
        if (this.outputFunction) {
            this.outputFunction(index);
        }
    }
    getCurrentState() {
        return this.currentStep;
    }
    /**
     * Se cambia el stado actual de la barra de progreso en el header.
     * @memberof BcStepperBehavior
     */
    setProgressHeader() {
        this.progressHeader = ((this.currentStep + 1) / this.maxStep) * STEPPER_N100;
        const progressDeg = STEPPER_N360 * this.progressHeader / STEPPER_N100;
        if (this.progressHeader < STEPPER_N50) {
            this.mySelf.querySelector(`.${STEPPER_NAME}-header-left .left .${STEPPER_NAME}-progress`)['style'].transform = 'rotate(' + progressDeg + 'deg)';
            this.mySelf.querySelector(`.${STEPPER_NAME}-header-left .right .${STEPPER_NAME}-progress`)['style'].transform = 'rotate(0deg)';
        }
        else {
            this.mySelf.querySelector(`.${STEPPER_NAME}-header-left .left .${STEPPER_NAME}-progress`)['style'].transform = 'rotate(180deg)';
            this.mySelf.querySelector(`.${STEPPER_NAME}-header-left .right .${STEPPER_NAME}-progress`)['style'].transform = 'rotate(' + (progressDeg - STEPPER_N180) + 'deg)';
        }
        this.mySelf.querySelector(`.${STEPPER_NAME}-header-left .${STEPPER_NAME}-number`).innerHTML =
            `${this.currentStep + 1} de ${this.maxStep}`;
    }
    /**
     * Se cambia la informacion de los pasos en el header.
     * @memberof BcStepperBehavior
     */
    setCurrentStepHeader() {
        const currentStep = this.labels[this.currentStep];
        const nextStep = this.labels[this.currentStep + 1] ? `Siguiente: ${this.labels[this.currentStep + 1]}` : '';
        this.mySelf.querySelector(`.${STEPPER_NAME}-header-center > h6`).innerHTML = currentStep;
        this.mySelf.querySelector(`.${STEPPER_NAME}-header-center > p`).innerHTML = nextStep;
    }
    /**
   * Registra el evento click que va permitir avanzar de paso.
   * @memberof BcStepperBehavior
   */
    addClickEventHeader() {
        this.mySelf.querySelector(`.${STEPPER_NAME}-header-right`).addEventListener(BcCommonConstants.EVENT_CLICK, (event) => {
            event.target['classList'].toggle("active");
            const isExpanded = this.mySelf.getAttribute(BcCommonConstants.ARIA_EXPANDED) === 'true' ? 'false' : 'true';
            this.mySelf.setAttribute(BcCommonConstants.ARIA_EXPANDED, isExpanded);
            const elements = this.mySelf.querySelectorAll(`section.${STEPPER_NAME}-step`);
            elements.forEach(e => {
                e.classList.toggle('hidden-step');
                isExpanded === 'true' ? e.setAttribute('tabindex', '5') : e.setAttribute('tabindex', '-1');
            });
        });
    }
    /**
   * Registra el evento scroll in header.
   * @memberof BcStepperBehavior
   */
    scrollEventHeader() {
        window.addEventListener('scroll', (e) => {
            const rect = this.mySelf.getBoundingClientRect();
            const elemTop = rect.top;
            const heightClient = this.mySelf.querySelector(`.${STEPPER_NAME}-header`).clientHeight;
            if (elemTop === 0 && !this.isTop) {
                this.mySelf.querySelector('header').classList.add('isTop');
                this.isTop = true;
                return;
            }
            if (elemTop > heightClient && this.isTop) {
                this.mySelf.querySelector('header').classList.remove('isTop');
                this.isTop = false;
            }
        });
    }
}

const SCROLLER_SCROLLABLE_CLASS = `${BcCommonConstants.PREFIX_LIB}-scrollable`;
const SCROLLER_SCROLLABLE_CONTENT_CLASS = `${BcCommonConstants.PREFIX_LIB}-content-wrapper`;
const SCROLLER_CLASS = `${BcCommonConstants.PREFIX_LIB}-content-scroller`;
const SHOW_SCROLL_CLASS = 'showScroll';

class BcScrollerBehavior extends BcDefaultBehavior {
    constructor() {
        super();
        this.contentPosition = 0;
        this.scrollerBeingDragged = false;
    }
    static setUpAll() {
        const srollerElements = Array.from(document.querySelectorAll(`[class^='${SCROLLER_SCROLLABLE_CLASS}']`));
        const elements = [];
        for (const element of srollerElements) {
            const bc = new BcScrollerBehavior();
            bc.setElement(element);
            bc.setUp();
            elements.push(bc);
        }
        return elements;
    }
    _setUp() {
        const content = this.mySelf.querySelector(`[class='${SCROLLER_SCROLLABLE_CONTENT_CLASS}']`);
        try {
            this.createScroller(this.mySelf, content);
        }
        catch (err) {
            this.scroller = null;
        }
    }
    /**
   * Calcula la altura del contenido  con respecto a la altura total incluyendo el contenido
   * que no es visible en la pantalla debido al desbordamiento.
   * @return visibleRatio multiplica ese ratio por la altura del elemento, incluyendo los bordes y el padding
   * @memberof BcScrollerBehavior
   */
    calculateScrollerHeight() {
        const visibleRatio = this.scrollContainer.offsetHeight / this.scrollContentWrapper.scrollHeight;
        return visibleRatio * this.scrollContainer.offsetHeight;
    }
    /**
     * Posiciona el scroll centrado al contenido
     * @param evt
     * @memberof BcScrollerBehavior
     */
    moveScroller(evt) {
        const scrollPercentage = evt.target.scrollTop / this.scrollContentWrapper.scrollHeight;
        const size = 5;
        this.topPosition = scrollPercentage * (this.scrollContainer.offsetHeight - size);
        this.scroller.style.top = this.topPosition.toString() + 'px';
    }
    /**
     * Reubica el scroll en la parte superior de la pantalla
     * @param evt
     * @memberof BcScrollerBehavior
     */
    startDrag(evt) {
        this.normalizedPosition = evt.pageY;
        this.contentPosition = this.scrollContentWrapper.scrollTop;
        this.scrollerBeingDragged = true;
    }
    /**
     * Detiene el arrastre del scroll
     * @param evt
     * @memberof BcScrollerBehavior
     */
    stopDrag(evt) {
        this.scrollerBeingDragged = false;
    }
    /**
     * Detecta el movimiento del scroll con el mouse y calcula la nueva posición del mismo
     * @param evt
     * @memberof BcScrollerBehavior
     */
    scrollBarScroll(evt) {
        if (this.scrollerBeingDragged === true) {
            const mouseDifferential = evt.pageY - this.normalizedPosition;
            const scrollEquivalent = mouseDifferential * (this.scContenWrapperHeight / this.ofContainerHeight);
            this.scrollContentWrapper.scrollTop = this.contentPosition + scrollEquivalent;
        }
    }
    /**Crea un contenedor con scroll del tamaño de la pantalla incluyendo el desbordamiento
     * @fileoverview
     * @param container
     * @param content
     * @memberof BcScrollerBehavior
     */
    createScroller(container, content) {
        this.scrollContainer = container;
        this.scrollContentWrapper = content;
        this.scrollerHeight = this.calculateScrollerHeight();
        if (this.scrollerHeight / this.scrollContainer.offsetHeight < 1) {
            this.scroller = document.createElement('div');
            this.scroller.style.height = this.scrollerHeight.toString() + 'px';
            this.scroller.classList.add(SCROLLER_CLASS);
            this.scrollContainer.appendChild(this.scroller);
            this.scrollContainer.classList.add(SHOW_SCROLL_CLASS);
            this.scroller.addEventListener('mousedown', (evt) => this.startDrag(evt));
            this.scrollContainer.addEventListener('mouseup', (evt) => this.stopDrag(evt));
            this.scrollContainer.addEventListener('mousemove', (evt) => this.scrollBarScroll(evt));
            this.scrollContentWrapper.addEventListener('scroll', (evt) => this.moveScroller(evt));
            return this.scroller;
        }
    }
}

const BC_BUTTON_GROUP = Object.freeze({
    INPUT: `${BcCommonConstants.PREFIX_LIB}-button-group-input`,
    INDICATOR: `${BcCommonConstants.PREFIX_LIB}-button-indicator`,
    CONTAINER: `${BcCommonConstants.PREFIX_LIB}-button-group-container`,
    DEFAULT_INDICATOR_COLOR: `${BcCommonConstants.PREFIX_LIB}-default-indicator`,
    BLACK_INDICATOR_COLOR: `${BcCommonConstants.PREFIX_LIB}-black-indicator`,
    BLACK_INDICATOR_INPUT: `blackActiveIndicator`,
    DEFAULT_INDICATOR_INPUT: `defaultActiveIndicator`,
    SMALL: `${BcCommonConstants.PREFIX_LIB}-button-group-font-size-small`,
    X_SMALL: `${BcCommonConstants.PREFIX_LIB}-button-group-font-size-xsmall`
});

class BcButtonGroupBehavior extends BcDefaultBehavior {
    constructor() {
        super();
        this.buttonsState = [];
    }
    static setUpAll() {
        const containers = Array.from(document.querySelectorAll(`${BcCommonConstants.ARTICLE_TAG}.${BC_BUTTON_GROUP.CONTAINER}`));
        const bcButtonGroupBehavior = new BcButtonGroupBehavior();
        const elements = [];
        for (const element of containers) {
            bcButtonGroupBehavior.setElement(element);
            bcButtonGroupBehavior.setUp();
            elements.push(bcButtonGroupBehavior);
        }
        return elements;
    }
    _setUp() {
        this.setElements();
        this.selectElements();
        try {
            if (this.inputElements.length < COMMON_CONSTANTS_NUMBERS.N2 || this.inputElements.length > COMMON_CONSTANTS_NUMBERS.N4) {
                this.mySelf.innerHTML = '';
                throw Error(`There must be at least 2 and at most 4 buttons. Current count:${this.inputElements.length}`);
            }
            else {
                this.setUpAllFeatures();
            }
        }
        catch (error) {
            console.error(error);
        }
    }
    /**
     * Selecciona los botones y después los agrupa.
     * @memberof BcButtonGroupBehavior
     */
    selectElements() {
        for (let index = 0; index < this.inputElements.length; index++) {
            const element = this.inputElements[index];
            addFocusable(element);
        }
    }
    /**
   * Asigna todas los comportamientos y estilos.
   * @memberof BcButtonGroupBehavior
   */
    setUpAllFeatures() {
        this.setLabelWidth();
        this.setCheckedProperty();
        this.setIndicatorFeatures();
        this.setEventListeners();
        this.setIndicatorColor();
        this.addFontSizeClass();
    }
    /**
   * Inicializa cada variable Element de la clase.
   * @memberof BcButtonGroupBehavior
   */
    setElements() {
        const checked = `${BcCommonConstants.INPUT_TAG}.${BC_BUTTON_GROUP.INPUT}:${BcCommonConstants.CHECKED} + ${BcCommonConstants.LABEL_TAG}`;
        this.container = this.mySelf;
        this.indicator = this.mySelf.querySelector(`${BcCommonConstants.DIV_TAG}.${BC_BUTTON_GROUP.INDICATOR}`);
        this.labels = Array.from(this.mySelf.querySelectorAll(`${BcCommonConstants.INPUT_TAG}.${BC_BUTTON_GROUP.INPUT}+ ${BcCommonConstants.LABEL_TAG}`));
        this.inputElements = Array.from(this.mySelf.querySelectorAll(`${BcCommonConstants.INPUT_TAG}.${BC_BUTTON_GROUP.INPUT}`));
        this.checkedLabel = this.mySelf.querySelector(checked);
    }
    /**
     * Asigna los comportamientos y estilos del indicador.
     * @memberof BcButtonGroupBehavior
     */
    setIndicatorFeatures() {
        this.setCheckedInput();
        this.setIndicatorPosition();
        this.setIndicatorDimensions();
    }
    /**
    * Pone el indicador en la posicion 0 por defecto.
    * @memberof BcButtonGroupBehavior
    */
    setCheckedProperty() {
        this.inputElements[COMMON_CONSTANTS_NUMBERS.N0].setAttribute(BcCommonConstants.CHECKED, '');
    }
    /**
    * Asigna un ancho igual a cada label dependiendo de cuanto mida el contenedor.
    * @memberof BcButtonGroupBehavior
    */
    setLabelWidth() {
        let width = Math.max(this.container.clientWidth) / this.labels.length;
        this.labels.forEach((label) => {
            label.style.width = width + 'px';
        });
    }
    /**
    * Asigna tamaño del indicador al tamaño del label.
    * @memberof BcButtonGroupBehavior
    */
    setIndicatorDimensions() {
        this.indicator.style.width = Math.max(this.container.clientWidth) / this.labels.length + 'px';
    }
    /**
    * Mueve la posicion del indicador.
    * @memberof BcButtonGroupBehavior
    */
    setIndicatorPosition() {
        this.indicator.style.left = this.getCheckedLabelAbsolutePosition().left;
        this.indicator.style.top = this.getCheckedLabelAbsolutePosition().top;
    }
    /**
    * Proporciona las coordenadas del label seleccionado.
    * @memberof BcButtonGroupBehavior
    */
    getCheckedLabelAbsolutePosition() {
        const containLeft = this.container.getBoundingClientRect().left;
        const containPaddLeft = parseInt(getComputedStyle(this.container).paddingLeft);
        const containTop = this.container.getBoundingClientRect().top;
        const containPaddTop = parseInt(getComputedStyle(this.container).paddingTop);
        return {
            left: this.checkedLabel.getBoundingClientRect().left - containLeft - containPaddLeft + 'px',
            top: this.checkedLabel.getBoundingClientRect().top - containTop - containPaddTop + 'px'
        };
    }
    /**
    * Asigna los eventos.
    * @memberof BcButtonGroupBehavior
    */
    setEventListeners() {
        this.inputElements.forEach((radioButton) => {
            radioButton.addEventListener(BcCommonConstants.EVENT_CHANGE, () => {
                this.setIndicatorFeatures();
            });
        });
        window.addEventListener(BcCommonConstants.EVENT_RESIZE, () => {
            this.setIndicatorPosition();
            this.setIndicatorDimensions();
            this.setLabelWidth();
            this.getCheckedLabelAbsolutePosition();
        });
    }
    /**
    * Cambiar el texto del indicador por el texto del label.
    * @memberof BcButtonGroupBehavior
    */
    setCheckedInput() {
        const checked = `${BcCommonConstants.INPUT_TAG}.${BC_BUTTON_GROUP.INPUT}:${BcCommonConstants.CHECKED} + ${BcCommonConstants.LABEL_TAG}`;
        this.checkedLabel = this.mySelf.querySelector(checked);
        this.indicator.querySelector(BcCommonConstants.SPAN_TAG).innerHTML = this.checkedLabel.innerHTML;
    }
    /**
    * Agrega el tamaño de fuente de los elementos.
    * @memberof BcButtonGroupBehavior
    */
    addFontSizeClass() {
        const labelSize = this.fontSize === BcCommonConstants.SMALL || !this.fontSize ? BC_BUTTON_GROUP.SMALL : BC_BUTTON_GROUP.X_SMALL;
        this.indicator.classList.add(labelSize);
        this.labels.forEach((label) => {
            label.className = labelSize;
        });
    }
    /**
    * Asigna el color del indicador.
    * @memberof BcButtonGroupBehavior
    */
    setIndicatorColor() {
        if (this.indicatorColor) {
            switch (this.indicatorColor) {
                case BC_BUTTON_GROUP.BLACK_INDICATOR_INPUT:
                    this.indicator.className = BC_BUTTON_GROUP.INDICATOR;
                    this.indicator.classList.add(BC_BUTTON_GROUP.BLACK_INDICATOR_COLOR);
                    break;
                default:
                    this.indicator.className = BC_BUTTON_GROUP.INDICATOR;
                    this.indicator.classList.add(BC_BUTTON_GROUP.DEFAULT_INDICATOR_COLOR);
            }
        }
        else {
            this.indicator.classList.add(BC_BUTTON_GROUP.DEFAULT_INDICATOR_COLOR);
        }
        this.addFontSizeClass();
    }
    setInitialIndicator() {
        const checked = `${BcCommonConstants.INPUT_TAG}.${BC_BUTTON_GROUP.INPUT}:${BcCommonConstants.CHECKED}`;
        const input = this.mySelf.querySelector(checked);
        this.indicator.querySelector(BcCommonConstants.SPAN_TAG).innerHTML = input.value;
    }
    setFontSize(fontSize) {
        this.fontSize = fontSize;
        this.addFontSizeClass();
    }
    setActiveButtonColor(indicatorColor) {
        this.indicatorColor = indicatorColor;
        this.setIndicatorColor();
    }
}

const BC_AVATAR_NULL_SRC = `${BcCommonConstants.PREFIX_LIB}-avatar-null-src`;
const SRC_TAG = `src`;
const SVG_DEFAULT = `data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yMCAxMy4zMzMzQzIwIDcuODIgMjQuNDg2NyAzLjMzMzMzIDMwIDMuMzMzMzNDMzUuNTEzMyAzLjMzMzMzIDQwIDcuODIgNDAgMTMuMzMzM1YxOC4yNjMzQzQwIDIzLjE4MzMgMzcuNTU2NyAzMy4zMzY3IDMwIDMzLjMzNjdDMjIuNDQzMyAzMy4zMzY3IDIwIDIzLjE4MzMgMjAgMTguMjYzM1YxMy4zMzMzWk0xNi42NjY3IDE4LjI2MzNDMTYuNjY2NyAyNS45MDY3IDIwLjgwMzMgMzYuNjcgMzAgMzYuNjdDMzkuMTk2NyAzNi42NyA0My4zMzMzIDI1LjkwNjcgNDMuMzMzMyAxOC4yNjMzVjEzLjMzMzNDNDMuMzMzMyA1Ljk4IDM3LjM1MzMgMCAzMCAwQzIyLjY0NjcgMCAxNi42NjY3IDUuOTggMTYuNjY2NyAxMy4zMzMzVjE4LjI2MzNaTTU2LjY2NjcgNTVWNTYuNjY2N0gzLjMzMzMzVjU1QzMuMzMzMzMgNDguMzUgNy43NzMzMyA0Mi40OTMzIDE0LjA1MzMgNDAuNjIzM0MxNy4yODMzIDQ2LjM2MzMgMjMuNCA1MCAzMCA1MEMzNi42IDUwIDQyLjcxNjcgNDYuMzYzMyA0NS45NDY3IDQwLjYyMzNDNTIuMjI2NyA0Mi40OTMzIDU2LjY2NjcgNDguMzUgNTYuNjY2NyA1NVpNMCA2MEg2MFY1NUM2MCA0Ni4zNTY3IDUzLjg2MzMgMzguODEgNDUuNDA2NyAzNy4wNTMzTDQ0LjExNjcgMzYuNzg2N0w0My41NTY3IDM3Ljk4QzQxLjA5MzMgNDMuMjU2NyAzNS43NyA0Ni42NjY3IDMwIDQ2LjY2NjdDMjQuMjMgNDYuNjY2NyAxOC45MDY3IDQzLjI1NjcgMTYuNDQzMyAzNy45OEwxNS44ODMzIDM2Ljc4NjdMMTQuNTkzMyAzNy4wNTMzQzYuMTM2NjcgMzguODEgMCA0Ni4zNTY3IDAgNTVWNjBaIiBmaWxsPSIjMkMyQTI5Ii8+Cjwvc3ZnPgo=`;
const AVATAR_SMALL = `${BcCommonConstants.PREFIX_LIB}-avatar-small`;
const AVATAR_PUFFY = `${BcCommonConstants.PREFIX_LIB}-avatar-puffy`;
const ELEMENT_AVATAR_CLASS = `${BcCommonConstants.PREFIX_LIB}-avatar`;

class BcAvatarBehavior extends BcDefaultBehavior {
    static setUpAll() {
        const imgElements = Array.from(document.querySelectorAll(`[class^='${ELEMENT_AVATAR_CLASS}']`));
        const elements = [];
        for (const imgElement of imgElements) {
            const element = imgElement;
            const bc = new BcAvatarBehavior();
            bc.setElement(element);
            bc.setUp();
            elements.push(bc);
        }
        return elements;
    }
    _setUp() {
        const SRC = this.mySelf.getAttribute(SRC_TAG);
        /* istanbul ignore else */
        if (!SRC) {
            this.mySelf.setAttribute(SRC_TAG, SVG_DEFAULT);
            this.mySelf.classList.add(BC_AVATAR_NULL_SRC);
        }
    }
}

const SKIP_LINK_CONTENT_CLASS = `${BcCommonConstants.PREFIX_LIB}-skip-link`;

class BcSkipLinkBehavior extends BcDefaultBehavior {
    constructor() {
        super();
    }
    static setUpAll() {
        const skipLinkElements = Array.from(document.querySelectorAll(`a[class~='${SKIP_LINK_CONTENT_CLASS}']`));
        const elements = [];
        for (let i = 0; i < skipLinkElements.length; i++) {
            const element = skipLinkElements[i];
            const bc = new BcSkipLinkBehavior();
            bc.setElement(element);
            bc.setUp();
            elements.push(bc);
        }
        return elements;
    }
    /**
     * Agrega el foco al elemento para que sea el primero en el dom
     * en ejecutarse al presionar el tabulador.
     * @memberof BcSkipLinkBehavior
     */
    configScrollToElement() {
        addFocusable(this.mySelf, { tabindex: '0' }, {
            event: () => {
                const element = this.mySelf.getAttribute('href');
                document.querySelector(element).scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
            }
        });
    }
}

const INPUT_CLASS = `${BcCommonConstants.PREFIX_LIB}-input`;
const INPUT_ACTIVE_CLASS = `${BcCommonConstants.PREFIX_LIB}-active`;
const INPUT_FORM_FILE = `${BcCommonConstants.PREFIX_LIB}-form-field`;
const INPUT_PADDING_RIGHT_WHEN_ICON = `${BcCommonConstants.PREFIX_LIB}-pe-4`;
const INVISIBLE_CLASS = `${BcCommonConstants.PREFIX_LIB}-invisible`;
const EM_TAG = `${BcCommonConstants.EM_TAG}`;
const INPUT_ERROR_CLASS = `${BcCommonConstants.PREFIX_LIB}-${BcCommonConstants.INPUT_TAG}-error`;
const INPUT_SUCCESS_CLASS = `${BcCommonConstants.PREFIX_LIB}-${BcCommonConstants.INPUT_TAG}-success`;
const BC_INPUT_VALIDATION_CLASS = `${BcCommonConstants.PREFIX_LIB}-${BcCommonConstants.INPUT_TAG}-validation`;
const BC_INPUT_VALUE_CLASS = `${BcCommonConstants.PREFIX_LIB}-${BcCommonConstants.INPUT_TAG}-value`;
const INPUT_BUTTON_ICON_CLASS = `${BcCommonConstants.BC_BTN_CLASS}-icon`;
const BC_INPUT_SUCCESSFUL_ICON = 'successful';
const BC_INPUT_REMOVE_ICON = 'remove';
const BC_CLOUDY_ICON = 'cloudy';

class BcInputBehavior extends BcDefaultBehavior {
    constructor() {
        super();
        /**
        * Setea checkInput con value siempre que value no sea nulo o vacio.
        * @param {string} value valor del checkInput.
        * @memberof BcInputBehavior
        */
        this.checkInput = (value) => value !== null && value !== undefined && value !== '';
        /**
         * Agrega o remueve la clase INPUT_ACTIVE_CLASS al input según el valor del parámetro bool.
         * @param bool booleano, si es true agrega la clase INPUT_ACTIVE_CLASS de lo contrario la elimina.
         * @param myself representa el elemento input.
         * @memberof BcInputBehavior
         */
        this.addRemoveClass = (bool, myself) => {
            bool ? myself.classList.add(INPUT_ACTIVE_CLASS) : myself.classList.remove(INPUT_ACTIVE_CLASS);
        };
        this.updateState = (event) => {
            if (this.mySelf) {
                this.addRemoveClass(this.checkInput(this.mySelf.value), this.mySelf);
            }
        };
    }
    setMyLastClass(myLastClass) {
        this.myLastClass = myLastClass;
    }
    getMyLastClass() {
        return this.myLastClass;
    }
    static setUpAll() {
        const imgElements = Array.from(document.querySelectorAll(`[class^='${INPUT_CLASS}']`));
        const elements = [];
        for (const element of imgElements) {
            const bc = new BcInputBehavior();
            bc.setElement(element);
            bc.setUp();
            elements.push(bc);
        }
        return elements;
    }
    _setUp() {
        this.addPaddingRightWhenIcon(this.mySelf);
        this.addRemoveClass(this.checkInput(this.mySelf.value), this.mySelf);
        this.mySelf.addEventListener(BcCommonConstants.EVENT_INPUT, this.updateState);
        this.getInputs();
        this.setMyLastClass(this.mySelf.className);
        this.getMyLastClass();
        this.watchClassChanges(this.mySelf);
        this.inputValueListener(this.mySelf);
    }
    getInputs() {
        const inputs = Array.from(document.querySelectorAll(`[class~='${INPUT_CLASS}']`));
        for (const input of inputs) {
            addFocusable(input, { tabindex: '0' });
        }
    }
    inputValueListener(input) {
        if (input.classList.value.includes(BC_INPUT_VALUE_CLASS)) {
            input.addEventListener(BcCommonConstants.EVENT_INPUT, (e) => {
                this.formatInputValue(e, input);
                this.updateState(e);
            });
        }
    }
    formatInputValue(e, input) {
        if (e['data'] === ' ') {
            input.value = input.value.split(' ').join('');
        }
        let num = (input.value).replace(/\./g, '');
        if (!isNaN(num)) {
            num = num.toString().split('').reverse().join('').replace(/(?=\d*\.?)(\d{3})/g, '$1.');
            num = num.split('').reverse().join('').replace(/^[\.]/, '');
            input.value = num;
        }
        else {
            input.value = input.value.replace(/[^\d\.]*/g, '');
        }
    }
    /**
     * agrega un espacio a la derecha a los input que tienen un icono a la derecha
     * @param input elemento al que se le agregará el padding
     */
    addPaddingRightWhenIcon(input) {
        if (this.checkSiblingElementEM(input)) {
            input.classList.add(INPUT_PADDING_RIGHT_WHEN_ICON);
        }
    }
    /**
     * valida si el elemento tiene un elemente hermano em
     * @returns true si tiene un elemento hermano em, de lo contrario false
     */
    checkSiblingElementEM(input) {
        if (input.nextElementSibling !== null) {
            return input.nextElementSibling.nodeName.toLowerCase() === EM_TAG;
        }
        else {
            return false;
        }
    }
    validateFlow(myLastClass, currentClass) {
        this.lastClassDontHaveClassess = (!(myLastClass.includes(INPUT_ERROR_CLASS) || myLastClass.includes(INPUT_SUCCESS_CLASS))
            && (currentClass.includes(INPUT_ERROR_CLASS) || currentClass.includes(INPUT_SUCCESS_CLASS)));
        this.removeTheIcon = ((myLastClass.includes(INPUT_ERROR_CLASS) || myLastClass.includes(INPUT_SUCCESS_CLASS))
            && !(currentClass.includes(INPUT_ERROR_CLASS) || currentClass.includes(INPUT_SUCCESS_CLASS)));
        this.changeToTheOtherClass = ((myLastClass.includes(INPUT_ERROR_CLASS) || myLastClass.includes(INPUT_SUCCESS_CLASS)) && myLastClass !== currentClass);
    }
    watchClassChanges(mySelf) {
        this.setMyLastClass(mySelf.className);
        const observer = new MutationObserver((event) => {
            const currentClass = event[0].target.className;
            const myLastClass = this.getMyLastClass();
            if (currentClass.includes(BC_INPUT_VALIDATION_CLASS)) {
                this.validateFlow(myLastClass, currentClass);
                if (this.lastClassDontHaveClassess) {
                    this.bcInputValidation(mySelf);
                }
                else if (this.removeTheIcon) {
                    this.removeIconAndPadding(mySelf);
                    mySelf.nextElementSibling?.classList.remove(INVISIBLE_CLASS);
                    this.setMyLastClass(mySelf.className);
                    this.addRemoveClass(this.checkInput(this.mySelf.value), this.mySelf);
                    this.addPaddingRightWhenIcon(mySelf);
                }
                else if (this.changeToTheOtherClass) {
                    this.bcInputValidation(mySelf);
                }
            }
        });
        observer.observe(this.mySelf, {
            attributes: true,
            attributeFilter: ['class'],
            childList: false,
            characterData: false
        });
    }
    removeIconAndPadding(input) {
        if (this.checkSiblingElementEM(input)) {
            input.nextElementSibling.remove();
            input.style.paddingRight = '';
        }
    }
    bcInputValidation(input) {
        const nextElementToInput = input.nextElementSibling;
        let emElement;
        if (this.checkNextElmentToInput(nextElementToInput)) {
            if (this.checkIfButtonIsErrorOSuccess(nextElementToInput.innerHTML)) {
                if (this.checkIfBottonAlreadyExist(nextElementToInput.innerHTML, input.className)) {
                    return;
                }
                else {
                    nextElementToInput.parentNode?.removeChild(nextElementToInput);
                }
            }
            else {
                nextElementToInput.classList.add(INVISIBLE_CLASS);
            }
        }
        if (input.className.includes(INPUT_SUCCESS_CLASS)) {
            emElement = this.createElementEM();
            this.setSuccesIconography(emElement);
            input.insertAdjacentElement(BcCommonConstants.AFTER_END, emElement);
        }
        else if (input.className.includes(INPUT_ERROR_CLASS)) {
            emElement = this.createElementEM();
            this.setErrorIconography(emElement, input);
            input.insertAdjacentElement(BcCommonConstants.AFTER_END, emElement);
        }
        input.style.paddingRight = '24px';
        this.setMyLastClass(input.className);
        this.addRemoveClass(this.checkInput(this.mySelf.value), this.mySelf);
    }
    setSuccesIconography(emElement) {
        emElement.innerHTML = BC_INPUT_SUCCESSFUL_ICON;
    }
    checkIfBottonAlreadyExist(nameButton, classess) {
        let tempClass;
        if (nameButton === BC_INPUT_SUCCESSFUL_ICON) {
            tempClass = INPUT_SUCCESS_CLASS;
        }
        else {
            tempClass = INPUT_ERROR_CLASS;
        }
        if (classess.includes(tempClass)) {
            return true;
        }
        else {
            return false;
        }
    }
    checkIfButtonIsErrorOSuccess(nameButton) {
        if (nameButton === BC_INPUT_SUCCESSFUL_ICON || nameButton === BC_INPUT_REMOVE_ICON) {
            return true;
        }
        else {
            return false;
        }
    }
    setErrorIconography(emElement, input) {
        emElement.innerHTML = BC_INPUT_REMOVE_ICON;
        addFocusable(emElement, { tabindex: '0' });
        emElement.classList.add(INPUT_BUTTON_ICON_CLASS);
        emElement.addEventListener(BcCommonConstants.EVENT_CLICK, () => {
            input.className = input.className.replace(INPUT_ERROR_CLASS, '');
            input.className = input.className.replace(INPUT_ACTIVE_CLASS, '');
            input.value = '';
            input.focus();
        });
        this.addScreenReader(emElement);
    }
    checkNextElmentToInput(nextElementToInput) {
        if (nextElementToInput.nodeName.toLowerCase() == BcCommonConstants.EM_TAG) {
            return true;
        }
        else {
            return false;
        }
    }
    createElementEM() {
        return document.createElement(EM_TAG);
    }
    addScreenReader(element) {
        element.addEventListener(BcCommonConstants.EVENT_KEY_UP, (event) => {
            if (event.key === ' ') {
                this.focusNext(element);
            }
        });
    }
    focusNext(element) {
        element.click();
    }
}

const CIRCLE_TEMPLATE = `<svg class="bc-progress-circular-progress" xmlns="http://www.w3.org/2000/svg">
<circle class="bc-progress-circle-container-background" cx="50%" cy="50%" pathLength="100"></circle>
<circle class="bc-progress-circle-container-progress"  cx="50%" cy="50%" pathLength="100"></circle>
</svg>`;
const LINEAL_TEMPLATE = `<div class="bc-progress-container bc-progress-bar-lineal-container">
<div  class="bc-progress-bar-lineal-value"></div>
</div>`;
const SEMI_CIRCLE_TEMPLATE = `
<svg class="bc-progress-semi-circular-progress"  xmlns="http://www.w3.org/2000/svg">
  <circle class="bc-progress-semi-circular-container-background"  cx="50%" cy="50%" pathLength="100"></circle>
  <circle class="bc-progress-semi-circular-container-progress"   cx="50%" cy="50%" pathLength="100">
  </circle>
</svg>`;
const PERMITED_COLORS = ['yellow', 'green', 'purple', 'orange', 'pink', 'blue', 'white', 'red'];
const BC_PROGRESS_BAR_ELEMENT = `${BcCommonConstants.PREFIX_LIB}-progress-bar`;
const BC_PROGRESS_BAR_CONTAINER = `${BcCommonConstants.PREFIX_LIB}-progress-container`;
const BC_PROGRESS_BAR_CONTENT = `${BcCommonConstants.PREFIX_LIB}-progress-bar-content`;
const BC_PROGRESS_BAR_CIRCLE_CONTAINER_BACKGROUND = `${BcCommonConstants.PREFIX_LIB}-progress-circle-container-background`;
const BC_PROGRESS_BAR_CIRCLE_CONTAINER_PROGRESS = `${BcCommonConstants.PREFIX_LIB}-progress-circle-container-progress`;
const BC_PROGRESS_BAR_SEMICIRCLE_CONTAINER_BACKGROUND = `${BcCommonConstants.PREFIX_LIB}-progress-semi-circular-container-background`;
const BC_PROGRESS_BAR_SEMICIRCLE_CONTAINER_PROGRESS = `${BcCommonConstants.PREFIX_LIB}-progress-semi-circular-container-progress`;
const BC_PROGRESS_BAR_LINEAL_VALUE = `${BcCommonConstants.PREFIX_LIB}-progress-bar-lineal-value`;
const BC_DEFAULT_STROKE_WIDTH = '4';
const BC_HALF_DIAMETER = 2;
const BC_THREE_QUARTER_CIRCLE = 75;
const BC_COMPLETE_CIRCLE = 100;
const BC_CIRCLE = 'circle';
const BC_SEMI_CIRCLE = 'semi-circle';
const BC_LINEAL = 'lineal';
const SVG = 'svg';
const VERTICAL = 'vertical';
const HORIZONTAL = 'horizontal';

class BcProgressBarBehavior extends BcDefaultBehavior {
    constructor() {
        super();
    }
    /**
     * Para cada elemento con una clase que comience con 'bc-progress-bar', cree un nuevo
     * BcProgressBarBehavior, establezca su elemento en el elemento actual y configúrelo.
     * @memberof BcProgressBarBehavior
     * @returns Una matriz de objetos BcProgressBarBehavior.
     */
    static setUpAll() {
        const progressElements = Array.from(document.querySelectorAll(`[class^='${BC_PROGRESS_BAR_ELEMENT}']`));
        const elements = [];
        progressElements.forEach((element) => {
            const progress = new BcProgressBarBehavior();
            progress.setElement(element);
            progress.setUp();
            elements.push(progress);
        });
        return elements;
    }
    /**
     * @memberof BcProgressBarBehavior
     */
    _setUp() {
        this.createProgresBar();
        this.setProgress(parseFloat(this.getValueProgress()));
        this.setColor(this.getColorProgress());
        this.setDiameter(parseFloat(this.getDiameter()));
        this.setOrientation(this.getOrientation());
    }
    /**
     * Si la barra de progreso es lineal, si la orientación es vertical, gire la barra de progreso 90
     * grados; de lo contrario, gire la barra de progreso 0 grados.
     * @param {string} orientation - cadena -&gt; VERTICALES u HORIZONTALES
     */
    setOrientation(orientation) {
        if (this.getTypeProgress() === BC_LINEAL) {
            if (orientation === VERTICAL) {
                this.getMySelf().style.transform = `rotate(90deg)`;
                this.getMySelf().style.transformOrigin = '6px 100%';
            }
            else {
                this.getMySelf().style.transform = `rotate(0deg)`;
            }
        }
    }
    /**
     * "Si el tipo de progreso es un círculo o semicírculo, establezca el ancho de trazo del círculo o
     * semicírculo en el ancho de trazo pasado".
     * @param {number} stroke - número
     */
    setStroke(stroke) {
        const typeProgress = this.getTypeProgress();
        if (typeProgress === BC_CIRCLE || typeProgress === BC_SEMI_CIRCLE) {
            const circleContainerBackground = this.mySelf.querySelector(`.${BC_PROGRESS_BAR_CIRCLE_CONTAINER_BACKGROUND}`);
            const circleContainerProgress = this.getMySelf().querySelector(`.${BC_PROGRESS_BAR_CIRCLE_CONTAINER_PROGRESS}`);
            const semiCircleContainerBackground = this.mySelf.querySelector(`.${BC_PROGRESS_BAR_SEMICIRCLE_CONTAINER_BACKGROUND}`);
            const semiCircleContainerProgress = this.getMySelf().querySelector(`.${BC_PROGRESS_BAR_SEMICIRCLE_CONTAINER_PROGRESS}`);
            if (circleContainerBackground) {
                circleContainerBackground['style'].strokeWidth = String(stroke);
            }
            if (circleContainerProgress) {
                circleContainerProgress.style.strokeWidth = String(stroke);
            }
            if (semiCircleContainerBackground) {
                semiCircleContainerBackground['style'].strokeWidth = String(stroke);
            }
            if (semiCircleContainerProgress) {
                semiCircleContainerProgress.style.strokeWidth = String(stroke);
            }
        }
    }
    /**
     * Si el tipo de progreso es BC_SEMI_CIRCLE, establezca el diámetro del semicírculo en el diámetro
     * dado; de lo contrario, establezca el diámetro del círculo en el diámetro dado.
     * @param {number} diameter - número - el diámetro de la barra de progreso
     */
    setDiameter(diameter) {
        switch (this.getTypeProgress()) {
            case BC_SEMI_CIRCLE:
                this.setDiameterSemiCircle(diameter);
                break;
            case BC_CIRCLE:
                this.setDiameterCircle(diameter);
        }
    }
    /**
     * Configuración del ancho y la altura del elemento SVG.
     * @memberof BcProgressBarBehavior
     */
    setDiameterSemiCircle(diameter) {
        this.getMySelf().querySelector(SVG).style.width = diameter;
        this.getMySelf().querySelector(SVG).style.height = diameter;
    }
    /**
     * Esta función establece el diámetro del círculo al valor del parámetro de diámetro.
     * @param diameter - El diámetro del círculo.
     */
    setDiameterCircle(diameter) {
        this.getMySelf().querySelector(SVG).style.width = diameter;
        this.getMySelf().querySelector(SVG).style.height = diameter;
    }
    /**
     * @memberof BcProgressBarBehavior
     */
    /**
     * Cree una barra de progreso basada en el tipo de barra de progreso que se establece.
     */
    createProgresBar() {
        switch (this.getTypeProgress()) {
            case BC_LINEAL:
                this.createProgressLineal();
                break;
            case BC_SEMI_CIRCLE:
                this.createProgressSemiCircle();
                break;
            case BC_CIRCLE:
                this.createProgressCircle();
        }
    }
    /**
     *
     * @param progress
     * @memberof BcProgressBarBehavior
     */
    /**
     * Si el progreso es lineal, cambie el progreso lineal. Si el progreso es un semicírculo, cambie el
     * semicírculo de progreso. Si el progreso es un círculo, cambie el círculo de progreso.
     * @param {number} progress - número: el valor de progreso que se establecerá.
     */
    setProgress(progress) {
        switch (this.getTypeProgress()) {
            case BC_LINEAL:
                this.changeProgressLineal(progress);
                break;
            case BC_SEMI_CIRCLE:
                this.changeProgressSemiCircle(progress);
                break;
            case BC_CIRCLE:
                this.changeProgressCircle(progress);
        }
    }
    /**
     *
     * @param progress
     * @memberof BcProgressBarBehavior
     */
    /**
     * Si el color no está en la matriz de colores permitidos, arroja un error. De lo contrario, si el
     * tipo de progreso es lineal, cambie el color de la barra de progreso lineal. Si el
     * tipo de progreso es semicírculo, cambie el color de la barra de progreso del semicírculo. De lo
     * contrario, cambie el color de la barra de progreso del círculo.
     * @param {string} color - cuerda
     */
    setColor(color) {
        if (!PERMITED_COLORS.includes(this.getColorProgress())) {
            throw new Error('Color no disponible.');
        }
        switch (this.getTypeProgress()) {
            case BC_LINEAL:
                this.changeColorLineal(color);
                break;
            case BC_SEMI_CIRCLE:
                this.changeColorSemiCircle(color);
                break;
            case BC_CIRCLE:
                this.changeColorCircle(color);
        }
    }
    /**
     * Elimina el color actual del círculo y agrega el nuevo color al círculo.
     * @param {string} color - string - el color al que quieres cambiar
     */
    changeColorCircle(color) {
        this.removeCurrentColor(this.getMySelf().querySelector(SVG));
        this.getMySelf().querySelector(SVG).classList.add(`${BC_PROGRESS_BAR_CONTAINER}-${color}`);
    }
    /**
     * "Esta función elimina el color actual del elemento svg y agrega el nuevo color al elemento svg".
     * @param {string} color - string - el color al que quieres cambiar
     */
    changeColorSemiCircle(color) {
        this.removeCurrentColor(this.getMySelf().querySelector(SVG));
        this.getMySelf().querySelector(SVG).classList.add(`${BC_PROGRESS_BAR_CONTAINER}-${color}`);
    }
    /**
     * Elimina el color actual de la barra de progreso y agrega el nuevo color.
     * @param {string} color - cadena -&gt; El color al que desea cambiar la barra de progreso.
     */
    changeColorLineal(color) {
        this.removeCurrentColor(this.getMySelf().querySelector(BcCommonConstants.DIV_TAG));
        this.getMySelf().querySelector(BcCommonConstants.DIV_TAG).classList.add(`${BC_PROGRESS_BAR_CONTAINER}-${color}`);
    }
    /**
     * Elimina el color actual de la barra de progreso.
     * @param {HTMLElement | SVGSVGElement} element - Elemento HTML | SVGSVGElement: el elemento del que
     * desea eliminar el color actual.
     */
    removeCurrentColor(element) {
        element.classList.forEach(classElement => {
            if (classElement.startsWith(`${BC_PROGRESS_BAR_CONTAINER}`)) {
                element.classList.remove(classElement);
            }
        });
    }
    /**
     * Esta función crea un círculo de progreso y establece el diámetro, el trazo y el color de fondo del
     * círculo.
     */
    createProgressCircle() {
        this.getMySelf().innerHTML += CIRCLE_TEMPLATE;
        const diameter = parseFloat(this.getDiameter());
        const radio = diameter / BC_HALF_DIAMETER - parseFloat(this.getStroke()) / BC_HALF_DIAMETER;
        const svg = this.getMySelf().querySelector(SVG);
        const circleContainerBackground = this.getMySelf().querySelector(`.${BC_PROGRESS_BAR_CIRCLE_CONTAINER_BACKGROUND}`);
        const circleContainerProgress = this.getMySelf().querySelector(`.${BC_PROGRESS_BAR_CIRCLE_CONTAINER_PROGRESS}`);
        svg.setAttribute('viewBox', `0 0 ${diameter} ${diameter}`);
        svg.classList.add(`${this.getBackgroundColor()}`);
        if (circleContainerBackground) {
            circleContainerBackground.setAttribute('r', String(radio));
            circleContainerBackground.style.strokeWidth = String(this.getStroke());
        }
        if (circleContainerProgress) {
            circleContainerProgress.setAttribute('r', String(radio));
            circleContainerProgress.style.strokeWidth = String(this.getStroke());
        }
        this.getMySelf().style.position = 'relative';
        this.getMySelf().style.width = String(diameter + 'px');
        this.getMySelf().style.height = String(diameter + 'px');
        const content = this.getMySelf().querySelector(`.${BC_PROGRESS_BAR_CONTENT}`);
        if (content) {
            content.style.position = 'absolute';
            content.style.top = '50%';
            content.style.left = '50%';
            content.style.transform = 'translate(-50%, -50%)';
        }
    }
    /**
     * Esta función crea una barra de progreso semicircular y establece el diámetro, el trazo y el color
     * de fondo de la barra de progreso.
     */
    createProgressSemiCircle() {
        this.getMySelf().innerHTML += SEMI_CIRCLE_TEMPLATE;
        const diameter = parseFloat(this.getDiameter());
        const radio = diameter / BC_HALF_DIAMETER - parseFloat(this.getStroke()) / BC_HALF_DIAMETER;
        const svg = this.getMySelf().querySelector(SVG);
        const circleContainerBackground = this.getMySelf().querySelector(`.${BC_PROGRESS_BAR_SEMICIRCLE_CONTAINER_BACKGROUND}`);
        const circleContainerProgress = this.getMySelf().querySelector(`.${BC_PROGRESS_BAR_SEMICIRCLE_CONTAINER_PROGRESS}`);
        svg.setAttribute('viewBox', `0 0 ${diameter} ${diameter}`);
        svg.classList.add(`${this.getBackgroundColor()}`);
        if (circleContainerBackground) {
            circleContainerBackground.setAttribute('r', String(radio));
            circleContainerBackground.style.strokeWidth = String(this.getStroke());
        }
        if (circleContainerProgress) {
            circleContainerProgress.setAttribute('r', String(radio));
            circleContainerProgress.style.strokeWidth = String(this.getStroke());
        }
        this.getMySelf().style.position = 'relative';
        this.getMySelf().style.width = String(diameter + 'px');
        this.getMySelf().style.height = String(diameter + 'px');
        const content = this.getMySelf().querySelector(`.${BC_PROGRESS_BAR_CONTENT}`);
        if (content) {
            content.style.position = 'absolute';
            content.style.top = '50%';
            content.style.left = '50%';
            content.style.transform = 'translate(-50%, -50%)';
        }
    }
    /**
     * Crea un elemento lineal de progreso y le agrega un color de fondo.
     */
    createProgressLineal() {
        this.getMySelf().innerHTML += LINEAL_TEMPLATE;
        this.getMySelf().querySelector(BcCommonConstants.DIV_TAG)?.classList.add(`${this.getBackgroundColor()}`);
    }
    /**
     * Si la barra de progreso existe, establezca su ancho en el valor de progreso.
     * @param {number} progress - número
     */
    changeProgressLineal(progress) {
        const progressBarLieal = this.getMySelf().querySelector(`.${BC_PROGRESS_BAR_LINEAL_VALUE}`);
        if (progressBarLieal) {
            progressBarLieal.style.width = progress + '%';
        }
    }
    /**
     * "La función toma un número como parámetro y luego cambia el strokeDashoffset del elemento svg al
     * valor del número".
     * @param {number} progress - número - el valor de progreso que se establecerá
     */
    changeProgressSemiCircle(progress) {
        const progressValue = this.computeProgressValue(progress);
        const semiCircleContainer = this.getMySelf().querySelector(`.${BC_PROGRESS_BAR_SEMICIRCLE_CONTAINER_PROGRESS}`);
        if (semiCircleContainer) {
            semiCircleContainer.style.strokeDashoffset = progressValue.toString();
        }
    }
    /**
     * La función toma un número como argumento y luego establece el desplazamiento del trazo de la barra
     * de progreso al valor del número.
     * @param {number} progress - número - el valor del progreso
     */
    changeProgressCircle(progress) {
        const progressValue = this.computeProgressValue(progress);
        const progressContainer = this.getMySelf().querySelector(`.${BC_PROGRESS_BAR_CIRCLE_CONTAINER_PROGRESS}`);
        if (progressContainer) {
            progressContainer.style.strokeDashoffset = progressValue.toString();
        }
    }
    /**
     * Devuelve el valor del atributo 'tipo' del elemento que tiene la clase 'progreso'
     * @returns El atributo de tipo del elemento.
     */
    getTypeProgress() {
        return this.getMySelf().getAttribute('type');
    }
    /**
     * Obtenga el valor de la barra de progreso y devuélvalo.
     * @returns El valor de la barra de progreso.
     */
    getValueProgress() {
        return this.getMySelf().getAttribute('value');
    }
    /**
     * Devuelve el atributo de color del elemento que llamó a la función.
     * @returns El atributo de color del elemento sobre el que se está desplazando.
     */
    getColorProgress() {
        return String(this.getMySelf().getAttribute('color'));
    }
    /**
     * Esta función devuelve el diámetro del círculo.
     * @returns El diámetro del círculo.
     */
    getDiameter() {
        return this.getMySelf().getAttribute('diameter');
    }
    /**
     * Devuelve el ancho de trazo del elemento.
     * @returns El ancho de trazo del elemento.
     */
    getStroke() {
        return this.getMySelf().getAttribute('stroke') || BC_DEFAULT_STROKE_WIDTH;
    }
    /**
     * Devuelve el valor del atributo `background-color` del elemento `my-self`, o `light` si el atributo
     * no está presente.
     * @returns El color de fondo del elemento.
     */
    getBackgroundColor() {
        return this.getMySelf().getAttribute('background-color') || 'light';
    }
    /**
     * Obtenga la orientación del control deslizante, si no está configurado, devuelva el valor
     * predeterminado.
     * @returns La orientación del control deslizante.
     */
    getOrientation() {
        return this.getMySelf().getAttribute('orientation') || HORIZONTAL;
    }
    /**
     * Si el tipo de progreso es un semicírculo, devuelva el valor de la barra de progreso como un
     * porcentaje del círculo de tres cuartos; de lo contrario, devuelva el valor de la barra de progreso
     * como un porcentaje del círculo completo.
     * @param {number} val - número - el valor de la barra de progreso
     * @returns El valor de la barra de progreso.
     */
    computeProgressValue(val) {
        if (this.getTypeProgress() === BC_SEMI_CIRCLE) {
            return Math.abs(BC_THREE_QUARTER_CIRCLE - (val * BC_THREE_QUARTER_CIRCLE) / BC_COMPLETE_CIRCLE);
        }
        else {
            return Math.abs(BC_COMPLETE_CIRCLE - val);
        }
    }
}

const MOLECULA = `${BcCommonConstants.PREFIX_LIB}-tabs-group`;
const TAB_HEADER_CLASS = `${BcCommonConstants.PREFIX_LIB}-tab-header`;
const TAB_CONTAINER_CLASS = `${BcCommonConstants.PREFIX_LIB}-tabs`;
const TAB_CLASS = `${BcCommonConstants.PREFIX_LIB}-tab`;
const TAB_BODY_CLASS = `${BcCommonConstants.PREFIX_LIB}-tab-body`;
const TAB_CONTENT_CLASS = `${BcCommonConstants.PREFIX_LIB}-tab-content`;
const ARROW_BUTTONS = 'arrow-buttons';
const ACTIVE_CLASS = 'active';
const HIDE_CLASS = 'hide';
const PREV_CLASS = 'prev';
const NEXT_CLASS = 'next';
const FOUR_LENGTH = 4;
const FIVE_LENGTH = 4;
const SIX_LENGTH = 4;
const MIN_WIDTH = 551;
const MEDIUM_WIDTH = 650;
const ONE_HUNDRED = 100;
const FIVE_HUNDRED = 500;
const TWO_NUMBER = 2;
const THREE_NUMBER = 3;
const TWELVE_NUMBER = 12;

const NOT_LABELS_ERROR = 'There are no labels in tabs.';
const NOT_LABEL_HEADER_ERROR = 'Is not posible to find the labels container. Please review the HTML structure of you component.';
const LEFT_POSITION = 'flex-start';
const RIGHT_POSITION = 'flex-end';
const JUSTIFY_CONTENT = 'Justifycontent';
const SPACE_BETWEEN = 'space-between';
const ORIENTATION = 'orientation';
class BcTabsGroupBehavior extends BcDefaultBehavior {
    constructor() {
        super();
        this.initialTab = 0;
        this.currentTabsSelected = 0;
        this.firsLoad = true;
        this.tabScrollPosition = 0;
    }
    /**
     * Configura todos los elementos en el DOM que posean la clase a la cual hace referencia un Tab.
     * @description Llama el método de configuración del objeto del tipo en cuestión. Por tanto este método debe estár implementado
     * en la clase.
     * @returns Listado de elementos de ese tipo en el DOM.
     * @memberof BcTabsGroupBehavior
     */
    static setUpAll() {
        const tabsElements = Array.from(document.querySelectorAll(`div[class^='${MOLECULA}']`));
        const elements = [];
        for (let i = 0; i < tabsElements.length; i++) {
            const element = tabsElements[i];
            const bcTabsGroupBehavior = new BcTabsGroupBehavior();
            bcTabsGroupBehavior.setElement(element);
            bcTabsGroupBehavior.setUp();
            elements.push(bcTabsGroupBehavior);
        }
        return elements;
    }
    /**
     * Realiza toda la configuración del objeto.
     * @returns
     * @memberof BcTabsGroupBehavior
     */
    _setUp() {
        this.initTabs();
    }
    initTabs() {
        super._setUp();
        this.container = this.mySelf;
        this.tabHeader = this.mySelf.querySelector(`:scope > .${TAB_HEADER_CLASS}`);
        this.tabsContainer = this.tabHeader.querySelector(`:scope > .${TAB_CONTAINER_CLASS}`);
        this.tabsArrowButtons = this.tabHeader.querySelector(`:scope > .${ARROW_BUTTONS}`);
        this.tabsPane = this.tabHeader.querySelectorAll(`:scope .${TAB_CONTAINER_CLASS} > .${TAB_CLASS}`);
        this.tabHeaderStyle = window.getComputedStyle(this.tabHeader) || this.tabHeader.style;
        this.tabHeaderMargin =
            parseInt(this.tabHeaderStyle.marginLeft, 10) +
                parseInt(this.tabHeaderStyle.marginRight, 10) +
                parseInt(this.tabHeaderStyle.paddingLeft, 10) +
                parseInt(this.tabHeaderStyle.paddingRight, 10);
        this.tabsLength = this.tabsPane.length;
        this.maxWidth = this.tabHeader.offsetWidth;
        this.scrollBase = Math.round(this.maxWidth / this.tabsLength);
        this.base = 0;
        this.left = 0;
        this.tabBody = this.mySelf.querySelector(`:scope > .${TAB_BODY_CLASS}`);
        this.justifycontent =
            this.tabsContainer.getAttribute(JUSTIFY_CONTENT) != null
                ? this.tabsContainer.getAttribute(JUSTIFY_CONTENT)
                : SPACE_BETWEEN;
        this.orientation = this.tabsContainer.getAttribute(ORIENTATION);
        this.positionTabs();
        this.setColSize();
        this.addWindowListeners();
        this.initTabsGroup();
        this.addListenersArrows();
    }
    /*Inicializa los listeners para el ajuste de las pestañas
     @memberof BcTabsGroupBehavior*/
    addWindowListeners() {
        window.addEventListener(BcCommonConstants.EVENT_LOAD, () => {
            this.configureTabsWidth(this.justifycontent);
            this.tabScrollPosition = 0;
            this.onResizeFunction(window.innerWidth);
        });
        window.addEventListener(BcCommonConstants.EVENT_RESIZE, (e) => {
            this.tabScrollPosition = 0;
            this.onResizeFunction(e.target.innerWidth);
        });
    }
    /**
     * Asigna la función call back a la pestaña seleccionada (onSelectTab).
     * @param functionCallback
     * @memberof BcTabsGroupBehavior
     */
    callBackTabSelected(functionCallback) {
        this.onSelectTab = functionCallback;
    }
    initTabsGroup() {
        const firstPane = this.tabsPane[0];
        const firstBody = this.tabBody.querySelectorAll(`:scope > .${TAB_CONTENT_CLASS}`)[0];
        firstPane !== undefined && firstPane.classList.add(ACTIVE_CLASS);
        firstBody !== undefined && firstBody.classList.add(ACTIVE_CLASS);
        for (let i = 0; i < this.tabsPane.length; i++) {
            const pane = this.tabsPane[i];
            this.addClickEventTab(pane, i);
            addFocusable(pane, { tabindex: '0' });
            this.screenReader(pane, i);
        }
        if (firstPane) {
            firstPane.click();
        }
    }
    getCurrentIndexSelected() {
        return this.currentTabsSelected;
    }
    onResizeFunction(innerWidth) {
        this.maxWidth = this.tabsContainer.offsetWidth;
        this.scrollBase = Math.round(this.maxWidth / this.tabsLength);
        this.toggleNav(this.tabsArrowButtons, innerWidth);
        this.firsLoad = true;
        setTimeout(() => {
        }, FIVE_HUNDRED);
    }
    setColSize() {
        if (this.mySelf.getAttribute('cols')) {
            const colSize = Number(this.mySelf.getAttribute('cols')) ? Number(this.mySelf.getAttribute('cols')) : TWELVE_NUMBER;
            if (colSize >= THREE_NUMBER && colSize <= TWELVE_NUMBER) {
                this.tabsContainer.classList.add('bc-col-' + colSize);
            }
            else {
                this.tabsContainer.classList.add('bc-col-12');
            }
        }
    }
    positionTabs() {
        if (this.mySelf.getAttribute('right') && this.mySelf.getAttribute('right') === 'true') {
            this.tabsContainer.setAttribute(JUSTIFY_CONTENT, RIGHT_POSITION);
        }
        if (this.mySelf.getAttribute('left') && this.mySelf.getAttribute('left') === 'true') {
            this.tabsContainer.setAttribute(JUSTIFY_CONTENT, LEFT_POSITION);
        }
    }
    toggleNav(tabsArrowButtons, innerWidth) {
        const ele = tabsArrowButtons;
        if (this.tabHeader.offsetWidth < this.getWidthAllTabs()) {
            ele.classList.remove(HIDE_CLASS);
            const tabs = this.tabsContainer.children;
            this.tabsContainer.setAttribute(JUSTIFY_CONTENT, LEFT_POSITION);
            if (tabs.length > FIVE_LENGTH) {
                this.base = SIX_LENGTH;
            }
            if (tabs.length < SIX_LENGTH) {
                this.base = FOUR_LENGTH;
            }
            if (innerWidth < MIN_WIDTH && tabs.length > FIVE_LENGTH) {
                this.base = FOUR_LENGTH;
            }
            if (innerWidth < MEDIUM_WIDTH && tabs.length > FIVE_LENGTH) {
                this.base = FIVE_LENGTH;
            }
            if (this.firsLoad) {
                this.firsLoad = false;
            }
        }
        else {
            ele.classList.add(HIDE_CLASS);
            this.tabsContainer.setAttribute(JUSTIFY_CONTENT, this.justifycontent);
            this.tabsContainer.style.left = '0';
        }
    }
    hideElement(element, displayString) {
        element.style.display = displayString;
    }
    addListenersArrows() {
        const arrowButtons = this.tabsArrowButtons.children;
        const tabsContainer = this.tabsContainer;
        tabsContainer.style.left = '0';
        const prevArrow = arrowButtons[0];
        this.tabScrollPosition == 0 ? this.hideElement(prevArrow, 'none') : this.hideElement(prevArrow, '');
        for (let i = 0; i < arrowButtons.length; i++) {
            const element = arrowButtons[i];
            element.addEventListener(BcCommonConstants.EVENT_CLICK, () => {
                if (element.className.indexOf(PREV_CLASS) >= 0 && this.tabScrollPosition > 0) {
                    this.hideElement(arrowButtons[1], '');
                    const leftPosition = `-${this.left * -1 - this.tabsPane[this.tabScrollPosition].offsetWidth}px`;
                    tabsContainer.style.left = leftPosition;
                    this.tabScrollPosition--;
                    this.tabScrollPosition == 0 ? this.hideElement(element, 'none') : this.hideElement(element, '');
                }
                else if (element.className.indexOf(NEXT_CLASS) >= 0 && this.tabsPane.length - TWO_NUMBER >= this.tabScrollPosition) {
                    this.hideElement(prevArrow, '');
                    const leftPosition = `-${this.left * -1 + this.tabsPane[this.tabScrollPosition].offsetWidth}px`;
                    tabsContainer.style.left = leftPosition;
                    this.tabScrollPosition++;
                    if (this.tabsPane[this.tabsPane.length - TWO_NUMBER].getBoundingClientRect().right <=
                        this.tabHeader.getBoundingClientRect().right) {
                        this.hideElement(element, 'none');
                    }
                }
                this.left = parseInt(this.tabsContainer.style.left, 10);
            });
        }
    }
    /**
     * Verifica que tecla ha sido activada por el usuario en el componente
     * @param {number} index
     * @memberof BcTabsGroupBehavior
     */
    screenReader(element, index) {
        element.addEventListener(BcCommonConstants.EVENT_KEY_UP, (event) => {
            if (event.key === BcCommonConstants.KEY_EVENT_ARROW_RIGHT) {
                this.focusNext(index);
            }
            else if (event.key === BcCommonConstants.KEY_EVENT_ARROW_LEFT) {
                this.focusBack(index);
            }
            else if (event.key === BcCommonConstants.KEY_EVENT_ENTER) {
                this.focusEnter(index);
            }
            else if (event.key === BcCommonConstants.KEY_EVENT_SPACE) {
                this.focusEnter(index);
            }
        });
    }
    /**
     * Metodo que permite enfocar el siguiente elemento del tab
     * @param {number} index
     * @memberof BcTabsGroupBehavior
     */
    focusNext(index) {
        let element = this.getCurrentElement(index);
        if (element !== null) {
            element.classList.remove(BcCommonConstants.OUTLINE_ELEMENT);
            if (index < this.tabsPane.length - 1) {
                index++;
                element = this.getCurrentElement(index);
            }
            else {
                index = this.initialTab;
                element = this.getCurrentElement(index);
            }
            element.classList.add(BcCommonConstants.OUTLINE_ELEMENT);
            element.focus();
        }
    }
    /**
     * Metodo que permite enfocar el tab anterior al que se encuentra situado
     * @param {number} index
     * @memberof BcTabsGroupBehavior
     */
    focusBack(index) {
        let element = this.getCurrentElement(index);
        if (element !== null) {
            element.classList.remove(BcCommonConstants.OUTLINE_ELEMENT);
            if (index > 0) {
                index--;
                element = this.getCurrentElement(index);
            }
            else {
                index = this.tabsPane.length - 1;
                element = this.getCurrentElement(index);
            }
            element.classList.add(BcCommonConstants.OUTLINE_ELEMENT);
            element.focus();
        }
    }
    /**
     * Metodo que permite enfocar el siguiente elemento del tab
     * @param {number} index
     * @memberof BcTabsGroupBehavior
     */
    focusEnter(index) {
        this.tabsPane[index].click();
    }
    /**
     * Metodo que permite obtener el current element
     * @param {number} index
     * @memberof BcTabsGroupBehavior
     */
    getCurrentElement(index) {
        return this.mySelf.querySelectorAll('.bc-tab')[index];
    }
    addClickEventTab(pane, i) {
        pane.addEventListener(BcCommonConstants.EVENT_CLICK, () => {
            this.removeAddClasses(pane, i);
            if (this.onSelectTab) {
                this.currentTabsSelected = i;
                this.onSelectTab(this.currentTabsSelected);
            }
        });
    }
    removeAddClasses(pane, i) {
        const activeContainer = this.tabHeader.querySelectorAll(`:scope .${TAB_CONTAINER_CLASS} > .${ACTIVE_CLASS}`)[0];
        activeContainer !== undefined && activeContainer.classList.remove(`${ACTIVE_CLASS}`);
        const activeBody = this.tabBody.querySelectorAll(`:scope > .${ACTIVE_CLASS}`)[0];
        activeBody !== undefined && activeBody.classList.remove(`${ACTIVE_CLASS}`);
        pane !== undefined && pane.classList.add(ACTIVE_CLASS);
        const body = this.tabBody.querySelectorAll(`:scope > .${TAB_CONTENT_CLASS}`)[i];
        addFocusable(body, { tabindex: '0' });
        body !== undefined && body.classList.add(ACTIVE_CLASS);
    }
    selectTab(index) {
        if (this.tabsPane[index]) {
            this.tabsPane[index].click();
        }
    }
    configureTabsWidth(justifyContent) {
        let sizeTabs = 'auto';
        if (justifyContent === SPACE_BETWEEN) {
            const numTabs = this.tabsPane.length || 0;
            sizeTabs = `${ONE_HUNDRED / numTabs}%`;
        }
        this.tabsPane.forEach((element) => {
            if (this.orientation === 'vertical') {
                element.style.width = `100%`;
            }
        });
    }
    show(index) {
        const tab = this.getTabsHTMLObject(index);
        tab.title.style.display = 'block';
    }
    hidden(index) {
        const tab = this.getTabsHTMLObject(index);
        tab.title.style.display = 'none';
        this.autoSelectTab(index);
    }
    getTabsHTMLObject(index) {
        return {
            title: this.mySelf.querySelectorAll('.bc-tab')[index],
            body: this.mySelf.querySelectorAll('.bc-tab-content')[index],
        };
    }
    autoSelectTab(indexHidden) {
        if (indexHidden == this.getCurrentIndexSelected()) {
            const nextTabIndex = indexHidden + 1;
            const prevTabIndex = indexHidden - 1;
            if (nextTabIndex < this.tabsLength) {
                this.selectTab(nextTabIndex);
            }
            else if (prevTabIndex > 0) {
                this.selectTab(prevTabIndex);
            }
        }
    }
    getWidthAllTabs() {
        return Array.from(this.tabsPane)
            .map((a) => a.offsetWidth)
            .reduce((a, b) => {
            return a + b;
        });
    }
}

const SIDE_BAR = `${BcCommonConstants.PREFIX_LIB}-sidebar`;
const SIDE_BAR_ACTIVE_CONTENT = `${BcCommonConstants.PREFIX_LIB}-sidebar-active-content`;
const SIDE_BAR_ACTIVE_ITEM = `${BcCommonConstants.PREFIX_LIB}-sidebar-active-item`;
const CLOSE_BUTTON_TEXT = 'error';
const SIDE_BAR_STATUS_PROPERTY = 'status';
const SIDE_BAR_TYPE_PROPERTY = 'type';
const SIDE_BAR_ASIDE = ':scope>aside';
const SIDE_BAR_PRINCIPAL_CONTENT = ':scope>section:first-child>div:first-child';
const SIDE_BAR_BUTTONS_QUERY = ':scope>aside>section:first-child>section:first-child>button';
const SIDE_BAR_ARIA_CONTROL = '';
const SIDE_BAR_CONTENT_QUERY = ':scope>aside>section:first-child>section:nth-child(2)>div';
const SIDE_BAR_ID = 'id';
const SIDE_BAR_LI_NAV = ':scope>aside>nav>ul>li';
const SIDE_BAR_BUTTON_NAV = ':scope>aside>nav>ul:first-child>li>button';
const ARIA_LABEL_BARRA_EXPANDIR = 'Expandir barra lateral';
const ARIA_LABEL_BARRA_CONTRAER = 'Contraer barra lateral';
const ARIA_LABEL = 'aria-label';
var SideBarStatus;
(function (SideBarStatus) {
    SideBarStatus["close"] = "close";
    SideBarStatus["open"] = "open";
})(SideBarStatus || (SideBarStatus = {}));
var SideBarType;
(function (SideBarType) {
    SideBarType["fixed"] = "fixed";
    SideBarType["hide"] = "hide";
    SideBarType["collapsible"] = "collapsible";
    SideBarType["states"] = "states";
})(SideBarType || (SideBarType = {}));

class BcSidebarBehavior extends BcDefaultBehavior {
    constructor() {
        super();
    }
    static setUpAll() {
        const sidebarElements = Array.from(document.querySelectorAll(`section[class~='${SIDE_BAR}']`));
        const elements = [];
        for (const sidebarElement of sidebarElements) {
            const element = sidebarElement;
            const bc = new BcSidebarBehavior();
            bc.setElement(element);
            bc.setUp();
            elements.push(bc);
        }
        return elements;
    }
    _setUp() {
        this.configTypeFActions();
    }
    configOpenCloseButtonEvent() {
        const openCloseButton = this.mySelf.querySelector(`${SIDE_BAR_BUTTONS_QUERY}:first-child`);
        openCloseButton.addEventListener(BcCommonConstants.EVENT_CLICK, () => {
            switch (this.mySelf.getAttribute(SIDE_BAR_STATUS_PROPERTY)) {
                case SideBarStatus.close:
                    this.open();
                    break;
                case SideBarStatus.open:
                    this.close();
                    break;
                default:
                    this.open();
                    break;
            }
        });
    }
    setHeightContent() {
        const content = this.mySelf.querySelector(`${SIDE_BAR_PRINCIPAL_CONTENT}`);
        let height = document.documentElement.clientHeight;
        content.style.height = height + 'px';
        window.addEventListener('resize', function (event) {
            height = document.documentElement.clientHeight;
            content.style.height = height + 'px';
        });
    }
    open() {
        const openCloseButton = this.mySelf.querySelector(`${SIDE_BAR_BUTTONS_QUERY}:first-child`);
        this.changeStatus(SideBarStatus.open);
        this.configMainContent(true);
        openCloseButton.setAttribute(`${ARIA_LABEL}`, `${ARIA_LABEL_BARRA_CONTRAER}`);
        openCloseButton.innerHTML = BcCommonConstants.ICON_ARROW_RIGHT;
    }
    close() {
        const openCloseButton = this.mySelf.querySelector(`${SIDE_BAR_BUTTONS_QUERY}:first-child`);
        this.changeStatus(SideBarStatus.close);
        this.configMainContent(false);
        openCloseButton.setAttribute(`${ARIA_LABEL}`, `${ARIA_LABEL_BARRA_EXPANDIR}`);
        openCloseButton.innerHTML = BcCommonConstants.ICON_ARROW_LEFT;
    }
    changeStatus(status) {
        this.mySelf.setAttribute(SIDE_BAR_STATUS_PROPERTY, status);
    }
    configMainContent(action) {
        const contenToShow = this.mySelf.querySelector(`${SIDE_BAR_CONTENT_QUERY}:first-child`);
        if (action) {
            contenToShow.classList.toggle(SIDE_BAR_ACTIVE_CONTENT);
        }
        else {
            contenToShow.classList.remove(SIDE_BAR_ACTIVE_CONTENT);
        }
    }
    configCloseButtonEvent() {
        const closeButton = this.mySelf.querySelector(`${SIDE_BAR_BUTTONS_QUERY}:first-child`);
        closeButton?.addEventListener(BcCommonConstants.EVENT_CLICK, () => {
            this.mySelf.setAttribute(SIDE_BAR_STATUS_PROPERTY, SideBarStatus.close);
        });
    }
    configOpenButtonEventHide() {
        if (this.mySelf.getAttribute(SIDE_BAR_TYPE_PROPERTY).includes(SideBarType.hide)) {
            this.changeStatus(SideBarStatus.open);
        }
    }
    removeArrowButton() {
        this.removeDiferentSelectedButtons([CLOSE_BUTTON_TEXT]);
    }
    menuComponent() {
        const arrayTemp = [];
        const button = this.mySelf.querySelectorAll(`${SIDE_BAR_BUTTONS_QUERY}`);
        button.forEach((item) => {
            if (arrayTemp.includes(item.innerText)) {
                item.remove();
            }
            else {
                arrayTemp.push(item.innerText);
            }
        });
    }
    closeEventKey() {
        const contenToShow = this.mySelf.querySelectorAll(`${SIDE_BAR_BUTTONS_QUERY}`);
        window.addEventListener(BcCommonConstants.EVENT_KEY_DOWN, (event) => {
            this.closeComponentWithEsc(event, contenToShow);
        });
    }
    closeComponentWithEsc(event, contenToShow) {
        if (event.key === BcCommonConstants.KEY_EVENT_ESCAPE) {
            if (this.mySelf.getAttribute(SIDE_BAR_TYPE_PROPERTY) == SideBarType.collapsible) {
                this.close();
            }
            else {
                this.mySelf.setAttribute(SIDE_BAR_STATUS_PROPERTY, SideBarStatus.close);
            }
            for (let index = 0; index < contenToShow.length; index++) {
                contenToShow[index].classList.remove(SIDE_BAR_ACTIVE_CONTENT);
            }
        }
    }
    removeDiferentSelectedButtons(wantedButtonText) {
        this.mySelf.querySelectorAll(`${SIDE_BAR_BUTTONS_QUERY}`).forEach((item) => {
            if (!wantedButtonText.includes(item.textContent)) {
                item.remove();
            }
        });
        this.menuComponent();
    }
    removeBothButtons() {
        this.removeArrowButton();
        this.removeCloseButton();
    }
    removeCloseButton() {
        this.removeDiferentSelectedButtons([BcCommonConstants.ICON_ARROW_LEFT]);
    }
    configMenuItemsAction() {
        const itemsButton = this.mySelf.querySelectorAll(`${SIDE_BAR_LI_NAV}`);
        for (let index = 0; index < itemsButton.length; index++) {
            const item = itemsButton[index];
            const button = item.querySelector('button');
            addFocusable(button, { tabindex: '0' });
            button.setAttribute('aria-label', `Seleccionado ${index} de ${itemsButton.length}`);
            const idReference = button.getAttribute('aria-controls');
            if (idReference) {
                const elementContent = this.mySelf.querySelector(`${SIDE_BAR_CONTENT_QUERY}#${idReference}`);
                const validateOpenId = this.validateOpenId(item, elementContent);
                button.addEventListener(BcCommonConstants.EVENT_CLICK, validateOpenId);
            }
        }
    }
    accesibility() {
        const closeButton = this.mySelf.querySelector(`${SIDE_BAR_BUTTONS_QUERY}:first-child`);
        addFocusable(closeButton, { tabindex: '0' });
    }
    validateOpenId(item, elementContent) {
        return () => {
            if (item.classList.contains(SIDE_BAR_ACTIVE_ITEM)) {
                this.removeActiveItem();
                elementContent.classList.remove(SIDE_BAR_ACTIVE_CONTENT);
                this.changeStatus(SideBarStatus.close);
            }
            else {
                this.mySelf
                    .querySelector(`${SIDE_BAR_CONTENT_QUERY}.${SIDE_BAR_ACTIVE_CONTENT}`)
                    ?.classList.remove(SIDE_BAR_ACTIVE_CONTENT);
                if (elementContent) {
                    this.removeActiveItem();
                    item.classList.toggle(SIDE_BAR_ACTIVE_ITEM);
                    elementContent.classList.toggle(SIDE_BAR_ACTIVE_CONTENT);
                    this.changeStatus(SideBarStatus.open);
                }
            }
        };
    }
    removeActiveItem() {
        this.mySelf.querySelector(`${SIDE_BAR_LI_NAV}.${SIDE_BAR_ACTIVE_ITEM}`)?.classList.remove(SIDE_BAR_ACTIVE_ITEM);
    }
    configTypeFActions() {
        switch (this.mySelf.getAttribute(SIDE_BAR_TYPE_PROPERTY)) {
            case SideBarType.collapsible:
                this.setHeightContent();
                this.removeCloseButton();
                this.configOpenCloseButtonEvent();
                this.accesibility();
                this.closeEventKey();
                break;
            case SideBarType.hide:
                this.setHeightContent();
                this.configMainContent(true);
                this.removeArrowButton();
                this.configCloseButtonEvent();
                this.configOpenButtonEventHide();
                this.accesibility();
                break;
            case SideBarType.states:
                this.setHeightContent();
                this.removeBothButtons();
                this.configMenuItemsAction();
                this.closeEventKey();
                break;
            case SideBarType.fixed:
                this.setHeightContent();
                this.configMainContent(true);
                this.removeBothButtons();
                break;
            default:
                this.removeBothButtons();
                break;
        }
    }
}

const BC_CARD_AUTHENTICATION = `${BcCommonConstants.PREFIX_LIB}-card-auth`;
const BC_CARD_BUTTON_PRIMARY = `${BcCommonConstants.PREFIX_LIB}-button-primary`;
const BC_CARD_INPUT_ERROR = `${BcCommonConstants.PREFIX_LIB}-input-error`;
const BC_CARD_INPUT = 'input';
const BC_CARD_AUTH_CONTAINER = `${BC_CARD_AUTHENTICATION}-container`;
const BC_CARD_AUTH_MAX_INPUTS = 4;

class BcCardAuthenticationBehavior extends BcDefaultBehavior {
    constructor() {
        super();
        this.button = null;
        this.formValidate = this.validateForm.bind(this);
    }
    /**
     * Busca el componente mediante querySelectorAll y lo inicializa.
     * @returns array de elementos de tipo BcCardAuthentication encontrados.
     * @memberof BcCardAuthenticationBehavior
     */
    static setUpAll() {
        const cardAuthGroup = Array.from(document.querySelectorAll(`.${BC_CARD_AUTHENTICATION}`));
        const elements = [];
        for (const element of cardAuthGroup) {
            const bcCardAuthentication = new BcCardAuthenticationBehavior();
            bcCardAuthentication.setElement(element);
            bcCardAuthentication.setUp();
            elements.push(bcCardAuthentication);
        }
        return elements;
    }
    _setUp() {
        super._setUp();
        this.button = this.mySelf.querySelector(`.${BC_CARD_BUTTON_PRIMARY}`);
        this.button.addEventListener('click', (e) => {
            e.preventDefault();
            this.validateForm();
        });
        this.inputLimit();
    }
    /**
     * Recorre y valida la informacion requerido en los inputs que se encuentan adentro de la etiqueta form,
     * para usarlo se debe pasar en el html data-required="true"
     * @memberof BcCardAuthenticationBehavior
     */
    validateForm() {
        const formRequired = this.mySelf.querySelectorAll('form input[data-required="true"]');
        formRequired.forEach((input) => {
            if (!input.value) {
                input.classList.add(BC_CARD_INPUT_ERROR);
            }
            else {
                input.classList.remove(BC_CARD_INPUT_ERROR);
            }
        });
        const valid = !Array.from(formRequired).find((input) => !input.value);
        const form = this.mySelf.querySelectorAll(BC_CARD_INPUT);
        const values = Array.from(form).map((input) => input.value);
        if (this.outputFunction) {
            this.outputFunction(values, valid);
        }
    }
    /**
     * Recorre y valida adentro de la clase container que solo permita un maximo de 4 inputs
     * @memberof BcCardAuthenticationBehavior
     */
    inputLimit() {
        const container = this.mySelf.querySelector(`.${BC_CARD_AUTH_CONTAINER}`);
        const maxInputs = BC_CARD_AUTH_MAX_INPUTS;
        const inputs = container.querySelectorAll(BC_CARD_INPUT);
        if (inputs.length >= maxInputs) {
            const children = container.children;
            for (let value of children) {
                if (maxInputs <= children.length) {
                    const indexToRemove = BC_CARD_AUTH_MAX_INPUTS;
                    container.removeChild(children[indexToRemove]);
                }
            }
        }
    }
}

const CARD_PRIMARY = `${BcCommonConstants.PREFIX_LIB}-card-primary`;
const CARD_PRIMARY_LINK = `${BcCommonConstants.PREFIX_LIB}-card-primary-link`;
const CARD_PRIMARY_SIZE = `${BcCommonConstants.PREFIX_LIB}-card-primary-size`;
const CARD_PRIMARY_BALANCE = `${BcCommonConstants.PREFIX_LIB}-card-primary-balance`;
const CARD_PRIMARY_MENU_ITEM = `${BcCommonConstants.PREFIX_LIB}-card-primary-action-button`;
const CARD_PRIMARY_TAG_ITEM = `${BcCommonConstants.PREFIX_LIB}-card-primary-tag`;

class BcCardPrimaryBehavior extends BcDefaultBehavior {
    constructor() {
        super();
    }
    static setUpAll() {
        const imgElements = Array.from(document.querySelectorAll(`[class^='${CARD_PRIMARY}']`));
        const elements = [];
        for (const element of imgElements) {
            const bc = new BcCardPrimaryBehavior();
            bc.setElement(element);
            bc.setUp();
            elements.push(bc);
        }
        return elements;
    }
    _setUp() {
        super._setUp();
        this.setColorPositionCard();
    }
    /**
   * Funcion para la posición de la card, horizontal o vertical.
   * @memberof BcPopOverBehavior
   */
    setColorPositionCard() {
        this.cardElement = this.mySelf;
        if (this.cardElement.classList.contains(CARD_PRIMARY)) {
            const positionCard = this.mySelf.getAttribute("data-position")
                ? this.mySelf.getAttribute("data-position")
                : "horizontal";
            this.cardElement = this.mySelf;
            this.mySelf.classList.add(`bc-card-primary-${positionCard}`);
            if (this.mySelf.getAttribute("data-border") === "true") {
                this.mySelf.classList.add(`bc-card-primary-color-${positionCard}`);
            }
        }
    }
}

var CardPrimaryType;
(function (CardPrimaryType) {
    CardPrimaryType["cardProduct"] = "card-product";
    CardPrimaryType["cardProductVertical"] = "card-product-vertical";
    CardPrimaryType["creditCard"] = "credit-card";
    CardPrimaryType["lightCard"] = "light-card";
    CardPrimaryType["newProductHomeCard"] = "new-product-home-card";
})(CardPrimaryType || (CardPrimaryType = {}));

const BC_POP_OVER = `${BcCommonConstants.PREFIX_LIB}-pop-over`;
class BcPopOverConstans {
}
BcPopOverConstans.BC_POP_OVER = `${BC_POP_OVER}`;
BcPopOverConstans.BC_POP_OVER_CONTAINER = `${BC_POP_OVER}-container`;
BcPopOverConstans.BC_POP_OVER_ACTIVE = `${BC_POP_OVER}-active`;
BcPopOverConstans.BC_POP_OVER_TARGET = `${BC_POP_OVER}-target`;
BcPopOverConstans.BC_POP_OVER_ARROW = `${BC_POP_OVER}-arrow`;
BcPopOverConstans.BC_POP_OVER_GRAY = `${BC_POP_OVER}-gray`;
BcPopOverConstans.BC_POP_OVER_CONTENT_CLOSE = `${BC_POP_OVER}-content-close`;
BcPopOverConstans.BC_POP_OVER_ATRIBUTE_BUTTON_CLOSE = 'buttonClose';
BcPopOverConstans.BC_POP_OVER_BACKDROP = `${BC_POP_OVER}-backdrop`;
BcPopOverConstans.BC_POP_OVER_SCROLL = `${BC_POP_OVER}-scroll`;
BcPopOverConstans.BC_POP_OVER_SCROLL_BLOCK = `${BC_POP_OVER}-scroll-block`;
BcPopOverConstans.BC_POP_OVER_SCROLL_HIGHLIGHT = `${BC_POP_OVER}-highlight`;
BcPopOverConstans.BC_POP_OVER_PROPERTY_WIDTH = 'width';
BcPopOverConstans.BC_POP_OVER_PROPERTY_TYPE_WIDTH = 'typeWidth';
BcPopOverConstans.BC_POP_OVER_PROPERTY_HEIGHT = 'height';
BcPopOverConstans.BC_POP_OVER_PROPERTY_TYPE_HEIGHT = 'typeHeight';
BcPopOverConstans.BC_POP_OVER_PROPERTY_BACKDROP = 'backdrop';
BcPopOverConstans.BC_POP_OVER_PROPERTY_FULLSCREEN = 'fullScreen';
BcPopOverConstans.BC_POP_OVER_PROPERTY_HOVER = 'hover';
BcPopOverConstans.BC_POP_OVER_PROPERTY_CLOSE_OUTSIDE = 'closeOutside';
BcPopOverConstans.BC_POP_OVER_PROPERTY_HIDDEN_ARROW = 'hiddenArrow';
BcPopOverConstans.BC_POP_OVER_VALUE_TRUE = 'true';
BcPopOverConstans.BC_POP_OVER_ICON_ERROR = 'error';
BcPopOverConstans.BC_POP_OVER_CONTAINER_MIN_WIDTH = 140;

class LocationBuilderClientRectUtils {
    getFullBoundingClientRect(element) {
        const bounding = element.getBoundingClientRect();
        return {
            x: bounding.x + window.scrollX,
            y: bounding.y + window.scrollY,
            bottom: bounding.bottom + window.scrollY,
            right: bounding.right + window.scrollX,
            width: bounding.width,
            height: bounding.height,
        };
    }
}

const BC_LOCATION_BUILDER_ANIMATION_IN = `fade-in-opacity ease-in-out 350ms forwards`;
const BC_LOCATION_BUILDER__RIGHT = `right`;
const BC_LOCATION_BUILDER_LEFT = `left`;
const BC_LOCATION_BUILDER_TOP = `top`;
const BC_LOCATION_BUILDER_BOTTOM = `bottom`;
const BC_LOCATION_BUILDER_NUMBER_2 = 2;
const BC_LOCATION_BUILDER_ARROW_SPACE = 16;
const BC_LOCATION_BUILDER_NUMBER_6 = 6;
const BC_LOCATION_BUILDER_END_POSITION = 'end';
const BC_LOCATION_BUILDER_START_POSITION = 'start';
const BC_LOCATION_BUILDER_CENTER_POSITION = 'center';
const BC_LOCATION_BUILDER_WIDTH = 'width';
const BC_LOCATION_BUILDER_HEIGHT = 'height';
const BC_LOCATION_BUILDER_X = 'x';
const BC_LOCATION_BUILDER_Y = 'y';

class BcLocationBuilderPosition {
    /**
     *Evalua la posición que tendrá el arrow del Coachmark
     * @memberof BcTooltipBehavior
     */
    evaluateArrowPosition(position, arrow, targetOffset) {
        switch (position) {
            case BC_LOCATION_BUILDER_BOTTOM: {
                this.setPosititonArrow(BC_LOCATION_BUILDER_BOTTOM, arrow, targetOffset);
                break;
            }
            case BC_LOCATION_BUILDER__RIGHT: {
                this.setPosititonArrow(BC_LOCATION_BUILDER__RIGHT, arrow, targetOffset);
                break;
            }
            case BC_LOCATION_BUILDER_LEFT: {
                this.setPosititonArrow(BC_LOCATION_BUILDER_LEFT, arrow, targetOffset);
                break;
            }
            default: {
                this.setPosititonArrow(BC_LOCATION_BUILDER_TOP, arrow, targetOffset);
                break;
            }
        }
    }
    /**
     * Posiciona el arrow del elemento según la posición del coachmark
     * @memberof BcTooltipBehavior
     */
    setPosititonArrow(position, arrow, targetOffset) {
        arrow.classList.remove(arrow.classList.item(1));
        arrow.classList.add(arrow.classList.item(0) + '--' + position);
        switch (position) {
            case BC_LOCATION_BUILDER_BOTTOM: {
                arrow['style'].left = targetOffset.width / BC_LOCATION_BUILDER_NUMBER_2 - BC_LOCATION_BUILDER_NUMBER_6 + 'px';
                arrow['style'].top = targetOffset.height + 'px';
                break;
            }
            case BC_LOCATION_BUILDER__RIGHT: {
                arrow['style'].top = targetOffset.height / BC_LOCATION_BUILDER_NUMBER_2 - BC_LOCATION_BUILDER_NUMBER_6 + 'px';
                arrow['style'].left = targetOffset.width + 'px';
                break;
            }
            case BC_LOCATION_BUILDER_LEFT: {
                arrow['style'].top = targetOffset.height / BC_LOCATION_BUILDER_NUMBER_2 - BC_LOCATION_BUILDER_NUMBER_6 + 'px';
                arrow['style'].left = -BC_LOCATION_BUILDER_ARROW_SPACE + 'px';
                break;
            }
            default: {
                arrow['style'].left = targetOffset.width / BC_LOCATION_BUILDER_NUMBER_2 - BC_LOCATION_BUILDER_NUMBER_6 + 'px';
                arrow['style'].top = -BC_LOCATION_BUILDER_ARROW_SPACE + 'px';
                break;
            }
        }
    }
    /**
   * Configura el estilo left y top donde se situará el componente
   * @param coachPosition: Posición del coachmark en x y en y
   * @param element: Coachmark
   * @memberof BcCoachMarkBehavior
   */
    setElementPosition(coachPosition, coachMark, position) {
        let top;
        if (position === 'right' || position === 'left') {
            top = coachPosition.y + 6;
        }
        else {
            top = coachPosition.y;
        }
        coachMark['style'].left = coachPosition.x + 'px';
        coachMark['style'].top = top + 'px';
        coachMark['style'].animation = BC_LOCATION_BUILDER_ANIMATION_IN;
        coachMark.scrollIntoView?.();
    }
    /**
     * Obtiene la propiedades de posicionamiento del target
     * @param target
     * @param localization
     * @memberof BcCoachMarkBehavior
     */
    getTargetOffset(target, localization) {
        const targetOffset = localization.getFullBoundingClientRect(target);
        return targetOffset;
    }
    /**
     * Obtiene la propiedades de posicionamiento del coachmark
     * @param coach
     * @param localization
     * @memberof BcCoachMarkBehavior
     */
    getCoachOffset(coach, localization) {
        const coachOffset = localization.getFullBoundingClientRect(coach);
        return coachOffset;
    }
    /**
     * Obtiene el posicionamiento del coachmark
     * @param coachLocalizationBuilder
     * @param targetOffset
     * @param coachOffset
     * @param viewportOffset
     * @memberof BcCoachMarkBehavior
     */
    getCoachPosition(coachLocalizationBuilder, targetOffset, coachOffset, viewportOffset) {
        const position = coachLocalizationBuilder.getPosition(targetOffset, coachOffset, viewportOffset);
        return position;
    }
}

class BcLocationBuilder {
    /**
     * Permite obtener la posición del componente
     * @param targetOffset: Target con sus valores de posicionamiento y tamaño
     * @param coachOffset: Coach con sus valores de posicionamiento y tamaño
     * @param viewportOffset: Medidas del viewport
     * @returns Posición en x y en y del Coachmark
     * @memberof BcCoachMarkLocalizationBuilder
     */
    getPosition(targetOffset, coachOffset, viewportOffset) {
        let jsonObject = { x: 0, y: 0 };
        const permut = this.permute(this.center, this.start, this.end);
        for (const iterator of permut) {
            const yPosition = this.getXYPosition(targetOffset, coachOffset, viewportOffset, { axis: BC_LOCATION_BUILDER_Y, sizeProperty: BC_LOCATION_BUILDER_HEIGHT }, iterator);
            if (yPosition.kind === 'start') {
                const xPosition = this.getXYPosition(targetOffset, coachOffset, viewportOffset, { axis: BC_LOCATION_BUILDER_X, sizeProperty: BC_LOCATION_BUILDER_WIDTH }, iterator);
                const dependentYPosition = this.getXYPosition(targetOffset, coachOffset, viewportOffset, { axis: BC_LOCATION_BUILDER_Y, sizeProperty: BC_LOCATION_BUILDER_HEIGHT }, iterator, xPosition);
                if (xPosition.value != null && dependentYPosition.value != null) {
                    jsonObject = { x: xPosition.value, y: dependentYPosition.value };
                    this.validateXPosition(xPosition, dependentYPosition);
                }
            }
            else {
                const dependentXPosition = this.getXYPosition(targetOffset, coachOffset, viewportOffset, { axis: BC_LOCATION_BUILDER_X, sizeProperty: BC_LOCATION_BUILDER_WIDTH }, iterator, yPosition);
                if (dependentXPosition.value != null && yPosition.value != null) {
                    jsonObject = { x: dependentXPosition.value, y: yPosition.value };
                    this.validateYPosition(dependentXPosition, yPosition);
                    dependentXPosition.kind = BC_LOCATION_BUILDER_CENTER_POSITION;
                    if (dependentXPosition.kind === BC_LOCATION_BUILDER_CENTER_POSITION) {
                        return jsonObject;
                    }
                }
            }
        }
        return jsonObject;
    }
    /**
     * Permite validar la posición x del componente (top, bottom, right, left)
     * @param xPosition: Posición relativa en x
     * @param yPosition: Posición relativa en y
     * @memberof BcCoachMarkLocalizationBuilder
     */
    validateXPosition(xPosition, yPosition) {
        if (xPosition.kind == BC_LOCATION_BUILDER_END_POSITION) {
            this.position = `${BC_LOCATION_BUILDER__RIGHT}`;
        }
        else if (xPosition.kind == BC_LOCATION_BUILDER_START_POSITION) {
            this.position = `${BC_LOCATION_BUILDER_LEFT}`;
        }
        else if (xPosition.kind == BC_LOCATION_BUILDER_CENTER_POSITION && yPosition.kind == BC_LOCATION_BUILDER_END_POSITION) {
            this.position = `${BC_LOCATION_BUILDER_BOTTOM}`;
        }
        else if (xPosition.kind == BC_LOCATION_BUILDER_CENTER_POSITION && yPosition.kind == BC_LOCATION_BUILDER_START_POSITION) {
            this.position = `${BC_LOCATION_BUILDER_TOP}`;
        }
    }
    /**
     * Permite validar la posición y del componente (top, bottom, right, left)
     * @param xPosition: Posición relativa en x
     * @param yPosition: Posición relativa en y
     * @memberof BcCoachMarkLocalizationBuilder
     */
    validateYPosition(xPosition, yPosition) {
        if (yPosition.kind == BC_LOCATION_BUILDER_END_POSITION) {
            this.position = `${BC_LOCATION_BUILDER_BOTTOM}`;
        }
        else if (yPosition.kind == BC_LOCATION_BUILDER_START_POSITION) {
            this.position = `${BC_LOCATION_BUILDER_TOP}`;
        }
        else if (yPosition.kind == BC_LOCATION_BUILDER_CENTER_POSITION && xPosition.kind == BC_LOCATION_BUILDER_END_POSITION) {
            this.position = `${BC_LOCATION_BUILDER__RIGHT}`;
        }
        else if (yPosition.kind == BC_LOCATION_BUILDER_CENTER_POSITION && xPosition.kind == BC_LOCATION_BUILDER_START_POSITION) {
            this.position = `${BC_LOCATION_BUILDER_LEFT}`;
        }
    }
    /**
     * Permite permutar las diferentes combinaciones posibles de posicionamiento del componente (end, center, start)
     * @param center
     * @param start
     * @param end
     * @returns Retorna un arreglo con las diferentes permutaciones
     * @memberof BcCoachMarkLocalizationBuilder
     */
    permute(center, start, end) {
        const functions = [center, start, end];
        const response = [];
        for (const func1 of functions) {
            for (const func2 of functions) {
                for (const func3 of functions) {
                    if (func1 != func2 && func2 != func3 && func1 != func3) {
                        response.push([
                            func1, func2, func3
                        ]);
                    }
                }
            }
        }
        return response;
    }
    /**
     * Algoritmo que determina si el componente puede ponerse en el medio del eje x o y
     * @param targetOffset: Target con sus valores de posicionamiento y tamaño
     * @param coachOffset: Coach con sus valores de posicionamiento y tamaño
     * @param viewportOffset: Medidas del viewport
     * @param axisConfig: Propiedades del eje
     * @param mainAlignment: Alineación principal del elemento
     * @returns Retorna el value y kind donde es posible situar el elemento
     * @memberof BcCoachMarkLocalizationBuilder
     */
    center(targetOffset, coachOffset, viewportOffset, axisConfig, mainAlignment) {
        const centerTarget = targetOffset[axisConfig.axis] + targetOffset[axisConfig.sizeProperty] / BC_LOCATION_BUILDER_NUMBER_2;
        const halfSizePropertyCoach = coachOffset[axisConfig.sizeProperty] / BC_LOCATION_BUILDER_NUMBER_2;
        const positionFinalYCoach = centerTarget + halfSizePropertyCoach;
        const altoViewport = viewportOffset[axisConfig.sizeProperty];
        const initialPositionCoach = centerTarget - halfSizePropertyCoach;
        const isAvailableCenterStart = initialPositionCoach > 0;
        const isAvailableCenterEnd = centerTarget + halfSizePropertyCoach <= viewportOffset[axisConfig.sizeProperty];
        const isAvailableCenter = isAvailableCenterStart && isAvailableCenterEnd;
        const spaceToStart = targetOffset[axisConfig.axis];
        const overflowCoach = Math.abs(altoViewport - positionFinalYCoach);
        const spaceToEnd = Math.abs(altoViewport - positionFinalYCoach);
        const response = { kind: BC_LOCATION_BUILDER_CENTER_POSITION, value: null };
        if (!mainAlignment) {
            if (isAvailableCenter) {
                response.value = centerTarget - halfSizePropertyCoach;
            }
            else {
                if (!isAvailableCenterStart) {
                    this.validateScroll(initialPositionCoach, spaceToEnd, halfSizePropertyCoach, axisConfig, response);
                }
                else {
                    this.validateAvailableCenterStart(overflowCoach, spaceToStart, halfSizePropertyCoach, response, viewportOffset, axisConfig);
                }
            }
        }
        else {
            if (mainAlignment.kind != BC_LOCATION_BUILDER_CENTER_POSITION) {
                this.validateCenterNotMain(response, isAvailableCenterStart, coachOffset, axisConfig, initialPositionCoach, targetOffset, viewportOffset);
            }
        }
        return response;
    }
    /**
     * Algoritmo que determina si el componente puede ponerse al inicio del eje x o y
     * @param targetOffset: Target con sus valores de posicionamiento y tamaño
     * @param coachOffset: Coach con sus valores de posicionamiento y tamaño
     * @param viewportOffset: Medidas del viewport
     * @param axisConfig: Propiedades del eje
     * @param mainAlignment: Alineación principal del elemento
     * @returns Retorna el value y kind donde es posible situar el elemento
     * @memberof BcCoachMarkLocalizationBuilder
     */
    start(targetOffset, coachOffset, viewportOffset, axisConfig, mainAlignment) {
        const spaceToStart = targetOffset[axisConfig.axis];
        const arrowSpace = BC_LOCATION_BUILDER_ARROW_SPACE;
        const response = {
            kind: BC_LOCATION_BUILDER_START_POSITION,
            value: null,
        };
        let isAvailableStart = spaceToStart - arrowSpace >= coachOffset[axisConfig.sizeProperty];
        if (!mainAlignment) {
            if (isAvailableStart) {
                response.value = targetOffset[axisConfig.axis] - arrowSpace - coachOffset[axisConfig.sizeProperty];
            }
        }
        else {
            let space = 0;
            if (mainAlignment.kind == BC_LOCATION_BUILDER_CENTER_POSITION) {
                space = targetOffset[axisConfig.sizeProperty] + arrowSpace;
            }
            const finalPositionTarget = targetOffset[axisConfig.axis] + targetOffset[axisConfig.sizeProperty];
            isAvailableStart = finalPositionTarget - coachOffset[axisConfig.sizeProperty] - space >= 0;
            if (isAvailableStart) {
                response.value = finalPositionTarget - coachOffset[axisConfig.sizeProperty] - space;
            }
        }
        return response;
    }
    /**
     * Algoritmo que determina si el componente puede ponerse al final del eje x o y
     * @param targetOffset: Target con sus valores de posicionamiento y tamaño
     * @param coachOffset: Coach con sus valores de posicionamiento y tamaño
     * @param viewportOffset: Medidas del viewport
     * @param axisConfig: Propiedades del eje
     * @param mainAlignment: Alineación principal del elemento
     * @returns Retorna el value y kind donde es posible situar el elemento
     * @memberof BcCoachMarkLocalizationBuilder
     */
    end(targetOffset, coachOffset, viewportOffset, axisConfig, mainAlignment) {
        const arrowSpace = BC_LOCATION_BUILDER_ARROW_SPACE;
        const response = {
            kind: BC_LOCATION_BUILDER_END_POSITION,
            value: null,
        };
        const spaceToEnd = viewportOffset[axisConfig.sizeProperty] - targetOffset[axisConfig.axis] - targetOffset[axisConfig.sizeProperty];
        let isAvailableEnd = spaceToEnd - arrowSpace >= coachOffset[axisConfig.sizeProperty];
        if (!mainAlignment) {
            if (isAvailableEnd) {
                response.value = targetOffset[axisConfig.axis] + arrowSpace + targetOffset[axisConfig.sizeProperty];
            }
        }
        else {
            let space = 0;
            if (mainAlignment.kind == BC_LOCATION_BUILDER_CENTER_POSITION) {
                space = targetOffset[axisConfig.sizeProperty] + arrowSpace;
            }
            const finalPositionCoach = targetOffset[axisConfig.axis] + coachOffset[axisConfig.sizeProperty] + space;
            isAvailableEnd = finalPositionCoach <= viewportOffset[axisConfig.sizeProperty];
            if (isAvailableEnd) {
                response.value = targetOffset[axisConfig.axis] + space;
            }
        }
        return response;
    }
    /**
     * Obtiene la posición X y Y del componente
     * @param targetOffset: Target con sus valores de posicionamiento y tamaño
     * @param coachOffset: Coach con sus valores de posicionamiento y tamaño
     * @param viewportOffset: Medidas del viewport
     * @param axisConfig: Propiedades del eje
     * @param permutation: Permutaciones disponibles de posicionamiento del elemento
     * @param mainAlignment: Alineación principal del elemento
     * @param arrowOffset: Propiedades del Arrow del componente
     * @returns Retorna el value y kind donde es posible situar el elemento
     * @memberof BcCoachMarkLocalizationBuilder
     */
    getXYPosition(targetOffset, coachOffset, viewportOffset, axisConfig, permutation, mainAlignment, arrowOffset) {
        let response = {
            kind: BC_LOCATION_BUILDER_END_POSITION,
            value: null,
        };
        for (const func of permutation) {
            response = func.call(this, targetOffset, coachOffset, viewportOffset, axisConfig, mainAlignment, arrowOffset);
            if (response.value != null) {
                return response;
            }
        }
        return response;
    }
    /**
     * Valida cuando el componente no recibe como posición principal el centro
     * @param isAvailableCenter: Indica si el componente puede centrarse
     * @param response
     * @param centerTarget: Medida del centro del target
     * @param halfSizePropertyCoach: Mitad del tamaño del coachmark
     * @param isAvailableCenterStart: Indica si el componente puede centrarse en x o y inicial
     * @param overflowCoach: Indica cuando se desborda el componente
     * @param coachOffset: Coachmark con sus valores de posicionamiento y tamaño
     * @param axisConfig: Propiedades del eje
     * @param initialPositionCoach: Posición tentativa inicial del coachmark
     * @param spaceToStart: Espacio disponible para posicionar el componente
     * @param viewportOffset: Alineación principal del elemento
     * @memberof BcCoachMarkLocalizationBuilder
     */
    validateCenterNotMain(response, isAvailableCenterStart, coachOffset, axisConfig, initialPositionCoach, targetOffset, viewportOffset) {
        const centerTarget = targetOffset[axisConfig.axis] + targetOffset[axisConfig.sizeProperty] / BC_LOCATION_BUILDER_NUMBER_2;
        const halfSizePropertyCoach = coachOffset[axisConfig.sizeProperty] / BC_LOCATION_BUILDER_NUMBER_2;
        const isAvailableCenterEnd = centerTarget + halfSizePropertyCoach <= viewportOffset[axisConfig.sizeProperty];
        const isAvailableCenter = isAvailableCenterStart && isAvailableCenterEnd;
        const spaceToStart = targetOffset[axisConfig.axis];
        const positionFinalYCoach = centerTarget + halfSizePropertyCoach;
        const overflowCoach = Math.abs(viewportOffset[axisConfig.sizeProperty] - positionFinalYCoach);
        if (isAvailableCenter) {
            response.value = centerTarget - halfSizePropertyCoach;
        }
        else {
            if (!isAvailableCenterStart) {
                this.validateOverflowCoach(overflowCoach, coachOffset, axisConfig, initialPositionCoach, response);
            }
            else {
                if (overflowCoach <= coachOffset[axisConfig.sizeProperty] && overflowCoach <= spaceToStart) {
                    response.value = viewportOffset[axisConfig.sizeProperty] - coachOffset[axisConfig.sizeProperty];
                }
            }
        }
    }
    /**
     * Valida donde debe ubicarse el componente si está disponible en el centro (x,y) y arriba(x,y)
     * @param overflowCoach
     * @param spaceToStart
     * @param halfSizePropertyCoach
     * @param response
     * @param viewportOffset
     * @param axisConfig
     * @memberof BcCoachMarkLocalizationBuilder
     */
    validateAvailableCenterStart(overflowCoach, spaceToStart, halfSizePropertyCoach, response, viewportOffset, axisConfig) {
        if (overflowCoach <= spaceToStart && halfSizePropertyCoach >= overflowCoach &&
            spaceToStart < halfSizePropertyCoach) {
            response.value = viewportOffset[axisConfig.sizeProperty];
        }
    }
    /**
     * Valida donde debe ubicarse el componente si se desborda
     * @param overflowCoach
     * @param coachOffset
     * @param axisConfig
     * @param initialPositionCoach
     * @param response
     * @memberof BcCoachMarkLocalizationBuilder
     */
    validateOverflowCoach(overflowCoach, coachOffset, axisConfig, initialPositionCoach, response) {
        if (overflowCoach <= coachOffset[axisConfig.sizeProperty] && overflowCoach >= Math.abs(initialPositionCoach)) {
            response.value = 0;
        }
    }
    /**
     * Valida donde debe ubicarse el componente si la pantalla posee Scroll
     * @param initialPositionCoach
     * @param spaceToEnd
     * @param axisConfig
     * @param halfSizePropertyCoach
     * @param response
     * @memberof BcCoachMarkLocalizationBuilder
     */
    validateScroll(initialPositionCoach, spaceToEnd, halfSizePropertyCoach, axisConfig, response) {
        if (Math.abs(initialPositionCoach) <= spaceToEnd && halfSizePropertyCoach >=
            Math.abs(initialPositionCoach) && spaceToEnd < halfSizePropertyCoach) {
            if (axisConfig.axis == BC_LOCATION_BUILDER_X) {
                response.value = window.scrollX;
            }
            else {
                response.value = window.scrollY;
            }
        }
    }
}

class BcPopOverBehavior extends BcDefaultBehavior {
    constructor() {
        super();
    }
    static setUpAll() {
        const popOverElements = Array.from(document.querySelectorAll(`${BcCommonConstants.SECTION_TAG}[class~='${BcPopOverConstans.BC_POP_OVER}']`));
        const elements = [];
        for (const popOverElement of popOverElements) {
            const element = popOverElement;
            const bcPopOverBehavior = new BcPopOverBehavior();
            bcPopOverBehavior.setElement(element);
            bcPopOverBehavior.setUp();
            elements.push(bcPopOverBehavior);
        }
        return elements;
    }
    _setUp() {
        this.bcContainer = this.mySelf.querySelector(`.${BcPopOverConstans.BC_POP_OVER_CONTAINER}`);
        this.localization = new LocationBuilderClientRectUtils();
        this.localizationBuilder = new BcLocationBuilder();
        this.elementPosition = new BcLocationBuilderPosition();
        this.idAttribute = this.mySelf.getAttribute(BcCommonConstants.ID);
        this.target = document.querySelector(`[${BcCommonConstants.ARIA_CONTROL}=${this.idAttribute}]`);
        this.widthAttribute = this.mySelf.getAttribute(BcPopOverConstans.BC_POP_OVER_PROPERTY_WIDTH);
        this.typeWidth = this.mySelf.getAttribute(BcPopOverConstans.BC_POP_OVER_PROPERTY_TYPE_WIDTH) ?? 'px';
        this.heightAttribute = this.mySelf.getAttribute(BcPopOverConstans.BC_POP_OVER_PROPERTY_HEIGHT);
        this.typeHeight = this.mySelf.getAttribute(BcPopOverConstans.BC_POP_OVER_PROPERTY_TYPE_HEIGHT) ?? 'px';
        this.backdropAttribute = this.mySelf.getAttribute(BcPopOverConstans.BC_POP_OVER_PROPERTY_BACKDROP);
        this.fullScreenAttribute = this.mySelf.getAttribute(BcPopOverConstans.BC_POP_OVER_PROPERTY_FULLSCREEN);
        this.hiddenArrowAttribute = this.mySelf.getAttribute(BcPopOverConstans.BC_POP_OVER_PROPERTY_HIDDEN_ARROW);
        this.setButtonClose();
        this.setScrollAttribute();
        this.setHover();
        this.setCloseOutside();
        this.arrowElement = createElement({ element: BcCommonConstants.DIV_TAG, classList: [BcPopOverConstans.BC_POP_OVER_ARROW] });
        this.listenerResize();
        this.listenerScroll();
        this.listenerCloseEventKey();
        this.setSizeMediaQuery(false);
    }
    /**
    * Setea el comportamiento del buttonClose.
    * @memberof BcPopOverBehavior
    */
    setButtonClose() {
        const buttonClose = this.mySelf.getAttribute(BcPopOverConstans.BC_POP_OVER_ATRIBUTE_BUTTON_CLOSE);
        if (buttonClose === BcPopOverConstans.BC_POP_OVER_VALUE_TRUE) {
            this.createButonClose();
        }
    }
    /**
    * Setea el comportamiento del scroll.
    * @memberof BcPopOverBehavior
    */
    setScrollAttribute() {
        this.scrollAttribute = this.mySelf.getAttribute(BcCommonConstants.SCROLL) ?? BcPopOverConstans.BC_POP_OVER_VALUE_TRUE;
        if (this.scrollAttribute === BcPopOverConstans.BC_POP_OVER_VALUE_TRUE) {
            this.setScroll();
        }
    }
    /**
    * Setea el comportamiento del close outside.
    * @memberof BcPopOverBehavior
    */
    setCloseOutside() {
        this.closeOutsideAttribute = this.mySelf.getAttribute(BcPopOverConstans.BC_POP_OVER_PROPERTY_CLOSE_OUTSIDE);
        if (this.closeOutsideAttribute === BcPopOverConstans.BC_POP_OVER_VALUE_TRUE) {
            this.listenerClickOut();
        }
    }
    /**
    * Setea el comportamiento del hover.
    * @memberof BcPopOverBehavior
    */
    setHover() {
        this.hoverAttribute = this.mySelf.getAttribute(BcPopOverConstans.BC_POP_OVER_PROPERTY_HOVER);
        if (this.hoverAttribute === BcPopOverConstans.BC_POP_OVER_VALUE_TRUE) {
            this.listenerMouseEnter();
            this.listenerMouseLeave();
        }
    }
    /**
    * Realiza el pocisionamiento del componente basado en el bc-location-builder.
    * @memberof BcPopOverBehavior
    */
    setPosition() {
        if (this.mySelf.classList.contains(BcPopOverConstans.BC_POP_OVER_ACTIVE)) {
            this.target.appendChild(this.arrowElement);
        }
        const targetOffset = this.elementPosition.getTargetOffset(this.target, this.localization);
        const popOverElement = this.mySelf;
        const viewportOffset = this.getSizeWindows();
        const offset = this.elementPosition.getCoachOffset(this.mySelf, this.localization);
        const position = this.elementPosition.getCoachPosition(this.localizationBuilder, targetOffset, offset, viewportOffset);
        this.elementPosition.evaluateArrowPosition(this.localizationBuilder.position, this.arrowElement, targetOffset);
        this.elementPosition.setElementPosition(position, popOverElement, this.localizationBuilder.position);
        if (this.bcContainer.classList.contains(BcPopOverConstans.BC_POP_OVER_GRAY)) {
            this.arrowElement.classList.add(BcPopOverConstans.BC_POP_OVER_GRAY);
        }
        else {
            this.arrowElement;
        }
    }
    /**
* Crea el boton opcional para cerrar el pop-over.
* @memberof BcPopOverBehavior
*/
    createButonClose() {
        const contentButtonClose = createElement({
            element: BcCommonConstants.DIV_TAG,
            classList: [BcPopOverConstans.BC_POP_OVER_CONTENT_CLOSE]
        });
        const emIconClose = createElement({
            element: BcCommonConstants.EM_TAG,
            classList: [BcCommonConstants.ICONS_CLASS, BcCommonConstants.ICON_SM_CLASS],
            innerText: BcPopOverConstans.BC_POP_OVER_ICON_ERROR
        });
        contentButtonClose.appendChild(emIconClose);
        const popOverContainer = this.mySelf.querySelector(`.${BcPopOverConstans.BC_POP_OVER_CONTAINER}`);
        popOverContainer.prepend(contentButtonClose);
        emIconClose.addEventListener(BcCommonConstants.EVENT_CLICK, () => {
            this.closePopOver();
        });
    }
    /**
* Agrega clase para aplicar estilos de scroll.
* @memberof BcPopOverBehavior
*/
    setScroll() {
        this.bcContainer.classList.add(BcPopOverConstans.BC_POP_OVER_SCROLL);
    }
    /**
    * Setea el ancho del pop-over.
    * @param {string} typeWidth recibe el tipo de medida del pop-over, por default es px.
    * @memberof BcPopOverBehavior
    */
    setWidth(typeWidth) {
        if (Number(this.widthAttribute) > BcPopOverConstans.BC_POP_OVER_CONTAINER_MIN_WIDTH) {
            this.bcContainer.style.setProperty(BcPopOverConstans.BC_POP_OVER_PROPERTY_WIDTH, `${this.widthAttribute}${typeWidth}`);
        }
    }
    /**
    * Setea el alto del pop-over.
    * @param {string} typeHeight recibe el tipo de medida del pop-over, por default es px.
    * @memberof BcPopOverBehavior
    */
    setHeight(typeHeight) {
        this.bcContainer.style.setProperty(BcPopOverConstans.BC_POP_OVER_PROPERTY_HEIGHT, `${this.heightAttribute}${typeHeight}`);
    }
    /**
    * funcion para crear el backdrop.
    * @memberof BcPopOverBehavior
    */
    createBackdrop() {
        if (this.backdropAttribute === BcPopOverConstans.BC_POP_OVER_VALUE_TRUE) {
            const backdrop = createElement({
                element: BcCommonConstants.DIV_TAG,
                classList: [BcPopOverConstans.BC_POP_OVER_BACKDROP],
            });
            const body = document.body;
            document.body.prepend(backdrop);
            body.classList.add(BcPopOverConstans.BC_POP_OVER_SCROLL_BLOCK);
        }
    }
    /**
    * Funcion para remover el backdrop.
    * @memberof BcPopOverBehavior
    */
    removeBackdrop() {
        const backdrop = document.querySelector(`.${BcPopOverConstans.BC_POP_OVER_BACKDROP}`);
        if (backdrop) {
            backdrop.remove();
            const body = document.body;
            body.classList.remove(BcPopOverConstans.BC_POP_OVER_SCROLL_BLOCK);
        }
    }
    /**
    * Funcion que reposiciona el pop-over al hacer resize a la pantalla.
    * @memberof BcPopOverBehavior
    */
    listenerResize() {
        window.addEventListener(BcCommonConstants.EVENT_RESIZE, () => {
            this.setSizeMediaQuery(true);
            this.setPosition();
        });
    }
    /**
    * Funcion que escucha evento scroll sobre un contenedor especifico.
    * @memberof BcPopOverBehavior
    */
    listenerScroll() {
        const containersScroll = document.querySelectorAll(`.${BcPopOverConstans.BC_POP_OVER_SCROLL}`);
        if (containersScroll) {
            containersScroll.forEach((container) => {
                container.addEventListener(BcCommonConstants.EVENT_SCROLL, () => {
                    this.setSizeMediaQuery(true);
                    this.setPosition();
                });
            });
        }
    }
    /**
    * Funcion que escucha evento mouseenter para funcionalidad de Hover.
    * @memberof BcPopOverBehavior
    */
    listenerMouseEnter() {
        this.target.addEventListener(BcCommonConstants.EVENT_MOUSEENTER, () => {
            this.openPopOver();
        }, true);
    }
    /**
    * Funcion que escucha evento mouseleave para funcionalidad de Hover.
    * @memberof BcPopOverBehavior
    */
    listenerMouseLeave() {
        this.target.addEventListener(BcCommonConstants.EVENT_MOUSELEAVE, () => {
            this.closePopOver();
        });
    }
    /**
    * Funcion que cierra el pop-over al presionar la tecla escape.
    * @memberof BcPopOverBehavior
    */
    listenerCloseEventKey() {
        window.addEventListener(BcCommonConstants.EVENT_KEY_DOWN, (event) => {
            if (event.key === BcCommonConstants.KEY_EVENT_ESCAPE) {
                this.closePopOver();
            }
        });
    }
    /**
    * Funcion que cierra el pop-over al dar click afuera del mismo.
    * @memberof BcPopOverBehavior
    */
    listenerClickOut() {
        document.addEventListener(BcCommonConstants.EVENT_CLICK, (event) => {
            const targetClick = event.target.classList.contains(BcPopOverConstans.BC_POP_OVER_TARGET);
            const element = event.target.offsetParent;
            if (this.mySelf.classList.contains(BcPopOverConstans.BC_POP_OVER_ACTIVE)) {
                if (element) {
                    const classElement = element.classList.contains(BcPopOverConstans.BC_POP_OVER);
                    if (!targetClick) {
                        if (!classElement) {
                            this.closePopOver();
                        }
                    }
                }
            }
        });
    }
    /**
    * Funcion que oculta la flecha del pop-over.
    * @memberof BcPopOverBehavior
    */
    hiddenArrow() {
        if (this.hiddenArrowAttribute === BcPopOverConstans.BC_POP_OVER_VALUE_TRUE) {
            const arrow = this.target.querySelector(`.${BcPopOverConstans.BC_POP_OVER_ARROW}`);
            arrow.style.setProperty(BcCommonConstants.DISPLAY, BcCommonConstants.NONE);
        }
    }
    /**
    * Funcion que ajusta el tamaño completo para responsive.
    * @param {boolean} resize bandera para diferenciar el evento resize.
    * @memberof BcPopOverBehavior
    */
    setSizeMediaQuery(resize) {
        if (resize) {
            if (this.fullScreenAttribute === BcPopOverConstans.BC_POP_OVER_VALUE_TRUE) {
                const widthWindow = this.getSizeWindows();
                if (widthWindow.width <= BcCommonConstants.BREAKPOINT_XS) {
                    this.bcContainer.style.setProperty(BcPopOverConstans.BC_POP_OVER_PROPERTY_WIDTH, `${COMMON_CONSTANTS_NUMBERS.N100}vw`);
                    this.bcContainer.style.setProperty(BcPopOverConstans.BC_POP_OVER_PROPERTY_HEIGHT, `${COMMON_CONSTANTS_NUMBERS.N100}vh`);
                }
                else {
                    this.setWidth(this.typeWidth);
                    this.setHeight(this.typeHeight);
                }
            }
        }
        else {
            this.setWidth(this.typeWidth);
            this.setHeight(this.typeHeight);
        }
    }
    getSizeWindows() {
        return {
            height: window.innerHeight,
            width: window.innerWidth,
        };
    }
    /**
    * Funcion para abrir el pop-over.
    * @memberof BcPopOverBehavior
    */
    openPopOver() {
        this.target.classList.add(BcPopOverConstans.BC_POP_OVER_SCROLL_HIGHLIGHT);
        this.createBackdrop();
        this.mySelf.classList.add(BcPopOverConstans.BC_POP_OVER_ACTIVE);
        this.setPosition();
        this.hiddenArrow();
    }
    /**
    * Funcion para hacer toogle al abrir y cerrar el pop-over.
    * @memberof BcPopOverBehavior
    */
    tooglePopOver() {
        if (this.mySelf.classList.contains(BcPopOverConstans.BC_POP_OVER_ACTIVE)) {
            this.closePopOver();
        }
        else {
            this.openPopOver();
        }
    }
    /**
    * Funcion para cerrar el pop-over.
    * @memberof BcPopOverBehavior
    */
    closePopOver() {
        this.mySelf.classList.remove(BcPopOverConstans.BC_POP_OVER_ACTIVE);
        this.removeBackdrop();
        this.target.classList.remove(BcPopOverConstans.BC_POP_OVER_SCROLL_HIGHLIGHT);
        this.target.querySelector(`.${BcPopOverConstans.BC_POP_OVER_ARROW}`).remove();
    }
}

const BADGE = `${BcCommonConstants.PREFIX_LIB}-badge`;
const BADGE_BODY = BADGE + '-body';
const BADGE_BUTTON_LEFT = BADGE + '-bl';
const BADGE_BUTTON_RIGHT = BADGE + '-br';
const BADGE_TOP_LEFT = BADGE + '-tl';
const BADGE_TOP_RIGHT = BADGE + '-tr';
const BADGE_RED = BADGE + '-red';
const BADGE_PINK = BADGE + '-pink';
const BADGE_YELLOW = BADGE + '-yellow';
const BADGE_BLUE = BADGE + '-blue';
const BADGE_GREEN = BADGE + '-green';
const BADGE_PURPLE = BADGE + '-purple';
const BADGE_SMALL = BADGE + '-small';
const BADGE_MEDIUM = BADGE + '-medium';
const BADGE_ANIMATION = BADGE + '-animation';
const BADGE_BORDER = BADGE + '-border';

class BcBadgeBehavior extends BcDefaultBehavior {
    constructor() {
        super();
    }
    /**
     * Coloca las clases de posición en el badge.
     * @memberof BcBadgeBehavior
     */
    setPosition(position) {
        this.removePosition();
        if (position === 'button-left') {
            this.mySelf.classList.add(BADGE_BUTTON_LEFT);
        }
        if (position === 'button-right') {
            this.mySelf.classList.add(BADGE_BUTTON_RIGHT);
        }
        if (position === 'top-right') {
            this.mySelf.classList.add(BADGE_TOP_RIGHT);
        }
        if (position === 'top-left') {
            this.mySelf.classList.add(BADGE_TOP_LEFT);
        }
    }
    /**
     * Remueve  las clases de posición en el badge.
     * @memberof BcBadgeBehavior
     */
    removePosition() {
        if (this.mySelf.classList.contains(BADGE_BUTTON_LEFT)) {
            this.mySelf.classList.remove(BADGE_BUTTON_LEFT);
        }
        if (this.mySelf.classList.contains(BADGE_BUTTON_RIGHT)) {
            this.mySelf.classList.remove(BADGE_BUTTON_RIGHT);
        }
        if (this.mySelf.classList.contains(BADGE_TOP_RIGHT)) {
            this.mySelf.classList.remove(BADGE_TOP_RIGHT);
        }
        if (this.mySelf.classList.contains(BADGE_TOP_LEFT)) {
            this.mySelf.classList.remove(BADGE_TOP_LEFT);
        }
    }
    /**
      * Coloca  las clases de color en el badge.
      * @memberof BcBadgeBehavior
      */
    setColor(color) {
        this.removeColor();
        if (color === 'red') {
            this.mySelf.classList.add(BADGE_RED);
        }
        if (color === 'green') {
            this.mySelf.classList.add(BADGE_GREEN);
        }
        if (color === 'yellow') {
            this.mySelf.classList.add(BADGE_YELLOW);
        }
        if (color === 'pink') {
            this.mySelf.classList.add(BADGE_PINK);
        }
        if (color === 'purple') {
            this.mySelf.classList.add(BADGE_PURPLE);
        }
        if (color === 'blue') {
            this.mySelf.classList.add(BADGE_BLUE);
        }
    }
    /**
    * Remueve  las clases de color en el badge.
    * @memberof BcBadgeBehavior
    */
    removeColor() {
        if (this.mySelf.classList.contains(BADGE_RED)) {
            this.mySelf.classList.remove(BADGE_RED);
        }
        if (this.mySelf.classList.contains(BADGE_GREEN)) {
            this.mySelf.classList.remove(BADGE_GREEN);
        }
        if (this.mySelf.classList.contains(BADGE_YELLOW)) {
            this.mySelf.classList.remove(BADGE_YELLOW);
        }
        if (this.mySelf.classList.contains(BADGE_PINK)) {
            this.mySelf.classList.remove(BADGE_PINK);
        }
        if (this.mySelf.classList.contains(BADGE_PURPLE)) {
            this.mySelf.classList.remove(BADGE_PURPLE);
        }
        if (this.mySelf.classList.contains(BADGE_BLUE)) {
            this.mySelf.classList.remove(BADGE_BLUE);
        }
    }
    /**
     * Coloca  las clases de tamaño en el badge.
     * @memberof BcBadgeBehavior
     */
    setSize(size) {
        this.removeSize();
        if (size === 'small') {
            this.mySelf.classList.add(BADGE_SMALL);
        }
        if (size === 'medium') {
            this.mySelf.classList.add(BADGE_MEDIUM);
        }
    }
    /**
     * Remueve las clases de tamaño en el badge.
     * @memberof BcBadgeBehavior
     */
    removeSize() {
        if (this.mySelf.classList.contains(BADGE_SMALL)) {
            this.mySelf.classList.remove(BADGE_SMALL);
        }
        if (this.mySelf.classList.contains(BADGE_MEDIUM)) {
            this.mySelf.classList.remove(BADGE_MEDIUM);
        }
    }
    /**
     * Asigna las clases de borde en el badge.
     * @memberof BcBadgeBehavior
     */
    setBorder(border) {
        if (border) {
            this.mySelf.classList.add(BADGE_BORDER);
        }
        else if (!border) {
            this.mySelf.classList.remove(BADGE_BORDER);
        }
    }
    /**
      * Dispara la animación cada vez que llega una nueva notificación.
      * @memberof BcBadgeBehavior
      */
    setAnimation() {
        if (this.mySelf) {
            setTimeout(() => {
                this.mySelf.classList.add(BADGE_ANIMATION);
            });
            if (this.mySelf.classList.contains(BADGE_ANIMATION)) {
                this.mySelf.classList.remove(BADGE_ANIMATION);
            }
        }
    }
    /**
      * Actualiza las notificaciones.
      * @memberof BcBadgeBehavior
      */
    setNotification(sizeBadge, notification) {
        if (sizeBadge == 'medium' && Number.isInteger(notification)) {
            const number = 99;
            if (parseInt(notification) < number) {
                return notification;
            }
            else {
                return '99+';
            }
        }
        else {
            return '';
        }
    }
}

const INPUT_NUMBER = `${BcCommonConstants.PREFIX_LIB}-input-number`;

class BcInputNumberBehavior extends BcDefaultBehavior {
    constructor() {
        super();
        this.value = 0;
    }
    /**
      * Busca el componente mediante querySelectorAll y lo inicializa.
      * @returns array de elementos de tipo BcInputDateBehavior encontrados.
      * @memberof BcInputNumberBehavior
      */
    static setUpAll() {
        const inputElements = Array.from(document.querySelectorAll(`div[class='${INPUT_NUMBER}']`));
        const elements = [];
        for (const inputNumber of inputElements) {
            const bcInputNumberBehavior = new BcInputNumberBehavior();
            bcInputNumberBehavior.setElement(inputNumber);
            bcInputNumberBehavior.setUp();
            elements.push(bcInputNumberBehavior);
        }
        return elements;
    }
    _setUp() {
        this.getElement();
        this.addEventListeners();
        this.inputBehavior = new BcInputBehavior();
        this.inputBehavior.setElement(this.numberInput);
        this.inputBehavior.setUp();
        this.value = parseInt(this.numberInput.value);
    }
    /**
      * Asigna value al atributo value del numberInput casteado como string
      * @param {number} value
      * @memberof BcInputNumberBehavior
      */
    setValue(value) {
        if (this.numberInput) {
            this.numberInput.value = String(value);
            this.inputBehavior.updateState(null);
        }
    }
    /**
     * Agrega o elimina la clase 'bc-input-error' del numberInput, según el valor del parámetro isValid sea true o false.
     * @param {boolean} isValid
     * @memberof BcInputNumberBehavior
     */
    setErrorState(isValid) {
        if (isValid) {
            this.numberInput.classList.remove('bc-input-error');
        }
        else {
            this.numberInput.classList.add('bc-input-error');
        }
    }
    /**
  * Agrega o elimina la clase 'bc-input-success' del numberInput, según el valor del parámetro isSuccess sea true o false.
  * @param {boolean} isSuccess
  * @memberof BcInputNumberBehavior
  */
    setSuccessState(isSuccess) {
        if (isSuccess) {
            this.numberInput.classList.add('bc-input-success');
        }
        else {
            this.numberInput.classList.remove('bc-input-success');
        }
    }
    /**
       * Habilita o deshabilita el numberInput y los botones de incremento y decremento, según el valor del parámetro isDisabled sea true o false.
       * @param {boolean} isDisabled
       * @memberof BcInputNumberBehavior
       */
    setDisabled(isDisabled) {
        this.numberInput.disabled = isDisabled;
        this.buttonDecrease.disabled = isDisabled;
        this.buttonIncrease.disabled = isDisabled;
    }
    /**
     * Selecciona los elementos html mediante querySelector
     * @memberof BcInputNumberBehavior
     */
    getElement() {
        this.buttonDecrease = this.mySelf.querySelector(`${BcCommonConstants.BUTTON_TAG}:first-of-type`);
        this.buttonIncrease = this.mySelf.querySelector(`${BcCommonConstants.BUTTON_TAG}:last-of-type`);
        this.numberInput = this.mySelf.querySelector('input[type=number]');
    }
    /**
     * Setea output con el atributo value de numberInput. Garantiza que value sea entero.
     * @memberof BcInputNumberBehavior
     */
    emitEvent() {
        this.value = parseInt(this.numberInput.value);
        if (this.output) {
            this.output(this.value);
        }
    }
    /**
     * Registra el evento click a los botones de incremeto y decremento. Adicionalmente resetea el estado de inputBehavior.
     * @memberof BcInputNumberBehavior
     */
    addEventListeners() {
        this.buttonDecrease.addEventListener(BcCommonConstants.EVENT_CLICK, () => {
            this.numberInput.stepDown();
            this.inputBehavior.updateState(null);
            this.emitEvent();
        });
        this.buttonIncrease.addEventListener(BcCommonConstants.EVENT_CLICK, () => {
            this.numberInput.stepUp();
            this.inputBehavior.updateState(null);
            this.emitEvent();
        });
        addFocusable(this.buttonDecrease, { role: 'button', pressed: 'false' });
        addFocusable(this.buttonIncrease, { role: 'button', pressed: 'false' });
        this.numberInput.addEventListener(BcCommonConstants.EVENT_INPUT, () => {
            this.emitEvent();
        });
    }
}

const INPUT_CURRENCY = `${BcCommonConstants.PREFIX_LIB}-input-currency`;

class BcInputCurrencyBehavior extends BcDefaultBehavior {
    constructor() {
        super();
        this.value = 0;
    }
    /**
      * Busca el componente mediante querySelectorAll y lo inicializa.
      * @returns array de elementos de tipo BcInputCurrencyBehavior encontrados.
      * @memberof BcInputCurrencyBehavior
      */
    static setUpAll() {
        const inputElements = Array.from(document.querySelectorAll(`div[class='${INPUT_CURRENCY}']`));
        const elements = [];
        for (let i = 0; i < inputElements.length; i++) {
            const element = inputElements[i];
            const bcInputCurrencyBehavior = new BcInputCurrencyBehavior();
            bcInputCurrencyBehavior.setElement(element);
            bcInputCurrencyBehavior.setUp();
            elements.push(bcInputCurrencyBehavior);
        }
        return elements;
    }
    _setUp() {
        this.getElement();
        this.addEventListeners();
        this.inputBehavior = new BcInputBehavior();
        this.inputBehavior.setElement(this.currencyInput);
        this.inputBehavior.setUp();
        this.value = parseInt(this.currencyInput.value);
    }
    /**
      * Asigna value al atributo value del currencyInput casteado como string
      * @param {number} value
      * @memberof BcInputCurrencyBehavior
      */
    setValue(value) {
        if (this.currencyInput) {
            this.currencyInput.value = String(value);
            this.inputBehavior.updateState(null);
        }
    }
    /**
     * Agrega o elimina la clase 'bc-input-error' del currencyInput, según el valor del parámetro isValid sea true o false.
     * @param {boolean} isValid
     * @memberof BcInputCurrencyBehavior
     */
    setErrorState(isValid) {
        if (isValid) {
            this.currencyInput.classList.remove('bc-input-error');
        }
        else {
            this.currencyInput.classList.add('bc-input-error');
        }
    }
    /**
    * Agrega o elimina la clase 'bc-input-success' del currencyInput, según el valor del parámetro isSuccess sea true o false.
    * @param {boolean} isSuccess
    * @memberof BcInputCurrencyBehavior
    */
    setSuccessState(isSuccess) {
        if (isSuccess) {
            this.currencyInput.classList.add('bc-input-success');
        }
        else {
            this.currencyInput.classList.remove('bc-input-success');
        }
    }
    /**
     * Habilita o deshabilita el currencyInput, según el valor del parámetro isDisabled sea true o false.
     * @param {boolean} isDisabled
     * @memberof BcInputCurrencyBehavior
     */
    setDisabled(isDisabled) {
        this.currencyInput.disabled = isDisabled;
    }
    /**
     * Selecciona los elementos html mediante querySelector
     * @memberof BcInputCurrencyBehavior
     */
    getElement() {
        this.currencyInput = this.mySelf.querySelector('input[type=number]');
    }
    /**
     * Setea output con el atributo value de currencyInput. Garantiza que value sea entero.
     * @memberof BcInputCurrencyBehavior
     */
    emitEvent() {
        this.value = parseInt(this.currencyInput.value);
        if (this.output) {
            this.output(this.value);
        }
    }
    /**
     * Resetea el estado de inputBehavior.
     * @memberof BcInputCurrencyBehavior
     */
    addEventListeners() {
        this.currencyInput.addEventListener(BcCommonConstants.EVENT_INPUT, () => {
            this.emitEvent();
        });
    }
}

const INPUT_SELECT_TOGGLE_CLASS = `${BcCommonConstants.PREFIX_LIB}-input-select-toggle`;
const INPUT_SELECT_ACTIVE_TOGGLE_CLASS = `${BcCommonConstants.PREFIX_LIB}-input-select-active-toggle`;
const INPUT_SELECT_CONTENT_CLASS = `${BcCommonConstants.PREFIX_LIB}-input-select-content`;
const INPUT_SELECT_ACTIVE_CONTENT_CLASS = `${BcCommonConstants.PREFIX_LIB}-input-select-content-active`;
const INPUT_SELECT_ITEM_CLASS = `${BcCommonConstants.PREFIX_LIB}-input-select-item`;
const INPUT_SPAN_SINGLE = `${BcCommonConstants.PREFIX_LIB}-span-single`;
const INPUT_SELECT_TRIANGLE_CLASS = `${BcCommonConstants.PREFIX_LIB}-input-select-triangle`;
const INPUT_SELECT_CLASS = `${BcCommonConstants.PREFIX_LIB}-input-select`;
const INPUT_SELECT_ACTIVE_CLASS = `${BcCommonConstants.PREFIX_LIB}-input-select-active`;
const INPUT_SELECT_PADDING_RIGHT_WHEN_ICON = `${BcCommonConstants.PREFIX_LIB}-pe-4`;
const LABEL_ELIPSIS = `${BcCommonConstants.PREFIX_LIB}-input-select-label`;
const CREATE_EM_TAG = `${BcCommonConstants.EM_TAG}`;

const INPUT = `${BcCommonConstants.PREFIX_LIB}-input`;
const FORM_FIELD = `${BcCommonConstants.PREFIX_LIB}-form-field`;
const ICON = `${BcCommonConstants.PREFIX_LIB}-icon`;
const INPUT_AREA = `${BcCommonConstants.PREFIX_LIB}-input-area`;
const SPAN_INFO = `${BcCommonConstants.PREFIX_LIB}-span-info`;
const LEFT = `${BcCommonConstants.PREFIX_LIB}-left`;
const INVALID_FEEDBACK = `${BcCommonConstants.PREFIX_LIB}-invalid-feedback`;
const INPUT_ERROR = `${BcCommonConstants.PREFIX_LIB}-input-error`;
const INPUT_SUCCESS = `${BcCommonConstants.PREFIX_LIB}-input-success`;
const ICON_LEFT_ERROR = `${BcCommonConstants.PREFIX_LIB}-icon-left-error`;
const ICON_RIGHT_ERROR = `${BcCommonConstants.PREFIX_LIB}-icon-right-error`;
const INPUT_VALID = `${BcCommonConstants.PREFIX_LIB}-input-valid`;
const ICON_VALID = `${BcCommonConstants.PREFIX_LIB}-icon-valid`;
const VALID_FEEBACK = `${BcCommonConstants.PREFIX_LIB}-valid-feedback`;
const ICON_LEFT = `${BcCommonConstants.PREFIX_LIB}-icon-left`;
const _ICON_LEFT = 'icon-left';
const ICON_RIGHT = `${BcCommonConstants.PREFIX_LIB}-icon-right`;
const _ICON_RIGHT = 'icon-right';
const ICONS_LEFT = `${BcCommonConstants.PREFIX_LIB}-icons-left`;
const ICONS_RIGHT = `${BcCommonConstants.PREFIX_LIB}-icons-right`;

const _DROPDOWN_TOGGLE_CLASS = `${BcCommonConstants.PREFIX_LIB}-dropdown-toggle`;
const _DROPDOWN_TOGGLE_ACTIVE_CLASS = `${BcCommonConstants.PREFIX_LIB}-dropdown-toggle-active`;
const _DROPDOWN_ITEM_CLASS = `${BcCommonConstants.PREFIX_LIB}-dropdown-item`;
const _DROPDOWN_CLASS = `${BcCommonConstants.PREFIX_LIB}-dropdown`;
const _DROPDOWN_ACTIVE_CLASS = `${BcCommonConstants.PREFIX_LIB}-dropdown-active`;
const _DROPDOWN_CONTENT_CLASS = `${BcCommonConstants.PREFIX_LIB}-dropdown-content`;
const _DROPDOWN_CONTENT_ACTIVE_CLASS = `${BcCommonConstants.PREFIX_LIB}-dropdown-content-active`;
const _DROPDOWN_DROPTOP_CLASS = `${BcCommonConstants.PREFIX_LIB}-droptop`;
const _DROPDOWN_TRIANGLE_CLASS = `${BcCommonConstants.PREFIX_LIB}-dropdown-triangle`;
const _DROPDOWN_UNDIMISS_CLASS = `${BcCommonConstants.PREFIX_LIB}-dropdown-undismiss`;
const _DROPDOWN_CLOSE_BUTTON_CLASS = `${BcCommonConstants.PREFIX_LIB}-dropdown-close-button`;
const _DROPDOWN_OPENED_EVENT = `${BcCommonConstants.PREFIX_LIB}DropdownOpened`;
const _DROPDOWN_CLOSED_EVENT = `${BcCommonConstants.PREFIX_LIB}DropdownClosed`;
const _DROPDOWN_DISCARDED_EVENT = `${BcCommonConstants.PREFIX_LIB}DropdownDiscarded`;
const _DROPDOWN_NUMBER_0 = 0;
const _DROPDOWN_NUMBER_1 = -1;
const _DROPDOWN_NUMBER_11 = 11;
const _DROPDOWN_NUMBER_14 = 14;
const _DROPDOWN_NUMBER_26 = 26;
const _DROPDOWN_NUMBER_243 = 243;
const _DROPDOWN_NUMBER_60 = 60;

class BcDropdownHelper {
    getProperty(obj, properties, defaultValue) {
        let property = null;
        if (properties.length > 0 && properties[0] in obj) {
            const obtTemp = obj[properties[0]];
            if (properties.length - 1 > 0) {
                property = this.getProperty(obtTemp, properties.slice(1, properties.length), defaultValue);
            }
            else {
                property = obtTemp;
            }
        }
        else {
            if (defaultValue) {
                property = defaultValue;
            }
        }
        return property;
    }
    isNullOrUndefined(property) {
        if (property === null || property === undefined) {
            return true;
        }
        return false;
    }
}

const CARD_SELECT_CLASS = `${BcCommonConstants.PREFIX_LIB}-card-select`;
const CARD_SELECT_INPUT = `${BcCommonConstants.PREFIX_LIB}-input`;
const CARD_SELECT_ACTIVE_CLASS = `${CARD_SELECT_CLASS}-active`;
const CARD_SELECT_SELECTED_CLASS = `${CARD_SELECT_CLASS}-selected`;
const CARD_SELECT_ACTIVE_ITEM_CLASS = `${CARD_SELECT_CLASS}-active-item`;
const CARD_SELECT_SELECTED_ITEM_CLASS = `${CARD_SELECT_CLASS}-selected-item`;
const CARD_SELECT_CONTROL_CLASS = `${CARD_SELECT_CLASS}-control`;
const CARD_SELECT_INPUT_CLASS = `${CARD_SELECT_CLASS}-input`;
const CARD_SELECT_PLACEHOLDER_CLASS = `${CARD_SELECT_CLASS}-placeholder`;
const CARD_ICON_SEARCH_CLASS = `${CARD_SELECT_CLASS}-search`;
const CARD_SELECT_CONTENT_TOGGLE_CLASS = `${CARD_SELECT_CLASS}-content-toggle`;
const CARD_SELECT_TOGGLE_CLASS = `${CARD_SELECT_CLASS}-toggle`;
const CARD_SELECT_ACTIVE_TOGGLE_CLASS = `${CARD_SELECT_CLASS}-active-toggle`;
const CARD_SELECT_DROPDOWN_CLASS = `${CARD_SELECT_CLASS}-content`;
const CARD_SELECT_DROPDOWN_ACTIVE_CLASS = `${CARD_SELECT_CLASS}-content-active`;
const CARD_SELECT_DROPDOWN_BODY_CLASS = `${CARD_SELECT_CLASS}-content-body`;
const CARD_SELECT_DROPDOWN_ITEM_CLASS = `${CARD_SELECT_CLASS}-item`;
const CARD_SELECT_DROPDOWN_FILTRABLE_ITEMS_CLASS = `${CARD_SELECT_DROPDOWN_ACTIVE_CLASS}-filtrable`;
const CARD_SELECT_DROPDOWN_FILTERED_ITEMS_CLASS = `${CARD_SELECT_DROPDOWN_ITEM_CLASS}-filtered`;
const CARD_SELECT_DROPDOWN_FOOTER_CLASS = `${CARD_SELECT_CLASS}-content-footer`;
const CARD_SELECT_DROPDOWN_FOOTER_ITEM_CLASS = `${CARD_SELECT_CLASS}-content-add-item`;
const CARD_DROPDOWN_SELECT_ACTION = `${CARD_SELECT_CLASS}-action`;
const CARD_SELECT_CONTENT_NO_DATA_CLASS = `${CARD_SELECT_CLASS}-no-data`;
const CARD_SELECT_SUBTITLE_CLASS = `${BcCommonConstants.PREFIX_LIB}-subtittle`;
const CARD_SELECT_INFO_CLASS = `${BcCommonConstants.PREFIX_LIB}-card-info-balance`;
const CARD_SELECT_OUTLINE_ELEMENT = 'outline-element';
const CARD_SELECT_MAX_WIDTH_CLIENT = 6;
const CARD_SELECT_MIN_FILTER_CHA = 3;
const CARD_SELECT_MIN_SIZE = `${BcCommonConstants.PREFIX_LIB}-col-xs-6`;
const CARD_SELECT_MAX_SIZE = `${BcCommonConstants.PREFIX_LIB}-col-sm-12`;
const CARD_SELECT_PLACEHOLDER_MEDIUM_CLASS = `${CARD_SELECT_CLASS}-placeholder-medium`;
const CARD_SELECT_PLACEHOLDER_LARGE_CLASS = `${CARD_SELECT_CLASS}-placeholder-large`;
const CARD_SELECT_SIZE = `${CARD_SELECT_CLASS}-size`;
const CARD_SELECT_DROPDOWN_CONTENT_NOTDATA = `${CARD_SELECT_DROPDOWN_CLASS}-notdata`;
const CARD_SELECT_DROPDOWN_CONTENT_VISIBLE = `${CARD_SELECT_DROPDOWN_CONTENT_NOTDATA}-visible`;
const CARD_SELECT_DROPDOWN_ICON_NOTDATA = `${CARD_SELECT_CLASS}-icon-notData`;
const CARD_SELECT_JUSTIFY = `${BcCommonConstants.PREFIX_LIB}-justify-content-center`;
const CARD_SELECT_CONTROL_DISABLED_CLASS = `${CARD_SELECT_CONTROL_CLASS}-disabled`;
const CARD_SELECT_SCROLL_MIN = 600;

class BcAbstractDropdownBehavior extends BcDefaultBehavior {
    constructor() {
        super();
        this.toggleButton = null;
        this.dropdownContent = null;
        this.dropdownActive = null;
        this.dropdownItems = [];
        this.config = {};
        this.topMarginContent = 0;
        this.closeButton = null;
        this.toggleButtonEventsAdded = false;
        this.helper = new BcDropdownHelper();
    }
    setConfig(config) {
        if (config) {
            this.config = config;
        }
        this.initConfiguration();
    }
    initConfiguration() {
        this.config = {
            toggleClass: this.helper.getProperty(this.config, ['toggleClass'], _DROPDOWN_TOGGLE_CLASS),
            toggleActiveClass: this.helper.getProperty(this.config, ['toggleActiveClass'], _DROPDOWN_TOGGLE_ACTIVE_CLASS),
            contentClass: this.helper.getProperty(this.config, ['contentClass'], _DROPDOWN_CONTENT_CLASS),
            contentActiveClass: this.helper.getProperty(this.config, ['contentActiveClass'], _DROPDOWN_CONTENT_ACTIVE_CLASS),
            itemClass: this.helper.getProperty(this.config, ['itemClass'], _DROPDOWN_ITEM_CLASS),
            triangleClass: this.helper.getProperty(this.config, ['triangleClass'], _DROPDOWN_TRIANGLE_CLASS),
            toggleEvents: this.config.toggleEvents ? this.config.toggleEvents : ['click', 'input'],
            mainClass: this.helper.getProperty(this.config, ['mainClass'], _DROPDOWN_CLASS),
            mainActiveClass: this.helper.getProperty(this.config, ['mainActiveClass'], _DROPDOWN_ACTIVE_CLASS),
            static: !this.helper.isNullOrUndefined(this.config.static) ? this.config.static : false,
            isPopUp: !this.helper.isNullOrUndefined(this.config.isPopUp) ? this.config.isPopUp : false,
            isDisabled: !this.helper.isNullOrUndefined(this.config.isDisabled) ? this.config.isDisabled : false,
            parentWidth: !this.helper.isNullOrUndefined(this.config.parentWidth) ? this.config.parentWidth : false,
            contentAutoWidth: !this.helper.isNullOrUndefined(this.config.contentAutoWidth)
                ? this.config.contentAutoWidth
                : false,
            multiple: !this.helper.isNullOrUndefined(this.config.multiple) ? this.config.multiple : false,
            maxHeightContent: !this.helper.isNullOrUndefined(this.config.maxHeightContent)
                ? this.config.maxHeightContent
                : null,
            isAutoStyle: !this.helper.isNullOrUndefined(this.config.isAutoStyle) ? this.config.isAutoStyle : true,
            onlyBottomPosition: !this.helper.isNullOrUndefined(this.config.onlyBottomPosition)
                ? this.config.onlyBottomPosition
                : false,
        };
    }
    initAccesibilityConfig() {
        addFocusable(this.dropdownContent, {
            expanded: 'true',
            role: 'listbox',
        });
    }
    _setUp() {
        this.initConfiguration();
        this.getElements();
        if (this.config.isPopUp) {
            this.addDropdownTriangle();
        }
        if (this.config.maxHeightContent) {
            this.configureMaxHeight(this.config.maxHeightContent);
        }
        this.addEventClick();
        if (!this.config.static && !this.mySelf.classList.contains(_DROPDOWN_UNDIMISS_CLASS)) {
            this.addWindowEventClick();
        }
        window.addEventListener('resize', () => {
            this.setDropdownContentPosition();
        });
        window.addEventListener('scroll', (event) => {
            if (this.dropdownContent != event.target) {
                document.querySelector('body')['style'].overflow !== 'hidden' && this.setDropdownContentPosition();
            }
        }, true);
        this.setAriaExpanded(false);
        this.initAccesibilityConfig();
    }
    /**
     * Abrir dropdown, corrigiendo la posición si es necesario
     * @memberof BcAbstractDropdownBehavior
     */
    openDrowndown() {
        this.closeAllDropdowns();
        setTimeout(() => {
            this.setDropdownContentPosition();
        });
        if (INPUT_SELECT_TOGGLE_CLASS) {
            const input = this.mySelf.querySelector(`${EM_TAG}.${INPUT_SELECT_TOGGLE_CLASS}`);
            if (input) {
                input.textContent = BcCommonConstants.ICON_ARROW_UP;
            }
            const inputMySelf = this.mySelf.querySelector(`${EM_TAG}.${INPUT_SELECT_ACTIVE_TOGGLE_CLASS}`);
            if (inputMySelf) {
                inputMySelf.textContent = BcCommonConstants.ICON_ARROW_UP;
            }
        }
        const dropdownContent = this.dropdownContent;
        this.setAriaExpanded(true);
        replaceClass(dropdownContent, this.config.contentClass, this.config.contentActiveClass);
        replaceClass(this.toggleButton, this.config.toggleClass, this.config.toggleActiveClass);
        replaceClass(this.mySelf, this.config.mainClass, this.config.mainActiveClass);
        this.dropdownActive = dropdownContent;
        if (this.dropdownContent) {
            window.dispatchEvent(new CustomEvent(_DROPDOWN_OPENED_EVENT, { detail: this.dropdownContent.getAttribute('id') }));
        }
        if (this.config.parentWidth) {
            this.setParentWidth();
        }
    }
    /**
     * Cerrar el dropdown
     * @memberof BcAbstractDropdownBehavior
     */
    closeDropdown(discard) {
        if (INPUT_SELECT_ACTIVE_TOGGLE_CLASS) {
            const input = this.mySelf.querySelector(`${EM_TAG}.${INPUT_SELECT_ACTIVE_TOGGLE_CLASS}`);
            const inputArrow = this.mySelf.querySelector(`${EM_TAG}.${INPUT_SELECT_TOGGLE_CLASS}`);
            if (input) {
                input.textContent = BcCommonConstants.ICON_ARROW_DOWN;
            }
            if (inputArrow) {
                inputArrow.textContent = BcCommonConstants.ICON_ARROW_DOWN;
            }
        }
        replaceClass(this.dropdownContent, this.config.contentActiveClass, this.config.contentClass);
        replaceClass(this.toggleButton, this.config.toggleActiveClass, this.config.toggleClass);
        replaceClass(this.mySelf, this.config.mainActiveClass, this.config.mainClass);
        this.dropdownActive = null;
        this.setAriaExpanded(false);
        if (this.toggleButton) {
            this.toggleButton.classList.remove(_DROPDOWN_DROPTOP_CLASS);
        }
        if (this.dropdownContent !== null && !discard) {
            window.dispatchEvent(new CustomEvent(_DROPDOWN_CLOSED_EVENT, { detail: this.dropdownContent.getAttribute('id') }));
        }
        if (discard) {
            window.dispatchEvent(new CustomEvent(_DROPDOWN_DISCARDED_EVENT, { detail: this.dropdownContent.getAttribute('id') }));
        }
    }
    setAriaExpanded(expanded) {
        this.dropdownContent?.setAttribute('aria-expanded', String(expanded));
    }
    setHeightContent(positionContent) {
        this.targetOffsetPos = this.mySelf.getBoundingClientRect();
        this.dropdownOffsetPos = this.dropdownContent.getBoundingClientRect();
        const top = this.targetOffsetPos.top + this.targetOffsetPos.height;
        this.windowHeight = document.documentElement.clientHeight;
        this.bodyHeight = document.body.offsetHeight;
        if (positionContent === 'bottom') {
            if (top + this.dropdownOffsetPos.height > this.windowHeight &&
                this.targetOffsetPos.top > this.dropdownOffsetPos.height) {
                this.configureMaxHeight(this.firstHeight);
                return;
            }
            if (top + this.dropdownOffsetPos.height > this.windowHeight &&
                this.targetOffsetPos.top < this.dropdownOffsetPos.height &&
                this.bodyHeight > this.windowHeight) {
                if (top + this.dropdownOffsetPos.height > this.bodyHeight) {
                    const lessHeight = top + this.dropdownOffsetPos.height - this.windowHeight;
                    const maxHeight = this.firstHeight - lessHeight;
                    this.configureMaxHeight(maxHeight);
                    return lessHeight;
                }
                else {
                    this.configureMaxHeight(this.firstHeight);
                    return;
                }
            }
            if (top + this.dropdownOffsetPos.height > this.windowHeight &&
                this.targetOffsetPos.top < this.dropdownOffsetPos.height &&
                this.bodyHeight < this.windowHeight) {
                const lessHeight = top + this.dropdownOffsetPos.height - this.windowHeight;
                const maxHeight = this.firstHeight - lessHeight;
                this.configureMaxHeight(maxHeight);
                return lessHeight;
            }
            this.configureMaxHeight(this.firstHeight);
            return false;
        }
    }
    /**
     * Se añade el evento click a los elementos que tienen la clase "bc-dropdown-toggle"
     * el cual permite abrir o cerrar el dropdown que tenga relacionado a id del elemento actual
     * @memberof BcAbstractDropdownBehavior
     */
    addEventClick() {
        const eventToggle = (event, discard) => {
            this.clickToggleEvent(event, discard);
        };
        if (this.toggleButton && !this.toggleButtonEventsAdded) {
            this.config.toggleEvents.forEach((event) => {
                this.toggleButton.removeEventListener(event, eventToggle);
                this.toggleButton.addEventListener(event, eventToggle);
            });
            this.toggleButtonEventsAdded = true;
        }
        this.configureExtraToggles(this.clickToggleEvent);
        addFocusable(this.toggleButton, { haspopup: 'listbox' }, { event: this.clickToggleEvent.bind(this) });
        if (this.closeButton !== null) {
            this.closeButton.addEventListener('click', (event) => {
                eventToggle(event, true);
            });
            addFocusable(this.closeButton, { haspopup: 'listbox' }, { event: eventToggle });
        }
    }
    /**
     * Evento toggle por medio del click del mouse, llama a la función toggleDropdown
     * @param {MouseEvent} [event]
     * @memberof BcAbstractDropdownBehavior
     */
    clickToggleEvent(event, discard) {
        event?.preventDefault();
        event?.stopPropagation();
        if (this && this.disabled) {
            return;
        }
        this.toggleDropdown(discard);
        this.emitEvent(event);
    }
    /**
     * Retorna el evento de despliege del dropdown
     * @param {MouseEvent} [event]
     * @memberof BcAbstractDropdownBehavior
     */
    emitEvent(event) {
        return event;
    }
    /**
     * Alterna el estado del dropdown entre abierto y cerrado
     * @param {boolean} [noClose] Indica si el dropdown no se puede cerrar automaticamente
     * @memberof BcAbstractDropdownBehavior
     */
    toggleDropdown(discard, noClose) {
        if (!this.validateDropdownIsActive()) {
            this.dropdownActive = null;
        }
        if (this.dropdownActive != null && !noClose) {
            this.closeDropdown(discard);
        }
        else {
            this.openDrowndown();
        }
    }
    configureExtraToggles(clickEvent) {
        if (this.config.extraToggles) {
            for (const extraToggle of this.config.extraToggles) {
                let element;
                if (extraToggle.id) {
                    element = this.mySelf.querySelector(`*[id='${extraToggle.id}']`);
                }
                else {
                    element = extraToggle.node;
                }
                if (element) {
                    for (const event of extraToggle.events) {
                        element.addEventListener(event, (data) => {
                            clickEvent.bind(this, data);
                        });
                    }
                }
            }
        }
    }
    /**
     * Se obtienen los elementos a manipular en el comportamiento
     * @memberof BcAbstractDropdownBehavior
     */
    getElements() {
        this.toggleButton = this.mySelf.querySelector(`.${this.config.toggleActiveClass},.${this.config.toggleClass}`);
        if (!this.toggleButton &&
            (this.mySelf.classList.contains(this.config.toggleActiveClass) ||
                this.mySelf.classList.contains(this.config.toggleClass))) {
            this.toggleButton = this.mySelf;
        }
        if (this.toggleButton) {
            this.idContent = this.toggleButton.getAttribute('aria-controls');
        }
        this.dropdownContent = this.mySelf.querySelector(`*[id='${this.idContent}']`);
        if (this.dropdownContent !== null) {
            this.dropdownItems = Array.from(this.dropdownContent.querySelectorAll(`*[class~='${this.config.itemClass}']`));
            this.closeButton = this.dropdownContent.querySelector(`*[class~='${_DROPDOWN_CLOSE_BUTTON_CLASS}']`);
        }
    }
    /**
     * Se valida si el dropdown tiene la clase "bc-dropdown-active"
     * @memberof BcAbstractDropdownBehavior
     */
    validateDropdownIsActive() {
        return this.dropdownContent !== null
            ? this.dropdownContent.classList.contains(this.config.contentActiveClass)
            : false;
    }
    /**
     * Se asigna a posición del dropdown-conent dependiendo si está fuera de la pantalla
     * @memberof BcAbstractDropdownBehavior
     */
    setDropdownContentPosition() {
        if (this.dropdownActive !== null && this.config.isAutoStyle) {
            this.validateFirstHeight();
            this.targetOffsetPos = this.mySelf.getBoundingClientRect();
            this.dropdownOffsetPos = this.dropdownContent.getBoundingClientRect();
            this.windowWidth = document.documentElement.clientWidth;
            this.windowHeight = document.documentElement.clientHeight;
            this.triangle && this.triangle.classList.remove(_DROPDOWN_DROPTOP_CLASS);
            let right = _DROPDOWN_NUMBER_0;
            let bottom = _DROPDOWN_NUMBER_0;
            let left = this.targetOffsetPos.left;
            let top = this.targetOffsetPos.top + this.targetOffsetPos.height;
            ({ top, left, right, bottom } = this.position(top, left, right, bottom));
            this.setPosition(left, right, top, bottom);
        }
    }
    position(top, left, right, bottom) {
        if (!this.config.onlyBottomPosition) {
            if (this.config.isPopUp) {
                top = top + _DROPDOWN_NUMBER_11;
            }
            if (left + this.dropdownOffsetPos.width >= this.windowWidth) {
                right = this.windowWidth - (left + this.targetOffsetPos.width);
                left = _DROPDOWN_NUMBER_1;
            }
            if (top + this.dropdownOffsetPos.height > this.windowHeight &&
                this.dropdownOffsetPos.height + this.targetOffsetPos.height > top) {
                bottom =
                    this.windowHeight -
                        (this.targetOffsetPos.y + this.targetOffsetPos.height + this.dropdownOffsetPos.height - _DROPDOWN_NUMBER_26);
                top = _DROPDOWN_NUMBER_1;
            }
            else if (top + this.dropdownOffsetPos.height >= this.windowHeight) {
                bottom = this.windowHeight - (this.targetOffsetPos.bottom - this.targetOffsetPos.height - _DROPDOWN_NUMBER_14);
                top = _DROPDOWN_NUMBER_1;
                this.triangle && this.triangle.classList.add(_DROPDOWN_DROPTOP_CLASS);
            }
        }
        else {
            left = _DROPDOWN_NUMBER_0;
            right = _DROPDOWN_NUMBER_0;
            top = _DROPDOWN_NUMBER_0;
            bottom = _DROPDOWN_NUMBER_60;
        }
        return { top, left, right, bottom };
    }
    validateFirstHeight() {
        if (!this.firstHeight) {
            this.firstHeight = this.dropdownContent.clientHeight;
        }
        else {
            this.configureMaxHeight(this.firstHeight);
        }
    }
    setPosition(left, right, top, bottom) {
        if (!this.config.onlyBottomPosition) {
            if (left !== _DROPDOWN_NUMBER_1) {
                this.dropdownContent['style'].left = `${left}px`;
                this.dropdownContent['style'].right = 'auto';
            }
            else {
                this.dropdownContent['style'].left = 'auto';
                this.dropdownContent['style'].right = `${right}px`;
            }
            if (top !== _DROPDOWN_NUMBER_1) {
                this.dropdownContent['style'].top = `${top}px`;
                this.dropdownContent['style'].bottom = 'auto';
                this.setHeightContent();
            }
            else {
                const conditionBotton = this.setHeightContent('bottom');
                if (conditionBotton) {
                    this.dropdownContent['style'].top = 'auto';
                    this.dropdownContent['style'].bottom = `${bottom + conditionBotton}px`;
                }
                else {
                    this.dropdownContent['style'].top = 'auto';
                    this.dropdownContent['style'].bottom = `${bottom}px`;
                }
            }
        }
        else {
            this.dropdownContent['style'].position = 'absolute';
            this.dropdownContent['style'].top = 'calc(100% - 5px)';
        }
    }
    /**
     * Se agrega el triangulo que indica o señala el elemento que ha abierto el dropdown
     * para este caso señala el elemento con la clase "bc-dropdown-toggle" que tiene como Id
     * el cual está relacionado con el dropdown
     * @memberof BcAbstractDropdownBehavior
     */
    addDropdownTriangle() {
        this.triangle = document.createElement('div');
        this.triangle.classList.add(this.config.triangleClass);
        this.mySelf.appendChild(this.triangle);
    }
    /**
     * Se configura un alto maximo al contenido
     * @memberof BcAbstractDropdownBehavior
     */
    configureMaxHeight(height) {
        this.dropdownContent.style.maxHeight = height - _DROPDOWN_NUMBER_1 + 'px';
        if (this.dropdownContent['classList'].contains(CARD_SELECT_DROPDOWN_ACTIVE_CLASS)) {
            this.dropdownContent.style.maxHeight = 'fit-content';
        }
    }
    /**
     * Se añade el evento click a window para poder cerrar los dropdowns abiertos
     * @memberof BcAbstractDropdownBehavior
     */
    addWindowEventClick() {
        window.addEventListener('click', (event) => {
            event.stopPropagation();
            const isToggleElement = event.target['className'].indexOf(this.config.toggleClass) !== -1;
            const isInputElement = event.target['className'].indexOf(INPUT) !== -1;
            const isMainElement = this.config.multiple
                ? event.target['className'].indexOf(this.config.itemClass) !== -1
                : false;
            if (this.dropdownActive && !isToggleElement && (!isMainElement || !isInputElement)) {
                this.closeDropdown();
            }
        });
    }
    /**
     * Se asigna el ancho del padre (mainClass) a el contenedor del dropdown
     * @memberof BcAbstractDropdownBehavior
     */
    setParentWidth() {
        if (!this.config.contentAutoWidth) {
            const parentWidth = this.mySelf.clientWidth;
            if (parentWidth >= _DROPDOWN_NUMBER_243) {
                this.dropdownContent.style.width = `${parentWidth}px`;
            }
            else {
                this.dropdownContent.style.width = `${_DROPDOWN_NUMBER_243}px`;
            }
        }
    }
    closeAllDropdowns() {
        document.querySelectorAll('.' + INPUT_SELECT_ACTIVE_CLASS).forEach((dropdown) => {
            replaceClass(dropdown, INPUT_SELECT_ACTIVE_CLASS, INPUT_SELECT_CLASS);
        });
        document.querySelectorAll('.' + INPUT_SELECT_ACTIVE_CONTENT_CLASS).forEach((dropdown) => {
            replaceClass(dropdown, INPUT_SELECT_ACTIVE_CONTENT_CLASS, INPUT_SELECT_CONTENT_CLASS);
        });
    }
}

class BcInputSelectBehavior extends BcAbstractDropdownBehavior {
    constructor() {
        super();
        this.activeElements = {};
        this.selectedItemsDisplay = '{0} ítems seleccionados';
        this.bcInputBehavior = new BcInputBehavior();
        this.isDisabled = false;
        this.isKeydown = false;
        this.inpValue = '';
    }
    _setUp() {
        this.addPaddingRightWhenIcon();
        this.isMultiple = this.mySelf.hasAttribute('multiple');
        this.isFilter = this.mySelf.hasAttribute('filter');
        const input = this.mySelf.querySelector('input');
        input.readOnly = this._setReadOnly(this.isFilter, input);
        this.setDropDownConfiguration();
        super._setUp();
        this.bcInputBehavior.setElement(input);
        this.bcInputBehavior.setUp();
        this.createItems();
        this.getInsideElements();
        this.setMarginTop();
        this.setEventListeners();
        this.markItemByIndex(this.defaultIndex);
        this.toggleFocus();
        this.initAccesibilityInput();
        this.closeEsc();
        this.focusFirstLastItem();
        this.itemsArrow();
    }
    /**
     * setea el parametro ReadOnly del imput
     *
     * @private
     * @param {boolean} type
     * @returns {boolean}
     *
     * @memberOf BcInputSelectBehavior
     */
    _setReadOnly(typeInput, input) {
        if (typeInput) {
            this.filter(input);
            return false;
        }
        return true;
    }
    /**
     * @fileoverview Crea los ítems del dropdown por medio del array dropdownItems.
     * Los ítems pueden ser únicos o múltiples, según el tipo de dropdown, lo cual se verifica mediante el atributo boleano: isMultiple
     * @memberof BcInputSelectBehavior
     */
    createItems() {
        this.closeDropdown();
        const mySelf = this.mySelf.querySelector(`*[id='${this.idContent}']`);
        for (const i of Array.from(mySelf.childNodes)) {
            mySelf.removeChild(i);
        }
        this.activeElements = {};
        this.dropdownItems = [];
        if (this.itemsConfig) {
            for (const itemObj of this.itemsConfig) {
                const index = this.itemsConfig.indexOf(itemObj);
                if (typeof itemObj != 'object') {
                    this.itemsConfig[index] = { label: itemObj, value: itemObj, aux: itemObj };
                }
                let li = null;
                this.itemsConfigAux = this.itemsConfig;
                if (this.isMultiple) {
                    li = this.createItemTypeMultiple(this.itemsConfig[index]);
                }
                else if (this.isFilter) {
                    li = this.createItemTypeSingle(this.itemsConfig[index]);
                    addFocusable(li, { tabindex: '0' });
                }
                else {
                    li = this.createItemTypeSingle(this.itemsConfig[index]);
                }
                addFocusable(li, { tabindex: '0' });
                this.dropdownItems.push(li);
                this.dropdownContent.appendChild(li);
            }
        }
        this.setValueInputMultiple();
    }
    /**
     * Crea cada ítem de tipo único, con su correspondiente icono y etiqueta
     * @returns li
     * @memberof BcInputSelectBehavior
     */
    createItemTypeSingle(data) {
        const li = document.createElement(BcCommonConstants.LI_TAG);
        li.classList.add(this.config.itemClass);
        if (data.icon) {
            const em = document.createElement(BcCommonConstants.EM_TAG);
            em.innerText = data.icon;
            li.appendChild(em);
        }
        const spanTag = document.createElement(BcCommonConstants.SPAN_TAG);
        spanTag.innerHTML = data.label;
        spanTag.classList.add(INPUT_SPAN_SINGLE);
        li.appendChild(spanTag);
        return li;
    }
    /**
     * Crea cada item de tipo múltiple, con su correspondiente label y etiqueta y se le asigna un checkbox que permite la selección múltiple
     * @returns li
     * @memberof BcInputSelectBehavior
     */
    createItemTypeMultiple(data) {
        const li = document.createElement(BcCommonConstants.LI_TAG);
        li.classList.add(this.config.itemClass);
        const labelTag = document.createElement(BcCommonConstants.LABEL_TAG);
        const inputTag = document.createElement(BcCommonConstants.INPUT_TAG);
        const spanTag = document.createElement(BcCommonConstants.SPAN_TAG);
        labelTag.classList.add(BcCommonConstants.CONTAINER_CHECKBOX_CLASS);
        spanTag.classList.add(BcCommonConstants.CHECKBOX_CLASS);
        inputTag.setAttribute('type', 'checkbox');
        inputTag.setAttribute('class', INPUT_SELECT_ITEM_CLASS);
        labelTag.innerText = data.label;
        labelTag.appendChild(inputTag);
        labelTag.appendChild(spanTag);
        li.appendChild(labelTag);
        li.appendChild(labelTag);
        return li;
    }
    /**
     * Setea itemsConfig con el argumento items
     * @param items
     * @memberof BcInputSelectBehavior
     */
    setItems(items) {
        this.itemsConfig = items;
        this.itemsConfigAux = items;
        this.updateDropdown();
    }
    /**
     * Asigna un margin top de -25 siempre que el elemento HTMLSpanElement exista.
     * @memberof BcInputSelectBehavior
     */
    setMarginTop() {
        if (this.span) {
            this.topMarginContent = COMMON_CONSTANTS_NUMBERS.Negative25;
        }
    }
    /**
     * Setea selectedItemsDisplay con los items seleccionados, siempre que existan ítems seleccionados
     * @param displayInfo
     * @memberof BcInputSelectBehavior
     */
    setSelectedItemsDisplay(displayInfo) {
        if (displayInfo) {
            this.selectedItemsDisplay = displayInfo;
        }
    }
    /**
     * Define el index por default del dropdown seteando defaultIndex con el argumento index.
     * @param index
     * @memberof BcInputSelectBehavior
     */
    setDefaultIndex(index) {
        this.defaultIndex = index;
    }
    /**
     * Setea el valor seleccionado por default del dropdown, para ello válida que el argumento value
     * no sea indefinido y que existan items cargados en el dropdown. finalmente válida que value sea de tipo string u object y lo selecciona.
     * @param {any} value
     * @memberof BcInputSelectBehavior
     */
    setDefaultValue(value) {
        let index = 0;
        if (value) {
            for (const elementIndex in this.itemsConfig) {
                const itemConfigIndex = this.itemsConfig[elementIndex];
                const stringCondition = typeof itemConfigIndex === 'string' && itemConfigIndex === value;
                const objectCondition = typeof itemConfigIndex === 'object' &&
                    (itemConfigIndex['value'] === value || itemConfigIndex['label'] === value);
                if (stringCondition || objectCondition) {
                    break;
                }
                index++;
            }
            this.markItemByIndex(index);
            if (index >= 0 && index < this.itemsConfig.length) {
                this.defaultIndex = index;
            }
        }
    }
    /**
     * Obtiene los elementos tipo input del dropdown
     * @memberof BcInputSelectBehavior
     */
    getInsideElements() {
        this.input = this.mySelf.querySelector(`${BcCommonConstants.INPUT_TAG}[class*=${INPUT}]`);
        this.span = this.mySelf.querySelector(`${BcCommonConstants.INPUT_TAG}[class=${INPUT}] ~ ${BcCommonConstants.SPAN_TAG}`);
        if (!this.itemsConfig) {
            this.getItems();
        }
    }
    /**
     * Obtiene el array de items seleccionados del dropdown, incluyendo la etiqueta span y los setea en el array itemsConfig.
     * @memberof BcInputSelectBehavior
     */
    getItems() {
        const items = Array.from(this.mySelf.querySelectorAll(`*[class=${INPUT_SELECT_ITEM_CLASS}]`));
        this.itemsConfig = [];
        for (const item of items) {
            this.dropdownItems.push(item);
            const span = item.querySelector(`${BcCommonConstants.SPAN_TAG}`);
            this.itemsConfig.push({ label: span.innerText, value: span.innerText });
        }
    }
    /**
     * Se encarga de realizar la configuración para el comportamiento general heredado del Dropdown
     * @memberof BcInputSelectBehavior
     */
    setDropDownConfiguration() {
        this.setConfig({
            toggleClass: INPUT_SELECT_TOGGLE_CLASS,
            toggleActiveClass: INPUT_SELECT_ACTIVE_TOGGLE_CLASS,
            contentClass: INPUT_SELECT_CONTENT_CLASS,
            contentActiveClass: INPUT_SELECT_ACTIVE_CONTENT_CLASS,
            itemClass: INPUT_SELECT_ITEM_CLASS,
            triangleClass: INPUT_SELECT_ITEM_CLASS,
            extraToggles: [
                {
                    node: this.input,
                    events: ['focus'],
                },
            ],
            toggleEvents: ['click', 'input'],
            mainClass: INPUT_SELECT_CLASS,
            mainActiveClass: INPUT_SELECT_ACTIVE_CLASS,
            static: false,
            isPopUp: false,
            isDisabled: this.isDisabled,
            parentWidth: true,
            multiple: this.isMultiple,
            maxHeightContent: this.maxHeightContent,
        });
    }
    /**
     * Asigna el argumento isDisabled al atributo disabled del dropdown,
     * si el componente está activo y isDisabled es true, entonces cierra el dropdown.
     * @param {boolean} isDisabled
     * @memberof BcInputSelectBehavior
     */
    setDisabled(isDisabled) {
        this.isDisabled = isDisabled;
        this.disabled = isDisabled;
        this.setDropDownConfiguration();
        if (this.validateDropdownIsActive() && this.isDisabled) {
            this.closeDropdown();
        }
    }
    /**
     * Obtiene los ítems activos del dropdown en el array response,
     * sí el dropdown no es de tipo múltiple solo se obtendrá un solo ítem activo
     * @memberof BcInputSelectBehavior
     */
    getCurrentActiveItems() {
        let response = [];
        if (this.itemsConfig) {
            for (const key in this.activeElements) {
                if (Object.prototype.hasOwnProperty.call(this.activeElements, key) && parseInt(key) < this.itemsConfig.length) {
                    if (this.formatType === 'full') {
                        response.push(this.itemsConfig[parseInt(key)]);
                    }
                    else {
                        response.push(this.itemsConfig[parseInt(key)].value);
                    }
                }
            }
            if (!this.isMultiple && response.length > 0) {
                response = response[0];
            }
        }
        return response;
    }
    /**
     * Asigna el tipo de formato al atributo formatType (puede ser simple o full).
     * @param {string} formatType
     * @memberof BcInputSelectBehavior
     */
    setFormatOutput(formatType) {
        if (formatType && (formatType === 'simple' || formatType === 'full')) {
            this.formatType = formatType;
        }
    }
    /**
     * Crea la etiqueta de texto con énfasis <em> con el texto 'ok' y la retorna.
     * @returns check
     * @memberof BcInputSelectBehavior
     */
    createActiveIcon() {
        const check = document.createElement(BcCommonConstants.EM_TAG);
        check.innerText = 'ok';
        return check;
    }
    /**
    * Elimina la etiqueta de texto con énfasis <em> con el texto 'ok'
    * @returns check
    * @memberof BcInputSelectBehavior
    */
    deleteActiveIcon() {
        const BASE_10 = 10;
        this.dropdownItems.forEach((itemDropdown, i) => {
            const checkElement = itemDropdown.querySelector(`${BcCommonConstants.EM_TAG}`);
            const checkBoxElement = itemDropdown.querySelector(`[class~='${BcCommonConstants.CONTAINER_CHECKBOX_CLASS}'] .${BcCommonConstants.CHECKBOX_CLASS}`);
            if (checkElement && checkElement.innerHTML == 'ok') {
                itemDropdown.removeChild(checkElement);
            }
            if (checkBoxElement) {
                for (const property in this.activeElements) {
                    this.markItemByIndex(parseInt(property, BASE_10));
                }
            }
        });
    }
    /**
     * Marca un ítem del dropdown de acuerdo al indice (index), también se activa el evento click para seleccionar dicho ítem.
     * @param {number} index
     * @memberof BcInputSelectBehavior
     */
    markItemByIndex(index) {
        if (index !== undefined && this.dropdownItems.length > index && index >= 0) {
            this.bcInputBehavior.addRemoveClass(true, this.mySelf.querySelector('input'));
            this.dropdownItems[String(index)].dispatchEvent(new Event(BcCommonConstants.EVENT_CLICK, {}));
        }
    }
    /**
     * Configura el evento seleccionado (event). Si el dropdown es de tipo múltiple verifica los ítems checkeados y los activa.
     * Si el dropdown es de tipo único activa el item directamente del argumento.
     * @param {Event} event
     * @param {number} i index del array de ítems activos
     * @param {Element} item
     * @memberof BcInputSelectBehavior
     */
    configSelectedEvent(event, i, item) {
        if (this.isMultiple) {
            if (['INPUT', 'LI'].indexOf(event.target.tagName) === -1) {
                event.stopPropagation();
                return;
            }
            const inputInside = item.querySelector(BcCommonConstants.INPUT_TAG);
            const condition = i in this.activeElements;
            if (inputInside) {
                this.configInputCheck(inputInside, condition, event, item, i);
            }
            this.setValueInputMultiple();
        }
        else {
            this.dropdownItems.forEach((itemDropdown) => {
                const checkElement = itemDropdown.querySelector(`${BcCommonConstants.EM_TAG}`);
                if (checkElement) {
                    itemDropdown.removeChild(checkElement);
                }
            });
            this.activeElements = {};
            const check = this.createActiveIcon();
            if (event.target.tagName == 'LI') {
                event.target.appendChild(check);
            }
            else {
                event.target.parentNode.appendChild(check);
            }
            this.activeElements[i] = { item: event.target, check };
            this.closeDropdown();
            this.setValueInputSingle();
        }
        if (this.outputFunction) {
            this.outputFunction(this.getCurrentActiveItems());
        }
    }
    /**
     * Controla marcado y desmarcado del check en el dropdown múltiple, dependiendo del estado de  (condition).
     * Sí una vez activado el evento el input no está checkeado, se checkea y se actualiza su estado del array activeElements.
     * @param {HTMLElement} inputInside
     * @param {boolean} condition
     * @param {Event} event
     * @param {Element} item
     * @param {number} i index del array de ítems activos
     * @memberof BcInputSelectBehavior
     */
    configInputCheck(inputInside, condition, event, item, i) {
        if (event.target.tagName === 'LI') {
            event.stopPropagation();
            inputInside.click();
            return;
        }
        if (!condition) {
            inputInside.setAttribute('checked', '' + condition);
            this.activeElements[i] = {
                item: item,
                check: null,
            };
        }
        else {
            inputInside.removeAttribute('checked');
            delete this.activeElements[i];
        }
    }
    /**
     * Registra el evento click al ítem y después lo configura mediante configSelectedEvent.
     * @memberof BcInputSelectBehavior
     */
    setEventListeners() {
        const addEvent = (item) => {
            item.addEventListener(BcCommonConstants.EVENT_CLICK, (event) => {
                this.inpValue = '';
                const dropdownItemsString = this.dropdownItems.map((x) => x.innerHTML);
                this.configSelectedEvent(event, dropdownItemsString.indexOf(item.innerHTML), item);
                if (this.isKeydown === true) {
                    this.itemsConfig = this.itemsConfigAux;
                    this.updateDropdown();
                    this.isKeydown = false;
                }
            });
        };
        this.openDropdownClickInput(this.input);
        for (const item of this.dropdownItems) {
            addEvent(item);
        }
    }
    /**
     * Setea el valor del ítem activo en el atributo value del input.
     * Valida los ítems activos en el array (activeElements) y asigna su valor según sea el tipo del dropdown: único o múltiple.
     * @memberof BcInputSelectBehavior
     */
    setValueInputMultiple() {
        let text = null;
        const keys = Object.keys(this.activeElements);
        if (keys.length > 1) {
            this.bcInputBehavior.addRemoveClass(true, this.mySelf.querySelector('input'));
            text = this.selectedItemsDisplay.replace('{0}', String(keys.length));
        }
        else if (keys.length == 1) {
            this.bcInputBehavior.addRemoveClass(true, this.mySelf.querySelector('input'));
            text = this.getValueInputSingle(parseInt(keys[0]));
        }
        else {
            this.bcInputBehavior.addRemoveClass(false, this.mySelf.querySelector('input'));
            text = '';
        }
        if (this.input) {
            this.input.value = text;
        }
    }
    /**
     * Setea el valor del ítem activo (indexItem) en el atributo value del input. Aplica solo para dropdown de tipo único.
     * @param {number} indexItem
     * @memberof BcInputSelectBehavior
     */
    setValueInputSingle(indexItem) {
        const text = this.getValueInputSingle(indexItem);
        if (this.input) {
            this.input.value = text;
        }
        this.bcInputBehavior.addRemoveClass(true, this.mySelf.querySelector('input'));
        return text;
    }
    getValueInputSingle(indexItem) {
        let index = 0;
        let item = null;
        if (indexItem) {
            index = indexItem;
            item = this.activeElements[String(index)];
        }
        else {
            for (const key in this.activeElements) {
                if (Object.prototype.hasOwnProperty.call(this.activeElements, key)) {
                    index = parseInt(key);
                    item = this.activeElements[key];
                }
            }
        }
        let text = '';
        if (this.config) {
            text = this.itemsConfig[index].label;
        }
        else {
            if (item) {
                const spanLabel = item.querySelector(BcCommonConstants.SPAN_TAG);
                const textLabel = spanLabel.innerText;
                text = textLabel;
            }
        }
        return text;
    }
    filter(input) {
        let selectArray = [];
        this.inpValue = '';
        let key = '';
        input.addEventListener('keydown', (event) => {
            const keyRegExp = /([a-zA-Z])\w+/;
            if (!keyRegExp.test(event.key)) {
                key += event.key.toLowerCase();
                this.inpValue = key;
            }
            if (event.key === 'Backspace') {
                key = key.slice(0, key.length - 1);
                this.inpValue = key;
            }
            if (this.inpValue && this.inpValue != '') {
                this.isKeydown = true;
                selectArray = this.itemsConfigAux.filter((x) => {
                    return x.label.toLowerCase().indexOf(this.inpValue.toLowerCase()) > -1;
                });
                selectArray.forEach((text) => {
                    text.aux = text.label;
                    text.label = text.label.replace(new RegExp(`(${this.inpValue})`, 'i'), '<strong>$1</strong>');
                });
                this.itemsConfig = selectArray;
                this.updateDropdown();
                this.openDrowndown();
            }
            else {
                selectArray = [];
                this.itemsConfig = this.itemsConfigAux;
                this.updateDropdown();
            }
        });
        this.openDropdownClickInput(input);
    }
    addItemSelectArray(itemsConfigAux, selectArray, inpValue) {
        itemsConfigAux.forEach((item) => {
            const itemLabel = item.label.toLowerCase();
            if (itemLabel.includes(inpValue)) {
                selectArray.push(item);
                this.itemsConfig = selectArray;
                selectArray = this.removeItemSelectArray(selectArray, inpValue);
                this.updateDropdown();
                this.openDrowndown();
            }
        });
        return selectArray;
    }
    removeItemSelectArray(selectArray, inpValue) {
        selectArray.find((element, index) => {
            if (element) {
                const elementLabel = element.label.toLowerCase();
                if (!elementLabel.includes(inpValue)) {
                    selectArray.splice(index, 1);
                }
            }
        });
        if (selectArray.length > 0) {
            selectArray.reduce((unique, item, index) => {
                if (item.label === unique.label) {
                    selectArray.splice(index, 1);
                }
            });
        }
        return selectArray;
    }
    updateDropdown() {
        this.closeDropdown();
        const mySelf = this.mySelf.querySelector(`*[id='${this.idContent}']`);
        if (!mySelf) {
            return;
        }
        for (const i of Array.from(mySelf.childNodes)) {
            mySelf.removeChild(i);
        }
        this.activeElements = {};
        this.dropdownItems = [];
        if (this.itemsConfig) {
            for (const itemObj of this.itemsConfig) {
                const index = this.itemsConfig.indexOf(itemObj);
                if (typeof itemObj != 'object') {
                    this.itemsConfig[index] = { label: itemObj, value: itemObj };
                }
                else {
                    this.itemsConfig[index] = itemObj;
                }
                this.createDropdownItem(index);
            }
        }
        this.setEventListeners();
    }
    createDropdownItem(index) {
        let li = null;
        if (this.isFilter) {
            if (this.isMultiple) {
                li = this.createItemTypeMultiple(this.itemsConfig[index]);
            }
            else {
                li = this.createItemTypeSingle(this.itemsConfig[index]);
            }
            this.itemsConfig[index].label = this.itemsConfig[index].aux
                ? this.itemsConfig[index].aux
                : this.itemsConfig[index].label;
        }
        if (!li) {
            return;
        }
        li.setAttribute('tabIndex', '0');
        this.dropdownItems = this.dropdownItems.concat(li);
        this.dropdownContent.appendChild(li);
    }
    setInputValue(value) {
        if (!this.mySelf) {
            return;
        }
        const empyString = value ? value : '';
        this.mySelf.querySelector('input').value = empyString;
    }
    addPaddingRightWhenIcon() {
        const input = this.mySelf.querySelector('input');
        input.nextElementSibling.nextElementSibling.classList.add(LABEL_ELIPSIS);
    }
    openDropdownKeyboard(element) {
        element.addEventListener('keyup', (event) => {
            if (event.code === BcCommonConstants.KEY_EVENT_ENTER_NUM ||
                event.code === BcCommonConstants.KEY_EVENT_SPACE_NUM) {
                this.openDrowndown();
            }
        });
    }
    openDropdownClickInput(input) {
        input.addEventListener('click', () => {
            setTimeout(() => {
                this.openDrowndown();
            }, COMMON_CONSTANTS_NUMBERS.N10);
        });
    }
    toggleFocus() {
        const toggle = document.querySelectorAll(`.${INPUT_SELECT_TOGGLE_CLASS}`);
        toggle.forEach((element) => {
            addFocusable(element, { tabindex: '0' });
            this.openDropdownKeyboard(element);
        });
    }
    initAccesibilityInput() {
        document
            .querySelectorAll(`input.${INPUT_SELECT_ITEM_CLASS}`)
            .forEach((element) => element.setAttribute('tabindex', '-1'));
        document.querySelectorAll('span.bc-checkbox').forEach((element) => {
            addFocusable(element, { tabindex: '0' });
            this.addClickEvent(element, element.previousSibling);
        });
        document.querySelectorAll(`li.${INPUT_SELECT_ITEM_CLASS}`).forEach((element) => {
            addFocusable(element, { tabindex: '0' });
            this.addClickEvent(element, element);
        });
    }
    addClickEvent(element, clickeableElement) {
        element.addEventListener('keydown', (event) => {
            if (event.code == BcCommonConstants.KEY_EVENT_SPACE || event.key == BcCommonConstants.KEY_EVENT_ENTER) {
                event.preventDefault();
                event.stopPropagation();
                clickeableElement.click();
            }
        });
    }
    closeEsc() {
        const input = this.mySelf.querySelector('input');
        this.mySelf.addEventListener(BcCommonConstants.EVENT_KEY_UP, (event) => {
            if (event.code === BcCommonConstants.KEY_EVENT_ESCAPE) {
                this.inpValue = '';
                input.value = '';
                input.dispatchEvent(new KeyboardEvent(BcCommonConstants.EVENT_KEY_DOWN, { key: '' }));
                this.closeDropdown();
            }
        });
    }
    focusFirstLastItem() {
        const firstItem = this.dropdownItems[0];
        const lastItem = this.dropdownItems[this.dropdownItems.length - 1];
        this.mySelf.addEventListener(BcCommonConstants.EVENT_KEY_DOWN, (event) => {
            if (event.code === BcCommonConstants.KEY_EVENT_HOME) {
                this.openDrowndown();
                setTimeout(() => {
                    lastItem.focus();
                }, COMMON_CONSTANTS_NUMBERS.N100);
            }
            else if (event.code === BcCommonConstants.KEY_EVENT_END) {
                this.openDrowndown();
                setTimeout(() => {
                    firstItem.focus();
                }, COMMON_CONSTANTS_NUMBERS.N100);
            }
        });
    }
    itemsArrow() {
        const firstItem = this.dropdownItems[0];
        const lastItem = this.dropdownItems[this.dropdownItems.length - 1];
        this.dropdownItems.forEach((element, index) => {
            element.addEventListener(BcCommonConstants.EVENT_KEY_DOWN, (event) => {
                if (event.code === BcCommonConstants.KEY_EVENT_ARROW_DOWN) {
                    if (index == this.dropdownItems.length - 1) {
                        firstItem.focus();
                    }
                    else {
                        element.nextElementSibling.focus();
                    }
                }
                else if (event.code === BcCommonConstants.KEY_EVENT_ARROW_UP) {
                    if (index == 0) {
                        lastItem.focus();
                    }
                    else {
                        element.previousElementSibling.focus();
                    }
                }
            });
        });
    }
}

const ACCORDIONS_GROUPS_SUFIX = `${BcCommonConstants.PREFIX_LIB}-accordions-group`;
const ACCORDION_CLASS = `${BcCommonConstants.PREFIX_LIB}-accordion`;
const ACCORDION_SINGLE_CLASS = `${BcCommonConstants.PREFIX_LIB}-single`;
const ACCORDION_TOGGLE_BTN_CLASS = `${BcCommonConstants.PREFIX_LIB}-toggle-button`;
const ACCORDION_ACTIVE_CLASS = `${BcCommonConstants.PREFIX_LIB}-active`;
const ACCORDION_COLUMNS_CLASS = `${BcCommonConstants.PREFIX_LIB}-accordion-column`;
const ACCORDION_COLUMNS_CONTAINER_CLASS = `${BcCommonConstants.PREFIX_LIB}-accordion-columns-container`;
const ACCORDION_TEXT_CONTAINER_CLASS = `${BcCommonConstants.PREFIX_LIB}-accordion-text-container`;
const ACCORDION_HEADER_RIGHT_CLASS = `${BcCommonConstants.PREFIX_LIB}-accordion-header-right`;
const ACCORDION_HEADER_LEFT_CLASS = `${BcCommonConstants.PREFIX_LIB}-accordion-header-left`;
const ACCORDION_ACTION_CONTAINER_CLASS = `${BcCommonConstants.PREFIX_LIB}-accordion-action-container`;
const ACCORDION_CONTENT_CLASS = `${BcCommonConstants.PREFIX_LIB}-accordion-content`;
const ACCORDION_LABEL = `${BcCommonConstants.PREFIX_LIB}-accordion-label`;
const ACCORDION_HEADER = `header`;
const ACCORDION_ARTICLE_HEADER = `article`;

const BC_TOOLTIP_SELECTOR = `${BcCommonConstants.PREFIX_LIB}-tooltip`;
const BC_TOOLTIP_CONTAINER_SELECTOR = `${BcCommonConstants.PREFIX_LIB}-tooltip-container`;
const BC_TOOLTIP_TEXT_ATTRIBUTE = `${BcCommonConstants.PREFIX_LIB}TooltipText`;
const BC_TOOLTIP_TITLE_ATTRIBUTE = `${BcCommonConstants.PREFIX_LIB}TooltipTitle`;
const BC_TOOLTIP_BUTTON_TEXT_ATTRIBUTE = `${BcCommonConstants.PREFIX_LIB}TooltipButtonText`;
const BC_TOOLTIP_POSITION_ATTRIBUTE = `${BcCommonConstants.PREFIX_LIB}TooltipPosition`;
const BC_TOOLTIP_ARROW_CLASS = `${BcCommonConstants.PREFIX_LIB}-tooltip-arrow`;
const BC_TOOLTIP_DIVIDER_CLASS = `${BcCommonConstants.PREFIX_LIB}-tooltip-arrow`;
const BC_TOOLTIP_BUTTON_CLOSE_CLASS = `${BcCommonConstants.PREFIX_LIB}-tooltip-close-btn`;
const BC_TOOLTIP_BUTTON_CLASS = `${BcCommonConstants.PREFIX_LIB}-button`;
const BC_TOOLTIP_BUTTON_CLASS_TYPE = `${BcCommonConstants.PREFIX_LIB}-button-secondary`;
const BC_TOOLTIP_PARENT_ELEMENT_CLASS = `${BcCommonConstants.PREFIX_LIB}TooltipParentElement`;
const BC_TOOLTIP_BUTTON_TOP = `top`;
const BC_TOOLTIP_BUTTON_RIGHT = `right`;
const BC_TOOLTIP_BUTTON_BOTTOM = `bottom`;
const BC_TOOLTIP_BUTTON_LEFT = `left`;
const BC_TOOLTIP_EIGHT = 8;
const BC_TOOLTIP_TWO = 2;

class BcAccordionBehavior extends BcDefaultBehavior {
    /**
     * Creates an instance of BcAccordionBehavior.
     * @memberof BcAccordionBehavior
     */
    constructor() {
        super();
        this.headerList = [];
        this.closeButtons = [];
    }
    /**
     * Configura todos los elementos en el DOM que posean la clase a la cual hace referencia un Tab.
     * @description Llama el metodo de configuración del objeto del tipo en cuestión. Por tanto este método debe estár implementado
     * en la clase.
     * @returns Listado de elementos de ese tipo en el DOM.
     */
    static setUpAll() {
        const accordionsGroup = Array.from(document.querySelectorAll(`div[class~='${ACCORDIONS_GROUPS_SUFIX}']`));
        const elements = [];
        for (const element of accordionsGroup) {
            const bcAccordionsBehavior = new BcAccordionBehavior();
            bcAccordionsBehavior.setElement(element);
            bcAccordionsBehavior.setUp();
            elements.push(bcAccordionsBehavior);
        }
        return elements;
    }
    /**
     * Realiza toda la configuración del objeto.
     * @returns
     */
    _setUp() {
        this.headerList = [];
        this.getAccordionsGroup();
        const accordionList = this.getAccordions();
        let i = 0;
        for (const accordion of accordionList) {
            this.setTabIndexIcon(accordion);
            this.addExpandEvent(accordion, i);
            this.setAccessibility();
            i++;
        }
    }
    /**
     * Se obtiene el elemento header de la acordeón
     * @param accordion Accordeón seleccionado
     * @returns Elemento header del DOM
     * @memberof BcAccordionBehavior
     */
    getHeader(accordion) {
        return accordion.querySelector(ACCORDION_HEADER);
    }
    /**
     * Se obtiene el elemento section referente al contenido del acordeón
     * @param accordion Accordeón seleccionado
     * @returns Elemento section del DOM
     * @memberof BcAccordionBehavior
     */
    getContent(accordion) {
        return accordion.querySelector(`section.${ACCORDION_CONTENT_CLASS}`);
    }
    /**
     * Se obtiene el tooltip referente al header del acordeón
     * @param accordion Accordeón seleccionado
     * @returns Elemento section del DOM
     * @memberof BcAccordionBehavior
     */
    setLabelTooltipText(accordion) {
        const tooltipText = accordion.querySelectorAll(`.${BC_TOOLTIP_SELECTOR}`);
        tooltipText.forEach((element) => {
            if (tooltipText != null) {
                addFocusable(element, { tabindex: '0' });
                const attributte = element.getAttribute('bctooltiptext');
                element.setAttribute('aria-label', attributte);
            }
        });
    }
    /**
     * Se obtiene y agrega tabindex a los iconos del acordeón
     * @param accordion Accordeón seleccionado
     * @memberof BcAccordionBehavior
     */
    setTabIndexIcon(accordion) {
        const header = this.getHeader(accordion);
        const iconsFromHeaderLeft = Array.from(header.querySelectorAll(`[class~='${ACCORDION_HEADER_LEFT_CLASS}'] .${ACCORDION_TEXT_CONTAINER_CLASS} .${BcCommonConstants.ICONS_CLASS}`));
        const iconsFromHeaderRight = Array.from(header.querySelectorAll(`[class~='${ACCORDION_HEADER_RIGHT_CLASS}'] .${ACCORDION_ACTION_CONTAINER_CLASS} .${BcCommonConstants.ICONS_CLASS}`));
        const labelFromHeaderRight = Array.from(header.querySelectorAll(`[class~='${ACCORDION_HEADER_RIGHT_CLASS}'] .${ACCORDION_LABEL}`));
        const columnsFromHeaderRight = Array.from(header.querySelectorAll(`[class~='${ACCORDION_HEADER_RIGHT_CLASS}'] .${ACCORDION_COLUMNS_CONTAINER_CLASS} .${ACCORDION_COLUMNS_CLASS}`));
        const focusableElements = [...iconsFromHeaderRight, ...labelFromHeaderRight, ...columnsFromHeaderRight];
        iconsFromHeaderLeft.concat(focusableElements).forEach((element) => {
            addFocusable(element, { tabindex: '0' });
        });
    }
    /**
     * Se obtienen todos los grupos de acordeones es en DOM
     * @returns  Listado de elementos de ese tipo en el DOM.
     * @memberof BcAccordionBehavior
     */
    getAccordionsGroup() {
        const accordionsGroup = Array.from(document.querySelectorAll(`div[class~='${ACCORDIONS_GROUPS_SUFIX}']`));
        for (const accordion of accordionsGroup) {
            addFocusable(accordion, { role: 'group', tabindex: '-1' });
        }
        return accordionsGroup;
    }
    /**
     * Se obtienen las acordeones dentro el grupo
     * @returns Listado de elementos de ese tipo en el DOM.
     * @memberof BcAccordionBehavior
     */
    getAccordions() {
        return Array.from(this.mySelf.querySelectorAll(`:scope > article[class~='${ACCORDION_CLASS}'],:scope >*>*> article[class~='${ACCORDION_CLASS}']`));
    }
    /**
     * Permite expandir el conetido de la acordeón agregando la clase 'active'
     * y removiendo las clase 'active' de las demás acordeones para asi abrir una a la vez
     * @param accordion Acordeón a expandir
     * @memberof BcAccordionBehavior
     */
    addExpandEvent(accordion, index) {
        if (accordion != null) {
            const content = this.getContent(accordion);
            const header = this.getHeader(accordion);
            this.setLabelTooltipText(accordion);
            const expand = () => {
                const accordionsGroup = accordion.closest(`.${ACCORDIONS_GROUPS_SUFIX}`);
                const isSingle = accordionsGroup.classList.contains(`${ACCORDION_SINGLE_CLASS}`);
                const accordions = Array.from(accordionsGroup.querySelectorAll(`:scope > [class~='${ACCORDION_CLASS}']`));
                for (const element of accordions) {
                    if (element !== accordion && isSingle) {
                        element.classList.remove(`${ACCORDION_ACTIVE_CLASS}`);
                    }
                }
                const isIdMatched = accordion.id === header.getAttribute('aria-controls');
                if (isIdMatched) {
                    const isPresent = accordion.classList.toggle(`${ACCORDION_ACTIVE_CLASS}`);
                    if (isPresent && this.activeFunction) {
                        this.activeFunction(index);
                    }
                    header.setAttribute('aria-expanded', String(isPresent));
                    content.setAttribute('tabindex', isPresent ? '0' : '-1');
                }
            };
            const btnClose = header.querySelector(`.${ACCORDION_TOGGLE_BTN_CLASS}`);
            if (header !== null && !this.closeButtons.includes(btnClose)) {
                btnClose.addEventListener(BcCommonConstants.EVENT_CLICK, expand);
                this.closeButtons.push(btnClose);
                header.addEventListener(BcCommonConstants.EVENT_CLICK, function (event) {
                    const currentEvnt = event.target;
                    if (!currentEvnt.classList.contains(BcCommonConstants.ICONS_CLASS)) {
                        expand();
                    }
                });
            }
            const expandedValue = header.classList.contains(ACCORDION_ACTIVE_CLASS);
            addFocusable(header, { expanded: String(expandedValue), level: '1', tabindex: '0' }, { event: expand });
        }
    }
    /**
     * Metodo que permite obtener el current accordion
     * @param {number} index
     * @memberof BcAccordionBehavior
     */
    getCurrentElement(index) {
        return this.mySelf.querySelectorAll(ACCORDION_HEADER)[index];
    }
    /**
    * Metodo que permite obtener la columna actual
    * @param {number} index
    * @memberof BcAccordionBehavior
    */
    getCurrentColumn(index) {
        return this.mySelf.querySelectorAll(`[class~='${ACCORDION_HEADER_RIGHT_CLASS}'] .${ACCORDION_COLUMNS_CONTAINER_CLASS} .${ACCORDION_COLUMNS_CLASS}`)[index];
    }
    /**
* Metodo que permite obtener la columna actual
* @param {number} index
* @memberof BcAccordionBehavior
*/
    getCurrentLabel(index) {
        return this.mySelf.querySelectorAll(`[class~='${ACCORDION_HEADER_RIGHT_CLASS}'] .${ACCORDION_LABEL}`)[index];
    }
    /**
     * Accesibilidad de foco y soporte por teclado.
     * @memberof BcAccordionBehavior
     */
    setAccessibility() {
        this.mySelf.querySelectorAll(ACCORDION_HEADER).forEach((element, index) => {
            this.addScreenReader(element, index);
        });
        this.mySelf.querySelectorAll(`[class~='${ACCORDION_HEADER_RIGHT_CLASS}'] .${ACCORDION_COLUMNS_CONTAINER_CLASS} .${ACCORDION_COLUMNS_CLASS}`).forEach((element, index) => {
            this.addScreenReaderArrows(element, index);
        });
        this.mySelf.querySelectorAll(`[class~='${ACCORDION_HEADER_LEFT_CLASS}'] .${'bc-tooltip'}`).forEach((element, index) => {
            this.addScreenReaderLabel(element, index);
        });
    }
    /**
     * Verifica que tecla ha sido activada por el usuario en el componente
     * @param {number} index
     * @memberof BcAccordionBehavior
     */
    addScreenReader(element, index) {
        element.addEventListener(BcCommonConstants.EVENT_KEY_UP, (event) => {
            if (event.key === BcCommonConstants.KEY_EVENT_ARROW_DOWN) {
                this.focusNext(index);
            }
            else if (event.key === BcCommonConstants.KEY_EVENT_ARROW_UP) {
                this.focusBack(index);
            }
            else if (event.key === BcCommonConstants.KEY_EVENT_HOME) {
                this.focusHomeEnd(index, true);
            }
            else if (event.key === BcCommonConstants.KEY_EVENT_ARROW_RIGHT) {
                this.focusColumns(index);
            }
            else if (event.key === BcCommonConstants.KEY_EVENT_END) {
                this.focusHomeEnd(index);
            }
        });
    }
    /**
   * Verifica que tecla ha sido activada por el usuario en el componente para dar foco a los label de los header
   * @param {number} index
   * @memberof BcAccordionBehavior
   */
    addScreenReaderLabel(element, index) {
        element.addEventListener(BcCommonConstants.EVENT_KEY_UP, (event) => {
            if (event.key === BcCommonConstants.KEY_EVENT_ARROW_RIGHT) {
                this.focusLabel(index);
            }
        });
    }
    /**
    * Verifica que tecla ha sido activada por el usuario en el componente y cambia el foco en los headers que tengan columnas
    * @param {number} index
    * @memberof BcAccordionBehavior
    */
    addScreenReaderArrows(element, index) {
        element.addEventListener(BcCommonConstants.EVENT_KEY_UP, (event) => {
            if (event.key === BcCommonConstants.KEY_EVENT_ARROW_RIGHT) {
                this.focusRight(index);
                event.stopPropagation();
            }
            else if (event.key === BcCommonConstants.KEY_EVENT_ARROW_LEFT) {
                this.focusLeft(index);
            }
        });
    }
    /**
     * Metodo que permite enfocar el ultimo y el primer header de cada accordeon
     * @param {number} index
     * @memberof BcAccordionBehavior
     */
    focusHomeEnd(index, key = false) {
        const header = this.mySelf.querySelectorAll(ACCORDION_HEADER);
        if (this.getCurrentElement(index) !== null) {
            this.getCurrentElement(index).classList.remove(BcCommonConstants.OUTLINE_ELEMENT);
            if (key) {
                index = 0;
            }
            else {
                index = header.length - 1;
            }
            this.getCurrentElement(index).classList.add(BcCommonConstants.OUTLINE_ELEMENT);
            this.getCurrentElement(index).focus();
        }
    }
    /**
     * Metodo que permite enfocar el siguiente acordeon en el que se encuentra situado el tab
     * @param {number} index
     * @memberof BcAccordionBehavior
     */
    focusNext(index) {
        const header = this.mySelf.querySelectorAll(ACCORDION_HEADER);
        if (this.getCurrentElement(index) !== null) {
            this.getCurrentElement(index).classList.remove(BcCommonConstants.OUTLINE_ELEMENT);
            if (index < header.length - 1) {
                index++;
            }
            else {
                index = 0;
            }
            this.getCurrentElement(index).classList.add(BcCommonConstants.OUTLINE_ELEMENT);
            this.getCurrentElement(index).focus();
        }
    }
    /**
     * Metodo que permite enfocar el anterior acordeon en el que se encuentra situado el tab
     * @param {number} index
     * @memberof BcAccordionBehavior
     */
    focusBack(index) {
        const header = this.mySelf.querySelectorAll(ACCORDION_HEADER);
        if (this.getCurrentElement(index) !== null) {
            this.getCurrentElement(index).classList.remove(BcCommonConstants.OUTLINE_ELEMENT);
            if (index > 0) {
                index--;
            }
            else {
                index = header.length - 1;
            }
            this.getCurrentElement(index).classList.add(BcCommonConstants.OUTLINE_ELEMENT);
            this.getCurrentElement(index).focus();
        }
    }
    /**
     * Metodo que permite enfocar la siguiente columna del acordeon datos en columnas en el que se encuentra situado el tab
     * @param {number} index
     * @memberof BcAccordionBehavior
     */
    focusRight(index) {
        const column = this.mySelf.querySelectorAll(`[class~='${ACCORDION_HEADER_RIGHT_CLASS}'] .${ACCORDION_COLUMNS_CONTAINER_CLASS} .${ACCORDION_COLUMNS_CLASS}`);
        if (this.getCurrentColumn(index) !== null) {
            this.getCurrentColumn(index).classList.remove(BcCommonConstants.OUTLINE_ELEMENT);
            if (index < column.length - 1) {
                index++;
            }
            this.getCurrentColumn(index).classList.add(BcCommonConstants.OUTLINE_ELEMENT);
            this.getCurrentColumn(index).focus();
        }
    }
    /**
    * Metodo que permite enfocar los label de los acordeones que lo posean al presionar arrowRight
    * @param {number} index
    * @memberof BcAccordionBehavior
    */
    focusLabel(index) {
        const label = this.mySelf.querySelectorAll(`[class~='${ACCORDION_HEADER_RIGHT_CLASS}'] .${ACCORDION_LABEL}`);
        if (label.length - 1 === index) {
            this.mySelf.querySelectorAll(`[class~='${ACCORDION_HEADER_LEFT_CLASS}'] .${'bc-tooltip'}`)[index].classList.remove(BcCommonConstants.OUTLINE_ELEMENT);
            this.getCurrentLabel(index).classList.add(BcCommonConstants.OUTLINE_ELEMENT);
            this.getCurrentLabel(index).focus();
        }
    }
    /**
    * Metodo que permite enfocar el primer elemento de las columnas del acordeon datos en columnas al presionar arrowRight
    * @param {number} index
    * @memberof BcAccordionBehavior
    */
    focusColumns(index) {
        const currentHeader = this.getCurrentElement(index).querySelectorAll(`[class~='${ACCORDION_HEADER_RIGHT_CLASS}'] .${ACCORDION_COLUMNS_CONTAINER_CLASS} .${ACCORDION_COLUMNS_CLASS}`);
        if (currentHeader.length) {
            this.getCurrentElement(index).classList.remove(BcCommonConstants.OUTLINE_ELEMENT);
            this.getCurrentElement(index).querySelector(`[class~='${ACCORDION_HEADER_RIGHT_CLASS}'] .${ACCORDION_COLUMNS_CONTAINER_CLASS} .${ACCORDION_COLUMNS_CLASS}`).classList.add(BcCommonConstants.OUTLINE_ELEMENT);
            this.getCurrentElement(index).querySelector(`[class~='${ACCORDION_HEADER_RIGHT_CLASS}'] .${ACCORDION_COLUMNS_CONTAINER_CLASS} .${ACCORDION_COLUMNS_CLASS}`).focus();
        }
    }
    /**
     * Metodo que permite enfocar la anterior columna del acordeon datos en columnas en el que se encuentra situado el tab
     * @param {number} index
     * @memberof BcAccordionBehavior
     */
    focusLeft(index) {
        const column = this.mySelf.querySelectorAll(`[class~='${ACCORDION_HEADER_RIGHT_CLASS}'] .${ACCORDION_COLUMNS_CONTAINER_CLASS} .${ACCORDION_COLUMNS_CLASS}`);
        if (this.getCurrentColumn(index) !== null) {
            this.getCurrentColumn(index).classList.remove(BcCommonConstants.OUTLINE_ELEMENT);
            if (index > 0) {
                index--;
            }
            this.getCurrentColumn(index).classList.add(BcCommonConstants.OUTLINE_ELEMENT);
            this.getCurrentColumn(index).focus();
        }
    }
}

/**
 * Tooltip
 * @example
 * <span class="bc-tooltip">tooltip</span>
 */
class BcTooltipBehavior extends BcDefaultBehavior {
    constructor() {
        super(...arguments);
        this.margin = BC_TOOLTIP_EIGHT;
    }
    /**
     * Configura todos los elementos en el DOM que posean
     * la clase a la cual hace referencia un Tooltip.
     * @description Llama la configuración del objeto del tipo en cuestión.
     * Por tanto debe estár implementado
     * en la clase.
     * @returns Listado de elementos de ese tipo en el DOM.
     * @memberof BcTooltipBehavior
     */
    static setUpAll() {
        const tooltipElements = Array.from(document.querySelectorAll(`.${BC_TOOLTIP_SELECTOR}`));
        const elements = [];
        for (const element of tooltipElements) {
            const bcTooltipBehavior = new BcTooltipBehavior();
            bcTooltipBehavior.setElement(element);
            bcTooltipBehavior.setUp();
            elements.push(bcTooltipBehavior);
        }
        return elements;
    }
    /**
     * Realiza toda la configuración inicial del objeto.
     * @memberof BcTooltipBehavior
     */
    _setUp() {
        this.buildView();
        this.addListeners();
    }
    buildView() {
        const innerText = this.mySelf.getAttribute(BC_TOOLTIP_TEXT_ATTRIBUTE);
        const innerTitle = this.mySelf.getAttribute(BC_TOOLTIP_TITLE_ATTRIBUTE);
        const buttonText = this.mySelf.getAttribute(BC_TOOLTIP_BUTTON_TEXT_ATTRIBUTE);
        this.parentELementClass = this.mySelf.getAttribute(BC_TOOLTIP_PARENT_ELEMENT_CLASS);
        this.position = this.mySelf.getAttribute(BC_TOOLTIP_POSITION_ATTRIBUTE);
        this.classNameWithId = `${BC_TOOLTIP_CONTAINER_SELECTOR}--${BcTooltipBehavior.ID}`;
        BcTooltipBehavior.ID++;
        this.mySelf.setAttribute('tabindex', '0');
        this.tooltipElement = this.createElement('div', 'class', `${BC_TOOLTIP_CONTAINER_SELECTOR} ${this.classNameWithId}`);
        this.arrowElement = this.createElement('div', 'class', BC_TOOLTIP_ARROW_CLASS);
        const text = this.createElementWithText('p', innerText ? innerText : '');
        addFocusable(text);
        this.position = this.position ? this.position.toLowerCase() : 'top';
        this.arrowElement.classList.add(this.arrowElement.classList.item(0) + '--' + this.position);
        this.setElementTitle(innerTitle);
        this.tooltipElement.appendChild(text);
        this.tooltipElement.appendChild(this.arrowElement);
        this.setElementButton(buttonText);
        document.body.appendChild(this.tooltipElement);
        if (isMobileDevice()) {
            this.tooltipElement.classList.add(BC_TOOLTIP_BUTTON_CLOSE_CLASS);
        }
    }
    setElementButton(buttonText) {
        if (buttonText != null && buttonText !== 'undefined') {
            const button = this.createElementWithText('button', buttonText ? buttonText : '');
            button.classList.add(BC_TOOLTIP_BUTTON_CLASS_TYPE);
            button.classList.add(`${BC_TOOLTIP_SELECTOR}-button`);
            button.setAttribute(BC_TOOLTIP_BUTTON_CLASS, '');
            button.setAttribute('typeButton', 'secondary');
            button.addEventListener(BcCommonConstants.EVENT_CLICK, () => {
                this.hideTooltip();
                this.buttonClickCallback();
            });
            addFocusable(button);
            this.tooltipElement.appendChild(button);
        }
    }
    setElementTitle(innerTitle) {
        if (innerTitle != null && innerTitle !== 'undefined') {
            const title = this.createElementWithText('h5', innerTitle ? innerTitle : '');
            this.tooltipElement.appendChild(title);
            this.tooltipElement.appendChild(this.createElement('hr', 'class', BC_TOOLTIP_DIVIDER_CLASS));
            addFocusable(title);
        }
    }
    showTooltip() {
        this.fadeIn(this.mySelf, null, this.tooltipElement, false);
    }
    hideTooltip() {
        this.fadeOut(this.mySelf, null, this.tooltipElement, false);
    }
    addListeners() {
        this.fadeIn(this.mySelf, BcCommonConstants.EVENT_MOUSEENTER, this.tooltipElement, false);
        this.fadeIn(this.mySelf, BcCommonConstants.EVENT_FOCUS, this.tooltipElement, false);
        this.fadeOut(this.mySelf, BcCommonConstants.EVENT_MOUSEOUT, this.tooltipElement, false);
        this.fadeOut(this.mySelf, BcCommonConstants.EVENT_BLUR, this.tooltipElement, false);
        window.addEventListener('resize', () => {
            this.setPosition();
        });
        document.addEventListener('scroll', () => {
            this.setPosition();
        });
        if (this.parentELementClass != null && this.parentELementClass !== 'undefined') {
            const parentElement = document.querySelector(`div[class~='${this.parentELementClass}']`);
            parentElement
                .addEventListener('scroll', () => {
                this.setPosition();
            });
            parentElement
                .addEventListener('resize', () => {
                this.setPosition();
            });
        }
    }
    /**
     *Agrega la funcion callback
      que se ejecutara al presionar el boton
     * @memberof BcTooltipBehavior
    */
    buttonClick(callback) {
        this.buttonClickCallback = callback;
    }
    /**
     *Evalua la posición que tendrá el tooltip
     * @memberof BcTooltipBehavior
     */
    setPosition() {
        const self = this.mySelf;
        switch (this.position) {
            case BC_TOOLTIP_BUTTON_BOTTOM: {
                this.bottomTooltip(self, this.arrowElement, this.tooltipElement);
                break;
            }
            case BC_TOOLTIP_BUTTON_RIGHT: {
                this.rightTooltip(self, this.arrowElement, this.tooltipElement);
                break;
            }
            case BC_TOOLTIP_BUTTON_LEFT: {
                this.leftTooltip(self, this.arrowElement, this.tooltipElement);
                break;
            }
            default: {
                this.topTooltip(self, this.arrowElement, this.tooltipElement);
                break;
            }
        }
    }
    /**
     * Permite crear un elemento con atributos
     * @param tag: etiqueta que tendrá el elemento
     * @param tagAttribute: nombre del atributo
     * @param tagAttributeValue valor del atributo
     * @return HTMLElement: elemento creado
     * @memberof BcTooltipBehavior
     */
    createElement(tag, tagAttribute, tagAttributeValue) {
        const el = document.createElement(tag);
        el.setAttribute(tagAttribute, tagAttributeValue);
        return el;
    }
    /**
     * Permite crear un elemento con text
     * @param tag: etiqueta que tendrá el elemento
     * @param text: text del elemento
     * @return HTMLElement: elemento creado
     * @memberof BcTooltipBehavior
     */
    createElementWithText(tag, text) {
        const el = document.createElement(tag);
        el.innerText = text;
        return el;
    }
    /**
     * Posiciona el Tooltip arriba
     * @param target: Elemento que contiene el Tooltip
     * @param arrow: Flecha que apunta hacia el elemento que contiene el tooltip
     * @param tooltip: Tooltip
     * @memberof BcTooltipBehavior
     */
    topTooltip(target, arrow, tooltip) {
        this.changeArrowClass(arrow, tooltip, 'top');
        const posX = this.fixPosXIfElementIsOutScreen(target, tooltip, arrow);
        this.setElementPosition(tooltip, this.offset(target).top -
            tooltip.offsetHeight -
            arrow.offsetHeight -
            this.margin, posX.tooltip);
        this.setElementPosition(arrow, tooltip.offsetHeight, posX.arrow);
    }
    /**
     * Se retorna la posición en X y Y
     * @param el: Elemento
     * @return top y lef son las posiciones del elemento enviado (incluye scroll de la pantalla)
     * @memberof BcTooltipBehavior
     */
    offset(el) {
        const rect = el.getBoundingClientRect(), scrollLeft = window.pageXOffset || document.documentElement.scrollLeft, scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        return { top: rect.top + scrollTop, left: rect.left + scrollLeft };
    }
    /**
     * Posiciona el Tooltip abajo
     * @param target: Elemento que contiene el Tooltip
     * @param arrow: Flecha que apunta hacia el elemento que contiene el tooltip
     * @param tooltip: Tooltip
     * @memberof BcTooltipBehavior
     */
    bottomTooltip(target, arrow, tooltip) {
        const posX = this.fixPosXIfElementIsOutScreen(target, tooltip, arrow);
        this.setElementPosition(tooltip, this.offset(target).top +
            target.offsetHeight +
            arrow.offsetHeight +
            this.margin, posX.tooltip);
        this.setElementPosition(arrow, -arrow.offsetHeight, posX.arrow);
    }
    /**
     * Posiciona el Tooltip a la derecha
     * @param target: Elemento que contiene el Tooltip
     * @param arrow: Flecha que apunta hacia el elemento que contiene el tooltip
     * @param tooltip: Tooltip
     * @memberof BcTooltipBehavior
     */
    rightTooltip(target, arrow, tooltip) {
        const posXTooltip = this.offset(target).left +
            target.offsetWidth +
            arrow.offsetWidth +
            this.margin;
        const posY = this.centerToTarget(target, tooltip, arrow, true);
        if (posXTooltip + tooltip.offsetWidth >= document.body.offsetWidth) {
            this.topTooltip(target, arrow, tooltip);
        }
        else {
            this.changeArrowClass(arrow, tooltip, 'right');
            this.setElementPosition(tooltip, posY.tooltip, posXTooltip);
            this.setElementPosition(arrow, posY.arrow, -arrow.offsetWidth);
        }
    }
    /**
     * Posiciona el Tooltip a la Izquierda
     * @param target: Elemento que contiene el Tooltip
     * @param arrow: Flecha que apunta hacia el elemento que contiene el tooltip
     * @param tooltip: Tooltip
     * @memberof BcTooltipBehavior
     */
    leftTooltip(target, arrow, tooltip) {
        const posXTooltip = this.offset(target).left -
            tooltip.offsetWidth -
            arrow.offsetWidth -
            this.margin;
        const posY = this.centerToTarget(target, tooltip, arrow, true);
        if (posXTooltip <= 0) {
            this.topTooltip(target, arrow, tooltip);
        }
        else {
            this.changeArrowClass(arrow, tooltip, 'left');
            this.setElementPosition(tooltip, posY.tooltip, posXTooltip);
            this.setElementPosition(arrow, posY.arrow, tooltip.offsetWidth);
        }
    }
    /**
     * Muestra el Tooltip en la pantalla.
     * @param elementFocusable
     * @param eventName: nombre del evento que se va a agregar ejemplo: "focus"
     * @param tooltip: Tooltip
     * @param options: especifica características sobre el detector de eventos
     * @memberof BcTooltipBehavior
     */
    fadeIn(elementFocusable, eventName, tooltip, options) {
        if (!eventName) {
            this.setPosition();
            return 'fade-in-opacity 100ms forwards';
        }
        elementFocusable.addEventListener(eventName, () => {
            this.setPosition();
            tooltip.style.animation = 'fade-in-opacity 100ms forwards';
        }, options);
    }
    /**
     * Desaparece el Tooltip de la pantalla.
     * @param elementFocusable
     * @param eventName: nombre del evento que se va a agregar ejemplo: "focus"
     * @param tooltip: Tooltip
     * @param options: especifica características sobre el detector de eventos
     * @memberof BcTooltipBehavior
     */
    fadeOut(elementFocusable, eventName, tooltip, options) {
        if (!eventName) {
            return 'fade-out-opacity 100ms forwards';
        }
        elementFocusable.addEventListener(eventName, () => {
            tooltip.style.animation = 'fade-out-opacity 100ms forwards';
        }, options);
    }
    /**
     * Posiciona cualquier elemento que tenga una posición absoluta
     * @param element: Elemento que quiero mover
     * @param top: Posición en el eje Y
     * @param left: Posición en el eje X
     * @memberof BcTooltipBehavior
     */
    setElementPosition(element, top, left) {
        element.style.top = top + 'px';
        element.style.left = left + 'px';
    }
    /**
     * Centra el Tooltip al target
     * @param target: Elemento que contiene el Tooltip
     * @param tooltip: Tooltip
     * @param arrow: Flecha que apunta hacia el elemento que contiene el tooltip
     * @param isBeside: si es verdadero indica si está a la izquierda o a la derecha, si es false está arriba o abajo
     * @return posición centrada del tooltip y de la flecha
     * @memberof BcTooltipBehavior
     */
    centerToTarget(target, tooltip, arrow, isBeside) {
        const offsetEdge = isBeside
            ? this.offset(target).top
            : this.offset(target).left;
        const offsetLength = isBeside ? 'offsetHeight' : 'offsetWidth';
        const edgeTooltip = offsetEdge - tooltip[offsetLength] / BC_TOOLTIP_TWO + target[offsetLength] / BC_TOOLTIP_TWO;
        const edgeArrow = tooltip[offsetLength] / BC_TOOLTIP_TWO - arrow[offsetLength] / BC_TOOLTIP_TWO;
        return { tooltip: edgeTooltip, arrow: edgeArrow };
    }
    /**
     * cambia el diseño de la flecha que señala al elemento que contiene el tooltip, (top, bottom, right, left)
     * @param arrow: Flecha que apunta hacia el elemento que contiene el tooltip
     * @param tooltip: Tooltip
     * @param position: Posición del tooltip (top, bottom, right, left)
     * @memberof BcTooltipBehavior
     */
    changeArrowClass(arrow, tooltip, position) {
        tooltip.removeChild(arrow);
        arrow.classList.remove(arrow.classList.item(1));
        arrow.classList.add(arrow.classList.item(0) + '--' + position);
        tooltip.appendChild(arrow);
    }
    /**
     * Posiciona los elementos arriba si el tooltip está por fuera de la pantalla (Horizontal)
     * @param target: Elemento que contiene el Tooltip
     * @param tooltip: Tooltip
     * @param arrow: Flecha que apunta hacia el elemento que contiene el tooltip
     * @return posX: posición en X del Tooltip
     * @memberof BcTooltipBehavior
     */
    fixPosXIfElementIsOutScreen(target, tooltip, arrow) {
        const posX = this.centerToTarget(target, tooltip, arrow, false);
        if (posX.tooltip + tooltip.offsetWidth >= document.body.offsetWidth) {
            posX.tooltip =
                this.offset(target).left + target.offsetWidth - tooltip.offsetWidth;
            posX.arrow =
                tooltip.offsetWidth - arrow.offsetWidth - target.offsetWidth / BC_TOOLTIP_TWO;
        }
        else if (posX.tooltip <= 0) {
            posX.tooltip = this.offset(target).left;
            posX.arrow = target.offsetWidth / BC_TOOLTIP_TWO;
        }
        return posX;
    }
}
BcTooltipBehavior.ID = 0;

class BcDropdownBehavior extends BcAbstractDropdownBehavior {
    constructor() {
        super();
    }
    static setUpAll(config) {
        const dropdownElements = Array.from(document.querySelectorAll(`[class~='${_DROPDOWN_CLASS}']`));
        const elements = [];
        for (const element of dropdownElements) {
            const bcDropdownBehavior = new BcDropdownBehavior();
            bcDropdownBehavior.setElement(element);
            config && bcDropdownBehavior.setConfig(config);
            bcDropdownBehavior.setUp();
            elements.push(bcDropdownBehavior);
        }
        return elements;
    }
}

const MOLECULE_PAGINATOR = `${BcCommonConstants.PREFIX_LIB}-paginator`;
const MOLECULE_PAGINATOR_LIST = `${BcCommonConstants.PREFIX_LIB}-paginator-list`;
const MOLECULE_PAGINATOR_PAGES = `${BcCommonConstants.PREFIX_LIB}-paginator-pages`;
const MOLECULE_PAGINATOR_PAGE_INFO = `${BcCommonConstants.PREFIX_LIB}-paginator-pages-info`;
const MOLECULE_PAGINATOR_CENTER = `${BcCommonConstants.PREFIX_LIB}-paginator-center`;
const MOLECULE_PAGINATOR_PREV = `${BcCommonConstants.PREFIX_LIB}-paginator-prev`;
const MOLECULE_PAGINATOR_NEXT = `${BcCommonConstants.PREFIX_LIB}-paginator-next`;
const MOLECULE_DROPDOWN = `${BcCommonConstants.PREFIX_LIB}-dropdown`;
const MOLECULE_DROPDOWN_TOGGLE = `${BcCommonConstants.PREFIX_LIB}-dropdown-toggle`;
const MOLECULE_DROPDOWN_CONTENT = `${BcCommonConstants.PREFIX_LIB}-dropdown-content`;
const MOLECULE_DROPDOWN_CUSTOM = `${BcCommonConstants.PREFIX_LIB}-dropdown-custom`;
const MOLECULE_DROPDOWN_ITEM = `${BcCommonConstants.PREFIX_LIB}-dropdown-item`;
const MOLECULE_DROPDOWN_PERPAGE = 'dropdown-per-page';
const MAX_LENGHT = 7;
const SECOND_PAGE = 2;
const DEFAULT_PAGE_COUNT = 10;
const PER_PAGE = 10;
const PER_MULTIPLE = 5;
const PAGINATOR_MATH_VALUE_1000 = 1000;
const PAGINATOR_MATH_VALUE_100 = 100;
const PAGINATOR_MATH_VALUE_6 = 6;

class BcPaginatorBehavior extends BcDefaultBehavior {
    constructor() {
        super();
        /** Lista numpérica del paginator
         * @memberof BcPaginatorBehavior */
        this.paginatorList = document.createElement(BcCommonConstants.DIV_TAG);
        /** Dropdown con la lista numérica
         * @memberof BcPaginatorBehavior */
        this.dropdownPages = document.createElement(BcCommonConstants.DIV_TAG);
        /** Información sobre las páginas
         * @memberof BcPaginatorBehavior */
        this.pagesInfo = document.createElement(BcCommonConstants.DIV_TAG);
        /** Selección para ir a la anterior pestaña
         * @memberof BcPaginatorBehavior */
        this.prev = document.createElement(BcCommonConstants.DIV_TAG);
        /** Selección para seleccionar la actual pestaña
         * @memberof BcPaginatorBehavior */
        this.center = document.createElement(BcCommonConstants.DIV_TAG);
        /** Selección para ir a la siguiente pestaña
         * @memberof BcPaginatorBehavior */
        this.next = document.createElement(BcCommonConstants.DIV_TAG);
        /** Inicio del paginator
         * @memberof BcPaginatorBehavior */
        this.currentStart = 0;
        /** Actual página
         * @memberof BcPaginatorBehavior */
        this.currentPage = 1;
        /** Muestra el listado por páginas
         * @memberof BcPaginatorBehavior */
        this.perPage = PER_PAGE;
        /** Muestra el listado por múltiplos
         * @memberof BcPaginatorBehavior */
        this.perMultiple = PER_MULTIPLE;
        /** Mostrar la lista del paginator
         * @memberof BcPaginatorBehavior */
        this.pageNum = 1;
    }
    /**
     * Configura todos los elementos en el DOM que posean la clase a la cual hace referencia un Tab.
     * @description Llama la configuración del objeto del tipo en cuestión.
     * Por tanto debe estár implementado
     * en la clase.
     * @returns Listado de elementos de ese tipo en el DOM.
     * @memberof BcPaginatorBehavior
     */
    static setUpAll() {
        const paginatorElements = Array.from(document.querySelectorAll(`nav[class^='${MOLECULE_PAGINATOR}']`));
        const elements = [];
        for (let i = 0; i < paginatorElements.length; i++) {
            const element = paginatorElements[i];
            const bcPaginatorBehavior = new BcPaginatorBehavior();
            bcPaginatorBehavior.setElement(element);
            bcPaginatorBehavior.setUp();
            elements.push(bcPaginatorBehavior);
        }
        return elements;
    }
    /**
     * Realiza toda la configuración del objeto.
     * @memberof BcPaginatorBehavior
     */
    _setUp() {
        super._setUp();
        this.typePaginator = this.mySelf.getAttribute('typepaginator');
        if (this.typePaginator != 'default') {
            this.buildMoleculeAllType();
        }
        else {
            this.buildMoleculeDefaultType();
        }
    }
    /**
     * Paramétriza los elementos del paginador tipo default.
     * @memberof BcPaginatorBehavior
     */
    buildMoleculeDefaultType() {
        this.paginatorList.classList.add(MOLECULE_PAGINATOR_LIST);
        this.paginatorList.classList.add('default');
        this.mySelf.appendChild(this.paginatorList);
        this.prev.classList.add(MOLECULE_PAGINATOR_PREV);
        this.next.classList.add(MOLECULE_PAGINATOR_NEXT);
        this.addArrowButtonDefault(this.prev, 'arrow2-left', 'Anterior');
        this.addArrowButtonDefault(this.next, 'arrow2-right', 'Siguiente');
        this.paginatorList.insertAdjacentElement('afterbegin', this.prev);
        this.paginatorList.insertAdjacentElement('beforeend', this.next);
        this.prevPage();
        this.nextPage();
    }
    /**
     * Paramétriza los elementos del paginador de todos los tipos.
     * @memberof BcPaginatorBehavior
     */
    buildMoleculeAllType() {
        this.totalPages = parseInt(this.mySelf.getAttribute('totalregisters'), 10);
        this.idPaginator = this.mySelf.getAttribute('typepaginator');
        this.perPage = parseInt(this.mySelf.getAttribute('perpage'), 10);
        this.perMultiple = parseInt(this.mySelf.getAttribute('multiple'), 10);
        this.paginatorList.classList.add(MOLECULE_PAGINATOR_LIST);
        this.pagesInfo.classList.add(MOLECULE_PAGINATOR_PAGE_INFO);
        this.dropdownPages.classList.add(MOLECULE_PAGINATOR_PAGES);
        if (this.typePaginator === 'full') {
            this.mySelf.appendChild(this.pagesInfo);
        }
        this.mySelf.appendChild(this.paginatorList);
        if (this.typePaginator === 'simple' || this.typePaginator === 'full') {
            this.mySelf.appendChild(this.dropdownPages);
        }
        this.prev.classList.add(MOLECULE_PAGINATOR_PREV);
        this.center.classList.add(MOLECULE_PAGINATOR_CENTER);
        this.next.classList.add(MOLECULE_PAGINATOR_NEXT);
        this.addArrowButton(this.prev, 'arrow2-left');
        this.addArrowButton(this.next, 'arrow2-right');
        this.prevPage();
        this.nextPage();
        this.setperPage(this.dropdownPages);
        this.buildPagination(this.totalPages, this.currentStart, this.perPage);
    }
    /**
     * Agrega el boton de flecha al paginador
     * @param {Element} elem
     * @param {string} icon
     * @memberof BcPaginatorBehavior
     */
    addArrowButton(elem, icon) {
        elem.innerHTML = `<button class="bc-btn-icon" aria-label="Boton" tabindex="0">
  <i class="bc-icon bc-sm" aria-hidden="true" aria-label="prueba" role="img" size="md">${icon}</i>
</button>`;
    }
    /**
     * Agrega el boton de flecha al paginador tipo default
     * @param {Element} elem
     * @param {Element} icon
     * @memberof BcPaginatorBehavior
     */
    addArrowButtonDefault(elem, icon, text) {
        elem.innerHTML = `<button class="bc-btn-icon" aria-label="Boton" tabindex="0">
  <i class="bc-icon bc-sm" aria-hidden="true" aria-label="prueba" role="img" size="md">${icon}</i>
</button>`;
        const arrowButton = elem.getElementsByTagName('button')[0];
        const textContent = document.createElement(BcCommonConstants.SPAN_TAG);
        if (text === 'Anterior') {
            textContent.textContent = text;
            arrowButton.insertAdjacentElement('beforeend', textContent);
        }
        if (text === 'Siguiente') {
            textContent.textContent = text;
            arrowButton.insertAdjacentElement('afterbegin', textContent);
        }
    }
    /**
     * Crear el arreglo de páginas
     * @param {any} totalPages
     * @param {number} startNumber
     * @param {number} resultPage
     * @memberof BcPaginatorBehavior
     */
    pagination(totalPages, startNumber, resultPage = DEFAULT_PAGE_COUNT) {
        this.validateNumbers(totalPages, startNumber, resultPage);
        const length = Math.ceil(Math.abs(totalPages / resultPage));
        this.currentPage = (startNumber / resultPage) + 1;
        if (length <= MAX_LENGHT) {
            const fullArray = Array.from(Array(length), (x, index) => index + 1);
            return fullArray;
        }
        if (startNumber === 1) {
            this.currentPage = 1;
        }
        return this.pageManagement(this.currentPage, length);
    }
    /**
     * Toma un número de página actual y una longitud de páginas, y devuelve una matriz de números de
     * página.
     * @param {number} currentPage - el número de página actual
     * @param {number} length - número de páginas
     * @returns Una matriz de números.
     */
    pageManagement(currentPage, length) {
        const pages = new Array();
        for (let i = 1; i <= length; i++) {
            this.pageAdder(i, currentPage, length, { pages });
        }
        return pages;
    }
    /**
     * Si la página actual es la primera página, agregue la primera página y la segunda página a la
     * matriz. Si la página actual es la última página, agregue la última página y la penúltima página a
     * la matriz. Si la página actual no es ni la primera ni la última página, agregue la página actual,
     * la página anterior a la página actual y la página posterior a la página actual a la matriz.
     * @param {number} index - el índice actual del bucle
     * @param {number} currentPage - el número de página actual
     * @param {number} length - el número total de páginas
     * @param _ - { páginas: cualquiera[] }
     * @returns El valor devuelto es un objeto con una propiedad llamada páginas.
     */
    pageAdder(index, currentPage, length, _) {
        if (index === 1) {
            _.pages.push(index);
        }
        if (currentPage === 1 && index === 1) {
            _.pages.push(index + 1);
            _.pages.push('...');
            return;
        }
        if (currentPage === length && index === length) {
            _.pages.push('...');
            _.pages.push(index - 1);
        }
        if (index === length) {
            _.pages.push(index);
            return;
        }
        this.currentPageIndexValidator(currentPage, index, _, length);
        return _;
    }
    /**
     * Si la página actual es el índice y el índice es mayor que la segunda página, inserte el índice
     * menos uno en la matriz de páginas.
     * @param {number} currentPage - número - el índice de la página actual
     * @param {number} index - el índice actual de la matriz
     * @param _ - { páginas: cualquiera[] }
     * @param {number} length - número de páginas
     */
    currentPageIndexValidator(currentPage, index, _, length) {
        if (currentPage === index && index - 1 === SECOND_PAGE) {
            _.pages.push(index - 1);
        }
        if (currentPage === index && index - 1 > SECOND_PAGE) {
            _.pages.push('...');
            _.pages.push(index - 1);
        }
        if (currentPage === index) {
            _.pages.push(index);
        }
        if (currentPage === index && index + 1 < length) {
            _.pages.push(index + 1);
            _.pages.push('...');
        }
    }
    /**
     * Si totalPages, resultPage y startNumber son todos números finitos, y totalPages y resultPage son
     * mayores que 0, y startNumber es mayor o igual que 0, entonces devuelve verdadero.
     * @param {any} totalPages - El número total de páginas.
     * @param {number} startNumber - El número de la primera página.
     * @param {number} resultPage - El número de página actual.
     */
    validateNumbers(totalPages, startNumber, resultPage) {
        const allNumbers = [totalPages, resultPage, startNumber].every(Number.isFinite);
        if (!allNumbers) {
            throw new TypeError('pagination() espera solo numeros finitos como argumentos.');
        }
        if (totalPages <= 0) {
            throw new Error('totalPages debe ser un número mayor que 0.');
        }
        if (resultPage <= 0) {
            throw new Error('resultPage debe se un número mayor que 0.');
        }
        if (startNumber < 0) {
            throw new Error('startNumber debe se un número mayor o igual que 0.');
        }
    }
    /**
     * Construye el paginador
     * @param {number} totalPages
     * @param {number} currentStart
     * @param {number} resultPerPage
     * @memberof BcPaginatorBehavior
     */
    buildPagination(totalPages, currentStart, resultPerPage) {
        if (!currentStart) {
            currentStart = 0;
        }
        if (totalPages < 1) {
            throw new Error('No hay resultados');
        }
        this.pageList = this.pagination(totalPages, currentStart, resultPerPage);
        this.paginatorList.appendChild(this.center);
        this.addPagination(resultPerPage);
    }
    /**
     * Agregar cada unos de los botones de las páginas del paginador.
     * @param {number} resultPerPage
     * @memberof BcPaginatorBehavior
     */
    addPagination(resultPerPage) {
        for (let i = 0; i < this.pageList.length; i++) {
            this.addPaginationManagement(i, resultPerPage);
        }
    }
    /**
     * Esta función agrega gestión de paginación a la página.
     * @param {number} index - número =&gt; el índice del número de página en la matriz pageList
     * @param {number} resultPerPage - número = 10;
     * @returns el valor de la variable inicio.
     */
    addPaginationManagement(index, resultPerPage) {
        this.pageNum = this.pageList[index];
        if (this.pageNum === '...') {
            const id = (Math.random() * PAGINATOR_MATH_VALUE_1000) / PAGINATOR_MATH_VALUE_100;
            this.addEllipsis(this.center, `ellipsis-${this.idPaginator}-${id.toFixed(0)}`, this.pageList[index - 1], this.pageList[index + 1]);
        }
        else {
            let start = (this.pageNum - 1) * resultPerPage;
            if (this.pageNum === this.currentPage) {
                this.isCurrentPage(start);
                return;
            }
            this.addButtons(this.center, this.pageNum);
        }
    }
    /**
     * Si la página actual es mayor que 1, agregue el botón anterior a la lista del paginador. Si la
     * página actual es menor que la última página, agregue el siguiente botón a la lista del paginador.
     * Si la página actual es 1, elimina el botón anterior. Si la página actual es la última página,
     * elimine el botón siguiente. Agregue el número de página actual al centro de la lista del
     * paginador.
     * @param {number} start - número - el punto de partida de la lista de paginación
     * @returns Se devuelve el valor inicial.
     */
    isCurrentPage(start) {
        const characterLength = 2;
        if (this.currentPage > 1) {
            this.paginatorList.insertAdjacentElement('afterbegin', this.prev);
        }
        else {
            this.prev.remove();
        }
        if (this.currentPage < this.pageList[this.pageList.length - 1]) {
            if (this.currentPage === 1) {
                start = 0;
            }
            this.paginatorList.insertAdjacentElement('beforeend', this.next);
        }
        else {
            this.next.remove();
        }
        if (String(this.currentPage).length > characterLength) {
            this.center.insertAdjacentHTML('beforeend', `<button class="bc-paginator-number-active bc-paginator-large-button">${this.pageNum}</button>`);
        }
        else {
            this.center.insertAdjacentHTML('beforeend', `<button class="bc-paginator-number-active">${this.pageNum}</button>`);
        }
        return start;
    }
    /**
     * Construye el dropdown de agrupación de páginas (perPages).
     * @param {HTMLElement} dropdownPages
     * @memberof BcPaginatorBehavior
     */
    setperPage(dropdownPages) {
        const dropdown = document.createElement(BcCommonConstants.DIV_TAG);
        const toggle = document.createElement(BcCommonConstants.DIV_TAG);
        const title = document.createElement(BcCommonConstants.H6_TAG);
        const icon = document.createElement(BcCommonConstants.EM_TAG);
        const content = document.createElement(BcCommonConstants.DIV_TAG);
        const list = document.createElement(BcCommonConstants.UL_TAG);
        const oneHundred = 100;
        const oneThousand = 1000;
        const id = (Math.random() * oneThousand) / oneHundred;
        this.setInfo();
        dropdown.classList.add(MOLECULE_DROPDOWN, MOLECULE_DROPDOWN_PERPAGE);
        dropdown.setAttribute('id', `${id.toFixed(0)}`);
        toggle.classList.add(MOLECULE_DROPDOWN_TOGGLE, `${BcCommonConstants.PREFIX_LIB}-${BcCommonConstants.FLEX}`, BcCommonConstants.BC_ALIGN_ITEMS_BASELINE_CLASS, BcCommonConstants.BC_TEXT_DECORATION_UNDERLINE);
        toggle.setAttribute('aria-controls', `${id.toFixed(0)}`);
        title.innerHTML = `${this.perPage}`;
        icon.classList.add(BcCommonConstants.ICONS_CLASS, BcCommonConstants.ICON_XS_CLASS);
        icon.innerHTML = BcCommonConstants.ICON_ARROW_DOWN;
        content.classList.add(MOLECULE_DROPDOWN_CONTENT);
        content.setAttribute('id', `${id.toFixed(0)}`);
        this.dropdownFor(dropdown, dropdownPages, list);
        content.appendChild(list);
        toggle.appendChild(title);
        toggle.appendChild(icon);
        dropdown.appendChild(toggle);
        dropdown.appendChild(content);
        dropdownPages.appendChild(dropdown);
        this.initDropdown(dropdown);
    }
    /**
     * Esta función crea un menú desplegable para el paginador.
     * @param {Element} dropdown - Elemento = el elemento desplegable
     * @param {HTMLElement} dropdownPages - HTMLElement = this.dropdownPages.nativeElement;
     * @param {Element} list - Elemento = el elemento ul
     */
    dropdownFor(dropdown, dropdownPages, list) {
        for (let i = 1; i <= PAGINATOR_MATH_VALUE_6; i++) {
            const item = document.createElement(BcCommonConstants.LI_TAG);
            const button = document.createElement(BcCommonConstants.BUTTON_TAG);
            item.classList.add(MOLECULE_DROPDOWN_ITEM);
            button.classList.add(BcCommonConstants.BC_LINK_CLASS);
            button.innerHTML = `${i * this.perMultiple}`;
            button.addEventListener(BcCommonConstants.EVENT_CLICK, () => this.onClickPerPage(dropdown, dropdownPages, i));
            item.appendChild(button);
            list.appendChild(item);
        }
    }
    /**
     * Función onClick de los ítems del dropdown del páginador.
     * Setea el nuevo valor de agrupación, actualiza el estado y cierra el dropdown.
     * @param {Element} dropdown
     * @param {HTMLElement} dropdownPages
     * @param {number} i
     * @memberof BcPaginatorBehavior
     */
    onClickPerPage(dropdown, dropdownPages, i) {
        this.perPage = i * this.perMultiple;
        this.currentStart = 0;
        this.pageList = this.pagination(this.totalPages, this.currentStart, this.perPage);
        this.center.innerHTML = '';
        this.addPagination(this.perPage);
        this.setperPage(dropdownPages);
        dropdown.remove();
        this.setInfo();
        this.changeStatus();
    }
    /**
     * Construye los botones de Ellipsis (puntos suspensivos).
     * @param {HTMLElement} center
     * @param {string} id
     * @param {number} startnum
     * @param {number} endnum
     * @memberof BcPaginatorBehavior
     */
    addEllipsis(center, id, startnum, endnum) {
        const dropdownId = (Math.random() * PAGINATOR_MATH_VALUE_1000) / PAGINATOR_MATH_VALUE_100;
        const dropdownEllipsis = document.createElement(BcCommonConstants.DIV_TAG);
        const icon = document.createElement(BcCommonConstants.EM_TAG);
        const content = document.createElement(BcCommonConstants.DIV_TAG);
        const list = document.createElement(BcCommonConstants.UL_TAG);
        dropdownEllipsis.classList.add(MOLECULE_DROPDOWN, MOLECULE_DROPDOWN_CUSTOM);
        dropdownEllipsis.setAttribute('id', `${dropdownId.toFixed(0)}`);
        icon.classList.add(BcCommonConstants.ICONS_CLASS, BcCommonConstants.ICON_XL_CLASS, MOLECULE_DROPDOWN_TOGGLE);
        icon.setAttribute('aria-controls', id);
        icon.innerHTML = 'secondary-menu-horizontal';
        content.classList.add(MOLECULE_DROPDOWN_CONTENT);
        content.setAttribute('id', id);
        for (let i = startnum + 1; i < endnum; i++) {
            const item = document.createElement(BcCommonConstants.LI_TAG);
            const button = document.createElement(BcCommonConstants.BUTTON_TAG);
            item.classList.add(MOLECULE_DROPDOWN_ITEM);
            button.classList.add(BcCommonConstants.BC_LINK_CLASS);
            button.innerHTML = `${i}`;
            button.addEventListener(BcCommonConstants.EVENT_CLICK, () => this.onClickAddEllipsis(center, i));
            item.appendChild(button);
            list.appendChild(item);
        }
        content.appendChild(list);
        dropdownEllipsis.appendChild(icon);
        dropdownEllipsis.appendChild(content);
        center.insertAdjacentElement('beforeend', dropdownEllipsis);
        this.initDropdown(dropdownEllipsis);
    }
    /**
     * Función onClick de los botones de Ellipsis (puntos suspensivos).
     *
     * Actualiza el estado de la páginación.
     * @param {HTMLElement} center
     * @param {number} i
     * @memberof BcPaginatorBehavior
     */
    onClickAddEllipsis(center, i) {
        this.currentStart = (i - 1) * this.perPage;
        this.currentPage = this.currentStart / this.perPage + 1;
        this.pageList = this.pagination(this.totalPages, this.currentStart, this.perPage);
        center.innerHTML = '';
        this.addPagination(this.perPage);
        this.setInfo();
        this.changeStatus();
    }
    /**
     * Inicializar el dropdown.
     * @param {Element} dropdown
     * @memberof BcPaginatorBehavior
     */
    initDropdown(dropdown) {
        const config = {
            isPopUp: true,
        };
        this.bcDropdownBehavior = new BcDropdownBehavior();
        this.bcDropdownBehavior.setElement(dropdown);
        this.bcDropdownBehavior.setConfig(config);
        this.bcDropdownBehavior.setUp();
    }
    /**
     * Agregar botones.
     * @param {HTMLElement}center
     * @param {number}pageNum
     * @memberof BcPaginatorBehavior
     */
    addButtons(center, pageNum) {
        const numButtom = document.createElement(BcCommonConstants.BUTTON_TAG);
        numButtom.textContent = `${pageNum}`;
        numButtom.addEventListener(BcCommonConstants.EVENT_CLICK, () => this.onClickAddButtons(center, pageNum));
        center.insertAdjacentElement('beforeend', numButtom);
    }
    onClickAddButtons(center, pageNum) {
        this.currentStart = (pageNum - 1) * this.perPage;
        this.currentPage = this.currentStart / this.perPage + 1;
        this.pageList = this.pagination(this.totalPages, this.currentStart, this.perPage);
        center.innerHTML = '';
        this.addPagination(this.perPage);
        this.setInfo();
        this.changeStatus();
    }
    /**
     * Agraga Event Listener al boton Prev.
     * @memberof BcPaginatorBehavior
     */
    prevPage() {
        this.prev.children[0].addEventListener(BcCommonConstants.EVENT_CLICK, () => this.onClickPrevPage());
    }
    /**
     * Función onClick del botón de retroceder página.
     * @memberof BcPaginatorBehavior
     */
    onClickPrevPage() {
        if (this.typePaginator != 'default') {
            this.currentPage--;
            if (this.currentStart >= 0) {
                this.currentStart = this.currentStart - this.perPage;
                this.pageList = this.pagination(this.totalPages, this.currentStart, this.perPage);
                this.center.innerHTML = '';
                this.addPagination(this.perPage);
                this.setInfo();
            }
            this.changeStatus();
        }
        else {
            this.changeStatusDefault('previous');
        }
    }
    /**
     * Agraga Event Listener al boton Next.
     * @memberof BcPaginatorBehavior
     */
    nextPage() {
        this.next.children[0].addEventListener(BcCommonConstants.EVENT_CLICK, () => this.onClickNextPage());
    }
    /**
      * Función onClick del botón de avanzar página.
      * @memberof BcPaginatorBehavior
      */
    onClickNextPage() {
        if (this.typePaginator != 'default') {
            this.currentPage++;
            if (this.currentStart - this.perPage <= this.totalPages - this.perPage) {
                this.currentStart = this.currentStart + this.perPage;
                this.pageList = this.pagination(this.totalPages, this.currentStart, this.perPage);
                this.center.innerHTML = '';
                this.addPagination(this.perPage);
                this.setInfo();
            }
            this.changeStatus();
        }
        else {
            this.changeStatusDefault('next');
        }
    }
    /**
     * Establecer la información de los items que se muestran.
     * @memberof BcPaginatorBehavior
     */
    setInfo() {
        const info = document.createElement(BcCommonConstants.SPAN_TAG);
        info.innerHTML = `Mostrando ${this.getQuantityInfo()} de ${this.totalPages}`;
        this.pagesInfo.innerHTML = '';
        this.pagesInfo.appendChild(info);
    }
    /**
     * Se cálcula la cantidad de items que se muestran.
     * @return {*}  {number}
     * @memberof BcPaginatorBehavior
     */
    getQuantityInfo() {
        const currentItems = this.currentPage * this.perPage;
        if (currentItems > this.totalPages) {
            return this.totalPages;
        }
        else {
            return currentItems;
        }
    }
    /**
     * Actualiza el cambio de estado del páginador.
     * @memberof BcPaginatorBehavior
     */
    changeStatus() {
        this.changeState({
            TotalRegisters: this.totalPages,
            CurrentPage: this.currentPage,
            PerPage: this.perPage,
        });
    }
    /**
     * Actualiza el cambio de estado del páginador tipo default.
     * @param {string} text
     * @memberof BcPaginatorBehavior
     */
    changeStatusDefault(text) {
        let previous = false;
        let next = false;
        if (text === 'previous') {
            previous = true;
        }
        if (text === 'next') {
            next = true;
        }
        this.changeState({
            PreviousPage: previous,
            NextPage: next,
        });
    }
    /**
     * Permite que dos paginadores compartan comportamiento en caso de necesitarlo
     *
     * @param {BcPaginatorBehavior} pair Par del paginador que se espera comparta comportamiento
     * @memberof BcPaginatorBehavior
     */
    pairPaginator(pair) {
        this.pairPaginatorPrev(pair);
        this.pairPaginatorNext(pair);
        this.pairPaginatorPages(pair);
        this.pairPaginatorDropdwon(pair);
    }
    /**
     * Relaciona los comporamientos del boton prev entre los paginadores, para que estos actuen
     * en forma compartida
     *
     * @param {BcPaginatorBehavior} pair Par del paginador que se espera comparta comportamiento
     * @memberof BcPaginatorBehavior
     */
    pairPaginatorPrev(pair) {
        this.prev.children[0].addEventListener(BcCommonConstants.EVENT_CLICK, () => {
            pair.onClickPrevPage();
        });
        pair.prev.children[0].addEventListener(BcCommonConstants.EVENT_CLICK, () => {
            this.onClickPrevPage();
        });
    }
    /**
     * Relaciona los comporamientos del boton next entre los paginadores, para que estos actuen
     * en forma compartida
     *
     * @param {BcPaginatorBehavior} pair Par del paginador que se espera comparta comportamiento
     * @memberof BcPaginatorBehavior
     */
    pairPaginatorNext(pair) {
        this.next.children[0].addEventListener(BcCommonConstants.EVENT_CLICK, () => {
            pair.onClickNextPage();
        });
        pair.next.children[0].addEventListener(BcCommonConstants.EVENT_CLICK, () => {
            this.onClickNextPage();
        });
    }
    /**
     * Relaciona los comporamientos de las paginas entre los paginadores, para que estos actuen
     * en forma compartida
     *
     * @param {BcPaginatorBehavior} pair Par del paginador que se espera comparta comportamiento
     * @memberof BcPaginatorBehavior
     */
    pairPaginatorPages(pair) {
        this.paginatorList.addEventListener(BcCommonConstants.EVENT_CLICK, () => {
            pair.onClickAddButtons(pair.center, this.currentPage);
        });
        pair.paginatorList.addEventListener(BcCommonConstants.EVENT_CLICK, () => {
            this.onClickAddButtons(this.center, pair.currentPage);
        });
    }
    /**
     * Relaciona los comporamientos del dropdown entre los paginadores, para que estos actuen
     * en forma compartidad
     *
     * @param {BcPaginatorBehavior} pair Par del paginador que se espera comparta comportamiento
     * @memberof BcPaginatorBehavior
     */
    pairPaginatorDropdwon(pair) {
        this.dropdownPages.addEventListener(BcCommonConstants.EVENT_CLICK, () => {
            let page = pair.dropdownPages.querySelector(BcCommonConstants.H6_TAG);
            pair.perPage = this.perPage;
            pair.currentStart = this.currentStart;
            pair.pageList = pair.pagination(this.totalPages, this.currentStart, this.perPage);
            pair.center.innerHTML = '';
            if (page) {
                page.textContent = `${pair.perPage}`;
            }
            pair.addPagination(pair.perPage);
            pair.setInfo();
            pair.changeStatus();
        });
        pair.dropdownPages.addEventListener(BcCommonConstants.EVENT_CLICK, () => {
            let page = this.dropdownPages.querySelector(BcCommonConstants.H6_TAG);
            this.perPage = pair.perPage;
            this.currentStart = pair.currentStart;
            this.pageList = this.pagination(pair.totalPages, pair.currentStart, pair.perPage);
            this.center.innerHTML = '';
            if (page) {
                page.textContent = `${this.perPage}`;
            }
            this.addPagination(this.perPage);
            this.setInfo();
            this.changeStatus();
        });
    }
    /**
     * Esta función devuelve el elemento paginatorList.
     * @returns La propiedad paginatorList.
     */
    getPaginatorList() {
        return this.paginatorList;
    }
}

const CALENDAR_N1 = 1;
const CALENDAR_N2 = 2;
const CALENDAR_N3 = 3;
const CALENDAR_N4 = 4;
const CALENDAR_N5 = 5;
const CALENDAR_N6 = 6;
const CALENDAR_N7 = 7;
const CALENDAR_N8 = 8;
const CALENDAR_N9 = 9;
const CALENDAR_N10 = 10;
const CALENDAR_N11 = 11;
const CALENDAR_N12 = 12;
const CALENDAR_N14 = 14;
const CALENDAR_N15 = 15;
const CALENDAR_N17 = 17;
const CALENDAR_N20 = 20;
const CALENDAR_N25 = 25;
const CALENDAR_N27 = 27;
const CALENDAR_N21 = 21;
const CALENDAR_N28 = 28;
const CALENDAR_N29 = 29;
const CALENDAR_N30 = 30;
const CALENDAR_N31 = 31;
const CALENDAR_N100 = 100;
const CALENDAR_N120 = 120;
const CALENDAR_N400 = 400;
const SM_BREAKPOINT_N576 = 576;
const PADDING_INPUT_N30 = 30;
const SIZE_DATE_STR = 10;
var DateFormate;
(function (DateFormate) {
    DateFormate["fullDate"] = "fullDate";
    DateFormate["mediumDate"] = "mediumDate";
    DateFormate["shortDate"] = "shortDate";
})(DateFormate || (DateFormate = {}));
class BcDateConstants {
}
BcDateConstants.MAX_SCREEN_WIDTH = SM_BREAKPOINT_N576;
BcDateConstants.CALENDAR_CLASS = 'bc-calendar';
BcDateConstants.HOLIDAY_CLASS = 'bc-calendar-holiday';
BcDateConstants.CALENDAR_CLASS_ACTIVE = 'bc-calendar-active';
BcDateConstants.DATE_INPUT_DATE_CLASS = 'bc-input-date';
BcDateConstants.DATE_FORM_FIELD_CLASS = 'bc-form-field';
BcDateConstants.RANGE_MOLECULE_CLASSES = 'bc-input-date-range';
BcDateConstants.WEEK_CLASS = 'bc-calendar-week';
BcDateConstants.TOP_BAR_SELECTOR_CLASS = 'bc-calendar-top-bar';
BcDateConstants.CURRENT_SELECTION_CLASS = 'bc-calendar-current-selection';
BcDateConstants.DAYS_CLASS = 'bc-calendar-days';
BcDateConstants.TWO_CALENDARS_CLASS = 'bc-two-calendars';
BcDateConstants.SCROLLABLE_CALENDARS_CLASS = 'bc-calendar-scrollable-calendars';
BcDateConstants.FIX_UPPER_BUTTONS = 'bc-calendar-fix-upper-buttons';
BcDateConstants.DISPLAYED_CALENDARS_CLASS = 'bc-calendar-displayed-month';
BcDateConstants.MONTH_NAME_CLASS = 'bc-month';
BcDateConstants.CONFIRM_CLASS = 'btn-confirm';
BcDateConstants.CANCEL_CLASS = 'btn-cancel';
BcDateConstants.RESTORE_CLASS = 'btn-restore';
BcDateConstants.BC_TAG_FILTER = 'bc-tag-filter';
BcDateConstants.BC_TAG_FILTER_ACTIVE = 'bc-tag-filter-active';
BcDateConstants.YEAR_CLASS = 'bc-year';
BcDateConstants.NEXT_CLASS = 'next';
BcDateConstants.PREV_CLASS = 'prev';
BcDateConstants.SELECTED_DATE_CLASS = 'bc-calendar-selected-date';
BcDateConstants.INSIDE_RANGE_CLASS = 'bc-calendar-inside-range';
BcDateConstants.TODAY_CLASS = 'bc-calendar-today';
BcDateConstants.OUTLINE_CLASS = 'outline-element';
BcDateConstants.THIS_MONTH_OR_YEAR_CLASS = 'bc-calendar-this-month-or-year';
BcDateConstants.DAY = 'day';
BcDateConstants.UPPPER_BTNS_CLASS = 'bc-calendar-upper-btns';
BcDateConstants.MONTHS_OR_YEARS_CLASS = 'bc-calendar-months-or-years';
BcDateConstants.WEEK_SHORT = ['Dom', 'Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab'];
BcDateConstants.MONTHS_TEXT = [
    'Enero',
    'Febrero',
    'Marzo',
    'Abril',
    'Mayo',
    'Junio',
    'Julio',
    'Agosto',
    'Septiembre',
    'Octubre',
    'Noviembre',
    'Diciembre',
];
BcDateConstants.MONTHS_TEXT_SHORT = [
    'Ene',
    'Feb',
    'Mar',
    'Abr',
    'May',
    'Jun',
    'Jul',
    'Ago',
    'Sep',
    'Oct',
    'Nov',
    'Dic',
];
BcDateConstants.HOLIDAY_DATES = [
    [CALENDAR_N1, CALENDAR_N1],
    [CALENDAR_N10, CALENDAR_N1],
    [CALENDAR_N21, CALENDAR_N3],
    [CALENDAR_N14, CALENDAR_N4],
    [CALENDAR_N15, CALENDAR_N4],
    [CALENDAR_N1, CALENDAR_N5],
    [CALENDAR_N20, CALENDAR_N6],
    [CALENDAR_N27, CALENDAR_N6],
    [CALENDAR_N4, CALENDAR_N7],
    [CALENDAR_N20, CALENDAR_N7],
    [CALENDAR_N7, CALENDAR_N8],
    [CALENDAR_N15, CALENDAR_N8],
    [CALENDAR_N17, CALENDAR_N10],
    [CALENDAR_N7, CALENDAR_N11],
    [CALENDAR_N14, CALENDAR_N11],
    [CALENDAR_N8, CALENDAR_N12],
    [CALENDAR_N25, CALENDAR_N12],
];
BcDateConstants.LONG_MONTHS = [
    -1,
    0,
    CALENDAR_N2,
    CALENDAR_N4,
    CALENDAR_N6,
    CALENDAR_N7,
    CALENDAR_N9,
    CALENDAR_N11,
    CALENDAR_N12,
];
BcDateConstants.NUMBERS = {
    CALENDAR_N1,
    CALENDAR_N2,
    CALENDAR_N3,
    CALENDAR_N4,
    CALENDAR_N5,
    CALENDAR_N6,
    CALENDAR_N7,
    CALENDAR_N8,
    CALENDAR_N9,
    CALENDAR_N10,
    CALENDAR_N11,
    CALENDAR_N12,
    CALENDAR_N14,
    CALENDAR_N15,
    CALENDAR_N17,
    CALENDAR_N20,
    CALENDAR_N25,
    CALENDAR_N27,
    CALENDAR_N21,
    CALENDAR_N28,
    CALENDAR_N29,
    CALENDAR_N30,
    CALENDAR_N31,
    CALENDAR_N100,
    CALENDAR_N120,
    CALENDAR_N400
};
BcDateConstants.SHORT_MONTHS = [CALENDAR_N3, CALENDAR_N5, CALENDAR_N8, CALENDAR_N10];
BcDateConstants.STATE_DAYS = 'days';
BcDateConstants.STATE_MONTHS = 'months';
BcDateConstants.STATE_YEARS = 'years';
BcDateConstants.STATE_RANGE = 'range';
BcDateConstants.STATE_SPLIT = 'split';
BcDateConstants.STATE_SELECT_MONTH = "month";
BcDateConstants.STATE_SELECT_YEAR = "year";
BcDateConstants.MOBILE_CALENDAR_CLASS = 'bc-calendar-mobile';
BcDateConstants.MOBILE_CONFIRM_CLASS = 'bc-calendar-confirm-mobile';
BcDateConstants.FAST_BUTTONS = 'fastButtons';
BcDateConstants.BUTTONS_RANGE_CONTAINER_CLASS = 'bc-calendar-buttons-range-container';
BcDateConstants.BUTTONS_SIMPLE_CONTAINER_CLASS = 'bc-calendar-buttons-simple-container';
BcDateConstants.FIXED_CONTENT_CLASS = 'bc-calendar-fixed-content';
BcDateConstants.MOBILE_CALENDAR_TITLE = 'Selecciona una fecha';
BcDateConstants.MOBILE_TITLE_CLASS = 'mobile-title';
BcDateConstants.DISABLED_DAY = 'bc-calendar-disabled-day';
BcDateConstants.BTN_X_CLASS = 'btn-x';
BcDateConstants.DATES_CLASS = 'dates';
BcDateConstants.FROM_CLASS = 'from';
BcDateConstants.TO_CLASS = 'to';
BcDateConstants.RANGES = 'ranges';
BcDateConstants.RANGES_TEXT = 'rangesText';
BcDateConstants.TYPE_LINK = 'gray';
BcDateConstants.CALENDAR_BUTTON = 'CalendarButton';
BcDateConstants.CALENDAR_FILTER = 'CalendarFilter';
BcDateConstants.CALENDAR_HOLIDAY = 'CalendarHoliday';
BcDateConstants.FORMAT_DATE = 'formatdate';
BcDateConstants.SM_BREAKPOINT = SM_BREAKPOINT_N576;
BcDateConstants.PADDING_INPUT = PADDING_INPUT_N30;
BcDateConstants.MONTH_NUMBER = "month_number";
BcDateConstants.ID = "id";
BcDateConstants.ID_DAY = "DAY";
BcDateConstants.ID_MONTH = "MONTH";
BcDateConstants.ID_YEAR = "YEAR";

class BcCalendarUtilities {
    /**
     * un top bar solo para cambiar de mes a mes
     * @return {Element} div con el nombre del mes y el año en el mismo selector
     */
    topBarSingleMonth() {
        return `<div class="${BcDateConstants.TOP_BAR_SELECTOR_CLASS}">
    <em class="${BcCommonConstants.ICONS_CLASS} ${BcCommonConstants.ICON_SM_CLASS} ${BcDateConstants.PREV_CLASS}">arrow2-left</em>
    <h6 class="${BcDateConstants.MONTH_NAME_CLASS}"></h6> 
    <em class="${BcCommonConstants.ICONS_CLASS} ${BcCommonConstants.ICON_SM_CLASS} ${BcDateConstants.NEXT_CLASS}">arrow2-right</em>
    </div>`;
    }
    filterSimple(text) {
        return `<button class = "${BcDateConstants.BC_TAG_FILTER}">
      <em class='${BcCommonConstants.ICONS_CLASS} ${BcCommonConstants.ICON_SM_CLASS}'> calendar </em>        
      <p class='${BcDateConstants.BC_TAG_FILTER}-text'>${text}</p>
      <em class='${BcCommonConstants.ICONS_CLASS} ${BcCommonConstants.ICON_SM_CLASS}'></em>
    </button>`;
    }
    /**
     * un top bar que slecciona años y meses por separado
     * @return {Element} div con mes y año separados
     */
    topBarSingleMonthSplitSelector() {
        return `<div class="${BcDateConstants.TOP_BAR_SELECTOR_CLASS}"><em class="${BcCommonConstants.ICONS_CLASS} 
    ${BcCommonConstants.ICON_SM_CLASS}${BcDateConstants.PREV_CLASS}">arrow2-left</em>
    <h6 class="${BcDateConstants.MONTH_NAME_CLASS}"></h6><em class="${BcCommonConstants.ICONS_CLASS}
    ${BcCommonConstants.ICON_SM_CLASS} ${BcDateConstants.NEXT_CLASS}">arrow2-right</em>
    <em class="${BcCommonConstants.ICONS_CLASS} ${BcCommonConstants.ICON_SM_CLASS} ${BcDateConstants.PREV_CLASS}">arrow2-left</em><h6 class="${BcDateConstants.YEAR_CLASS}">
    </h6><em class="${BcCommonConstants.ICONS_CLASS} ${BcCommonConstants.ICON_SM_CLASS} ${BcDateConstants.NEXT_CLASS}">arrow2-right</em></div>`;
    }
    /**
     * un top bar en el cual no se ven las flechas
     * @return {Element} div solo con el nombre del mes y año
     */
    topBarMobileScrollable() {
        return `<div class="${BcDateConstants.TOP_BAR_SELECTOR_CLASS}">
    <h6 class="${BcDateConstants.MONTH_NAME_CLASS}"></div>`;
    }
    /**
     * Crea un DisplayedMonth con la barra simple
     * @return {DisplayedMonth[]} array con un elemento para calendario sencillo.
     */
    getOneSimpleMonth(referenceMonth, referenceYear) {
        return {
            month: referenceMonth,
            year: referenceYear,
        };
    }
    /**
     * Elementos html para un elemento graifco de la interfaz DisplayedMonth
     * @return {Element} div con los contenedores y clases para un calendario
     */
    getDisplayedMonthElement(topBar) {
        const innerHTML = `
    ${topBar}
    <div class='${BcDateConstants.WEEK_CLASS}'></div>
    <div class='${BcDateConstants.DAYS_CLASS}'></div>`;
        const elem = document.createElement('div');
        elem.classList.add(BcDateConstants.DISPLAYED_CALENDARS_CLASS);
        elem.innerHTML = innerHTML;
        return elem;
    }
    /**
     * Crea doce meses scrolleables para el calendario de rango
     * @return {DisplayedMonth[]} array con un elemento para cada mes.
     */
    getTwelveScrollableMonths(referenceMonth, referenceYear) {
        const months = [];
        for (let i = referenceMonth - BcDateConstants.NUMBERS.CALENDAR_N6; i <= referenceMonth + BcDateConstants.NUMBERS.CALENDAR_N6; i++) {
            const tempDate = new Date(referenceYear, i, 1);
            const month = {
                month: tempDate.getMonth(),
                year: tempDate.getFullYear(),
            };
            months.push(month);
        }
        return months;
    }
    /**
     * Crea dos meses para el calendario de rango
     * @param {number} referenceMonth= mes de referencia para tener 2 meses en el calendario
     * @param {number} referenceYear= año de referencia para tener 2 meses en el calendario
     * @return {DisplayedMonth[]} array con un elemento para cada mes que se muestra.
     */
    getTwoRangeMonths(referenceMonth, referenceYear) {
        const months = [];
        const tempDate = new Date();
        tempDate.setMonth(referenceMonth, 1);
        tempDate.setFullYear(referenceYear);
        for (let i = referenceMonth; i <= referenceMonth + 1; i++) {
            tempDate.setMonth(i);
            const month = {
                month: tempDate.getMonth(),
                year: tempDate.getFullYear(),
            };
            months.push(month);
        }
        return months;
    }
    /**
     * Va a un mes anterior cuando es un calendario simple
     * @param {DisplayedMonth} displayedMonth= el elemento completo del mes en pantalla.
     * @void
     */
    goToPreviousMonth(displayedMonth) {
        displayedMonth.month--;
        if (displayedMonth.month < 0) {
            displayedMonth.month = 11;
            displayedMonth.year--;
        }
    }
    /**
     * Elementos html para un calendario simple que tiene un grid diferente para seleccionar
     * meses o años en el eespacio de los dias
     * @return {string} Elementos html para un calendario simple que tiene un grid
     * diferente para seleccionar meses o años en el eespacio de los dias
     */
    getCalendarSelectMonthOrYear() {
        return `
    <div class='${BcDateConstants.TOP_BAR_SELECTOR_CLASS}'>
    <em class='${BcCommonConstants.ICONS_CLASS} ${BcCommonConstants.ICON_SM_CLASS}
    ${BcDateConstants.PREV_CLASS}'>arrow2-left</em>
    <h6 class='${BcDateConstants.CURRENT_SELECTION_CLASS}'>
    </h6><em class='${BcCommonConstants.ICONS_CLASS}
    ${BcCommonConstants.ICON_SM_CLASS}
    ${BcDateConstants.NEXT_CLASS}'>arrow2-right</em></div>
    <div class='${BcDateConstants.MONTHS_OR_YEARS_CLASS}'></div>`;
    }
    /**
     * Elementos html para los botones de seleccion de rangos rapidos
     * @return {string} Elementos html para los botones de seleccion de rangos rapidos
     */
    getRangeCalendarButtons() {
        return `<div class="${BcDateConstants.UPPPER_BTNS_CLASS}"></div>`;
    }
    /**
     * elementos html
     * @return {string} contenedor inferior en el calendario mobile scrolleable
     */
    getContentFixedContainer() {
        return ` <div class='from-to-container'>
   <div class='${BcDateConstants.DATES_CLASS}'><p class='${BcCommonConstants.SMALL}'>Desde</p><p class='${BcDateConstants.FROM_CLASS}'>dd/mm/aa</p></div>
   <div class='${BcDateConstants.DATES_CLASS}'><p class='${BcCommonConstants.SMALL}'>Hasta</p><p class='${BcDateConstants.TO_CLASS}'>dd/mm/aa</p></div>
   </div>
   <button class='${BcCommonConstants.BC_BTN_CLASS} ${BcCommonConstants.BTN_PRIMARY_CLASS} ${BcDateConstants.CONFIRM_CLASS}
   ${BcCommonConstants.BUTTON_SMALL_CLASS}' disabled='true'>Aceptar</button>
   <em class='${BcCommonConstants.ICONS_CLASS}  ${BcDateConstants.CANCEL_CLASS} ${BcCommonConstants.ICON_SM_CLASS} ${BcDateConstants.BTN_X_CLASS}'>error</em>`;
    }
    /**
     * Le da valor a las variables cuando se muestra un calendario de rango en desktop
     * @return {string} Element: Elemento html con los string de los botones
     */
    confirmBtnsString() {
        return `
              <a ${BcCommonConstants.BC_LINK_CLASS} typeLink='${BcDateConstants.TYPE_LINK}' 
              class= "bc-col-6 ${BcDateConstants.RESTORE_CLASS}"> Restablecer </a>                               
              <button class='${BcCommonConstants.BC_BTN_CLASS} bc-col-3 ${BcCommonConstants.BTN_SECONDARY_CLASS} 
              ${BcDateConstants.CANCEL_CLASS} ${BcCommonConstants.BUTTON_SMALL_CLASS}'>Cancelar</button>
              <button class='${BcCommonConstants.BC_BTN_CLASS} bc-col-3 ${BcCommonConstants.BTN_PRIMARY_CLASS} 
              ${BcDateConstants.CONFIRM_CLASS} ${BcCommonConstants.BUTTON_SMALL_CLASS}'>Aceptar</button>
            `;
    }
    /**
     * Le da valor a las variables cuando se muestra un calendario de rango en desktop
     * @return {string} Element: Elemento html con los string de los botones
     */
    confirmBtnString(text) {
        return `<button class='${BcCommonConstants.BC_BTN_CLASS} ${BcCommonConstants.BTN_PRIMARY_CLASS} ${BcDateConstants.CONFIRM_CLASS}'>${text}</button>`;
    }
    /**
     * Permite crear un elemento de boton 'automatico' que selecciona n días hacia atrás en el calendario
     * @param {number} number: El numero de días que el boton debe seleccionar automaticamente
     * @return Element: Botón creado
     */
    createARangeButton(days, text) {
        const btn = document.createElement('button');
        btn.classList.add(BcDateConstants.BC_TAG_FILTER);
        if (text == null) {
            btn.innerHTML = `<em class='${BcCommonConstants.ICONS_CLASS}
        ${BcCommonConstants.ICON_SM_CLASS}'></em>
        <p class='${BcDateConstants.BC_TAG_FILTER}-text'>últimos ${days} días</p>
        <em class='${BcCommonConstants.ICONS_CLASS} ${BcCommonConstants.ICON_SM_CLASS}'></em>`;
        }
        else {
            btn.innerHTML = `<em class='${BcCommonConstants.ICONS_CLASS}
        ${BcCommonConstants.ICON_SM_CLASS}'></em>
        <p class='${BcDateConstants.BC_TAG_FILTER}-text'>${text}</p>
        <em class='${BcCommonConstants.ICONS_CLASS} ${BcCommonConstants.ICON_SM_CLASS}'></em>`;
        }
        btn.setAttribute('value', days + '');
        return btn;
    }
    /**
     * agrega los dias de la semana al elemento enviado
     * @param {Element} contenedor en el calendario donde se indican los dias de la semana (dom-sab)
     * @void
     */
    addWeekDays(week) {
        week.innerHTML = '';
        BcDateConstants.WEEK_SHORT.forEach((day) => {
            const textDay = document.createElement('p');
            textDay.classList.add(BcCommonConstants.SMALL, BcCommonConstants.TEXT_GRAY);
            textDay.textContent = day;
            week.appendChild(textDay);
        });
    }
    /**
     * Va a un mes siguiente cuando es un calendario simple (con selector simple o dividido)
     * @param {DisplayedMonth} displayedMonth= el elemento completo del mes en pantalla.
     * @void
     */
    goToNextMonth(displayedMonth) {
        displayedMonth.month++;
        if (displayedMonth.month > BcDateConstants.NUMBERS.CALENDAR_N11) {
            displayedMonth.month = 0;
            displayedMonth.year++;
        }
    }
    /**
     * Indica si febrero de ese año tiene 29 días o no
     * @param {number} year: año que se desea validar si es biciesto o no
     * @return boolean
     */
    validateLeapYear(year) {
        return year % BcDateConstants.NUMBERS.CALENDAR_N100 === 0
            ? year % BcDateConstants.NUMBERS.CALENDAR_N400 === 0
            : year % BcDateConstants.NUMBERS.CALENDAR_N4 === 0;
    }
    /**
     * compara las fechas de un arreglo para ordenarlas de menor a mayor
     * @param {Date} date1 = primera fecha
     * @param {Date} date2 = segunda fecha a comparar
     * @return {number} -1 , 0 , 1 para organizar un arreglo
     */
    compareDates(date1, date2) {
        return date1.getTime() - date2.getTime();
    }
    /**
     * a partir de un mes escrito textualmente retorna su indice en numerico
     * @param {string} month = mes textual
     * @return {number} numero de ese mes
     */
    getMonthIndex(month) {
        return BcDateConstants.MONTHS_TEXT.findIndex((currentValue) => currentValue === month);
    }
    /**
     * a partir de un mes escrito textualmente de forma reducida retorna su indice en numerico
     * @param {string} month = mes textual
     * @return {number} numero de ese mes
     */
    getMonthShorIndex(month) {
        return BcDateConstants.MONTHS_TEXT_SHORT.findIndex((currentValue) => currentValue === month);
    }
    /**
     * Retorna el año del día que fue clickeado en el calendario
     * @param {Element} elem: elemento clickeaod dentro del calendario
     * @return {string}: Año del dia que representa el elemento
     */
    getClickedDateYear(elem) {
        const monthTextElement = elem.querySelectorAll(BcCommonConstants.H6_TAG);
        return monthTextElement[1]
            ? monthTextElement[1].textContent
            : monthTextElement[0].textContent.split(' ')[1];
    }
    /**
     * Retorna el numero de dias que tiene un mes en su respectivo año
     * @param {number} numberMonth: numero del mes a validar
     * @param {number} year: numero del año a validar
     * @return {number} numero de dias de ese mes
     */
    getNumberOfDays(numberMonth, year) {
        if (BcDateConstants.LONG_MONTHS.includes(numberMonth)) {
            return BcDateConstants.NUMBERS.CALENDAR_N31;
        }
        else if (BcDateConstants.SHORT_MONTHS.includes(numberMonth)) {
            return BcDateConstants.NUMBERS.CALENDAR_N30;
        }
        else {
            return this.validateLeapYear(year) ? BcDateConstants.NUMBERS.CALENDAR_N29 : BcDateConstants.NUMBERS.CALENDAR_N28;
        }
    }
    /**
     * a partir de un elemento en el calendario, retorna el mes textual del elemento clickeado
     * @param {Element} elem = año de 4 digitos del calendario gregoriano
     * @return {string} mes ene l cual se clickeo un numero
     */
    getClickedDateMonth(elem) {
        const monthTextElement = elem.querySelector('h6');
        return monthTextElement.textContent.split(' ')[0];
    }
    configMonthElement(topBar, monthInfo) {
        const element = this.getDisplayedMonthElement(topBar);
        const month = element.querySelector(`.${BcDateConstants.DAYS_CLASS}`);
        const year = element.querySelector(`.${BcDateConstants.YEAR_CLASS}`);
        const monthName = element.querySelector(`.${BcDateConstants.MONTH_NAME_CLASS}`);
        const week = element.querySelector(`.${BcDateConstants.WEEK_CLASS}`);
        if (year) {
            monthName.textContent = BcDateConstants.MONTHS_TEXT[monthInfo.month];
            year.textContent = monthInfo.year + '';
        }
        else {
            monthName.textContent = BcDateConstants.MONTHS_TEXT[monthInfo.month] + ' ' + monthInfo.year;
        }
        this.addWeekDays(week);
        month.innerHTML = '';
        const tempDate = new Date();
        tempDate.setFullYear(monthInfo.year);
        tempDate.setMonth(monthInfo.month, 1);
        const emptyDays = tempDate.getDay();
        return {
            emptyDays,
            month,
            tempDate,
            element,
        };
    }
    maxScreenWidth() {
        if (screen.width <= BcDateConstants.MAX_SCREEN_WIDTH) {
            return true;
        }
        else {
            return false;
        }
    }
    /**
     * Se encarga de revisiar si el dia es festivo y agregar la clase corresponite
     * @param  dayIterator dia que se va a revisar
     * @param  monthInfo informacion del mes
     * @param  day elemento del dia
     * @void
     * @memberof BcCalendarUtilities
     */
    holidays(dayIterator, monthInfo, day) {
        for (const date of BcDateConstants.HOLIDAY_DATES) {
            if (dayIterator == date[0] && monthInfo.month == date[1] - 1) {
                const holiday = document.createElement('div');
                holiday.classList.add(BcDateConstants.HOLIDAY_CLASS);
                day.appendChild(holiday);
            }
        }
    }
    /**
     * Inicializa los listeners de focus para el elemento seleccionado
     * @param {Element} elemt elemto al cual se le añaden los listeners
     * @memberof BcCalendarUtilities
     * @void
     */
    focusListeners(elem) {
        elem.addEventListener(BcCommonConstants.EVENT_FOCUS, (event) => {
            elem.classList.add(BcDateConstants.OUTLINE_CLASS);
        });
        elem.addEventListener(BcCommonConstants.EVENT_FOCUSOUT, (event) => {
            elem.classList.remove(BcDateConstants.OUTLINE_CLASS);
        });
    }
    setDayAttribute(day, monthInfo) {
        day.setAttribute(BcDateConstants.ID, `${BcDateConstants.ID_DAY}${day.textContent}`);
        day.setAttribute(BcDateConstants.ID_MONTH, `${monthInfo.month}`);
        day.setAttribute(BcDateConstants.ID_YEAR, `${monthInfo.year}`);
    }
    /**
     *añade los listeners tecla por tecla
     *para un calendario en estado de seleccion de año
     * @param event evento disparado
     * @param element elemento al cual se le agregan los listeners
     * @param myMap arreglo para identificar la pulsacion de dos teclas simultaneas
     * @memberof BcStepperBehavior
     */
    accessibilityYears(event, element, myMap, calendarBehavior) {
        if (myMap.has(event.key)) {
            this.pageUpPageDownAndAltYears(myMap, event, element, calendarBehavior);
        }
        else if (event.key === BcCommonConstants.KEY_EVENT_ARROW_LEFT) {
            this.moveYears(element, -BcDateConstants.NUMBERS.CALENDAR_N1, calendarBehavior);
        }
        else if (event.key === BcCommonConstants.KEY_EVENT_ARROW_RIGHT) {
            this.moveYears(element, BcDateConstants.NUMBERS.CALENDAR_N1, calendarBehavior);
        }
        else if (event.key === BcCommonConstants.KEY_EVENT_ARROW_UP) {
            this.moveYears(element, -BcDateConstants.NUMBERS.CALENDAR_N4, calendarBehavior);
        }
        else if (event.key === BcCommonConstants.KEY_EVENT_ARROW_DOWN) {
            this.moveYears(element, BcDateConstants.NUMBERS.CALENDAR_N4, calendarBehavior);
        }
        else if (event.key === BcCommonConstants.KEY_EVENT_HOME) {
            this.moveToInitOrFinalYear(true, calendarBehavior);
        }
        else if (event.key === BcCommonConstants.KEY_EVENT_END) {
            this.moveToInitOrFinalYear(false, calendarBehavior);
        }
        else if (event.key === BcCommonConstants.KEY_EVENT_ENTER || event.key === BcCommonConstants.KEY_EVENT_SPACE) {
            calendarBehavior.selectMonth(parseInt(element.getAttribute(BcDateConstants.MONTH_NUMBER)), calendarBehavior.displayedMonths[0]);
        }
    }
    /**
     * añade los listeners tecla para las teclas pageUp PageDown y Alt
     * para un calendario en estado de seleccion de año
     * ya que se puden oprimir en simultaneo o solas
     * @param myMap arreglo para identificar la pulsacion de dos teclas simultaneas
     * @param event evento disparado
     * @param element elemento al cual se le agregan los listeners
     * @memberof BcStepperBehavior
     */
    pageUpPageDownAndAltYears(myMap, event, element, calendarBehavior) {
        myMap.set(event.key, true);
        if (!myMap.get(BcCommonConstants.KEY_EVENT_ALT) && myMap.get(BcCommonConstants.KEY_EVENT_PAGE_UP)) {
            this.moveYears(element, -BcDateConstants.NUMBERS.CALENDAR_N12, calendarBehavior);
        }
        if (!myMap.get(BcCommonConstants.KEY_EVENT_ALT) && myMap.get(BcCommonConstants.KEY_EVENT_PAGE_DOWN)) {
            this.moveYears(element, BcDateConstants.NUMBERS.CALENDAR_N12, calendarBehavior);
        }
        if (myMap.get(BcCommonConstants.KEY_EVENT_ALT) && myMap.get(BcCommonConstants.KEY_EVENT_PAGE_UP)) {
            this.moveYears(element, -BcDateConstants.NUMBERS.CALENDAR_N120, calendarBehavior);
        }
        if (myMap.get(BcCommonConstants.KEY_EVENT_ALT) && myMap.get(BcCommonConstants.KEY_EVENT_PAGE_DOWN)) {
            this.moveYears(element, BcDateConstants.NUMBERS.CALENDAR_N120, calendarBehavior);
        }
    }
    /**
     * funcion para moverse entre años con las teclas
     * @param year año actual
     * @param howMany cuantos se va a mover
     * @memberof BcStepperBehavior
     */
    moveYears(year, howMany, calendarBehavior) {
        const getValues = calendarBehavior.yearGroupName.textContent.split('-');
        const init = parseInt(getValues[0]);
        const final = parseInt(getValues[1]);
        const next = parseInt(year.textContent) + howMany;
        if (next > final) {
            const jumps = Math.ceil((next - final) / BcDateConstants.NUMBERS.CALENDAR_N12);
            calendarBehavior.displayedMonths[0].year += jumps * BcDateConstants.NUMBERS.CALENDAR_N12;
            calendarBehavior.yearGroup = [
                calendarBehavior.displayedMonths[0].year - BcDateConstants.NUMBERS.CALENDAR_N11,
                calendarBehavior.displayedMonths[0].year,
            ];
            calendarBehavior.setElementsWithCalendarState(calendarBehavior.displayedMonths[0]);
            document.getElementById(`${BcDateConstants.ID_YEAR}${next}`)?.focus();
        }
        else if (next < init) {
            const jumps = -Math.ceil((init - next) / BcDateConstants.NUMBERS.CALENDAR_N12);
            calendarBehavior.displayedMonths[0].year += jumps * BcDateConstants.NUMBERS.CALENDAR_N12;
            calendarBehavior.yearGroup = [
                calendarBehavior.displayedMonths[0].year - BcDateConstants.NUMBERS.CALENDAR_N11,
                calendarBehavior.displayedMonths[0].year,
            ];
            calendarBehavior.setElementsWithCalendarState(calendarBehavior.displayedMonths[0]);
            document.getElementById(`${BcDateConstants.ID_YEAR}${next}`)?.focus();
        }
        else {
            document.getElementById(`${BcDateConstants.ID_YEAR}${next}`)?.focus();
        }
    }
    /**
     * muve el focus al año inicial o final de la pantalla de selecion de año
     * @param {boolean } goToinit indica si ir al inicio o al final
     * @memberof BcStepperBehavior
     */
    moveToInitOrFinalYear(goToinit, calendarBehavior) {
        const getValues = calendarBehavior.yearGroupName.textContent.split('-');
        const init = getValues[0];
        const final = getValues[1];
        if (goToinit) {
            document.getElementById(`${BcDateConstants.ID_YEAR}${init}`)?.focus();
        }
        else {
            document.getElementById(`${BcDateConstants.ID_YEAR}${final}`)?.focus();
        }
    }
    /**
     *añede los listeners tecla por tecla
     *para un calendario en estado de seleccion de mes
     * @param event evento disparado
     * @param element elemento al cual se le agregan los listeners
     * @param myMap arreglo para identificar la pulsacion de dos teclas simultaneas
     * @memberof BcStepperBehavior
     */
    accessibilityMonths(event, element, myMap, calendarBehavior) {
        if (myMap.has(event.key)) {
            this.pageUpPageDownAndAltMonths(myMap, event, element, calendarBehavior);
        }
        else {
            this.keyEventsMonths(event, element, calendarBehavior);
        }
    }
    /**
    *añede los listeners tecla por tecla
    *que solo pude ser presionada en sola
    *para un calendario en estado de seleccion de mes
    * @param event evento disparado
    * @param element elemento al cual se le agregan los listeners
    * @memberof BcStepperBehavior
    */
    keyEventsMonths(event, element, calendarBehavior) {
        if (event.key === BcCommonConstants.KEY_EVENT_ARROW_LEFT) {
            this.moveMonths(element, -BcDateConstants.NUMBERS.CALENDAR_N1);
        }
        else if (event.key === BcCommonConstants.KEY_EVENT_ARROW_RIGHT) {
            this.moveMonths(element, BcDateConstants.NUMBERS.CALENDAR_N1);
        }
        else if (event.key === BcCommonConstants.KEY_EVENT_ARROW_UP) {
            this.moveMonths(element, -BcDateConstants.NUMBERS.CALENDAR_N4);
        }
        else if (event.key === BcCommonConstants.KEY_EVENT_ARROW_DOWN) {
            this.moveMonths(element, BcDateConstants.NUMBERS.CALENDAR_N4);
        }
        else if (event.key === BcCommonConstants.KEY_EVENT_HOME) {
            this.moveToMonths(0);
        }
        else if (event.key === BcCommonConstants.KEY_EVENT_END) {
            this.moveToMonths(BcDateConstants.NUMBERS.CALENDAR_N11);
        }
        else if (event.key === BcCommonConstants.KEY_EVENT_ENTER || event.key === BcCommonConstants.KEY_EVENT_SPACE) {
            calendarBehavior.selectMonth(parseInt(element.getAttribute(BcDateConstants.MONTH_NUMBER)), calendarBehavior.displayedMonths[0]);
        }
    }
    /**
     * añade los listeners tecla para las teclas pageUp PageDown y Alt
     * para un calendario en estado de seleccion de mes
     * ya que se puden oprimir en simultaneo o solas
     * @param myMap arreglo para identificar la pulsacion de dos teclas simultaneas
     * @param event evento disparado
     * @param element elemento al cual se le agregan los listeners
     * @memberof BcStepperBehavior
     */
    pageUpPageDownAndAltMonths(myMap, event, element, calendarBehavior) {
        myMap.set(event.key, true);
        if (!myMap.get(BcCommonConstants.KEY_EVENT_ALT) && myMap.get(BcCommonConstants.KEY_EVENT_PAGE_UP)) {
            this.displaceYears(calendarBehavior.displayedMonths[0], -BcDateConstants.NUMBERS.CALENDAR_N1, calendarBehavior);
            this.moveMonths(element, 0);
        }
        if (!myMap.get(BcCommonConstants.KEY_EVENT_ALT) && myMap.get(BcCommonConstants.KEY_EVENT_PAGE_DOWN)) {
            this.displaceYears(calendarBehavior.displayedMonths[0], BcDateConstants.NUMBERS.CALENDAR_N1, calendarBehavior);
            this.moveMonths(element, 0);
        }
        if (myMap.get(BcCommonConstants.KEY_EVENT_ALT) && myMap.get(BcCommonConstants.KEY_EVENT_PAGE_UP)) {
            this.displaceYears(calendarBehavior.displayedMonths[0], -BcDateConstants.NUMBERS.CALENDAR_N10, calendarBehavior);
            this.moveMonths(element, 0);
        }
        if (myMap.get(BcCommonConstants.KEY_EVENT_ALT) && myMap.get(BcCommonConstants.KEY_EVENT_PAGE_DOWN)) {
            this.displaceYears(calendarBehavior.displayedMonths[0], BcDateConstants.NUMBERS.CALENDAR_N10, calendarBehavior);
            this.moveMonths(element, 0);
        }
    }
    /**
     * funcion para moverse entre meses con las teclas
     * @param month mes actual
     * @param howMany cuantos meses se va a mover
     * @memberof BcStepperBehavior
     */
    moveMonths(month, howMany) {
        const next = (parseInt(month.getAttribute(BcDateConstants.MONTH_NUMBER)) + howMany).toString();
        document.getElementById(`${BcDateConstants.ID_MONTH}${next}`)?.focus();
    }
    /**
     * funcion para moverse al mes indicado
     * @param monthNumber numero del mes al cual se quiere mover
     * @memberof BcStepperBehavior
     */
    moveToMonths(monthNumber) {
        document.getElementById(`${BcDateConstants.ID_MONTH}${monthNumber}`)?.focus();
    }
    /**
     * añade los listeners para verificar si una tecla ha sido activada
     * por el usuario en el componente
     * @param element elento al cual se le agrega el listener
     * @param {boolean} dayEnabled solo se recibe si el elemento es un dia
     * ya que los dias no activos no se pueden seleccionar
     * @memberof BcStepperBehavior
     */
    keyReader(element, calendarBehavior, dayEnabled) {
        const myMap = new Map([
            [BcCommonConstants.KEY_EVENT_ALT, false],
            [BcCommonConstants.KEY_EVENT_PAGE_DOWN, false],
            [BcCommonConstants.KEY_EVENT_PAGE_UP, false],
        ]);
        element.addEventListener(BcCommonConstants.EVENT_KEY_DOWN, (event) => {
            if (calendarBehavior.calendarState == BcDateConstants.STATE_YEARS) {
                this.accessibilityYears(event, element, myMap, calendarBehavior);
            }
            else if (calendarBehavior.calendarState == BcDateConstants.STATE_MONTHS) {
                this.accessibilityMonths(event, element, myMap, calendarBehavior);
            }
            else {
                this.accessibilityDays(event, element, myMap, dayEnabled, calendarBehavior);
            }
        });
        element.addEventListener(BcCommonConstants.EVENT_KEY_UP, (event) => {
            if (myMap.has(event.key)) {
                myMap.set(event.key, false);
            }
        });
    }
    /**
     *añede los listeners tecla por tecla
     *para un calendario en estado de seleccion de dia
     * @param event evento disparado
     * @param element elemento al cual se le agregan los listeners
     * @param myMap arreglo para identificar la pulsacion de dos teclas simultaneas
     * @memberof BcStepperBehavior
     */
    accessibilityDays(event, element, myMap, dayEnabled, calendarBehavior) {
        if (myMap.has(event.key)) {
            this.pageUpPageDownAndAltDays(myMap, event, element, calendarBehavior);
        }
        else {
            this.keyEventsDays(event, element, dayEnabled, calendarBehavior);
        }
    }
    /**
     *añede los listeners tecla por tecla
     *que solo pude ser presionada en sola
     *para un calendario en estado de seleccion de dia
     * @param event evento disparado
     * @param element elemento al cual se le agregan los listeners
     * @param dayEnabled representa si el dia esta activo o no
     * @memberof BcStepperBehavior
     */
    keyEventsDays(event, element, dayEnabled, calendarBehavior) {
        if (event.key === BcCommonConstants.KEY_EVENT_ARROW_LEFT) {
            this.moveDay(element, -BcDateConstants.NUMBERS.CALENDAR_N1);
        }
        else if (event.key === BcCommonConstants.KEY_EVENT_ARROW_RIGHT) {
            this.moveDay(element, BcDateConstants.NUMBERS.CALENDAR_N1);
        }
        else if (event.key === BcCommonConstants.KEY_EVENT_ARROW_UP) {
            this.moveDay(element, -BcDateConstants.NUMBERS.CALENDAR_N7);
        }
        else if (event.key === BcCommonConstants.KEY_EVENT_ARROW_DOWN) {
            this.moveDay(element, BcDateConstants.NUMBERS.CALENDAR_N7);
        }
        else if (event.key === BcCommonConstants.KEY_EVENT_HOME) {
            this.moveToDay(BcDateConstants.NUMBERS.CALENDAR_N1);
        }
        else if (event.key === BcCommonConstants.KEY_EVENT_END) {
            this.moveToDay(this.getNumberOfDays(calendarBehavior.displayedMonths[0].month, calendarBehavior.displayedMonths[0].year));
        }
        else if ((event.key === BcCommonConstants.KEY_EVENT_ENTER || event.key === BcCommonConstants.KEY_EVENT_SPACE) &&
            dayEnabled) {
            calendarBehavior.selectDateByButton();
        }
    }
    /**
     * añade los listeners tecla para las teclas pageUp PageDown y Alt
     * para un calendario en estado de seleccion de dia
     * ya que se puden oprimir en simultaneo o solas
     * @param myMap arreglo para identificar la pulsacion de dos teclas simultaneas
     * @param event evento disparado
     * @param element elemento al cual se le agregan los listeners
     * @memberof BcStepperBehavior
     */
    pageUpPageDownAndAltDays(myMap, event, element, calendarBehavior) {
        myMap.set(event.key, true);
        if (!myMap.get(BcCommonConstants.KEY_EVENT_ALT) && myMap.get(BcCommonConstants.KEY_EVENT_PAGE_UP)) {
            this.goToPreviousMonth(calendarBehavior.displayedMonths[0]);
            calendarBehavior.setUpDisplayedMonthElement(calendarBehavior.displayedMonths[0]);
            this.moveDay(element, 0);
        }
        if (!myMap.get(BcCommonConstants.KEY_EVENT_ALT) && myMap.get(BcCommonConstants.KEY_EVENT_PAGE_DOWN)) {
            this.goToNextMonth(calendarBehavior.displayedMonths[0]);
            calendarBehavior.setUpDisplayedMonthElement(calendarBehavior.displayedMonths[0]);
            this.moveDay(element, 0);
        }
        if (myMap.get(BcCommonConstants.KEY_EVENT_ALT) && myMap.get(BcCommonConstants.KEY_EVENT_PAGE_UP)) {
            this.displaceYears(calendarBehavior.displayedMonths[0], -1, calendarBehavior);
            this.moveDay(element, 0);
        }
        if (myMap.get(BcCommonConstants.KEY_EVENT_ALT) && myMap.get(BcCommonConstants.KEY_EVENT_PAGE_DOWN)) {
            this.displaceYears(calendarBehavior.displayedMonths[0], 1, calendarBehavior);
            this.moveDay(element, 0);
        }
    }
    /**
     * funcion para moverse entre dias con las teclas
     * @param month dia actual
     * @param howMany cuantos dias se va a mover
     * @memberof BcStepperBehavior
     */
    moveDay(day, howMany) {
        const next = (parseInt(day.textContent) + howMany).toString();
        document.getElementById(`${BcDateConstants.ID_DAY}${next}`)?.focus();
    }
    /**
     * funcion para moverse al dia indicado
     * @param dayNumber numero del dia al cual se quiere mover
     * @memberof BcStepperBehavior
     */
    moveToDay(dayNumber) {
        document.getElementById(`${BcDateConstants.ID_DAY}${dayNumber}`)?.focus();
    }
    /**
     * Cambia el año en cada mes del calendario
     * @param {DisplayedMonth} displayedMonth = Elemento de el calendario en pantalla
     * @memberof BcCalendarUtilities
     * @void
     */
    displaceYears(displayedMonth, years, calendarBehavior) {
        displayedMonth.year += years;
        calendarBehavior.setElementsWithCalendarState(displayedMonth);
    }
}

class BcCalendarRangeBehavior {
    constructor() {
        this.bcCalendarUtilities = new BcCalendarUtilities();
    }
    /**
     * Permite inicializar los valores de fecha minima y maxima
     * @memberof BcCalendarUtilities
     * @void
     */
    setUpMinAndMaxDate(calendarBehavior, min, max) {
        if (min && !isNaN(Date.parse(min))) {
            calendarBehavior.minDate = new Date(min);
            calendarBehavior.minDate.setUTCHours(0, 0, 0, 0);
        }
        if (max && !isNaN(Date.parse(max))) {
            calendarBehavior.maxDate = new Date(max);
            calendarBehavior.maxDate.setUTCHours(0, 0, 0, 0);
        }
    }
    /**
     * Inicializa los listeners para el calendario con el selector dividido
     * @memberof BcCalendarUtilities
     * @void
     */
    addListenersForSplitSelectorCalendar(calendarBehavior) {
        this.addListenerToMonthBtn(calendarBehavior);
        calendarBehavior.monthTopBar.addEventListener(BcCommonConstants.EVENT_CLICK, (event) => {
            calendarBehavior.setElementsForMonthSelector();
            event.stopPropagation();
        }, { once: true });
        calendarBehavior.prevYearBtn.addEventListener(BcCommonConstants.EVENT_CLICK, (event) => {
            this.bcCalendarUtilities.displaceYears(calendarBehavior.displayedMonths[0], -1, calendarBehavior);
            event.stopPropagation();
        });
        calendarBehavior.yearTopBar.addEventListener(BcCommonConstants.EVENT_CLICK, (event) => {
            calendarBehavior.setElementsForYearSelector();
            event.stopPropagation();
        }, { once: true });
        calendarBehavior.nextYearBtn.addEventListener(BcCommonConstants.EVENT_CLICK, (event) => {
            this.bcCalendarUtilities.displaceYears(calendarBehavior.displayedMonths[0], 1, calendarBehavior);
            event.stopPropagation();
        });
        this.addLestenerEnterKeyForSplitSelectorCalendar(calendarBehavior);
    }
    addLestenerEnterKeyForSplitSelectorCalendar(calendarBehavior) {
        this.addEnterKeyListener(calendarBehavior.nextYearBtn, () => {
            this.bcCalendarUtilities.displaceYears(calendarBehavior.displayedMonths[0], 1, calendarBehavior);
            calendarBehavior.nextYearBtn.focus();
        });
        this.addEnterKeyListener(calendarBehavior.monthTopBar, () => {
            calendarBehavior.setElementsForMonthSelector();
        });
        this.addEnterKeyListener(calendarBehavior.prevYearBtn, () => {
            this.bcCalendarUtilities.displaceYears(calendarBehavior.displayedMonths[0], -1, calendarBehavior);
            calendarBehavior.prevYearBtn.focus();
        });
        this.addEnterKeyListener(calendarBehavior.yearTopBar, () => {
            calendarBehavior.setElementsForYearSelector();
        });
    }
    /**
     * Inicializa los listeners para el boton de mes
     * @memberof BcCalendarUtilities
     * @void
     */
    addListenerToMonthBtn(calendarBehavior) {
        calendarBehavior.prevMonthBtn.addEventListener(BcCommonConstants.EVENT_CLICK, (event) => {
            this.bcCalendarUtilities.goToPreviousMonth(calendarBehavior.displayedMonths[0]);
            calendarBehavior.setUpDisplayedMonthElement(calendarBehavior.displayedMonths[0]);
            event.stopPropagation();
        });
        this.addEnterKeyListener(calendarBehavior.prevMonthBtn, (event) => {
            this.bcCalendarUtilities.goToPreviousMonth(calendarBehavior.displayedMonths[0]);
            calendarBehavior.setUpDisplayedMonthElement(calendarBehavior.displayedMonths[0]);
            calendarBehavior.prevMonthBtn.focus();
            event.stopPropagation();
        });
        calendarBehavior.nextMonthBtn.addEventListener(BcCommonConstants.EVENT_CLICK, (event) => {
            this.bcCalendarUtilities.goToNextMonth(calendarBehavior.displayedMonths[0]);
            calendarBehavior.setUpDisplayedMonthElement(calendarBehavior.displayedMonths[0]);
            event.stopPropagation();
        });
        this.addEnterKeyListener(calendarBehavior.nextMonthBtn, (event) => {
            this.bcCalendarUtilities.goToNextMonth(calendarBehavior.displayedMonths[0]);
            calendarBehavior.setUpDisplayedMonthElement(calendarBehavior.displayedMonths[0]);
            calendarBehavior.nextMonthBtn.focus();
            event.stopPropagation();
        });
    }
    /**
     * Inicializa los listeners para cuando se levanta de la tecla enter
     * @param {Element} element  elemento al cual se le añade el listener
     * @param {Function} Do funcion que se ejecuta al levantar la tecla enter
     * @memberof BcCalendarUtilities
     * @void
     */
    addEnterKeyListener(element, Do) {
        element.addEventListener(BcCommonConstants.EVENT_KEY_UP, (event) => {
            if (event.key === BcCommonConstants.KEY_EVENT_ENTER) {
                Do();
            }
        });
    }
    /**
     * Agrega al elemento de calendario simple los 12 meses del año para hacer un selector de meses
     * @memberof BcCalendarUtilities
     * @void
     */
    addMonthsPicker(calendarBehavior) {
        for (let i = 0; i < BcDateConstants.MONTHS_TEXT.length; i++) {
            const month = document.createElement('p');
            month.textContent = BcDateConstants.MONTHS_TEXT[i].substring(0, BcDateConstants.NUMBERS.CALENDAR_N3);
            if (calendarBehavior.today.getMonth() == i &&
                calendarBehavior.today.getFullYear() == calendarBehavior.displayedMonths[0].year) {
                month.classList.add(BcDateConstants.THIS_MONTH_OR_YEAR_CLASS);
            }
            calendarBehavior.monthsOrYearsContainer.appendChild(month);
            addFocusable(month, { tabindex: '0' });
            this.bcCalendarUtilities.focusListeners(month);
            month.setAttribute(BcDateConstants.ID, `${BcDateConstants.ID_MONTH}${i}`);
            month.setAttribute(BcDateConstants.MONTH_NUMBER, `${i}`);
            this.bcCalendarUtilities.keyReader(month, calendarBehavior);
            this.addListenerToSelectMonth(month, i, calendarBehavior);
        }
    }
    /**
     * Inicializa los listeners de casa mes para el calendario simple en
     * cuando esta en el modo de selector de meses
     * @param {Element} element - elemento de mes (normalmente un 'p').
     * @memberof BcCalendarUtilities
     * @void
     */
    addListenerToSelectMonth(element, index, calendarBehavior) {
        element.addEventListener(BcCommonConstants.EVENT_CLICK, (event) => {
            calendarBehavior.selectMonth(index, calendarBehavior.displayedMonths[0]);
            if (this.getFormatAttributte(calendarBehavior) === DateFormate.mediumDate) {
                calendarBehavior.selectCalendarOption(element, this.getFormatAttributte(calendarBehavior));
            }
            event.stopPropagation();
        });
    }
    getFormatAttributte(calendarBehavior) {
        return calendarBehavior.calendarsContainer.parentElement?.parentElement.querySelectorAll('input')[0].getAttribute(BcDateConstants.FORMAT_DATE);
    }
    /**
     * Cambia el grupo de años del calendario cuando es el selector de años
     * @memberof BcCalendarUtilities
     * @void
     */
    nextYearGroup(calendarBehavior) {
        const displayedMonth = calendarBehavior.displayedMonths[0];
        displayedMonth.year += BcDateConstants.NUMBERS.CALENDAR_N12;
        calendarBehavior.yearGroup = [displayedMonth.year - BcDateConstants.NUMBERS.CALENDAR_N11, displayedMonth.year];
        calendarBehavior.setElementsWithCalendarState(displayedMonth);
    }
    /**
     * Inicializa los listeners de cada elemento (dia del mes) cada vez que se carga
     * un nuevo mes en pantalla
     * @param {Element} element - elemento de el dia del mes (normalmente un 'p').
     * @memberof BcCalendarUtilities
     * @void
     */
    addListenerToSelectDate(element, calendarBehavior) {
        element.addEventListener(BcCommonConstants.EVENT_CLICK, (event) => {
            calendarBehavior.selectCalendarOption(element, DateFormate.fullDate);
            event.stopPropagation();
        });
        element.addEventListener(BcCommonConstants.EVENT_FOCUS, () => {
            calendarBehavior.focus = element.textContent;
        });
    }
    /**
     * Se encarga de revisiar si el dia esta en el rango dado
     * @param {DisplayedMonth} informacion del mes
     * @param {number} dayNumber dia que se va a revisar
     * @param {boolean} dayEnabled indicador de si el dia esta en el rango o no se resive por defeto en verdadero y se cambia de ser necesario
     * @param {HTMLParagraphElement} day elemento dia
     * @return {boolean} si el dia esta dentro del rango o no
     * @memberof BcCalendarUtilities
     */
    maxAndMinDate(monthInfo, dayNumber, dayEnabled, day, calendarBehavior) {
        if (calendarBehavior.minDate || calendarBehavior.maxDate) {
            const dayFullDate = new Date(`${monthInfo.year}-${monthInfo.month + 1}-${dayNumber}`);
            dayFullDate.setUTCHours(0, 0, 0, 0);
            if (calendarBehavior.minDate && dayFullDate < calendarBehavior.minDate) {
                dayEnabled = false;
            }
            if (calendarBehavior.maxDate && dayFullDate > calendarBehavior.maxDate) {
                dayEnabled = false;
            }
        }
        if (dayEnabled) {
            this.addListenerToSelectDate(day, calendarBehavior);
        }
        else {
            day.classList.add(BcDateConstants.DISABLED_DAY);
        }
        return dayEnabled;
    }
    /**
     * Crea un elemento de mes
     * @param {DisplayedMonth} informacion del mes a pintar
     * @param {string} Html en string de la barra superior de cada mes
     * @return {Element} El elemento de mes que necesita cada tipo de calendario.
     * @memberof BcCalendarUtilities
     */
    createAMonthElement(monthInfo, topBar, calendarBehavior, includeHolidays) {
        const configMonthElements = this.bcCalendarUtilities.configMonthElement(topBar, monthInfo);
        for (let dayNumber = 1 - configMonthElements.emptyDays; dayNumber <= this.bcCalendarUtilities.getNumberOfDays(monthInfo.month, monthInfo.year); dayNumber++) {
            this.creatingAMonthElement(dayNumber, configMonthElements, monthInfo, calendarBehavior, includeHolidays);
        }
        return configMonthElements.element;
    }
    creatingAMonthElement(dayNumber, configMonthElements, monthInfo, calendarBehavior, includeHolidays) {
        if (dayNumber < 1) {
            const empty = document.createElement('div');
            configMonthElements.month.appendChild(empty);
        }
        else {
            const day = document.createElement('p');
            let dayEnabled = true;
            day.classList.add(BcCommonConstants.SMALL, BcDateConstants.DAY);
            day.textContent = dayNumber < 1 ? '' : dayNumber.toString();
            configMonthElements.month.appendChild(day);
            configMonthElements.tempDate.setDate(dayNumber);
            if (configMonthElements.tempDate.toDateString() == calendarBehavior.today.toDateString()) {
                day.classList.add(BcDateConstants.TODAY_CLASS);
            }
            if (includeHolidays == 'yes') {
                this.bcCalendarUtilities.holidays(dayNumber, monthInfo, day);
            }
            addFocusable(day, { tabindex: '0' });
            this.bcCalendarUtilities.focusListeners(day);
            this.bcCalendarUtilities.setDayAttribute(day, monthInfo);
            dayEnabled = calendarBehavior.bcCalendarRange.maxAndMinDate(monthInfo, dayNumber, dayEnabled, day, calendarBehavior);
            this.bcCalendarUtilities.keyReader(day, calendarBehavior, dayEnabled);
        }
    }
    /**
     * Inicializa los listeners para el calendario simple en el selector de dias del mes
     * @memberof BcCalendarUtilities
     * @void
     */
    addListenersForPrevAndNextBtns(calendarBehavior) {
        calendarBehavior.next.addEventListener(BcCommonConstants.EVENT_CLICK, (event) => {
            this.nextAction(calendarBehavior),
                {
                    once: true,
                };
            event.stopPropagation();
        });
        calendarBehavior.prev.addEventListener(BcCommonConstants.EVENT_CLICK, (event) => {
            this.prevAction(calendarBehavior),
                {
                    once: true,
                };
            event.stopPropagation();
        });
    }
    /**
     * Dependiendo del estado de calendario se ejecuta una accion al darle en el boton 'previous'
     * @memberof BcCalendarUtilities
     * @void
     */
    prevAction(calendarBehavior) {
        if (calendarBehavior.calendarState === BcDateConstants.STATE_DAYS) {
            this.bcCalendarUtilities.goToPreviousMonth(calendarBehavior.displayedMonths[0]);
            calendarBehavior.setUpDisplayedMonthElement(calendarBehavior.displayedMonths[0]);
        }
        else if (calendarBehavior.calendarState === BcDateConstants.STATE_RANGE) {
            calendarBehavior.displayedMonths.forEach((item) => {
                this.bcCalendarUtilities.goToPreviousMonth(item);
            });
            calendarBehavior.setUpDisplayedMonthElement();
        }
        calendarBehavior.addBorderSelectedDates();
    }
    /**
     * En la pantañña de selección de años este cambia un grupo de 12 años por los años anteriores
     * @memberof BcCalendarUtilities
     * @void
     */
    previousYearGroup(displayedMonth, calendarBehavior) {
        displayedMonth.year -= 12;
        calendarBehavior.yearGroup = [displayedMonth.year - BcDateConstants.NUMBERS.CALENDAR_N11, displayedMonth.year];
        calendarBehavior.setElementsWithCalendarState(displayedMonth);
    }
    /**
     * Dependiendo del estado de calendario se ejecuta una accion al darle en el boton 'next'
     * @memberof BcCalendarUtilities
     * @void
     */
    nextAction(calendarBehavior) {
        if (calendarBehavior.calendarState === BcDateConstants.STATE_RANGE) {
            calendarBehavior.displayedMonths.forEach((item) => {
                this.bcCalendarUtilities.goToNextMonth(item);
            });
            calendarBehavior.setUpDisplayedMonthElement();
        }
        else {
            this.bcCalendarUtilities.goToNextMonth(calendarBehavior.displayedMonths[0]);
            calendarBehavior.setUpDisplayedMonthElement(calendarBehavior.displayedMonths[0]);
        }
        calendarBehavior.addBorderSelectedDates();
    }
    /**
     * Busca los botones en el dom y les pone un listener
     * @memberof BcCalendarUtilities
     * @void
     */
    addListenerToBtnYearGroup(calendarBehavior) {
        addFocusable(calendarBehavior.next, { tabindex: '0' });
        addFocusable(calendarBehavior.prev, { tabindex: '0' });
        this.bcCalendarUtilities.focusListeners(calendarBehavior.next);
        this.bcCalendarUtilities.focusListeners(calendarBehavior.prev);
        calendarBehavior.next.addEventListener(BcCommonConstants.EVENT_CLICK, (event) => {
            this.nextYearGroup(calendarBehavior);
            event.stopPropagation();
        });
        this.addEnterKeyListener(calendarBehavior.next, (event) => {
            this.nextYearGroup(calendarBehavior);
            event.stopPropagation();
        });
        calendarBehavior.prev.addEventListener(BcCommonConstants.EVENT_CLICK, (event) => {
            this.previousYearGroup(calendarBehavior.displayedMonths[0], calendarBehavior);
            event.stopPropagation();
        });
        this.addEnterKeyListener(calendarBehavior.prev, (event) => {
            this.previousYearGroup(calendarBehavior.displayedMonths[0], calendarBehavior);
            event.stopPropagation();
        });
    }
    /**
     * Selecciona un rango con los botones de selección  Automatica
     * @param {number} daysToGoBack = días que se deben restar para seleciconar la segunda fecha
     * @memberof BcCalendarUtilities
     * @void
     */
    automaticRange(daysToGoBack, calendarBehavior) {
        if (calendarBehavior.date == null) {
            calendarBehavior.date = calendarBehavior.today;
        }
        const dateToSelect = new Date(calendarBehavior.date.getFullYear(), calendarBehavior.date.getMonth(), calendarBehavior.date.getDate() - daysToGoBack);
        calendarBehavior.dateTwo = dateToSelect;
        calendarBehavior.addDatesToArraySelectRangeAndSort();
        calendarBehavior.btnConfirm.removeAttribute('disabled');
        calendarBehavior.addBorderSelectedDates();
    }
}

class BcCalendarBehavior extends BcDefaultBehavior {
    constructor() {
        super(...arguments);
        this.today = new Date();
        this.yearGroup = [this.today.getFullYear() - BcDateConstants.NUMBERS.CALENDAR_N11, this.today.getFullYear()];
        this.displayedMonths = [];
        this.bcCalendarUtilities = new BcCalendarUtilities();
        this.bcCalendarRange = new BcCalendarRangeBehavior();
    }
    /**
     * @fileoverview Configura todos los elementos en el DOM que
     * posean la clase a la cual hace referencia un Tooltip.
     * @description Llama el metodo de configuración del
     * objeto del tipo en cuestión. Por tanto este debe estár implementado
     * en la clase.
     * @memberof BcCalendarUtilities
     * @returns {BcCalendarBehavior[]} Listado de elementos de ese tipo en el DOM.
     */
    static setUpAll() {
        const calendarElements = Array.from(document.querySelectorAll(`div[class='${BcDateConstants.CALENDAR_CLASS}']`));
        const elements = [];
        for (const element of calendarElements) {
            const calendarBehavior = new BcCalendarBehavior();
            calendarBehavior.setElement(element);
            calendarBehavior.setUp();
            elements.push(calendarBehavior);
        }
        return elements;
    }
    /**
     * Permite inica los elementos necesarios para un calendario
     * dependiendo del tipo de calendario que se solicite
     * @memberof BcCalendarUtilities
     * @void
     */
    _setUp() {
        const mobile = this.bcCalendarUtilities.maxScreenWidth();
        this.calendarsContainer = this.mySelf;
        this.bcCalendarRange.setUpMinAndMaxDate(this, this.mySelf.getAttribute('min'), this.mySelf.getAttribute('max'));
        switch (this.mySelf.getAttribute('type')) {
            case BcDateConstants.STATE_RANGE:
                this.caseStateRange(mobile);
                break;
            case BcDateConstants.STATE_SPLIT:
                this.displayedMonths = [
                    this.bcCalendarUtilities.getOneSimpleMonth(this.today.getMonth(), this.today.getFullYear()),
                ];
                this.splitCalendarSetUp();
                break;
            default:
                this.displayedMonths = [
                    this.bcCalendarUtilities.getOneSimpleMonth(this.today.getMonth(), this.today.getFullYear()),
                ];
                this.simpleCalendarSetUp();
                break;
        }
        if (this.mySelf.getAttribute('type') !== BcDateConstants.STATE_RANGE) {
            this.setElementsWithFormatDate();
        }
    }
    caseStateRange(mobile) {
        if (mobile) {
            this.displayedMonths = this.bcCalendarUtilities.getTwelveScrollableMonths(this.today.getMonth(), this.today.getFullYear());
            this.rangeMobileCalendarSetUp();
        }
        else {
            this.displayedMonths = this.bcCalendarUtilities.getTwoRangeMonths(this.today.getMonth(), this.today.getFullYear());
            this.rangeDesktopCalendarSetUp();
        }
    }
    /**
     * Crea todos los elementos calendar que hayan en pantalla
     * @memberof BcCalendarUtilities
     * @void
     */
    setUpDisplayedCalendars(calendarsContainer, topBar) {
        calendarsContainer.innerHTML = '';
        this.displayedMonths.forEach((displayedMonth) => {
            calendarsContainer.appendChild(this.bcCalendarRange.createAMonthElement(displayedMonth, topBar, this, this.mySelf.getAttribute(BcDateConstants.CALENDAR_HOLIDAY)));
        });
    }
    /**
     * Le da el valor a los elementos que son recurrentes en los calendarios simples
     * @memberof BcCalendarUtilities
     * @void
     */
    simpleCalendarSetUp() {
        this.setUpDisplayedCalendars(this.calendarsContainer, this.bcCalendarUtilities.topBarSingleMonth());
        this.calendarState = BcDateConstants.STATE_DAYS;
        this.topBarSelector = this.mySelf.querySelector(`.${BcDateConstants.TOP_BAR_SELECTOR_CLASS}`);
        this.next = this.mySelf.querySelector(`.${BcDateConstants.NEXT_CLASS}`);
        this.prev = this.mySelf.querySelector(`.${BcDateConstants.PREV_CLASS}`);
        this.monthAndDay = this.mySelf.querySelector('h6');
        this.monthAndDay.addEventListener(BcCommonConstants.EVENT_CLICK, (event) => {
            this.changeCalendarType();
            event.stopPropagation();
        });
        if (this.bcCalendarUtilities.maxScreenWidth()) {
            this.prependMobileTitleText();
        }
        this.bcCalendarRange.addListenersForPrevAndNextBtns(this);
        if (this.mySelf.getAttribute(BcDateConstants.CALENDAR_BUTTON) != null &&
            this.mySelf.getAttribute(BcDateConstants.CALENDAR_BUTTON) != 'null' &&
            this.mySelf.getAttribute('type') != BcDateConstants.STATE_RANGE) {
            this.mySelf.appendChild(this.getBottomSimple());
        }
        if (this.mySelf.getAttribute(BcDateConstants.CALENDAR_BUTTON) != null &&
            this.mySelf.getAttribute(BcDateConstants.CALENDAR_FILTER) != 'null' &&
            this.mySelf.getAttribute('type') != BcDateConstants.STATE_RANGE) {
            this.topBarSelector.appendChild(this.configFilterSimple());
        }
    }
    /**
     * crea el filtro para el calendario simple
     * @memberof BcCalendarUtilities
     * @return el filtro para el calendario simple
     */
    configFilterSimple() {
        const filterValues = this.mySelf.getAttribute(BcDateConstants.CALENDAR_FILTER)
            ? this.mySelf.getAttribute(BcDateConstants.CALENDAR_FILTER)
            : '[]';
        const value = JSON.parse(filterValues)[0];
        const filterContainer = document.createElement('div');
        let text = 'hoy';
        if (JSON.parse(filterValues)[1] != '') {
            text = JSON.parse(filterValues)[1];
        }
        filterContainer.innerHTML = this.bcCalendarUtilities.filterSimple(text);
        const btn = filterContainer.querySelector(`button`);
        btn.addEventListener(BcCommonConstants.EVENT_CLICK, () => {
            if (value == 0) {
                this.selectDateByButton(this.today.getDate());
            }
            else {
                this.selectDateByButton(value);
            }
        });
        this.bcCalendarUtilities.focusListeners(filterContainer);
        return filterContainer;
    }
    /**
     * Agrega un titulo al calendario mobile
     * @memberof BcCalendarUtilities
     * @void
     */
    prependMobileTitleText() {
        const title = document.createElement('p');
        title.classList.add(BcDateConstants.MOBILE_TITLE_CLASS);
        title.textContent = BcDateConstants.MOBILE_CALENDAR_TITLE;
        this.mySelf.prepend(title);
        this.mySelf.insertAdjacentHTML('beforeend', `<em class="${BcCommonConstants.ICONS_CLASS}
      ${BcCommonConstants.ICON_SM_CLASS}
      ${BcDateConstants.CANCEL_CLASS} ${BcDateConstants.BTN_X_CLASS}">error</em>`);
        this.btnCancel = this.mySelf.querySelector(`.${BcDateConstants.CANCEL_CLASS}`);
        this.btnCancel.addEventListener(BcCommonConstants.EVENT_CLICK, () => {
            this.eventRangeCanceled();
        });
    }
    /**
     * va a cambiar las propiedades del elemento HTML
     * del displayedMonth y a hacerlo grafico en la pantalla cuando ya hay uno previo
     * @param {DisplayedMonth} displayedMonth mes en pantalla
     * @memberof BcCalendarUtilities
     * @void
     */
    setElementsWithCalendarState(displayedMonth) {
        switch (this.calendarState) {
            case BcDateConstants.STATE_SPLIT:
                this.setUpDisplayedMonthElement(displayedMonth);
                break;
            case BcDateConstants.STATE_MONTHS:
                this.setElementsForMonthSelector();
                break;
            case BcDateConstants.STATE_YEARS:
                this.setElementsForYearSelector();
                break;
            default:
                this.setUpDisplayedMonthElement(displayedMonth);
                break;
        }
    }
    /**
     * va a cambiar la vista del calendar dependiendo del date format ingresado por el usuario
     * @memberof BcCalendarUtilities
     * @void
     */
    setElementsWithFormatDate() {
        switch (this.mySelf.parentElement?.parentElement.querySelectorAll('input')[0].getAttribute(BcDateConstants.FORMAT_DATE)) {
            case DateFormate.fullDate:
                this.simpleCalendarSetUp();
                break;
            case DateFormate.mediumDate:
                this.setElementsForMonthSelector();
                break;
            case DateFormate.shortDate:
                this.setElementsForYearSelector();
                break;
            default:
                this.simpleCalendarSetUp();
                break;
        }
    }
    /**
     * va a cambiar las propiedades del elemento HTML
     * del displayedMonth y a hacerlo grafico en la pantalla
     * @param {DisplayedMonth} displayedMonth= el elemento completo del mes en pantalla.
     * @memberof BcCalendarUtilities
     * @void
     */
    setUpDisplayedMonthElement(displayedMonth) {
        switch (this.calendarState) {
            case BcDateConstants.STATE_RANGE:
                this.rangeDesktopCalendarSetUp();
                break;
            case BcDateConstants.STATE_SPLIT:
                this.splitCalendarSetUp();
                break;
            case BcDateConstants.STATE_DAYS:
                this.simpleCalendarSetUp();
                break;
            default:
                this.simpleCalendarSetUp();
        }
    }
    /**
     * crea el cuerpo y el topbar de un caendario
     * simple con el selector de mes y año dividido
     * @memberof BcCalendarUtilities
     * @void
     */
    setUpDisplayedCalendarse() {
        this.setUpDisplayedCalendars(this.calendarsContainer, this.bcCalendarUtilities.topBarSingleMonthSplitSelector());
        this.calendarState = BcDateConstants.STATE_SPLIT;
        this.topBarSelector = this.mySelf.querySelector(`.${BcDateConstants.TOP_BAR_SELECTOR_CLASS}`);
        this.prevMonthBtn = this.topBarSelector.childNodes[0];
        this.nextMonthBtn = this.topBarSelector.childNodes[BcDateConstants.NUMBERS.CALENDAR_N3];
        addFocusable(this.prevMonthBtn, { tabindex: '0' });
        addFocusable(this.nextMonthBtn, { tabindex: '0' });
        this.bcCalendarUtilities.focusListeners(this.prevMonthBtn);
        this.bcCalendarUtilities.focusListeners(this.nextMonthBtn);
    }
    /**
     * Le da el valor a los elementos necesarios para un calendario
     *  simple con el selector de mes y año dividido
     * @memberof BcCalendarUtilities
     * @void
     */
    splitCalendarSetUp() {
        this.setUpDisplayedCalendarse();
        this.prevYearBtn = this.topBarSelector.childNodes[BcDateConstants.NUMBERS.CALENDAR_N5];
        this.nextYearBtn = this.topBarSelector.childNodes[BcDateConstants.NUMBERS.CALENDAR_N7];
        addFocusable(this.prevYearBtn, { tabindex: '0' });
        addFocusable(this.nextYearBtn, { tabindex: '0' });
        this.bcCalendarUtilities.focusListeners(this.prevYearBtn);
        this.bcCalendarUtilities.focusListeners(this.nextYearBtn);
        if (this.bcCalendarUtilities.maxScreenWidth()) {
            this.prependMobileTitleText();
        }
        this.monthTopBar = this.topBarSelector.querySelectorAll('h6')[0];
        this.yearTopBar = this.topBarSelector.querySelectorAll('h6')[1];
        addFocusable(this.monthTopBar, { tabindex: '0' });
        addFocusable(this.yearTopBar, { tabindex: '0' });
        this.bcCalendarUtilities.focusListeners(this.monthTopBar);
        this.bcCalendarUtilities.focusListeners(this.yearTopBar);
        this.bcCalendarRange.addListenersForSplitSelectorCalendar(this);
        if (this.mySelf.getAttribute(BcDateConstants.CALENDAR_BUTTON) != null &&
            this.mySelf.getAttribute(BcDateConstants.CALENDAR_BUTTON) != 'null' &&
            this.mySelf.getAttribute('type') != BcDateConstants.STATE_RANGE) {
            this.mySelf.appendChild(this.getBottomSimple());
        }
    }
    /**
     * Cambia el año en el selector unico de años
     * @param {number} i = año de 4 digitos del calendario gregoriano
     * @memberof BcCalendarUtilities
     * @void
     */
    selectYear(i, displayedMonth) {
        displayedMonth.year = i;
        if (this.mySelf.getAttribute('type') === BcDateConstants.STATE_SPLIT) {
            this.splitCalendarSetUp();
        }
        else {
            this.setElementsForMonthSelector();
        }
    }
    /**
     * Inicializa los listeners de cada año para el calendario simple en
     * cuando esta en el modo de selector de años
     * @param {Element} element - elemento de año (normalmente un 'p').
     * @memberof BcCalendarUtilities
     * @void
     */
    addListenerToSelectYear(element, year) {
        element.addEventListener(BcCommonConstants.EVENT_CLICK, (event) => {
            this.selectYear(year, this.displayedMonths[0]);
            const format = this.mySelf.parentElement?.parentElement.querySelectorAll('input')[0].getAttribute(BcDateConstants.FORMAT_DATE);
            if (format === DateFormate.shortDate) {
                this.selectCalendarOption(element, format);
            }
            event.stopPropagation();
        });
        this.bcCalendarRange.addEnterKeyListener(element, () => {
            this.selectYear(year, this.displayedMonths[0]);
        });
    }
    /**
     * Le da valor a todos los elementos cuando estamos en el selector de meses
     * @memberof BcCalendarUtilities
     * @void
     */
    setElementsForMonthSelector() {
        this.calendarState = BcDateConstants.STATE_MONTHS;
        this.mySelf.innerHTML = this.bcCalendarUtilities.getCalendarSelectMonthOrYear();
        this.topBarSelector = this.mySelf.querySelector(`.${BcDateConstants.TOP_BAR_SELECTOR_CLASS}`);
        this.addPrevAndNextBtnsToChangeYear();
        this.changeYearAndAddListener();
        this.monthsOrYearsContainer = this.mySelf.querySelector(`.${BcDateConstants.MONTHS_OR_YEARS_CLASS}`);
        this.bcCalendarRange.addMonthsPicker(this);
        if (this.bcCalendarUtilities.maxScreenWidth()) {
            this.prependMobileTitleText();
        }
    }
    /**
     * Cambia textualmente el año en pantalla y le agrega un listener al
     *  elemento para cambiar al selector de años
     * @memberof BcCalendarUtilities
     * @void
     */
    changeYearAndAddListener() {
        const yearName = this.topBarSelector.querySelector('h6');
        addFocusable(yearName, { tabindex: '0' });
        this.bcCalendarUtilities.focusListeners(yearName);
        yearName.textContent = `${this.displayedMonths[0].year}`;
        yearName.addEventListener(BcCommonConstants.EVENT_CLICK, (event) => {
            this.changeCalendarType();
            event.stopPropagation();
        }, { once: true });
        this.bcCalendarRange.addEnterKeyListener(yearName, (event) => {
            this.changeCalendarType();
            event.stopPropagation();
        });
    }
    /**
     * Crea los elementos del selector de años
     * @memberof BcCalendarUtilities
     * @void
     */
    setElementsForYearSelector() {
        this.calendarState = BcDateConstants.STATE_YEARS;
        this.yearGroup = [
            this.displayedMonths[0].year - BcDateConstants.NUMBERS.CALENDAR_N11,
            this.displayedMonths[0].year,
        ];
        this.mySelf.innerHTML = this.bcCalendarUtilities.getCalendarSelectMonthOrYear();
        this.topBarSelector = this.mySelf.querySelector(`.${BcDateConstants.TOP_BAR_SELECTOR_CLASS}`);
        this.addPrevAndNextBtnsToChangeYearGroup();
        this.changeYearGroupAndAddListener();
        this.monthsOrYearsContainer = this.mySelf.querySelector(`.${BcDateConstants.MONTHS_OR_YEARS_CLASS}`);
        this.addYearsPicker();
        if (this.bcCalendarUtilities.maxScreenWidth()) {
            this.prependMobileTitleText();
        }
    }
    /**
     * Cambia textualmente el año en pantalla y le agrega un listener al
     * elemento para cambiar al selector de años
     * @memberof BcCalendarUtilities
     * @void
     */
    changeYearGroupAndAddListener() {
        this.yearGroupName = this.topBarSelector.querySelector('h6');
        addFocusable(this.yearGroupName, { tabindex: '0' });
        this.bcCalendarUtilities.focusListeners(this.yearGroupName);
        this.yearGroupName.textContent = `${this.yearGroup[0]} - ${this.yearGroup[1]}`;
        this.yearGroupName.addEventListener(BcCommonConstants.EVENT_CLICK, (event) => {
            this.changeCalendarType();
            event.stopPropagation();
        }, { once: true });
        this.bcCalendarRange.addEnterKeyListener(this.yearGroupName, (event) => {
            this.changeCalendarType();
            event.stopPropagation();
        });
    }
    /**
     * Los botones del array se crean en el dom
     * @param {number[]} numbers: los valores de cada boton que debe ser creado
     * @memberof BcCalendarUtilities
     * @void
     */
    createBtnsfromArray(numbers, texts) {
        if (numbers != null) {
            for (let i = 0; i < numbers.length; i++) {
                this.upperBtnsContainer.appendChild(this.bcCalendarUtilities.createARangeButton(numbers[i], texts ? texts[i] : null));
            }
        }
    }
    /**
     * crea el contedor y los botones para un calendario rango
     * @memberof BcCalendarUtilities
     * @void
     */
    rangeDesktopCalendarFirstSet() {
        this.calendarState = BcDateConstants.STATE_RANGE;
        this.mySelf.innerHTML = '';
        this.mySelf.innerHTML = this.bcCalendarUtilities.getRangeCalendarButtons();
        this.upperBtnsContainer = this.mySelf.querySelector(`.${BcDateConstants.UPPPER_BTNS_CLASS}`);
        const rangesBtns = this.mySelf.getAttribute(BcDateConstants.RANGES)
            ? this.mySelf.getAttribute(BcDateConstants.RANGES)
            : '[]';
        let rangeBtnsArray = [];
        try {
            rangeBtnsArray = JSON.parse(rangesBtns);
        }
        catch (err) {
            rangeBtnsArray = [];
        }
        const rangesTextBtns = this.mySelf.getAttribute(BcDateConstants.RANGES_TEXT)
            ? this.mySelf.getAttribute(BcDateConstants.RANGES_TEXT)
            : '[]';
        let rangeTextBtnsArray = [];
        try {
            rangeTextBtnsArray = JSON.parse(rangesTextBtns);
        }
        catch (err) {
            rangeTextBtnsArray = [];
        }
        this.createBtnsfromArray(rangeBtnsArray, rangeTextBtnsArray);
    }
    /**
     * Inicializa los elementos para el funcionamiento de un calendario de rango
     * @memberof BcCalendarUtilities
     * @void
     */
    rangeDesktopCalendarSetUp() {
        this.rangeDesktopCalendarFirstSet();
        this.calendarsContainer = document.createElement('div');
        this.calendarsContainer.classList.add(BcDateConstants.TWO_CALENDARS_CLASS);
        this.mySelf.appendChild(this.calendarsContainer);
        this.setUpDisplayedCalendars(this.calendarsContainer, this.bcCalendarUtilities.topBarSingleMonth());
        this.mySelf.appendChild(this.getDesktopConfirmBottomRange());
        this.mySelf.querySelectorAll(`.${BcDateConstants.NEXT_CLASS}`)[0].textContent = ' ';
        this.mySelf.querySelectorAll(`.${BcDateConstants.PREV_CLASS}`)[1].textContent = ' ';
        this.next = this.mySelf.querySelectorAll(`.${BcDateConstants.NEXT_CLASS}`)[1];
        this.prev = this.mySelf.querySelectorAll(`.${BcDateConstants.PREV_CLASS}`)[0];
        if (this.selectedDates) {
            this.selectRange();
        }
        this.addButtonListenersForConfirmAndCancel();
        this.bcCalendarRange.addListenersForPrevAndNextBtns(this);
        this.addButtonListenersForUpperBtns();
    }
    /**
     * Inicializa los elementos para el funcionamiento de un calendario de rango en mobil
     * @memberof BcCalendarUtilities
     * @void
     */
    rangeMobileCalendarSetUp() {
        this.calendarState = BcDateConstants.STATE_RANGE;
        this.mySelf.innerHTML = '';
        this.mySelf.classList.add(BcDateConstants.MOBILE_CALENDAR_CLASS);
        this.calendarsContainer = document.createElement('div');
        this.calendarsContainer.classList.add(BcDateConstants.SCROLLABLE_CALENDARS_CLASS);
        const rangesBtns = this.addUpperBtnsMobile();
        this.mySelf.appendChild(this.calendarsContainer);
        this.setUpDisplayedCalendars(this.calendarsContainer, this.bcCalendarUtilities.topBarMobileScrollable());
        this.mySelf.appendChild(this.getFixedItemsScrollableCalendars());
        if (this.selectedDates) {
            this.selectRange();
        }
        if (rangesBtns != 'null' && rangesBtns != null) {
            this.calendarsContainer.classList.add(BcDateConstants.FIX_UPPER_BUTTONS);
        }
        this.addButtonListenersForConfirmAndCancel();
    }
    /**
     * añade los botones para un calendario rango mobile
     * @memberof BcCalendarUtilities
     * @void
     */
    addUpperBtnsMobile() {
        const rangesBtns = this.mySelf.getAttribute(BcDateConstants.RANGES)
            ? this.mySelf.getAttribute(BcDateConstants.RANGES)
            : '[]';
        let rangeBtnsArray = [];
        try {
            rangeBtnsArray = JSON.parse(rangesBtns);
        }
        catch (err) {
            rangeBtnsArray = [];
        }
        const rangesTextBtns = this.mySelf.getAttribute(BcDateConstants.RANGES_TEXT)
            ? this.mySelf.getAttribute(BcDateConstants.RANGES_TEXT)
            : '[]';
        let rangeTextBtnsArray = [];
        try {
            rangeTextBtnsArray = JSON.parse(rangesTextBtns);
        }
        catch (err) {
            rangeTextBtnsArray = [];
        }
        if (rangesBtns != 'null' && rangesBtns != null) {
            this.mySelf.innerHTML = this.bcCalendarUtilities.getRangeCalendarButtons();
            this.upperBtnsContainer = this.mySelf.querySelector(`.${BcDateConstants.UPPPER_BTNS_CLASS}`);
            this.createBtnsfromArray(rangeBtnsArray, rangeTextBtnsArray);
            this.addButtonListenersForUpperBtns();
        }
        return rangesBtns;
    }
    /**
     * Le da valor a las variables cuando se muestra un calendario de rango en desktop
     * @memberof BcCalendarUtilities
     * @return {Element} parte inferior contenedora de los botones.
     */
    getDesktopConfirmBottomRange() {
        const btnsContainer = document.createElement('div');
        btnsContainer.classList.add(BcDateConstants.BUTTONS_RANGE_CONTAINER_CLASS);
        btnsContainer.innerHTML = this.bcCalendarUtilities.confirmBtnsString();
        this.btnConfirm = btnsContainer.querySelector(`.${BcDateConstants.CONFIRM_CLASS}`);
        if (!this.selectedDates) {
            this.btnConfirm.setAttribute(BcCommonConstants.DISABLED, 'true');
        }
        this.btnCancel = btnsContainer.querySelector(`.${BcDateConstants.CANCEL_CLASS}`);
        this.btnRestore = btnsContainer.querySelector(`.${BcDateConstants.RESTORE_CLASS}`);
        return btnsContainer;
    }
    /**
     * Le da valor a las variables cuando se muestra un calendario de Simple
     * @memberof BcCalendarUtilities
     * @return {Element} parte inferior contenedora de los botones.
     */
    getBottomSimple() {
        const btnsContainer = document.createElement('div');
        btnsContainer.classList.add(BcDateConstants.BUTTONS_SIMPLE_CONTAINER_CLASS);
        let text = 'Aceptar';
        if (this.mySelf.getAttribute(BcDateConstants.CALENDAR_BUTTON) != '') {
            text = this.mySelf.getAttribute(BcDateConstants.CALENDAR_BUTTON);
        }
        btnsContainer.innerHTML = this.bcCalendarUtilities.confirmBtnString(text);
        this.btnConfirm = btnsContainer.querySelector(`.${BcDateConstants.CONFIRM_CLASS}`);
        addFocusable(this.btnConfirm, { tabindex: '0' });
        this.bcCalendarUtilities.focusListeners(this.btnConfirm);
        this.btnConfirm.addEventListener(BcCommonConstants.EVENT_CLICK, () => {
            this.selectDateByButton();
        });
        if (this.bcCalendarUtilities.maxScreenWidth()) {
            this.btnConfirm.classList.add(BcDateConstants.MOBILE_CONFIRM_CLASS);
        }
        return btnsContainer;
    }
    /**
     * Le da valor a las variables cuando se muestra un calendario de rango en desktop
     * @memberof BcCalendarUtilities
     * @return {Element} parte inferior contenedora de los botones.
     */
    getFixedItemsScrollableCalendars() {
        const fixedContent = document.createElement('div');
        fixedContent.classList.add(BcDateConstants.FIXED_CONTENT_CLASS);
        fixedContent.innerHTML = this.bcCalendarUtilities.getContentFixedContainer();
        this.btnConfirm = fixedContent.querySelector(`.${BcDateConstants.CONFIRM_CLASS}`);
        this.btnCancel = fixedContent.querySelector(`.${BcDateConstants.CANCEL_CLASS}`);
        return fixedContent;
    }
    /**
     * Inicializa los listeners de los botones de el calendario de rango (exepto los de prev y next)
     * @memberof BcCalendarUtilities
     * @void
     */
    addButtonListenersForConfirmAndCancel() {
        this.btnConfirm.addEventListener(BcCommonConstants.EVENT_CLICK, () => {
            this.eventRangeSelected();
        });
        this.btnCancel.addEventListener(BcCommonConstants.EVENT_CLICK, () => {
            this.eventRangeCanceled();
        });
        if (!this.bcCalendarUtilities.maxScreenWidth()) {
            this.btnRestore.addEventListener(BcCommonConstants.EVENT_CLICK, () => {
                this.eventRangeRestore();
            });
        }
    }
    /**
     * Inicializa los listeners de los botones de el calendario de rango (exepto los de prev y next)
     * @memberof BcCalendarUtilities
     * @void
     */
    addButtonListenersForUpperBtns() {
        this.upperBtnsContainer.childNodes.forEach((btn) => {
            const numberAttr = parseInt(btn.getAttribute('value'));
            btn.addEventListener(BcCommonConstants.EVENT_CLICK, () => {
                this.deactivateUpperBtns();
                btn.classList.add(BcDateConstants.BC_TAG_FILTER_ACTIVE);
                this.bcCalendarRange.automaticRange(numberAttr, this);
            });
        });
    }
    /**
     * Busca los botones en el dom y les pone un listener
     * @memberof BcCalendarUtilities
     * @void
     */
    addPrevAndNextBtnsToChangeYear() {
        this.next = this.mySelf.querySelector('.' + BcDateConstants.NEXT_CLASS);
        this.prev = this.mySelf.querySelector('.' + BcDateConstants.PREV_CLASS);
        addFocusable(this.next, { tabindex: '0' });
        addFocusable(this.prev, { tabindex: '0' });
        this.bcCalendarUtilities.focusListeners(this.next);
        this.bcCalendarUtilities.focusListeners(this.prev);
        this.next.addEventListener(BcCommonConstants.EVENT_CLICK, (event) => {
            this.bcCalendarUtilities.displaceYears(this.displayedMonths[0], 1, this);
            event.stopPropagation();
        });
        this.bcCalendarRange.addEnterKeyListener(this.next, () => {
            this.bcCalendarUtilities.displaceYears(this.displayedMonths[0], 1, this);
            this.next.focus();
        });
        this.prev.addEventListener(BcCommonConstants.EVENT_CLICK, (event) => {
            this.bcCalendarUtilities.displaceYears(this.displayedMonths[0], -1, this);
            event.stopPropagation();
        });
        this.bcCalendarRange.addEnterKeyListener(this.prev, () => {
            this.bcCalendarUtilities.displaceYears(this.displayedMonths[0], -1, this);
            this.prev.focus();
        });
    }
    /**
     * Busca los botones en el dom y les pone un listener
     * @memberof BcCalendarUtilities
     * @void
     */
    addPrevAndNextBtnsToChangeYearGroup() {
        this.next = this.mySelf.querySelector('.' + BcDateConstants.NEXT_CLASS);
        this.prev = this.mySelf.querySelector('.' + BcDateConstants.PREV_CLASS);
        this.bcCalendarRange.addListenerToBtnYearGroup(this);
    }
    /**
     * Cambia el tipo de selector (Dias, meses o años), cuando está el calendario simple
     * @memberof BcCalendarUtilities
     * @void
     */
    changeCalendarType() {
        switch (this.calendarState) {
            case BcDateConstants.STATE_DAYS:
                this.setElementsForMonthSelector();
                break;
            case BcDateConstants.STATE_MONTHS:
                this.setElementsForYearSelector();
                break;
            case BcDateConstants.STATE_YEARS:
                this.setElementsForMonthSelector();
                break;
            case BcDateConstants.STATE_SPLIT:
                this.splitCalendarSetUp();
                break;
            default:
                this.simpleCalendarSetUp();
        }
    }
    /**
     * Agrega al elemento de calendario simple los 12 años indicados en elselector de años
     * @memberof BcCalendarUtilities
     * @void
     */
    addYearsPicker() {
        this.monthsOrYearsContainer.innerHTML = '';
        for (let i = 0; i <= this.yearGroup[1] - this.yearGroup[0]; i++) {
            const year = document.createElement('p');
            const numericYear = this.yearGroup[0] + i;
            year.textContent = `${numericYear}`;
            if (this.today.getFullYear() == numericYear) {
                year.classList.add(BcDateConstants.THIS_MONTH_OR_YEAR_CLASS);
            }
            addFocusable(year, { tabindex: '0' });
            this.bcCalendarUtilities.focusListeners(year);
            this.monthsOrYearsContainer.appendChild(year);
            year.setAttribute(BcDateConstants.ID, `${BcDateConstants.ID_YEAR}${year.textContent}`);
            this.bcCalendarUtilities.keyReader(year, this);
            this.addListenerToSelectYear(year, numericYear);
        }
    }
    /**
     * Agrega la primera fecha seleccionada cuando se hace atrabes de teclado a un array y muestra la fecha visualmente
     * @param {Element} element: el elemento al que se le hizo click en el dom
     * @memberof BcCalendarUtilities
     * @void
     */
    selectDateByButton(day) {
        if (this.calendarState == BcDateConstants.STATE_RANGE && !this.bcCalendarUtilities.maxScreenWidth()) {
            this.deactivateUpperBtns();
        }
        const element = this.getElement(day);
        if (!this.firstDateIsSelected && !element?.classList.contains(BcDateConstants.SELECTED_DATE_CLASS)) {
            if (this.calendarState !== BcDateConstants.STATE_RANGE) {
                this.deleteAllSelected();
            }
            const calendarElement = element.parentElement?.parentElement;
            element.classList.add(BcDateConstants.SELECTED_DATE_CLASS);
            this.date = new Date();
            this.date.setHours(BcDateConstants.NUMBERS.CALENDAR_N12);
            this.date.setMonth(this.bcCalendarUtilities.getMonthIndex(this.bcCalendarUtilities.getClickedDateMonth(calendarElement)), parseInt(element.textContent));
            this.date.setFullYear(parseInt(this.bcCalendarUtilities.getClickedDateYear(calendarElement)));
            this.dateFormatIsosString();
            this.selectDateOneDates(this.dateFormatIsosString());
        }
        else {
            this.selectDateTwo(element);
        }
        this.addBorderSelectedDates();
    }
    /**
     * cambia el formato de la fecha a isos string y deja la salida DD/MM/AA
     * @memberof BcCalendarUtilities
     * @void
     */
    dateFormatIsosString() {
        const NUMBER_TEN = 10;
        return this.date.toISOString().substring(0, NUMBER_TEN);
    }
    /**
     * cambia el formato de la fecha a solo año
     * @memberof BcCalendarUtilities
     * @void
     */
    dateFormatYear() {
        const options = {
            timeZone: 'America/Bogota',
            year: 'numeric',
        };
        return this.date.toLocaleDateString('es-CO', options);
    }
    /**
     * cambia el formato de la fecha a mes y año
     * @memberof BcCalendarUtilities
     * @void
     */
    dateFormatMonthAndYear() {
        const options = {
            timeZone: 'America/Bogota',
            year: 'numeric',
            month: 'long',
        };
        return this.date.toLocaleDateString('es-CO', options);
    }
    /**
     * obtine el elemento dia de la pagina
     * @param day es el dia selecionado cuando no se pasa se obtine el dia con el focus
     * @memberof BcCalendarUtilities
     * @void
     */
    getElement(day) {
        let element;
        if (day != null) {
            element = document.getElementById(`${BcDateConstants.ID_DAY}${day}`);
        }
        else {
            element = document.getElementById(`${BcDateConstants.ID_DAY}${this.focus}`);
        }
        return element;
    }
    /**
     * Agrega la primera fecha seleccionada a un array y muestra la fecha visualmente
     * @param {Element} element: el elemento al que se le hizo click en el dom
     * @memberof BcCalendarUtilities
     * @void
     */
    selectCalendarOption(element, type) {
        if (this.calendarState == BcDateConstants.STATE_RANGE && !this.bcCalendarUtilities.maxScreenWidth()) {
            this.deactivateUpperBtns();
        }
        if (!this.firstDateIsSelected && !element.classList.contains(BcDateConstants.SELECTED_DATE_CLASS)) {
            if (this.calendarState !== BcDateConstants.STATE_RANGE) {
                this.deleteAllSelected();
            }
            element.classList.add(BcDateConstants.SELECTED_DATE_CLASS);
            this.date = new Date();
            this.date.setHours(BcDateConstants.NUMBERS.CALENDAR_N12);
            if (type === DateFormate.fullDate) {
                this.configFullView(element);
            }
            if (type === DateFormate.mediumDate) {
                this.configMediumView(element);
            }
            if (type === DateFormate.shortDate) {
                this.configShortView(element);
            }
        }
        else {
            this.selectDateTwo(element);
        }
        this.addBorderSelectedDates();
    }
    /**
     * Selecciona la vista completa DD/MM/YY
     * @param {Element} element: el elemento al que se le hizo click en el dom
     * @memberof BcCalendarUtilities
     * @void
     */
    configFullView(element) {
        const calendarElement = element.parentElement?.parentElement;
        this.date.setMonth(this.bcCalendarUtilities.getMonthIndex(this.bcCalendarUtilities.getClickedDateMonth(calendarElement)), parseInt(element.textContent));
        this.date.setFullYear(parseInt(this.bcCalendarUtilities.getClickedDateYear(calendarElement)));
        this.selectDateOneDates(this.dateFormatIsosString());
    }
    /**
    * Selecciona la vista para solo mes y año
    * @param {Element} element: el elemento al que se le hizo click en el dom
    * @memberof BcCalendarUtilities
    * @void
    */
    configMediumView(element) {
        const yearElement = this.mySelf.parentElement?.parentElement.getElementsByClassName('bc-calendar-top-bar')[0].querySelectorAll(BcCommonConstants.H6_TAG)[0].textContent;
        this.date.setMonth(this.bcCalendarUtilities.getMonthShorIndex(element.textContent));
        this.date.setFullYear(parseInt(yearElement.split(' ')[1]));
        this.selectDateOneDates(this.dateFormatMonthAndYear());
    }
    /**
  * Selecciona la vista de solo año
  * @param {Element} element: el elemento al que se le hizo click en el dom
  * @memberof BcCalendarUtilities
  * @void
  */
    configShortView(element) {
        this.date.setFullYear(parseInt(element.textContent));
        this.selectDateOneDates(this.dateFormatYear());
    }
    /**
     * dispara el evento para selecionar la primera fecha
     * @memberof BcCalendarUtilities
     * @void
     */
    selectDateOneDates(date) {
        const event = new CustomEvent(BcCommonConstants.EVENT_SELECT, {
            detail: date,
        });
        this.mySelf.dispatchEvent(event);
        if (this.selectedDates && this.selectedDates.length === BcDateConstants.NUMBERS.CALENDAR_N2) {
            this.addDatesToArraySelectRangeAndSort();
        }
        if (this.calendarState === BcDateConstants.STATE_RANGE) {
            this.firstDateIsSelected = true;
        }
    }
    /**
     * Agrega la segunda fecha seleccionada a un array y muestra la fecha visualmente
     * @memberof BcCalendarUtilities
     * @void
     */
    selectDateTwo(element) {
        if (!element.classList.contains(BcDateConstants.SELECTED_DATE_CLASS)) {
            const calendarElement = element.parentElement?.parentElement;
            this.dateTwo = new Date();
            this.dateTwo.setHours(BcDateConstants.NUMBERS.CALENDAR_N12);
            this.dateTwo.setMonth(this.bcCalendarUtilities.getMonthIndex(this.bcCalendarUtilities.getClickedDateMonth(calendarElement)), parseInt(element.textContent));
            this.dateTwo.setFullYear(parseInt(this.bcCalendarUtilities.getClickedDateYear(calendarElement)));
            this.addDatesToArraySelectRangeAndSort();
            this.btnConfirm.removeAttribute('disabled');
            this.firstDateIsSelected = false;
        }
    }
    /**
     * Agrega ambas fechas seleccionadas a un array que las organiza y luego
     * llama el metodo para seleccionar campos
     * @memberof BcCalendarUtilities
     * @void
     */
    addDatesToArraySelectRangeAndSort() {
        this.selectedDates = [this.date, this.dateTwo];
        this.selectedDates.sort((a, b) => this.bcCalendarUtilities.compareDates(a, b));
        this.selectRange();
        if (this.bcCalendarUtilities.maxScreenWidth()) {
            this.mySelf.querySelector(`.${BcDateConstants.FROM_CLASS}`).textContent = this.dateToStringFormat(this.selectedDates[0]);
            this.mySelf.querySelector(`.${BcDateConstants.TO_CLASS}`).textContent = this.dateToStringFormat(this.selectedDates[1]);
        }
    }
    /**
     * devulve el formato de texto de la fecha para mostralo en pantalla
     * @param {string} selectedDate fecha base pra obtener el nuevo formato
     * @memberof BcCalendarUtilities
     * @return {string} formato de fecha transformado
     */
    dateToStringFormat(selectedDate) {
        const parts = selectedDate.toISOString().substring(0, BcDateConstants.NUMBERS.CALENDAR_N10).split('-');
        return `${parts[BcDateConstants.NUMBERS.CALENDAR_N2]} ${BcDateConstants.MONTHS_TEXT_SHORT[parseInt(parts[1]) - 1]} ${parts[0]}`;
    }
    /**
     * Selecciona los rangos de las fechas seleccionadas en los meses visibles
     * @memberof BcCalendarUtilities
     * @void
     */
    selectRange() {
        this.deleteAllRange();
        this.deleteAllSelected();
        const monthsInCalendar = this.mySelf.querySelectorAll(`.${BcDateConstants.DISPLAYED_CALENDARS_CLASS}`);
        for (let i = 0; i < monthsInCalendar.length; i++) {
            const displayedMonth = this.displayedMonths[i];
            const monthElement = monthsInCalendar[i];
            const days = monthElement.querySelectorAll('.' + BcDateConstants.DAY);
            days.forEach((day) => {
                const tempDate = new Date(displayedMonth.year, displayedMonth.month, parseInt(day.textContent));
                this.setAllDatesToZeroHours(tempDate);
                this.addClassesSelectRange(tempDate, day);
            });
        }
    }
    /**
     * muesdtra en pantalla los elementos dia que estan dentro del rango seleccionado
     * @param {Date} tempDate fecha actual del proceso
     * @param {day} day elemto dia actual del prceso
     * @memberof BcCalendarUtilities
     * @void
     */
    addClassesSelectRange(tempDate, day) {
        if (this.today.getTime() == tempDate.getTime()) {
            day.classList.add(BcDateConstants.TODAY_CLASS);
        }
        if (this.selectedDates[0].getTime() == tempDate.getTime()) {
            day.classList.add(BcDateConstants.SELECTED_DATE_CLASS, BcDateConstants.INSIDE_RANGE_CLASS);
        }
        if (this.selectedDates[1].getTime() == tempDate.getTime()) {
            day.classList.add(BcDateConstants.SELECTED_DATE_CLASS, BcDateConstants.INSIDE_RANGE_CLASS);
        }
        if (this.selectedDates[0].getTime() <= tempDate.getTime() &&
            this.selectedDates[1].getTime() >= tempDate.getTime()) {
            day.classList.add(BcDateConstants.INSIDE_RANGE_CLASS);
        }
    }
    /**
     * Los objetos especificots de Date y un date de parametro tendran la hora en 0 0 0 hmsmsselectRange
     * @param {Date} una fecha temporal
     * @memberof BcCalendarUtilities
     * @void
     */
    setAllDatesToZeroHours(tempDate) {
        tempDate.setHours(0, 0, 0, 0);
        this.selectedDates[0].setHours(0, 0, 0, 0);
        this.selectedDates[1].setHours(0, 0, 0, 0);
        this.today.setHours(0, 0, 0, 0);
    }
    /**
     * Elimina todas las clases INSIDE_RANGE_CLASS de los elementos en el dom.
     * @memberof BcCalendarUtilities
     * @void
     */
    deleteAllRange() {
        this.mySelf.querySelectorAll('.' + BcDateConstants.DAY).forEach((day) => {
            day.classList.remove(BcDateConstants.INSIDE_RANGE_CLASS);
        });
    }
    /**
     * Elimina todas las clases SELECTED_DATE_CLASS de los elementos en el dom.
     * @memberof BcCalendarUtilities
     * @void
     */
    deleteAllSelected() {
        this.mySelf.querySelectorAll(`.${BcDateConstants.SELECTED_DATE_CLASS}`).forEach((day) => {
            day.classList.remove(BcDateConstants.SELECTED_DATE_CLASS);
            day.removeAttribute('date-selection');
        });
    }
    /**
     * Cambia el mes de en el selector unico de meses
     * @param {number} i = mes en formato js (0-11) para asignar el nuevo mes al que se le dio click
     * @memberof BcCalendarUtilities
     * @void
     */
    selectMonth(i, displayedMonth) {
        displayedMonth.month = i;
        if (this.mySelf.getAttribute('type') === BcDateConstants.STATE_SPLIT) {
            this.splitCalendarSetUp();
        }
        else {
            this.simpleCalendarSetUp();
        }
    }
    /**
     * Lanza un evento cuando se restablecen las fechas del rango
     * @memberof BcCalendarUtilities
     * @void
     */
    eventRangeRestore() {
        this.date = undefined;
        this.dateTwo = undefined;
        this.displayedMonths = undefined;
        this.firstDateIsSelected = undefined;
        this.selectedDates = undefined;
        this.deleteAllRange();
        this.deleteAllSelected();
        this._setUp();
    }
    /**
     * Lanza un evento cuando las fechas del rango fueron seleccionadas
     * @memberof BcCalendarUtilities
     * @void
     */
    eventRangeSelected() {
        if (this.selectedDates && this.selectedDates.length === BcDateConstants.NUMBERS.CALENDAR_N2) {
            const event = new CustomEvent(BcCommonConstants.EVENT_RANGE, {
                detail: this.selectedDates,
            });
            this.mySelf.dispatchEvent(event);
        }
        else {
            this.eventRangeCanceled();
        }
    }
    /**
     * Lanza un evento cuando se hace click en el boton cancelar del calendario de rangos
     * @memberof BcCalendarUtilities
     * @void
     */
    eventRangeCanceled() {
        const event = new CustomEvent(BcCommonConstants.EVENT_CANCEL);
        this.mySelf.dispatchEvent(event);
    }
    /**
     * emite el evento de selecion para cambiar el output
     * @memberof BcCalendarUtilities
     * @void
     */
    emitEvent() {
        this.value = this.selectedDates;
        if (this.output) {
            this.output(this.value);
        }
    }
    /**
     * pone en estado activo el boton seleccionado y desactiva el resto
     * @param {number} daysToGoBack = días que se deben restar para seleciconar la segunda fecha
     * @memberof BcCalendarUtilities
     * @void
     */
    deactivateUpperBtns() {
        this.upperBtnsContainer.childNodes.forEach((btn) => {
            if (btn.classList.contains(BcDateConstants.BC_TAG_FILTER_ACTIVE)) {
                btn.classList.remove(BcDateConstants.BC_TAG_FILTER_ACTIVE);
            }
        });
    }
    /**
     * muestra en pantalla los dieferentes tipos de bors para seleccion de fecha
     * @memberof BcCalendarUtilities
     * @void
     */
    addBorderSelectedDates() {
        const DATE_SELECTION = 'date-selection';
        const secondDateSelector = `.${BcDateConstants.SELECTED_DATE_CLASS}~ .${BcDateConstants.SELECTED_DATE_CLASS}`;
        const firstDateSelector = `.${BcDateConstants.DISPLAYED_CALENDARS_CLASS}:first-of-type .${BcDateConstants.SELECTED_DATE_CLASS}`;
        const allDateSelector = `.${BcDateConstants.SELECTED_DATE_CLASS}`;
        const notDateSelectionSelector = `.${BcDateConstants.SELECTED_DATE_CLASS}:not([date-selection])`;
        const rangeIsPresentSelector = `.${BcDateConstants.SELECTED_DATE_CLASS}.${BcDateConstants.INSIDE_RANGE_CLASS}`;
        const secondDateSelected = this.mySelf.querySelector(secondDateSelector);
        if (secondDateSelected) {
            secondDateSelected.setAttribute(DATE_SELECTION, '2');
            this.mySelf.querySelector(notDateSelectionSelector).setAttribute(DATE_SELECTION, '1');
        }
        else if (this.mySelf.querySelectorAll(allDateSelector).length > 1) {
            this.mySelf.querySelector(firstDateSelector).setAttribute(DATE_SELECTION, '1');
            this.mySelf.querySelector(notDateSelectionSelector).setAttribute(DATE_SELECTION, '2');
        }
        else if (this.mySelf.querySelector(rangeIsPresentSelector)) {
            if (this.mySelf.querySelector(`${rangeIsPresentSelector}~${BcDateConstants.INSIDE_RANGE_CLASS}`)) {
                this.mySelf.querySelector(rangeIsPresentSelector).setAttribute(DATE_SELECTION, '1');
            }
            else {
                this.mySelf.querySelector(rangeIsPresentSelector).setAttribute(DATE_SELECTION, '2');
            }
        }
    }
}

const BC_COACH_MARK_SELECTOR = `${BcCommonConstants.PREFIX_LIB}-coach-mark`;
const BC_COACH_MARK_CONTAINER = `${BcCommonConstants.PREFIX_LIB}-coach-mark-container`;
const BC_COACH_MARK_FOOTER = `${BC_COACH_MARK_SELECTOR}-footer`;
const BC_COACH_MARK_TITLE = `${BC_COACH_MARK_SELECTOR}-title`;
const BC_COACH_MARK_TITLE_ARIA = 'Cuadro de diálogo informativo señalando ';
const BC_COACH_MARK_TITLE_ARIA_TITLE = ' ,Título';
const BC_COACH_MARK_EXPANDED = `${BC_COACH_MARK_SELECTOR}-expanded`;
const BC_COACH_MARK_FOOTER_FIRST_BUTTON = `${BC_COACH_MARK_FOOTER}>button:first-child`;
const BC_COACH_MARK_HIGHLIGHT = `${BC_COACH_MARK_SELECTOR}-highlight`;
const BC_COACH_MARK_TARGET = `${BC_COACH_MARK_SELECTOR}-target`;
const BC_COACH_MARK_OVERLAY = `${BC_COACH_MARK_SELECTOR}-overlay`;
const BC_COACH_MARK_MAIN = `${BC_COACH_MARK_SELECTOR}-main`;
const BC_COACH_MARK_NEXT = `${BC_COACH_MARK_SELECTOR}-next`;
const BC_COACH_MARK_PREV = `${BC_COACH_MARK_SELECTOR}-prev`;
const BC_COACH_MARK_CLOSE = `${BC_COACH_MARK_SELECTOR}-close`;
const BC_COACH_MARK_ICON = `${BC_COACH_MARK_SELECTOR}-icon`;
const BC_COACH_MARK_QUANTITY_ITEMS = `${BC_COACH_MARK_SELECTOR}-quantity-items`;
const BC_COACH_MARK_NUMBER = `${BC_COACH_MARK_SELECTOR}-number`;
const BC_COACH_MARK_DATA_ATTRIBUTE = `dataCoachmark`;
const BC_COACH_MARK_DATA_CONTROLLER = `dataController`;
const BC_COACH_MARK_LINK = `${BC_COACH_MARK_SELECTOR}-link`;
const BC_COACH_MARK_BLOCK_SCROLL = `${BC_COACH_MARK_SELECTOR}-scroll-block`;
const BC_COACH_MARK_ANIMATION_IN = `fade-in-opacity ease-in-out 350ms forwards`;
const BC_COACH_MARK_ANIMATION_OUT = 'ease-in-out 250ms forwards';
const BC_COACH_MARK_RIGHT = `right`;
const BC_COACH_MARK_LEFT = `left`;
const BC_COACH_MARK_TOP = `top`;
const BC_COACH_MARK_BOTTOM = `bottom`;
const BC_COACH_MARK_ARIA_LABEL = 'aria-label';
const BC_COACH_MARK_NUMBER_0 = 0;
const BC_COACH_MARK_NUMBER_1 = 1;
const BC_COACH_MARK_NUMBER_2 = 2;
const BC_COACH_MARK_NUMBER_6 = 6;
const BC_COACH_MARK_NUMBER_20 = 20;
const BC_COACH_MARK_NUMBER_16 = 16;
const BC_COACH_MARK_NUMBER_MIN_WIDTH = 280;
const BC_COACH_MARK_UNDERSTOOD_TEXT = 'Entendido';
const BC_COACH_MARK_NEXT_TEXT = 'Siguiente';
const BC_COACH_MARK_PREV_TEXT = 'Regresar';
const BC_COACH_MARK_CLOSE_TEXT = 'Cerrar';
const BC_COACH_MARK_STATUS = 'status';
const BC_COACH_MARK_STATUS_ACTIVE = 'active';
const BC_COACH_MARK_STATUS_ID = 'id';
const BC_COACH_MARK_ARROW_CLASS = `${BC_COACH_MARK_SELECTOR}-arrow`;
const BC_COACH_MARK_ARROW_SPACE = 16;
const BC_COACH_MARK_END_POSITION = 'end';
const BC_COACH_MARK_START_POSITION = 'start';
const BC_COACH_MARK_CENTER_POSITION = 'center';
const BC_COACH_MARK_WIDTH = 'width';
const BC_COACH_MARK_HEIGHT = 'height';
const BC_COACH_MARK_POSITION = 'position';
const BC_COACH_MARK_X = 'x';
const BC_COACH_MARK_Y = 'y';
const BC_COACH_MARK_Z_INDEX = '2001';
const BC_COACH_BUTTON_FOOTER = ':scope>section>section:nth-child(4)>button:first-child';
var CoachmarkStyle;
(function (CoachmarkStyle) {
    CoachmarkStyle["none"] = "none";
    CoachmarkStyle["flex"] = "flex";
    CoachmarkStyle["block"] = "block";
    CoachmarkStyle["contents"] = "contents";
})(CoachmarkStyle || (CoachmarkStyle = {}));
var bcDisplay;
(function (bcDisplay) {
    bcDisplay["none"] = "bc-d-none";
    bcDisplay["flex"] = "bc-d-flex";
    bcDisplay["block"] = "bc-d-block";
    bcDisplay["contents"] = "contents";
})(bcDisplay || (bcDisplay = {}));

class BcCoachMarkBehavior extends BcDefaultBehavior {
    constructor() {
        super();
    }
    /**
     * Busca el componente mediante querySelectorAll y lo inicializa.
     * @returns array de elementos de tipo BcCoachMarkBehavior encontrados.
     * @memberof BcCoachMarkBehavior
     */
    static setUpAll() {
        const coachMarkGroup = Array.from(document.querySelectorAll(`.${BC_COACH_MARK_SELECTOR}`));
        const elements = [];
        for (const element of coachMarkGroup) {
            const bcCoachMarkBehavior = new BcCoachMarkBehavior();
            bcCoachMarkBehavior.setElement(element);
            bcCoachMarkBehavior.setUp();
            elements.push(bcCoachMarkBehavior);
        }
        return elements;
    }
    _setUp() {
        this.hashMap = new Map();
        this.coachMarkElement = this.mySelf.querySelector(`.${BC_COACH_MARK_CONTAINER}`);
        this.pagination = this.mySelf.querySelector(`${BcCommonConstants.SECTION_TAG}.${BC_COACH_MARK_QUANTITY_ITEMS}`);
        this.sliderElements = Array.from(this.mySelf.querySelectorAll(`.${BC_COACH_MARK_MAIN}`));
        this.buttonPrev = this.mySelf.querySelector(`.${BC_COACH_MARK_PREV}`);
        this.buttonNext = this.mySelf.querySelector(`.${BC_COACH_MARK_NEXT}`);
        this.buttonUnderstand = this.mySelf.querySelector(`.${BC_COACH_MARK_FOOTER_FIRST_BUTTON}`);
        this.arrowElement = createElement({ element: BcCommonConstants.DIV_TAG, classList: [BC_COACH_MARK_ARROW_CLASS] });
        this.createPaginationStep();
        this.setAccessibility();
        this.addEventListeners();
    }
    /**
     * Crea la paginación del Coachmark
     * @memberof BcCoachMarkBehavior
     */
    createPaginationStep() {
        const bodysContent = Array.from(this.mySelf.querySelectorAll(`.${BC_COACH_MARK_MAIN}`));
        this.pagination.innerHTML = '';
        const initialNumber = `${BC_COACH_MARK_NUMBER_1}/${bodysContent.length}`;
        this.pagination.appendChild(createElement({
            element: BcCommonConstants.DIV_TAG,
            classList: [BC_COACH_MARK_NUMBER],
            innerText: initialNumber,
        }));
    }
    /**
   * Setea la paginación del Coachmark
   * @memberof BcCoachMarkBehavior
   */
    setStepQuantity() {
        const currentStep = this.currentStep();
        const paginationNumber = this.mySelf.querySelector(`.${BC_COACH_MARK_NUMBER}`);
        if (paginationNumber) {
            paginationNumber.innerHTML = '';
            paginationNumber.innerHTML = `${currentStep + BC_COACH_MARK_NUMBER_1}/${this.sliderElements.length}`;
            paginationNumber.setAttribute(BC_COACH_MARK_ARIA_LABEL, 'Paso ' + `${currentStep + BC_COACH_MARK_NUMBER_1}` + ' de ' + `${this.sliderElements.length}`);
        }
    }
    /**
     * Setea los estilos de los botones e indica cual debe verse y
     * cuál no con respecto a los pasos del Coachmark
     * @memberof BcCoachMarkBehavior
     */
    setButtonsStyle() {
        const currentStep = this.currentStep();
        if (this.sliderElements.length == 1) {
            this.setNextAndUnderstoodButton();
            this.pagination.remove();
            replaceClass(this.buttonPrev, bcDisplay.flex, bcDisplay.none);
        }
        else {
            if (currentStep + BC_COACH_MARK_NUMBER_1 == 1) {
                replaceClass(this.buttonUnderstand, BC_COACH_MARK_CLOSE, BC_COACH_MARK_NEXT);
                replaceClass(this.buttonPrev, bcDisplay.flex, bcDisplay.none);
                this.buttonUnderstand.setAttribute(BC_COACH_MARK_ARIA_LABEL, BC_COACH_MARK_NEXT_TEXT);
            }
            else if (currentStep + BC_COACH_MARK_NUMBER_1 == this.sliderElements.length) {
                this.buttonUnderstand.textContent = BC_COACH_MARK_UNDERSTOOD_TEXT;
                this.setNextAndUnderstoodButton();
                replaceClass(this.buttonPrev, bcDisplay.none, bcDisplay.flex);
                this.buttonPrev.setAttribute(BC_COACH_MARK_ARIA_LABEL, BC_COACH_MARK_PREV_TEXT);
            }
            else {
                replaceClass(this.buttonPrev, bcDisplay.none, bcDisplay.flex);
                replaceClass(this.buttonUnderstand, bcDisplay.none, bcDisplay.flex);
                replaceClass(this.buttonUnderstand, BC_COACH_MARK_CLOSE, BC_COACH_MARK_NEXT);
                if (this.buttonUnderstand && this.buttonPrev) {
                    this.buttonPrev.setAttribute(BC_COACH_MARK_ARIA_LABEL, BC_COACH_MARK_PREV_TEXT);
                    this.buttonUnderstand.setAttribute(BC_COACH_MARK_ARIA_LABEL, BC_COACH_MARK_NEXT_TEXT);
                }
            }
        }
    }
    /**
     * Cambia la clase y el texto del boton Siguiente del Coachmark
     * @memberof BcCoachMarkBehavior
     */
    setNextAndUnderstoodButton() {
        if (this.buttonUnderstand) {
            this.buttonUnderstand.textContent = BC_COACH_MARK_UNDERSTOOD_TEXT;
            this.buttonUnderstand.setAttribute(BC_COACH_MARK_ARIA_LABEL, BC_COACH_MARK_UNDERSTOOD_TEXT);
            replaceClass(this.buttonUnderstand, BC_COACH_MARK_NEXT, BC_COACH_MARK_CLOSE);
        }
    }
    /**
     * Inicializa el el componente coachMark
     * @memberof BcCoachMarkBehavior
     */
    initTour() {
        for (const slider of this.sliderElements) {
            this.targetElement = document.getElementById(slider.getAttribute(BC_COACH_MARK_DATA_CONTROLLER));
            this.setValueTour(this.targetElement, slider);
            this.setStepQuantity();
            break;
        }
        if (this.sliderElements.length == 1) {
            this.buttonPrev.innerText = BC_COACH_MARK_UNDERSTOOD_TEXT;
        }
    }
    /**
     * Setea el comportamiento del componente cuando se cambia de Slide
     * @param element: Target del componente
     * @param slider: Slider o contenido del Componente
     * @memberof BcCoachMarkBehavior
     */
    setValueTour(element, slider) {
        this.removeAllProperties();
        this.createOverlay();
        element.classList.add(`${BC_COACH_MARK_HIGHLIGHT}`);
        const optionScrollView = {
            block: 'nearest',
            inline: 'nearest'
        };
        element.scrollIntoView(optionScrollView);
        this.setTargetBackground(element);
        slider.setAttribute(BC_COACH_MARK_STATUS, BC_COACH_MARK_STATUS_ACTIVE);
        element.appendChild(this.arrowElement);
        document.body.append(this.mySelf);
        this.setPosition(this.coachMarkElement, this.arrowElement, element);
        this.coachMarkElement.classList.add(`${BC_COACH_MARK_SELECTOR}-expanded`);
        if (element.classList.contains(`${BC_COACH_MARK_TARGET}`)) {
            this.focusElement();
        }
        else {
            this.setInitTargetZIndex(element);
        }
        document.body.style.overflow = 'hidden';
        element['style'].pointerEvents = 'none';
        this.setButtonsStyle();
    }
    /**
    * Remueve la clase highlight que resalta el
    * target del componente al estar seleccionado
    * @memberof BcCoachMarkBehavior
    */
    removeHighLight() {
        const isHighLight = this.sliderElements.find((coachMarkContent) => coachMarkContent.getAttribute(BC_COACH_MARK_STATUS));
        if (isHighLight) {
            const elementCurrent = document.getElementById(isHighLight.getAttribute(BC_COACH_MARK_DATA_CONTROLLER));
            elementCurrent.classList.remove(BC_COACH_MARK_HIGHLIGHT);
            elementCurrent['style'].pointerEvents = 'all';
            isHighLight.removeAttribute(BC_COACH_MARK_STATUS);
        }
    }
    /**
     * Crea el backdrop del Coachmark al desplegarse
     * @memberof BcCoachMarkBehavior
     */
    createOverlay() {
        const status = createElement({
            element: BcCommonConstants.DIV_TAG,
            classList: [BC_COACH_MARK_OVERLAY],
        });
        document.body.insertBefore(status, null);
        this.addClassBlockScroll();
    }
    /**
     * Agrega la clase que bloquea el Scroll de la pantalla
     * @memberof BcCoachMarkBehavior
     */
    addClassBlockScroll() {
        const bodySelector = document.body;
        bodySelector.classList.add(BC_COACH_MARK_BLOCK_SCROLL);
    }
    /**
     * Remueve el backdrop del Coachmark al desplegarse
     * @memberof BcCoachMarkBehavior
     */
    removeOverlay() {
        const overlayElement = document.querySelector(`.${BC_COACH_MARK_OVERLAY}`);
        if (overlayElement) {
            overlayElement.remove();
        }
        this.removeClassBlockScroll();
    }
    /**
     * Remueve la clase que bloquea el Scroll de la pantalla
     * @memberof BcCoachMarkBehavior
     */
    removeClassBlockScroll() {
        const bodySelector = document.body;
        bodySelector.classList.remove(BC_COACH_MARK_BLOCK_SCROLL);
    }
    /**
     * Remueve el backdrop del componente y el resaltado del target
     * @memberof BcCoachMarkBehavior
     */
    removeAllProperties() {
        this.removeOverlay();
        this.removeHighLight();
    }
    /**
     * Enfoca el componente dentro de la pantalla
     * @memberof BcCoachMarkBehavior
     */
    focusElement() {
        const focusCoachMark = this.mySelf.querySelector(`.${BC_COACH_MARK_CONTAINER}`);
        focusCoachMark.scrollIntoView();
    }
    /**
     * Lista los métodos que poseen eventos de click en el componente
     * @memberof BcCoachMarkBehavior
     */
    addEventListeners() {
        this.listenerNext();
        this.listenerPrev();
        this.listenerCloseButton();
    }
    /**
     * Evento que cierra el coachmark por medio del Click
     * @memberof BcCoachMarkBehavior
     */
    listenerCloseButton() {
        this.mySelf.querySelectorAll(`.${BC_COACH_MARK_CLOSE}`).forEach((item) => {
            item.addEventListener(BcCommonConstants.EVENT_CLICK, () => {
                this.hideWindow();
            });
        });
    }
    /**
     * Permite pasar al siguiente slide por medio del click en el botón correspondiente
     * @memberof BcCoachMarkBehavior
     */
    listenerNext() {
        this.buttonUnderstand.addEventListener(BcCommonConstants.EVENT_CLICK, () => {
            if (this.buttonUnderstand.innerText !== BC_COACH_MARK_UNDERSTOOD_TEXT) {
                this.nextStep();
            }
            else {
                this.hideWindow();
            }
        });
    }
    /**
     * Permite cerrar el componente y restaurar sus valores
     * @memberof BcCoachMarkBehavior
     */
    hideWindow() {
        this.coachMarkElement.classList.remove(`${BC_COACH_MARK_SELECTOR}-expanded`);
        this.coachMarkElement.style.animation = BC_COACH_MARK_ANIMATION_OUT;
        this.setTargetZIndexClose();
        this.restoreValueButton();
        this.removeAllProperties();
        this.arrowElement.remove();
        this.mySelf.remove();
        document.body.style.overflow = 'visible';
    }
    /**
     * Permite pasar al siguiente slide por medio del click en el botón correspondiente
     * @memberof BcCoachMarkBehavior
     */
    listenerPrev() {
        const buttonPrev = this.mySelf.querySelector(`.${BC_COACH_MARK_PREV}`);
        buttonPrev.addEventListener(BcCommonConstants.EVENT_CLICK, () => {
            const stepActive = this.currentStep();
            if (stepActive > 0) {
                this.prevStep();
            }
            else {
                this.hideWindow();
            }
        });
    }
    /**
     * Permite pasar al siguiente paso del slide
     * @memberof BcCoachMarkBehavior
     */
    nextStep() {
        this.arrowElement.remove();
        this.moveStep(BC_COACH_MARK_NUMBER_1);
    }
    /**
     * Permite pasar al anterior paso del slide
     * @memberof BcCoachMarkBehavior
     */
    prevStep() {
        this.arrowElement.remove();
        this.moveStep();
    }
    /**
     * Retorna el paso actual en el que se encuentra el componente
     * @return number: Paso actual
     * @memberof BcCoachMarkBehavior
     */
    currentStep() {
        const currentElement = this.sliderElements.find(item => item.getAttribute(BC_COACH_MARK_STATUS) === BC_COACH_MARK_STATUS_ACTIVE);
        return parseInt(currentElement.getAttribute(BC_COACH_MARK_DATA_ATTRIBUTE));
    }
    /**
     * Permite mover de paso el slide del componente
     * @param step: dirección del elemento
     * @memberof BcCoachMarkBehavior
     */
    moveStep(step = 0) {
        let stepActive;
        const button = this.mySelf.querySelector(`.${BC_COACH_MARK_FOOTER_FIRST_BUTTON}`);
        const currentActive = this.sliderElements.find((coachMarkContent) => coachMarkContent.getAttribute(BC_COACH_MARK_STATUS));
        if (currentActive) {
            const valueItemData = parseInt(currentActive.getAttribute(BC_COACH_MARK_DATA_ATTRIBUTE));
            if (step) {
                stepActive = valueItemData + BC_COACH_MARK_NUMBER_1;
            }
            else {
                stepActive = valueItemData - BC_COACH_MARK_NUMBER_1;
            }
            if (stepActive === this.sliderElements.length - BC_COACH_MARK_NUMBER_1) {
                button.innerText = `${BC_COACH_MARK_UNDERSTOOD_TEXT}`;
            }
            else {
                this.restoreValueButton();
            }
            const setStepNext = this.sliderElements.find((coachMarkContent) => parseInt(coachMarkContent.getAttribute(BC_COACH_MARK_DATA_ATTRIBUTE)) === stepActive);
            const itemDom = document.getElementById(setStepNext.getAttribute(BC_COACH_MARK_DATA_CONTROLLER));
            if (setStepNext) {
                this.mySelf.removeAttribute(BC_COACH_MARK_POSITION);
                this.setValueTour(itemDom, setStepNext);
                this.setStepQuantity();
            }
        }
    }
    /**
     * Restaura los valores predeterminados de los botones del elemento
     * @memberof BcCoachMarkBehavior
     */
    restoreValueButton() {
        const button = this.mySelf.querySelector(`.${BC_COACH_MARK_FOOTER_FIRST_BUTTON}`);
        button.innerText = `${BC_COACH_MARK_NEXT_TEXT}`;
        replaceClass(button, `${BC_COACH_MARK_CLOSE}`, `${BC_COACH_MARK_NEXT}`);
    }
    /**
     * Configura la accesibilidad del componente
     * @memberof BcCoachMarkBehavior
     */
    setAccessibility() {
        const title = this.mySelf.querySelector(`.${BC_COACH_MARK_TITLE}`);
        const link = this.mySelf.querySelector(`.${BC_COACH_MARK_LINK} ${BcCommonConstants.HREF_TAG}`);
        const buttonClose = this.mySelf.querySelector(`${BcCommonConstants.SECTION_TAG}.${BC_COACH_MARK_CLOSE} ${BcCommonConstants.BUTTON_TAG}`);
        if (title) {
            title.setAttribute(BC_COACH_MARK_ARIA_LABEL, BC_COACH_MARK_TITLE_ARIA + title.textContent + BC_COACH_MARK_TITLE_ARIA_TITLE);
        }
        if (link) {
            link.setAttribute(BC_COACH_MARK_ARIA_LABEL, link.textContent);
        }
        if (buttonClose) {
            buttonClose.setAttribute(BC_COACH_MARK_ARIA_LABEL, BC_COACH_MARK_CLOSE_TEXT);
        }
        addFocusable(this.mySelf, { tabindex: '0' });
        addFocusable(this.buttonUnderstand, { tabindex: '0' });
        addFocusable(this.buttonPrev, { tabindex: '0' });
        addFocusable(buttonClose, { tabindex: '0' });
        addFocusable(link, { tabindex: '0' });
    }
    /**
     * Setea la posición del elemento
     * @param target
     * @param coach
     * @param arrow
     * @memberof BcCoachMarkBehavior
     */
    setPosition(coach, arrow, target) {
        const localization = new LocationBuilderClientRectUtils();
        const coachLocalizationBuilder = new BcLocationBuilder();
        const elementPosition = new BcLocationBuilderPosition();
        const viewportOffset = {
            height: window.innerHeight,
            width: window.innerWidth,
        };
        const targetOffset = elementPosition.getTargetOffset(target, localization);
        const coachOffset = elementPosition.getCoachOffset(coach, localization);
        const coachPosition = elementPosition.getCoachPosition(coachLocalizationBuilder, targetOffset, coachOffset, viewportOffset);
        if (coachOffset.width + coachPosition.x === viewportOffset.width) {
            coachPosition.x = coachPosition.x - BC_COACH_MARK_NUMBER_16;
        }
        else if (coachPosition.x === 0) {
            coachPosition.x = coachPosition.x + BC_COACH_MARK_NUMBER_16;
        }
        elementPosition.evaluateArrowPosition(coachLocalizationBuilder.position, arrow, targetOffset);
        this.setElementPosition(coachPosition);
        elementPosition.setElementPosition(coachPosition, this.coachMarkElement, coachLocalizationBuilder.position);
        this.resizeElement(elementPosition, target, localization, coach, coachLocalizationBuilder, arrow);
    }
    /**
     * Ajusta el responsive del componente y calcula su posicion cada
     * vez que se modifica el tamaño del window
     * @memberof BcCoachMarkBehavior
     */
    resizeElement(elementPosition, target, localization, coach, coachLocalizationBuilder, arrow) {
        const coachMarkElement = this.mySelf;
        const viewportOffset = {
            height: window.innerHeight,
            width: window.innerWidth,
        };
        let targetOffsetResize;
        let coachOffsetResize;
        let coachPositionResize;
        window.addEventListener('resize', function (event) {
            targetOffsetResize = elementPosition.getTargetOffset(target, localization);
            coachOffsetResize = elementPosition.getCoachOffset(coach, localization);
            coachPositionResize = elementPosition.getCoachPosition(coachLocalizationBuilder, targetOffsetResize, coachOffsetResize, viewportOffset);
            elementPosition.evaluateArrowPosition(coachLocalizationBuilder.position, arrow, targetOffsetResize);
            if (coachOffsetResize.width + coachPositionResize.x === viewportOffset.width) {
                coachPositionResize.x = coachPositionResize.x - BC_COACH_MARK_NUMBER_16;
            }
            else if (coachPositionResize.x === 0) {
                coachPositionResize.x = coachPositionResize.x + BC_COACH_MARK_NUMBER_16;
            }
            coachMarkElement['style'].left = coachPositionResize.x + 'px';
            coachMarkElement['style'].top = coachPositionResize.y + 'px';
            coachMarkElement.scrollIntoView();
        });
        return { targetOffsetResize, coachOffsetResize, coachPositionResize };
    }
    /**
     * Configura el estilo left y top donde se situará el componente
     * @param coachPosition: Posición del coachmark en x y en y
     * @param element: Coachmark
     * @memberof BcCoachMarkBehavior
     */
    setElementPosition(coachPosition) {
        this.mySelf['style'].left = coachPosition.x + 'px';
        this.mySelf['style'].top = coachPosition.y + 'px';
        this.coachMarkElement.style.animation = BC_COACH_MARK_ANIMATION_IN;
        this.focusElement();
    }
    /**
     * Ajusta el background color que debe tener el target
     * @param target: Target donde se situa el componente
     * @memberof BcCoachMarkBehavior
     */
    setTargetBackground(target) {
        let backgroundColor = window.getComputedStyle(target).backgroundColor;
        let parent = target.parentElement;
        if (backgroundColor === 'rgba(0, 0, 0, 0)' || backgroundColor === '') {
            backgroundColor = window.getComputedStyle(parent).backgroundColor;
            while (backgroundColor === 'rgba(0, 0, 0, 0)') {
                parent = parent.parentElement;
                backgroundColor = window.getComputedStyle(parent).backgroundColor;
            }
        }
        target['style'].backgroundColor = backgroundColor;
    }
    /**
     * Ajusta el z-index que tiene el target desde su padre para situar el coachmark
     * @param target: Target donde se situa el componente
     * @memberof BcCoachMarkBehavior
     */
    setInitTargetZIndex(target) {
        this.initParent = target.closest(`.${BC_COACH_MARK_TARGET}`);
        let parent = target.parentElement;
        let zIndex = window.getComputedStyle(parent).zIndex;
        parent['style'].zIndex = 'auto';
        this.hashMap.set(parent, zIndex);
        while (parent != this.initParent) {
            parent = parent.parentElement;
            zIndex = window.getComputedStyle(parent).zIndex;
            parent['style'].zIndex = 'auto';
            this.hashMap.set(parent, zIndex);
        }
    }
    /**
     * Por medio de un mapa clave,valor devuelve el z-index(value) a la
     * etiqueta donde inicialmente lo tenia el componente(value)
     * @memberof BcCoachMarkBehavior
     */
    setTargetZIndexClose() {
        this.hashMap.forEach((values, keys) => {
            keys['style'].zIndex = values;
        });
    }
}

const LIST = `${BcCommonConstants.PREFIX_LIB}-list`;
const LIST_ACTION_ICON = LIST + '-action-icon';
const LIST_CHECKBOX = LIST + '-checkbox';
const LIST_CONTENT = LIST + '-content';
const LIST_CONTENT_DATA = LIST + '-content-data';
const LIST_MAIN_CONTENT = LIST + '-main-content';
const LIST_CONTAINER_CHECKBOX = LIST + '-container-checkbox';
const LIST_SELECTED = `${BcCommonConstants.PREFIX_LIB}-selected`;

class BcListBehavior extends BcDefaultBehavior {
    constructor() {
        super();
    }
    static setUpAll() {
        const listElements = Array.from(document.querySelectorAll(`section[class~='${LIST}']`));
        const elements = [];
        for (const listElement of listElements) {
            const element = listElement;
            const list = new BcListBehavior();
            list.setElement(element);
            list.setUp();
            elements.push(list);
        }
        return elements;
    }
    _setUp() {
        this.setCheckbox();
        this.accessibility();
    }
    /**
     * Asigna la clase al list cuando el checkbox esta activo.
     * @memberof BcListBehavior
     */
    setCheckbox() {
        const checkbox = document.querySelector('input[type=checkbox]');
        checkbox?.addEventListener('change', function () {
            const list = document.getElementById('list');
            if (this.checked) {
                list.classList.add(LIST_SELECTED);
            }
            else {
                list.classList.remove(LIST_SELECTED);
            }
        });
    }
    /**
     * Accesibilidad de foco.
     * @memberof BcListBehavior
     */
    accessibility() {
        const element = Array.from(document.querySelectorAll(`.${LIST}`));
        for (const content of element) {
            addFocusable(content, { tabindex: '0' });
        }
    }
}

class BcListRowConstants extends BcCommonConstants {
}
BcListRowConstants.LIST_ROW_LAST_ITEMS = COMMON_CONSTANTS_NUMBERS.N2;
BcListRowConstants.LIST_ROW_MAX_NUMBER = COMMON_CONSTANTS_NUMBERS.N5;
BcListRowConstants.LIST_ROW_SEPARATION_MOBILE = COMMON_CONSTANTS_NUMBERS.N8;
BcListRowConstants.ZERO = COMMON_CONSTANTS_NUMBERS.N0;
BcListRowConstants.FIRST_POSITION = COMMON_CONSTANTS_NUMBERS.N1;
BcListRowConstants.TWO_PRIMARY_ELEMENTS = COMMON_CONSTANTS_NUMBERS.N2;
BcListRowConstants.DOUBLE = COMMON_CONSTANTS_NUMBERS.N2;
BcListRowConstants.LIST_COLUMN = `${BcCommonConstants.PREFIX_LIB}-list-column`;
BcListRowConstants.LIST_COLUMN_ACTION = `${BcCommonConstants.PREFIX_LIB}-list-column-action`;
BcListRowConstants.LIST_COLUMN_ACTION_CHECKBOX = `${BcCommonConstants.PREFIX_LIB}-list-column-action-checkbox`;
BcListRowConstants.LIST_COLUMN_CONTENT = BcListRowConstants.LIST_COLUMN + '-content';
BcListRowConstants.LIST_COLUMN_CONTENT_DATA = BcListRowConstants.LIST_COLUMN + '-content-data';
BcListRowConstants.LIST_COLUMN_CONTENT_DATA_TEXT_SHRINKABLE = `${BcListRowConstants.LIST_COLUMN_CONTENT_DATA}-text-shrinkable`;
BcListRowConstants.LIST_COLUMN_CONTENT_PRIMARY = `${BcListRowConstants.LIST_COLUMN_CONTENT}-primary`;
BcListRowConstants.LIST_COLUMN_HIDE_EXTRA_COLUMN = BcListRowConstants.LIST_COLUMN + '-hide-extra-column';
BcListRowConstants.LIST_COLUMN_MENU = BcListRowConstants.LIST_COLUMN + '-menu';
BcListRowConstants.LIST_COLUMN_ORDER = BcListRowConstants.LIST_COLUMN + '-order';
BcListRowConstants.LIST_COLUMN_LEFT_MOBILE_POSITION = BcListRowConstants.LIST_COLUMN + '-left-mobile-position';
BcListRowConstants.LIST_ROW = `${BcCommonConstants.PREFIX_LIB}-list-row`;
BcListRowConstants.LIST_ROW_ACTION_ICON = BcListRowConstants.LIST_ROW + '-action-icon';
BcListRowConstants.LIST_ROW_CHECKBOX = BcListRowConstants.LIST_ROW + '-checkbox';
BcListRowConstants.LIST_ROW_CHECKBOX_SELECTED = `${BcListRowConstants.LIST_ROW_CHECKBOX}-selected`;
BcListRowConstants.LIST_ROW_CONTAINER_CHECKBOX = BcListRowConstants.LIST_ROW + '-container-checkbox';
BcListRowConstants.LIST_ROW_CONTENT = BcListRowConstants.LIST_ROW + '-content';
BcListRowConstants.LIST_ROW_CONTENT_DATA = BcListRowConstants.LIST_ROW + '-content-data';
BcListRowConstants.LIST_ROW_MAIN_CONTENT = BcListRowConstants.LIST_ROW + '-main-content';
BcListRowConstants.LIST_ROW_NUMBER_0 = `${BcListRowConstants.ZERO}`;
BcListRowConstants.LIST_ROW_NUMBER_1 = `${COMMON_CONSTANTS_NUMBERS.N1}`;
BcListRowConstants.LIST_ROW_NUMBER_2 = `${COMMON_CONSTANTS_NUMBERS.N2}`;
BcListRowConstants.LIST_ROW_NUMBER_3 = `${COMMON_CONSTANTS_NUMBERS.N3}`;
BcListRowConstants.LIST_ROW_NUMBER_4 = `${COMMON_CONSTANTS_NUMBERS.N4}`;
BcListRowConstants.LIST_ROW_NUMBER_5 = `${COMMON_CONSTANTS_NUMBERS.N5}`;
BcListRowConstants.LIST_ROW_NUMBER_6 = `${COMMON_CONSTANTS_NUMBERS.N6}`;
BcListRowConstants.LIST_ROW_RADIOBUTTON = BcListRowConstants.LIST_ROW + '-radiobutton';
BcListRowConstants.LIST_ROW_RADIOBUTTON_SELECTED = `${BcListRowConstants.LIST_ROW_RADIOBUTTON}-selected`;
BcListRowConstants.LIST_ROW_TABLE = `${BcListRowConstants.LIST_ROW}-table`;
BcListRowConstants.LIST_ROW_TITLE = `${BcListRowConstants.LIST_ROW}-title`;
BcListRowConstants.TABLE_SMALL_BREAK_POINT = '576';
BcListRowConstants.TABINDEX = 'tabindex';
BcListRowConstants.HEIGHT = 'height';
BcListRowConstants.BOTTOM = 'bottom';
class BcListRowAriaLabels {
}
BcListRowAriaLabels.FOR_BUTTON = 'button';
BcListRowAriaLabels.FOR_CELL = 'cell';
BcListRowAriaLabels.MAIN_ACTION = 'Acción principal';
BcListRowAriaLabels.DATA_COLUMN = 'Columna de datos';
BcListRowAriaLabels.CHECKBOX = 'Casilla de verificación';
BcListRowAriaLabels.ROW_OPTIONS = 'Opciones de la fila';
class BcListRowQuerySelectors {
}
BcListRowQuerySelectors.INPUT_TYPE_CHECKBOX = 'input[type=checkbox]';
BcListRowQuerySelectors.INPUT_TYPE_RADIO = 'input[type=radio]';

const _FLOAT_MENU_TOGGLE_CLASS = `${BcCommonConstants.PREFIX_LIB}-float-menu-toggle`;
const _FLOAT_MENU_CLASS = `${BcCommonConstants.PREFIX_LIB}-float-menu`;
const _FLOAT_MENU_CONTENT_CLASS = `${BcCommonConstants.PREFIX_LIB}-float-menu-content`;
const _FLOAT_MENU_CONTENT_ACTIVE_CLASS = `${BcCommonConstants.PREFIX_LIB}-float-menu-content-active`;
const _FLOAT_MENU_POSITION_LEFT = `${BcCommonConstants.PREFIX_LIB}-float-menu-positon-left`;
const _FLOAT_MENU_POSITION_RIGHT = `${BcCommonConstants.PREFIX_LIB}-float-menu-positon-right`;
const _FLOAT_MENU_ARROW = `${BcCommonConstants.PREFIX_LIB}-float-menu-arrow`;
const _FLOAT_MENU_ARROW_ACTIVE = `${BcCommonConstants.PREFIX_LIB}-float-menu-arrow-active`;
const _FLOAT_MENU_OPTION_CLASS = `${BcCommonConstants.PREFIX_LIB}-float-menu-option`;
const _FLOAT_MENU_CHECKBOX_CLASS = `${BcCommonConstants.PREFIX_LIB}-container-checkbox`;
const _FLOAT_MENU_SELECTED_ITEM_CLASS = `${BcCommonConstants.PREFIX_LIB}-float-menu-selected-item`;
const _FLOAT_MENU_SELECTED_ICON_CLASS = `${BcCommonConstants.PREFIX_LIB}-float-menu-selected-icon`;
const FLOAT_MENU_RADIO_GROUP_CLASS = `${BcCommonConstants.PREFIX_LIB}-radio-group`;
const _FLOAT_MENU_RADIO_LABEL = `${BcCommonConstants.PREFIX_LIB}-radio-label`;
const _FLOAT_MENU_OVERFLOW_BOTTOM = `${BcCommonConstants.PREFIX_LIB}-float-menu-overflow-botoom`;
const _FLOAT_MENU_OVERFLOW_RIGHT = `${BcCommonConstants.PREFIX_LIB}-float-menu-overflow-right`;
const _FLOAT_MENU_OVERFLOW_LEFT = `${BcCommonConstants.PREFIX_LIB}-float-menu-overflow-left`;
const _FLOAT_MENU_ARROW_OVERFLOW_BOTTOM = `${BcCommonConstants.PREFIX_LIB}-float-menu-overflow-arrow-botoom`;
const _FLOAT_MENU_ARROW_OVERFLOW_RIGHT = `${BcCommonConstants.PREFIX_LIB}-float-menu-overflow-arrow-right`;
const _FLOAT_MENU_ARROW_OVERFLOW_LEFT = `${BcCommonConstants.PREFIX_LIB}-float-menu-overflow-arrow-left`;
const FLOAT_MENU_A_TAG_ELEMENT = `a`;
const _FLOAT_MENU_POSITION_OVERFLOW_BOTTOM = `${BcCommonConstants.PREFIX_LIB}-float-menu-overflow-position-botoom`;
const _FLOAT_MENU_POSITION_OVERFLOW_RIGHT = `${BcCommonConstants.PREFIX_LIB}-float-menu-overflow-position-right`;
const _FLOAT_MENU_POSITION_OVERFLOW_LEFT = `${BcCommonConstants.PREFIX_LIB}-float-menu-overflow-position-left`;
const FLOAT_MENU_INPUT_SELECT_CLASS = `${BcCommonConstants.PREFIX_LIB}-input-select`;
const FLOAT_MENU_ROLE_MENU = `menu`;
const FLOAT_MENU_ROLE_MENU_ITEM = `menuitem`;
const _FLOAT_MENU_NUMBER_0 = 0;
const _FLOAT_MENU_NUMBER_1 = 1;
const _FLOAT_MENU_SELECTED_CLASS = `${BcCommonConstants.PREFIX_LIB}-selected`;

class BcFloatMenuBehavior extends BcDefaultBehavior {
    constructor() {
        super();
        this.floatMenuContent = null;
        this.toggleButton = null;
        this.aElement = null;
        this.liElement = null;
        this.liElements = null;
        this.inputSelectElement = null;
        this.checkIfPositionLeft = null;
        this.checkIfPositionRight = null;
        this.arrowElement = null;
    }
    static setUpAll() {
        const floatMenuElements = Array.from(document.querySelectorAll(`[class~='${_FLOAT_MENU_CLASS}']`));
        for (const element of floatMenuElements) {
            const bcFloatMenuBehavior = new BcFloatMenuBehavior();
            bcFloatMenuBehavior.setElement(element);
            bcFloatMenuBehavior.setUp();
        }
    }
    _setUp() {
        this.getElements(this.mySelf);
        this.setFloatWidht(this.mySelf);
        this.eventListenerToggleButtonCloseOrOpenFloatMenu();
        this.eventListenerWindowCloseFloatMenu();
        this.eventListenerSelectedLiElementes();
        this.validateIfCheckboxOrRadioButtons();
        this.setWidthIfParentIsInputSelect();
        this.initAccesibility();
        this.itemsArrow();
    }
    getElements(mySelf) {
        this.toggleButton = mySelf.previousElementSibling;
        this.inputSelectElement = this.toggleButton;
        this.floatMenuContent = mySelf.querySelector(`.${_FLOAT_MENU_CONTENT_CLASS}`);
        this.liElement = this.floatMenuContent.querySelector(BcCommonConstants.LI_TAG);
        this.checkIfPositionLeft = mySelf.querySelector(`.${_FLOAT_MENU_POSITION_LEFT}`);
        this.checkIfPositionRight = mySelf.querySelector(`.${_FLOAT_MENU_POSITION_RIGHT}`);
        this.liElements = Array.from(this.floatMenuContent.querySelectorAll(BcCommonConstants.LI_TAG));
        this.arrowElement = mySelf.querySelector(`.${_FLOAT_MENU_ARROW}`);
    }
    setFloatWidht(mySelf) {
        if (!this.inputSelectElement.classList.contains(FLOAT_MENU_INPUT_SELECT_CLASS)) {
            const al = this.toggleButton.getBoundingClientRect();
            mySelf.style.width = `${al.width}px`;
            if ((this.mySelf.classList.contains(_FLOAT_MENU_POSITION_LEFT) || this.mySelf.classList.contains(_FLOAT_MENU_POSITION_RIGHT)) || this.arrowElement !== null) {
                mySelf.style.height = `${al.height}px`;
            }
        }
    }
    eventListenerToggleButtonCloseOrOpenFloatMenu() {
        this.toggleButton.addEventListener(BcCommonConstants.EVENT_CLICK, () => {
            this.toggleDropdown();
        });
    }
    eventListenerWindowCloseFloatMenu() {
        window.addEventListener(BcCommonConstants.EVENT_CLICK, (event) => {
            const isToggleElement = event.target.className.includes(_FLOAT_MENU_TOGGLE_CLASS);
            const isMainElement = event.target.className.includes(_FLOAT_MENU_OPTION_CLASS);
            const checkbox = event.target.className.includes(_FLOAT_MENU_CHECKBOX_CLASS);
            if (this.floatMenuActive && !isToggleElement && !isMainElement && !checkbox) {
                this.closeDropdown();
            }
        });
    }
    deleteSelectedItem(item) {
        const aSelected = item.querySelector(FLOAT_MENU_A_TAG_ELEMENT);
        if (aSelected.nextElementSibling?.nextElementSibling?.innerHTML === 'ok') {
            aSelected.nextElementSibling.nextElementSibling.remove();
        }
        else {
            aSelected.nextElementSibling?.remove();
        }
        if (this.checkSiblingElementEM(aSelected)) {
            aSelected.nextElementSibling.classList.remove(BcCommonConstants.INVISIBLE_CLASS);
        }
    }
    checkIfSelectedItems(ilElements) {
        for (const item of ilElements) {
            if (this.checkIfCheckbox(item)) {
                const isIt = item;
                if (isIt.className.includes(_FLOAT_MENU_SELECTED_ITEM_CLASS)) {
                    isIt.classList.remove(_FLOAT_MENU_SELECTED_ITEM_CLASS);
                    if (this.floatMenuContent.className.includes(_FLOAT_MENU_SELECTED_ICON_CLASS)) {
                        this.deleteSelectedItem(isIt);
                    }
                }
            }
        }
    }
    selectedBehavior(event) {
        let floatMenuContentCurrent;
        if (this.validateIfCheckboxOrRadioButtons()) {
            floatMenuContentCurrent = event.parentElement.parentElement.parentElement.parentElement;
        }
        else {
            floatMenuContentCurrent = event.parentNode;
        }
        const ilElements = Array.from(floatMenuContentCurrent.querySelectorAll(BcCommonConstants.LI_TAG));
        if (this.deleteSelectedCheckbox(event)) {
            return;
        }
        this.checkIfSelectedItems(ilElements);
        this.putSelected(event);
        if (this.checkIfCheckbox(event)) {
            this.closeDropdown();
        }
    }
    deleteSelectedCheckbox(event) {
        if (!this.checkIfCheckbox(event)) {
            if (event.classList.contains(_FLOAT_MENU_SELECTED_ITEM_CLASS) === true) {
                event.querySelector(BcCommonConstants.INPUT_TAG).checked = false;
                event.classList.remove(_FLOAT_MENU_SELECTED_ITEM_CLASS);
                return true;
            }
        }
    }
    checkIfCheckbox(event) {
        if (event.querySelector(`.${_FLOAT_MENU_CHECKBOX_CLASS}`) == null) {
            return true;
        }
        else {
            return false;
        }
    }
    putSelected(event) {
        let selected = event;
        if (this.validateIfCheckboxOrRadioButtons()) {
            selected = this.putValueToCheckboc(selected);
        }
        selected.classList.add(_FLOAT_MENU_SELECTED_ITEM_CLASS);
        this.aElement = selected.querySelector(FLOAT_MENU_A_TAG_ELEMENT);
        if (!this.floatMenuContent.className.includes(_FLOAT_MENU_SELECTED_ICON_CLASS)) {
            return;
        }
        if (this.checkSiblingElementEM(this.aElement)) {
            this.aElement.nextElementSibling?.classList.add(BcCommonConstants.INVISIBLE_CLASS);
        }
        const em = document.createElement(BcCommonConstants.EM_TAG);
        em.innerText = 'ok';
        em.classList.add(BcCommonConstants.ICONS_CLASS);
        selected.appendChild(em);
    }
    putValueToCheckboc(selected) {
        const a = selected.querySelector(BcCommonConstants.INPUT_TAG);
        a.checked = true;
        if (selected.classList.contains(_FLOAT_MENU_RADIO_LABEL)) {
            return ((selected.parentElement.parentElement.parentElement));
        }
        if (selected.classList.contains(_FLOAT_MENU_CHECKBOX_CLASS)) {
            return (selected.parentElement.parentElement);
        }
        else {
            return selected;
        }
    }
    checkSiblingElementEM(selected) {
        if (selected.nextElementSibling !== null) {
            return selected.nextElementSibling.nodeName.toLowerCase() === BcCommonConstants.EM_TAG || selected.nextElementSibling.nodeName.toLowerCase() === BcCommonConstants.IMG_TAG;
        }
        else {
            return false;
        }
    }
    eventListenerSelectedLiElementes() {
        for (const elementLi of this.liElements) {
            elementLi.addEventListener(BcCommonConstants.EVENT_CLICK, (event) => {
                event.preventDefault();
                this.selectedBehavior(event.target);
            });
        }
    }
    validateIfCheckboxOrRadioButtons() {
        return (this.liElement.innerHTML.includes(FLOAT_MENU_RADIO_GROUP_CLASS) || this.liElement.innerHTML.includes(_FLOAT_MENU_CHECKBOX_CLASS));
    }
    openDrowndown() {
        replaceClass(this.floatMenuContent, _FLOAT_MENU_CONTENT_CLASS, _FLOAT_MENU_CONTENT_ACTIVE_CLASS);
        replaceClass(this.arrowElement, _FLOAT_MENU_ARROW, _FLOAT_MENU_ARROW_ACTIVE);
        this.setDropdownContentPosition();
        this.floatMenuActive = true;
    }
    closeDropdown() {
        replaceClass(this.floatMenuContent, _FLOAT_MENU_CONTENT_ACTIVE_CLASS, _FLOAT_MENU_CONTENT_CLASS);
        replaceClass(this.arrowElement, _FLOAT_MENU_ARROW_ACTIVE, _FLOAT_MENU_ARROW);
        this.floatMenuActive = false;
    }
    validateDropdownIsActive() {
        return this.floatMenuContent.classList.contains(_FLOAT_MENU_CONTENT_ACTIVE_CLASS);
    }
    toggleDropdown() {
        if (!this.validateDropdownIsActive()) {
            this.floatMenuActive = false;
        }
        if (this.floatMenuActive) {
            this.closeDropdown();
        }
        else {
            this.openDrowndown();
        }
    }
    setWidthIfParentIsInputSelect() {
        if (this.inputSelectElement.classList.contains(FLOAT_MENU_INPUT_SELECT_CLASS)) {
            const parentWidth = this.inputSelectElement.clientWidth;
            this.floatMenuContent.style.width = `${parentWidth}px`;
            this.floatMenuContent.style.overflow = BcCommonConstants.HIDDEN;
            this.floatMenuContent.querySelector(BcCommonConstants.UL_TAG).style.maxWidth = BcCommonConstants.NONE;
        }
    }
    setDropdownContentPosition() {
        if (this.floatMenuActive !== null) {
            this.floatMenuPosition = this.mySelf.getBoundingClientRect();
            this.floatMenuContentPosition = this.floatMenuContent.getBoundingClientRect();
            this.windowWidth = document.documentElement.clientWidth;
            this.windowHeight = document.documentElement.clientHeight;
            const right = this.floatMenuContentPosition.right;
            const bottom = this.floatMenuContentPosition.bottom;
            const left = this.floatMenuContentPosition.left;
            this.positionDefaultFloatMenu(left, right, bottom);
            this.positionFeaturePostionFloatMenu(left, right, bottom);
            this.positionFeatureArrow(left, right, bottom);
        }
    }
    positionFeatureArrow(left, right, bottom) {
        if (this.arrowElement !== null) {
            if (bottom > this.windowHeight) {
                this.mySelf.classList.add(_FLOAT_MENU_ARROW_OVERFLOW_BOTTOM);
            }
            if (right > this.windowWidth) {
                this.mySelf.classList.add(_FLOAT_MENU_ARROW_OVERFLOW_RIGHT);
            }
            if (left < 0) {
                this.mySelf.classList.add(_FLOAT_MENU_ARROW_OVERFLOW_LEFT);
            }
        }
    }
    positionFeaturePostionFloatMenu(left, right, bottom) {
        if ((this.mySelf.classList.contains(_FLOAT_MENU_POSITION_LEFT) || this.mySelf.classList.contains(_FLOAT_MENU_POSITION_RIGHT))) {
            if (bottom > this.windowHeight) {
                this.mySelf.classList.add(_FLOAT_MENU_POSITION_OVERFLOW_BOTTOM);
            }
            if (right > this.windowWidth) {
                this.mySelf.classList.add(_FLOAT_MENU_POSITION_OVERFLOW_RIGHT);
            }
            if (left < 0) {
                this.mySelf.classList.add(_FLOAT_MENU_POSITION_OVERFLOW_LEFT);
            }
        }
    }
    positionDefaultFloatMenu(left, right, bottom) {
        if (!(this.mySelf.classList.contains(_FLOAT_MENU_POSITION_LEFT) || this.mySelf.classList.contains(_FLOAT_MENU_POSITION_RIGHT)) && (this.arrowElement === null)) {
            if (bottom > this.windowHeight) {
                this.mySelf.classList.add(_FLOAT_MENU_OVERFLOW_BOTTOM);
            }
            if (right > this.windowWidth) {
                this.floatMenuContent.style.right = `${_FLOAT_MENU_NUMBER_0}%`;
            }
            if (left < 0) {
                this.floatMenuContent.classList.add(_FLOAT_MENU_OVERFLOW_LEFT);
            }
        }
    }
    initAccesibility() {
        const ulElemnet = this.floatMenuContent.querySelector(BcCommonConstants.UL_TAG);
        addFocusable(ulElemnet, { role: FLOAT_MENU_ROLE_MENU });
        for (const iteme of this.liElements) {
            const aElm = ulElemnet?.querySelector(FLOAT_MENU_A_TAG_ELEMENT);
            addFocusable(aElm, { role: FLOAT_MENU_ROLE_MENU_ITEM });
            addFocusable(iteme, { tabindex: '0', role: FLOAT_MENU_ROLE_MENU_ITEM });
        }
        for (const elementLi of this.liElements) {
            elementLi.addEventListener(BcCommonConstants.EVENT_KEY_UP, (event) => {
                if (event['key'] === BcCommonConstants.KEY_EVENT_ENTER) {
                    this.selectedBehavior(event.target);
                    this.closeDropdown();
                }
            });
            addFocusable(this.toggleButton, { tabindex: '0' });
            this.toggleButton.addEventListener(BcCommonConstants.EVENT_KEY_UP, (event) => {
                if (event['key'] === BcCommonConstants.KEY_EVENT_ENTER) {
                    this.openDrowndown();
                }
            });
            this.toggleButton.addEventListener(BcCommonConstants.EVENT_KEY_UP, (event) => {
                if (event['key'] === BcCommonConstants.KEY_EVENT_ESCAPE) {
                    this.closeDropdown();
                }
            });
        }
        this.floatMenuContent.addEventListener(BcCommonConstants.EVENT_KEY_UP, (event) => {
            const _liElements = Array.from(this.floatMenuContent.querySelectorAll(BcCommonConstants.LI_TAG));
            const firstItem = _liElements[_FLOAT_MENU_NUMBER_0];
            const lastIment = _liElements[_liElements.length - _FLOAT_MENU_NUMBER_1];
            if (event['key'] === BcCommonConstants.KEY_EVENT_ESCAPE) {
                this.closeDropdown();
            }
            if (event['key'] === BcCommonConstants.KEY_EVENT_HOME) {
                firstItem.focus();
            }
            else if (event['key'] === BcCommonConstants.KEY_EVENT_END) {
                lastIment.focus();
            }
        });
    }
    itemsArrow() {
        const firstItem = this.liElements[0];
        const lastItem = this.liElements[this.liElements.length - _FLOAT_MENU_NUMBER_1];
        this.liElements.forEach((element, index) => {
            element.addEventListener(BcCommonConstants.EVENT_KEY_DOWN, (event) => {
                if (event.code === BcCommonConstants.KEY_EVENT_ARROW_DOWN) {
                    if (index == this.liElements.length - _FLOAT_MENU_NUMBER_1) {
                        firstItem.focus();
                    }
                    else {
                        element.nextElementSibling.focus();
                    }
                }
                else if (event.code === BcCommonConstants.KEY_EVENT_ARROW_UP) {
                    if (index == _FLOAT_MENU_NUMBER_0) {
                        lastItem.focus();
                    }
                    else {
                        element.previousElementSibling.focus();
                    }
                }
            });
        });
    }
}

class BcListRowBehavior extends BcDefaultBehavior {
    constructor() {
        super();
        this.tagClass = `${BcListRowConstants.LIST_COLUMN_ORDER}-${BcListRowConstants.TAG_TAG}`;
        this.orderClass = `${BcListRowConstants.LIST_COLUMN_ORDER}`;
    }
    /**
     * Encuentra todos los elementos con la clase `.bc-list-row-table` y luego crea una nueva instancia
     * de `BcListRowBehavior` para cada uno
     * @returns Una matriz de instancias de BcListRowBehavior.
     */
    static setUpAll() {
        const listRowParentElements = Array.from(document.querySelectorAll(`.${BcListRowConstants.LIST_ROW_TABLE}`));
        const elements = [];
        for (const listRowParentElement of listRowParentElements) {
            const listRowInstance = new BcListRowBehavior();
            listRowInstance.setElement(listRowParentElement);
            listRowInstance.setUp();
            elements.push(listRowInstance);
        }
        return elements;
    }
    /**
     * Realiza toda la configuración del objeto.
     */
    _setUp() {
        this.getElements();
        this.setCheckbox();
        this.setRadioButton();
        this.setAccesibility();
        this.setTooltipTexts();
        this.addingPrimaryColumns();
        this.windowsResizeEvent();
        this.mobileResponsive();
        BcTooltipBehavior.setUpAll();
        BcFloatMenuBehavior.setUpAll();
    }
    /**
     * Obtiene la lista de filas que tengan la clase bc-list-row y las almacena en la propiedad rows
     * @memberof BcListRowBehavior
     */
    getElements() {
        this.rows = Array.from(this.mySelf.querySelectorAll(`.${BcListRowConstants.LIST_ROW}`));
    }
    /**
     * Asigna la clase al list cuando el checkbox esta activo.
     * @memberof BcListRowBehavior
     */
    setCheckbox() {
        this.rows.forEach((row) => {
            const checkbox = row.querySelector(BcListRowQuerySelectors.INPUT_TYPE_CHECKBOX);
            checkbox?.addEventListener(BcListRowConstants.EVENT_CHANGE, function () {
                this.checked ? row.classList.add(BcListRowConstants.LIST_ROW_CHECKBOX_SELECTED) : row.classList.remove(BcListRowConstants.LIST_ROW_CHECKBOX_SELECTED);
            });
        });
    }
    /**
     * Asigna la clase al list cuando el radio button esta activo.
     * @memberof BcListRowBehavior
     */
    setRadioButton() {
        this.rows.forEach((row) => {
            const radioButton = row.querySelector(BcListRowQuerySelectors.INPUT_TYPE_RADIO);
            radioButton?.addEventListener(BcListRowConstants.EVENT_CHANGE, function () {
                const rowSelected = document.querySelector(`tr.${BcListRowConstants.LIST_ROW_RADIOBUTTON_SELECTED}`);
                rowSelected?.classList.remove(BcListRowConstants.LIST_ROW_RADIOBUTTON_SELECTED);
                this.checked && row.classList.add(BcListRowConstants.LIST_ROW_RADIOBUTTON_SELECTED);
            });
        });
    }
    /**
     * Controla la accesibilidad de foco en la fila y agrega el atributo tabindex y un detector de eventos keydown a la
     * columna de acción y la columna de menú.
     * @memberof BcListRowBehavior
     */
    setAccesibility() {
        const bcListRowElements = Array.from(this.mySelf.querySelectorAll(`.${BcListRowConstants.LIST_ROW}`));
        bcListRowElements.forEach((row) => {
            this.setElementAttributes(row);
            this.setListenerForActionableKeys(row);
        });
    }
    /**
     * Ajusta la configuración de textos cuando hay ellipsis
     *  @memberof BcListRowBehavior
     */
    setTooltipTexts() {
        const bcListTexts = this.mySelf.querySelectorAll(`.${BcListRowConstants.LIST_COLUMN_CONTENT_DATA_TEXT_SHRINKABLE}`);
        bcListTexts.forEach((bcListText) => {
            if (bcListText.offsetWidth < bcListText.scrollWidth) {
                bcListText.classList.add(BcListRowConstants.BC_TOOLTIP_CLASS);
                bcListText.setAttribute(BcListRowConstants.BC_TOOLTIP_TEXT, bcListText.innerHTML);
                bcListText.removeAttribute(BcListRowConstants.TABINDEX);
            }
        });
    }
    /**
     * Recorre cada fila de la tabla y por cada fila agrega la clase primary y oculta las columnas extras
     * @memberof BcListRowBehavior
     */
    addingPrimaryColumns() {
        this.rows.forEach(row => {
            this.setPrimaryColumns(row);
            this.hideExtraColumns(row);
        });
    }
    /**
     * Recorre todos los elementos `td` con la clase bc-list-column-content que tambien tengan la clase primary y obtiene sus indices.
     * En caso de no tenerlos, este metodo asigna por defecto la clase primary.
     * @param {Element} row - Element - el elemento row
     * @memberof BcListRowBehavior
     */
    setPrimaryColumns(row) {
        const contentColumns = Array.from(row.querySelectorAll(`.${BcListRowConstants.LIST_COLUMN_CONTENT}`));
        let contentColumnIndexes = [];
        contentColumns.forEach((contentColumn, index) => {
            contentColumn.classList.contains(BcListRowConstants.LIST_COLUMN_CONTENT_PRIMARY) && contentColumnIndexes.push(index);
        });
        if (contentColumnIndexes.length === 0) {
            contentColumnIndexes = this.getDefaultPrimaryIndexes(contentColumns);
            this.addPrimaryClassForResponsive(row, contentColumnIndexes);
        }
    }
    /**
    * Evento de resize para recalcular
    * @private
    * @memberof BcListRowBehavior
    */
    windowsResizeEvent() {
        window.addEventListener(BcListRowConstants.EVENT_RESIZE, () => {
            this.mobileResponsive();
        });
    }
    /**
     * Obtiene de la propiedad `row` la lista de elementos y los recorre para ajustar el responsive mobile en resolucion de 576px
     * @private
     * @memberof BcListRowBehavior
     */
    mobileResponsive() {
        this.getElements();
        this.rows.forEach((row) => {
            window.innerWidth <= Number(BcListRowConstants.TABLE_SMALL_BREAK_POINT)
                ? this.addPrimaryOrderIndex(row)
                : this.removeMobileClasses(row);
        });
    }
    /**
     * Consulta la cantidad de elementos que tiene la fila para luego obtener los indices de los que tendran la clase bc-list-column-content-primary
     * @private
     * @returns {number[]} una lista de los elementos que tendran la clase bc-list-column-content-primary
     * @memberof BcListRowBehavior
     */
    getDefaultPrimaryIndexes(contentColumns) {
        const lengthOfContentColumnsShowed = contentColumns.length > BcListRowConstants.LIST_ROW_MAX_NUMBER ? BcListRowConstants.LIST_ROW_MAX_NUMBER : contentColumns.length;
        const listOfTheLastContentColumnsIndexes = Array.from({ length: lengthOfContentColumnsShowed }, (_, index) => index).slice(-BcListRowConstants.LIST_ROW_LAST_ITEMS);
        const firstRowElementIndex = 0;
        return [firstRowElementIndex, ...listOfTheLastContentColumnsIndexes];
    }
    /**
     * Toma una fila y agrega la clase hide para ocultar columnas extras
     * @param {Element} row - Element - fila que contiene las columnas a las que se le va a aplicar la clase hide
     * @memberof BcListRowBehavior
     */
    hideExtraColumns(row) {
        const columns = Array.from(row.querySelectorAll(`.${BcListRowConstants.LIST_COLUMN_CONTENT}`));
        const numberOfExtraColumns = columns.length - BcListRowConstants.LIST_ROW_MAX_NUMBER;
        const extraColumns = numberOfExtraColumns > 0 ? columns.slice(-numberOfExtraColumns) : [];
        extraColumns.forEach(extraColumn => {
            extraColumn.classList.add(BcListRowConstants.LIST_COLUMN_HIDE_EXTRA_COLUMN);
        });
    }
    /**
     * Agrega la clase primary segun la lista de indices de columnas
     * @param {Element} row - Element - la fila que contiene las columnas a las que se le agrega la clase primary
     * @param {Array} primaryColumnIndexes - Arreglo de índices de las columnas a las que se le agrega la clase primary.
     * @memberof BcListRowBehavior
     */
    addPrimaryClassForResponsive(row, primaryColumnIndexes) {
        const columnContents = Array.from(row.querySelectorAll(`.${BcListRowConstants.LIST_COLUMN_CONTENT}`));
        for (const primaryColumnIndex of primaryColumnIndexes) {
            columnContents[primaryColumnIndex].classList.add(BcListRowConstants.LIST_COLUMN_CONTENT_PRIMARY);
        }
    }
    /**
     * Agrega la clase primary en mobile responsive
     * @param {HTMLElement} row - HTMLElement - la fila que contiene las columnas que se les agregan las clases necesarias para el responsive mobile
     * @memberof BcListRowBehavior
     */
    addPrimaryOrderIndex(row) {
        if (!row.style.height) {
            const { paddingBottom, height } = this.getComputedValues(row);
            const primaries = row.querySelectorAll(`.${BcListRowConstants.LIST_COLUMN_CONTENT_PRIMARY}`);
            primaries.forEach((primary, index) => {
                let setIndex = index + 1;
                (primaries.length === BcListRowConstants.TWO_PRIMARY_ELEMENTS && index === BcListRowConstants.FIRST_POSITION) && setIndex++;
                primary.classList.contains(BcListRowConstants.LIST_COLUMN_LEFT_MOBILE_POSITION) ?
                    primary.classList.add(this.tagClass) : primary.classList.add(`${this.orderClass}-${setIndex}`);
                primary.style.bottom = `${paddingBottom}px`;
            });
            if (primaries.length > 1 && !row.classList.contains(BcListRowConstants.LIST_ROW_TITLE)) {
                row.style.height = `${(height * BcListRowConstants.DOUBLE) + BcListRowConstants.LIST_ROW_SEPARATION_MOBILE + paddingBottom}px`;
            }
        }
    }
    /**
     * Elimina la configuracion de estilo para el responsive mobile
     * @param {HTMLElement} row - HTMLElement -la fila que va a modificar su comportamiento responsive mobile
     * @memberof BcListRowBehavior
     */
    removeMobileClasses(row) {
        if (row.style.height) {
            row.style.removeProperty(BcListRowConstants.HEIGHT);
            const primaries = row.querySelectorAll(`.${BcListRowConstants.LIST_COLUMN_CONTENT_PRIMARY}`);
            primaries.forEach((primary, index) => {
                primary.style.removeProperty(BcListRowConstants.BOTTOM);
                primary.classList.remove(`${this.orderClass}-${index + 1}`);
            });
        }
    }
    /**
     * Obtiene atributos de estilos css de un elemento html
     * @param {HTMLElement} element -Elemento del cual se quiere obtener los atributos.
     * @returns Un objeto con las propiedades de paddingTop, paddingBottom, y height.
     * @memberof BcListRowBehavior
     */
    getComputedValues(element) {
        const computedStyle = getComputedStyle(element);
        const height = element.offsetHeight;
        return {
            paddingTop: parseFloat(computedStyle.paddingTop),
            paddingBottom: parseFloat(computedStyle.paddingBottom),
            height: height - parseFloat(computedStyle.paddingTop) - parseFloat(computedStyle.paddingBottom)
        };
    }
    /**
     * Agrega un listener a la columna de acción y al menú desplegable de la fila.
     * @param {Element | HTMLElement} element - Elemento | HTMLElement: el elemento al que queremos
     * agregar el detector de eventos.
     * @memberof BcListRowBehavior
     */
    setListenerForActionableKeys(element) {
        const actionColumn = element.querySelector(`.${BcListRowConstants.LIST_COLUMN_ACTION}`);
        const columnMenu = element.querySelector(`.${BcListRowConstants.LIST_COLUMN_MENU}`);
        if (actionColumn) {
            actionColumn.addEventListener(BcListRowConstants.EVENT_KEY_DOWN, (event) => {
                if (event.code === BcListRowConstants.KEY_EVENT_SPACE || event.code === BcListRowConstants.KEY_EVENT_ENTER) {
                    event.preventDefault();
                    event.target.click();
                }
            });
        }
        if (columnMenu) {
            columnMenu.addEventListener(BcListRowConstants.EVENT_KEY_DOWN, (event) => {
                if (event.code === BcListRowConstants.KEY_EVENT_SPACE || event.code === BcListRowConstants.KEY_EVENT_ENTER) {
                    event.preventDefault();
                    event.target.click();
                }
            });
        }
    }
    /**
     * Establece los atributos tabindex, rol y aria-label de la fila y sus columnas
     * @param {Element | HTMLElement} element - Elemento | HTMLElement: El elemento al que se agregarán
     * los atributos.
     * @memberof BcListRowBehavior
     */
    setElementAttributes(element) {
        element.setAttribute(BcListRowConstants.TABINDEX, `${BcListRowConstants.ZERO}`);
        element.setAttribute(BcListRowConstants.ROLE, BcListRowAriaLabels.FOR_BUTTON);
        element.setAttribute(BcListRowConstants.ARIA_LABEL, BcListRowAriaLabels.MAIN_ACTION);
        const childrenElements = Array.from(element.children);
        if (element.children.length > 0) {
            childrenElements.forEach((child, index) => {
                child.setAttribute(BcListRowConstants.ROLE, BcListRowAriaLabels.FOR_CELL);
                child.classList.contains(BcListRowConstants.LIST_COLUMN_CONTENT) && child.setAttribute(BcListRowConstants.ARIA_LABEL, `${BcListRowAriaLabels.DATA_COLUMN} ${index}`);
                child.classList.contains(BcListRowConstants.LIST_COLUMN_ACTION) && child.setAttribute(BcListRowConstants.ARIA_LABEL, `${BcListRowAriaLabels.CHECKBOX}`);
                child.classList.contains(BcListRowConstants.LIST_COLUMN_MENU) && child.setAttribute(BcListRowConstants.ARIA_LABEL, `${BcListRowAriaLabels.ROW_OPTIONS}`);
            });
        }
    }
}

class BcInputDateBehavior extends BcAbstractDropdownBehavior {
    /**
      * Busca el componente mediante querySelectorAll y lo inicializa.
      * @returns array de elementos de tipo BcInputDateBehavior encontrados.
      * @memberof BcInputDateBehavior
      */
    static setUpAll() {
        const inputDateElements = Array.from(document.querySelectorAll(`.${BcDateConstants.DATE_INPUT_DATE_CLASS}`));
        const elements = [];
        for (let i = 0; i < inputDateElements.length; i++) {
            const element = inputDateElements[i];
            const inputDateElement = new BcInputDateBehavior();
            inputDateElement.setElement(element);
            inputDateElement.setUp();
            elements.push(inputDateElement);
        }
        return elements;
    }
    /**
     * Asigna el atributo type de tipo split al inputDate
     * @memberof BcInputDateBehavior
     */
    setUpSplitCalendar() {
        this.mySelf.setAttribute('type', BcDateConstants.STATE_SPLIT);
    }
    _setUp() {
        this.dropDownId = getId(BcInputDateBehavior);
        this.inputDate = this.mySelf.querySelector('input');
        const inputArrow = Array.from(this.mySelf.querySelectorAll(':scope div.bc-form-field em'));
        this.inputArrow = inputArrow[inputArrow.length - 1];
        this.inputDate.style.cursor = BcCommonConstants.CURSOR_POINTER;
        this.wrapperCalendar = document.createElement('div');
        const calendar = document.createElement('div');
        this.wrapperCalendar.setAttribute('id', this.dropDownId);
        this.wrapperCalendar.classList.add(_DROPDOWN_CONTENT_CLASS);
        calendar.classList.add(BcDateConstants.CALENDAR_CLASS);
        calendar.setAttribute('type', this.mySelf.getAttribute('type'));
        calendar.setAttribute(BcDateConstants.CALENDAR_BUTTON, this.mySelf.getAttribute(BcDateConstants.CALENDAR_BUTTON));
        calendar.setAttribute(BcDateConstants.CALENDAR_FILTER, this.mySelf.getAttribute(BcDateConstants.CALENDAR_FILTER));
        calendar.setAttribute(BcDateConstants.CALENDAR_HOLIDAY, this.mySelf.getAttribute(BcDateConstants.CALENDAR_HOLIDAY));
        this.wrapperCalendar.appendChild(calendar);
        this.calendarElement = calendar;
        this.mySelf.appendChild(this.wrapperCalendar);
        const calendarBehavior = new BcCalendarBehavior();
        this.setupMinAndMaxDate();
        calendarBehavior.setElement(this.calendarElement);
        calendarBehavior.setUp();
        this.calendarBehavior = calendarBehavior;
        this.configDropDown();
        this.addListeners();
        this.setAccesibility();
    }
    /**
     * Asigna los atributos de fecha minima y maxima al calendario en caso de estar presente en el input
     * @memberof BcInputDateBehavior
    */
    setupMinAndMaxDate() {
        const min = this.mySelf.getAttribute("min");
        const max = this.mySelf.getAttribute("max");
        if (min) {
            this.calendarElement.setAttribute("min", min);
        }
        if (max) {
            this.calendarElement.setAttribute("max", max);
        }
    }
    configDropDown() {
        const toogle = document.createElement('div');
        toogle.setAttribute('aria-controls', this.dropDownId);
        toogle.classList.add(_DROPDOWN_TOGGLE_CLASS);
        toogle.style.display = BcCommonConstants.NONE;
        this.mySelf.appendChild(toogle);
        this.mySelf.classList.add(_DROPDOWN_CLASS);
        const dropDowConfig = {
            toggleEvents: ['click', 'focus'],
            extraToggles: [
                {
                    node: this.inputDate,
                    events: ['focus']
                }
            ],
            static: true,
            isPopUp: false,
            isDisabled: false,
            parentWidth: true,
            contentAutoWidth: true,
            maxHeightContent: this.maxHeightContent
        };
        this.setDropdownContentPosition();
        this.setConfig(dropDowConfig);
        super._setUp();
    }
    addListeners() {
        this.eventCalendar();
        this.eventFocusOut();
        this.eventClick();
        this.eventKeyPress();
        this.eventInpuntDate();
    }
    /**
     * Configura la accesibilidad del Input date
     * @memberof BcInputDateBehavior
     * @void
     */
    setAccesibility() {
        window.addEventListener(BcCommonConstants.EVENT_KEY_DOWN, (event) => {
            if (event.key === BcCommonConstants.KEY_EVENT_ESCAPE) {
                this.closeDropdown();
            }
        });
    }
    /**
     * Inicializa los listeners para abrir y cerrar
     *  el calendar del input date
     * @memberof BcInputDateBehavior
     * @void
     */
    eventInpuntDate() {
        this.inputArrow.style.cursor = 'pointer';
        this.inputDate.addEventListener(BcCommonConstants.EVENT_CLICK, (e) => {
            this.handleClick(e);
        });
        this.inputArrow.addEventListener(BcCommonConstants.EVENT_CLICK, (e) => {
            this.handleClick(e);
        });
        this.calendarElement.addEventListener(BcCommonConstants.EVENT_CANCEL, (e) => {
            this.closeDropdown();
        });
    }
    /**
     * Inicializa los listeners para seleccion
     * del calendar del input date
     * @memberof BcInputDateBehavior
     * @void
     */
    eventCalendar() {
        this.calendarElement.addEventListener(BcCommonConstants.EVENT_SELECT, (e) => {
            e.preventDefault();
            this.setInputDateValue(e.detail);
            this.closeDropdown();
        });
    }
    /**
     * Inicializa los listeners para focusOut
     * del calendar del input date
     * @memberof BcInputDateBehavior
     * @void
     */
    eventFocusOut() {
        this.inputDate.addEventListener(BcCommonConstants.EVENT_FOCUSOUT, (e) => {
            e.preventDefault();
            if (e.target.value) {
                this.setInputDateValue(e.target.value);
            }
        }, false);
    }
    /**
     * Inicializa los listeners para clik
     * del calendar del input date
     * @memberof BcInputDateBehavior
     * @void
     */
    eventClick() {
        this.inputDate.addEventListener(BcCommonConstants.EVENT_CLICK, (e) => {
            e.preventDefault();
        });
    }
    /**
     * Inicializa los listeners para presionar teclas
     * del calendar del input date
     * @memberof BcInputDateBehavior
     * @void
     */
    eventKeyPress() {
        this.inputDate.addEventListener(BcCommonConstants.EVENT_KEY_PRESS, (e) => {
            if (e.key === 'Enter' && e.target.value) {
                this.setInputDateValue(e.target.value);
            }
        });
    }
    /**
     * cambia el estado del dropdown de abierto a cerrado o al contrario
     * @memberof BcInputDateBehavior
     * @void
     */
    handleClick(e) {
        this.calendarBehavior.setElementsWithFormatDate();
        e.preventDefault();
        this.toggleDropdown();
    }
    /**
     * setea el valor del input date
     * @memberof BcInputDateBehavior
     * @void
     */
    setInputDateValue(e) {
        this.inputDate.value = e;
        this.emitEvent();
    }
    /**
     * Actualiza el valor date al inputDate al output
     * @memberof BcInputDateBehavior
     */
    emitEvent() {
        this.value = this.inputDate.value;
        if (this.output) {
            this.output(this.value);
        }
    }
    /**
     * Asigna el nuevo valor date al input, una vez se modifique
     * @param value
     * @memberof BcInputDateBehavior
     */
    setValue(value) {
        if (this.inputDate) {
            this.inputDate.value = value;
            this.emitEvent();
        }
    }
    /**
      * Setea el atributo disabled al inputDate, habilita o deshabilita el componente.
      * @param {boolean} isDisabled
      * @memberof BcInputDateBehavior
      */
    setDisabledState(isDisabled) {
        this.inputDate.disabled = isDisabled;
    }
}

class BcInputDateRangeBehavior extends BcAbstractDropdownBehavior {
    static setUpAll() {
        const inputDateElements = Array.from(document.querySelectorAll(`.${BcDateConstants.RANGE_MOLECULE_CLASSES}`));
        const elements = [];
        for (let i = 0; i < inputDateElements.length; i++) {
            const element = inputDateElements[i];
            const inputDateElement = new BcInputDateRangeBehavior();
            inputDateElement.setElement(element);
            inputDateElement.setUp();
            elements.push(inputDateElement);
        }
        return elements;
    }
    _setUp() {
        this.dropDownId = getId(BcInputDateRangeBehavior);
        this.inputDate = this.mySelf.querySelectorAll('input')[0];
        this.inputDate.style.cursor = BcCommonConstants.CURSOR_POINTER;
        this.wrapperCalendar = document.createElement('div');
        this.wrapperCalendar.setAttribute('id', this.dropDownId);
        this.wrapperCalendar.classList.add(_DROPDOWN_CONTENT_CLASS);
        this.inputDateTwo = this.mySelf.querySelectorAll('input')[1];
        this.inputDateTwo.style.cursor = BcCommonConstants.CURSOR_POINTER;
        const fastButtons = this.mySelf.getAttribute(BcDateConstants.FAST_BUTTONS);
        const rangesText = this.mySelf.getAttribute(BcDateConstants.RANGES_TEXT);
        const calendar = document.createElement('div');
        calendar.setAttribute('type', 'range');
        calendar.setAttribute(BcDateConstants.RANGES, fastButtons);
        calendar.setAttribute(BcDateConstants.RANGES_TEXT, rangesText);
        calendar.classList.add(BcDateConstants.CALENDAR_CLASS);
        calendar.setAttribute(BcDateConstants.CALENDAR_HOLIDAY, this.mySelf.getAttribute(BcDateConstants.CALENDAR_HOLIDAY));
        this.wrapperCalendar.appendChild(calendar);
        this.calendarElement = calendar;
        this.mySelf.appendChild(this.wrapperCalendar);
        const calendarBehavior = new BcCalendarBehavior();
        this.setupMinAndMaxDate();
        calendarBehavior.setElement(this.calendarElement);
        calendarBehavior.setUp();
        this.calendarBehavior = calendarBehavior;
        this.configDropDown();
        this.addListeners();
    }
    configDropDown() {
        const toogle = document.createElement('div');
        toogle.setAttribute('aria-controls', this.dropDownId);
        toogle.classList.add(_DROPDOWN_TOGGLE_CLASS);
        toogle.style.display = BcCommonConstants.NONE;
        this.mySelf.appendChild(toogle);
        this.mySelf.classList.add(_DROPDOWN_CLASS);
        const dropDowConfig = {
            toggleEvents: ['click', 'focus'],
            extraToggles: [
                {
                    node: this.inputDate,
                    events: ['focus']
                },
                {
                    node: this.inputDateTwo,
                    events: ['focus']
                }
            ],
            static: true,
            isPopUp: false,
            isDisabled: false,
            parentWidth: true,
            contentAutoWidth: true,
            maxHeightContent: this.maxHeightContent
        };
        this.setDropdownContentPosition();
        this.setConfig(dropDowConfig);
        super._setUp();
    }
    addListeners() {
        this.calendarElement.addEventListener(BcCommonConstants.EVENT_RANGE, (e) => this.setInputDateValues(e));
        this.calendarElement.addEventListener(BcCommonConstants.EVENT_CANCEL, (e) => {
            this.closeDropdown();
        });
        this.inputDate.addEventListener(BcCommonConstants.EVENT_CLICK, (e) => {
            this.handleClick(e);
        });
        this.inputDateTwo.addEventListener(BcCommonConstants.EVENT_CLICK, (e) => {
            this.handleClick(e);
        });
        this.mySelf.querySelectorAll('em').forEach(em => {
            if (!em.classList.contains(BcDateConstants.CANCEL_CLASS)) {
                em.addEventListener(BcCommonConstants.EVENT_CLICK, () => this.openDrowndown(), false);
                em.style.cursor = BcCommonConstants.CURSOR_POINTER;
            }
        });
    }
    handleClick(e) {
        e.preventDefault();
        this.toggleDropdown();
    }
    setInputDateValues(e) {
        this.inputDate.value = e.detail[0].toISOString().substring(0, SIZE_DATE_STR);
        this.inputDateTwo.value = e.detail[1].toISOString().substring(0, SIZE_DATE_STR);
        this.toggleDropdown();
        this.emitEvent();
    }
    emitEvent() {
        const value = {
            initialDate: this.inputDate.value,
            toDate: this.inputDateTwo.value,
        };
        this.inputDateValue = this.inputDate.value;
        this.inputDateTwoValue = this.inputDateTwo.value;
        if (this.output) {
            this.output(value);
        }
    }
    setValues(value, valueTwo) {
        if (value && valueTwo) {
            this.inputDate.value = value;
            this.inputDateTwo.value = valueTwo;
            this.emitEvent();
        }
    }
    setDisabled(isDisabled) {
        this.inputDate.disabled = isDisabled;
        this.inputDateTwo.disabled = isDisabled;
    }
    /**
     * Asigna los atributos de fecha minima y maxima al calendario en caso de estar presente en el input
     * @memberof BcInputDateBehavior
    */
    setupMinAndMaxDate() {
        const min = this.mySelf.getAttribute("min");
        const max = this.mySelf.getAttribute("max");
        if (min) {
            this.calendarElement.setAttribute("min", min);
        }
        if (max) {
            this.calendarElement.setAttribute("max", max);
        }
    }
}

const MODAL = `${BcCommonConstants.PREFIX_LIB}-modal`;
const MODAL_ACTIVE = `${BcCommonConstants.PREFIX_LIB}-modal-active`;
const BC_MODAL_CLOSE = `${BcCommonConstants.PREFIX_LIB}-modal-close-button`;
const BC_MODAL_BUTTON_CONTAINER = `${BcCommonConstants.PREFIX_LIB}-modal-button-container`;
const BC_MODAL_TITLE = `${BcCommonConstants.PREFIX_LIB}-modal-title`;
const BC_MODAL_TITLE_LABEL = `modal-title-label`;
const BC_MODAL_CONTENT = `${BcCommonConstants.PREFIX_LIB}-modal-content`;
const BC_MODAL_OVERLAY = `${BcCommonConstants.PREFIX_LIB}-modal-overlay`;
const OPEN_STATE_MODAL = 1;
const CLOSE_STATE_MODAL = 0;
const MAIN_TASK = 1;
const SECONDARY_TASK = 0;

class BcModalBehavior extends BcDefaultBehavior {
    constructor() {
        super();
        this.isMainButtonConfigured = false;
        this.isSecondaryButtonConfigured = false;
        this.eventClosedAdded = false;
        this.modalState = CLOSE_STATE_MODAL;
    }
    static setUpAll() {
        const modalElements = Array.from(document.querySelectorAll(`article[class='${MODAL}']`));
        const elements = [];
        for (const modal of modalElements) {
            const bcModalBehavior = new BcModalBehavior();
            bcModalBehavior.setElement(modal);
            bcModalBehavior.setUp();
            elements.push(bcModalBehavior);
        }
        return elements;
    }
    _setUp() {
        this.getElement();
        this.configEventListener();
        if (this.closeButton && !this.eventClosedAdded) {
            this.closeButton.removeEventListener(BcCommonConstants.EVENT_CLICK, this.closeModal.bind(this));
            this.closeButton.addEventListener(BcCommonConstants.EVENT_CLICK, this.closeModal.bind(this));
            this.eventClosedAdded = true;
        }
        this.accessibility();
        this.optionalClose();
        this.closeEventKey();
        if (this.closeButton !== null) {
            this.setEventToCloseBtn();
        }
    }
    createOverlay() {
        const status = createElement({
            element: BcCommonConstants.DIV_TAG,
            classList: [BC_MODAL_OVERLAY],
        });
        document.body.insertBefore(status, null);
    }
    /**
     * Configura la accesibilidad de los botones del modal. El principal, el secundario y el de cierre.
     * @memberof BcModalBehavior
     */
    accessibility() {
        const title = this.mySelf.querySelector(`.${BC_MODAL_TITLE_LABEL}`);
        const content = this.mySelf.querySelector(`section.${BC_MODAL_CONTENT}`);
        addFocusable(title, { tabindex: '0' });
        addFocusable(content, { tabindex: '0' });
        addFocusable(this.closeButton, { pressed: 'false', tabindex: '0' }, { event: () => this.closeModal() });
        addFocusable(this.mainButton, { pressed: 'false' }, { event: () => this.configEventListener() });
        addFocusable(this.secondaryButton, { pressed: 'false' }, { event: () => this.configEventListener() });
    }
    getElement() {
        this.mainButton = this.mySelf.querySelector(`.${BC_MODAL_BUTTON_CONTAINER} .${BcCommonConstants.BTN_PRIMARY_CLASS}`);
        this.secondaryButton = this.mySelf.querySelector(`.${BC_MODAL_BUTTON_CONTAINER} .${BcCommonConstants.BTN_SECONDARY_CLASS}`);
        this.closeButton = this.mySelf.querySelector(`button[class*='${BC_MODAL_CLOSE}']`);
        this.modalOverlay = this.mySelf.querySelector(`article[class='${MODAL}']`);
    }
    /**
     * Configura el callback en el evento click en los botones del modal.
     * @memberof BcModalBehavior
     */
    configEventListener() {
        if (this.callback) {
            if (this.mainButton && !this.isMainButtonConfigured) {
                this.isMainButtonConfigured = true;
                this.configureCallBack(this.mainButton, MAIN_TASK);
            }
            if (this.secondaryButton && !this.isSecondaryButtonConfigured) {
                this.configureCallBack(this.secondaryButton, SECONDARY_TASK);
                this.isSecondaryButtonConfigured = true;
            }
        }
    }
    configureCallBack(button, state) {
        function functToEval() {
            this.callback(state);
        }
        button.addEventListener(BcCommonConstants.EVENT_CLICK, functToEval.bind(this), true);
    }
    optionalClose() {
        this.mySelf.addEventListener(BcCommonConstants.EVENT_CLICK, (event) => {
            if (event.target.classList.contains(MODAL_ACTIVE) &&
                this.modalState === 1) {
                this.closeModal();
            }
        });
    }
    closeEventKey() {
        window.addEventListener(BcCommonConstants.EVENT_KEY_DOWN, (event) => {
            if (event.key === BcCommonConstants.KEY_EVENT_ESCAPE) {
                this.closeModal();
            }
        });
    }
    /**
     * Abre el modal y actualiza el control del estado (changeState).
     * @memberof BcModalBehavior
     */
    openModal() {
        this.modalState = OPEN_STATE_MODAL;
        this.changeState();
        this.createOverlay();
    }
    /**
     * Cierra el modal y actualiza el control del estado (changeState).
     * @memberof BcModalBehavior
     */
    closeModal() {
        this.modalState = CLOSE_STATE_MODAL;
        this.changeState();
        const overlayElement = document.querySelector(`.${BC_MODAL_OVERLAY}`);
        if (overlayElement) {
            overlayElement.remove();
        }
        if (this.closeModalCallback) {
            this.closeModalCallback();
        }
    }
    changeState() {
        if (this.modalState === OPEN_STATE_MODAL) {
            this.mySelf.classList.replace(MODAL, MODAL_ACTIVE);
        }
        else if (this.modalState === CLOSE_STATE_MODAL) {
            this.mySelf.classList.replace(MODAL_ACTIVE, MODAL);
        }
    }
    setEventToCloseBtn() {
        this.closeButton.addEventListener(BcCommonConstants.EVENT_CLICK, () => {
            this.closeModal();
        });
    }
}

const BC_ALERT = `${BcCommonConstants.PREFIX_LIB}-alert`;
const BC_ALERT_ACTIVE = `${BcCommonConstants.PREFIX_LIB}-alert-active`;
const BC_ALERT_CLOSE = `${BcCommonConstants.PREFIX_LIB}-alert-close`;
const BC_ALERT_CLOSING = `${BcCommonConstants.PREFIX_LIB}-alert-closing`;
const BC_ALERT_DISMISSIBLE = `${BcCommonConstants.PREFIX_LIB}-alert-dismissible`;
const BC_ALERT_INLINE = `${BcCommonConstants.PREFIX_LIB}-alert-inline`;
const BC_ALERT_CONTENT = `${BcCommonConstants.PREFIX_LIB}-alert-content`;
const MAX_TIME_DELAY = 10000;
const MIN_TIME_DELAY = 5000;
const MIN_TIMEOUT = 1000;

class BcAlertBehavior extends BcDefaultBehavior {
    constructor() {
        super();
        this.timeOut = 0;
    }
    static setUpAll() {
        const alertElements = Array.from(document.querySelectorAll(`.${BC_ALERT}`));
        const elements = [];
        for (let i = 0; i < alertElements.length; i++) {
            const element = alertElements[i];
            const bcAlertBehavior = new BcAlertBehavior();
            bcAlertBehavior.setElement(element);
            bcAlertBehavior.setUp();
            elements.push(bcAlertBehavior);
        }
        return elements;
    }
    _setUp() {
        this.getCloseButton();
        this.listeners();
        this.accessibility();
        this.closeKeyboard();
    }
    /**
     * Configura la accesibilidad del botón de cierre de la alerta.
     * @memberof BcAlertBehavior
     */
    accessibility() {
        addFocusable(this.bcAlertCloseButton, { pressed: 'false' }, { event: () => this.close() });
    }
    /**
     * Obtiene el botón de cierre de la alerta mediante querySelector.
     * @memberof BcAlertBehavior
     */
    getCloseButton() {
        this.bcAlertCloseButton = this.mySelf.querySelector(`.${BC_ALERT_CLOSE}`);
    }
    /**
     * Registra el evento click al botón de cierre de la alerta.
     * @memberof BcAlertBehavior
     */
    listeners() {
        this.bcAlertCloseButton.addEventListener(BcCommonConstants.EVENT_CLICK, () => {
            this.close();
        });
        this.hideAlertAfterCloseAnimation();
    }
    /**
     * Cierre de la ventana de alerta, verifica si la ventana está activa y la cierra.
     *
     * @memberof BcAlertBehavior
     */
    close() {
        if (this.mySelf.classList.contains(BC_ALERT_ACTIVE) || this.mySelf.classList.contains(BC_ALERT_DISMISSIBLE)) {
            this.mySelf.classList.add(BC_ALERT_CLOSING);
        }
    }
    onClose(fn) {
        this.onCloseFunction = fn;
    }
    /**
     * Oculta la alerta después de cerrar la animación. Valida el evento y elimina las clases BC_ALERT_CLOSING y  BC_ALERT_INLINE
     * @memberof BcAlertBehavior
     */
    hideAlertAfterCloseAnimation() {
        this.mySelf.addEventListener('animationend', (ev) => {
            if (ev.animationName === BcCommonConstants.FADE_OUT_OPACITY ||
                ev.animationName === BcCommonConstants.SLIDE_UP_REVERSE) {
                this.mySelf.classList.remove(BC_ALERT_CLOSING);
                this.mySelf.classList.remove(BC_ALERT_INLINE);
                replaceClass(this.mySelf, BC_ALERT_ACTIVE, BC_ALERT);
                this.onCloseFunction && this.onCloseFunction();
            }
        });
    }
    /**
     * Abre la ventana de alerta y la mantiene activa durante el tiempo timeOut.
     * @memberof BcAlertBehavior
     */
    open() {
        replaceClass(this.mySelf, BC_ALERT, BC_ALERT_ACTIVE);
        if (this.timeOut != 0) {
            this.mySelf.setAttribute('role', 'alert');
            setTimeout(() => {
                this.close();
            }, this.timeOut);
        }
    }
    /**
     * Configura el tiempo en el que se mantiene la ventana de alerta abierta, además
     * valida que ese tiempo no se sale del rango establecido por los límites MIN_TIME_DELAY y MAX_TIME_DELAY.
     * @param {number} time es el tiempo del timeout
     * @memberof BcAlertBehavior
     */
    setTimeOut(time) {
        if (time >= MIN_TIME_DELAY && time <= MAX_TIME_DELAY) {
            this.timeOut = time;
        }
        else if (time > MAX_TIME_DELAY) {
            this.timeOut = MAX_TIME_DELAY;
        }
        else if (time > 0 && time < MIN_TIME_DELAY) {
            this.timeOut = MIN_TIME_DELAY;
        }
        else {
            this.timeOut = 0;
        }
    }
    closeKeyboard() {
        document.body.addEventListener('keyup', (event) => {
            if (event.code === BcCommonConstants.KEY_EVENT_ESCAPE) {
                this.close();
            }
        });
    }
}

const BC_NEW_ALERT_INLINE = `${BcCommonConstants.PREFIX_LIB}-inline-alert`;
const BC_ALERT_INLINE_ACTIVE = `${BcCommonConstants.PREFIX_LIB}-inline-alert-active`;
const BC_ALERT_INLINE_CLOSE = `${BcCommonConstants.PREFIX_LIB}-inline-alert-close`;
const BC_ALERT_INLINE_CLOSING = `${BcCommonConstants.PREFIX_LIB}-inline-alert-closing`;
const BC_ALERT_INLINE_DISMISSIBLE = `${BcCommonConstants.PREFIX_LIB}-inline-alert-dismissible`;
const BC_ALERT_INLINE_CONTENT = `${BcCommonConstants.PREFIX_LIB}-inline-alert-content`;
const ALERT = `alert`;
const ROLE = `role`;
const MAX_TIME_DELAY_INLINE = 10000;
const MIN_TIME_DELAY_INLINE = 5000;
const MIN_TIMEOUT_INLINE = 1000;

class BcInlineAlertBehavior extends BcDefaultBehavior {
    constructor() {
        super();
        this.timeOut = 0;
    }
    static setUpAll() {
        const InlineAlertElements = Array.from(document.querySelectorAll(`.${BC_NEW_ALERT_INLINE}`));
        const elements = [];
        for (const element of InlineAlertElements) {
            const bcInlineAlertBehavior = new BcInlineAlertBehavior();
            bcInlineAlertBehavior.setElement(element);
            bcInlineAlertBehavior.setUp();
            elements.push(bcInlineAlertBehavior);
        }
        return elements;
    }
    _setUp() {
        this.getCloseButton();
        this.listeners();
        this.accessibility();
        this.closeKeyboard();
    }
    /**
     * Configura la accesibilidad del botón de cierre de la alerta.
     * @memberof BcInlineAlertBehavior
     */
    accessibility() {
        addFocusable(this.bcInlineAlertCloseButton, { pressed: 'false' }, { event: () => this.close() });
        addFocusable(this.mySelf, { tabindex: '0' });
    }
    /**
     * Obtiene el botón de cierre de la alerta mediante querySelector.
     * @memberof BcInlineAlertBehavior
     */
    getCloseButton() {
        this.bcInlineAlertCloseButton = this.mySelf.querySelector(`.${BC_ALERT_INLINE_CLOSE}`);
    }
    /**
     * Registra el evento click al botón de cierre de la alerta.
     * @memberof BcInlineAlertBehavior
     */
    listeners() {
        this.bcInlineAlertCloseButton.addEventListener(BcCommonConstants.EVENT_CLICK, () => {
            this.close();
        });
        this.hideAlertAfterCloseAnimation();
    }
    /**
     * Cierre de la ventana de alerta, verifica si la ventana está activa y la cierra.
     *
     * @memberof BcAlertBehavior
     */
    close() {
        if (this.mySelf.classList.contains(BC_ALERT_INLINE_ACTIVE) || this.mySelf.classList.contains(BC_ALERT_INLINE_DISMISSIBLE)) {
            this.mySelf.classList.add(BC_ALERT_INLINE_CLOSING);
        }
    }
    onClose(fn) {
        this.onCloseFunction = fn;
    }
    /**
     * Oculta la alerta después de cerrar la animación. Valida el evento y elimina las clases BC_ALERT_CLOSING y  BC_ALERT_INLINE
     * @memberof BcAlertBehavior
     */
    hideAlertAfterCloseAnimation() {
        this.mySelf.addEventListener('animationend', (ev) => {
            if (ev.animationName === BcCommonConstants.FADE_OUT_OPACITY ||
                ev.animationName === BcCommonConstants.SLIDE_UP_REVERSE) {
                this.mySelf.classList.remove(BC_ALERT_INLINE_CLOSING);
                replaceClass(this.mySelf, BC_ALERT_INLINE_ACTIVE, BC_NEW_ALERT_INLINE);
                this.onCloseFunction && this.onCloseFunction();
            }
        });
    }
    /**
     * Abre la ventana de alerta y la mantiene activa durante el tiempo timeOut.
     * @memberof BcAlertBehavior
     */
    open() {
        replaceClass(this.mySelf, BC_NEW_ALERT_INLINE, BC_ALERT_INLINE_ACTIVE);
        if (this.timeOut != 0) {
            this.mySelf.setAttribute(ROLE, ALERT);
            setTimeout(() => {
                this.close();
            }, this.timeOut);
        }
    }
    /**
     * Configura el tiempo en el que se mantiene la ventana de alerta abierta, además
     * valida que ese tiempo no se sale del rango establecido por los límites MIN_TIME_DELAY y MAX_TIME_DELAY.
     * @param {number} time es el tiempo del timeout
     * @memberof BcInlineAlertBehavior
     */
    setTimeOut(time) {
        if (time >= MIN_TIME_DELAY_INLINE && time <= MAX_TIME_DELAY_INLINE) {
            this.timeOut = time;
        }
        else if (time > MAX_TIME_DELAY_INLINE) {
            this.timeOut = MAX_TIME_DELAY_INLINE;
        }
        else if (time > 0 && time < MIN_TIME_DELAY_INLINE) {
            this.timeOut = MIN_TIME_DELAY_INLINE;
        }
        else {
            this.timeOut = 0;
        }
    }
    closeKeyboard() {
        document.body.addEventListener('keyup', (event) => {
            if (event.code === BcCommonConstants.KEY_EVENT_ESCAPE) {
                this.close();
            }
        });
    }
}

const OFF_CANVAS = `${BcCommonConstants.PREFIX_LIB}-off-canvas`;
const OFF_CANVAS_STATUS_PROPERTY = 'status';
const OFF_CANVAS_CLOSE_BUTTON_TEXT = 'error';
const OFF_CANVAS_STATUS_TYPE = 'type';
const OFF_CANVAS_BUTTONS_QUERY = ':scope>aside>section:first-child>button:first-child';
var OffCanvasStatus;
(function (OffCanvasStatus) {
    OffCanvasStatus["close"] = "close";
    OffCanvasStatus["open"] = "open";
})(OffCanvasStatus || (OffCanvasStatus = {}));

class BcOffCanvasBehavior extends BcDefaultBehavior {
    constructor() {
        super();
    }
    static setUpAll() {
        const offCanvasElements = Array.from(document.querySelectorAll(`section[class~='${OFF_CANVAS}']`));
        const elements = [];
        for (const offCanvasElement of offCanvasElements) {
            const element = offCanvasElement;
            const bc = new BcOffCanvasBehavior();
            bc.setElement(element);
            bc.setUp();
            elements.push(bc);
        }
        return elements;
    }
    _setUp() {
        this.configCloseButton();
        this.closeAccesibilidad();
        this.closeOffCanvasWithclick();
        this.closeEventKey();
    }
    closeOffCanvasWithclick() {
        this.mySelf.addEventListener(BcCommonConstants.EVENT_CLICK, (event) => {
            if (event.target.className === OFF_CANVAS) {
                this.close();
            }
        });
    }
    closeEventKey() {
        window.addEventListener(BcCommonConstants.EVENT_KEY_DOWN, (event) => {
            /* istanbul ignore else*/
            if (event.key === BcCommonConstants.KEY_EVENT_ESCAPE) {
                this.close();
            }
        });
    }
    open() {
        this.changeStatus(OffCanvasStatus.open);
    }
    close() {
        this.changeStatus(OffCanvasStatus.close);
    }
    configCloseButton() {
        const closeButton = this.mySelf.querySelector(`${OFF_CANVAS_BUTTONS_QUERY}`);
        closeButton?.addEventListener(BcCommonConstants.EVENT_CLICK, () => {
            this.close();
        });
    }
    closeAccesibilidad() {
        const closeButton = this.mySelf.querySelector(`${OFF_CANVAS_BUTTONS_QUERY}`);
        addFocusable(closeButton, { tabindex: '0' });
    }
    changeStatus(status) {
        this.mySelf.setAttribute(OFF_CANVAS_STATUS_PROPERTY, status);
    }
}

class BcInputCreateConstants {
}
BcInputCreateConstants.INPUT_CREATE = `${BcCommonConstants.PREFIX_LIB}-input-create`;
BcInputCreateConstants.TYPE_ATR = `type`;
BcInputCreateConstants.CONDITIONALS_ATR = `conditionals`;
BcInputCreateConstants.TITLE_ATR = `title`;
BcInputCreateConstants.MASK_ATR = `mask`;
BcInputCreateConstants.ID_ATR = `id`;
BcInputCreateConstants.ARIA_CONTROLS_ATR = `aria-controls`;
BcInputCreateConstants.FOR_ATR = `for`;
BcInputCreateConstants.SUPPORT_TEXT_CONDITION_ATR = `supportTextCondition`;
BcInputCreateConstants.FIRST_ICON_ATR = `firstIcon`;
BcInputCreateConstants.SECOND_ICON_ATR = `secondIcon`;
BcInputCreateConstants.THIRD_ICON_ATR = `thirdIcon`;
BcInputCreateConstants.TITLE_ICON_ATR = `titleIcon`;
BcInputCreateConstants.FIRST_LABEL_ATR = `firstLabel`;
BcInputCreateConstants.SECOND_LABEL_ATR = `secondLabel`;
BcInputCreateConstants.THIRD_LABEL_ATR = `thirdLabel`;
BcInputCreateConstants.FIRST_MSG_ERROR_ATR = `firstMsgError`;
BcInputCreateConstants.SECOND_MSG_ERROR_ATR = `secondMsgError`;
BcInputCreateConstants.THIRD_MSG_ERROR_ATR = `thirdMsgError`;
BcInputCreateConstants.FIRST_ID_INPUT_ATR = `firstIdInput`;
BcInputCreateConstants.SECOND_ID_INPUT_ATR = `secondIdInput`;
BcInputCreateConstants.THIRD_ID_INPUT_ATR = `thirdIdInput`;
BcInputCreateConstants.STATUS_ATR = `disableStatus`;
BcInputCreateConstants.CURRENT_PASSWORD_VALUE_DEFAULT = `Clave`;
BcInputCreateConstants.NEW_PASSWORD_VALUE_DEFAULT = `Nueva Clave`;
BcInputCreateConstants.CONFIRM_PASSWORD_VALUE_DEFAULT = `Confirmar nueva Clave`;
BcInputCreateConstants.MSG_ERROR_VALUE_DEFAULT = `La clave no cumple con los criterios requeridos`;
BcInputCreateConstants.MSG_ERROR_VALIDATION_VALUE_DEFAULT = `Las claves no coinciden`;
BcInputCreateConstants.TITLE_VALUE_DEFAULT = `La clave debe contener`;
BcInputCreateConstants.SUPPORT_TEXT_DEFAULT = `Sugerencias`;
BcInputCreateConstants.INPUT_CREATE_8 = 8;
BcInputCreateConstants.TYPE_USER = `user`;
BcInputCreateConstants.TYPE_PASSWORD = `password`;
BcInputCreateConstants.TYPE_PASSWORD_CREATE = `password-create`;
BcInputCreateConstants.TYPE_PASSWORD_UPDATE = `password-update`;
BcInputCreateConstants.TYPE_TEXT = `text`;
BcInputCreateConstants.TYPE_LOWERCASE = `lowercase`;
BcInputCreateConstants.TYPE_UPPERCASE = `uppercase`;
BcInputCreateConstants.TYPE_CHARACTER = `character`;
BcInputCreateConstants.TYPE_NUMBER = `number`;
BcInputCreateConstants.ICON_USER = `user`;
BcInputCreateConstants.ICON_DOT = `asterisk`;
BcInputCreateConstants.ICON_NO_VIEW = `no-view`;
BcInputCreateConstants.ICON_VIEW = `view`;
BcInputCreateConstants.ICON_OK = `ok`;
BcInputCreateConstants.ICON_ERROR = `error`;
BcInputCreateConstants.ICON_REMOVE = `remove`;
BcInputCreateConstants.ICON_SUCCESSFUL = `successful`;
BcInputCreateConstants.ICON_LOCK = `lock`;
BcInputCreateConstants.CLASS_BUTTON_ICON = `${BcCommonConstants.PREFIX_LIB}-button-icon`;
BcInputCreateConstants.CLASS_FORM_FIELD = `${BcCommonConstants.PREFIX_LIB}-form-field`;
BcInputCreateConstants.CLASS_INPUT = `${BcCommonConstants.PREFIX_LIB}-input`;
BcInputCreateConstants.CLASS_INPUT_SUCCESS = `${BcInputCreateConstants.CLASS_INPUT}-success`;
BcInputCreateConstants.CLASS_INPUT_ERROR = `${BcInputCreateConstants.CLASS_INPUT}-error`;
BcInputCreateConstants.CLASS_FIRST_CONTAINER = `${BcInputCreateConstants.INPUT_CREATE}-first-container`;
BcInputCreateConstants.CLASS_SECOND_CONTAINER = `${BcInputCreateConstants.INPUT_CREATE}-second-container`;
BcInputCreateConstants.CLASS_THIRD_CONTAINER = `${BcInputCreateConstants.INPUT_CREATE}-third-container`;
BcInputCreateConstants.CLASS_ICONS_STATE_CONDITION = `icon-state-condition`;
BcInputCreateConstants.DOCUMENT_QUERY = `section[class~='${BcInputCreateConstants.INPUT_CREATE}']`;
BcInputCreateConstants.CLASS_INPUT_CREATE_CONTAINER = `${BcInputCreateConstants.INPUT_CREATE}-container`;
BcInputCreateConstants.CLASS_INPUT_CREATE_EQUAL = `${BcInputCreateConstants.INPUT_CREATE}-equal`;
BcInputCreateConstants.CLASS_INPUT_CREATE_FIRST_INPUT = `${BcInputCreateConstants.INPUT_CREATE}-first-input`;
BcInputCreateConstants.CLASS_CONTENT_CONDITIONALS = `${BcCommonConstants.PREFIX_LIB}-content-conditionals`;
BcInputCreateConstants.CLASS_CONTENT_CONDITIONALS_BODY = `${BcInputCreateConstants.CLASS_CONTENT_CONDITIONALS}-body`;
BcInputCreateConstants.CLASS_CONTENT_CONDITIONALS_BODY_ITEM = `${BcInputCreateConstants.CLASS_CONTENT_CONDITIONALS_BODY}-item`;
BcInputCreateConstants.CLASS_CONTENT_CONDITIONALS_BODY_ITEM_STATE = `${BcInputCreateConstants.CLASS_CONTENT_CONDITIONALS_BODY_ITEM}-state`;
BcInputCreateConstants.CLASS_CONTENT_CONDITIONALS_BODY_ITEM_TEXT = `${BcInputCreateConstants.CLASS_CONTENT_CONDITIONALS_BODY_ITEM}-text`;
BcInputCreateConstants.CLASS_CONTENT_CONDITIONALS_HEADER = `${BcInputCreateConstants.CLASS_CONTENT_CONDITIONALS}-header`;
BcInputCreateConstants.CLASS_CONTENT_CONDITIONALS_HEADER_ICON = `${BcInputCreateConstants.CLASS_CONTENT_CONDITIONALS_HEADER}-icon`;
BcInputCreateConstants.CLASS_CONTENT_CONDITIONALS_HEADER_TEXT = `${BcInputCreateConstants.CLASS_CONTENT_CONDITIONALS_HEADER}-text`;
BcInputCreateConstants.CLASS_CONTENT_CONDITIONALS_FOOTER = `${BcInputCreateConstants.CLASS_CONTENT_CONDITIONALS}-footer`;
BcInputCreateConstants.CLASS_DROPDOWN_CONTENT = `${BcCommonConstants.PREFIX_LIB}-dropdown-content`;
BcInputCreateConstants.CLASS_DROPDOWN_CONTENT_ACTIVE = `${BcInputCreateConstants.CLASS_DROPDOWN_CONTENT}-active`;
BcInputCreateConstants.CLASS_DROPDOWN_TOGGLE = `${BcCommonConstants.PREFIX_LIB}-dropdown-toggle`;
BcInputCreateConstants.TRUE_VALUE = `true`;
BcInputCreateConstants.USER_VALUE = `user`;
BcInputCreateConstants.PASSWORD_VALUE = `password`;
BcInputCreateConstants.NEW_PASSWORD_VALUE = `newPassword`;
BcInputCreateConstants.CURRENT_PASSWORD_VALUE = `currentPassword`;
BcInputCreateConstants.VALIDATIONS_VALUE = `validations`;
BcInputCreateConstants.EQUAL_VALUE = `equal`;
BcInputCreateConstants.VISIBLE_VALUE = `visible`;
BcInputCreateConstants.ERROR_VALUE = `error`;
BcInputCreateConstants.SUCCESS_VALUE = `success`;
BcInputCreateConstants.CONDITION_VALUE = `condition`;
BcInputCreateConstants.STATE_VALUE = `state`;
BcInputCreateConstants.CONDITION_MAX_LENGTH = `maxLength`;
BcInputCreateConstants.CONDITION_CAPITAL_LETTERS = `capitalLetters`;
BcInputCreateConstants.CONDITION_SOME_NUMBERS = `someNumbers`;
BcInputCreateConstants.CONDITION_INITIAL_CHARACTERS = `initialCharacter`;
BcInputCreateConstants.CONDITION_SPECIAL_CHARACTER = `specialCharacter`;
BcInputCreateConstants.CONDITION_CONSECUTIVE_NUMBERS = `consecutiveNumbers`;
BcInputCreateConstants.NONE_TEXT = `none`;
BcInputCreateConstants.MY_DROPDOWN_TEXT = `myDropDown`;
BcInputCreateConstants.ID_CONDITION_TEXT = `${BcInputCreateConstants.ID_ATR}-condition`;
BcInputCreateConstants.FIRST_ID_TEXT = `firstId`;
BcInputCreateConstants.SECOND_ID_TEXT = `secondId`;
BcInputCreateConstants.THIRD_ID_TEXT = `thirdId`;
BcInputCreateConstants.FIRST_TEXT = `first`;
BcInputCreateConstants.EQUAL_TEXT = `equal`;
BcInputCreateConstants.NUMBER_TWO = 2;

class BcInputCreateDropDownValidations {
    /**
     * Inicializa la instancia del 'BcDropdownBehavior'.
     *
     * @public
     * @memberof BcInputCreateBehavior
     */
    initDropDownBehavior(inputCreateElement) {
        const element = inputCreateElement.querySelector(`.${BcCommonConstants.BC_DROPDOWN_CLASS}`);
        if (element !== null) {
            const config = {
                isPopUp: true,
                parentWidth: true
            };
            this.dropDownBehavior = new BcDropdownBehavior();
            this.dropDownBehavior.setElement(element);
            this.dropDownBehavior.setConfig(config);
            this.dropDownBehavior.setUp();
        }
    }
    /**
     * Construye el contenedor del dropdown.
     *
     * @param {string} title Titulo que tendra el dropdown
     * @public
     * @memberof BcInputCreateBehavior
     */
    createDropdownContainer(title, supportText, titleIconAtr) {
        const contentConditionalsHeader = this.createContainner(BcInputCreateConstants.CLASS_CONTENT_CONDITIONALS, BcInputCreateConstants.CLASS_CONTENT_CONDITIONALS_HEADER);
        const contentConditionalsHeaderIcon = this.createContainner(BcInputCreateConstants.CLASS_CONTENT_CONDITIONALS_HEADER, BcInputCreateConstants.CLASS_CONTENT_CONDITIONALS_HEADER_ICON);
        const contentConditionalsHeaderText = this.createContainner(BcInputCreateConstants.CLASS_CONTENT_CONDITIONALS_HEADER, BcInputCreateConstants.CLASS_CONTENT_CONDITIONALS_HEADER_TEXT);
        this.createContainner(BcInputCreateConstants.CLASS_CONTENT_CONDITIONALS, BcInputCreateConstants.CLASS_CONTENT_CONDITIONALS_BODY);
        const contentConditionalsFooter = this.createContainner(BcInputCreateConstants.CLASS_CONTENT_CONDITIONALS, BcInputCreateConstants.CLASS_CONTENT_CONDITIONALS_FOOTER);
        const emIcon = document.createElement(BcCommonConstants.EM_TAG);
        emIcon.classList.add(BcCommonConstants.ICONS_CLASS);
        emIcon.classList.add(BcCommonConstants.ICON_SM_CLASS);
        emIcon.setAttribute('aria-hidden', 'true');
        emIcon.innerText = titleIconAtr;
        contentConditionalsHeaderText.textContent = title;
        contentConditionalsFooter.textContent = supportText;
        contentConditionalsHeaderIcon.appendChild(emIcon);
        contentConditionalsHeader.appendChild(contentConditionalsHeaderIcon);
        contentConditionalsHeader.appendChild(contentConditionalsHeaderText);
    }
    /**
 * Funcion auxiliar con la cual se obtiene y crea un elemento hijo a una seccion del documento.
 *
 * @param {string} query Elemento del documento a la que se le creara un hijo
 * @param {string} classContainer Elemento hijo.
 * @public
 * @memberof BcInputCreateBehavior
 */
    createContainner(query, classContainer) {
        const element = document.querySelector(`.${query}`);
        const section = document.createElement(BcCommonConstants.SECTION_TAG);
        section.classList.add(classContainer);
        element?.appendChild(section);
        return section;
    }
    /**
     * Obtiene los condicionales que se cumplen del input.
     *
     * @public
     * @memberof BcInputCreateBehavior
     * @returns {boolean} Si se cumplen todas las condiciones del dropdown
     */
    getValidations(conditionalItems) {
        return conditionalItems.every((item) => { return item.state === true; });
    }
    /**
     * Obtiene los condicionales que no se cumplen del input
     *
     * @returns {object[]} Si no se han cumplido todas las condiciones
     * @public
     * @memberof BcInputCreateBehavior
     */
    getFilterValidations(conditionalItems) {
        return conditionalItems.filter((item) => { return item.state === false; });
    }
    /**
     * Modifica el estado del condicional con id ingresado por parametro al estado error.
     *
     * @param {string} id Identificador del condicional al que se le modificara el estado
     * @public
     * @memberof BcInputCreateBehavior
     */
    changeStatusItem(id, inputCreateElement) {
        const contentConditionals = inputCreateElement.querySelector(`.${BcInputCreateConstants.CLASS_CONTENT_CONDITIONALS}`);
        const item = contentConditionals.querySelector(`#${BcInputCreateConstants.ID_CONDITION_TEXT}-${id}`);
        const icon = item.querySelector(`.${BcInputCreateConstants.CLASS_CONTENT_CONDITIONALS_BODY_ITEM_STATE}`);
        const text = item.querySelector(`.${BcInputCreateConstants.CLASS_CONTENT_CONDITIONALS_BODY_ITEM_TEXT}`);
        const em = icon.querySelector(BcCommonConstants.EM_TAG);
        em.textContent = BcInputCreateConstants.ICON_ERROR;
        em.setAttribute('aria-hidden', 'false');
        em.setAttribute(BcCommonConstants.ARIA_LABEL, 'No lo cumple');
        icon.classList.add(`${BcInputCreateConstants.CLASS_CONTENT_CONDITIONALS_BODY_ITEM_STATE}-${BcInputCreateConstants.ERROR_VALUE}`);
        text.classList.add(`${BcInputCreateConstants.CLASS_CONTENT_CONDITIONALS_BODY_ITEM_TEXT}-${BcInputCreateConstants.ERROR_VALUE}`);
    }
    /**
 * Modifica el estado del condicional con id ingresado por parametro al estado normal.
 *
 * @param {string} id Identificador del condicional al que se le modificara el estado
 * @public
 * @memberof BcInputCreateBehavior
 */
    changeStatusItemDot(id, inputCreateElement) {
        const contentConditionals = inputCreateElement.querySelector(`.${BcInputCreateConstants.CLASS_CONTENT_CONDITIONALS}`);
        const item = contentConditionals.querySelector(`#${BcInputCreateConstants.ID_CONDITION_TEXT}-${id}`);
        const icon = item.querySelector(`.${BcInputCreateConstants.CLASS_CONTENT_CONDITIONALS_BODY_ITEM_STATE}`);
        const text = item.querySelector(`.${BcInputCreateConstants.CLASS_CONTENT_CONDITIONALS_BODY_ITEM_TEXT}`);
        const em = icon.querySelector(BcCommonConstants.EM_TAG);
        em.textContent = BcInputCreateConstants.ICON_DOT;
        icon.classList.add(`${BcInputCreateConstants.CLASS_CONTENT_CONDITIONALS_BODY_ITEM_STATE}`);
        text.classList.add(`${BcInputCreateConstants.CLASS_CONTENT_CONDITIONALS_BODY_ITEM_TEXT}`);
    }
    /**
 * Obtiene el icono del condicional.
 *
 * @param {string} id La posicion del condicional
 * @returns {Element[]} Nombre y icono del condicional.
 * @public
 * @memberof BcInputCreateBehavior
 */
    getConditionIcon(id, inputCreateElement) {
        const contentDropdown = inputCreateElement.querySelector(`.${BcInputCreateConstants.CLASS_DROPDOWN_CONTENT_ACTIVE}`);
        const item = contentDropdown.querySelector(`#${BcInputCreateConstants.ID_CONDITION_TEXT}-${id}`);
        const itemText = item.querySelector(`.${BcInputCreateConstants.CLASS_CONTENT_CONDITIONALS_BODY_ITEM_TEXT}`);
        const itemContentIcon = item.querySelector(`.${BcInputCreateConstants.CLASS_CONTENT_CONDITIONALS_BODY_ITEM_STATE}`);
        itemText.classList.remove(`${BcInputCreateConstants.CLASS_CONTENT_CONDITIONALS_BODY_ITEM_TEXT}-${BcInputCreateConstants.ERROR_VALUE}`);
        const itemIcon = item.querySelector(`.${BcInputCreateConstants.CLASS_ICONS_STATE_CONDITION}`);
        itemContentIcon.classList.remove(`${BcInputCreateConstants.CLASS_CONTENT_CONDITIONALS_BODY_ITEM_STATE}-${BcInputCreateConstants.ERROR_VALUE}`);
        return [itemContentIcon, itemIcon];
    }
    /**
* Modifica el estado de la condicion segun el valor asignado por parametro.
*
* @param {string} condition Condicion del estado
* @param {boolean} value Valor que se le asignara al estado
* @public
* @memberof BcInputCreateBehavior
*/
    changeGeneralState(condition, value, conditionalItems) {
        conditionalItems.forEach((item) => {
            if (item.condition === condition) {
                item.state = value;
            }
        });
    }
    /**
 * Modifica el estado del condicional a success o normal segun el contenido ACTUAL del input.
 *
 * @param {string} id Indentificador del elemento
 * @public
 * @memberof BcInputCreateBehavior
 */
    changeState(id, success, inputCreateElement, conditionalItems) {
        const returnSetItems = this.getConditionIcon(id, inputCreateElement);
        if (success === true) {
            this.changeGeneralState(id, true, conditionalItems);
            returnSetItems[0].classList.add(`${BcInputCreateConstants.CLASS_CONTENT_CONDITIONALS_BODY_ITEM_STATE}-${BcInputCreateConstants.SUCCESS_VALUE}`);
            returnSetItems[1].textContent = BcInputCreateConstants.ICON_OK;
            returnSetItems[1].setAttribute('aria-hidden', 'false');
            returnSetItems[1].setAttribute(BcCommonConstants.ARIA_LABEL, 'Lo cumple');
        }
        else {
            this.changeGeneralState(id, false, conditionalItems);
            returnSetItems[0].classList.remove(`${BcInputCreateConstants.CLASS_CONTENT_CONDITIONALS_BODY_ITEM_STATE}-${BcInputCreateConstants.SUCCESS_VALUE}`);
            returnSetItems[1].textContent = BcInputCreateConstants.ICON_DOT;
            returnSetItems[1].setAttribute('aria-hidden', 'true');
        }
    }
    /**
     * Funcion auxiliar. Modifica el estado de la condicion que le es ingresada por parametro.
     *
     * @param {string} id Identificador del elemento
     * @param {boolean} condition Condicional a evaluar
     * @public
     * @memberof BcInputCreateBehavior
     */
    changeStateByCondition(id, condition, inputCreateElement, conditionalItems) {
        condition ? this.changeState(id, true, inputCreateElement, conditionalItems) : this.changeState(id, false, inputCreateElement, conditionalItems);
    }
    /**
 * Condicional sobre el tamaño minimo y maximo del contenido del input.
 *
 * @param {string} id Indentificador del condicional, su posicion en el dropdown
 * @param {string} text Contenido del input
 * @param {number} maxCharacters Numero maximo de caracteres que puede contener el input para tener estado success
 * @param {number} minCharacters Numero minimo de caracteres que puede contener el input para tener estado success
 * @private
 * @memberof BcInputCreateBehavior
 */
    conditionMaxLenght(id, input, maxCharacters, minCharacters, inputCreateElement, conditionalItems) {
        if (minCharacters === undefined && maxCharacters === undefined) {
            minCharacters = BcInputCreateConstants.INPUT_CREATE_8;
        }
        if (minCharacters && maxCharacters === undefined) {
            this.changeStateByCondition(id, (input.length >= minCharacters), inputCreateElement, conditionalItems);
        }
        if (minCharacters === undefined && maxCharacters) {
            this.changeStateByCondition(id, (input.length <= maxCharacters), inputCreateElement, conditionalItems);
        }
        if (minCharacters && maxCharacters) {
            this.changeStateByCondition(id, (input.length >= minCharacters && input.length <= maxCharacters), inputCreateElement, conditionalItems);
        }
    }
    /**
     * Condicional sobre si el contenido debe contener una mayuscula o minuscula.
     *
     * @param {string} id Indentificador del condicional, su posicion en el dropdown
     * @param {string} input Contenido del input
     * @param {string} type Condicion que debe cumplir el input ya sea uppercase o lowercase
     * @private
     * @memberof BcInputCreateBehavior
     */
    conditionCapitalLetters(id, input, type, inputCreateElement, conditionalItems) {
        if (type == BcInputCreateConstants.TYPE_UPPERCASE) {
            this.changeStateByCondition(id, (/[A-Z]/.test(input)), inputCreateElement, conditionalItems);
        }
        if (type == BcInputCreateConstants.TYPE_LOWERCASE) {
            this.changeStateByCondition(id, (/[a-z]/.test(input)), inputCreateElement, conditionalItems);
        }
    }
    /**
     * Condicional sobre si el contenido debe contener cierta cantidad de numeros.
     *
     * @param {string} id Indentificador del condicional, su posicion en el dropdown
     * @param {string} input Contenido del input
     * @param {number} numbers Numero minimo de numeros que debe contener el input
     * @private
     * @memberof BcInputCreateBehavior
     */
    conditionSomeNumbers(id, input, numbers, inputCreateElement, conditionalItems) {
        const inputArr = Array.from(input);
        let aux = 0;
        inputArr.forEach((char) => {
            if (Number(char) || char === '0') {
                aux++;
            }
        });
        this.changeStateByCondition(id, (aux >= numbers), inputCreateElement, conditionalItems);
    }
    /**
     * Condicional sobre si el contenido debe iniciar con un numero o una letra.
     *
     * @param {string} id Indentificador del condicional, su posicion en el dropdown
     * @param {string} input Contenido del input
     * @param {string} type Condicion que debe cumplir el input ya sea character o number
     * @private
     * @memberof BcInputCreateBehavior
     */
    conditionInitialCharacter(id, input, type, inputCreateElement, conditionalItems) {
        const inputArr = Array.from(input); //Contenido del input como arreglo
        if (type === BcInputCreateConstants.TYPE_CHARACTER) { //Si el primer caracter debe ser un char ...
            this.changeStateByCondition(id, ((/[A-Z]/.test(inputArr[0]) || /[a-z]/.test(inputArr[0])) && input !== ''), inputCreateElement, conditionalItems);
        }
        if (type === BcInputCreateConstants.TYPE_NUMBER) { //Si el primer caracter debe ser un number
            this.changeStateByCondition(id, ((Number(inputArr[0]) || inputArr[0] === '0') && input !== ''), inputCreateElement, conditionalItems);
        }
    }
    /**
     * Condicional sobre si el contenido debe contener o no un caracter especial.
     *
     * @param {string} id Indentificador del condicional, su posicion en el dropdown
     * @param {string} input Contenido del input
     * @param {boolean} condition Si debe o no contener un caracter especial. En caso de ser false, el input no debe contener
     * caracteres especiales
     * @private
     * @memberof BcInputCreateBehavior
     */
    conditionSpecialCharacter(id, input, condition, inputCreateElement, conditionalItems) {
        if (condition) {
            this.changeStateByCondition(id, (this.hasSpecialChars(input)), inputCreateElement, conditionalItems);
        }
        if (!condition) {
            this.changeStateByCondition(id, (!this.hasSpecialChars(input)), inputCreateElement, conditionalItems);
        }
    }
    /**
     * Funcion auxiliar para verificar si un input ingresado por parametro contiene un caracter especial.
     * Los caractes especiales que verifica son: `, ¡, !, @, #, $, %, ^, &, *, (, ), _, +, -, =, [, ]
     *                                              {, }, ;, ', :, ", \, |, ,, ., <, >, /, ¿, ?, ~
     *
     * @param {string} input Contenido que se verificara
     * @returns {boolean} Si contiene o no, caracteres especial
     * @private
     * @memberof BcInputCreateBehavior
     */
    hasSpecialChars(input) {
        const specialChars = /[`¡!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/¿?~]/;
        return specialChars.test(input);
    }
    /**
     * Condicional sobre si el contenido puede contener numeros consecutivos, ya sea ascendemente o descendentemente.
     *
     * @param {string} id Indentificador del condicional, su posicion en el dropdown
     * @param {string} input Contenido del input
     * @param {number} max Numero maximo de numeros consecutivos que se pueden encontrar en el input. Por defecto es 2.
     * @param {boolean} ascAndDesc Si verifica ascendentemente y descendentemente. En caso de ser false, solo verifica ascendentemente
     * @public
     * @memberof BcInputCreateBehavior
     */
    conditionConsecutiveNumbers(id, input, ascAndDesc, inputCreateElement, conditionalItems, max = BcInputCreateConstants.NUMBER_TWO) {
        if (input.length !== 0) {
            this.changeState(id, true, inputCreateElement, conditionalItems);
        }
        this.changeStateByCondition(id, (!this.hasConsecutive(input, max, ascAndDesc)), inputCreateElement, conditionalItems);
        if (input === '') {
            this.changeState(id, false, inputCreateElement, conditionalItems);
        }
    }
    /**
     * Funcion auxiliar que verifica si el input contiene numeros consecutivos, ya sea ascendentemente o descendentemente.
     *
     * @param {string} input Texto que se quiere verificar.
     * @param {number} max Numero maximo de numeros consecutivos permitidos.
     * @param {boolean} ascAndDesc Indica si no acepta numeros consecutivos forma ascendente y descendente,
     *                  en false solo verifica ascendentemente.
     * @returns {boolean} Si contiene numeros consecutivos o no
     * @private
     * @memberof BcInputCreateBehavior
     */
    hasConsecutive(input, max, ascAndDesc) {
        const inputArr = Array.from(input);
        let cont = 1;
        let rta = false;
        if (input.length > 1) {
            cont = this.calculateResult(inputArr, ascAndDesc);
        }
        if (cont >= max) {
            rta = true;
        }
        return rta;
    }
    /**
     * Funcion auxiliar que calcula la cantidad de numeros consecutivos.
     *
     * @param {Array<string>} inputArr Input ingresado al elemento divido como Array
     * @param {boolean} ascAndDesc Indica si no acepta numeros consecutivos forma ascendente y descendente,
     * en false solo verifica ascendentemente.
     * @returns {number} Contador sobre cuantos numeros consecutivos tiene el input
     * @private
     * @memberof BcInputCreateBehavior
     */
    calculateResult(inputArr, ascAndDesc) {
        let aux = 1;
        for (let index = 1; index < inputArr.length; index++) {
            const character = inputArr[index];
            const current = Number(inputArr[index]);
            const previous = Number(inputArr[index - 1]);
            if (Number(character) || character === "0") {
                aux += this.increaseAux(ascAndDesc, current, previous);
            }
        }
        return aux;
    }
    /**
 * Funcion auxiliar que modifica el auxiliar para determinar la cantidad de numeros consecutivos.
 *
 * @param {boolean} ascAndDesc Si debe verificar ascendentemente y descendentemente o no.
 * @param {number} current Pivote del caracter actual
 * @param {number} previous Pivote del caracter anterior
 * @returns {number} Cantidad de numeros consecutivos
 * @private
 * @memberof BcInputCreateBehavior
 */
    increaseAux(ascAndDesc, current, previous) {
        let aux = 0;
        if (ascAndDesc === true) {
            if (Math.abs(current - previous) === 1) {
                aux++;
            }
        }
        else {
            if (current - previous === 1) {
                aux++;
            }
        }
        return aux;
    }
    /**
     * Construye los elementos condicionales que contendra el dropdown.
     *
     * @private
     * @memberof BcInputCreateBehavior
     *
     * @param {string} idCondition
     * @param {string} description
     */
    createConditionItem(idCondition, description, position, maxPos, inputCreateElement) {
        const contentBody = inputCreateElement.querySelector(`.${BcInputCreateConstants.CLASS_CONTENT_CONDITIONALS_BODY}`);
        const item = this.createContainner(BcInputCreateConstants.CLASS_CONTENT_CONDITIONALS_BODY, BcInputCreateConstants.CLASS_CONTENT_CONDITIONALS_BODY_ITEM);
        item.setAttribute(BcInputCreateConstants.ID_ATR, `${BcInputCreateConstants.ID_CONDITION_TEXT}-${idCondition}`);
        const sectionIconState = document.createElement(BcCommonConstants.SECTION_TAG);
        const sectionTextCondition = document.createElement(BcCommonConstants.SECTION_TAG);
        const iconState = document.createElement(BcCommonConstants.EM_TAG);
        sectionIconState.classList.add(BcInputCreateConstants.CLASS_CONTENT_CONDITIONALS_BODY_ITEM_STATE);
        sectionTextCondition.classList.add(BcInputCreateConstants.CLASS_CONTENT_CONDITIONALS_BODY_ITEM_TEXT);
        iconState.classList.add(BcCommonConstants.ICONS_CLASS);
        iconState.classList.add(BcInputCreateConstants.CLASS_ICONS_STATE_CONDITION);
        sectionTextCondition.innerText = description;
        iconState.innerText = BcInputCreateConstants.ICON_DOT;
        sectionIconState.appendChild(iconState);
        item.appendChild(sectionIconState);
        item.appendChild(sectionTextCondition);
        contentBody.appendChild(item);
        sectionTextCondition.setAttribute(BcCommonConstants.ARIA_LABEL, `${description}. Elemento ${position} de ${maxPos}`);
        iconState.setAttribute('aria-hidden', 'true');
    }
    /**
     * Verifica los condicionales que tendra el input-create y les asigna su comportamiento.
     *
     * @private
     * @memberof BcInputCreateBehavior
     */
    validateConditionals(inputCreateElement, conditionalItems, conditionalsAtr, typeAtr, returnValue) {
        const conditionals = JSON.parse(conditionalsAtr);
        const dropdownQuery = inputCreateElement.querySelector(`.${BcCommonConstants.BC_DROPDOWN_CLASS}`);
        const input = dropdownQuery.querySelector(BcCommonConstants.INPUT_TAG);
        this.addConditionalItems(conditionalsAtr, conditionalItems, inputCreateElement);
        input.addEventListener(BcCommonConstants.EVENT_INPUT, () => {
            const value = input.value;
            for (const condition in conditionals) {
                const parameters = conditionals[condition];
                if (condition === BcInputCreateConstants.CONDITION_MAX_LENGTH) {
                    this.conditionMaxLenght(condition, value, parameters.max, parameters.min, inputCreateElement, conditionalItems);
                }
                if (condition === BcInputCreateConstants.CONDITION_CAPITAL_LETTERS) {
                    this.conditionCapitalLetters(condition, value, parameters.type, inputCreateElement, conditionalItems);
                }
                if (condition === BcInputCreateConstants.CONDITION_SOME_NUMBERS) {
                    this.conditionSomeNumbers(condition, value, parameters.numbers, inputCreateElement, conditionalItems);
                }
                if (condition === BcInputCreateConstants.CONDITION_INITIAL_CHARACTERS) {
                    this.conditionInitialCharacter(condition, value, parameters.type, inputCreateElement, conditionalItems);
                }
                if (condition === BcInputCreateConstants.CONDITION_SPECIAL_CHARACTER) {
                    this.conditionSpecialCharacter(condition, value, parameters.condition, inputCreateElement, conditionalItems);
                }
                if (condition === BcInputCreateConstants.CONDITION_CONSECUTIVE_NUMBERS) {
                    this.conditionConsecutiveNumbers(condition, value, parameters.ascAndDesc, inputCreateElement, conditionalItems, parameters.max);
                }
            }
            this.asignValidations(value, conditionalItems, typeAtr, returnValue);
        });
    }
    /**
     * Crea y asigna los condicionales que se debe tener el input.
     *
     * @private
     * @memberof BcInputCreateBehavior
     */
    addConditionalItems(conditionalsAtr, conditionalItems, inputCreateElement) {
        const conditionals = JSON.parse(conditionalsAtr);
        const conditions = [BcInputCreateConstants.CONDITION_MAX_LENGTH, BcInputCreateConstants.CONDITION_CAPITAL_LETTERS,
            BcInputCreateConstants.CONDITION_SOME_NUMBERS, BcInputCreateConstants.CONDITION_INITIAL_CHARACTERS,
            BcInputCreateConstants.CONDITION_SPECIAL_CHARACTER, BcInputCreateConstants.CONDITION_CONSECUTIVE_NUMBERS];
        const quantity = Object.keys(conditionals).length;
        let cont = 0;
        for (const condition in conditionals) {
            const parameters = conditionals[condition];
            conditions.forEach((conditional) => {
                if (condition === conditional) {
                    cont++;
                    this.addConditionWithState(condition, conditionalItems);
                    this.createConditionItem(conditional, parameters.description, cont, quantity, inputCreateElement);
                }
            });
        }
    }
    /**
     * Agrega las condiciones y el estado a la lista de condicionales que tendra el input.
     *
     * @param {string} condition Condicion que se agregara
     * @private
     * @memberof BcInputCreateBehavior
     */
    addConditionWithState(condition, conditionalItems) {
        const item = { condition: condition, state: false };
        conditionalItems.push(item);
    }
    /**
     * Asigna las validaciones segun la variante.
     *
     * @param {string} inputValidator Tipo del input
     * @private
     * @memberof BcInputCreateBehavior
     */
    asignValidations(inputValidator, conditionalItems, typeAtr, returnValue) {
        const totalValidators = this.getValidations(conditionalItems);
        if (typeAtr === BcInputCreateConstants.TYPE_USER) {
            returnValue[BcInputCreateConstants.USER_VALUE] = inputValidator;
        }
        if (typeAtr === BcInputCreateConstants.TYPE_PASSWORD) {
            returnValue[BcInputCreateConstants.PASSWORD_VALUE] = inputValidator;
            returnValue[BcInputCreateConstants.VALIDATIONS_VALUE] = totalValidators;
        }
        if (typeAtr === BcInputCreateConstants.TYPE_PASSWORD_CREATE) {
            returnValue[BcInputCreateConstants.NEW_PASSWORD_VALUE] = inputValidator;
            returnValue[BcInputCreateConstants.VALIDATIONS_VALUE] = totalValidators;
        }
        if (typeAtr === BcInputCreateConstants.TYPE_PASSWORD_UPDATE) {
            returnValue[BcInputCreateConstants.NEW_PASSWORD_VALUE] = inputValidator;
            returnValue[BcInputCreateConstants.VALIDATIONS_VALUE] = totalValidators;
        }
    }
}

class BcInputCreateBehavior extends BcDefaultBehavior {
    constructor() {
        super();
        /** Declarando una propiedad privada llamada conditionalItems y asignándole una matriz vacía de tipo Item.
         * @memberof BcInputCreateBehavior */
        this.conditionalItems = [];
        /** Creando un nuevo objeto y asignándolo a la variable returnValue.
         * @memberof BcInputCreateBehavior */
        this.returnValue = new Object();
        /** Declarar una variable llamada toggleMask y asignarle un valor de verdadero.
         * @memberof BcInputCreateBehavior */
        this.toggleMask = true;
        /** Creando una nueva instancia de la clase BcInputCreateDropDownValidations.
         * @memberof BcInputCreateBehavior */
        this.dropDown = new BcInputCreateDropDownValidations();
    }
    /**
     * Construye el comportamiento del los componentes input-create.
     *
     * @returns {BcInputCreateBehavior} Los comportamientos del componente
     */
    static setUpAll() {
        const inputCreateElements = Array.from(document.querySelectorAll(BcInputCreateConstants.DOCUMENT_QUERY));
        const elements = [];
        for (const inputCreateElement of inputCreateElements) {
            const element = inputCreateElement;
            const bcInputCreateBehavior = new BcInputCreateBehavior();
            bcInputCreateBehavior.setElement(element);
            bcInputCreateBehavior.setUp();
            elements.push(bcInputCreateBehavior);
        }
        return elements;
    }
    /**
     * Construye los elementos del componente input-create.
     *
     * @protected
     * @memberof BcInputCreateBehavior
     */
    _setUp() {
        this.typeAtr = this.mySelf.getAttribute(BcInputCreateConstants.TYPE_ATR) || BcInputCreateConstants.TYPE_PASSWORD;
        this.conditionalsAtr = this.mySelf.getAttribute(BcInputCreateConstants.CONDITIONALS_ATR);
        this.maskAtr = this.mySelf.getAttribute(BcInputCreateConstants.MASK_ATR);
        this.titleAtr = this.mySelf.getAttribute(BcInputCreateConstants.TITLE_ATR);
        this.supportTextConditionAtr = this.mySelf.getAttribute(BcInputCreateConstants.SUPPORT_TEXT_CONDITION_ATR);
        this.titleIconAtr = this.mySelf.getAttribute(BcInputCreateConstants.TITLE_ICON_ATR);
        this.statusAtr = this.mySelf.getAttribute(BcInputCreateConstants.STATUS_ATR);
        if (this.maskAtr === BcInputCreateConstants.TRUE_VALUE) {
            this.maskAtr = true;
        }
        else {
            this.maskAtr = false;
        }
        if (this.statusAtr === BcInputCreateConstants.TRUE_VALUE) {
            this.statusAtr = true;
        }
        else {
            this.statusAtr = false;
        }
        this.getAttributesIcon();
        this.getIdsInputs();
        this.getAttributesLabel();
        this.getAttributesMsgError();
        this.createStructure(this.typeAtr, this.maskAtr);
        this.dropDown.createDropdownContainer(this.titleAtr, this.supportTextConditionAtr, this.titleIconAtr);
        this.dropDown.initDropDownBehavior(this.mySelf);
        this.initInputBehavior();
        this.createReturn();
        this.listenners();
        this.dropDown.validateConditionals(this.mySelf, this.conditionalItems, this.conditionalsAtr, this.typeAtr, this.returnValue);
    }
    /**
     * Asigna los elementos a validar en el input segun la variante.
     *
     * @private
     * @memberof BcInputCreateBehavior
     */
    createReturn() {
        if (this.conditionalsAtr !== null && this.typeAtr === BcInputCreateConstants.TYPE_USER) {
            this.returnValue[BcInputCreateConstants.USER_VALUE] = '';
            this.returnValue[BcInputCreateConstants.VALIDATIONS_VALUE] = '';
        }
        if (this.conditionalsAtr !== null && this.typeAtr === BcInputCreateConstants.TYPE_PASSWORD) {
            this.returnValue[BcInputCreateConstants.PASSWORD_VALUE] = '';
            this.returnValue[BcInputCreateConstants.VALIDATIONS_VALUE] = '';
        }
        if (this.typeAtr === BcInputCreateConstants.TYPE_PASSWORD_CREATE) {
            this.returnValue[BcInputCreateConstants.NEW_PASSWORD_VALUE] = '';
            this.returnValue[BcInputCreateConstants.VALIDATIONS_VALUE] = '';
            this.returnValue[BcInputCreateConstants.EQUAL_VALUE] = false;
        }
        if (this.typeAtr === BcInputCreateConstants.TYPE_PASSWORD_UPDATE) {
            this.returnValue[BcInputCreateConstants.CURRENT_PASSWORD_VALUE] = '';
            this.returnValue[BcInputCreateConstants.NEW_PASSWORD_VALUE] = '';
            this.returnValue[BcInputCreateConstants.VALIDATIONS_VALUE] = '';
            this.returnValue[BcInputCreateConstants.EQUAL_VALUE] = false;
        }
    }
    /**
     * Inicializa las instancias de los input que contiene el componente. Les asigna su comportamiento 'BcInputBehavior'.
     *
     * @private
     * @memberof BcInputCreateBehavior
     */
    initInputBehavior() {
        const inputs = this.mySelf.querySelectorAll(BcCommonConstants.INPUT_TAG);
        inputs.forEach((input) => {
            this.inputBehavior = new BcInputBehavior;
            this.inputBehavior.setElement(input);
            this.inputBehavior.setUp();
        });
    }
    /**
     * Funcion para obtener el valor de los iconos que tendra el componente.
     *
     * @private
     * @memberof BcInputCreateBehavior
     */
    getAttributesIcon() {
        this.firstIconAtr = this.mySelf.getAttribute(BcInputCreateConstants.FIRST_ICON_ATR);
        this.secondIconAtr = this.mySelf.getAttribute(BcInputCreateConstants.SECOND_ICON_ATR);
        this.thirdIconAtr = this.mySelf.getAttribute(BcInputCreateConstants.THIRD_ICON_ATR);
        this.titleIconAtr = this.mySelf.getAttribute(BcInputCreateConstants.TITLE_ICON_ATR) || BcInputCreateConstants.ICON_LOCK;
    }
    /**
     * Funcion para obtener el id de los inputs del componente.
     *
     * @private
     * @memberof BcInputCreateBehavior
     */
    getIdsInputs() {
        this.firstIdInputAtr = this.mySelf.getAttribute(BcInputCreateConstants.FIRST_ID_INPUT_ATR) || BcInputCreateConstants.FIRST_ID_TEXT;
        this.secondIdInputAtr = this.mySelf.getAttribute(BcInputCreateConstants.SECOND_ID_INPUT_ATR) || BcInputCreateConstants.SECOND_ID_TEXT;
        this.thirdIdInputAtr = this.mySelf.getAttribute(BcInputCreateConstants.THIRD_ID_INPUT_ATR) || BcInputCreateConstants.THIRD_ID_TEXT;
    }
    /**
     * Funcion para obtener el valor de los labels que se le asignaran al componente.
     *
     * @private
     * @memberof BcInputCreateBehavior
     */
    getAttributesLabel() {
        this.firstLabelAtr = this.mySelf.getAttribute(BcInputCreateConstants.FIRST_LABEL_ATR) || BcInputCreateConstants.CURRENT_PASSWORD_VALUE_DEFAULT;
        this.secondLabelAtr = this.mySelf.getAttribute(BcInputCreateConstants.SECOND_LABEL_ATR) || BcInputCreateConstants.NEW_PASSWORD_VALUE_DEFAULT;
        this.thirdLabelAtr = this.mySelf.getAttribute(BcInputCreateConstants.THIRD_LABEL_ATR) || BcInputCreateConstants.CONFIRM_PASSWORD_VALUE_DEFAULT;
        this.titleAtr = this.mySelf.getAttribute(BcInputCreateConstants.TITLE_ATR) || BcInputCreateConstants.TITLE_VALUE_DEFAULT;
        this.supportTextConditionAtr = this.mySelf.getAttribute(BcInputCreateConstants.SUPPORT_TEXT_CONDITION_ATR) || BcInputCreateConstants.SUPPORT_TEXT_DEFAULT;
    }
    /**
     * Funcion para ontener el valor de los span que se le asignaran al componente.
     * Los span son el mensaje de error en caso de no cumplir con los criterios requeridos.
     *
     * @private
     * @memberof BcInputCreateBehavior
     */
    getAttributesMsgError() {
        this.firstMsgErrorAtr = this.mySelf.getAttribute(BcInputCreateConstants.FIRST_MSG_ERROR_ATR) || BcInputCreateConstants.MSG_ERROR_VALUE_DEFAULT;
        this.secondMsgErrorAtr = this.mySelf.getAttribute(BcInputCreateConstants.SECOND_MSG_ERROR_ATR) || BcInputCreateConstants.MSG_ERROR_VALUE_DEFAULT;
        this.thirdMsgErrorAtr = this.mySelf.getAttribute(BcInputCreateConstants.THIRD_MSG_ERROR_ATR) || BcInputCreateConstants.MSG_ERROR_VALIDATION_VALUE_DEFAULT;
    }
    /**
     * Asigna los distintos listeners que tendran los input del componente.
     *
     * @private
     * @memberof BcInputCreateBehavior
     */
    listenners() {
        this.listenerClickInput();
        this.preventCopyCutPaste();
        this.listenerToggleMask();
        this.listenerFocusOut();
        this.listenerFocus();
        this.inputSpacingListener();
        this.validateEqualsInputs();
        this.listenerFocusOutEqual();
        this.listenerFocusEqual();
    }
    /**
     * Comportamiento al hacer focus en los input del componente.
     *
     * @private
     * @memberof BcInputCreateBehavior
     */
    listenerFocus() {
        const dropdownQuery = this.mySelf.querySelector(`.${BcCommonConstants.BC_DROPDOWN_CLASS}`);
        const span = dropdownQuery.querySelector(BcCommonConstants.SPAN_TAG);
        let inputEqual;
        let spanEqual;
        let emState;
        if (this.validateTypes([BcInputCreateConstants.TYPE_PASSWORD_CREATE, BcInputCreateConstants.TYPE_PASSWORD_UPDATE])) {
            inputEqual = this.mySelf.querySelector(`.${BcInputCreateConstants.CLASS_INPUT_CREATE_EQUAL}`);
            spanEqual = inputEqual.parentElement.querySelector(BcCommonConstants.SPAN_TAG);
            emState = inputEqual.parentElement.querySelectorAll(BcCommonConstants.EM_TAG);
        }
        if (dropdownQuery) {
            const input = dropdownQuery.querySelector(BcCommonConstants.INPUT_TAG);
            input.addEventListener(BcCommonConstants.EVENT_FOCUS, () => {
                const validators = this.conditionalItems;
                const inputValue = input.value;
                this.dropDown.dropDownBehavior.openDrowndown();
                if (inputValue.length === 0) {
                    validators.forEach((item) => {
                        this.dropDown.changeStatusItemDot(item.condition, this.mySelf);
                    });
                }
                input.classList.remove(BcInputCreateConstants.CLASS_INPUT_SUCCESS);
                input.classList.remove(BcInputCreateConstants.CLASS_INPUT_ERROR);
                span.style.visibility = BcCommonConstants.HIDDEN;
                if (inputEqual !== undefined) {
                    inputEqual.classList.remove(BcInputCreateConstants.CLASS_INPUT_SUCCESS);
                }
                if (this.validateTypes([BcInputCreateConstants.TYPE_PASSWORD_CREATE, BcInputCreateConstants.TYPE_PASSWORD_UPDATE])) {
                    emState[1].textContent = '';
                    spanEqual.style.visibility = BcCommonConstants.HIDDEN;
                }
            });
        }
    }
    /**
     * Comportamiento al hacer focus-out a los input del componente.
     *
     * @private
     * @memberof BcInputCreateBehavior
     */
    listenerFocusOut() {
        const dropdownQuery = this.mySelf.querySelector(`.${BcCommonConstants.BC_DROPDOWN_CLASS}`);
        const span = dropdownQuery.querySelector(BcCommonConstants.SPAN_TAG);
        const inputEqual = this.mySelf.querySelector(`.${BcInputCreateConstants.CLASS_INPUT_CREATE_EQUAL}`);
        let inputEqualSpan;
        let emState;
        if (this.validateTypes([BcInputCreateConstants.TYPE_PASSWORD_CREATE, BcInputCreateConstants.TYPE_PASSWORD_UPDATE])) {
            emState = inputEqual.parentElement.querySelectorAll(BcCommonConstants.EM_TAG);
            inputEqualSpan = inputEqual.parentElement.querySelector(BcCommonConstants.SPAN_TAG);
        }
        if (dropdownQuery) {
            const input = dropdownQuery.querySelector(BcCommonConstants.INPUT_TAG);
            input.addEventListener(BcCommonConstants.EVENT_FOCUSOUT, () => {
                const validators = this.dropDown.getValidations(this.conditionalItems);
                const filterItems = this.dropDown.getFilterValidations(this.conditionalItems);
                this.focusOutValidations(validators, filterItems, input, inputEqual, span, inputEqualSpan, emState);
            });
        }
    }
    /**
     * Funcion auxiliar que modifica el estado de los input segun el contenido.
     *
     * @param {boolean} validators Indica si se cumplen las condiciones del dropdown
     * @param {object[]} filterItems Elementos del dropdown que no se cumplen
     * @param {Element} fstValue Input en el que se ingresa el valor que se espera cumpla las condiciones del dropdown
     * @param {Element} sndInput Input correspondiente al validation password.
     * @param {Element} fstSpan Mensaje que indica si no se cumplen los requerimientos de la clave
     * @param {Element} sndSpan Mensaje que indica si la clave no es igual a la ingresada anteriormente
     * @param {any} emState Icono del segundo input que indica si la clave es igual a la ingresada anteriormente
     * @private
     * @memberof BcInputCreateBehavior
     */
    focusOutValidations(validators, filterItems, fstValue, sndInput, fstSpan, sndSpan, emState) {
        const inputValue = fstValue.value;
        const inputEqualValue = sndInput.value;
        if (validators) {
            fstValue.classList.add(BcInputCreateConstants.CLASS_INPUT_SUCCESS);
        }
        else {
            fstValue.classList.add(BcInputCreateConstants.CLASS_INPUT_ERROR);
            fstSpan.style.visibility = BcInputCreateConstants.VISIBLE_VALUE;
        }
        if (inputValue.length !== 0) {
            filterItems.forEach((item) => {
                this.dropDown.changeStatusItem(item.condition, this.mySelf);
            });
        }
        if (inputValue.length === 0) {
            fstValue.classList.remove(BcInputCreateConstants.CLASS_INPUT_ERROR);
            fstValue.classList.remove(BcInputCreateConstants.CLASS_INPUT_SUCCESS);
            fstValue.classList.add(BcInputCreateConstants.CLASS_INPUT);
            fstSpan.style.visibility = BcCommonConstants.HIDDEN;
        }
        this.focusOutTypeValidations(inputValue, inputEqualValue, sndInput, sndSpan, emState);
    }
    /**
     * Funcion auxiliar que segun el tipo de input, modifica el comportamiento del mismo.
     *
     * @param {string} fstValue Contenido del input al que se le ingresa la clave a validar
     * @param {string} sndValue Contenido del input que valida que la clave ingresada anteriormente sea igual
     * @param {Element} sndInput Input correspondiente al validation password
     * @param {Element} sndSpan Mensaje que indica si la clave no es igual a la ingresada anteriormente
     * @param {any} emState Icono del segundo input que indica si la clave es igual a la ingresada anteriormente
     * @private
     * @memberof BcInputCreateBehavior
     */
    focusOutTypeValidations(fstValue, sndValue, sndInput, sndSpan, emState) {
        if (this.validateTypes([BcInputCreateConstants.TYPE_PASSWORD_CREATE, BcInputCreateConstants.TYPE_PASSWORD_UPDATE])) {
            if (fstValue === sndValue && fstValue.length !== 0) {
                sndInput.classList.add(BcInputCreateConstants.CLASS_INPUT_SUCCESS);
                emState[1].textContent = BcInputCreateConstants.ICON_SUCCESSFUL;
                this.returnValue[BcInputCreateConstants.EQUAL_VALUE] = true;
            }
            if (fstValue.length === 0 && sndValue.length !== 0) {
                sndInput.classList.add(BcInputCreateConstants.CLASS_INPUT_ERROR);
                emState[1].textContent = BcInputCreateConstants.ICON_REMOVE;
                sndSpan.style.visibility = BcInputCreateConstants.VISIBLE_VALUE;
            }
            if (fstValue !== sndValue && sndValue.length !== 0) {
                sndInput.classList.add(BcInputCreateConstants.CLASS_INPUT_ERROR);
                emState[1].textContent = BcInputCreateConstants.ICON_REMOVE;
                sndSpan.style.visibility = BcInputCreateConstants.VISIBLE_VALUE;
            }
        }
    }
    /**
     * Comportamiento al hacer focus en el input correspondiente a la validacion de la clave.
     *
     * @private
     * @memberof BcInputCreateBehavior
     */
    listenerFocusEqual() {
        if (this.validateTypes([BcInputCreateConstants.TYPE_PASSWORD_CREATE, BcInputCreateConstants.TYPE_PASSWORD_UPDATE])) {
            const input = this.mySelf.querySelector(`.${BcInputCreateConstants.CLASS_INPUT_CREATE_EQUAL}`);
            const span = input.parentElement.querySelector(BcCommonConstants.SPAN_TAG);
            const emState = input.parentElement.querySelectorAll(BcCommonConstants.EM_TAG);
            if (input) {
                input.addEventListener(BcCommonConstants.EVENT_FOCUS, () => {
                    this.dropDown.dropDownBehavior.closeDropdown();
                    emState[1].textContent = '';
                    span.style.visibility = BcCommonConstants.HIDDEN;
                });
            }
        }
    }
    /**
     * Comportamiento al hacer focus out del input correspondiente a la validacion de la clave.
     *
     * @private
     * @memberof BcInputCreateBehavior
     */
    listenerFocusOutEqual() {
        const dropdownQuery = this.mySelf.querySelector(`.${BcCommonConstants.BC_DROPDOWN_CLASS}`);
        const inputValidator = dropdownQuery.querySelector(BcCommonConstants.INPUT_TAG);
        const input = this.mySelf.querySelector(`.${BcInputCreateConstants.CLASS_INPUT_CREATE_EQUAL}`);
        let span;
        let emState;
        if (this.validateTypes([BcInputCreateConstants.TYPE_PASSWORD_CREATE, BcInputCreateConstants.TYPE_PASSWORD_UPDATE])) {
            span = input.parentElement.querySelector(BcCommonConstants.SPAN_TAG);
            emState = input.parentElement.querySelectorAll(BcCommonConstants.EM_TAG);
            emState[1].classList.add(BcCommonConstants.ICONS_CLASS);
        }
        if (input) {
            input.addEventListener(BcCommonConstants.EVENT_FOCUSOUT, () => {
                this.focusOutEqualValidations(input, inputValidator, span, emState);
            });
        }
    }
    /**
     * Funcion auxiliar que modifica el comportamiento del input correspondiente a la validacion de la clave.
     *
     * @param {Element} fstInput Input en el que se ingresa el valor que se espera cumpla las condiciones del dropdown
     * @param {Element} sndInput Input correspondiente al validation password.
     * @param {Element} span Mensaje que indica si la clave no es igual a la ingresada anteriormente
     * @param {any} emState Icono del segundo input que indica si la clave es igual a la ingresada anteriormente
     * @private
     * @memberof BcInputCreateBehavior
     */
    focusOutEqualValidations(fstInput, sndInput, span, emState) {
        const inputValue = fstInput.value;
        const inputValitadorValue = sndInput.value;
        if (inputValue === inputValitadorValue && inputValitadorValue.length !== 0 && inputValue.length !== 0) {
            this.returnValue[BcInputCreateConstants.EQUAL_VALUE] = true;
            emState[1].textContent = BcInputCreateConstants.ICON_SUCCESSFUL;
        }
        else {
            this.returnValue[BcInputCreateConstants.EQUAL_VALUE] = false;
            fstInput.classList.add(`${BcInputCreateConstants.CLASS_INPUT_ERROR}`);
            if (this.validateTypes([BcInputCreateConstants.TYPE_PASSWORD_CREATE, BcInputCreateConstants.TYPE_PASSWORD_UPDATE])) {
                span.style.visibility = BcInputCreateConstants.VISIBLE_VALUE;
                emState[1].textContent = BcInputCreateConstants.ICON_REMOVE;
            }
        }
        if (inputValue.length === 0) {
            fstInput.classList.remove(`${BcInputCreateConstants.CLASS_INPUT_ERROR}`);
            fstInput.classList.add(`${BcInputCreateConstants.CLASS_INPUT}`);
            span.style.visibility = BcCommonConstants.HIDDEN;
            emState[1].textContent = '';
        }
        if (inputValitadorValue.length === 0 && inputValue.length === 0) {
            fstInput.classList.remove(`${BcInputCreateConstants.CLASS_INPUT_SUCCESS}`);
            fstInput.classList.remove(`${BcInputCreateConstants.CLASS_INPUT_ERROR}`);
            fstInput.classList.add(`${BcInputCreateConstants.CLASS_INPUT}`);
            span.style.visibility = BcCommonConstants.HIDDEN;
            emState[1].textContent = '';
        }
    }
    /**
     * Verifica que el tipo de input ingresado en el componente sea valido.
     *
     * @param {string[]} types Tipos de inputs
     * @returns {boolean} Si contiene el tipo de input deseado
     * @private
     * @memberof BcInputCreateBehavior
     */
    validateTypes(types) {
        return types.includes(this.typeAtr);
    }
    /**
     * Modifica el estado de las validaciones si la clave ingresada y la validacion coinciden.
     *
     * @private
     * @memberof BcInputCreateBehavior
     */
    validateEqualsInputs() {
        const input = this.mySelf.querySelector(`.${BcInputCreateConstants.CLASS_INPUT_CREATE_EQUAL}`);
        const dropdownQuery = this.mySelf.querySelector(`.${BcCommonConstants.BC_DROPDOWN_CLASS}`);
        const inputDropdown = dropdownQuery.querySelector(BcCommonConstants.INPUT_TAG);
        if (input) {
            input.addEventListener(BcCommonConstants.EVENT_INPUT, () => {
                const value = input.value;
                input.classList.remove(`${BcInputCreateConstants.CLASS_INPUT_ERROR}`);
                if (value === inputDropdown.value) {
                    input.classList.add(`${BcInputCreateConstants.CLASS_INPUT_SUCCESS}`);
                    this.returnValue[BcInputCreateConstants.EQUAL_VALUE] = true;
                }
                else {
                    input.classList.remove(`${BcInputCreateConstants.CLASS_INPUT_SUCCESS}`);
                    this.returnValue[BcInputCreateConstants.EQUAL_VALUE] = false;
                }
            });
        }
    }
    /**
     * Listener sobre el focus del enmascaramiento del input password
     *
     * @private
     * @memberof BcInputCreateBehavior
     */
    listenerToggleMask() {
        let input;
        const buttonState = this.mySelf.querySelector(`.${BcInputCreateConstants.CLASS_BUTTON_ICON}`);
        if (this.typeAtr === BcInputCreateConstants.TYPE_USER || this.typeAtr === BcInputCreateConstants.TYPE_PASSWORD) {
            input = this.mySelf.querySelector(BcCommonConstants.INPUT_TAG);
        }
        else {
            const dropdownQuery = this.mySelf.querySelector(`.${BcCommonConstants.BC_DROPDOWN_CLASS}`);
            input = dropdownQuery.querySelector(BcCommonConstants.INPUT_TAG);
        }
        if (buttonState) {
            this.toggleWithClick(buttonState, input);
            this.toggleWithKeyboard(buttonState, input);
        }
    }
    /**
     * Funcion auxiliar que modifica el estado de enmascaramiento al dar click en el boton de mascara
     *
     * @param {Element} btn Boton de enmascaramiento del input
     * @param {Element} input Input que cuenta con la opcion de enmasacar-desenmascarar
     * @private
     * @memberof BcInputCreateBehavior
     */
    toggleWithClick(btn, input) {
        btn.addEventListener(BcCommonConstants.EVENT_CLICK, () => {
            this.toggleMask = !this.toggleMask;
            if (!this.toggleMask) {
                input.setAttribute(BcInputCreateConstants.TYPE_ATR, BcInputCreateConstants.TYPE_TEXT);
                btn.textContent = BcInputCreateConstants.ICON_VIEW;
            }
            if (this.toggleMask) {
                input.setAttribute(BcInputCreateConstants.TYPE_ATR, BcInputCreateConstants.TYPE_PASSWORD);
                btn.textContent = BcInputCreateConstants.ICON_NO_VIEW;
            }
        });
    }
    /**
     * Funcion auxiliar que modifica el estado de enmascaramiento al oprimir la tecla
     * enter o espacio en el boton de mascara.
     *
     * @param {Element} btn Boton de enmascaramiento del input
     * @param {Element} input Input que cuenta con la opcion de enmasacar-desenmascarar
     * @private
     * @memberof BcInputCreateBehavior
     */
    toggleWithKeyboard(btn, input) {
        btn.addEventListener(BcCommonConstants.EVENT_KEY_UP, (event) => {
            const _event = event;
            if (_event.key === BcCommonConstants.KEY_EVENT_ENTER || _event.key === BcCommonConstants.KEY_EVENT_SPACE) {
                this.toggleMask = !this.toggleMask;
                if (!this.toggleMask) {
                    input.setAttribute(BcInputCreateConstants.TYPE_ATR, BcInputCreateConstants.TYPE_TEXT);
                    btn.textContent = BcInputCreateConstants.ICON_VIEW;
                }
                if (this.toggleMask) {
                    input.setAttribute(BcInputCreateConstants.TYPE_ATR, BcInputCreateConstants.TYPE_PASSWORD);
                    btn.textContent = BcInputCreateConstants.ICON_NO_VIEW;
                }
            }
        });
    }
    /**
     * Listener sobre el input para desplegar el dropdown
     *
     * @private
     * @memberof BcInputCreateBehavior
     */
    listenerClickInput() {
        const dropdownQuery = this.mySelf.querySelector(`.${BcCommonConstants.BC_DROPDOWN_CLASS}`);
        if (dropdownQuery !== null) {
            const input = dropdownQuery.querySelector(BcCommonConstants.INPUT_TAG);
            input.addEventListener(BcCommonConstants.EVENT_CLICK, (event) => {
                event.stopPropagation();
                event.preventDefault();
                this.dropDown.dropDownBehavior.openDrowndown();
            });
        }
    }
    /**
     * Listener sobre los inputs para prevenir el espaciado en el contenido.
     *
     * @private
     * @memberof BcInputCreateBehavior
     */
    inputSpacingListener() {
        const fstInput = this.mySelf.querySelector(`.${BcInputCreateConstants.CLASS_INPUT_CREATE_FIRST_INPUT}`);
        const dropdownQuery = this.mySelf.querySelector(`.${BcCommonConstants.BC_DROPDOWN_CLASS}`);
        const sndInput = dropdownQuery.querySelector(BcCommonConstants.INPUT_TAG);
        const trdInput = this.mySelf.querySelector(`.${BcInputCreateConstants.CLASS_INPUT_CREATE_EQUAL}`);
        if (fstInput) {
            this.preventSpacing(fstInput);
        }
        if (sndInput) {
            this.preventSpacing(sndInput);
        }
        if (trdInput) {
            this.preventSpacing(trdInput);
        }
    }
    /**
     * Funcion auxiliar que previene el ingreso de espacios al un input ingresado por parametro.
     *
     * @param {Element} input Input al que se pretende evitar el espaciado
     * @private
     * @memberof BcInputCreateBehavior
     */
    preventSpacing(input) {
        const fstInput = this.mySelf.querySelector(`.${BcInputCreateConstants.CLASS_INPUT_CREATE_FIRST_INPUT}`);
        input.addEventListener(BcCommonConstants.EVENT_INPUT, () => {
            const value = input.value;
            if (value.includes(' ')) {
                const arrText = Array.from(value);
                arrText.pop();
                const text = arrText.toString();
                const textNonArray = text.replace(/,/g, '');
                input.value = textNonArray;
            }
            if (input === fstInput) {
                this.returnValue[BcInputCreateConstants.CURRENT_PASSWORD_VALUE] = value;
            }
        });
    }
    /**
     * Funcion encargada de prevenir que se copie, pegue u corte el contenido del input.
     *
     * @private
     * @memberof BcInputCreateBehavior
     */
    preventCopyCutPaste() {
        const container = this.mySelf.querySelector(`.${BcInputCreateConstants.CLASS_INPUT_CREATE_CONTAINER}`);
        const inputs = container.querySelectorAll(BcCommonConstants.INPUT_TAG);
        inputs.forEach((char) => {
            char.addEventListener(BcCommonConstants.EVENT_PASTE, (event) => {
                event.preventDefault();
            });
            char.addEventListener(BcCommonConstants.EVENT_COPY, (event) => {
                event.preventDefault();
            });
            char.addEventListener(BcCommonConstants.EVENT_CUT, (event) => {
                event.preventDefault();
            });
        });
    }
    /**
     * Funcion para validar la variante del componente y crearlo segun esto.
     *
     * @param {string} type Tipo de variante del componente
     * @param {boolean} mask Indica si el input a construir tiene enmascaramiento
     * @private
     * @memberof BcInputCreateBehavior
     */
    createStructure(type, mask) {
        const mainContainer = this.dropDown.createContainner(BcInputCreateConstants.INPUT_CREATE, BcInputCreateConstants.CLASS_INPUT_CREATE_CONTAINER);
        this.createTypeUser(type, mask, mainContainer);
        this.createTypePassword(type, mask, mainContainer);
        this.createTypePasswordCreate(type, mask, mainContainer);
        this.createTypePasswordUpdate(type, mask, mainContainer);
    }
    /**
     * Construye la variante user.
     *
     * @param {string} type Tipo de variante del componente
     * @param {boolean} mask Indica si el input a construir tiene enmascaramiento
     * @private
     * @memberof BcInputCreateBehavior
     */
    createTypeUser(type, mask, mainContainer) {
        if (type === BcInputCreateConstants.TYPE_USER) {
            const firstContainer = this.dropDown.createContainner(BcInputCreateConstants.CLASS_INPUT_CREATE_CONTAINER, BcInputCreateConstants.CLASS_FIRST_CONTAINER);
            firstContainer.setAttribute(BcCommonConstants.ARIA_LABEL, `${this.firstLabelAtr}`);
            const dropDownBoolean = this.conditionalsAtr === null ? false : true;
            this.createInput(this.firstIconAtr, firstContainer, this.firstIdInputAtr, this.firstLabelAtr, this.firstMsgErrorAtr, dropDownBoolean, false, type);
            mainContainer.appendChild(firstContainer);
        }
    }
    /**
     * Construye la variante password.
     *
     * @param {string} type Tipo de variante del componente
     * @param {boolean} mask Indica si el input a construir tiene enmascaramiento
     * @private
     * @memberof BcInputCreateBehavior
     */
    createTypePassword(type, mask, mainContainer) {
        if (type === BcInputCreateConstants.TYPE_PASSWORD) {
            const firstContainer = this.dropDown.createContainner(BcInputCreateConstants.CLASS_INPUT_CREATE_CONTAINER, BcInputCreateConstants.CLASS_FIRST_CONTAINER);
            firstContainer.setAttribute(BcCommonConstants.ARIA_LABEL, `${this.firstLabelAtr}, editar texto seguro.`);
            const dropDownBoolean = this.conditionalsAtr === null ? false : true;
            this.createInput(this.firstIconAtr, firstContainer, this.firstIdInputAtr, this.firstLabelAtr, this.firstMsgErrorAtr, dropDownBoolean, mask, type);
            mainContainer.appendChild(firstContainer);
        }
    }
    /**
     * Construye la variante password-create.
     *
     * @param {string} type Tipo de variante del componente
     * @param {boolean} mask Indica si el input a construir tiene enmascaramiento
     * @private
     * @memberof BcInputCreateBehavior
     */
    createTypePasswordCreate(type, mask, mainContainer) {
        if (type === BcInputCreateConstants.TYPE_PASSWORD_CREATE) {
            const firstContainer = this.dropDown.createContainner(BcInputCreateConstants.CLASS_INPUT_CREATE_CONTAINER, BcInputCreateConstants.CLASS_FIRST_CONTAINER);
            firstContainer.setAttribute(BcCommonConstants.ARIA_LABEL, `${this.firstLabelAtr}, editar texto seguro.`);
            this.createInput(this.firstIconAtr, firstContainer, this.firstIdInputAtr, this.firstLabelAtr, this.firstMsgErrorAtr, true, mask);
            const secondContainer = this.dropDown.createContainner(BcInputCreateConstants.CLASS_INPUT_CREATE_CONTAINER, BcInputCreateConstants.CLASS_SECOND_CONTAINER);
            secondContainer.setAttribute(BcCommonConstants.ARIA_LABEL, `${this.secondLabelAtr}, editar texto seguro.`);
            this.createInput(this.secondIconAtr, secondContainer, this.secondIdInputAtr, this.secondLabelAtr, this.secondMsgErrorAtr, false, false, '', BcInputCreateConstants.EQUAL_TEXT);
            mainContainer.appendChild(firstContainer);
            mainContainer.appendChild(secondContainer);
        }
    }
    /**
     * Construye la variante password-update.
     *
     * @param {string} type Tipo de variante del componente
     * @param {boolean} mask Indica si el input a construir tiene enmascaramiento
     * @private
     * @memberof BcInputCreateBehavior
     */
    createTypePasswordUpdate(type, mask, mainContainer) {
        if (type === BcInputCreateConstants.TYPE_PASSWORD_UPDATE) {
            const firstContainer = this.dropDown.createContainner(BcInputCreateConstants.CLASS_INPUT_CREATE_CONTAINER, BcInputCreateConstants.CLASS_FIRST_CONTAINER);
            firstContainer.setAttribute(BcCommonConstants.ARIA_LABEL, `${this.firstLabelAtr}, editar texto seguro.`);
            this.createInput(this.firstIconAtr, firstContainer, this.firstIdInputAtr, this.firstLabelAtr, this.firstMsgErrorAtr, false, false, '', BcInputCreateConstants.FIRST_TEXT);
            const secondContainer = this.dropDown.createContainner(BcInputCreateConstants.CLASS_INPUT_CREATE_CONTAINER, BcInputCreateConstants.CLASS_SECOND_CONTAINER);
            secondContainer.setAttribute(BcCommonConstants.ARIA_LABEL, `${this.secondLabelAtr}, editar texto seguro.`);
            this.createInput(this.secondIconAtr, secondContainer, this.secondIdInputAtr, this.secondLabelAtr, this.secondMsgErrorAtr, true, mask);
            const thirdContainer = this.dropDown.createContainner(BcInputCreateConstants.CLASS_INPUT_CREATE_CONTAINER, BcInputCreateConstants.CLASS_THIRD_CONTAINER);
            thirdContainer.setAttribute(BcCommonConstants.ARIA_LABEL, `${this.thirdLabelAtr}, editar texto seguro.`);
            this.createInput(this.thirdIconAtr, thirdContainer, this.thirdIdInputAtr, this.thirdLabelAtr, this.thirdMsgErrorAtr, false, false, '', BcInputCreateConstants.EQUAL_TEXT);
            mainContainer.appendChild(firstContainer);
            mainContainer.appendChild(secondContainer);
            mainContainer.appendChild(thirdContainer);
            thirdContainer.addEventListener(BcCommonConstants.EVENT_FOCUS, () => {
                this.dropDown.dropDownBehavior.closeDropdown();
            });
        }
    }
    /**
     * Funcion para crear un input.
     *
     * @param {Element} container Contenedor donde se va a crear el input
     * @param {string} id Id que se aplicará al input y al label
     * @param {string} label Texto que se le aplicará al label
     * @param {string} errorMsg Texto de error que se mostrara en la etiqueta span
     * @param {boolean} dropDown Define si el input tiene dropdown
     * @private
     * @memberof BcInputCreateBehavior
     */
    createInput(icon, container, id, textLabel, errorMsg, dropDown, mask, type, aditionalClass) {
        const { emIcon, formField, input, emMaskState, label, span, spanHidden } = this.createStylesInput(id, type, mask, textLabel, errorMsg);
        if (icon) {
            emIcon.innerText = icon;
            formField.appendChild(emIcon);
        }
        formField.appendChild(input);
        formField.appendChild(emMaskState);
        formField.appendChild(label);
        formField.appendChild(span);
        formField.appendChild(spanHidden);
        if (aditionalClass === BcInputCreateConstants.EQUAL_TEXT) {
            input.classList.add(BcInputCreateConstants.CLASS_INPUT_CREATE_EQUAL);
        }
        if (aditionalClass === BcInputCreateConstants.FIRST_TEXT) {
            input.classList.add(BcInputCreateConstants.CLASS_INPUT_CREATE_FIRST_INPUT);
        }
        this.conditionalDropDown(dropDown, container, id, spanHidden, formField);
        container.appendChild(formField);
        this.accesibility(emMaskState, span, label, textLabel, input, emIcon);
        if (this.statusAtr) {
            input.setAttribute(BcCommonConstants.DISABLED, 'true');
            formField.setAttribute(BcCommonConstants.DISABLED, 'true');
            container.setAttribute(BcCommonConstants.DISABLED, 'true');
        }
    }
    /**
     * "Esta función crea un campo de formulario, una etiqueta, una entrada, un intervalo y un intervalo oculto, y los devuelve como un objeto".
     * @param {string} id - cadena, tipo: cadena | indefinido, máscara: booleano | indefinido, etiqueta
     * de texto: cadena, mensaje de error: cadena
     * @param {string | undefined} type - cadena | indefinido, máscara: booleano | indefinido, etiqueta
     * de texto: cadena, mensaje de error: cadena
     * @param {boolean | undefined} mask - booleano | indefinido
     * @param {string} textLabel - cadena, mensaje de error: cadena
     * @param {string} errorMsg - cadena = BcInputCreateConstants.ERROR_MSG_TEXT;
     * @returns Un objeto con las siguientes propiedades:
     * emIcon, formField, entrada, emMaskState, etiqueta, intervalo, intervalo oculto
     */
    createStylesInput(id, type, mask, textLabel, errorMsg) {
        const formField = document.createElement(BcCommonConstants.SECTION_TAG);
        const emIcon = document.createElement(BcCommonConstants.EM_TAG);
        const input = document.createElement(BcCommonConstants.INPUT_TAG);
        const emMaskState = document.createElement(BcCommonConstants.EM_TAG);
        const label = document.createElement(BcCommonConstants.LABEL_TAG);
        const span = document.createElement(BcCommonConstants.SPAN_TAG);
        const spanHidden = document.createElement(BcCommonConstants.SPAN_TAG);
        formField.classList.add(BcInputCreateConstants.CLASS_FORM_FIELD);
        input.setAttribute(BcInputCreateConstants.ID_ATR, id);
        type === BcInputCreateConstants.TYPE_USER ?
            input.setAttribute(BcInputCreateConstants.TYPE_ATR, BcInputCreateConstants.TYPE_TEXT) :
            input.setAttribute(BcInputCreateConstants.TYPE_ATR, BcInputCreateConstants.TYPE_PASSWORD);
        label.setAttribute(BcInputCreateConstants.FOR_ATR, id);
        input.classList.add(BcInputCreateConstants.CLASS_INPUT);
        spanHidden.style.display = BcInputCreateConstants.NONE_TEXT;
        this.conditionalMask(mask, emMaskState);
        label.innerText = textLabel;
        span.innerText = errorMsg;
        span.style.visibility = BcCommonConstants.HIDDEN;
        return { emIcon, formField, input, emMaskState, label, span, spanHidden };
    }
    /**
     * "Esta función agrega accesibilidad al componente".
     * @param {HTMLElement} emMaskState - HTMLElement, intervalo: HTMLElement, etiqueta: HTMLElement,
     * textLabel: cadena, entrada: HTMLElement, emIcon: HTMLElement
     * @param {HTMLElement} span - HTMLElement, etiqueta: HTMLElement, textLabel: cadena, entrada:
     * HTMLElement, emIcon: HTMLElement
     * @param {HTMLElement} label - HTMLElement, textLabel: cadena, entrada: HTMLElement, emIcon:
     * HTMLElement
     * @param {string} textLabel - cadena - el texto que se mostrará en la etiqueta
     * @param {HTMLElement} input - el elemento de entrada
     * @param {HTMLElement} emIcon - el icono que se muestra en el lado derecho de la entrada
     */
    accesibility(emMaskState, span, label, textLabel, input, emIcon) {
        addFocusable(emMaskState, { tabindex: "0" });
        addFocusable(span, { tabindex: "0" });
        label.setAttribute('aria-hidden', 'true');
        label.setAttribute(BcCommonConstants.ARIA_LABEL, `${textLabel}`);
        input.setAttribute(BcCommonConstants.ARIA_LABEL, `${textLabel}, editar texto seguro`);
        emIcon.setAttribute('aria-hidden', 'true');
    }
    /**
     * Si el parámetro desplegable es verdadero, cree un contenedor desplegable
     * @param {boolean | undefined} dropDown - booleano | indefinido =&gt; este es un valor booleano
     * que se pasa desde el componente principal.
     * @param {Element} container - Elemento =&gt; el contenedor de la entrada
     * @param {string} id - cadena - la identificación de la entrada
     * @param {HTMLElement} spanHidden - HTMLElement =
     * documento.createElement(BcCommonConstants.SPAN_TAG);
     * @param {HTMLElement} formField - HTMLElement = el campo de formulario al que se agrega el menú
     * desplegable
     */
    conditionalDropDown(dropDown, container, id, spanHidden, formField) {
        if (dropDown) {
            if (this.conditionalsAtr !== '') {
                const mainContainerDropdown = this.dropDown.createContainner(container.className, BcInputCreateConstants.CLASS_DROPDOWN_CONTENT);
                const section = document.createElement(BcCommonConstants.SECTION_TAG);
                section.classList.add(BcInputCreateConstants.CLASS_CONTENT_CONDITIONALS);
                mainContainerDropdown.appendChild(section);
                mainContainerDropdown.setAttribute(BcInputCreateConstants.ID_ATR, `${BcInputCreateConstants.MY_DROPDOWN_TEXT}-${id}`);
                spanHidden.classList.add(BcInputCreateConstants.CLASS_DROPDOWN_TOGGLE);
                spanHidden.setAttribute(BcInputCreateConstants.ARIA_CONTROLS_ATR, `${BcInputCreateConstants.MY_DROPDOWN_TEXT}-${id}`);
                container.classList.add(BcCommonConstants.BC_DROPDOWN_CLASS);
                formField.appendChild(mainContainerDropdown);
            }
        }
    }
    /**
     * Si la máscara es verdadera, agregue la clase, establezca el texto interno y establezca el
     * atributo.
     * @param {boolean | undefined} mask - booleano | indefinido
     * @param {HTMLElement} emMaskState - HTMLElement =
     * this.element.querySelector(BcInputCreateConstants.SELECTOR_MASK_STATE);
     */
    conditionalMask(mask, emMaskState) {
        if (mask) {
            emMaskState.classList.add(BcInputCreateConstants.CLASS_BUTTON_ICON);
            emMaskState.innerText = BcInputCreateConstants.ICON_NO_VIEW;
            emMaskState.setAttribute(BcCommonConstants.ARIA_LABEL, 'Mostrar/Ocultar contraseña, botón');
        }
    }
}

const BC_NOTIFICATION = `${BcCommonConstants.PREFIX_LIB}-notification`;
const BC_NOTIFICATION_ACTIVE = `${BcCommonConstants.PREFIX_LIB}-notification-active`;
const BC_NOTIFICATION_CLOSE = `${BcCommonConstants.PREFIX_LIB}-close`;
const BC_NOTIFICATION_CLOSING = `${BcCommonConstants.PREFIX_LIB}-notification-closing`;
const BC_NOTIFICATION_DISMISSIBLE = `${BcCommonConstants.PREFIX_LIB}-notification-dismissible`;
const BC_NOTIFICATION_INLINE = `${BcCommonConstants.PREFIX_LIB}-notification-inline`;
const _MAX_TIME_DELAY = 10000;
const _MIN_TIME_DELAY = 5000;

class BcNotificationBehavior extends BcDefaultBehavior {
    constructor() {
        super();
        this.timeOut = 0;
    }
    static setUpAll() {
        const notificationElements = Array.from(document.querySelectorAll(`.${BC_NOTIFICATION}`));
        const elements = [];
        for (let i = 0; i < notificationElements.length; i++) {
            const element = notificationElements[i];
            const bcNotificationBehavior = new BcNotificationBehavior();
            bcNotificationBehavior.setElement(element);
            bcNotificationBehavior.setUp();
            elements.push(bcNotificationBehavior);
        }
        return elements;
    }
    _setUp() {
        this.getCloseButton();
        this.listeners();
        this.accessibility();
    }
    /**
     *Configura la accesibilidad del boton de cierre de la notificación.
     * @memberof BcNotificationBehavior
     */
    accessibility() {
        addFocusable(this.bcNotificationCloseButton, { pressed: 'false' }, { event: () => this.close() });
    }
    /**
     * Selecciona el boton de cierre de la notificación por medio de la clase BC_NOTIFICATION_CLOSE
     * @memberof BcNotificationBehavior
     */
    getCloseButton() {
        this.bcNotificationCloseButton = this.mySelf.querySelector(`.${BC_NOTIFICATION_CLOSE}`);
    }
    /**
     * Registra el evento click del boton de cierre de la notificación.
     * @memberof BcNotificationBehavior
     */
    listeners() {
        this.bcNotificationCloseButton.addEventListener(BcCommonConstants.EVENT_CLICK, (e) => this.close());
        this.hideNotificationAfterCloseAnimation();
    }
    /**
     * Función de cierre de la notificación, siempre y cuando esté activa y visible.
     * @memberof BcNotificationBehavior
     */
    close() {
        if (this.mySelf.classList.contains(BC_NOTIFICATION_ACTIVE) || this.mySelf.classList.contains(BC_NOTIFICATION_DISMISSIBLE)) {
            this.mySelf.classList.add(BC_NOTIFICATION_CLOSING);
        }
    }
    /**
     * Asigna el argumento fn a la función onCloseFunction
     * @param {Function} fn
     * @memberof BcNotificationBehavior
     */
    onClose(fn) {
        this.onCloseFunction = fn;
    }
    /**
     * Reinicia el estado de la notificación después del cierre de la misma.
     * @memberof BcNotificationBehavior
     */
    hideNotificationAfterCloseAnimation() {
        this.mySelf.addEventListener('animationend', (ev) => {
            if (ev.animationName === 'fade-out-opacity' ||
                ev.animationName === 'slide-up-reverse') {
                this.mySelf.classList.remove(BC_NOTIFICATION_CLOSING);
                this.mySelf.classList.remove(BC_NOTIFICATION_INLINE);
                replaceClass(this.mySelf, BC_NOTIFICATION_ACTIVE, BC_NOTIFICATION);
                this.onCloseFunction && this.onCloseFunction();
            }
        });
    }
    /**
      * Abre la notificación y dejandola en estado activo mediante la clase BC_NOTIFICATION_ACTIVE
      * @memberof BcNotificationBehavior
      */
    open() {
        replaceClass(this.mySelf, BC_NOTIFICATION, BC_NOTIFICATION_ACTIVE);
        if (this.timeOut != 0) {
            setTimeout(() => {
                this.close();
            }, this.timeOut);
        }
    }
    /**
     * Asigna el valor de espera (de tiempo) time a timeOut siempre que no se exceda de los límites: _MIN_TIME_DELAY y _MAX_TIME_DELAY.
     * @param {number} time
     * @memberof BcNotificationBehavior
     */
    setTimeOut(time) {
        if (time >= _MIN_TIME_DELAY && time <= _MAX_TIME_DELAY) {
            this.timeOut = time;
        }
        else if (time > _MAX_TIME_DELAY) {
            this.timeOut = _MAX_TIME_DELAY;
        }
        else if (time > 0 && time < _MIN_TIME_DELAY) {
            this.timeOut = _MIN_TIME_DELAY;
        }
        else {
            this.timeOut = 0;
        }
    }
}

var BcCardType;
(function (BcCardType) {
    BcCardType[BcCardType["none-icon"] = 0] = "none-icon";
    BcCardType[BcCardType["icon"] = 1] = "icon";
    BcCardType[BcCardType["small"] = 2] = "small";
    BcCardType[BcCardType["small-img"] = 3] = "small-img";
})(BcCardType || (BcCardType = {}));
var BcCardProductSizeFont;
(function (BcCardProductSizeFont) {
    BcCardProductSizeFont[BcCardProductSizeFont["normal"] = 0] = "normal";
    BcCardProductSizeFont[BcCardProductSizeFont["medium"] = 1] = "medium";
    BcCardProductSizeFont[BcCardProductSizeFont["large"] = 2] = "large";
})(BcCardProductSizeFont || (BcCardProductSizeFont = {}));

const CARD_CLASS = `${BcCommonConstants.PREFIX_LIB}-card`;
const CARD_MAIN_CLASS = `${CARD_CLASS}-product`;
const CARD_ICON_LEADING_ICON_CLASS = `${CARD_MAIN_CLASS}-icon`;
const CARD_ICON_LEADING_IMG_CLASS = `${CARD_MAIN_CLASS}-img`;
const CARD_BODY_CLASS = `${CARD_MAIN_CLASS}-body`;
const CARD_HEAD_CLASS = `${CARD_CLASS}-head`;
const CARD_TITTLE_CLASS = `${CARD_CLASS}-tittle`;
const CARD_TITTLE_MEDIUM_CLASS = `${CARD_CLASS}-tittle-medium`;
const CARD_TITTLE_LARGE_CLASS = `${CARD_CLASS}-tittle-large`;
const CARD_TOGGLE_CLASS = `${CARD_CLASS}-toggle`;
const CARD_TOGGLE_ACTIVE_CLASS = `${CARD_CLASS}-toggle-active`;
const CARD_TOGGLE_ACTIVE_DIRECTION_CLASS = 'arrow-direction';
const CARD_SUBTITTLE_CLASS = `${CARD_CLASS}-subtittle`;
const CARD_SUBTITTLE_MEDIUM_CLASS = `${CARD_CLASS}-subtittle-medium`;
const CARD_SUBTITTLE_LARGE_CLASS = `${CARD_CLASS}-subtittle-large`;
const CARD_SUBTITTLE_DESCRIPTION_CLASS = `${CARD_SUBTITTLE_CLASS}-description`;
const CARD_INFO_CLASS = `${CARD_CLASS}-info`;
const CARD_INFO_STATUS_CLASS = `${CARD_INFO_CLASS}-status`;
const CARD_INFO_ICON_CLASS = `${CARD_INFO_STATUS_CLASS}-icon`;
const CARD_INFO_STATUS_LABEL_CLASS = `${CARD_INFO_STATUS_CLASS}-label`;
const CARD_INFO_TITLE_BALANCE_CLASS = `${CARD_INFO_CLASS}-title-balance`;
const CARD_INFO_BALANCE_CLASS = `${CARD_INFO_CLASS}-balance`;
const CARD_INFO_ADITIOAL_TEXT_CLASS = `${CARD_INFO_CLASS}-aditional-text`;
const CARD_SUBTITTLE_DESCRIPTION_MEDIUM_CLASS = `${CARD_SUBTITTLE_CLASS}-description-medium`;
const CARD_SUBTITTLE_DESCRIPTION_LARGE_CLASS = `${CARD_SUBTITTLE_CLASS}-description-large`;
const CARD_STATUSTYPE = `${CARD_CLASS}-statusType`;
const STATUS_CLASS = `${BcCommonConstants.PREFIX_LIB}-status`;
const STATUS_ICON_LEFT_CLASS = `${STATUS_CLASS}-icon-left`;
const STATUS_ICON_RIGHT_CLASS = `${STATUS_CLASS}-icon-right`;

class BcCardProductBehavior extends BcDefaultBehavior {
    constructor() {
        super();
        this.toggleIcon = null;
        this.config = null;
        this.active = false;
        this.cardBody = null;
        this.onceToggleAction = false;
    }
    _setUp() {
        this.getElements();
        this.setEventListeners();
    }
    build() {
        this.isReady = false;
        this.bodySectionBuilder();
        this.cardHeadBuilder();
        this.cardDescriptionsBuilder();
        this.cardInfoContainerBuilder();
        this.cardTitleBalanceBuilder();
        this.cardStausBuilder();
        switch (this.toEnumValue(this.config.cardType)) {
            case BcCardType['small-img']:
                this.imgSectionBuilder();
                break;
            case BcCardType["none-icon"]:
                this.cardBalanceBuilder();
                break;
            case BcCardType.small:
                this.iconSectionBuilder();
                break;
            default:
                this.iconSectionBuilder();
                this.cardBalanceBuilder();
                break;
        }
        this.cardAddtionalText();
        this.isReady = true;
    }
    /**
     * Activa o desactiva el card por medio de un toggle de la clase CARD_TOGGLE_ACTIVE_CLASS
     * @param status es el estado actual del card
     * @memberof BcCardProductBehavior
     */
    setActive(status) {
        this.active = status;
        if (status) {
            replaceClass(this.toggleIcon, CARD_TOGGLE_CLASS, CARD_TOGGLE_ACTIVE_CLASS);
        }
        else {
            replaceClass(this.toggleIcon, CARD_TOGGLE_ACTIVE_CLASS, CARD_TOGGLE_CLASS);
        }
    }
    /**
     * Setea los parámetros de configuración definidos en la interfaz BcCardProductConfig
     * @param {BcCardProductConfig} config
     * @memberof BcCardProductBehavior
     */
    setConfig(config) {
        this.config = config;
        this.initConfiguration();
        this.getType();
    }
    /**
     * Obtiene la configuración del card product incluyendo: tipo, subtítulo, estado, texto, etc.
     * @return la configuración
     * @memberof BcCardProductBehavior
     */
    getConfig() {
        this.getType();
        this.getIconConfig();
        this.getSutittleConfig();
        this.getTitleBalanceConfig();
        this.getStatusConfig();
        this.getBalanceConfig();
        this.getAdditionalTextConfig();
        if (this.toggleIcon) {
            this.config.icon = this.toggleIcon;
        }
        return this.config;
    }
    initConfiguration() {
        if (!this.config) {
            this.config = {
                value: new Date().getMilliseconds(),
                cardType: BcCardType["none-icon"],
                tittle: this.getCardTittle(),
            };
        }
    }
    getElements() {
        this.getToggle();
        this.getCardBody();
    }
    getCardTittle() {
        const tittle = this.mySelf.querySelector(`*[class~='${CARD_TITTLE_CLASS}']`);
        if (tittle) {
            return tittle.innerHTML;
        }
        return "";
    }
    getCardBody() {
        const bodyContainer = this.mySelf.querySelector(`*[class~='${CARD_BODY_CLASS}']`);
        if (bodyContainer) {
            this.cardBody = bodyContainer;
        }
    }
    getToggle() {
        const toggleIcon = this.mySelf.querySelector(`.${CARD_TOGGLE_CLASS}, .${CARD_TOGGLE_ACTIVE_CLASS}`);
        if (toggleIcon) {
            this.toggleIcon = toggleIcon;
        }
    }
    getType() {
        if (!this.config) {
            this.initConfiguration();
        }
        this.mySelf.classList.forEach(c => {
            const _type = this.toEnumValue(c.replace(`${CARD_CLASS}-`, ''));
            if (_type) {
                this.config.cardType = _type;
            }
        });
    }
    setEventListeners() {
        if (this.toggleIcon && this.toggleAction) {
            const eventClick = (e) => {
                if (this.disabled) {
                    return;
                }
                this.toggleAction(e);
                e.target.setAttribute('listener', 'true');
            };
            if (this.toggleIcon.getAttribute('listener') !== 'true') {
                this.toggleIcon.addEventListener(BcCommonConstants.EVENT_CLICK, eventClick);
                addFocusable(this.toggleIcon, {}, { event: this.toggleAction });
            }
        }
        if (this.clickAction) {
            this.mySelf.addEventListener(BcCommonConstants.EVENT_CLICK, (event) => {
                if (this.disabled) {
                    return;
                }
                this.clickAction(event);
            });
        }
    }
    cardTitleBalanceBuilder() {
        if (this.config.titleBalance) {
            this.infoDivAppend(createElement({
                element: BcCommonConstants.P_TAG,
                classList: [CARD_INFO_TITLE_BALANCE_CLASS],
                innerText: this.config.titleBalance,
            }));
        }
    }
    cardAddtionalText() {
        if (this.config.additionalText) {
            this.infoDivAppend(createElement({
                element: BcCommonConstants.P_TAG,
                classList: [CARD_INFO_ADITIOAL_TEXT_CLASS],
                innerText: this.config.additionalText,
            }));
        }
    }
    cardBalanceBuilder() {
        this.infoDivAppend(createElement({
            element: BcCommonConstants.H6_TAG,
            classList: [CARD_INFO_BALANCE_CLASS],
            innerText: this.config.balance,
        }));
    }
    cardStausBuilder() {
        if (this.config.statusComponentClassList) {
            let elementsStatus;
            if (this.config.statusComponentIcon && this.config.statusComponentClassList.includes(STATUS_ICON_LEFT_CLASS)) {
                elementsStatus = [
                    createElement({
                        element: BcCommonConstants.I_TAG,
                        classList: [BcCommonConstants.ICONS_CLASS, BcCommonConstants.ICON_SM_CLASS],
                        innerText: this.config.statusComponentIcon
                    }),
                    createElement({
                        element: BcCommonConstants.SPAN_TAG,
                        innerText: this.config.statusComponentText
                    }),
                ];
            }
            else if (this.config.statusComponentIcon && this.config.statusComponentClassList.includes(STATUS_ICON_RIGHT_CLASS)) {
                elementsStatus = [
                    createElement({
                        element: BcCommonConstants.SPAN_TAG,
                        innerText: this.config.statusComponentText
                    }),
                    createElement({
                        element: BcCommonConstants.I_TAG,
                        classList: [BcCommonConstants.ICONS_CLASS, BcCommonConstants.ICON_SM_CLASS],
                        innerText: this.config.statusComponentIcon
                    }),
                ];
            }
            else {
                elementsStatus = [
                    createElement({
                        element: BcCommonConstants.SPAN_TAG,
                        innerText: this.config.statusComponentText
                    })
                ];
            }
            const status = createElement({
                element: BcCommonConstants.DIV_TAG,
                classList: [...this.config.statusComponentClassList],
                children: elementsStatus
            });
            this.infoDivAppend(status);
        }
    }
    infoDivAppend(element) {
        const infoDIv = this.cardBody.querySelector(`*[class~='${CARD_INFO_CLASS}']`);
        if (infoDIv) {
            infoDIv.appendChild(element);
        }
    }
    cardInfoContainerBuilder() {
        const divInfo = createElement({
            element: BcCommonConstants.DIV_TAG,
            classList: [CARD_INFO_CLASS],
        });
        if (this.cardBody) {
            this.cardBody.appendChild(divInfo);
        }
    }
    cardDescriptionsBuilder() {
        const bodyContainer = this.mySelf.querySelector(`*[class~='${CARD_BODY_CLASS}']`);
        const subTitleClass = this.getSizeClass().subtittleClass;
        const subTitleDescriptionClass = this.getSizeClass().subtittleDescriptionClass;
        if (bodyContainer) {
            const subtittle = createElement({
                element: BcCommonConstants.P_TAG,
                classList: [subTitleClass],
            });
            const subtittleDescription = createElement({
                element: BcCommonConstants.P_TAG,
                classList: [subTitleDescriptionClass],
            });
            const details = this.config.subtittle;
            if (details) {
                if (typeof details === "string") {
                    subtittle.innerText = details;
                }
                else {
                    subtittle.innerText = details[0];
                    subtittleDescription.innerText = details[1];
                }
                bodyContainer.appendChild(subtittle);
                bodyContainer.appendChild(subtittleDescription);
            }
        }
    }
    getSizeClass() {
        const size = { titleClass: CARD_TITTLE_CLASS, subtittleClass: CARD_SUBTITTLE_CLASS, subtittleDescriptionClass: CARD_SUBTITTLE_DESCRIPTION_CLASS };
        switch (this.config.size) {
            case BcCardProductSizeFont.normal:
                size.titleClass = CARD_TITTLE_CLASS;
                size.subtittleClass = CARD_SUBTITTLE_CLASS;
                size.subtittleDescriptionClass = CARD_SUBTITTLE_DESCRIPTION_CLASS;
                break;
            case BcCardProductSizeFont.medium:
                size.titleClass = CARD_TITTLE_MEDIUM_CLASS;
                size.subtittleClass = CARD_SUBTITTLE_MEDIUM_CLASS;
                size.subtittleDescriptionClass = CARD_SUBTITTLE_DESCRIPTION_MEDIUM_CLASS;
                break;
            case BcCardProductSizeFont.large:
                size.titleClass = CARD_TITTLE_LARGE_CLASS;
                size.subtittleClass = CARD_SUBTITTLE_LARGE_CLASS;
                size.subtittleDescriptionClass = CARD_SUBTITTLE_DESCRIPTION_LARGE_CLASS;
                break;
            default:
                size.titleClass = CARD_TITTLE_CLASS;
                size.subtittleClass = CARD_SUBTITTLE_CLASS;
                size.subtittleDescriptionClass = CARD_SUBTITTLE_DESCRIPTION_CLASS;
        }
        return size;
    }
    cardHeadBuilder() {
        const titleClass = this.getSizeClass().titleClass;
        if (this.cardBody) {
            const head = createElement({
                element: BcCommonConstants.DIV_TAG,
                classList: [CARD_HEAD_CLASS],
                children: [
                    createElement({
                        element: BcCommonConstants.H6_TAG,
                        classList: [titleClass],
                        innerText: this.config.tittle,
                    }),
                ]
            });
            const toggle = this.config.toggleIcon || createElement({
                element: BcCommonConstants.EM_TAG,
                classList: [
                    this.active ?
                        CARD_TOGGLE_ACTIVE_CLASS :
                        CARD_TOGGLE_CLASS,
                    BcCommonConstants.ICONS_CLASS,
                    CARD_TOGGLE_ACTIVE_DIRECTION_CLASS
                ],
                props: {
                    'aria-hidden': 'true',
                },
            });
            this.toggleIcon = toggle;
            head.appendChild(toggle);
            this.cardBody.appendChild(head);
        }
    }
    iconSectionBuilder() {
        const iconSection = createElement({
            element: BcCommonConstants.DIV_TAG,
            classList: [CARD_ICON_LEADING_ICON_CLASS],
            children: [
                createElement({
                    element: BcCommonConstants.EM_TAG,
                    classList: [BcCommonConstants.ICONS_CLASS, BcCommonConstants.ICON_XL_CLASS],
                    props: {
                        'aria-hidden': 'true',
                    },
                    innerText: this.config.icon || 'e-card'
                })
            ]
        });
        this.mySelf.prepend(iconSection);
    }
    imgSectionBuilder() {
        const imgSection = createElement({
            element: BcCommonConstants.DIV_TAG,
            classList: [CARD_ICON_LEADING_IMG_CLASS],
            children: [
                createElement({
                    element: BcCommonConstants.IMG_TAG,
                    classList: [BcCommonConstants.ICONS_CLASS],
                    props: {
                        'alt': this.config.icon,
                        'src': `/assets/icons/${this.config.typeIcon}/${this.config.icon}.svg`
                    },
                })
            ]
        });
        this.mySelf.prepend(imgSection);
    }
    bodySectionBuilder() {
        const bodyContainer = createElement({
            element: BcCommonConstants.DIV_TAG,
            classList: [CARD_BODY_CLASS],
        });
        this.mySelf.appendChild(bodyContainer);
        this.getCardBody();
    }
    toEnumValue(enumValue) {
        if (typeof enumValue === 'string') {
            const enumType = enumValue;
            return BcCardType[enumType];
        }
        return enumValue;
    }
    getIconConfig() {
        let iconClass = CARD_ICON_LEADING_ICON_CLASS;
        if (this.config.cardType === BcCardType["small-img"]) {
            iconClass = CARD_ICON_LEADING_IMG_CLASS;
        }
        const icon = this.mySelf.querySelector(`div.${iconClass} > em`);
        if (icon) {
            this.config.icon = icon;
        }
    }
    getSutittleConfig() {
        const subtittle = this.cardBody.querySelector(`*[class~='${CARD_SUBTITTLE_CLASS}']`);
        const subtittleDescription = this.cardBody.querySelector(`*[class~='${CARD_SUBTITTLE_DESCRIPTION_CLASS}']`);
        if (subtittle) {
            this.config.subtittle = subtittle.innerHTML;
            if (subtittleDescription) {
                this.config.subtittle = [subtittle.innerHTML, subtittleDescription.innerHTML];
            }
        }
    }
    getStatusConfig() {
        const statusDiv = this.cardBody.querySelector(`${BcCommonConstants.DIV_TAG}.${STATUS_CLASS}`);
        if (statusDiv) {
            const list = statusDiv.classList.value;
            this.config.statusComponentClassList = list.split(" ");
            const statusText = statusDiv.querySelector(BcCommonConstants.SPAN_TAG);
            if (statusText) {
                this.config.statusComponentText = statusText.innerHTML;
            }
            const statusIcon = statusDiv.querySelector(`.${BcCommonConstants.ICONS_CLASS}`);
            if (statusIcon) {
                this.config.statusComponentIcon = statusIcon.innerHTML;
            }
        }
    }
    getBalanceConfig() {
        const balance = this.cardBody.querySelector(`*[class~='${CARD_INFO_BALANCE_CLASS}']`);
        if (balance) {
            this.config.balance = balance.innerHTML;
        }
    }
    getTitleBalanceConfig() {
        const titleBalance = this.cardBody.querySelector(`*[class~='${CARD_INFO_TITLE_BALANCE_CLASS}']`);
        if (titleBalance) {
            this.config.titleBalance = titleBalance.innerHTML;
        }
    }
    getAdditionalTextConfig() {
        const additionalText = this.cardBody.querySelector(`*[class~='${CARD_INFO_ADITIOAL_TEXT_CLASS}']`);
        if (additionalText) {
            this.config.additionalText = additionalText.innerHTML;
        }
    }
}

class BcCardSelectBehavior extends BcAbstractDropdownBehavior {
    constructor() {
        super();
        /** Variable para activar el elemento
         * @memberof BcCardSelectBehavior */
        this.activeElement = null;
        /** Comportamiento del componente
         * @memberof BcCardSelectBehavior */
        this.bcCardProductBehavior = null;
        /** Una plantilla de cadena.
          * @memberof BcCardSelectBehavior */
        this.selectedItemsDisplay = '{0} ítems seleccionados';
        /** Creando una nueva instancia de la clase BcInputBehavior.
          * @memberof BcCardSelectBehavior */
        this.bcInputBehavior = new BcInputBehavior();
        /** Asignando el valor de la constante N0 a la variable oldValue.
          * @memberof BcCardSelectBehavior */
        this.oldValue = COMMON_CONSTANTS_NUMBERS.N0;
        /** Variable que almacena información
          * @memberof BcCardSelectBehavior */
        this.newValue = COMMON_CONSTANTS_NUMBERS.N0;
        this.createItemsFlag = true;
    }
    _setUp() {
        this.setDropDownConfiguration();
        this.getDropdownContent();
        super._setUp();
        this.bcInputBehavior.setElement(this.mySelf.querySelector('input'));
        this.bcInputBehavior.setUp();
        this.getInsideElements();
        this.setMarginTop();
        this.setupPlaceHolder();
        if (this.createItemsFlag) {
            this.createItems();
        }
        this.setEventListeners();
        this.markItemByIndex(this.defaultIndex);
        this.setupAccessibility();
        this.setEventClickOutside();
        this.setResponsive();
        this.emitEvent = () => {
            this.setPositionFixedContentBody();
        };
    }
    /**
     * Activa o desactiva el input y el card según el parámetro status sea true o false
     * @param status booleano que especifica si se quiere habilitar o deshabilitar
     * @memberof BcCardSelectBehavior
     */
    setDisable(status) {
        const controlContent = this.mySelf.querySelector((`*[class~='${CARD_SELECT_CONTROL_CLASS}']`));
        if (status) {
            this.closeDropdown();
            controlContent.classList.add(CARD_SELECT_CONTROL_DISABLED_CLASS);
        }
        else {
            controlContent.classList.remove(CARD_SELECT_CONTROL_DISABLED_CLASS);
        }
    }
    /**
      * Carga los items del dropdown a partir del objeto itemsConfig del tipo BcCardProductConfig
      * @memberof BcCardSelectBehavior
      */
    createItems() {
        if (this.itemsConfig && this.itemsConfig.length) {
            this.dropdownItems = [];
            this.itemsConfig.forEach((itemObj, i) => {
                const li = this.createCardItem(itemObj);
                this.dropdownItems[i] = li;
            });
            const bodyContent = this.dropdownContent.querySelector((`*[class~='${CARD_SELECT_DROPDOWN_BODY_CLASS}']`));
            bodyContent.innerHTML = '';
            bodyContent.appendChild(createElement({
                element: BcCommonConstants.UL_TAG,
                classList: ["bc-mt-1"],
                children: this.dropdownItems
            }));
        }
    }
    /**
     * Setea el objeto itemsConfig con el parámetro items
     * @param items es un array de tipo BcCardProductConfig que contiene los items del dropdown
     * @memberof BcCardSelectBehavior
     */
    setItems(items, sizeFont) {
        this.sizeFont = sizeFont;
        this.cleanItems();
        this.itemsConfig = items;
        if (this.itemsConfig) {
            this.itemsConfig.forEach(value => {
                value.size = sizeFont;
            });
        }
    }
    /**
     * Agrega un margin top de -25
     * @memberof BcCardSelectBehavior
     */
    setMarginTop() {
        if (this.span) {
            this.topMarginContent = -25;
        }
    }
    /**
     * "Si enumValue es una cadena, devuelva enumValue como una clave de tipo de BcCard ProductSizeFont;
     * de lo contrario, devuelva enumValue".
     * @param enumValue - El valor de enumeración para convertir en una cadena.
     * @returns El valor de enumeración.
     */
    toEnumValue(enumValue) {
        if (typeof enumValue === 'string') {
            const enumType = enumValue;
            return BcCardProductSizeFont[enumType];
        }
        return enumValue;
    }
    /**
     * Retorna la clase del tamaño del placeholder
     * @memberof BcCardSelectBehavior
   */
    getPlaceHolderClass() {
        let classPlaceHolder;
        switch (this.toEnumValue(this.sizeFont)) {
            case BcCardProductSizeFont.normal:
                classPlaceHolder = CARD_SELECT_PLACEHOLDER_CLASS;
                break;
            case BcCardProductSizeFont.medium:
                classPlaceHolder = CARD_SELECT_PLACEHOLDER_MEDIUM_CLASS;
                break;
            case BcCardProductSizeFont.large:
                classPlaceHolder = CARD_SELECT_PLACEHOLDER_LARGE_CLASS;
                break;
            default:
                classPlaceHolder = CARD_SELECT_PLACEHOLDER_CLASS;
                break;
        }
        return classPlaceHolder;
    }
    /**
     * Crea el placeholder del card select
     * @memberof BcCardSelectBehavior
   */
    setupPlaceHolder() {
        const classPlaceHolder = this.getPlaceHolderClass();
        this.cardSelectInput = this.mySelf.querySelector(`.${CARD_SELECT_INPUT_CLASS}`);
        if (this.cardSelectInput) {
            this.selectControl = this.mySelf.querySelector(`.${CARD_SELECT_CONTROL_CLASS}`);
            const label = this.cardSelectInput.querySelector("label");
            this.placeHolder = document.createElement("label");
            this.placeHolder.innerHTML = label.innerHTML;
            const placeHolder = this.getFirstElementByClassName(CARD_SELECT_PLACEHOLDER_CLASS);
            const placeHolderMedium = this.getFirstElementByClassName(CARD_SELECT_PLACEHOLDER_MEDIUM_CLASS);
            const placeHolderLarge = this.getFirstElementByClassName(CARD_SELECT_PLACEHOLDER_LARGE_CLASS);
            if (!placeHolder && !placeHolderMedium && !placeHolderLarge) {
                this.placeHolder.classList.add(`${CARD_SELECT_SUBTITLE_CLASS}`, `${classPlaceHolder}`);
                this.setupSelectControlAccesibility(false);
                this.cardSelectInput.parentNode.insertBefore(this.placeHolder, this.cardSelectInput.nextSibling || null);
                this.cardSelectInput.style.display = 'none';
            }
            window.addEventListener(_DROPDOWN_OPENED_EVENT, (data) => {
                this.setupSelectControlAccesibility(true);
                this.showPlaceHolder(data, false);
            });
            window.addEventListener(_DROPDOWN_CLOSED_EVENT, (data) => {
                this.setupSelectControlAccesibility(false);
                this.showPlaceHolder(data);
                this.setupDropDownAccessibility();
                this.setupCardAccessibility();
            });
        }
    }
    /**
     * Configuración de accesiblidad
     * @memberof BcCardSelectBehavior
    */
    setupAccessibility() {
        const dropdownFooter = this.dropdownContent.querySelector(`*[class~='${CARD_SELECT_DROPDOWN_FOOTER_CLASS}']`);
        addFocusable(dropdownFooter, { "role": "button", "tabindex": "0" });
        const dropdownBody = this.dropdownContent.querySelector(`*[class~='${CARD_SELECT_DROPDOWN_BODY_CLASS}']`);
        const cardsInfo = dropdownBody.querySelectorAll(`.${CARD_SELECT_INFO_CLASS}`);
        cardsInfo?.forEach((item) => {
            if (item.innerHTML.length > 0) {
                const ariaLabel = `Saldo de cuenta: ${item.innerHTML.replace('$', '')} pesos colombianos`;
                item.setAttribute('aria-label', ariaLabel);
            }
        });
        this.setupBodyAccessibility();
        this.setupCardAccessibility();
        this.setupDropDownAccessibility();
    }
    /**
     * Configuración de accesiblidad a los items para navegar con flechas del teclado
     * @memberof BcCardSelectBehavior
    */
    setupBodyAccessibility() {
        const dropdownBody = this.dropdownContent.querySelector(`*[class~='${CARD_SELECT_DROPDOWN_BODY_CLASS}']`);
        dropdownBody.addEventListener(BcCommonConstants.EVENT_KEY_DOWN, (event) => {
            this.processKeyDown(event, dropdownBody);
        });
    }
    /**
     * Configuración de accesiblidad a los items para navegar con flechas del teclado
     * @memberof BcCardSelectBehavior
    */
    processKeyDown(event, dropdownBody) {
        const currentItem = dropdownBody.querySelector(`li.${CARD_SELECT_OUTLINE_ELEMENT}`);
        let nextItem;
        if (currentItem) {
            if (event.key === BcCommonConstants.KEY_EVENT_ARROW_UP || event.key === BcCommonConstants.KEY_EVENT_ARROW_DOWN) {
                nextItem = this.processArrowUp(event, nextItem, currentItem);
                if (nextItem) {
                    this.focusNextItem(currentItem, nextItem);
                }
            }
            else if (event.key === BcCommonConstants.KEY_EVENT_END || event.key === BcCommonConstants.KEY_EVENT_HOME) {
                const items = dropdownBody.querySelectorAll(`.${CARD_SELECT_DROPDOWN_ITEM_CLASS}`);
                nextItem = this.processArrowEnd(event, nextItem, items);
                if (nextItem) {
                    this.focusNextItem(currentItem, nextItem);
                }
            }
        }
    }
    /**
     * Si el usuario presiona la tecla Finalizar, el siguiente elemento es el último elemento de la
     * lista. De lo contrario, el siguiente elemento es el primero de la lista.
     * @param {any} event - el evento que activó la función
     * @param {any} nextItem - el siguiente elemento a seleccionar
     * @param {any} items - la matriz de elementos que desea recorrer en iteración
     * @returns Se devuelve el nextItem.
     */
    processArrowEnd(event, nextItem, items) {
        if (event.key === BcCommonConstants.KEY_EVENT_END) {
            nextItem = items[items.length - 1];
        }
        else {
            nextItem = items[0];
        }
        return nextItem;
    }
    /**
     * "Si el evento es una flecha hacia arriba, entonces el elemento siguiente es el elemento anterior,
     * de lo contrario, es el elemento siguiente".
     * @param {any} event - any - el evento que se activó
     * @param {any} nextItem - cualquiera, elemento actual: HTMLElement
     * @param {HTMLElement} currentItem - HTMLElement: el elemento actual que está seleccionado
     * @returns Se devuelve el nextItem.
     */
    processArrowUp(event, nextItem, currentItem) {
        if (event.key === BcCommonConstants.KEY_EVENT_ARROW_UP) {
            nextItem = currentItem.previousElementSibling;
        }
        else {
            nextItem = currentItem.nextElementSibling;
        }
        return nextItem;
    }
    /**
     * Configura accesiblidad del card cuando esta o no seleccionado
     * @memberof BcCardSelectBehavior
    */
    setupCardAccessibility() {
        if (this.activeElement) {
            this.selectControl.removeAttribute("tabindex");
            addFocusable(this.mySelf, { tabindex: '0' });
        }
        else {
            this.mySelf.removeAttribute("tabindex");
            addFocusable(this.selectControl, { tabindex: '0' });
        }
    }
    /**
     * Configura accesiblidad para el selectControl
     * @memberof BcCardSelectBehavior
    */
    setupSelectControlAccesibility(expanded) {
        this.selectControl.setAttribute("aria-label", `${this.placeHolder?.innerHTML}, menú desplegable, ${expanded ? 'Expandido' : 'Contraido'}`);
    }
    /**
     * Configura accesiblidad del arrow el dropdown
     * @memberof BcCardSelectBehavior
    */
    setupDropDownAccessibility() {
        const dropDown = this.mySelf.querySelector(`em.${"arrow-direction"}`);
        addFocusable(dropDown, { tabindex: "0" });
        dropDown?.setAttribute("aria-label", `Cambiar producto, menú desplegable`);
    }
    /**
      * Remueve el foco del item actual y lo agrega al siguiente
      * @memberof BcCardSelectBehavior
    */
    focusNextItem(currentItem, nextItem) {
        currentItem.classList.remove(`${CARD_SELECT_OUTLINE_ELEMENT}`);
        nextItem.classList.add(`${CARD_SELECT_OUTLINE_ELEMENT}`);
        nextItem.focus();
    }
    /**
       * Metodo que se encarga de mostrar u ocultar el placeholder
       * @param dropDownId id del dropdown
       * @param show oculta o muestra el placeholder
       * @memberof BcCardSelectBehavior
    */
    showPlaceHolder(dropDownId, show = true) {
        const dropDown = this.mySelf.querySelector(`[aria-controls="${dropDownId.detail}"]`);
        if (dropDown) {
            const selectedCard = this.mySelf.querySelector(`.${CARD_SELECT_ACTIVE_ITEM_CLASS}`);
            if (!selectedCard) {
                if (!show) {
                    this.cardSelectInput.style.display = BcCommonConstants.BLOCK;
                    this.placeHolder.style.display = BcCommonConstants.NONE;
                    if (this.input) {
                        this.input.focus();
                    }
                }
                else {
                    this.cardSelectInput.style.display = BcCommonConstants.NONE;
                    this.placeHolder.style.display = BcCommonConstants.BLOCK;
                }
            }
            else {
                this.showSelectedCard(selectedCard, show);
            }
        }
    }
    /**
       * Metodo que se encarga de mostrar u ocultar el card seleccionado
       * @param show ocultar o mostrar el selectcard
       * @param selectedCard elemento del card seleccionado
       * @memberof BcCardSelectBehavior
    */
    showSelectedCard(selectedCard, show = true) {
        this.cardSelectInput.style.display = BcCommonConstants.BLOCK;
        if (!show) {
            this.selectControl.style.display = BcCommonConstants.FLEX;
            this.placeHolder.style.display = BcCommonConstants.NONE;
            selectedCard.style.display = BcCommonConstants.NONE;
            if (this.input) {
                this.input.focus();
            }
        }
        else {
            this.selectControl.style.display = BcCommonConstants.NONE;
            const activeSelectedCard = this.validateShow(selectedCard);
            if (activeSelectedCard) {
                selectedCard.style.display = BcCommonConstants.BLOCK;
            }
        }
    }
    /**
       * Metodo realiza validaciones para evitar que se muestre el selectedCard si estan desplegados aun los items
       * @param selectedCard elemento del card seleccionado
       * @memberof BcCardSelectBehavior
       * @returns Esta activo o no el content del dropdown.
    */
    validateShow(selectedCard) {
        const contentActive = document.getElementsByClassName(CARD_SELECT_DROPDOWN_ACTIVE_CLASS).item(0);
        if (contentActive) {
            if (selectedCard && this.selectControl.style.display == BcCommonConstants.NONE) {
                this.showSelectedCard(selectedCard, false);
                return false;
            }
        }
        else {
            return true;
        }
    }
    /**
     * Setea los items seleccionados, siempre y cuando existan
     * @param displayInfo son los items seleccionados del dropdown
     * @memberof BcCardSelectBehavior
     */
    setSelectedItemsDisplay(displayInfo) {
        if (displayInfo) {
            this.selectedItemsDisplay = displayInfo;
        }
    }
    /**
     * Setea el index seleccionado por default
     * @param index número entero que representa el index del item seleccionado por default
     * @memberof BcCardSelectBehavior
     */
    setDefaultIndex(index) {
        this.defaultIndex = index;
    }
    /**
     * Setea el valor seleccionado por default del dropdown, para ello válida que el parámetro value
     * no sea indefinido y que existan items cargados en el dropdown. finalmente filtra value y lo selecciona.
     * @param value
     * @memberof BcCardSelectBehavior
     */
    setDefaultValue(value) {
        if (typeof value == 'undefined') {
            return;
        }
        if (!this.itemsConfig) {
            return;
        }
        const filtered = this.itemsConfig.find(e => e.value == value);
        if (filtered) {
            const index = this.itemsConfig.indexOf(filtered);
            this.markItemByIndex(index);
            this.defaultIndex = index;
        }
    }
    /**
      * Verifica si el dropdown tiene items cargados, si no es así los carga por medio de getItems.
      * @memberof BcCardSelectBehavior
      */
    getInsideElements() {
        this.input = this.mySelf.querySelector(`${BcCommonConstants.INPUT_TAG}[class=${INPUT}]`);
        if (!this.itemsConfig) {
            this.getItems();
        }
    }
    /**
      * Carga los items del dropdown
      * @memberof BcCardSelectBehavior
      */
    getItems() {
        this.cleanItems();
        const items = Array.from(this.mySelf.querySelectorAll(`*[class=${CARD_SELECT_DROPDOWN_ITEM_CLASS}]`));
        items.forEach((item, i) => {
            const card = this.toCardComponent(item, false);
            this.itemsConfig[i] = card.getConfig();
            this.dropdownItems[i] = item;
        });
    }
    /**
     * Se encarga de realizar la configuración para el comportamiento general heredado del Dropdown
     * @memberof BcCardSelectBehavior
     */
    setDropDownConfiguration() {
        this.setConfig({
            toggleClass: CARD_SELECT_TOGGLE_CLASS,
            toggleActiveClass: CARD_SELECT_ACTIVE_TOGGLE_CLASS,
            contentClass: CARD_SELECT_DROPDOWN_CLASS,
            contentActiveClass: CARD_SELECT_DROPDOWN_ACTIVE_CLASS,
            itemClass: CARD_SELECT_DROPDOWN_ITEM_CLASS,
            triangleClass: CARD_SELECT_DROPDOWN_ITEM_CLASS,
            extraToggles: [
                {
                    node: this.input,
                    events: ['focus'],
                },
            ],
            toggleEvents: ['click', 'input'],
            mainClass: CARD_SELECT_CLASS,
            mainActiveClass: CARD_SELECT_ACTIVE_CLASS,
            static: true,
            isPopUp: false,
            parentWidth: true,
            onlyBottomPosition: true
        });
    }
    /**
      * Es un selector que obtiene el card activo
      * @returns activeElement
      * @memberof BcCardSelectBehavior
      */
    getCurrentActiveItem() {
        if (!this.activeElement) {
            const activeCard = this.mySelf.querySelector(`div[class=${CARD_SELECT_ACTIVE_ITEM_CLASS}]`);
            if (activeCard) {
                const card = this.toCardComponent(activeCard, true);
                this.setActiveItem(card);
            }
        }
        return this.activeElement;
    }
    /**
     * Asigna el tipo de formato, siempre que sea simple o full
     * @param {string} formatType
     * @memberof BcCardSelectBehavior
     */
    setFormatOutput(formatType) {
        if (formatType && (formatType === 'simple' || formatType === 'full')) {
            this.formatType = formatType;
        }
    }
    /**
     * Si el índice está definido, la matriz dropdownItems tiene más que el índice, el índice es mayor o
     * igual a 0 y la matriz de elementos tiene más de 0 elementos, luego agregue la clase a la entrada y
     * envíe el evento.
     * @param {number} index - número - el índice del elemento a seleccionar
     */
    markItemByIndex(index) {
        const items = this.mySelf.querySelectorAll((`li[class~='${CARD_SELECT_DROPDOWN_ITEM_CLASS}']`));
        if (index !== undefined && this.dropdownItems.length > index && index >= 0 && items.length > 0) {
            this.bcInputBehavior.addRemoveClass(true, this.mySelf.querySelector('input'));
            this.dropdownItems[String(index)].dispatchEvent(new Event(BcCommonConstants.EVENT_CLICK, {}));
        }
    }
    /**
     * Elimina el elemento seleccionado de la lista desplegable, muestra el elemento seleccionado en el
     * campo de entrada, cierra el menú desplegable, muestra todos los elementos en el menú desplegable,
     * elimina el filtro, establece el elemento activo y ordena los elementos desplegables.
     * @param event - el evento que activó la función
     * @param i - índice del elemento en la matriz
     * @param item - el elemento que se seleccionó
     * @returns el elemento que se seleccionó.
     */
    configSelectedEvent(event, i, item) {
        if (this.disabled) {
            return;
        }
        this.removeSelectedItem(item);
        this.showSelectedItem(item);
        this.closeDropdown();
        this.showAllItems();
        this.removeFilter();
        this.activeElement = this.itemsConfig[i];
        if (this.outputFunction) {
            this.outputFunction(this.itemsConfig[i]);
        }
        this.sortDropdownItems();
    }
    /**
     * Posiciona el card seleccionado en el index 0
     * @memberof BcCardSelectBehavior
     */
    sortDropdownItems() {
        const dropdownBody = this.dropdownContent.querySelector(`*[class~='${CARD_SELECT_DROPDOWN_BODY_CLASS}']`);
        const ulChild = dropdownBody.firstChild;
        const liChildren = ulChild.childNodes;
        const arrayItems = Array.from(liChildren);
        if (arrayItems.length > 0)
            arrayItems.forEach(function (currentValue, index) {
                if (currentValue['classList'] && currentValue['classList'].contains(CARD_SELECT_SELECTED_ITEM_CLASS)) {
                    arrayItems.unshift(currentValue);
                    arrayItems.splice(index + 1, 1);
                }
            });
        arrayItems.forEach(li => {
            ulChild.appendChild(li);
        });
        this.setPositionFixedContentBody();
    }
    /**
     * Asigna el evento click y el evento key up a los items del dropdown
     * Controla el reposicionamiento y el cierre del dropdown cuando el card-select está dentro de un modal
     * @memberof BcCardSelectBehavior
     */
    setEventListeners() {
        this.dropdownItems.forEach(item => {
            item.addEventListener(BcCommonConstants.EVENT_CLICK, (event) => {
                event.stopPropagation();
                event.preventDefault();
                this.configSelectedEvent(event, this.dropdownItems.indexOf(item), item);
            });
            addFocusable(item, { tabindex: '0' }, { event: this.configSelectedEvent.bind(this, {}, this.dropdownItems.indexOf(item), item) });
        });
        this.mySelf.addEventListener(BcCommonConstants.EVENT_KEY_UP, (event) => {
            this.filterItemsEvent(event);
        });
        window.addEventListener(BcCommonConstants.SCROLL, (event) => {
            const e = event.target;
            this.newValue = e.scrollTop;
            const element = this.dropdownContent.querySelector(`*[class~='${CARD_SELECT_DROPDOWN_BODY_CLASS}']`);
            const typePosition = getComputedStyle(element).position;
            if ((this.oldValue != this.newValue) && e.scrollHeight > CARD_SELECT_SCROLL_MIN && typePosition === 'fixed') {
                this.closeDropdown();
                this.setPositionFixedContentBody();
            }
            this.oldValue = this.newValue;
        }, true);
    }
    /**
     * Evento que reposiciona el content body cuando position es tipo fixed
     * @memberof BcCardSelectBehavior
     */
    setPositionFixedContentBody() {
        if (this.dropdownContent) {
            const contentBody = this.dropdownContent.querySelector(`*[class~='${CARD_SELECT_DROPDOWN_BODY_CLASS}']`);
            const coords = this.mySelf.getBoundingClientRect();
            contentBody['style'].top = coords.top + coords.height - COMMON_CONSTANTS_NUMBERS.N2 + 'px';
        }
    }
    /**
     * Evento que filtra siempre que el input contenga más de tres carácteres
     * @memberof BcCardSelectBehavior
     */
    filterItemsEvent(event) {
        if (typeof event.target.value === "string") {
            const value = event.target.value.toUpperCase();
            if (value.length >= CARD_SELECT_MIN_FILTER_CHA) {
                this.filterDropdown();
            }
            else {
                this.showAllItems();
            }
            this.setIconNotData();
        }
    }
    /**
    * Función que filtra el array de entrada en el dropdown
    * @memberof BcCardSelectBehavior
    */
    filterDropdown() {
        const valueInput = this.getFirstElementByClassName(CARD_SELECT_INPUT)['value'].toUpperCase();
        if (this.input) {
            this.input.value = this.getFirstElementByClassName(CARD_SELECT_INPUT)['value'];
        }
        if (valueInput.length >= CARD_SELECT_MIN_FILTER_CHA) {
            this.restoreFilters();
            let itemsFound = false;
            this.itemsConfig.forEach((config, i) => {
                let thisString = Object.values(config).map(el => typeof el === "string" ? el.toUpperCase() : '').join();
                const subTitle = config.subtittle.toString().toUpperCase();
                thisString = `${thisString},${subTitle}`;
                if (thisString.indexOf(valueInput) >= 0) {
                    itemsFound = true;
                    this.dropdownItems[i].classList.add(CARD_SELECT_DROPDOWN_FILTERED_ITEMS_CLASS);
                }
            });
            if (itemsFound) {
                this.openDrowndown();
            }
        }
        else {
            this.showAllItems();
        }
    }
    /**
     * Retorna el valor del input del card select
     * @memberof BcCardSelectBehavior
     */
    returnValueInput() {
        return this.getFirstElementByClassName(CARD_SELECT_INPUT)['value'];
    }
    /**
     * Devuelve el primer elemento con el nombre de la clase pasado como parámetro.
     * @param className - El nombre de clase del elemento que desea obtener.
     * @returns El primer elemento con el nombre de la clase.
     */
    getFirstElementByClassName(className) {
        const elements = this.mySelf.getElementsByClassName(className);
        let node = null;
        if (elements.length > 0) {
            node = elements[0];
        }
        return node;
    }
    /**
     * Cambia la clase "card-select-dropdown-filtraable-items" del elemento con el id
     * "card-select-dropdown-content".
     */
    showAllItems() {
        this.dropdownContent.classList.remove(CARD_SELECT_DROPDOWN_FILTRABLE_ITEMS_CLASS);
    }
    /**
     * Si el contenido desplegable existe, agregue CARD_SELECT_DROPDOWN_FILTRABLE_ITEMS_CLASS al
     * contenido desplegable y elimine CARD_SELECT_DROPDOWN_FILTERED_ITEMS_CLASS de cada elemento
     * desplegable.
     */
    restoreFilters() {
        if (this.dropdownContent) {
            this.dropdownContent.classList.add(CARD_SELECT_DROPDOWN_FILTRABLE_ITEMS_CLASS);
            this.dropdownItems.forEach(item => {
                item.classList.remove(CARD_SELECT_DROPDOWN_FILTERED_ITEMS_CLASS);
            });
        }
    }
    /**
     * Elimina la clase responsable del estilo del elemento seleccionado.
     */
    removeItemsSelection() {
        if (this.dropdownItems) {
            this.dropdownItems.forEach(item => {
                item.classList.remove(CARD_SELECT_SELECTED_ITEM_CLASS);
            });
        }
    }
    /**
     * Si la entrada existe, establezca el valor de la entrada en una cadena vacía.
     */
    removeFilter() {
        if (this.input) {
            this.input.value = '';
        }
    }
    /**
     * Esta función toma un elemento, un booleano y un evento opcional y devuelve un objeto
     * BcCardProductBehavior.
     * @param {Element} element - Elemento - el elemento que contiene la tarjeta
     * @param {boolean} isActive - booleano
     * @param [toggleEvent] - es una función que se pasa desde el componente principal.
     * @returns Un objeto BcCardProductBehavior.
     */
    toCardComponent(element, isActive, toggleEvent) {
        const card = element.querySelector(`div[class~=${CARD_MAIN_CLASS}]`).cloneNode(true);
        const cardItem = new BcCardProductBehavior();
        cardItem.setElement(card);
        if (toggleEvent) {
            cardItem.toggleAction = toggleEvent.bind(this);
        }
        cardItem.setUp();
        cardItem.setActive(isActive);
        return cardItem;
    }
    /**
     * "Si hay un elemento seleccionado, elimínelo, luego elimine la clase seleccionada de la tarjeta,
     * agregue la clase de elemento seleccionada al elemento y establezca el elemento activo en nulo".
     * @param {Element} item - Elemento: el elemento en el que se hizo clic
     */
    removeSelectedItem(item) {
        const selectedItem = this.mySelf.querySelector(`div[class~=${CARD_SELECT_ACTIVE_ITEM_CLASS}]`);
        this.removeItemsSelection();
        if (selectedItem) {
            selectedItem.remove();
        }
        this.mySelf.classList.remove(CARD_SELECT_SELECTED_CLASS);
        item.classList.add(CARD_SELECT_SELECTED_ITEM_CLASS);
        this.setActiveItem(null);
    }
    /**
     * Crea un nuevo componente de tarjeta, lo establece como el elemento activo, agrega una clase al
     * componente de selección de tarjeta y luego antepone un nuevo div al componente de selección de
     * tarjeta que contiene el componente de tarjeta.
     * @param {Element} item - Elemento: el elemento que se mostrará
     */
    showSelectedItem(item) {
        const card = this.toCardComponent(item, true, this.clickToggleEvent);
        this.setActiveItem(card);
        this.mySelf.classList.add(CARD_SELECT_SELECTED_CLASS);
        this.mySelf.prepend(createElement({
            element: BcCommonConstants.DIV_TAG,
            classList: [CARD_SELECT_ACTIVE_ITEM_CLASS],
            children: [
                card.getMySelf(),
            ]
        }));
    }
    /**
     * Cambia la configuración de la card por activado en caso tal que el valor traído sea nulo, en caso contrario, desactivará el elemento
     * @param {BcCardProductBehavior} card - BcCardProductBehavior: esta es la tarjeta en la que se hace
     * clic
     * @returns El valor de retorno es el valor de la última expresión en el cuerpo de la función; o
     * indefinido si la función no tiene declaración de retorno.
     */
    setActiveItem(card) {
        if (card) {
            this.activeElement = card.getConfig();
            this.bcCardProductBehavior = card;
            return;
        }
        this.activeElement = null;
        this.bcCardProductBehavior = null;
    }
    /**
     * Esta función obtiene el contenido del menú desplegable y contiene la configuración de este.
     */
    getDropdownContent() {
        this.getDropdownParent();
        this.getDropdownBody();
        if (this.dropdownButtonConfig) {
            this.getDropdownFooter();
        }
    }
    /**
     * Si el pie de página desplegable existe, agréguele un detector de eventos. Si no existe, créelo y
     * agréguele un detector de eventos.
     * @returns Se devuelve el dropdownFooter.
     */
    getDropdownFooter() {
        let dropdownFooter = this.dropdownContent.querySelector(`*[class~='${CARD_SELECT_DROPDOWN_FOOTER_CLASS}']`);
        if (dropdownFooter) {
            this.addDropdownButtonEventClick(dropdownFooter);
            return;
        }
        dropdownFooter = this.createDropDownFooter();
        this.dropdownContent.appendChild(dropdownFooter);
        this.addDropdownButtonEventClick(dropdownFooter);
    }
    /**
     * Crea el footer hacia el dropdown
     * @returns Un div con una clase card-select-dropdown-footer y un div hijo con una clase
     * card-select-dropdown-footer-item.
     */
    createDropDownFooter() {
        const buttonConfig = this.dropdownButtonConfig;
        const divContent = createElement({
            element: BcCommonConstants.DIV_TAG,
            classList: [CARD_SELECT_DROPDOWN_FOOTER_ITEM_CLASS],
            children: [
                createElement({
                    element: BcCommonConstants.LABEL_TAG,
                    innerText: buttonConfig.text
                }),
                createElement({
                    element: BcCommonConstants.EM_TAG,
                    classList: [BcCommonConstants.ICONS_CLASS, BcCommonConstants.ICON_SM_CLASS],
                    props: {
                        'aria-hidden': 'true'
                    },
                    innerText: buttonConfig.icon
                }),
            ]
        });
        return createElement({
            element: BcCommonConstants.DIV_TAG,
            classList: [CARD_SELECT_DROPDOWN_FOOTER_CLASS],
            children: [divContent]
        });
    }
    /**
     * Si el menú desplegable está filtrado y no hay elementos, o si no hay elementos en el menú
     * desplegable, muestre el icono.
     */
    setIconNotData() {
        const filtrable = this.dropdownContent.classList.contains(CARD_SELECT_DROPDOWN_FILTRABLE_ITEMS_CLASS);
        let countFilteredItems = 0;
        if (this.dropdownItems) {
            this.dropdownItems.forEach(item => {
                if (item.classList.contains(CARD_SELECT_DROPDOWN_FILTERED_ITEMS_CLASS)) {
                    countFilteredItems++;
                }
            });
        }
        if (((filtrable && countFilteredItems === 0) || (this.itemsConfig.length === 0))) {
            this.viewIconNotData(true);
        }
        else {
            this.viewIconNotData(false);
        }
    }
    /**
     * Metodo para determinar el tamañan del view
     * @param value - verdadero o falso
     */
    viewIconNotData(value) {
        const contentNotData = this.mySelf.querySelector(`*[class~='${CARD_SELECT_DROPDOWN_CONTENT_NOTDATA}']`);
        const contentNotDataVisible = this.mySelf.querySelector(`*[class~='${CARD_SELECT_DROPDOWN_CONTENT_VISIBLE}']`);
        if (value && contentNotData) {
            contentNotData.classList.replace(CARD_SELECT_DROPDOWN_CONTENT_NOTDATA, CARD_SELECT_DROPDOWN_CONTENT_VISIBLE);
        }
        else if (!value && contentNotDataVisible) {
            contentNotDataVisible.classList.replace(CARD_SELECT_DROPDOWN_CONTENT_VISIBLE, CARD_SELECT_DROPDOWN_CONTENT_NOTDATA);
        }
    }
    /**
      * Método que se encarga de crear un dropdown sin data
     */
    createDropDownNotdata() {
        const iconNotData = this.mySelf.querySelector(`*[class~='${CARD_SELECT_DROPDOWN_ICON_NOTDATA}']`);
        const notData = createElement({
            element: BcCommonConstants.DIV_TAG,
            classList: [CARD_SELECT_JUSTIFY, CARD_SELECT_DROPDOWN_CONTENT_NOTDATA],
            children: [iconNotData]
        });
        if (!this.mySelf.querySelector(`*[class~='${CARD_SELECT_DROPDOWN_CONTENT_NOTDATA}']`)) {
            this.dropdownContent.appendChild(notData);
            this.setIconNotData();
        }
    }
    /**
     * Esta función agrega un detector de eventos al elemento de pie de página y, cuando se activa el
     * evento, llama a la función de evento que se pasó como parámetro.
     * @param {Element} footerElement - Elemento: el elemento al que se agrega el evento
     */
    addDropdownButtonEventClick(footerElement) {
        footerElement.addEventListener(BcCommonConstants.EVENT_CLICK, (event) => {
            this.dropdownButtonConfig.event(event);
        });
        addFocusable(footerElement, {}, { event: this.dropdownButtonConfig.event });
    }
    /**
     * Si el dropdownBody no existe, créelo y agréguelo al dropdownContent.
     */
    getDropdownBody() {
        const dropdownBody = this.dropdownContent.querySelector(`*[class~='${CARD_SELECT_DROPDOWN_BODY_CLASS}']`);
        if (!dropdownBody) {
            this.dropdownContent.appendChild(createElement({
                element: BcCommonConstants.DIV_TAG,
                classList: [CARD_SELECT_DROPDOWN_BODY_CLASS]
            }));
        }
    }
    /**
     * "Si existe dropdownParent, establezca dropdownContent en dropdownParent; de lo contrario, cree un
     * nuevo dropdownParent y establezca dropdownContent en el nuevo dropdownParent".
     * @returns Se devuelve el dropdownParent.
     */
    getDropdownParent() {
        let dropdownParent = this.mySelf.querySelector(`*[class~='${CARD_SELECT_DROPDOWN_CLASS}']`);
        if (dropdownParent) {
            this.dropdownContent = dropdownParent;
            return;
        }
        const idCardSelect = this.mySelf.getAttribute('id');
        const contentId = `${idCardSelect}-content`;
        dropdownParent = createElement({
            element: BcCommonConstants.DIV_TAG,
            classList: [CARD_SELECT_DROPDOWN_CLASS],
            props: {
                id: contentId,
            },
        });
        this.mySelf.appendChild(dropdownParent);
        this.dropdownContent = dropdownParent;
    }
    /**
     *Almacena la información, luego la actualiza con los elementos seleccionados
     */
    cleanItems() {
        this.itemsConfig = [];
        this.dropdownItems = [];
    }
    /**
     * Crea un elemento de tarjeta, configura el elemento de tarjeta, construye el elemento de tarjeta y
     * devuelve el elemento de tarjeta.
     * @param data - {
     * @returns Un elemento de la lista con una tarjeta dentro.
     */
    createCardItem(data) {
        const cardDiv = createElement({
            element: BcCommonConstants.DIV_TAG,
            classList: [CARD_MAIN_CLASS, `${CARD_CLASS}-${String(data.cardType)}`],
        });
        const cardItem = new BcCardProductBehavior();
        cardItem.setElement(cardDiv);
        cardItem.setConfig(data);
        cardItem.setUp();
        cardItem.build();
        return createElement({
            element: BcCommonConstants.LI_TAG,
            classList: [this.config.itemClass],
            children: [cardItem.getMySelf()]
        });
    }
    /* Es una clase que se utiliza para crear un menú desplegable. */
    setEventClickOutside() {
        document.addEventListener('click', function (e) {
            const element = this.mySelf;
            const parent = this.mySelf.parentNode;
            parent.classList.add(CARD_SELECT_CLASS);
            if (element && !element.contains(e.target)) {
                this.closeDropdown();
            }
        }.bind(this));
    }
    setResponsive() {
        const parent = this.mySelf.parentElement;
        parent.classList.add(CARD_SELECT_SIZE);
    }
}

const INPUT_TOKEN = `${BcCommonConstants.PREFIX_LIB}-input-token`;
const INPUT_TOKEN_CONTAINER = `${BcCommonConstants.PREFIX_LIB}-input-token-container`;
const ALL_INPUTS_VALID = `${BcCommonConstants.PREFIX_LIB}-all-inputs-valid`;
const ALL_INPUTS_ERROR = `${BcCommonConstants.PREFIX_LIB}-all-inputs-error`;
const LABEL_BOTTOM = `${BcCommonConstants.PREFIX_LIB}-label-bottom-token`;
const INPUT_TOKEN_CONTAINER_INITIAL_FOCUS = `${BcCommonConstants.PREFIX_LIB}-input-token-initial-focus`;
const INPUT_TOKEN_CLASS = 'bc-input';
const INPUT_TOKEN_ZERO_ASCII_CODE = 48;
const INPUT_TOKEN_NINE_ASCII_CODE = 57;
const INPUT_TOKEN_ZERO_ASCII_CODE_ALFA = 96;
const INPUT_TOKEN_NINE_ASCII_CODE_ALFA = 105;
const INPUT_TOKEN_BACK_SPACE_ASCII_CODE = 8;
const INPUT_TOKEN_DELETE_ASCII_CODE = 46;
const INPUT_TOKEN_MAX_LENGTH_INPUT = 1;
const INPUT_TOKEN_MESSAGE_NUMBER_INPUTS = 'Ingresa el código de [NUM_INPUTS] digítos';
const INPUT_TOKEN_MESSAGE_REQUIRED = 'Debe completar todos los campos para continuar';
const INPUT_TOKEN_MESSAGE_INPUT = 'Ingresar [NUM] digito, Editar texto';
const INPUT_TOKEN_POSSITION_ARRAY = new Map([
    [1, 'primer'],
    [2, 'segundo'],
    [3, 'tercer'],
    [4, 'cuarto'],
    [5, 'quinto'],
    [6, 'sexto'],
    [7, 'septimo'],
    [8, 'octavo'],
    [9, 'noveno'],
    [10, 'decimo'],
]);

class BcInputTokenBehavior extends BcDefaultBehavior {
    constructor() {
        super();
        this.value = '';
        this.inputStatus = false;
        this.isValid = false;
        this.isUnmasked = false;
        this.showInfoMessage = true;
        this.errorMessage = '';
        this.infoMessage = '';
        this.nextValue = '';
    }
    static setUpAll() {
        const inputElements = Array.from(document.querySelectorAll(`div[class~='${INPUT_TOKEN}']`));
        const elements = [];
        for (const element of inputElements) {
            const bcInputTokenBehavior = new BcInputTokenBehavior();
            bcInputTokenBehavior.setElement(element);
            bcInputTokenBehavior.setUp();
            elements.push(bcInputTokenBehavior);
        }
        return elements;
    }
    getInfoMessage() {
        if (!this.showInfoMessage) {
            return '';
        }
        return (this.infoMessage.length !== 0
            ? this.infoMessage
            : INPUT_TOKEN_MESSAGE_NUMBER_INPUTS)
            .replace("[NUM_INPUTS]", this.numInputs.toString());
    }
    getErrorMessage() {
        return this.errorMessage.length !== 0 ? this.errorMessage : INPUT_TOKEN_MESSAGE_REQUIRED;
    }
    getStatusContainer() {
        const parentContainer = this.mySelf.querySelector(`div[class~='${INPUT_TOKEN_CONTAINER}']`)?.parentElement;
        return parentContainer?.attributes['status']?.value || "";
    }
    removeError() {
        this.mySelf.querySelector(`div[class~='${INPUT_TOKEN_CONTAINER}']`)?.classList.remove(`${ALL_INPUTS_ERROR}`);
        const labelBottom = this.mySelf.querySelector(`label[class~='${LABEL_BOTTOM}']`);
        labelBottom.innerText = this.getInfoMessage();
    }
    putError() {
        this.mySelf.querySelector(`div[class~='${INPUT_TOKEN_CONTAINER}']`)?.classList.add(`${ALL_INPUTS_ERROR}`);
        this.removeValid();
        const labelBottom = this.mySelf.querySelector(`label[class~='${LABEL_BOTTOM}']`);
        labelBottom.innerText = this.getErrorMessage();
    }
    putValid() {
        this.mySelf.querySelector(`div[class~='${INPUT_TOKEN_CONTAINER}']`)?.classList.add(`${ALL_INPUTS_VALID}`);
        this.removeError();
    }
    removeValid() {
        this.mySelf.querySelector(`div[class~='${INPUT_TOKEN_CONTAINER}']`)?.classList.remove(`${ALL_INPUTS_VALID}`);
    }
    removeErrorState() {
        this.status = this.getStatusContainer();
        if (this.status.toLowerCase() === "error") {
            const parentContainer = this.mySelf.querySelector(`div[class~='${INPUT_TOKEN_CONTAINER}']`)?.parentElement;
            parentContainer.setAttribute('status', 'default');
        }
    }
    validateErrorState() {
        const parentContainer = this.mySelf.querySelector(`div[class~='${INPUT_TOKEN_CONTAINER}']`)?.parentElement;
        const parentContainerStatus = parentContainer?.attributes['status']?.value || "";
        if (parentContainerStatus.toLowerCase() === "error") {
            this.putError();
        }
    }
    removeInitialFocusClass() {
        this.mySelf.querySelector(`div[class~='${INPUT_TOKEN_CONTAINER}']`)?.classList.remove(`${INPUT_TOKEN_CONTAINER_INITIAL_FOCUS}`);
    }
    validateInitialFocus() {
        setTimeout(() => {
            const input = this.mySelf.querySelector(`input[id='${this._id}-1']`);
            if (input === document.activeElement) {
                this.removeInitialFocusClass();
            }
        }, 1);
    }
    inputBlur() {
        if (this.inputStatus) {
            this.putValid();
        }
        else {
            const initialFocus = this.mySelf.querySelector(`div[class~='${INPUT_TOKEN_CONTAINER}']`)?.classList.value?.includes(`${INPUT_TOKEN_CONTAINER_INITIAL_FOCUS}`);
            if (!initialFocus) {
                this.putError();
            }
        }
    }
    inputFocus() {
        if (this.mySelf.querySelector(`label[class~='${LABEL_BOTTOM}']`)) {
            this.removeError();
        }
        const initialFocus = this.mySelf.querySelector(`div[class~='${INPUT_TOKEN_CONTAINER}']`)?.classList.value?.includes(`${INPUT_TOKEN_CONTAINER_INITIAL_FOCUS}`);
        if (initialFocus) {
            this.removeInitialFocusClass();
            this.removeErrorState();
        }
    }
    onInput(currentInput, id) {
        const input = currentInput.currentTarget;
        const maxLength = INPUT_TOKEN_MAX_LENGTH_INPUT;
        this.nextValue = '';
        if (input.value.length > maxLength) {
            if (id < this.numInputs) {
                this.nextValue = input.value.slice(1);
            }
            input.value = input.value.slice(0, maxLength);
        }
    }
    validateInputValues() {
        this.controlInputs();
        if (this.inputStatus) {
            this.putValid();
            this.changeValuesEmitEvent();
        }
        else {
            this.removeValid();
        }
        if ((!this.isValid && this.inputStatus) || (this.isValid && !this.inputStatus)) {
            this.isValid = this.inputStatus;
            this.changeStatusEmitEvent();
        }
    }
    getNextAvailable(currentInput) {
        let nextInput = -1;
        const container = this.mySelf.querySelectorAll(`input[id^='${this._id}']`);
        const inputElements = Array.from(container);
        let index = 0;
        while (index < inputElements.length && nextInput < 0) {
            const element = inputElements[index];
            const valueInput = element.value;
            if (valueInput.length === 0 && (index + 1) > currentInput) {
                nextInput = index + 1;
            }
            index++;
        }
        if (nextInput === -1) {
            nextInput = this.numInputs;
        }
        return nextInput;
    }
    validateValueOnNextInput(inputId) {
        if (this.nextValue.length > 0) {
            const input = this.mySelf.querySelector(`input[id='${this._id}-` + inputId + `']`);
            if (this.nextValue.length == 1 && !isNaN(Number(this.nextValue))) {
                input.value = this.nextValue;
                input.classList.add(`bc-filled`);
                this.validateInputValues();
                const pId = this.getNextAvailable(inputId);
                this.findInput(pId).focus();
            }
            this.nextValue = '';
        }
    }
    /**
     * Obtiene el caracter del teclado a partir del código ASCII.
     * Acepta únicamente números 0-9 y controla que el input solo reciva un caracter por campo
     * @param {any} keyEvent evento del teclado
     * @param {number} id identificador del input
     * @memberof BcInputTokenBehavior
     */
    inputkeyup(keyEvent, id) {
        const key = keyEvent.which;
        let pId = id;
        const input = this.mySelf.querySelector(`input[id='${this._id}-` + id + `']`);
        this.findInput(pId).blur();
        pId = this.inputKey(input, key, pId, id);
        const nextInput = this.findInput(pId);
        nextInput.focus();
        if (nextInput.value.length > 0) {
            const temporalValue = nextInput.value;
            nextInput.value = '';
            nextInput.value = temporalValue;
        }
        this.validateInputValues();
        this.validateValueOnNextInput(pId);
    }
    inputKey(input, key, pId, id) {
        if (input.value != null) {
            if (input.value.toString().length === 0 && key === INPUT_TOKEN_BACK_SPACE_ASCII_CODE) {
                pId = id <= 1 ? 1 : id - 1;
                input.classList.remove(`bc-filled`);
            }
            if (key === INPUT_TOKEN_DELETE_ASCII_CODE) {
                input.classList.remove(`bc-filled`);
            }
            if (input.value.toString().length == 1 && this.isValidNumber(key)) {
                pId = this.getNextAvailable(id);
                input.classList.add(`bc-filled`);
            }
        }
        else {
            input.setAttribute('value', '');
        }
        return pId;
    }
    isValidNumber(key) {
        let keyIsNumber = false;
        if ((key >= INPUT_TOKEN_ZERO_ASCII_CODE && key <= INPUT_TOKEN_NINE_ASCII_CODE) ||
            (key >= INPUT_TOKEN_ZERO_ASCII_CODE_ALFA && key <= INPUT_TOKEN_NINE_ASCII_CODE_ALFA)) {
            keyIsNumber = true;
        }
        return keyIsNumber;
    }
    findInput(id) {
        return this.mySelf.querySelector(`input[id='${this._id}-` + id + `']`);
    }
    _setUp() {
        this.validateId();
        this.getElement();
        this.createTokenInputs();
        this.createLabel();
        this.validateErrorState();
        this.validateInitialFocus();
    }
    validateId() {
        if (!this._id) {
            const prefix = 'input-token';
            const array = new Uint32Array(1);
            const randomNumber = window.crypto.getRandomValues(array);
            this._id = `${prefix}.${randomNumber[0]}`;
        }
    }
    setNumInputs(numInputs) {
        this.numInputs = numInputs;
    }
    validateNumbers(event, inputId) {
        const numericPattern = /^[0-9]*$/;
        if (!numericPattern.test(event.key)) {
            event.preventDefault();
        }
        const input = this.mySelf.querySelector(`input[id='${this._id}-` + inputId + `']`);
        const inputFilled = input.classList.value?.includes("bc-filled");
        const allInputsValid = this.mySelf.querySelector(`div[class~='${INPUT_TOKEN_CONTAINER}']`)?.classList.value?.includes(`${ALL_INPUTS_VALID}`);
        const nextId = this.getNextAvailable(inputId);
        if ((inputFilled && (inputId + 1) !== nextId) || allInputsValid) {
            event.preventDefault();
        }
    }
    validateOtherCharacters(event, inputId) {
        if (event.defaultPrevented) {
            return;
        }
        const numericPattern = /^[0-9]*$/;
        if (!numericPattern.test(event.key)) {
            setTimeout(() => {
                const input = this.mySelf.querySelector(`input[id='${this._id}-` + inputId + `']`);
                input.value = input.value.replace(/\D+/g, '');
            }, 0);
        }
    }
    getPositionLabel(index) {
        return INPUT_TOKEN_POSSITION_ARRAY.has(index) ? INPUT_TOKEN_POSSITION_ARRAY.get(index) : '';
    }
    addEventsInput(input, index) {
        input.addEventListener('keyup', (event) => {
            this.inputkeyup(event, index);
        });
        input.addEventListener('blur', () => {
            this.inputBlur();
        });
        input.addEventListener('focus', () => {
            this.inputFocus();
        });
        input.addEventListener('input', (currentInput) => {
            this.onInput(currentInput, index);
        });
        input.addEventListener('keypress', (event) => {
            this.validateNumbers(event, index);
        });
        input.addEventListener('keydown', (event) => {
            this.validateOtherCharacters(event, index);
        });
    }
    createTokenInputs() {
        this.status = this.getStatusContainer();
        for (let i = 1; i <= this.numInputs; i++) {
            const input = document.createElement('input');
            const valor = `^[0-9]$`;
            input.setAttribute('pattern', valor);
            const id = `${this._id}-${i}`;
            input.setAttribute('id', id);
            input.setAttribute('class', INPUT_TOKEN_CLASS);
            input.setAttribute('required', 'true');
            input.setAttribute('placeholder', ' ');
            input.setAttribute('aria-label', INPUT_TOKEN_MESSAGE_INPUT.replace("[NUM]", this.getPositionLabel(i)));
            if (this.isUnmasked) {
                input.setAttribute('type', 'number');
            }
            else {
                input.setAttribute('type', 'password');
            }
            this.addEventsInput(input, i);
            this.mySelf.querySelector(`div[class~='${INPUT_TOKEN_CONTAINER}']`).appendChild(input);
        }
        if (this.status.toLowerCase() === "disabled") {
            this.setDisabledState(true);
        }
        this.initialFocus();
    }
    initialFocus() {
        this.mySelf.querySelector(`input[id='${this._id}-1']`)?.focus();
        this.mySelf.querySelector(`div[class~='${INPUT_TOKEN_CONTAINER}']`)?.classList.add(`${INPUT_TOKEN_CONTAINER_INITIAL_FOCUS}`);
    }
    createLabel() {
        const label = document.createElement('label');
        label.setAttribute('class', 'bc-label-bottom-token');
        label.setAttribute('aria-label', this.getInfoMessage());
        label.innerText = this.getInfoMessage();
        this.mySelf.appendChild(label);
    }
    controlInputs() {
        const container = this.mySelf.querySelectorAll(`input[id^='${this._id}']`);
        let values = '';
        const inputElements = Array.from(container);
        let isValid = false;
        for (let i = 0; i < inputElements.length; i++) {
            const element = inputElements[i];
            const preValid = element.validity;
            values += element.value;
            if (i == 0 && preValid.valid) {
                isValid = true;
            }
            else if (!preValid.valid && isValid) {
                isValid = false;
            }
            else if (preValid.valid && isValid) {
                isValid = true;
            }
            else {
                isValid = false;
            }
        }
        this.value = values;
        this.inputStatus = isValid;
    }
    /**
     * Selector del contenedor de los inputs. Cuenta los inputs y setea ese número en (numInputs) por medio de la función (setNumInputs)
     * @memberof BcInputTokenBehavior
     */
    getElement() {
        const tokenInputContainer = this.mySelf.querySelector(`div[class~='${INPUT_TOKEN_CONTAINER}']`);
        const numInputs = tokenInputContainer.getAttribute('num-inputs');
        this.setNumInputs(parseInt(numInputs));
        const unmasked = tokenInputContainer.getAttribute('unmasked');
        this.isUnmasked = unmasked !== null && unmasked.toLowerCase() === "true" ? true : false;
        const showMsgs = tokenInputContainer.getAttribute('show-info-message');
        this.showInfoMessage = showMsgs !== null && showMsgs.toLowerCase() === "false" ? false : true;
        this.errorMessage = tokenInputContainer.getAttribute('error-message') || '';
        this.infoMessage = tokenInputContainer.getAttribute('info-message') || '';
    }
    /**
     * Actualiza el cambio de estado del valor del input en (outputValue)
     * @memberof BcInputTokenBehavior
     */
    changeValuesEmitEvent() {
        if (this.outputValue) {
            this.outputValue(this.value);
        }
    }
    /**
     * Actualiza el cambio de estado del atributo (isValid) en (outputStatus)
     * @memberof BcInputTokenBehavior
     */
    changeStatusEmitEvent() {
        if (this.outputStatus) {
            this.outputStatus(this.isValid);
        }
    }
    /**
     * Recorre todos los inputs del contenedor y los habilita/deshabilita según el estado de (isDisabled) sea true o false
     * @param {boolean} isDisabled
     * @memberof BcInputTokenBehavior
     */
    setDisabledState(isDisabled) {
        const inputs = Array.from(this.mySelf.querySelectorAll('input'));
        inputs.forEach((input) => {
            input.disabled = isDisabled;
        });
    }
    /**
     * Setea los valores de los inputs del contenedor en (currentInput).
     * Para ello recorre los inputs y actualiza el valor y el estado de cada uno.
     * @param value
     * @memberof BcInputTokenBehavior
     */
    setValue(value) {
        if (value) {
            const splitedValue = value.split('');
            const inputs = Array.from(this.mySelf.querySelectorAll('input'));
            let inputPosition = 0;
            splitedValue.forEach((digit) => {
                const currentInput = inputs[inputPosition];
                currentInput.value = digit;
                inputPosition++;
                if (inputs[inputPosition]) {
                    inputs[inputPosition].focus();
                }
            });
            this.controlInputs();
            if (this.inputStatus) {
                this.putValid();
                this.changeValuesEmitEvent();
            }
            else {
                this.removeValid();
            }
            if ((!this.isValid && this.inputStatus) || (this.isValid && !this.inputStatus)) {
                this.isValid = this.inputStatus;
                this.changeStatusEmitEvent();
            }
        }
    }
}

class BcTotalValueConstants {
}
BcTotalValueConstants.TOTAL_VALUE_CONTAINER_CLASS = `${BcCommonConstants.PREFIX_LIB}-total-value-container`;
BcTotalValueConstants.TOTAL_VALUE = `${BcCommonConstants.PREFIX_LIB}-total-value`;
BcTotalValueConstants.TOTAL_VALUE_ELLIPSIS_CLASS = `${BcCommonConstants.PREFIX_LIB}-total-value-ellipsis`;
BcTotalValueConstants.TOTAL_VALUE_CELL_INFORMATION_CLASS = `${BcCommonConstants.PREFIX_LIB}-total-value-cell-information`;
BcTotalValueConstants.TOTAL_VALUE_CELL_INFORMATION_PRIMARY_CLASS = `${BcTotalValueConstants.TOTAL_VALUE_CELL_INFORMATION_CLASS}-primary`;
BcTotalValueConstants.TOTAL_VALUE_CELL_COMPLEMENTARY_PRIMARY_CLASS = `${BcTotalValueConstants.TOTAL_VALUE}-cell-complementary-primary`;
BcTotalValueConstants.TOTAL_VALUE_BREAKPOINT_XS = 576;
BcTotalValueConstants.TOTAL_VALUE_BREAKPOINT_MD = 768;
BcTotalValueConstants.TOTAL_VALUE_NUMBER_COLUMNS_MOBILE = 2;
BcTotalValueConstants.TOTAL_VALUE_MAX_NUMBER_INFORMATION_COLUMNS = 4;
BcTotalValueConstants.TOTAL_VALUE_MAX_NUMBER_COMPLEMENTARY_COLUMNS = 1;

class BcTotalValueBehavior extends BcDefaultBehavior {
    constructor() {
        super();
    }
    /**
     * Configura todos los elementos en el DOM que posean la clase bc-total-value-container
     * @description Llama el metodo de configuración del objeto del tipo en cuestión. Por tanto este método debe estár implementado
     * en la clase.
     * @returns Listado de elementos de ese tipo en el DOM.
     */
    static setUpAll() {
        const inputElements = Array.from(document.querySelectorAll(`tr[class~='${BcTotalValueConstants.TOTAL_VALUE_CONTAINER_CLASS}']`));
        const elements = [];
        for (const inputElement of inputElements) {
            const bcTotalValueBehavior = new BcTotalValueBehavior();
            bcTotalValueBehavior.setElement(inputElement);
            bcTotalValueBehavior.setUp();
            elements.push(bcTotalValueBehavior);
        }
        return elements;
    }
    /**
     * Realiza toda la configuración del objeto.
     * @returns
     */
    _setUp() {
        this.getElements();
        this.setLabelTooltipText();
        this.addAccessibility();
        this.addTooltipToEllipsisClass();
        BcTooltipBehavior.setUpAll();
        this.removeFocusTooltipToEllipsisClass();
        this.setLastColumnAsDefaultVisibleResponsive();
        this.displayMaxNumColumnsMobile();
        this.hideExtraInformationColumns();
        window.addEventListener(BcCommonConstants.EVENT_RESIZE, () => {
            this.displayMaxNumColumnsMobile();
        });
    }
    /**
     * Se obtienen los elementos base
     *
     * @memberof BcTotalValueBehavior
     */
    getElements() {
        this.totalValueInformationColumns = Array.from(this.mySelf.querySelectorAll(`.${BcTotalValueConstants.TOTAL_VALUE_CELL_INFORMATION_CLASS}`));
        const numExtraColumns = this.totalValueInformationColumns.length - BcTotalValueConstants.TOTAL_VALUE_MAX_NUMBER_INFORMATION_COLUMNS;
        this.numberExtraColumnsAdded = numExtraColumns <= 0 ? 0 : numExtraColumns;
    }
    /**
     * Accesibilidad de foco
     * @memberof BcTotalValueBehavior
     */
    addAccessibility() {
        const element = Array.from(this.mySelf.querySelectorAll(`.${BcTotalValueConstants.TOTAL_VALUE}`));
        for (const content of element) {
            addFocusable(content, { tabindex: '0' });
        }
    }
    /**
     * Agrega aria-label a icono con tooltip
     * @memberof BcTotalValueBehavior
     */
    setLabelTooltipText() {
        const tooltipText = this.mySelf.querySelectorAll(`.${BcCommonConstants.ICONS_CLASS}.${BcCommonConstants.BC_TOOLTIP_CLASS}`);
        tooltipText.forEach((element) => {
            if (tooltipText != null) {
                addFocusable(element, { tabindex: '0' });
                const attribute = element.getAttribute(BcCommonConstants.BC_TOOLTIP_TEXT);
                element.setAttribute(BcCommonConstants.ARIA_LABEL, attribute);
            }
        });
    }
    /**
     * Agrega tooltip a span cuando este presenta texto con ellipsis
     * @memberof BcTotalValueBehavior
     */
    addTooltipToEllipsisClass() {
        const totalValueLabels = this.mySelf.querySelectorAll(`${BcCommonConstants.SPAN_TAG}.${BcTotalValueConstants.TOTAL_VALUE_ELLIPSIS_CLASS}`);
        totalValueLabels.forEach((totalValueLabel) => {
            if (totalValueLabel.offsetWidth < totalValueLabel.scrollWidth) {
                totalValueLabel.classList.add(BcCommonConstants.BC_TOOLTIP_CLASS);
                totalValueLabel.setAttribute(BcCommonConstants.BC_TOOLTIP_TEXT, totalValueLabel.innerHTML);
            }
        });
    }
    /**
     * Remueve foco de tooltip a span cuando este presenta texto con ellipsis
     * @memberof BcTotalValueBehavior
     */
    removeFocusTooltipToEllipsisClass() {
        const totalValueLabels = document.querySelectorAll(`${BcCommonConstants.SPAN_TAG}.${BcTotalValueConstants.TOTAL_VALUE_ELLIPSIS_CLASS}`);
        totalValueLabels.forEach((totalValueLabel) => {
            totalValueLabel.removeAttribute('tabindex');
        });
    }
    /**
     * Oculta columna con clase primary que superan el maximo numero de columnas visibles en movil
     * @memberof BcTotalValueBehavior
     */
    displayMaxNumColumnsMobile() {
        const informationPrimaryColumns = this.getTotalValueInformationPrimaryColumns();
        const startPositionColumn = this.numberExtraColumnsAdded == 0 ? 0 : this.numberExtraColumnsAdded - 1;
        const numberInformationPrimaryColumnsToHide = this.getNumberInformationPrimaryColumnsToHideMobile(informationPrimaryColumns.length);
        if (window.innerWidth > BcTotalValueConstants.TOTAL_VALUE_BREAKPOINT_XS) {
            this.changeColumnsVisibility(informationPrimaryColumns, startPositionColumn, numberInformationPrimaryColumnsToHide, BcCommonConstants.FLEX);
            return;
        }
        this.changeColumnsVisibility(informationPrimaryColumns, startPositionColumn, numberInformationPrimaryColumnsToHide, BcCommonConstants.NONE);
    }
    /**
     * Oculta las primeras columnas de informacion extras dejando solo las maximas permitidas
     * @memberof BcTotalValueBehavior
     */
    hideExtraInformationColumns() {
        this.changeColumnsVisibility(this.totalValueInformationColumns, 0, this.numberExtraColumnsAdded, BcCommonConstants.NONE);
    }
    /**
     * Agrega una clase primary por defecto a la ultima columna en caso de que no se defina ningun td con primary
     * @memberof BcTotalValueBehavior
     */
    setLastColumnAsDefaultVisibleResponsive() {
        const totalValueInformationPrimaryColumns = this.getTotalValueInformationPrimaryColumns();
        if (totalValueInformationPrimaryColumns.length === 0 && this.totalValueInformationColumns.length > 0) {
            this.totalValueInformationColumns[this.totalValueInformationColumns.length - 1].classList.add(BcTotalValueConstants.TOTAL_VALUE_CELL_INFORMATION_PRIMARY_CLASS);
        }
    }
    /**
     * Cambia la visibilidad de las columnas que se indiquen como parametros
     * @memberof BcTotalValueBehavior
     */
    changeColumnsVisibility(totalValueColumns, startPosition, numberOfColumns, displayStyle) {
        if (totalValueColumns.length <= startPosition || totalValueColumns.length <= numberOfColumns) {
            return;
        }
        totalValueColumns.slice(startPosition, numberOfColumns).forEach((column) => {
            column.style.display = displayStyle;
        });
    }
    /**
     * Obtiene todos los elementos con clase information-primary
     * @memberof BcTotalValueBehavior
     */
    getTotalValueInformationPrimaryColumns() {
        return Array.from(this.mySelf.querySelectorAll(`.${BcTotalValueConstants.TOTAL_VALUE_CELL_INFORMATION_PRIMARY_CLASS}`));
    }
    /**
     * Obtiene el numero de columnas information-primary para ocultar en mobile
     * @memberof BcTotalValueBehavior
     */
    getNumberInformationPrimaryColumnsToHideMobile(totalColumnsInformationPrimary) {
        const numberOfInformationPrimaryToHide = totalColumnsInformationPrimary - BcTotalValueConstants.TOTAL_VALUE_NUMBER_COLUMNS_MOBILE;
        const complementaryPrimaryColumn = this.mySelf.querySelector(`.${BcTotalValueConstants.TOTAL_VALUE_CELL_COMPLEMENTARY_PRIMARY_CLASS}`);
        return complementaryPrimaryColumn
            ? numberOfInformationPrimaryToHide + BcTotalValueConstants.TOTAL_VALUE_MAX_NUMBER_COMPLEMENTARY_COLUMNS
            : numberOfInformationPrimaryToHide;
    }
}

class BcCardTdcConstants {
}
BcCardTdcConstants.CARD_TDC = `${BcCommonConstants.PREFIX_LIB}-card-tdc`;
BcCardTdcConstants.CARD_TDC_CONTAINER = `${BcCommonConstants.PREFIX_LIB}-card-tdc-container`;
BcCardTdcConstants.CARD_TDC_SELECTED = `${BcCommonConstants.PREFIX_LIB}-card-tdc-selected`;
BcCardTdcConstants.CARD_TDC_CURRENCY_CONTAINER = `${BcCommonConstants.PREFIX_LIB}-card-tdc-currency-container`;
BcCardTdcConstants.CARD_TDC_AMOUNT = `${BcCommonConstants.PREFIX_LIB}-card-tdc-amount`;
BcCardTdcConstants.CARD_TDC_LONG_CURRENCY = `${BcCommonConstants.PREFIX_LIB}-card-tdc-long-currency`;
BcCardTdcConstants.CARD_TDC_HEADER = `${BcCommonConstants.PREFIX_LIB}-card-tdc-header`;
BcCardTdcConstants.CARD_TDC_MINIMUM_PAYMENT = `${BcCommonConstants.PREFIX_LIB}-card-tdc-minimum-payment`;
BcCardTdcConstants.CARD_TDC_DUE_DATE = `${BcCommonConstants.PREFIX_LIB}-card-tdc-due-date`;
BcCardTdcConstants.CARD_TDC_TITLE = `${BcCommonConstants.PREFIX_LIB}-card-tdc-title`;

class BcCardTdcBehavior extends BcDefaultBehavior {
    constructor() {
        super();
    }
    /**
     * Configura todos los elementos en el DOM que posean la clase bc-card-tdc la cual hace referencia a los componentes
     * @description Llama el metodo de configuración del objeto del tipo en cuestión. Por tanto este método debe estár implementado
     * en la clase.
     * @returns Listado de elementos de ese tipo en el DOM.
     */
    static setUpAll() {
        const tdcCardElements = Array.from(document.querySelectorAll(`[class~='${BcCardTdcConstants.CARD_TDC}']`));
        const elements = [];
        for (const cardTdcElement of tdcCardElements) {
            const bcCardTdcBehavior = new BcCardTdcBehavior();
            bcCardTdcBehavior.setElement(cardTdcElement);
            bcCardTdcBehavior.setUp();
            elements.push(bcCardTdcBehavior);
        }
        return elements;
    }
    /**
     *Realiza toda la configuración del objeto.
      * @protected
      * @memberof BcCardTdcBehavior
      */
    _setUp() {
        this.detectCheckable();
        this.initListeners();
        this.addAccessibility();
    }
    /**
     *Inicia los click listener de la card pago tdc
      *
      * @memberof BcCardTdcBehavior
      */
    initListeners() {
        this.mySelf.addEventListener('click', () => this.selectCard());
        this.selectableRef.addEventListener('click', (ev) => ev.preventDefault());
    }
    /**
     *Detecta el elemento checkable de la card (radio/checkbox)
      *
      * @memberof BcCardTdcBehavior
      */
    detectCheckable() {
        const isChekbox = this.mySelf.querySelector("input[type=checkbox]");
        const isRadio = this.mySelf.querySelector("input[type=radio]");
        if (isChekbox || isRadio) {
            this.selectableRef = (isChekbox || isRadio);
            this.type = isChekbox ? 'checkbox' : 'radioButton';
        }
    }
    /**
     * Des/Selecciona card cuando se da click
     *
     * @memberof BcCardTdcBehavior
     */
    selectCard() {
        if (this.selectableRef) {
            const currentCard = this.mySelf.querySelector(`.${BcCardTdcConstants.CARD_TDC}`) || this.mySelf;
            switch (this.type) {
                case 'checkbox':
                    const { checked } = this.selectableRef;
                    this.selectableRef.checked = !checked;
                    currentCard.classList[this.isSelected ? 'add' : 'remove'](BcCardTdcConstants.CARD_TDC_SELECTED);
                    break;
                case 'radioButton':
                    const radioGroup = document.getElementById(this.radioGroupName);
                    (radioGroup || document).querySelectorAll(`.${BcCardTdcConstants.CARD_TDC} input[type=radio]`).forEach((cardTdcRadio) => {
                        cardTdcRadio.checked = false;
                        cardTdcRadio.closest(`.bc-card-tdc`).classList.remove(BcCardTdcConstants.CARD_TDC_SELECTED);
                    });
                    this.selectableRef.checked = true;
                    currentCard.classList[this.isSelected ? 'add' : 'remove'](BcCardTdcConstants.CARD_TDC_SELECTED);
                    break;
                default:
                    break;
            }
        }
    }
    /**
     *
     * @readonly
     * @type {boolean}
     * @memberof BcCardTdcBehavior
     */
    get isSelected() {
        return this.selectableRef.checked;
    }
    /**
     * Configura la accesibilidad
     *
     * @private
     * @memberof BcCardTdcBehavior
     */
    addAccessibility() {
        addFocusable(this.mySelf.querySelector(`.${BcCardTdcConstants.CARD_TDC}`) || this.mySelf, { tabindex: '0' }, { event: () => this.selectCard() });
        this.addIconAccessibility();
        this.addHeaderAccessibility();
        this.addMinimumPaymentAccessibility();
        this.addDueDateAccessibility();
    }
    /**
     * Accesibilidad de la fecha limite de pago
     *
     * @private
     * @memberof BcCardTdcBehavior
     */
    addDueDateAccessibility() {
        const dueDateElement = Array.from(this.mySelf.querySelectorAll(`.${BcCardTdcConstants.CARD_TDC_DUE_DATE}`));
        for (const content of dueDateElement) {
            addFocusable(content, { tabindex: '-1' });
        }
    }
    /**
     * Accesibilidad del pago minimo
     *
     * @private
     * @memberof BcCardTdcBehavior
     */
    addMinimumPaymentAccessibility() {
        const minimumPaymentElement = Array.from(this.mySelf.querySelectorAll(`.${BcCardTdcConstants.CARD_TDC_MINIMUM_PAYMENT}`));
        for (const content of minimumPaymentElement) {
            addFocusable(content, { tabindex: '-1' });
        }
    }
    /**
     * Accesibilidad del icono de franquicia
     *
     * @private
     * @memberof BcCardTdcBehavior
     */
    addIconAccessibility() {
        const iconElement = Array.from(this.mySelf.querySelectorAll(`.${BcCardTdcConstants.CARD_TDC} .bc-icon`));
        for (const content of iconElement) {
            addFocusable(content, { tabindex: '-1' });
        }
    }
    /**
     * Accesibilidad del header (Tarjeta y numero)
     *
     * @private
     * @memberof BcCardTdcBehavior
     */
    addHeaderAccessibility() {
        const headerElement = Array.from(this.mySelf.querySelectorAll(`.${BcCardTdcConstants.CARD_TDC_HEADER}`));
        for (const content of headerElement) {
            addFocusable(content, { tabindex: '-1' });
        }
        const titleElement = Array.from(this.mySelf.querySelectorAll(`.${BcCardTdcConstants.CARD_TDC_TITLE}`));
        titleElement?.forEach((item) => {
            if (item.innerHTML.length > 0) {
                const ariaLabel = `Tarjeta ${item.innerHTML}`;
                item.setAttribute('aria-label', ariaLabel);
            }
        });
    }
}

class BcInputFileValidationError extends Error {
    constructor(message) {
        super(message);
        this.name = 'BcInputFileValidationError';
    }
}

const TAG_CONTENT = '[a-zñA-Z0-9áéíóúäëïöüÁÉÍÓÚÄËÏÖÜ!@#%&?¡¿°|:¬\[\*~`^\-_\]\$\t\\\n\(\)"\'/,; =><{}\.]';
const EMBBED_TAG_HTML = /<[a-zñA-Z0-9áéíóúäëïöüÁÉÍÓÚÄËÏÖÜ!@#%&?¡¿°|:¬\[\*~`^\-_\]\$\t\\\n\(\)\"'/,; =><{}\.]+>[a-zñA-Z0-9áéíóúäëïöüÁÉÍÓÚÄËÏÖÜ!@#%&?¡¿°|:¬\[\*~`^\-_\]\$\t\\\n\(\)\"'/,; =><{}\.]*(<[/a-zA-Z]+>)*/g;
class BcHTMLSanitizer {
    sanitize(text) {
        return text.replace((EMBBED_TAG_HTML), '');
    }
}

const ORGANISM_CLASS = `${BcCommonConstants.PREFIX_LIB}-input-file`;
const BUTTON_SELECT_FILE_CLASS = `${BcCommonConstants.PREFIX_LIB}-button-select-file`;
const INFO_NAME_CLASS = `${BcCommonConstants.PREFIX_LIB}-info-name`;
const INFO_NAME_FINAL_CLASS = `${BcCommonConstants.PREFIX_LIB}-info-name-final`;
const INFO_SIZE_CLASS = `${BcCommonConstants.PREFIX_LIB}-info-size`;
const INFO_LOAD_CLASS = `${BcCommonConstants.PREFIX_LIB}-info-load`;
const INFO_LOAD_SUCCESS_CLASS = `${BcCommonConstants.PREFIX_LIB}-info-load-success`;
const INFO_LOAD_ERROR_CLASS = `${BcCommonConstants.PREFIX_LIB}-info-load-error`;
const INFO_PERCENT_CLASS = `${BcCommonConstants.PREFIX_LIB}-info-percent`;
const DROP_AREA_CLASS = `${BcCommonConstants.PREFIX_LIB}-drop-area`;
const DROP_AREA_NONE_CLASS = `${BcCommonConstants.PREFIX_LIB}-drop-area-none`;
const DROP_AREA_HOVER_CLASS = `${BcCommonConstants.PREFIX_LIB}-drop-area-hover`;
const CONTAINER_INPUT_CLASS = `${BcCommonConstants.PREFIX_LIB}-container-button-input-file`;
const LABEL_BUTTON_CLASS = `${BcCommonConstants.PREFIX_LIB}-input-file-label`;
const FILES_CONTAINER_CLASS = `${BcCommonConstants.PREFIX_LIB}-files-container`;
const SEE_MORE_FILES_CONTAINER_CLASS = `${BcCommonConstants.PREFIX_LIB}-files-show-more-container`;
const UPLOADED_FILE_CLASS = `${BcCommonConstants.PREFIX_LIB}-uploaded-file`;
const UPLOADED_FILE_SUCCESS_CLASS = `${BcCommonConstants.PREFIX_LIB}-uploaded-file-success`;
const UPLOADED_FILE_ERROR_CLASS = `${BcCommonConstants.PREFIX_LIB}-uploaded-file-error`;
const UPLOADED_FILE_DELETED_CLASS = `${BcCommonConstants.PREFIX_LIB}-uploaded-file-deleted`;
const INPUT_FILE_HIDDEN_CLASS = `${BcCommonConstants.PREFIX_LIB}-input-file-hidden`;
const INPUT_REFRESH_CLASS = `${BcCommonConstants.PREFIX_LIB}-input-refresh`;
const FILE_CARD_LEFT = `${BcCommonConstants.PREFIX_LIB}-file-left`;
const FILE_CARD_CENTER = `${BcCommonConstants.PREFIX_LIB}-file-center`;
const FILE_CARD_RIGTH = `${BcCommonConstants.PREFIX_LIB}-file-right`;
const FILE_CARD_INFO = `${BcCommonConstants.PREFIX_LIB}-info`;
const PROGRESS_CONTAINER = `${BcCommonConstants.PREFIX_LIB}-progress-container`;
const INPUT_TYPE_FILE = 'input[type=file]';
const DRAG_EVENTS = ['drag', 'dragstart', 'dragend', 'dragenter', 'dragover', 'dragleave', 'drop'];
const DRAGENTER_EVENT = 'dragenter';
const DRAGLEAVE_EVENT = 'dragleave';
const DROP_EVENT = 'drop';
const CLICK_EVENT = 'click';
const MOUSEOUT_EVENT = 'mouseout';
const CHANGE_EVENT = 'change';
const SEE_MORE_MESSAGE = 'Ver más adjuntos';
const SEE_LESS_MESSAGE = 'Ver menos';
const ATTR_MAX_SIZE = 'maxSize';
const ATTR_MAX_CARDS = 'maxCards';
const ATTR_MAX_FILES = 'maxFiles';
const ATTR_VALID_TYPE = 'validType';
const FILE_MAX_SIZE = 5120;
const MAX_CONTAINERS = 3;
const KILOBYTE = 1024;
const MEGABYTE = 1048576;
const GIGABYTE = 1073741824;
const DECIMALS_MAX = 2;
const BYTES_1073741824 = 1073741824;
const SLICE = 28;
const ONE_HUNDRED_NUMBER = 100;
const ONE_NUMBER = 1;
const ZERO_NUMBER = 0;
const UPLOAD_STATUS = 'upload';
const SUCCESS_STATUS = 'success';
const ERROR_STATUS = 'error';
const CLOUD_UPLOAD_ICON = 'cloud-upload';
const SUCCESSFUL_ICON = 'successful';
const ALERT_ICON = 'alert';
const ERROR_ICON = 'error';
const REFRESH_ICON = 'refresh';
const BUTTON_ELEMENT = 'button';
const DISABLED = 'disabled';

class BcInputFileBehavior extends BcDefaultBehavior {
    constructor() {
        super();
        this.filesAdded = [];
        this.filesAddErr = [];
        this.counter = ZERO_NUMBER;
        this.counterMouse = ZERO_NUMBER;
        this.toogleChangeEvent = true;
        this.toogleButtonSeeMore = false;
        this.sanitizer = new BcHTMLSanitizer();
    }
    static setUpAll() {
        const inputFileElements = Array.from(document.querySelectorAll(`.${ORGANISM_CLASS}`));
        const elements = [];
        for (let i = ZERO_NUMBER; i < inputFileElements.length; i++) {
            const element = inputFileElements[i];
            const bcInputFileBehavior = new BcInputFileBehavior();
            bcInputFileBehavior.setElement(element);
            bcInputFileBehavior.setUp();
            elements.push(bcInputFileBehavior);
        }
        return elements;
    }
    _setUp() {
        this.dropArea = this.mySelf.querySelector(`.${DROP_AREA_CLASS}`);
        this.labelButton = this.mySelf.querySelector(`.${LABEL_BUTTON_CLASS}`);
        this.buttonSelectFile = this.mySelf.querySelector(`.${BUTTON_SELECT_FILE_CLASS}`);
        this.uploadedFilesMainContainer = this.mySelf.querySelector(`.${FILES_CONTAINER_CLASS}`);
        this.inputFile = this.mySelf.querySelector(INPUT_TYPE_FILE);
        this.setTypeAttribute();
        this.uploadedFilesSeeMoreContainer = this.mySelf.querySelector(`.${SEE_MORE_FILES_CONTAINER_CLASS}`);
        this.listeners();
    }
    listeners() {
        this.listenerDrags();
        this.listenerDrop();
        this.listenerClick();
        this.listenerDragenter();
        this.listenerDragleave();
        this.listenerMouseout();
        this.listenerChange();
    }
    listenerDrags() {
        DRAG_EVENTS.forEach((eventName) => {
            this.dropArea.addEventListener(eventName, this.preventDefaults, false);
        });
    }
    listenerDrop() {
        this.dropArea.addEventListener(DROP_EVENT, (e) => {
            if (!this.mySelf.querySelector(`.${DROP_AREA_CLASS}`).classList.contains(DROP_AREA_NONE_CLASS)) {
                this.handleDrop(e);
            }
        }, false);
    }
    listenerClick() {
        this.buttonSelectFile.addEventListener(CLICK_EVENT, () => {
            this.inputFile.click(), false;
        });
    }
    listenerDragenter() {
        this.dropArea.addEventListener(DRAGENTER_EVENT, (event) => {
            event.preventDefault();
            event.stopPropagation();
            this.counter++;
            const dropAreaNoneClass = event.target.classList.contains(DROP_AREA_NONE_CLASS);
            if (event.target.className === DROP_AREA_CLASS && !dropAreaNoneClass) {
                event.target.classList.add(DROP_AREA_HOVER_CLASS);
            }
        }, false);
    }
    listenerDragleave() {
        this.dropArea.addEventListener(DRAGLEAVE_EVENT, (event) => {
            event.preventDefault();
            event.stopPropagation();
            this.counter--;
            if (this.counter === ZERO_NUMBER) {
                event.target.classList.remove(DROP_AREA_HOVER_CLASS);
            }
        }, false);
    }
    listenerMouseout() {
        this.dropArea.addEventListener(MOUSEOUT_EVENT, (event) => {
            if (event.target.classList.contains(DROP_AREA_CLASS)) {
                event.target.classList.remove(DROP_AREA_HOVER_CLASS);
            }
        });
    }
    listenerChange() {
        this.inputFile.addEventListener(CHANGE_EVENT, (e) => {
            this.handleFiles(this.inputFile.files);
            this.inputFile.value = null;
            this.toogleChangeEvent = false;
        });
    }
    preventDefaults(e) {
        e.preventDefault();
        e.stopPropagation();
    }
    handleDrop(e) {
        const dt = e.dataTransfer;
        const files = dt.files;
        this.handleFiles(files);
    }
    handleFiles(files) {
        this.maxCards = this.inputFile.getAttribute(ATTR_MAX_CARDS)
            ? parseInt(this.inputFile.getAttribute(ATTR_MAX_CARDS))
            : MAX_CONTAINERS;
        this.maxSize = this.inputFile.getAttribute(ATTR_MAX_SIZE)
            ? parseInt(this.inputFile.getAttribute(ATTR_MAX_SIZE))
            : FILE_MAX_SIZE;
        this.maxFiles = this.inputFile.getAttribute(ATTR_MAX_FILES)
            ? parseInt(this.inputFile.getAttribute(ATTR_MAX_FILES))
            : null;
        if ((this.maxFiles && this.maxFiles > ZERO_NUMBER)
            && this.filesAdded.length + files.length > this.maxFiles) {
            if (this.changeStateMaxFiles) {
                this.changeStateMaxFiles(this.filesAdded);
            }
            return;
        }
        this.setTypeAttribute();
        this.iterateFiles(files, this.validTypesArray);
    }
    updateButtonState(disabled) {
        const button = this.mySelf.querySelector(BcCommonConstants.BUTTON_TAG);
        if (disabled) {
            button.setAttribute(DISABLED, '');
        }
        else {
            button.removeAttribute(DISABLED);
        }
    }
    setTypeAttribute() {
        let validTypesStr = this.inputFile.getAttribute(ATTR_VALID_TYPE)
            ? this.inputFile.getAttribute(ATTR_VALID_TYPE)
            : '[]';
        validTypesStr = validTypesStr.toLowerCase();
        try {
            const exreg = /'/gm;
            validTypesStr = validTypesStr.replace(exreg, '"');
            this.validTypesArray = JSON.parse(validTypesStr);
        }
        catch (err) {
            this.validTypesArray = [];
        }
        this.inputFile.accept = this.getInputAcceptTypes(this.validTypesArray);
    }
    iterateFiles(files, validTypesArray) {
        if (this.overFileLimit(files)) {
            this.validLimitFn(files);
            return;
        }
        this.iterateFilesErr(files, validTypesArray);
    }
    iterateFilesErr(files, validTypesArray) {
        const thereAreErrors = Array.from(files)
            .map((x) => {
            return this.isRepeatedFileErr(x);
        })
            .filter((prev) => {
            return prev;
        }).length > 0;
        if (!thereAreErrors) {
            for (let i = ZERO_NUMBER; i < files.length; i++) {
                if (!this.validateType(validTypesArray, files[i])) {
                    this.validTypeFn(files, i);
                    continue;
                }
                if ((files[i].size / KILOBYTE) > this.maxSize) {
                    this.validSizeFn(files, i);
                    continue;
                }
                this.appendFileMolecule(files[i], this.uploadedFilesMainContainer);
                if (this.changeState) {
                    this.changeState(this.filesAdded);
                }
            }
        }
    }
    validLimitFn(files) {
        const err = new BcInputFileValidationError('Este selector no permite más de un archivo');
        this.createFileInDom(files[ZERO_NUMBER], this.uploadedFilesMainContainer, String(err).slice(SLICE));
        const containers = this.getContainers(this.uploadedFilesMainContainer);
        this.hideContainers(containers, this.uploadedFilesMainContainer);
    }
    validTypeFn(files, i) {
        const err = new BcInputFileValidationError('Tipo de archivo inválido');
        this.filesAddErr.push(files[i]);
        this.createFileInDom(files[i], this.uploadedFilesMainContainer, String(err).slice(SLICE));
        if (this.changeStateErr) {
            this.changeStateErr(String(err).slice(SLICE));
        }
        const containers = this.getContainers(this.uploadedFilesMainContainer);
        this.hideContainers(containers, this.uploadedFilesMainContainer);
    }
    validSizeFn(files, i) {
        const err = new BcInputFileValidationError('Archivo demasiado grande');
        this.filesAddErr.push(files[i]);
        this.createFileInDom(files[i], this.uploadedFilesMainContainer, String(err).slice(SLICE));
        if (this.changeStateErr) {
            this.changeStateErr(String(err).slice(SLICE));
        }
        const containers = this.getContainers(this.uploadedFilesMainContainer);
        this.hideContainers(containers, this.uploadedFilesMainContainer);
    }
    appendFileMolecule(file, container) {
        if (this.isRepeatedFile(file)) {
            return;
        }
        this.filesAdded.push(file);
        this.createFileInDom(file, this.uploadedFilesMainContainer, UPLOAD_STATUS);
        if ((this.maxFiles && this.maxFiles > ZERO_NUMBER)
            && this.filesAdded.length >= this.maxFiles) {
            this.updateButtonState(true);
            return;
        }
        const containers = this.getContainers(container);
        this.hideContainers(containers, container);
    }
    /**
     * Valida si el nombre de archivo ya existe
     * @param {File} file
     * @return {*}  {boolean}
     * @memberof BcInputFileBehavior
     */
    isRepeatedFile(file) {
        let isRepeated = false;
        for (let i = ZERO_NUMBER; i < this.filesAdded.length; i++) {
            if (this.filesAdded[i].name === file.name) {
                isRepeated = true;
                break;
            }
        }
        return isRepeated;
    }
    isRepeatedFileErr(file) {
        let isRepeated = false;
        for (let i = ZERO_NUMBER; i < this.filesAddErr.length; i++) {
            if (this.filesAddErr[i].name === file.name) {
                isRepeated = true;
                break;
            }
        }
        return isRepeated;
    }
    hideContainers(containers, container) {
        for (let index = ONE_NUMBER; index <= containers.length; index++) {
            if (index <= this.maxCards) {
                containers[index - ONE_NUMBER].classList.remove(INPUT_FILE_HIDDEN_CLASS);
                continue;
            }
            containers[index - ONE_NUMBER].classList.add(INPUT_FILE_HIDDEN_CLASS);
            if (index === (this.maxCards + ONE_NUMBER)) {
                this.getSeeMoreButton(container, containers.length);
                continue;
            }
            this.buttonSeeMore.textContent = `${SEE_MORE_MESSAGE} (${containers.length - this.maxCards})`;
        }
        if (containers.length <= this.maxCards) {
            this.uploadedFilesSeeMoreContainer.innerHTML = '';
        }
    }
    getContainers(container) {
        return container.querySelectorAll(`.${UPLOADED_FILE_CLASS}`);
    }
    /**
     * Crea un contenedor con el nombre del archivo en el DOM html que es
     * visible para el usuario en el navegador por cada archivo que se sube
     * @param {File} file
     * @param {ChildNode} container
     * @memberof BcInputFileBehavior
     */
    createFileInDom(file, container, status) {
        const fileCard = document.createElement(BcCommonConstants.DIV_TAG);
        fileCard.classList.add(UPLOADED_FILE_CLASS);
        container.prepend(fileCard);
        this.addColLeft(fileCard, status);
        this.addColCenter(fileCard, file, status);
        const colRefresh = document.createElement(BcCommonConstants.DIV_TAG);
        colRefresh.classList.add(INPUT_REFRESH_CLASS);
        fileCard.appendChild(colRefresh);
        this.addColRight(fileCard, file, container, status);
    }
    addColLeft(container, status) {
        let colLeft;
        let icon = '';
        if (status === UPLOAD_STATUS) {
            colLeft = document.createElement(BcCommonConstants.DIV_TAG);
            colLeft.classList.add(FILE_CARD_LEFT);
            icon = CLOUD_UPLOAD_ICON;
        }
        if (status === SUCCESS_STATUS) {
            colLeft = container.querySelector(`.${FILE_CARD_LEFT}`);
            icon = SUCCESSFUL_ICON;
        }
        if (status === ERROR_STATUS) {
            colLeft = container.querySelector(`.${FILE_CARD_LEFT}`);
            icon = ALERT_ICON;
        }
        if (status != UPLOAD_STATUS && status != SUCCESS_STATUS && status != ERROR_STATUS) {
            colLeft = document.createElement(BcCommonConstants.DIV_TAG);
            colLeft.classList.add(FILE_CARD_LEFT);
            icon = ALERT_ICON;
        }
        colLeft.innerHTML = `<em class="bc-icon bc-md" aria-hidden="true" aria-label="prueba">${icon}</em>`;
        if (status != SUCCESS_STATUS && status != ERROR_STATUS) {
            container.appendChild(colLeft);
        }
    }
    addColCenter(container, file, status) {
        const percent = ZERO_NUMBER;
        const colCenter = document.createElement(BcCommonConstants.DIV_TAG);
        const info = document.createElement(BcCommonConstants.DIV_TAG);
        const progress = document.createElement(BcCommonConstants.DIV_TAG);
        colCenter.classList.add(FILE_CARD_CENTER);
        info.classList.add(FILE_CARD_INFO);
        progress.classList.add(PROGRESS_CONTAINER);
        info.innerHTML = `<div class="${INFO_NAME_CLASS}">
    <p><strong>${file.name}</strong></p>
    </div>
    <div class="${INFO_SIZE_CLASS}">
      <section class="${INFO_LOAD_CLASS}"></section>
      <section class="${INFO_PERCENT_CLASS}"></section>
    </div>`;
        this.updateProgressBar(progress, percent, status);
        colCenter.appendChild(info);
        colCenter.appendChild(progress);
        container.appendChild(colCenter);
        this.loaderFile(container, colCenter, info, file, progress, percent, status);
    }
    loaderFile(container, col, info, file, progress, percent, status) {
        const reader = new FileReader();
        reader.onprogress = (n) => {
            percent = (n.loaded / n.total) * ONE_HUNDRED_NUMBER;
            this.updateProgressBar(progress, percent, status);
            this.updatePercentage(info, percent, status);
            this.updateFileSize(container, info, n.loaded, n.total, file, status);
        };
        reader.readAsDataURL(file);
        reader.onload = () => {
            percent = ONE_HUNDRED_NUMBER;
            this.updateProgressBar(progress, percent, status);
            setTimeout(() => {
                col.removeChild(progress);
                container.querySelector(`.${INFO_NAME_CLASS}`).classList.add(INFO_NAME_FINAL_CLASS);
                if (status === UPLOAD_STATUS) {
                    this.addColLeft(container, SUCCESS_STATUS);
                }
                else {
                    this.addColLeft(container, ERROR_STATUS);
                }
            }, ONE_HUNDRED_NUMBER);
        };
    }
    addColRight(container, file, parentElement, status) {
        const colRight = document.createElement(BcCommonConstants.DIV_TAG);
        colRight.classList.add(FILE_CARD_RIGTH);
        colRight.innerHTML = `
      <button
        class="bc-fab-btn-icon
        file-button"
        aria-label="Boton"
        bc-fab-button=""
        sizebutton="puffy"
        ng-reflect-size-button="puffy"
        role="button" tabindex="0">
        <em class="bc-icon bc-sm" aria-hidden="true" aria-label="prueba">${ERROR_ICON}</em>
      </button>`;
        const button = colRight.querySelector(BcCommonConstants.BUTTON_TAG);
        container.appendChild(colRight);
        button.addEventListener(CLICK_EVENT, () => {
            this.deleteFile(file, container, parentElement, status);
        });
    }
    updateProgressBar(progress, percent, status = SUCCESS_STATUS) {
        if (status === UPLOAD_STATUS) {
            progress.innerHTML = `<progress value="${percent}" max="100"></progress>`;
        }
    }
    updatePercentage(container, percent, status = SUCCESS_STATUS) {
        if (status === UPLOAD_STATUS) {
            container.querySelector(`.${INFO_PERCENT_CLASS}`).textContent = `${Math.trunc(percent)}%`;
        }
        if (percent === ONE_HUNDRED_NUMBER) {
            container.querySelector(`.${INFO_PERCENT_CLASS}`).textContent = '';
        }
    }
    updateFileSize(container, info, sizeLoaded, sizeTotal, file, status = SUCCESS_STATUS) {
        if (status === UPLOAD_STATUS) {
            if (sizeLoaded === sizeTotal) {
                info.querySelector(`.${INFO_LOAD_CLASS}`).classList.add(INFO_LOAD_SUCCESS_CLASS);
                container.classList.add(UPLOADED_FILE_SUCCESS_CLASS);
            }
            info.querySelector(`.${INFO_LOAD_CLASS}`).textContent = `${(sizeLoaded >= sizeTotal)
                ? this.formatSizeUnits(sizeTotal) + ' / Listo'
                : this.formatSizeUnits(sizeLoaded) + '/' + this.formatSizeUnits(sizeTotal)}`;
            return;
        }
        info.querySelector(`.${INFO_LOAD_CLASS}`).classList.add(INFO_LOAD_ERROR_CLASS);
        container.classList.add(UPLOADED_FILE_ERROR_CLASS);
        info.querySelector(`.${INFO_LOAD_CLASS}`).textContent = `0 MB / ${status}`;
        container.querySelector(`.${INFO_NAME_CLASS}`).classList.add(INFO_NAME_FINAL_CLASS);
        this.addColRefresh(container, file, status);
    }
    addColRefresh(container, file, status) {
        container.querySelector(`.${INPUT_REFRESH_CLASS}`).innerHTML = `
    <button
        class="bc-fab-btn-icon file-button"
        aria-label="Boton" bc-fab-button=""
        sizebutton="puffy"
        ng-reflect-size-button="puffy"
        role="button" tabindex="0">
      <em class="bc-icon bc-sm" aria-hidden="true" aria-label="prueba">${REFRESH_ICON}</em>
    </button>`;
        const button = container.querySelector(BcCommonConstants.BUTTON_TAG);
        button.addEventListener(CLICK_EVENT, () => {
            this.deleteFile(file, container, this.uploadedFilesMainContainer, status);
            const dt = new DataTransfer();
            dt.items.add(file);
            const fileList = dt.files;
            this.iterateFiles(fileList, this.validTypesArray);
        });
    }
    formatSizeUnits(bytes) {
        this.gigaByte(bytes);
        this.megaByte(bytes);
        this.kiloByte(bytes);
        this.oneByte(bytes);
        return this.bytesFinal;
    }
    gigaByte(bytes) {
        if (bytes >= GIGABYTE) {
            bytes = `${(bytes / GIGABYTE).toFixed(DECIMALS_MAX)} Gb`;
            this.bytesFinal = bytes;
        }
    }
    megaByte(bytes) {
        if (bytes >= MEGABYTE && bytes < GIGABYTE) {
            bytes = `${(bytes / MEGABYTE).toFixed(DECIMALS_MAX)} Mb`;
            this.bytesFinal = bytes;
        }
    }
    kiloByte(bytes) {
        if (bytes >= KILOBYTE && bytes < MEGABYTE) {
            bytes = `${(bytes / KILOBYTE).toFixed(DECIMALS_MAX)} Kb`;
            this.bytesFinal = bytes;
        }
    }
    oneByte(bytes) {
        if (bytes > ONE_NUMBER && bytes < KILOBYTE) {
            bytes = `${bytes} bytes`;
            this.bytesFinal = bytes;
        }
        else if (bytes === ONE_NUMBER) {
            bytes = `${bytes} byte`;
            this.bytesFinal = bytes;
        }
        else if (bytes === ZERO_NUMBER) {
            bytes = '0 bytes';
            this.bytesFinal = bytes;
        }
    }
    deleteFile(fileToDelete, molecule, parent, status) {
        molecule.classList.add(UPLOADED_FILE_DELETED_CLASS);
        parent.removeChild(molecule);
        const existInFilesAdded = this.filesAdded.indexOf(fileToDelete);
        this.filesAdded = this.filesAdded.filter((fileFromArray) => fileFromArray !== fileToDelete);
        this.filesAddErr = this.filesAddErr.filter((fileErrDeleted) => {
            return fileErrDeleted !== fileToDelete;
        });
        if (this.changeState) {
            this.changeState(this.filesAdded);
        }
        if (this.changeStateErr) {
            this.changeStateErr(this.filesAddErr);
        }
        const containers = this.getContainers(parent);
        if (!this.toogleButtonSeeMore) {
            this.hideContainers(containers, parent);
        }
        else if (containers.length === this.maxCards) {
            this.uploadedFilesSeeMoreContainer.innerHTML = '';
        }
        if (existInFilesAdded > -1) {
            this.updateButtonState(false);
        }
    }
    getSeeMoreButton(container, countContainers) {
        const countButtons = this.uploadedFilesSeeMoreContainer.childElementCount;
        if (countButtons === ZERO_NUMBER) {
            this.buttonSeeMore = document.createElement(BcCommonConstants.BUTTON_TAG);
            this.buttonSeeMore.classList.add(BcCommonConstants.BC_BTN_CLASS, BcCommonConstants.BUTTON_SMALL_CLASS);
            this.uploadedFilesSeeMoreContainer.appendChild(this.buttonSeeMore);
            this.buttonSeeMore.addEventListener(CLICK_EVENT, () => this.toggleSeeMore(container));
        }
        this.buttonSeeMore.textContent = `${SEE_MORE_MESSAGE} (${countContainers - this.maxCards})`;
    }
    toggleSeeMore(container) {
        const containers = this.getContainers(container);
        this.toogleButtonSeeMore = !this.toogleButtonSeeMore;
        if (this.toogleButtonSeeMore) {
            for (let index = ZERO_NUMBER; index < containers.length; index++) {
                containers[index].classList.remove(INPUT_FILE_HIDDEN_CLASS);
            }
            this.uploadedFilesSeeMoreContainer.querySelector(BUTTON_ELEMENT).textContent = SEE_LESS_MESSAGE;
            return;
        }
        this.hideContainers(containers, container);
    }
    /**
     * Valida el tipo de archivo segun los tipos de archivos permitidos
     * @param {string[]} validTypes
     * @param {File} file
     * @return {*}  {boolean}
     * @memberof BcInputFileBehavior
     */
    validateType(validTypes, file) {
        if (validTypes.length === ZERO_NUMBER) {
            return true;
        }
        let type;
        for (let index = file.name.length; index > ZERO_NUMBER; index--) {
            if (file.name[index - ONE_NUMBER] === '.') {
                type = file.name.substring(index, file.name.length).toLowerCase();
                return validTypes.some((typeArr) => typeArr === type);
            }
        }
    }
    overFileLimit(files) {
        return (!this.inputFile.multiple && files.length > ONE_NUMBER);
    }
    /**
     * Obtiene el máximo peso en mb en archivos subidos
     * @param {FileList} files
     * @returns
     * @memberof BcInputFileBehavior
     */
    getInputAcceptTypes(validTypesArray) {
        let accept = '';
        for (let i = ZERO_NUMBER; i < validTypesArray.length; i++) {
            accept = accept.concat('.' + validTypesArray[i] + ',');
        }
        return accept;
    }
}

const FILE_DOWNLOAD = `${BcCommonConstants.PREFIX_LIB}-file-download`;
const FILE_DOWNLOAD_ACCORDION = FILE_DOWNLOAD + '-accordion';
const FILE_DOWNLOAD_CONTAINER = FILE_DOWNLOAD + '-container';
const FILE_DOWNLOAD_ROW = FILE_DOWNLOAD + '-row';
const FILE_DOWNLOAD_ERROR = FILE_DOWNLOAD + '-error';
const FILE_DOWNLOAD_SUCCESS = FILE_DOWNLOAD + '-success';
const FILE_DOWNLOAD_ROWSCONTAINER = FILE_DOWNLOAD + '-rowsContainer';
const FILE_DOWNLOAD_LOADER = FILE_DOWNLOAD + '-loader';
const FILE_DOWNLOAD_ICON = FILE_DOWNLOAD + '-icon';
const FILE_DOWNLOAD_PROGRESS_CONTAINER = `${BcCommonConstants.PREFIX_LIB}-progress-container`;
const FILE_DOWNLOAD_PROGRESS_YELLOW = FILE_DOWNLOAD_PROGRESS_CONTAINER;
const FILE_DOWNLOAD_PROGRESS_ORANGE = FILE_DOWNLOAD_PROGRESS_CONTAINER + '-orange';
const FILE_DOWNLOAD_PROGRESS_GREEN = FILE_DOWNLOAD_PROGRESS_CONTAINER + '-green';
const FILE_DOWNLOAD_ACCORDION_TYPE = `${BcCommonConstants.PREFIX_LIB}-accordion-basic`;
const FILE_DOWNLOAD_ACCORDION_TITLE = `${BcCommonConstants.PREFIX_LIB}-accordion-title`;
const FILE_DOWNLOAD_ACCORDION_SUBTITLE = `${BcCommonConstants.PREFIX_LIB}-file-download-accordion-subtitle`;
const FILE_DOWNLOAD_ACCORDION_ACTIVE = `${BcCommonConstants.PREFIX_LIB}-active`;
const FILE_DOWNLOAD_LOADER_2 = `${BcCommonConstants.PREFIX_LIB}-loader`;
const FILE_DOWNLOAD_ERROR_MESSAGE = `Error al generar el archivo`;
const FILE_DOWNLOAD_ERROR_MESSAGE_TITTLE = `Error en la descarga`;
const FILE_DOWNLOAD_ERROR_MESSAGE_SUBTITLE = `Ocurrio un error en la generación de un archivo`;
const FILE_DOWNLOAD_SUCCESS_MESSAGE_TITLE = `Descarga Completada`;
const FILE_DOWNLOAD_CERO = 0;
const FILE_DOWNLOAD_UNO = 1;
const FILE_DOWNLOAD_CUATRO = 4;
const FILE_DOWNLOAD_CIEN = 100;
const FILE_DOWNLOAD_DOSCIENTOS = 200;
const FILE_DOWNLOAD_TRECIENTOS = 300;

class BcFileDownloadBehavior extends BcDefaultBehavior {
    constructor() {
        super();
        this.downloadlist = 1;
        this.downloadlistSuccess = 0;
        this.arrayStatus = [];
        this.progressValue = {};
        this.allProgressBehavior = {};
    }
    /**
     * @memberof BcFileDownloadBehavior
     */
    _setUp() { }
    setRow(index) {
        return `<article class="bc-flex-fill bc-d-flex bc-align-items-center">
           <em class="bc-icon bc-md bc-ms-3 download-document_${index}" aria-hidden="true" role="img"  >download-document </em>
           <em class="bc-icon bc-md bc-ms-3 successful_${index}" aria-hidden="true" role="img" >successful</em>
           <em class="bc-icon bc-md bc-ms-3 alert_${index}" aria-hidden="true" role="img"  >alert</em>
               <div  data-background="true" class="progress-bar-download_${index} bc-flex bc-flex-column bc-w-100">            
                   <div class="info bc-px-2 bc-mb-2">
                       <div class="bc-d-flex bc-justify-content-between bc-direction-column">
                       <section class="bc-d-flex">
                       <p class="bc-file-download-labelPre_${index}">Generando &nbsp</p>
                       <p class="bc-file-download-nameFile"><strong class="bc-file-download-filename_${index}"></strong></p>
                       <p class="bc-file-download-state bc-file-download-labelPos_${index}">&nbsp generado</p>
                       </section>
                       <span class='progress-text_${index}'>Error al generar el archivo</span>
                       </div>
                   </div>
                   <div
                        id="bc-progress-bar_${index}"
                        class="bc-progress-bar progress_${index} bc-file-download-progress info bc-px-2 bc-w-100"
                        type="lineal" value="0" color="yellow" background-color="dark"
                      ></div>
               </div>
       </div>
       <a class='bc-file-download-link save-file_${index}' tabindex='0'>
        <div class='bc-tag-disabled tag-button_${index}'   > 
          <i class='bc-icon bc-sm bc-mx-1 bc-icon-download_${index}'>download</i>
          <p class='bc-mx-1 bc-label-download_${index} bc-file-download-hiddenLabel' >Descargar</p>
        </div>
       </a>
       <section class='bc-file-download-container-remove' tabindex='0'>
       <div class='bc-tag bc-file-download-remove'  > 
          <i class='bc-icon bc-sm  bc-tooltip delete-row_${index}'  bc-tooltip=''   bctooltipposition='top' bctooltiptext='Cancelar'>error</i>
        </div>
       </article>
       </section>
       `;
    }
    openAccordion() {
        const accordion = this.getFirstElementByClassName(FILE_DOWNLOAD_ACCORDION_TYPE);
        accordion.classList.add(FILE_DOWNLOAD_ACCORDION_ACTIVE);
        this.mySelf.classList.remove(FILE_DOWNLOAD_ACCORDION);
    }
    /**
     * Muestra el Icono correspondiente
     * @param {string} icon
     * @param {number} index
     * @memberof BcFileDownloadBehavior
     */
    showIcon(icon, index) {
        const iconDownloading = this.getFirstElementByClassName(`download-document_${index}`);
        const iconSuccess = this.getFirstElementByClassName(`successful_${index}`);
        const iconAlert = this.getFirstElementByClassName(`alert_${index}`);
        if (iconDownloading) {
            switch (icon) {
                case 'download-document':
                    iconDownloading.style.display = 'block';
                    iconSuccess.style.display = 'none';
                    iconAlert.style.display = 'none';
                    break;
                case 'successful':
                    iconDownloading.style.display = 'none';
                    iconSuccess.style.display = 'block';
                    iconAlert.style.display = 'none';
                    break;
                case 'alert':
                    iconDownloading.style.display = 'none';
                    iconSuccess.style.display = 'none';
                    iconAlert.style.display = 'block';
                    break;
                default:
                    iconDownloading.style.display = 'none';
                    iconSuccess.style.display = 'none';
                    iconAlert.style.display = 'none';
            }
        }
    }
    /**
     * Retorna el primer elemento con la clase className
     * @return {Element}
     * @param {string} className
     * @memberof BcFileDownloadBehavior
     */
    getFirstElementByClassName(className) {
        const elements = this.mySelf.getElementsByClassName(className);
        if (elements.length > FILE_DOWNLOAD_CERO) {
            return elements[FILE_DOWNLOAD_CERO];
        }
        return null;
    }
    /**
     * Retorna el binario del un File y crea un row con la descarga
     * @param {string} url
     * @param {File} file
     * @param {string} fileName
     * @memberof BcFileDownloadBehavior
     */
    convertToBinary(url, file, fileName) {
        if (!fileName) {
            fileName = file.name;
        }
        const reader = new FileReader();
        reader.onload = async () => {
            const base64File = reader.result;
            const base64 = await fetch(base64File.toString());
            const fileBlob = await base64.blob();
            this.createRow(url, fileBlob, fileName);
        };
        reader.readAsDataURL(file);
    }
    /**
     * Crea un row en el componente con la descarga
     * @param {string} url
     * @param {Blob} blob
     * @param {string} fileName
     * @memberof BcFileDownloadBehavior
     */
    createRow(url, blob, fileName) {
        this.fileName = fileName;
        const rowsContainer = this.getFirstElementByClassName(FILE_DOWNLOAD_ROWSCONTAINER);
        const section = document.createElement('section');
        section.innerHTML = this.setRow(this.downloadlist);
        section.classList.add(FILE_DOWNLOAD_ROW);
        section.classList.add(`file-download-row_${this.downloadlist}`);
        rowsContainer.prepend(section);
        this.showIcon('download-document', this.downloadlist);
        this.downloadFile(this.downloadlist, url, blob, fileName);
        this.allProgressBehavior['progress_' + this.downloadlist] = new BcProgressBarBehavior();
        this.allProgressBehavior['progress_' + this.downloadlist].setElement(this.mySelf.querySelector('#bc-progress-bar_' + this.downloadlist));
        this.allProgressBehavior['progress_' + this.downloadlist].setProgress(20);
        this.allProgressBehavior['progress_' + this.downloadlist].setUp();
        this.allProgressBehavior;
        this.downloadlist++;
        this.setHeadAccordion();
        this.openAccordion();
        this.showLoader(true);
        this.setUpGeneralCircularProgress();
        BcTooltipBehavior.setUpAll();
    }
    /**
     * Solicita la descarga del archivo según sea por url o blob
     * @param {string} url
     * @param {Blob} blob
     * @param {string} fileName
     * @memberof BcFileDownloadBehavior
     */
    downloadFile(index, url, blob, fileName) {
        this.managerProgressBar(index, url, 'init', FILE_DOWNLOAD_CERO);
        if (url) {
            this.eventListener(index, url, fileName);
            this.setNameFile(index, url, fileName);
        }
        if (blob && url === null) {
            if (blob.size > FILE_DOWNLOAD_TRECIENTOS) {
                this.eventListener(index, url, fileName);
                this.setHref(blob, index, fileName);
                this.setNameFile(index, url, fileName);
            }
            else {
                this.managerProgressBar(index, url, 'error', FILE_DOWNLOAD_CERO);
            }
        }
    }
    /**
     * Setea los estados de la barra de progreso.
     * @param {number} index
     * @param {string} url
     * @param {string} state
     * @param {valueProgress} valueProgress
     * @memberof BcFileDownloadBehavior
     */
    managerProgressBar(index, url, state, valueProgress) {
        const progressText = this.getFirstElementByClassName(`progress-text_${index}`);
        const progressBarDownload = this.getFirstElementByClassName(`progress-bar-download_${index}`);
        this.setStatusDownload(index, state);
        switch (state) {
            case 'init':
                this.stateInit(index);
                break;
            case 'success':
                this.stateSuccess(index);
                break;
            case 'error':
                this.stateError(index, url);
                break;
            case 'progress':
                const percentComplete = (valueProgress.loaded / valueProgress.total) * FILE_DOWNLOAD_CIEN;
                this.allProgressBehavior['progress_' + index].setProgress(percentComplete);
                this.calculateGlobalProgress(index, percentComplete);
                this.checkPercentComplete(percentComplete, progressText, index, progressBarDownload, url);
                break;
            default:
                this.stateError(index, url);
                break;
        }
    }
    checkPercentComplete(percentComplete, progressText, index, progressBarDownload, url) {
        if (!isNaN(percentComplete)) {
            percentComplete = Math.floor(percentComplete);
            progressText.innerHTML = percentComplete + '%';
            if (percentComplete === FILE_DOWNLOAD_CIEN) {
                this.showIcon('successful', index);
                progressBarDownload.classList.remove(FILE_DOWNLOAD_CONTAINER);
                progressBarDownload.classList.remove(FILE_DOWNLOAD_PROGRESS_YELLOW);
                progressBarDownload.classList.add(FILE_DOWNLOAD_PROGRESS_GREEN);
            }
        }
        else {
            this.stateError(index, url);
        }
        return percentComplete;
    }
    /**
     * Setea las clases del estado inicial de la barra de progreso.
     * @param {number} index
     * @memberof BcFileDownloadBehavior
     */
    stateInit(index) {
        this.setLabelProgress(index, 'loading');
        this.eventDeleteRow(index);
    }
    /**
     * Setea las clases del estado success de la barra de progreso.
     * @param {number} index
     * @memberof BcFileDownloadBehavior
     */
    stateSuccess(index) {
        const progressText = this.getFirstElementByClassName(`progress-text_${index}`);
        const progressBarDownload = this.getFirstElementByClassName(`progress-bar-download_${index}`);
        if (progressBarDownload) {
            progressBarDownload.classList.add(FILE_DOWNLOAD_PROGRESS_GREEN);
        }
        this.allProgressBehavior['progress_' + index].setColor('green');
        progressText.classList.remove(FILE_DOWNLOAD_ERROR);
        progressText.classList.add(FILE_DOWNLOAD_SUCCESS);
    }
    /**
     * Setea las clases del estado error de la barra de progreso.
     * @param {number} index
     * @param {string} url
     * @memberof BcFileDownloadBehavior
     */
    stateError(index, url) {
        const progress = this.getFirstElementByClassName(`progress_${index}`);
        const progressText = this.getFirstElementByClassName(`progress-text_${index}`);
        const progressBarDownload = this.getFirstElementByClassName(`progress-bar-download_${index}`);
        this.showIcon('alert', index);
        progressText.innerHTML = FILE_DOWNLOAD_ERROR_MESSAGE;
        progressText.classList.remove(FILE_DOWNLOAD_SUCCESS);
        progressText.classList.add(FILE_DOWNLOAD_ERROR);
        progress.setAttribute('value', '100');
        this.clearColorProgressbar(progressBarDownload);
        this.setHeadAccordionError();
        this.updatebuttonDownload(index, url, 'refresh', 'Reintentar');
        this.setRowClass(index, 'error');
        this.setLabelProgress(index, 'error');
        this.enableTagButton(index);
        this.allProgressBehavior['progress_' + index].setColor('red');
        this.allProgressBehavior['progress_' + index].setProgress(100);
    }
    /**
     * Ejecuta el servicio de XMLHttpRequest para iniciar la descarga por url.
     * @param {number} index
     * @param {string} url
     * @param {string} fileName
     * @memberof BcFileDownloadBehavior
     */
    eventListener(index, url, fileName) {
        const request = new XMLHttpRequest();
        request.responseType = 'blob';
        request.open('get', url, true);
        request.setRequestHeader('Access-Control-Allow-Headers', '*');
        request.setRequestHeader('Access-Control-Allow-Origin', '*');
        request.send();
        request.onerror = () => {
            this.managerProgressBar(index, url, 'error', FILE_DOWNLOAD_CERO);
        };
        request.onprogress = (e) => {
            this.validateOnProgress(request, e, index, url);
        };
        request.onloadend = (e) => {
            if (url) {
                if (request.readyState == FILE_DOWNLOAD_CUATRO &&
                    request.status == FILE_DOWNLOAD_DOSCIENTOS &&
                    e.total > FILE_DOWNLOAD_CERO) {
                    this.managerProgressBar(index, url, 'success', FILE_DOWNLOAD_CERO);
                    this.setHref(request.response, index, fileName);
                }
                else {
                    this.managerProgressBar(index, url, 'error', FILE_DOWNLOAD_CERO);
                }
            }
        };
        this.requestEventListener(request, url, index, fileName);
    }
    requestEventListener(request, url, index, fileName) {
        request.addEventListener = (e) => {
            if (url) {
                if (request.readyState == FILE_DOWNLOAD_CUATRO && request.status == FILE_DOWNLOAD_DOSCIENTOS) {
                    this.managerProgressBar(index, url, 'success', FILE_DOWNLOAD_CERO);
                    this.setHref(request.response, index, fileName);
                }
                else {
                    this.managerProgressBar(index, url, 'error', FILE_DOWNLOAD_CERO);
                }
            }
        };
    }
    validateOnProgress(request, e, index, url) {
        if (request.status == FILE_DOWNLOAD_DOSCIENTOS && e.total > FILE_DOWNLOAD_CERO) {
            this.managerProgressBar(index, url, 'progress', e);
        }
        else {
            this.managerProgressBar(index, url, 'error', FILE_DOWNLOAD_CERO);
        }
    }
    /**
     * Setea el atributo href del botón descargar con el evento de descarga.
     * @param {Blob} blob
     * @param {number} index
     * @param {string} fileName
     * @memberof BcFileDownloadBehavior
     */
    setHref(blob, index, fileName) {
        const obj = window.URL.createObjectURL(blob);
        const savefileElement = this.getFirstElementByClassName(`save-file_${index}`);
        savefileElement.setAttribute('href', obj);
        if (fileName) {
            savefileElement.setAttribute('download', fileName);
        }
        else {
            savefileElement.setAttribute('download', obj);
        }
        this.setRowClass(index, 'success');
        this.enableTagButton(index);
        this.updatebuttonDownload(index, obj, 'download', 'Descargar');
        this.setHeadAccordion();
        this.setLabelProgress(index, 'loaded');
    }
    /**
     * Carga el título y subtitulo del header del accordion.
     * @memberof BcFileDownloadBehavior
     */
    setHeadAccordion() {
        const rowCount = this.stateRow();
        if (this.downloadlistSuccess === rowCount) {
            this.updateTitte(FILE_DOWNLOAD_SUCCESS_MESSAGE_TITLE);
            this.updateSubTitte(null);
            this.showLoader(false);
        }
        else {
            if (rowCount == 1) {
                this.updateTitte(`Preparando descarga`);
            }
            else if (rowCount > 1) {
                this.updateTitte(`Preparando descarga (${this.downloadlistSuccess} de ${rowCount})`);
            }
        }
    }
    /**
     * Actualiza el estado de error de descarga en el head del accordion.
     * @memberof BcFileDownloadBehavior
     */
    setHeadAccordionError() {
        const errorMessage = FILE_DOWNLOAD_ERROR_MESSAGE_SUBTITLE;
        this.updateSubTitte(errorMessage);
        if (this.downloadlist === FILE_DOWNLOAD_UNO) {
            this.updateTitte(FILE_DOWNLOAD_ERROR_MESSAGE_TITTLE);
        }
        this.showLoader(false);
    }
    /**
     * Extrae el nombre del archivo desde la url.
     * @param {number} index
     * @param {string} url
     * @param {string} name
     * @memberof BcFileDownloadBehavior
     */
    setNameFile(index, url, name) {
        const labelFileName = this.getFirstElementByClassName(`bc-file-download-filename_${index}`);
        if (url) {
            const arrayUrl = url.split('/');
            const nameFile = arrayUrl[arrayUrl.length - FILE_DOWNLOAD_UNO];
            labelFileName.innerHTML = nameFile;
        }
        if (name) {
            labelFileName.innerHTML = name;
        }
    }
    /**
     * Habilita/deshabilita el botón de descarga.
     * @param {number} index
     * @memberof BcFileDownloadBehavior
     */
    enableTagButton(index) {
        const tag = this.getFirstElementByClassName(`tag-button_${index}`);
        tag.classList.remove('bc-tag-disabled');
        tag.classList.add('bc-tag');
    }
    /**
     * Resetea el color de la barra de progreso.
     * @param {HTMLElement} element
     * @memberof BcFileDownloadBehavior
     */
    clearColorProgressbar(element) {
        element.classList.remove('bc-progress-container');
        element.classList.remove('bc-progress-container-green');
        element.classList.remove('bc-progress-container-orange');
    }
    /**
     * Adiciona el evento de eliminar row.
     * @param {number} index
     * @memberof BcFileDownloadBehavior
     */
    eventDeleteRow(index) {
        const deleteRow = this.getFirstElementByClassName(`delete-row_${index}`);
        const deleteFunc = () => {
            this.deleteRow(index);
        };
        deleteRow.removeEventListener(BcCommonConstants.EVENT_CLICK, deleteFunc);
        deleteRow.addEventListener(BcCommonConstants.EVENT_CLICK, deleteFunc);
    }
    /**
     *Elimina las descargas
     * @param {number} index
     * @memberof BcFileDownloadBehavior
     */
    deleteRow(index) {
        const container = this.getFirstElementByClassName(FILE_DOWNLOAD_ROWSCONTAINER);
        const rowIndex = this.getFirstElementByClassName(`file-download-row_${index}`);
        if (rowIndex) {
            container.removeChild(rowIndex);
            this.setStatusDownload(index, 'delete');
        }
        this.setHeadAccordion();
        this.stateRow();
    }
    /**
     *Setea los label de generando y generado de la barra progess
     * @param {number} index
     * @param {string} state
     * @memberof BcFileDownloadBehavior
     */
    setLabelProgress(index, state) {
        const loading = this.getFirstElementByClassName(`bc-file-download-labelPre_${index}`);
        const loaded = this.getFirstElementByClassName(`bc-file-download-labelPos_${index}`);
        switch (state) {
            case 'loading':
                loading.style.display = 'block';
                loaded.style.display = 'none';
                break;
            case 'loaded':
                loading.style.display = 'none';
                loaded.style.display = 'block';
                break;
            case 'error':
                loading.style.display = 'none';
                loaded.style.display = 'none';
                break;
        }
    }
    /**
     *verifica el estado de los row con descargas success y fallidas. Oculta el accordion si se eliminan todos los row
     * @memberof BcFileDownloadBehavior
     */
    stateRow() {
        const rows = this.mySelf.getElementsByClassName(FILE_DOWNLOAD_ROW);
        if (rows.length === FILE_DOWNLOAD_CERO) {
            this.mySelf.classList.add(FILE_DOWNLOAD_ACCORDION);
        }
        const numSuccess = this.mySelf.getElementsByClassName(FILE_DOWNLOAD_SUCCESS);
        this.downloadlistSuccess = numSuccess.length;
        return rows.length;
    }
    /**
     *setea el row de descarga
     * @memberof BcFileDownloadBehavior
     * @param {number} index
     * @param {string} result
     */
    setRowClass(index, result) {
        const row = this.getFirstElementByClassName(`file-download-row_${index}`);
        row.classList.add(`bc-download-row-${result}`);
    }
    /**
     *setea el título del accordion
     * @param {string} value
     * @memberof BcFileDownloadBehavior
     */
    updateTitte(value) {
        const tittle = this.getFirstElementByClassName(FILE_DOWNLOAD_ACCORDION_TITLE);
        tittle.innerHTML = value;
    }
    /**
     *setea el subtítulo del accordion
     * @param {string} value
     * @memberof BcFileDownloadBehavior
     */
    updateSubTitte(value) {
        const subTittle = this.getFirstElementByClassName(FILE_DOWNLOAD_ACCORDION_SUBTITLE);
        subTittle.innerHTML = value;
    }
    /**
     *setea el nombre y evento del botón descargar
     * @param {number} index
     * @param {string} url
     * @param {string} icon
     * @param {string} label
     * @memberof BcFileDownloadBehavior
     */
    updatebuttonDownload(index, url, icon, label) {
        const iconButton = this.getFirstElementByClassName(`bc-icon-download_${index}`);
        const labelButton = this.getFirstElementByClassName(`bc-label-download_${index}`);
        iconButton.innerHTML = icon;
        labelButton.innerHTML = label;
        const saveFile = this.getFirstElementByClassName(`save-file_${index}`);
        saveFile.addEventListener(BcCommonConstants.EVENT_CLICK, () => {
            if (label === 'Reintentar') {
                this.downloadFile(index, url, null, this.fileName);
            }
        });
    }
    /**
     * Muestra el componente loader cuando la descarga está en proceso
     * @param {boolean} show
     * @memberof BcFileDownloadBehavior
     */
    showLoader(show) {
        const loader = this.getFirstElementByClassName(FILE_DOWNLOAD_LOADER);
        const iconDownload = this.getFirstElementByClassName(FILE_DOWNLOAD_ICON);
        if (show) {
            loader.style.display = 'block';
            iconDownload.style.display = 'none';
        }
        else {
            loader.style.display = 'none';
            iconDownload.style.display = 'block';
        }
    }
    setStatusDownload(index, state) {
        const objectStatus = {};
        objectStatus.index = index;
        objectStatus.state = state;
        const downloadProgress = this.arrayStatus.find((element) => element.index === index);
        if (downloadProgress) {
            let i;
            for (i = 0; i < this.arrayStatus.length; i++) {
                if (this.arrayStatus[i].index === index) {
                    this.arrayStatus[i].state = state;
                }
            }
        }
        else {
            this.arrayStatus.push(objectStatus);
        }
        this.emitEvent(this.arrayStatus);
    }
    setUpGeneralCircularProgress() {
        if (this.generalCircularProgressBehavior) {
            return;
        }
        const loader = this.mySelf.querySelector(`.${FILE_DOWNLOAD_LOADER}`);
        this.generalCircularProgressBehavior = new BcProgressBarBehavior();
        if (this.generalCircularProgressBehavior) {
            this.generalCircularProgressBehavior.setElement(loader);
            this.generalCircularProgressBehavior.setUp();
        }
    }
    calculateGlobalProgress(index, percentComplete) {
        let globalProgressSum = 0;
        this.progressValue['progress_' + index] = percentComplete;
        let numberDownloads = Object.keys(this.progressValue).length;
        for (var progress in this.progressValue) {
            globalProgressSum += this.progressValue[progress];
        }
        const globalProgress = globalProgressSum / numberDownloads;
        this.generalCircularProgressBehavior.setProgress(globalProgress);
        if (globalProgress >= 100) {
            this.showLoader(false);
        }
    }
    emitEvent(arrayStatus) {
        return arrayStatus;
    }
}

const BC_MENU = `${BcCommonConstants.PREFIX_LIB}-menu`;
const BC_MENU_CONTENT_BODIES = `${BcCommonConstants.PREFIX_LIB}-menu-content-bodies`;
const BC_MENU_CONTENT_BODY = `${BcCommonConstants.PREFIX_LIB}-menu-content-body`;
const BC_MENU_CONTENT_BODY_ACTIVE = `${BcCommonConstants.PREFIX_LIB}-menu-content-body-active`;
const BC_MENU_HEADER = `${BcCommonConstants.PREFIX_LIB}-menu-content-header`;
const BC_MENU_HEADER_HIDDEN = `${BcCommonConstants.PREFIX_LIB}-menu-content-header-hidden`;
const BC_MENU_COLUMN = `${BcCommonConstants.PREFIX_LIB}-menu-content-column`;
const BC_MENU_DRAWER = `${BcCommonConstants.PREFIX_LIB}-menu-drawer-content`;
const BC_MENU_DRAWER_ACTIVE = `${BcCommonConstants.PREFIX_LIB}-menu-drawer-content-active`;
const BC_MENU_ITEM = `${BcCommonConstants.PREFIX_LIB}-menu-item`;
const BC_MENU_ITEM_ACTIVE = `${BcCommonConstants.PREFIX_LIB}-menu-item-active`;
const BC_MENU_MAIN_CONTENT = `${BcCommonConstants.PREFIX_LIB}-menu-main-content`;
const BC_MENU_MAIN_CONTENT_ACTIVE = `${BcCommonConstants.PREFIX_LIB}-menu-main-content-active`;
const BC_MENU_MAIN_CONTENT_SM = `${BcCommonConstants.PREFIX_LIB}-menu-content-sm`;
const BC_MENU_MAIN_CONTENT_SM_VISIBLE = `${BcCommonConstants.PREFIX_LIB}-menu-content-sm-visible`;
const BC_MENU_MAIN_CONTENT_MD = `${BcCommonConstants.PREFIX_LIB}-menu-content-md`;
const BC_MENU_MAIN_CONTENT_MD_HIDDEN = `${BcCommonConstants.PREFIX_LIB}-menu-content-md-hidden`;
const BC_MENU_FOOTER = `${BcCommonConstants.PREFIX_LIB}-menu-drawer-content-footer`;
const BC_CLOSE_BUTTON = `${BcCommonConstants.PREFIX_LIB}-icon ${BcCommonConstants.PREFIX_LIB}-sm`;
const MAX_ITEMS = 7;
const BC_MENU_COLUMNS = `${BcCommonConstants.PREFIX_LIB}-menu-columns-properties`;
const BC_MENU_SUBMENU = `${BcCommonConstants.PREFIX_LIB}-menu-submenu`;
const BC_MENU_SUBMENU_ACTIVE = `${BcCommonConstants.PREFIX_LIB}-menu-submenu-active`;
const BC_MENU_SUBMENU_FOOTER_CONTAINER = `${BcCommonConstants.PREFIX_LIB}-submenu-footer-container`;
const BC_MENU_SUBMENU_INSIDE = `${BcCommonConstants.PREFIX_LIB}-menu-submenu-inside`;
const BC_MENU_ITEM_OPTIONS = `${BcCommonConstants.PREFIX_LIB}-menu-item-options`;
const BC_MENU_ITEM_OPTIONS_ACTIVE = `${BcCommonConstants.PREFIX_LIB}-menu-options-active`;
const BC_XS = 0;
const BC_SM = 576;
const BC_MD = 768;
const BC_LG = 992;
const BC_XL = 1200;
const BC_DRAWER_ERROR = 'The drawer is not present in the DOM';
const STATE = 'state';

class BcMenuGenerator {
    constructor() {
        this.sanitizer = new BcHTMLSanitizer();
        this.initMenu();
    }
    initMenu() {
        this.menu = document.createElement('div');
        this.menu.classList.add(BC_MENU);
    }
    generate(configuration) {
        this.configuration = configuration;
        this.generateItems();
        this.generateMainContent();
        return this.menu;
    }
    generateItems() {
        if (this.configuration.items) {
            const drawer = document.createElement('ul');
            drawer.classList.add(BC_MENU_DRAWER);
            for (const item of this.configuration.items) {
                const itemElement = this.generateItem(item);
                drawer.appendChild(itemElement);
            }
            this.generateButton(drawer);
            this.menu.appendChild(drawer);
        }
    }
    generateButton(drawer) {
        if (this.configuration.closeOptions) {
            const liButtonElement = document.createElement('li');
            liButtonElement.classList.add(BC_MENU_FOOTER);
            const buttonElement = document.createElement('button');
            buttonElement.classList.add('bc-btn', 'button-secondary', 'btn-small');
            buttonElement.innerText = this.sanitizer.sanitize(this.configuration.closeOptions.text);
            buttonElement.addEventListener('click', () => {
                this.configuration.closeOptions.function();
            });
            liButtonElement.appendChild(buttonElement);
            drawer.appendChild(liButtonElement);
        }
    }
    generateItem(item) {
        const itemElement = document.createElement('a');
        itemElement.classList.add(BC_MENU_ITEM);
        itemElement.setAttribute('for', item.identifierContent);
        if (item.path && item.path !== '') {
            itemElement.href = item.path;
        }
        else {
            itemElement.href = '#';
        }
        const liElement = document.createElement('li');
        if (item.iconName) {
            const imgElement = document.createElement('img');
            imgElement.setAttribute('class', 'bc-icon-brand--sm');
            imgElement.src = `/assets/icons/brand/${item.iconName}_off.svg`;
            liElement.appendChild(imgElement);
        }
        const textElement = document.createElement('div');
        textElement.innerText = this.sanitizer.sanitize(item.text);
        liElement.appendChild(textElement);
        itemElement.appendChild(liElement);
        return itemElement;
    }
    generateMainContent() {
        if (this.configuration.contents) {
            const main = document.createElement('div');
            main.classList.add(BC_MENU_MAIN_CONTENT);
            main.appendChild(this.generateHeader());
            this.generateBodies(main);
            this.menu.appendChild(main);
        }
    }
    generateBodies(main) {
        const bodies = document.createElement('div');
        bodies.classList.add(BC_MENU_CONTENT_BODIES);
        for (const body of this.configuration.contents) {
            const content = document.createElement('div');
            content.classList.add(BC_MENU_CONTENT_BODY);
            content.id = body.identifierContent;
            this.generateColumns(content, body.columns);
            bodies.appendChild(content);
        }
        main.appendChild(bodies);
    }
    generateHeader() {
        const header = document.createElement('div');
        header.classList.add(BC_MENU_HEADER);
        const title = document.createElement('h5');
        const i = document.createElement('i');
        i.classList.add('bc-icon');
        i.classList.add('bc-sm');
        i.innerText = 'error';
        header.appendChild(title);
        header.appendChild(i);
        return header;
    }
    generateColumns(content, columns) {
        for (const columnConfig of columns) {
            const column = document.createElement('div');
            column.classList.add(BC_MENU_COLUMN);
            this.generateSections(column, columnConfig.sections);
            content.appendChild(column);
        }
    }
    generateSections(column, sections) {
        for (const section of sections) {
            const sectionElement = document.createElement('ul');
            const aTitle = document.createElement('a');
            const liTitle = document.createElement('li');
            const h6Title = document.createElement('h6');
            h6Title.innerText = section.title;
            liTitle.appendChild(h6Title);
            aTitle.appendChild(liTitle);
            sectionElement.appendChild(aTitle);
            for (const option of section.options) {
                const a = document.createElement('a');
                const li = document.createElement('li');
                li.innerText = option.text;
                if (option.path && option.path !== '') {
                    a.href = option.path;
                }
                else {
                    a.href = '#';
                }
                a.appendChild(li);
                sectionElement.appendChild(a);
            }
            column.appendChild(sectionElement);
        }
    }
}

class BcMenuElementCreator extends BcDefaultBehavior {
    constructor() {
        super();
        this.showProfileInSubmenu = false;
    }
    createHTMLElement(conf) {
        const element = document.createElement(conf.tag);
        conf.classList &&
            conf.classList.forEach((c) => {
                element.classList.add(c);
            });
        conf.attributes &&
            conf.attributes.forEach((attr) => {
                element.setAttribute(attr.name, attr.value);
            });
        return element;
    }
    createLogoutBtn() {
        const logoutBtn = document.createElement(BcCommonConstants.BUTTON_TAG);
        if (window.innerWidth >= BC_LG) {
            logoutBtn.classList.add(BcCommonConstants.BUTTON_FAB_CLASS);
            logoutBtn.classList.add(BcCommonConstants.BUTTON_FAB_MINI_CLASS);
            logoutBtn.innerHTML = `<bc-icon class="bc-icon bc-sm">quit</bc-icon>`;
        }
        else {
            logoutBtn.classList.add(BcCommonConstants.BC_BTN_CLASS);
            logoutBtn.classList.add(BcCommonConstants.BTN_SECONDARY_CLASS);
            logoutBtn.classList.add(BcCommonConstants.BUTTON_SMALL_CLASS);
            logoutBtn.innerHTML = `<bc-icon class="bc-icon bc-sm">quit</bc-icon> CERRAR SESIÓN`;
        }
        if (this.logoutFunction) {
            logoutBtn.addEventListener(BcCommonConstants.EVENT_CLICK, () => {
                this.logoutFunction();
            });
        }
        return logoutBtn;
    }
    createProfileSection() {
        const container = document.createElement(BcCommonConstants.DIV_TAG);
        container.classList.add('bc-submenu-profile-container');
        container.innerHTML = `<div class="bc-submenu-profile-icon">
              <em class="bc-icon">user</em>
          </div>
          <div class="bc-submenu-profile">
            <span>${this.profileData.user}</span>
            <a href="${this.profileData.updateUserDataUrl}">Actualizar mis datos</a>
          </div>`;
        if (!this.profileData.updateUserDataUrl) {
            container.querySelector('a').style.display = 'none';
        }
        return container;
    }
    createExtraElements() {
        this.submenu = this.createHTMLElement({
            tag: BcCommonConstants.DIV_TAG,
            classList: [BC_MENU_SUBMENU],
        });
        this.itemElement = this.createHTMLElement({
            tag: 'a',
            classList: [BC_MENU_ITEM_OPTIONS],
        });
        const liElement = this.createHTMLElement({ tag: BcCommonConstants.LI_TAG });
        const icon = 'bc-icon';
        const iconElement = this.createHTMLElement({
            tag: BcCommonConstants.EM_TAG,
            classList: [icon],
        });
        iconElement.innerText = 'menu';
        const textElement = this.createHTMLElement({ tag: BcCommonConstants.DIV_TAG });
        textElement.innerText = 'Más';
        liElement.appendChild(iconElement);
        liElement.appendChild(textElement);
        this.itemElement.appendChild(liElement);
        const headerTitle = this.createHTMLElement({
            tag: BcCommonConstants.DIV_TAG,
            classList: ['bc-submenu-title'],
        });
        const title = this.createHTMLElement({ tag: 'h3' });
        title.innerText = 'Más';
        headerTitle.appendChild(title);
        this.closeBtn = this.createHTMLElement({
            tag: BcCommonConstants.ICONS_CLASS,
            classList: [BcCommonConstants.ICONS_CLASS, BcCommonConstants.ICON_SM_CLASS],
        });
        this.closeBtn.innerHTML = 'error';
        headerTitle.appendChild(this.closeBtn);
        this.submenu.appendChild(headerTitle);
        this.logoutBtnContainer = this.createHTMLElement({
            tag: BcCommonConstants.DIV_TAG,
            classList: [BC_MENU_SUBMENU_FOOTER_CONTAINER],
        });
        this.logoutBtnContainer.appendChild(this.createLogoutBtn());
        this.submenuContentContainer = this.createHTMLElement({
            tag: BcCommonConstants.DIV_TAG,
            classList: ['bc-submenu-container'],
        });
        this.submenuListContainer = this.createHTMLElement({ tag: BcCommonConstants.DIV_TAG });
        if (this.profileData && this.profileData.user !== '') {
            this.submenuContentContainer.appendChild(this.createProfileSection());
        }
        this.submenuListContainer['style'].overflow = BcCommonConstants.HIDDEN;
        this.submenuContentContainer.appendChild(this.submenuListContainer);
    }
}

const COLLAPSED_STATE = 0;
const ACTIVE_STATE = 1;
const OPEN_STATE = 2;
class BcMenuBehavior extends BcMenuElementCreator {
    constructor() {
        super();
        this.items = new Map();
        this.bodies = new Map();
        this.state = COLLAPSED_STATE;
        this.stateSubMenu = COLLAPSED_STATE;
        this.stateOptionSubmenu = COLLAPSED_STATE;
        this.comunicationWithHeader = true;
    }
    static setUpAll() {
        const menuElements = Array.from(document.querySelectorAll(`div[class='${BC_MENU}']`));
        const elements = [];
        for (const menuElement of menuElements) {
            const element = menuElement;
            const bc = new BcMenuBehavior();
            bc.setElement(element);
            bc.setUp();
            elements.push(bc);
        }
        return elements;
    }
    /**
    * Genera el menú apartir de la configuración
    * @param {BcMenuConfig} config configuración
    * @param {Element | string} parent
    * @returns {mySelf} el menú
    * @memberof BcMenuBehavior
    */
    generateByConfig(config, parent) {
        let parentElement = parent;
        if (!(parent instanceof Element)) {
            parentElement = document.getElementById(parent.toString());
        }
        this.config = config;
        const generator = new BcMenuGenerator();
        this.mySelf = generator.generate(this.config);
        this.setUp();
        if (parentElement !== null) {
            parentElement.appendChild(this.mySelf);
        }
        return this.mySelf;
    }
    _setUp() {
        try {
            this.getElements();
            this.addEvents();
            this.closeMegaMenu();
        }
        catch (e) {
            this.isReady = false;
        }
    }
    setState(state) {
        this.state = state;
        if (this.state === COLLAPSED_STATE) {
            replaceClass(this.drawer, BC_MENU_DRAWER_ACTIVE, BC_MENU_DRAWER);
            replaceClass(this.mainContent, BC_MENU_MAIN_CONTENT_ACTIVE, BC_MENU_MAIN_CONTENT);
            this.showHideBtnFab();
        }
        else if (this.state === ACTIVE_STATE) {
            replaceClass(this.drawer, BC_MENU_DRAWER, BC_MENU_DRAWER_ACTIVE);
            replaceClass(this.mainContent, BC_MENU_MAIN_CONTENT_ACTIVE, BC_MENU_MAIN_CONTENT);
        }
        else if (this.state === OPEN_STATE) {
            replaceClass(this.mainContent, BC_MENU_MAIN_CONTENT, BC_MENU_MAIN_CONTENT_ACTIVE);
            const active = this.mySelf.querySelector(`.${BC_MENU_MAIN_CONTENT_ACTIVE}`);
            active.classList.add(BC_MENU_MAIN_CONTENT_MD);
        }
    }
    getState() {
        return this.state;
    }
    addItemsEvents() {
        let i = 0;
        this.items.forEach((item, key) => {
            const _itemClickEvent = this.openItemClick(item, key, i);
            i++;
            const _overItemEvent = () => {
                this.setItemsEvents(item);
            };
            _overItemEvent();
            window.onresize = () => {
                _overItemEvent();
            };
            item.addEventListener(BcCommonConstants.EVENT_CLICK, (event) => {
                if (item.getAttribute(BcCommonConstants.ATTR_HREF) === '#' ||
                    item.getAttribute(BcCommonConstants.ATTR_HREF) === '') {
                    event.preventDefault();
                }
                _itemClickEvent(event);
            });
        });
    }
    setItemsEvents(item) {
        if (window.innerWidth >= BC_LG) {
            item.addEventListener(BcCommonConstants.EVENT_MOUSEOVER, (event) => {
                if (item !== this.selectedItem) {
                    this.showHideBtnFab();
                }
            });
        }
        else {
            item.removeEventListener(BcCommonConstants.EVENT_MOUSEOVER, () => { });
            item.removeEventListener(BcCommonConstants.EVENT_MOUSEOUT, () => { });
        }
    }
    setInitState() {
        this.stateInitial = this.mySelf.getAttribute('state');
        if (this.stateInitial === 'open') {
            this.setState(ACTIVE_STATE);
            this.addCloseButtonEvent(ACTIVE_STATE);
        }
        else {
            this.setState(COLLAPSED_STATE);
            this.drawer.addEventListener(BcCommonConstants.EVENT_MOUSEOUT, () => {
                if (this.state === ACTIVE_STATE) {
                    this.setState(COLLAPSED_STATE);
                    this.showHideBtnFab();
                    this.changeMenuOverflow(BcCommonConstants.HIDDEN);
                }
            });
            this.addCloseButtonEvent(COLLAPSED_STATE);
        }
    }
    addCloseButtonEvent(state) {
        this.closeButton.addEventListener(BcCommonConstants.EVENT_CLICK, () => {
            this.setState(state);
            this.showHideBtnFab();
            this.toggleItem();
        });
    }
    addDrawerEvents() {
        window.addEventListener(BcCommonConstants.EVENT_KEY_UP, (event) => {
            if (event.key === BcCommonConstants.KEY_EVENT_ESCAPE) {
                this.setInitState();
            }
        });
        this.drawer.addEventListener(BcCommonConstants.EVENT_MOUSEOVER, () => {
            if (this.state === COLLAPSED_STATE) {
                this.setState(ACTIVE_STATE);
                this.showHideBtnFab();
            }
        });
    }
    addEvents() {
        this.addItemsEvents();
        this.addDrawerEvents();
        if (this.comunicationWithHeader) {
            if (this.mySelf.classList.contains('bc-menu-global-container')) {
                this.mySelf.classList.add('bc-menu-with-header');
            }
            else {
                this.mySelf.parentElement.classList.add('bc-menu-with-header');
            }
            this.toggleEvent();
            this.quantityItemsEvent();
            this.headerIsReady();
        }
    }
    getElements() {
        this.mainContent = this.mySelf.querySelector(`div[class^='${BC_MENU_MAIN_CONTENT}']`);
        if (this.mainContent !== null) {
            this.getBodies();
        }
        this.drawer = this.mySelf.querySelector(`ul[class^='${BC_MENU_DRAWER}']`);
        if (this.drawer !== null) {
            this.getItems();
        }
        else {
            throw Error(BC_DRAWER_ERROR);
        }
        this.closeButton = this.mySelf.querySelector(`.bc-menu-content-header *[class^='${BC_CLOSE_BUTTON}']`);
        this.setInitState();
    }
    validateCloseSesionButton() {
        const footer = this.mySelf.querySelector(`*[class='${BC_MENU_SUBMENU_FOOTER_CONTAINER}']`);
        if (footer) {
            if (this.items.size > MAX_ITEMS) {
                footer.remove();
            }
        }
    }
    getBodies() {
        this.groupCollectionByProperty(this.mainContent, BC_MENU_CONTENT_BODY, 'id', this.bodies);
    }
    getItems() {
        this.groupCollectionByProperty(this.drawer, BC_MENU_ITEM, 'for', this.items);
        this.items.forEach((element, key, array) => {
            if (this.bodies.get(key)) {
                const imgElement = document.createElement(BcCommonConstants.EM_TAG);
                imgElement.classList.add(BcCommonConstants.ICONS_CLASS, BcCommonConstants.X_SMALL_CLASS);
                imgElement.innerText = 'arrow2-right';
                element.querySelector(BcCommonConstants.LI_TAG).appendChild(imgElement);
            }
            this.getCurrentItemActive(element);
        });
        this.structureExtraItems();
        setTimeout(() => {
            this.validateCloseSesionButton();
        });
    }
    structureConfigByResize(width) {
        const itemsInside = this.submenu.querySelectorAll(`a[class^='${BC_MENU_ITEM}']`);
        if (width < BC_LG) {
            itemsInside.forEach((item) => {
                const identifier = item.getAttribute('for');
                const body = this.bodies.get(identifier);
                this.addItemEventClick(item, width, identifier);
                body && this.addChevronIcon(item, body);
            });
        }
        else {
            if (this.itemElement && this.itemElement.parentElement) {
                this.itemElement.classList.remove(BC_MENU_ITEM_ACTIVE);
                this.itemElement.classList.remove(BC_MENU_ITEM);
            }
            itemsInside.forEach((item) => {
                const i = item.querySelectorAll('em');
                if (i.length > 1) {
                    i[i.length - 1].innerText = 'arrow2-right';
                }
            });
            const mainContents = this.submenu.querySelectorAll(`div[class^='${BC_MENU_CONTENT_BODY}']`);
            const bodiesContainer = this.mainContent.querySelector(`div[class^='${BC_MENU_CONTENT_BODIES}']`);
            mainContents.forEach((mainContent) => {
                bodiesContainer.appendChild(mainContent);
            });
        }
    }
    structureExtraItems() {
        window.addEventListener('resize', (event) => {
            this.structureConfigByResize(event.target.innerWidth);
        });
        this.createExtraElements();
        if (this.items.size > MAX_ITEMS) {
            this.logoutBtnContainer.classList.add('bigger');
        }
        this.itemElement.addEventListener(BcCommonConstants.EVENT_CLICK, () => {
            this.addEventCloseBtn();
        });
        this.closeBtn.addEventListener(BcCommonConstants.EVENT_CLICK, () => {
            this.addEventCloseBtn();
        });
        if (this.items.size > 4) {
            this.drawer.appendChild(this.itemElement);
        }
        this.drawer.appendChild(this.submenu);
        const i = 0;
        const maxItems = 3;
        this.setItemsStructure(maxItems, i);
        this.items.set('', this.itemElement);
        this.submenuContentContainer.querySelectorAll('bc-menu-item').forEach((element) => {
            element['style'].display = '';
        });
        this.submenu.appendChild(this.submenuContentContainer);
        this.submenu.appendChild(this.logoutBtnContainer);
        this.structureConfigByResize(window.innerWidth);
        this.setSubmenuBottomPos();
    }
    setItemsStructure(maxItems, i) {
        this.items.forEach((element, key, array) => {
            if (i > maxItems) {
                if (!element.parentElement.classList.contains(BC_MENU_DRAWER)) {
                    element.parentElement['style'].display = BcCommonConstants.NONE;
                }
                const validator = element.parentElement.parentElement.querySelector('bc-menu-item');
                if (validator) {
                    this.submenuListContainer.appendChild(element.parentElement);
                }
                else {
                    this.submenuListContainer.appendChild(element);
                }
            }
            else {
                this.addEventClickOnExtra(element);
            }
            i++;
        });
    }
    groupCollectionByProperty(parent, clsName, attr, map) {
        const elements = toArray(parent.querySelectorAll(`*[class^='${clsName}']`));
        elements.forEach((item) => {
            const propertyValue = item.getAttribute(attr);
            if (propertyValue !== null) {
                map.set(propertyValue, item);
            }
        });
    }
    makeItemsInactive() {
        this.items.forEach((item, index) => {
            this.makeItemInactive(item);
        });
        this.changeMenuOverflow(BcCommonConstants.HIDDEN);
    }
    makeItemActive(item, customClass = null) {
        let classToReplace = BC_MENU_ITEM_ACTIVE;
        if (customClass !== null) {
            classToReplace = customClass;
        }
        replaceClass(item, BC_MENU_ITEM, classToReplace);
        this.setMainContenPosition(item);
        this.toggleItem();
    }
    makeItemInactive(item) {
        replaceClass(item, BC_MENU_ITEM_ACTIVE, BC_MENU_ITEM, true);
        this.toggleItem();
        this.changeMenuOverflow(BcCommonConstants.HIDDEN);
    }
    makeBodiesInactive() {
        this.bodies.forEach((item, index) => {
            this.makeBodyInactive(item);
        });
        this.changeMenuOverflow(BcCommonConstants.HIDDEN);
    }
    makeBodyActive(item) {
        replaceClass(item, BC_MENU_CONTENT_BODY, BC_MENU_CONTENT_BODY_ACTIVE);
        this.changeMenuOverflow('visible');
    }
    makeBodyInactive(item) {
        replaceClass(item, BC_MENU_CONTENT_BODY_ACTIVE, BC_MENU_CONTENT_BODY);
        this.changeMenuOverflow(BcCommonConstants.HIDDEN);
    }
    makeSubmenuInactive() {
        replaceClass(this.submenu, BC_MENU_SUBMENU_ACTIVE, BC_MENU_SUBMENU);
        const itemOptions = this.mySelf.querySelector(`.${BC_MENU_ITEM_OPTIONS}`);
        replaceClass(itemOptions, BC_MENU_ITEM_OPTIONS_ACTIVE, BC_MENU_ITEM_OPTIONS);
    }
    setMainContenPosition(item) {
        item = item ? item : this.mySelf.querySelector(`.${BC_MENU_ITEM_ACTIVE}`);
        const menu = (this.mySelf.classList.contains(BC_MENU)
            ? this.mySelf
            : this.mySelf.querySelector(`.${BC_MENU}`));
        const contentActive = menu.querySelector(`.${BC_MENU_DRAWER_ACTIVE}`);
        const el = item;
        const main = this.mainContent;
        const maxColumns = 2;
        if (window.innerWidth > BC_SM && window.innerWidth < BC_LG) {
            const bodyActive = main.querySelector(`.${BC_MENU_CONTENT_BODY_ACTIVE}`);
            const columnsActive = bodyActive ? bodyActive.children.length : 0;
            menu.classList.add(BC_MENU_MAIN_CONTENT_SM_VISIBLE);
            if (el.offsetLeft === 0) {
                main.style.left = '32px';
                if (columnsActive > maxColumns) {
                    main.classList.add(BC_MENU_COLUMNS);
                }
                else {
                    main.classList.remove(BC_MENU_COLUMNS);
                }
            }
            else {
                this.setMainContentPositionLeft(columnsActive, maxColumns, main, contentActive, el, menu);
            }
        }
        this.onResizeMainContain(menu, main);
    }
    setMainContentPositionLeft(columnsActive, maxColumns, main, contentActive, el, menu) {
        const mainWidth = 296;
        this.setMainContentWithLeftOfset(columnsActive, maxColumns, main, mainWidth, contentActive, el, menu);
    }
    setMainContentWithLeftOfset(columnsActive, maxColumns, main, mainWidth, contentActive, el, menu) {
        const contentChildren = 3;
        const factor = 2;
        if (columnsActive > 0 && columnsActive <= maxColumns) {
            const width = main.clientWidth > 0 ? main.clientWidth : mainWidth;
            if (contentActive.children[contentChildren] &&
                (contentActive.children[contentChildren].firstChild === el ||
                    contentActive.children[contentChildren] === el)) {
                const offsetRight = menu.offsetWidth - (el.offsetLeft + el.offsetWidth);
                main.style.right = `${offsetRight - width / (maxColumns * factor)}px`;
                main.style.left = 'auto';
            }
            else {
                main.style.right = 'auto';
                main.style.left = `${el.offsetLeft - width / (maxColumns * factor)}px`;
            }
        }
        else {
            main.style.left = '32px';
            main.style.width = 'calc(100vw - 60px)';
        }
    }
    showHideBtnFab() {
        if (window.innerWidth >= BC_LG) {
            const select = '.bc-submenu-footer-container';
            const footer = this.mySelf.querySelector(select)
                ? this.mySelf.querySelector(select).firstChild
                : null;
            if (footer != null) {
                if (this.drawer.className.indexOf('active') != -1) {
                    replaceClass(footer, BcCommonConstants.BUTTON_FAB_CLASS, BcCommonConstants.BC_BTN_CLASS);
                    replaceClass(footer, BcCommonConstants.BUTTON_FAB_MINI_CLASS, BcCommonConstants.BUTTON_SMALL_CLASS);
                    footer.classList.add(BcCommonConstants.BTN_SECONDARY_CLASS);
                    footer.classList.add('expanded');
                    footer.innerHTML = `<bc-icon class="bc-icon bc-sm">quit</bc-icon> CERRAR SESIÓN`;
                }
                else {
                    replaceClass(footer, BcCommonConstants.BC_BTN_CLASS, BcCommonConstants.BUTTON_FAB_CLASS);
                    replaceClass(footer, BcCommonConstants.BUTTON_SMALL_CLASS, BcCommonConstants.BUTTON_FAB_MINI_CLASS);
                    footer.classList.remove(BcCommonConstants.BTN_SECONDARY_CLASS);
                    footer.classList.remove('expanded');
                    footer.innerHTML = `<bc-icon class="bc-icon bc-sm">quit</bc-icon>`;
                }
            }
        }
    }
    quantityItemsEvent() {
        if (this.items.get('')) {
            this.items.delete('');
        }
        if (this.items.size <= MAX_ITEMS) {
            const customEvent = new CustomEvent(BcCommonConstants.EVENT_MEMU_ITEMS);
            window.dispatchEvent(customEvent);
        }
    }
    setSubmenuBottomPos() {
        window.onload = () => {
            this
                .submenu.style.height = `calc(100vh - ${this.drawer.clientHeight}px)`;
            this
                .submenu.style.bottom = `${this.drawer.clientHeight}px`;
        };
    }
    toggleEvent() {
        window.addEventListener(BcCommonConstants.EVENT_HEADER_TOGGLE_MENU, (event, t = this) => {
            let e;
            const c = new Event(BcCommonConstants.EVENT_CLICK);
            if (this.state === OPEN_STATE) {
                this.closeButton.dispatchEvent(c);
            }
            else if (this.state === ACTIVE_STATE) {
                e = new Event(BcCommonConstants.EVENT_MOUSEOUT);
                t.drawer.dispatchEvent(e);
            }
            else {
                e = new Event(BcCommonConstants.EVENT_MOUSEOVER);
                t.drawer.dispatchEvent(e);
            }
        });
    }
    toggleItem() {
        if (window.innerWidth <= BC_SM) {
            const selectorItem = BC_MENU_ITEM_ACTIVE;
            const selectorOpt = BC_MENU_ITEM_OPTIONS_ACTIVE;
            const itemActive = this.mySelf.querySelector(`.${selectorItem}`) ||
                this.mySelf.querySelector(`.${selectorOpt}`);
            const opened = new CustomEvent(BcCommonConstants.EVENT_MENU_ITEM_OPENED, {
                detail: { itemStatus: itemActive },
            });
            window.dispatchEvent(opened);
        }
    }
    changeMenuOverflow(value) {
        if (window.innerWidth >= BC_LG) {
            let menu;
            if (this.mySelf.classList.contains(BC_MENU)) {
                menu = this.mySelf;
            }
            else {
                menu = this.mySelf.querySelector('.bc-menu');
            }
            if (value === 'visible') {
                menu.classList.add(BC_MENU_MAIN_CONTENT_SM_VISIBLE);
                menu.classList.remove(BC_MENU_MAIN_CONTENT_MD_HIDDEN);
            }
            else {
                menu.classList.add(BC_MENU_MAIN_CONTENT_MD_HIDDEN);
                menu.classList.remove(BC_MENU_MAIN_CONTENT_SM_VISIBLE);
            }
        }
    }
    headerIsReady() {
        window.addEventListener(BcCommonConstants.EVENT_HEADER_EXIST, () => {
            this.quantityItemsEvent();
        });
    }
    /**
     * Asigna una función a logoutFunction al momento del deslogueo
     * @param {(param?) => void} fn
     * @memberof BcMenuBehavior
     */
    setLogoutEvent(fn) {
        this.logoutFunction = fn;
    }
    getCurrentItemActive(element) {
        if (element.classList.contains(BC_MENU_ITEM_ACTIVE)) {
            this.currentItemActive = element;
            this.makeItemActive(this.currentItemActive);
        }
    }
    openItemClick(item, key, i) {
        const maxItem = 4;
        const _itemClickEvent = (event) => {
            const j = i;
            if (window.innerWidth >= BC_LG) {
                replaceClass(this.headerMainContent, BC_MENU_HEADER_HIDDEN, BC_MENU_HEADER);
            }
            if (j < maxItem) {
                this.makeSubmenuInactive();
            }
            const _openItem = this.openItem(item, key);
            if (this.selectedItem === undefined) {
                this.selectedItem = item;
                _openItem(event);
            }
            else if (this.selectedItem === item) {
                this.selectedItem = undefined;
                this.setState(ACTIVE_STATE);
                this.makeItemInactive(item);
            }
            else {
                this.selectedItem = item;
                _openItem(event);
            }
        };
        return _itemClickEvent;
    }
    openItem(item, key) {
        const _openItem = (event) => {
            if (item.getAttribute(BcCommonConstants.ATTR_HREF) === '#' ||
                item.getAttribute(BcCommonConstants.ATTR_HREF) === '') {
                event.preventDefault();
            }
            const body = this.bodies.get(key);
            this.makeItemsInactive();
            this.makeBodiesInactive();
            this.makeBodyActive(body);
            replaceClass(this.drawer, BC_MENU_DRAWER, BC_MENU_DRAWER_ACTIVE);
            this.headerMainContent = this.mySelf.querySelector(`div[class^='${BC_MENU_HEADER}']`);
            this.headerMainContent.querySelector('h5').innerText = item.querySelector('li div').innerHTML;
            if (item.classList.contains(BC_MENU_ITEM_OPTIONS)) {
                this.makeItemActive(item, BC_MENU_ITEM_OPTIONS_ACTIVE);
            }
            else {
                this.makeItemActive(item);
            }
            this.makeItemActive(item);
            if (this.bodies.get(item.getAttribute('for'))) {
                this.setState(OPEN_STATE);
            }
            else {
                this.setState(ACTIVE_STATE);
                this.selectedItem = undefined;
            }
        };
        return _openItem;
    }
    addItemEventClick(item, width, identifier) {
        item.addEventListener(BcCommonConstants.EVENT_CLICK, () => {
            if (width < BC_LG) {
                if (this.stateOptionSubmenu === COLLAPSED_STATE) {
                    replaceClass(this.headerMainContent, BC_MENU_HEADER, BC_MENU_HEADER_HIDDEN);
                    this.stateOptionSubmenu = OPEN_STATE;
                }
                else {
                    this.stateOptionSubmenu = COLLAPSED_STATE;
                    this.makeBodyInactive(this.bodies.get(identifier));
                }
            }
            else {
                replaceClass(this.headerMainContent, BC_MENU_HEADER, BC_MENU_HEADER_HIDDEN);
            }
        });
    }
    addChevronIcon(item, body) {
        const i = item.querySelectorAll('em');
        i[i.length - 1].innerText = 'arrow2-down';
        item.parentNode.insertBefore(body, item.nextSibling);
    }
    addEventCloseBtn() {
        this.makeItemsInactive();
        if (this.stateSubMenu === COLLAPSED_STATE) {
            this.stateSubMenu = ACTIVE_STATE;
            this.makeItemActive(this.itemElement, BC_MENU_ITEM_OPTIONS_ACTIVE);
            replaceClass(this.submenu, BC_MENU_SUBMENU, BC_MENU_SUBMENU_ACTIVE, true);
        }
        else {
            this.stateSubMenu = COLLAPSED_STATE;
            replaceClass(this.submenu, BC_MENU_SUBMENU_ACTIVE, BC_MENU_SUBMENU, true);
            replaceClass(this.mainContent, BC_MENU_MAIN_CONTENT_ACTIVE, BC_MENU_MAIN_CONTENT);
            const itemOptions = this.mySelf.querySelector(`.${BC_MENU_ITEM_OPTIONS}`);
            replaceClass(itemOptions, BC_MENU_ITEM_OPTIONS_ACTIVE, BC_MENU_ITEM_OPTIONS);
        }
        this.toggleItem();
    }
    addEventClickOnExtra(element) {
        element.addEventListener(BcCommonConstants.EVENT_CLICK, () => {
            this.stateOptionSubmenu = COLLAPSED_STATE;
            this.stateSubMenu = COLLAPSED_STATE;
            this.makeSubmenuInactive();
            replaceClass(this.headerMainContent, BC_MENU_HEADER_HIDDEN, BC_MENU_HEADER);
        });
    }
    onResizeMainContain(menu, main) {
        window.onresize = (event) => {
            if (window.innerWidth > BC_SM && window.innerWidth < BC_LG) {
                main.classList.remove(BC_MENU_MAIN_CONTENT_MD);
                main.classList.add(BC_MENU_MAIN_CONTENT_SM);
                main.classList.remove(BC_MENU_COLUMNS);
                menu.classList.add(BC_MENU_MAIN_CONTENT_SM_VISIBLE);
                menu.classList.remove(BC_MENU_MAIN_CONTENT_MD_HIDDEN);
            }
            else if (window.innerWidth >= BC_LG) {
                main.classList.add(BC_MENU_MAIN_CONTENT_MD);
                main.classList.remove(BC_MENU_MAIN_CONTENT_SM);
                main.classList.remove(BC_MENU_COLUMNS);
                menu.classList.add(BC_MENU_MAIN_CONTENT_MD_HIDDEN);
                menu.classList.remove(BC_MENU_MAIN_CONTENT_SM_VISIBLE);
            }
        };
    }
    closeMegaMenu() {
        const bindingThis = this;
        const element = Array.from(document.querySelectorAll('.bc-menu-content-column ul a'));
        for (const elements of element) {
            elements.addEventListener('click', () => {
                this.setInitState();
            });
        }
    }
}

const BC_FOOTER_HIDE = `hide`;
const BC_FOOTER_TOP = `footer-top `;
const BC_FOOTER_BC_ICON = `${BcCommonConstants.PREFIX_LIB}-icon`;
const BC_FOOTER_SELECTOR = `${BcCommonConstants.PREFIX_LIB}-footer`;
const BC_FOOTER_TOP_CONTAINER_T = `${BcCommonConstants.PREFIX_LIB}-footer-top-container-t`;
const BC_FOOTER_TOP_CONTAINER_P = `${BcCommonConstants.PREFIX_LIB}-footer-top-container-p`;
const BC_FOOTER_BOTTOM = `${BcCommonConstants.PREFIX_LIB}-footer-bottom `;
const BC_FOOTER_BOTTOM_RIGHT = `${BcCommonConstants.PREFIX_LIB}-footer-bottom-right`;
const BC_FOOTER_ELEMENTS_TOPTA = `${BcCommonConstants.PREFIX_LIB}FooterElementsTopTA`;
const BC_FOOTER_ELEMENTS_TOPPA = `${BcCommonConstants.PREFIX_LIB}footerElementsTopPA`;
const BC_FOOTER_A = `a`;
const BC_FOOTER_P = `p`;
const BC_FOOTER_CLICK = `mousedown`;
const BC_FOOTER_SHOW_DOWN_ARROW = `chevron-down`;
const BC_FOOTER_SHOW_UP_ARROW = `chevron-up`;
const BC_FOOTER_NETWORK_ICONS = `${BcCommonConstants.PREFIX_LIB}-footer-bottom-right-network-icons`;
const BC_FOOTER_TOP_CONTAINERS = `${BcCommonConstants.PREFIX_LIB}-footer-top-container`;
const BC_FOOTER_TOP_LA = `${BcCommonConstants.PREFIX_LIB}-footer-top-links-ca-a`;
const BC_FOOTER_ELEMENTS_LA = `${BcCommonConstants.PREFIX_LIB}FooterElementsLA`;
const BC_FOOTER_ACCORDION_CLASS = `${BcCommonConstants.PREFIX_LIB}-accordion`;
const BC_FOOTER_MOBILE_BREAK_POINT = 578;
const BC_FOOTER_ACCORDIONS_GROUP = `${BcCommonConstants.PREFIX_LIB}-accordions-group`;
const BC_FOOTER_ACCORDION = `${BcCommonConstants.PREFIX_LIB}-accordion`;
const BC_FOOTER_ACCORDION_TYPE = `${BcCommonConstants.PREFIX_LIB}-accordion-minimal-unbordered`;
const BC_FOOTER_ACCORDION_HEADER = `${BcCommonConstants.PREFIX_LIB}-accordion-header`;
const BC_FOOTER_ACCORDION_HEADER_LEFT = `${BcCommonConstants.PREFIX_LIB}-accordion-header-left`;
const BC_FOOTER_ACCORDION_HEADER_RIGHT = `${BcCommonConstants.PREFIX_LIB}-accordion-header-right`;
const BC_FOOTER_ACCORDION_TEXT_CONTAINER = `${BcCommonConstants.PREFIX_LIB}-accordion-text-container`;
const BC_FOOTER_ACCORDION_CONTENT = `${BcCommonConstants.PREFIX_LIB}-accordion-content`;

class BcFooterBehavior extends BcDefaultBehavior {
    constructor() {
        super();
        this.bcFooterIsMobile = false;
    }
    /**
     * Metodo para implementación nativa
     * @static
     * @return {*}  {BcFooterBehavior[]}
     * @memberof BcFooterBehavior
     */
    static setUpAll() {
        const inputElements = Array.from(document.querySelectorAll(`div[class~='${BC_FOOTER_SELECTOR}']`));
        const elements = [];
        for (let inputElement of inputElements) {
            const bcFooterBehavior = new BcFooterBehavior();
            bcFooterBehavior.setElement(inputElement);
            bcFooterBehavior.setUp();
            elements.push(bcFooterBehavior);
        }
        return elements;
    }
    _setUp() {
        this.selectElements();
        this.addAccesibility();
        this.validateBreakPointMobile();
    }
    /**
     * Selecciona los elementos html
     * @memberof BcFooterBehavior
     */
    selectElements() {
        this.bcFooterElementTop = this.mySelf.querySelector(`.${BC_FOOTER_TOP}`);
        this.bcFooterElementTopCont = this.bcFooterElementTop
            ? Array.from(this.bcFooterElementTop.children) : null;
        this.bcFooterIconNetwork = this.mySelf.querySelector(`.${BC_FOOTER_NETWORK_ICONS}`);
        this.bcFooterIconNetworkChildren = this.bcFooterIconNetwork
            ? Array.from(this.bcFooterIconNetwork.children) : [];
        this.bcFooterElementsTopT = Array.from(this.mySelf.querySelectorAll(`.${BC_FOOTER_TOP_CONTAINER_T}`));
        this.bcFooterElementsTopP = Array.from(this.mySelf.querySelectorAll(`.${BC_FOOTER_TOP_CONTAINER_P}`));
        this.bcFooterElementsTopTA = Array.from(this.mySelf.querySelectorAll(`.${BC_FOOTER_TOP_CONTAINER_T} ${BC_FOOTER_P} ${BC_FOOTER_A}`));
        this.bcfooterElementsTopPA = Array.from(this.mySelf.querySelectorAll(`.${BC_FOOTER_TOP_CONTAINER_P} ${BC_FOOTER_P} ${BC_FOOTER_A}`));
        this.bcFooterElementsLA = Array.from(this.mySelf.querySelectorAll(`.${BC_FOOTER_TOP_LA}`));
        this.bcfooterAccordions = Array.from(this.mySelf.querySelectorAll(`div[class~='${BC_FOOTER_ACCORDION_CLASS}']`));
    }
    /**
     * Agrega accesibilidad a los links y redes sociales
     * @memberof BcFooterBehavior
     */
    addAccesibility() {
        this.addAcceSocialNet();
        this.addAcceLinks();
    }
    /**
     * Agrega accesibilidad a las redes sociales
     * @memberof BcFooterBehavior
     */
    addAcceSocialNet() {
        for (const e of this.bcFooterIconNetworkChildren) {
            addFocusable(e, { label: `Ir a ${e.firstElementChild.innerHTML}` });
        }
    }
    /**
     * Agrega accesibilidad a los links del footer
     * @memberof BcFooterBehavior
     */
    addAcceLinks() {
        this.addAcceLink(BC_FOOTER_ELEMENTS_TOPTA);
        this.addAcceLink(BC_FOOTER_ELEMENTS_TOPPA);
        this.addAcceLink(BC_FOOTER_ELEMENTS_LA);
    }
    /**
     * Metodo para agregar las etiquetas de accesibilidad a los links
     * @param {string} href
     * @memberof BcFooterBehavior
     */
    addAcceLink(href) {
        this[href].forEach((elemA) => {
            this.addFocusableLink(elemA);
        });
    }
    /**
     * Agregar addFocusable al elemento html
     * @param {Element} elem
     * @memberof BcFooterBehavior
     */
    addFocusableLink(elem) {
        addFocusable(elem, { label: `Ir a ${elem.innerHTML}` });
    }
    /**
     * Obtiene todos los bc-footer-containers
     * @memberof BcFooterBehavior
     */
    getFooterTopELements() {
        return Array.from(this.mySelf.querySelectorAll(`div[class~='${BC_FOOTER_TOP_CONTAINERS}']`));
    }
    /**
    * Valida que la pantalla sea de tamaño mobil
    * Aplica estilos de acordion
    * @memberof BcFooterBehavior
    */
    validateBreakPointMobile() {
        const validateSizeWidth = () => {
            if ((window.innerWidth <= BC_FOOTER_MOBILE_BREAK_POINT && !this.bcFooterIsMobile)) {
                this.addAccordion();
            }
        };
        window.addEventListener('load', () => {
            validateSizeWidth();
        });
        window.addEventListener('resize', () => {
            validateSizeWidth();
        });
    }
    /**
    * Implementa las acordiones en el footer
    * @memberof BcFooterBehavior
    */
    addAccordion() {
        this.bcFooterIsMobile = true;
        this.getFooterTopELements().forEach((element, index) => {
            const textTitleList = element.querySelector(`.${BC_FOOTER_TOP_CONTAINER_T} h6`);
            const textItemsList = Array.from(element.querySelectorAll(`.${BC_FOOTER_TOP_CONTAINER_P} a`));
            const accordionGroupElement = this.createAccordionGroupELement(index);
            const accordionElement = this.createAccordionELement();
            const accordionHeaderElement = this.createAccordionHeaderELement(textTitleList, textItemsList.length);
            const accordionContentElement = this.createAccordionContentELement(textItemsList);
            accordionElement.appendChild(accordionHeaderElement);
            accordionElement.appendChild(accordionContentElement);
            accordionGroupElement.appendChild(accordionElement);
            element.appendChild(accordionGroupElement);
            BcAccordionBehavior.setUpAll();
        });
    }
    /**
    * Crea un grupo de acordiones
    * @memberof BcFooterBehavior
    */
    createAccordionGroupELement(index) {
        const accordionGroupElement = document.createElement('div');
        accordionGroupElement.classList.add(BC_FOOTER_ACCORDIONS_GROUP);
        accordionGroupElement.setAttribute('id', this.mySelf.getAttribute('id') + index);
        return accordionGroupElement;
    }
    /**
   * Crea una acordion
   * @memberof BcFooterBehavior
   */
    createAccordionELement() {
        const accordionElement = document.createElement('div');
        accordionElement.classList.add(BC_FOOTER_ACCORDION);
        accordionElement.classList.add(BC_FOOTER_ACCORDION_TYPE);
        return accordionElement;
    }
    /**
   * Crea la cabecera de una acordion
   * @memberof BcFooterBehavior
   */
    createAccordionHeaderELement(titleHeader, numberItems) {
        const accordionHeaderElement = document.createElement('div');
        accordionHeaderElement.classList.add(BC_FOOTER_ACCORDION_HEADER);
        const templateHeaderRight = numberItems > 0 ?
            `<div class="${BC_FOOTER_ACCORDION_HEADER_RIGHT}">
      <em class="bc-icon bc-sm bc-toggle-button">arrow2-down</em>
    </div>
    ` : '';
        const templateHeader = `
    <div class="${BC_FOOTER_ACCORDION_HEADER_LEFT}">
      <div class="${BC_FOOTER_ACCORDION_TEXT_CONTAINER}">
      </div>
    </div>
    ${templateHeaderRight}
    `;
        accordionHeaderElement.innerHTML = templateHeader;
        accordionHeaderElement.querySelector(`.${BC_FOOTER_ACCORDION_TEXT_CONTAINER}`).append(titleHeader.cloneNode(true));
        return accordionHeaderElement;
    }
    /**
   * Crea el cuerpo o contenido de la acordion
   * @memberof BcFooterBehavior
   */
    createAccordionContentELement(items) {
        const accordionContentElement = document.createElement('div');
        accordionContentElement.classList.add(BC_FOOTER_ACCORDION_CONTENT);
        items.forEach(item => {
            accordionContentElement.appendChild(item.cloneNode(true));
        });
        return accordionContentElement;
    }
    /** Metodo que permite parametrizar los colores del trazo
   * @memberof BcFooterBehavior
   */
    createParameterizationStrokeColors(colors) {
        const svg = this.mySelf.querySelector('#bc-footer-stroke');
        for (let propiedad in colors) {
            const pathElement = svg.querySelector('#' + propiedad);
            pathElement.setAttribute('fill', colors[propiedad]);
        }
    }
}

const SWIPE_CLASS = `${BcCommonConstants.PREFIX_LIB}-carousel`;
const SLIDER_CLASS = `${SWIPE_CLASS}-items-container`;
const SWIPE_MIN_SPEED = 1;
const SWIPE_CERO = 0;
const SWIPE_NUMBER_2 = 2;
const SWIPE_NUMBER_10 = 10;
const SWIPE_NUMBER_50 = 50;
const SWIPE_NUMBER_100 = 100;
const SWIPE_NUMBER_500 = 500;
const SWIPE_EASE = 0.9;
const SLIDER_STEP = 100;
const SWIPE_NOT_CONTENT_CLASS_ELEMENTS = 'null slides content div';

function round(n, p = 0) {
    var p = (p === 0) ? SWIPE_NUMBER_100 : Math.pow(SWIPE_NUMBER_10, p);
    return Math.round(n * p) / p;
}
function clamp(number, lower, upper) {
    return Math.min(Math.max(number, lower), upper);
}
class BcAbstractSwipeBehavior extends BcDefaultBehavior {
    constructor() {
        super();
        this.current = 0;
        this.vWidth = 0;
        this.mWidth = 0;
        this.target = 0;
        this.timeSettingCss = SWIPE_NUMBER_500;
        this.curDown = false;
        this.rAF = null;
        this.initialized = false;
        this.numListeners = 0;
        this.listeners = [];
        this.lastOffset = 0;
        this.finalPositionSlider = SWIPE_NUMBER_50;
        this.positionTranslateYX = 0;
        this.calc = (event) => {
            this.target += event.X;
            this.clampTarget();
            if (this.rAF === null) {
                requestAnimationFrame(this.moveSlider);
            }
        };
        this.moveSlider = () => {
            const offset = (this.target - this.current);
            this.current += offset * SWIPE_EASE;
            const currentRound = round(this.current);
            this.setCSS(currentRound);
            if (parseInt(offset.toFixed(SWIPE_NUMBER_2)) == 0) {
                this.rAF = null;
                if (this.config.infinity) {
                    this.restoreSwipe(offset);
                }
                else {
                    this.pivots(offset, currentRound);
                }
            }
            else {
                this.rAF = requestAnimationFrame(this.moveSlider);
            }
            this.config.onMoving && this.config.onMoving(currentRound);
        };
        this.pivots = (offset, xValue) => {
            const bounce = (starting, to) => {
                this.setCSS(starting + to);
                setTimeout(() => {
                    this.setCSS(starting);
                }, this.timeSettingCss);
            };
            if (this.isLastClamp(offset)) {
                bounce(xValue, -this.finalPositionSlider);
            }
            if (this.isStartClamp()) {
                bounce(xValue, this.finalPositionSlider);
            }
        };
        this.restoreSwipe = (offset) => {
            if (this.isLastClamp(offset)) {
                this.moveSliderTo(0);
            }
            if (this.isStartClamp()) {
                this.moveSliderTo(this.mWidth * -1);
            }
        };
        /**
         * valida que el swipe llego al limite inicial
         */
        this.isStartClamp = () => (this.swipeToLeft && this.target == SWIPE_CERO);
        this.onResize = () => {
            const parentWidth = this.mySelf.getBoundingClientRect().width;
            const contentWidth = this.containerItems.getBoundingClientRect().width;
            this.vWidth = window.innerWidth;
            this.mWidth = contentWidth + (this.vWidth - parentWidth);
            this.clampTarget();
            this.rAF = requestAnimationFrame(this.moveSlider);
        };
        this.on = (f) => {
            if (!this.initialized) {
                this.addListeners();
            }
            this.listeners.push(f);
            this.numListeners = this.listeners.length;
        };
        this.notify = (e) => {
            const _e = (this.isTouch && e.targetTouches) ? e.targetTouches[0] : e;
            this.swipeEvent.X = (_e.pageX - this.swipeEvent.initialX) * this.config.speed;
            this.swipeEvent.Y = (_e.pageY - this.swipeEvent.initialY) * this.config.speed;
            this.swipeEvent.originalEvent = e;
            this.swipeEvent.cursorDown = this.curDown;
            this.swipeEvent.initialX = _e.pageX;
            this.swipeEvent.initialY = _e.pageY;
            for (let i = 0; i < this.numListeners; i++) {
                this.listeners[i](this.swipeEvent);
            }
        };
        this.onDrag = (e) => {
            if (this.curDown) {
                e.preventDefault();
                this.notify(e);
                if (e.type == 'mousemove') {
                    this.setDirection(e.screenX);
                }
            }
        };
        this.onDragStart = (e) => {
            const _e = (this.isTouch && e.targetTouches) ? e.targetTouches[0] : e;
            this.swipeEvent.initialX = _e.pageX;
            this.swipeEvent.initialY = _e.pageY;
            this.curDown = true;
            this.setDirection(_e.screenX);
        };
        this.onDragEnd = (e) => {
            this.curDown = false;
        };
        this.onMouseLeave = (e) => {
            this.onDragEnd(e);
        };
        this.addListeners = () => {
            if (this.hasMouseEvent) {
                this.mySelf.addEventListener('mouseleave', this.onMouseLeave);
                this.mySelf.addEventListener('mouseup', this.onDragEnd);
                this.mySelf.addEventListener('mousedown', this.onDragStart);
                this.mySelf.addEventListener('mousemove', this.onDrag);
            }
            if (this.hasTouchEvent) {
                this.mySelf.addEventListener('touchmove', this.onDrag);
                this.mySelf.addEventListener('touchend', this.onDragEnd);
                this.mySelf.addEventListener('touchstart', this.onDragStart);
            }
        };
        this.removeListeners = () => {
            if (this.hasMouseEvent) {
                this.mySelf.removeEventListener('mouseleave', this.onMouseLeave);
                this.mySelf.removeEventListener('mouseup', this.onDragEnd);
                this.mySelf.removeEventListener('mousedown', this.onDragStart);
                this.mySelf.removeEventListener('mousemove', this.onDrag);
            }
            if (this.hasTouchEvent) {
                this.mySelf.removeEventListener('touchmove', this.onDrag);
                this.mySelf.removeEventListener('touchend', this.onDragEnd);
                this.mySelf.removeEventListener('touchstart', this.onDragStart);
            }
        };
    }
    _setUp() {
        this.initConfiguration();
        this.getElements();
        this.init();
    }
    init() {
        this.swipeInit();
        this.on((e) => this.calc(e));
        this.mySelf.addEventListener(BcCommonConstants.EVENT_RESIZE, this.onResize);
        this.onResize();
    }
    /**
     * Setea los parámetros de configuración definidos en la interfaz BcSwipeConfig
     * @param {BcSwipeConfig} config
     * @memberof BcAbstractSwipeBehavior
     */
    setConfig(config) {
        this.config = config;
        this.initConfiguration();
    }
    /**
     * Configuración default carousel
     * @memberof BcAbstractSwipeBehavior
     */
    initConfiguration() {
        this.config = {
            speed: SWIPE_MIN_SPEED,
            contentItemsClass: SWIPE_CLASS,
            sliderClass: SLIDER_CLASS,
            step: SLIDER_STEP,
            infinity: false,
            ...(this.config || {})
        };
    }
    getElements() {
        const contentItemsClass = this.mySelf.querySelector(`.${this.config.contentItemsClass}`);
        if (!contentItemsClass) {
            throw SWIPE_NOT_CONTENT_CLASS_ELEMENTS;
        }
        this.containerItems = contentItemsClass;
    }
    swipeInitConfig() {
        this.swipeEvent = {
            X: SWIPE_CERO,
            Y: SWIPE_CERO,
            cursorDown: false,
            initialX: SWIPE_CERO,
            initialY: SWIPE_CERO,
            originalEvent: null
        };
        this.initialized = false;
        this.curDown = false;
        this.numListeners = SWIPE_CERO;
        this.listeners = [];
    }
    setDirection(lastOffset) {
        this.swipeToLeft = lastOffset > this.lastOffset;
        this.lastOffset = lastOffset;
    }
    /**
     * Se utiliza para despazar el slider a la izquierda
     * @memberof BcAbstractSwipeBehavior
    */
    moveSliderToLeft(toLeft) {
        this.target = toLeft ? this.target + this.config.step : this.target - this.config.step;
        this.clampTarget();
        this.moveSlider();
    }
    /**
     * Se utiliza para identificar en que posicion se va a mover el slider
     * al dar clic en los bullets
     * @memberof BcAbstractSwipeBehavior
    */
    moveSliderTo(value) {
        this.target = value;
        this.clampTarget();
        this.moveSlider();
    }
    setCSS(position) {
        const x = `${Math.ceil(position)}px`;
        this.containerItems.style.transform = `translate3d(${x},${this.positionTranslateYX},${this.positionTranslateYX})`;
    }
    /**
     * valida que el swipe llego al limite final
     */
    isLastClamp(moveTo) {
        return (!this.swipeToLeft && this.target < SWIPE_CERO && this.target == this.current && moveTo == SWIPE_CERO);
    }
    clampTarget() {
        const max = this.mWidth - this.vWidth;
        this.target = clamp(this.target, -1 * max, 0);
    }
    detectInterationType() {
        this.hasMouseEvent = 'onmousedown' in document;
        this.hasTouchEvent = 'ontouchstart' in document;
        const supportsMultitouch = navigator.maxTouchPoints && navigator.maxTouchPoints > 1;
        this.isTouch = this.hasTouchEvent || supportsMultitouch;
    }
    swipeInit() {
        this.swipeInitConfig();
        this.detectInterationType();
    }
}

const CAROUSEL_CLASS = `${BcCommonConstants.PREFIX_LIB}-carousel`;
const CAROUSEL_LOADING_CLASS = `${CAROUSEL_CLASS}-loading`;
const CAROUSEL_INITIALIZED_CLASS = `${CAROUSEL_CLASS}-initialized`;
const CAROUSEL_HIDE_CLASS = `${CAROUSEL_CLASS}-hide`;
const CAROUSEL_GRID_CLASS = `${CAROUSEL_CLASS}-grid`;
const CAROUSEL_LIST_CLASS = `${CAROUSEL_CLASS}-list`;
const CAROUSEL_TRACK_CLASS = `${CAROUSEL_CLASS}-track`;
const CAROUSEL_ITEM_CLASS = `${CAROUSEL_CLASS}-item`;
const CAROUSEL_ROW_CLASS = `${CAROUSEL_CLASS}-row`;
const CAROUSEL_CELL_CLASS = `${CAROUSEL_CLASS}-cell`;
const CAROUSEL_COLSPAN_CLASS = `${CAROUSEL_CLASS}-colspan`;
const CAROUSEL_ARROW_CLASS = `${CAROUSEL_CLASS}-arrow`;
const CAROUSEL_ARROW_PREV_CLASS = `${CAROUSEL_CLASS}-arrow-prev`;
const CAROUSEL_ARROW_NEXT_CLASS = `${CAROUSEL_CLASS}-arrow-next`;
const CAROUSEL_BULLETS_CLASS = `${CAROUSEL_CLASS}-bullets`;
const CAROUSEL_BULLET_ITEM_CLASS = `${CAROUSEL_CLASS}-bullet-item`;
const CAROUSEL_BULLET_CLASS = `${CAROUSEL_CLASS}-bullet`;
const CAROUSEL_ACTIVE_BULLET_CLASS = `active`;
const CAROUSEL_CONTROL_LEFT_NAME = 'arrow-left';
const CAROUSEL_CONTROL_RIGHT_NAME = 'arrow-right';
const CAROUSEL_MOVE_TO = 'move-to';
const IS_STRING = 'string';
const CAROUSEL_CONTENT_NUMBER_PAGINATOR_CLASS = `${BcCommonConstants.PREFIX_LIB}-content-number-paginator`;
const CAROUSEL_CONTAINER_TOP_BUTTON_CLASS = `${CAROUSEL_CLASS}-container-top-button`;
const CAROUSEL_CONTAINER_BOTTOM_BUTTON_CLASS = `${CAROUSEL_CLASS}-container-bottom-button`;
const CAROUSEL_SWIPE_SPEED = 2;
const CAROUSEL_ITEMS_SPACE_BETWEEN = 3;
const CAROUSEL_ARIA_HIDDEN = 'aria-hidden';
const CAROUSEL_ARIA_LABEL = 'aria-label';
const CAROUSEL_ARIA_ROL_DESCRIPTION = 'aria-roledescription';
const CAROUSEL_ROL_ITEM = 'rol';
const CAROUSEL_ARIA_CONTROLS = 'aria-controls';
const CAROUSEL_TEXT_SLIDE_NEXT = 'Siguiente slide';
const CAROUSEL_TEXT_SLIDE_PREV = 'Anterior slide';
const CAROUSEL_DEFAULT_INTERVAL_TIMEOUT = 4000;
const COROUSEL_ID_CONTENT = 100;
const COROUSEL_TRACK_WIDTH = 500;

class BcCarouselBehavior extends BcAbstractSwipeBehavior {
    constructor() {
        super();
        this.options = null;
        this.slidesElements = [];
        this.currentIndex = 0;
        this.currentSlide = 0;
        this.slideCount = 0;
        this.pageNumber = '';
        this.prevArrow = null;
        this.nextArrow = null;
        this.bulletContent = null;
        this.slidesTrack = null;
        this.bullets = [];
        this.sliderWidth = 0;
        this.slideWidth = 0;
        this.slideOffset = 0;
        this.slideTrackWidth = 0;
        this.interval = 0;
        this.defaultIntervalTimeout = CAROUSEL_DEFAULT_INTERVAL_TIMEOUT;
        this.hideElement = (el, hide) => {
            if (hide) {
                el.classList.add(CAROUSEL_HIDE_CLASS);
                el.setAttribute(CAROUSEL_ARIA_HIDDEN, 'true');
            }
            else {
                el.classList.remove(CAROUSEL_HIDE_CLASS);
                el.setAttribute(CAROUSEL_ARIA_HIDDEN, 'false');
            }
        };
    }
    _setUp() {
        this.initOptions();
        this.initilize();
        this.setConfiguration();
        super._setUp();
        this.addEventListener();
    }
    setOptions(options) {
        this.options = options;
        this.initOptions();
    }
    createItems() {
        if (this.options && this.options.items.length > 0) {
            const { items } = this.options;
            items.forEach((item, i) => {
                const li = this.createItem(item);
                this.slidesElements[i] = li;
            });
            const content = this.mySelf.querySelector(`${BcCommonConstants.SECTION_TAG}.${CAROUSEL_LIST_CLASS}`);
            content.innerHTML = '';
            content.appendChild(createElement({
                element: BcCommonConstants.UL_TAG,
                classList: [CAROUSEL_TRACK_CLASS],
                children: this.slidesElements
            }));
            this.setSlideCount(items.length);
        }
    }
    setSlideCount(nSlides) {
        this.slideCount = nSlides;
    }
    initilize() {
        this.getContentItems();
        this.checkItems();
        this.buildBullets();
        this.addArrows();
        this.setupInfinite();
        this.setPosition();
        this.updateBullets();
        this.updateArrows();
        this.setupAutoPlay();
        this.changeDataAccessibility();
    }
    changeDataAccessibility() {
        const amountOfItems = this.mySelf.querySelectorAll(`.${CAROUSEL_ITEM_CLASS}`);
        const lengthItems = amountOfItems.length;
        amountOfItems.forEach((item, i) => {
            item.setAttribute(CAROUSEL_ARIA_LABEL, `${i + 1} de ${lengthItems}`);
            item.setAttribute(CAROUSEL_ARIA_ROL_DESCRIPTION, 'slide');
            item.setAttribute(CAROUSEL_ROL_ITEM, 'group');
        });
        this.mySelf.setAttribute(CAROUSEL_ARIA_ROL_DESCRIPTION, 'carousel');
    }
    buildBullets() {
        if (!this.options.bullets) {
            return;
        }
        if (this.options.bullets === true && this.slideCount > this.options.slidesToShow) {
            const bulletsQty = this.getBulletQty();
            for (let i = 0; i < bulletsQty; i += 1) {
                this.bullets[i] = this.createBullet();
            }
            this.getArrows();
            if (this.options.arrowsInBullets) {
                this.bullets.push(this.nextArrow);
                this.bullets.unshift(this.prevArrow);
            }
            this.createBulletsContent();
            this.mySelf.append(this.bulletContent);
            this.bullets[1].classList.add(CAROUSEL_ACTIVE_BULLET_CLASS);
        }
    }
    updateBullets() {
        if (this.bullets && this.bullets.length > 0) {
            const bulletActive = this.bullets.find(el => el.classList.contains(CAROUSEL_ACTIVE_BULLET_CLASS));
            this.bulletRemove(bulletActive);
            const index = this.getBulletPosByIndex();
            let bulletToActive;
            bulletToActive = this.bulletsToActivate(index, bulletToActive);
            this.bulletActiveRemove(bulletToActive);
        }
    }
    bulletsToActivate(index, bulletToActive) {
        if (this.options.arrowsInBullets) {
            if (index && this.bullets[index].classList[0] === `${CAROUSEL_CLASS}-arrow`) {
                bulletToActive = this.bullets[1];
            }
            else if (index === this.bullets.length && this.bullets[index].classList[0] === `${CAROUSEL_CLASS}-arrow`) {
                const indexArrow = this.bullets.length - 1;
                bulletToActive = this.bullets[indexArrow];
            }
            else {
                bulletToActive = this.bullets[index];
            }
        }
        else {
            bulletToActive = this.bullets[index];
        }
        return bulletToActive;
    }
    bulletRemove(bulletActive) {
        if (bulletActive) {
            bulletActive.classList.remove(CAROUSEL_ACTIVE_BULLET_CLASS);
        }
    }
    bulletActiveRemove(bulletToActive) {
        if (bulletToActive) {
            bulletToActive.classList.add(CAROUSEL_ACTIVE_BULLET_CLASS);
        }
    }
    getBulletPosByIndex() {
        const index = this.currentSlide, jump = this.options.slidesToScroll;
        for (let i = 0, k = 0; i <= this.getBulletQty() * jump; i += jump, k++) {
            if (index >= i && index < i + jump) {
                return k;
            }
        }
        return index;
    }
    createBulletsContent() {
        this.bulletContent = createElement({
            element: BcCommonConstants.DIV_TAG,
            classList: [CAROUSEL_BULLETS_CLASS],
            children: [
                createElement({
                    element: BcCommonConstants.UL_TAG,
                    children: this.bullets
                })
            ]
        });
    }
    createNumberPaginator() {
        const contentItems = this.mySelf.querySelector(`.${CAROUSEL_CONTENT_NUMBER_PAGINATOR_CLASS} > ${BcCommonConstants.P_TAG}`);
        if (!contentItems) {
            const content = createElement({
                element: BcCommonConstants.DIV_TAG,
                classList: [CAROUSEL_CONTENT_NUMBER_PAGINATOR_CLASS],
                children: [
                    createElement({
                        element: BcCommonConstants.P_TAG,
                        innerText: this.pageNumber,
                    })
                ]
            });
            this.mySelf.append(content);
        }
        else {
            contentItems.innerHTML = this.pageNumber;
        }
    }
    createBullet() {
        return createElement({
            element: BcCommonConstants.LI_TAG,
            classList: [CAROUSEL_BULLET_ITEM_CLASS],
            children: [
                createElement({
                    element: BcCommonConstants.BUTTON_TAG,
                    classList: [CAROUSEL_BULLET_CLASS],
                })
            ],
        });
    }
    getBulletQty() {
        const { slidesToScroll, slidesToShow } = this.options;
        return this.slideCount / (slidesToScroll >= slidesToShow ? slidesToScroll : slidesToShow);
    }
    initOptions() {
        this.options = {
            spacingBetweenItems: CAROUSEL_ITEMS_SPACE_BETWEEN,
            iconNamePrev: CAROUSEL_CONTROL_LEFT_NAME,
            iconNameNext: CAROUSEL_CONTROL_RIGHT_NAME,
            swipeSpeed: CAROUSEL_SWIPE_SPEED,
            items: [],
            arrows: true,
            bullets: false,
            accessibility: true,
            initialSlide: 0,
            slidesToShow: 1,
            slidesToScroll: 1,
            swipe: true,
            variableWidth: false,
            infinity: false,
            gridSystem: false,
            arrowsInBullets: false,
            autoPlay: false,
            sliderPagination: false,
            autoplayTimeout: 4000,
            ...(this.options || {}),
        };
        this.currentSlide = this.options.initialSlide;
    }
    setupInfinite() {
        if (!this.options.infinity) {
            return;
        }
    }
    pauseAutoPlay() {
        clearInterval(this.interval);
    }
    listenerMoveItem() {
        let screenXInitial = 0;
        let screenXEnd = 0;
        const listenerItem = this.mySelf.querySelector(`.${CAROUSEL_TRACK_CLASS}`);
        listenerItem.addEventListener(BcCommonConstants.EVENT_MOUSEDOWN, (e) => {
            screenXInitial = e.clientX;
        });
        listenerItem.addEventListener(BcCommonConstants.EVENT_MOUSEUP, (e) => {
            screenXEnd = e.clientX;
            if (screenXInitial !== screenXEnd) {
                this.pauseAutoPlay();
            }
        });
    }
    setupAutoPlay() {
        if (this.options.autoPlay && this.bullets && this.bullets.length > 0) {
            this.listenerMoveItem();
            if (!this.interval) {
                this.interval = setInterval(() => {
                    const activeBullet = this.bullets.find(el => el.classList.contains(CAROUSEL_ACTIVE_BULLET_CLASS));
                    if (activeBullet) {
                        let nextBullet = activeBullet.nextElementSibling;
                        if (nextBullet == null || !nextBullet.classList.contains(CAROUSEL_BULLET_ITEM_CLASS)) {
                            nextBullet = this.bullets[0];
                        }
                        nextBullet.dispatchEvent(new Event(BcCommonConstants.EVENT_CLICK));
                    }
                }, this.defaultIntervalTimeout || this.options.autoplayTimeout);
            }
        }
    }
    addEventListener() {
        this.onCLick(this.prevArrow, this.onLeftClick);
        this.onCLick(this.nextArrow, this.onRightClick);
        this.bulletsEventListeners();
    }
    bulletsEventListeners() {
        if (this.options.bullets && this.slideCount > this.options.slidesToShow) {
            const leftTo = Math.ceil(this.slideTrackWidth / this.getBulletQty());
            if (this.options.arrowsInBullets) {
                this.bullets.shift();
                this.bullets.pop();
            }
            this.bullets.forEach((el, i) => {
                el.setAttribute(CAROUSEL_MOVE_TO, (leftTo * i).toString());
                el.addEventListener(BcCommonConstants.EVENT_CLICK, () => {
                    const index = el.getAttribute(CAROUSEL_MOVE_TO);
                    const moveTo = this.getValidLeft(index, true);
                    this.moveSliderTo(moveTo);
                });
            });
        }
    }
    getValidLeft(leftTo, updateComponent = false) {
        leftTo = typeof leftTo === IS_STRING ? parseInt(leftTo) : leftTo;
        leftTo = leftTo < 0 ? leftTo * -1 : leftTo;
        let moveTo = this.moveValidLeft(leftTo);
        this.currentSlide = Math.floor(moveTo / this.slideWidth);
        if (updateComponent) {
            this.updateArrows();
            this.updateBullets();
        }
        return moveTo * -1;
    }
    moveValidLeft(leftTo) {
        const length = this.slideCount;
        let moveTo = 0, i = 0;
        for (i = 0; i < length; i++) {
            const from = this.slideWidth * i;
            const to = from + this.slideWidth / CAROUSEL_SWIPE_SPEED;
            const next = this.slideWidth * (i + 1);
            if (i == length - 1 && leftTo >= from) {
                moveTo = from;
            }
            else if (from <= leftTo && to >= leftTo) {
                moveTo = from;
            }
            else if (i < length - 1 && to <= leftTo && next >= leftTo) {
                moveTo = next;
            }
        }
        return moveTo;
    }
    onCLick(control, event) {
        event = event.bind(this);
        control.addEventListener(BcCommonConstants.EVENT_CLICK, (e) => {
            event(e);
        });
        addFocusable(control, {}, { event });
    }
    createItem(item) {
        const li = createElement({
            element: BcCommonConstants.LI_TAG,
            classList: [
                CAROUSEL_ITEM_CLASS,
                `${BcCommonConstants.PREFIX_LIB}-mx-${this.options.spacingBetweenItems}`,
                `${BcCommonConstants.PREFIX_LIB}-my-3`,
                (item.hidden ? BcCommonConstants.INVISIBLE_CLASS : '_')
            ],
            children: [
                item.content
            ]
        });
        return li;
    }
    getSlidesTrack() {
        const slidesTrack = this.mySelf.querySelector(`*.${CAROUSEL_TRACK_CLASS}`);
        if (slidesTrack) {
            this.slidesTrack = slidesTrack;
            return;
        }
        this.buildSlidesTrack();
    }
    buildSlidesTrack() {
        const slidesTrack = createElement({
            element: BcCommonConstants.DIV_TAG,
            classList: [CAROUSEL_TRACK_CLASS],
        });
        this.containerItems.append(slidesTrack);
        this.slidesTrack = slidesTrack;
    }
    getContentItems() {
        const contentItems = this.mySelf.querySelector(`.${CAROUSEL_LIST_CLASS}`);
        if (contentItems) {
            this.containerItems = contentItems;
            this.addIdClassList();
            return;
        }
        this.buildContentItems();
    }
    addIdClassList() {
        const contentItems = this.mySelf.querySelector(`.${CAROUSEL_LIST_CLASS}`);
        const idContent = Math.floor(Math.random() * COROUSEL_ID_CONTENT);
        contentItems.id = `${CAROUSEL_LIST_CLASS}-${idContent}`;
    }
    buildContentItems() {
        const content = createElement({
            element: BcCommonConstants.SECTION_TAG,
            classList: [CAROUSEL_LIST_CLASS],
        });
        this.mySelf.append(content);
        this.containerItems = content;
        this.addIdClassList();
    }
    cleanItems() {
        this.options.items = [];
        this.slidesElements = [];
    }
    checkItems() {
        if (this.options.gridSystem) {
            this.addGridOut();
            this.getGridItems();
            return;
        }
        this.getItems();
    }
    addGridOut() {
        this.mySelf.classList.add(CAROUSEL_GRID_CLASS);
    }
    addIdItemGrid(data) {
        data.forEach((item, i) => {
            item.id = `slide-${i}`;
        });
    }
    getGridItems() {
        const items = Array.from(this.mySelf.querySelectorAll(`*.${CAROUSEL_ITEM_CLASS}`));
        const itemsRowSlide = Array.from(this.mySelf.querySelectorAll(`*.${CAROUSEL_ROW_CLASS}`));
        if (items.length == 0) {
            this.createGridItems();
            return;
        }
        else if (itemsRowSlide.length > 0) {
            this.addIdItemGrid(items);
            this.slidesElements = itemsRowSlide;
            this.loadItemGrid(itemsRowSlide);
            return;
        }
        this.cleanItems();
        this.loadGridItemsObject(items);
    }
    loadGridItemsObject(items) {
        items.forEach((item, i) => {
            this.checkSpacing(item);
        });
        this.setSlideCount(items.length);
    }
    createGridItems() {
        if (this.options && this.options.items.length > 0) {
            const { items } = this.options;
            items.forEach((item, i) => {
                const li = this.createGridItem(item);
                this.slidesElements[i] = li;
            });
            const content = this.mySelf.querySelector(`${BcCommonConstants.SECTION_TAG}.${CAROUSEL_LIST_CLASS}`);
            content.innerHTML = '';
            content.appendChild(createElement({
                element: BcCommonConstants.UL_TAG,
                classList: [CAROUSEL_TRACK_CLASS],
                children: this.slidesElements
            }));
        }
    }
    loadItemGrid(items) {
        items.forEach((item) => {
            for (const element of item.children) {
                if (!element.classList.contains(CAROUSEL_ROW_CLASS)) {
                    element.classList.add(CAROUSEL_CELL_CLASS, `${BcCommonConstants.PREFIX_LIB}-m-${this.options.spacingBetweenItems}`);
                }
                this.setSlideCount(this.slideCount + 1);
            }
        });
    }
    createGridItem(item) {
        const div = createElement({
            element: BcCommonConstants.DIV_TAG,
            props: { id: `slide-${item.uid}` },
            classList: [
                ...(item.typeDesign === 'row' ?
                    [CAROUSEL_ROW_CLASS]
                    : [
                        CAROUSEL_ITEM_CLASS,
                        CAROUSEL_CELL_CLASS,
                        `${BcCommonConstants.PREFIX_LIB}-m-${this.options.spacingBetweenItems}`,
                        (item.colspan ? `${CAROUSEL_COLSPAN_CLASS}-${item.colspan}` : '_'),
                    ]),
                (item.hidden ? BcCommonConstants.INVISIBLE_CLASS : '_')
            ],
        });
        if (item.content) {
            div.append(item.content);
            this.setSlideCount(this.slideCount + 1);
            return div;
        }
        item.children.forEach(child => {
            const el = this.createGridItem(child);
            div.append(el);
        });
        return div;
    }
    getItems() {
        const items = Array.from(this.mySelf.querySelectorAll(`*.${CAROUSEL_ITEM_CLASS}`));
        if (items.length == 0) {
            this.createItems();
            return;
        }
        this.cleanItems();
        items.forEach((item, i) => {
            this.checkSpacing(item);
            this.options.items[i] = {
                content: item,
                order: i,
                hidden: item.classList.contains(BcCommonConstants.INVISIBLE_CLASS)
            };
            this.slidesElements[i] = item;
        });
        this.setSlideCount(items.length);
    }
    checkSpacing(slide) {
        const pascingBetweenSlides = `${BcCommonConstants.PREFIX_LIB}-mx-${this.options.spacingBetweenItems}`;
        const pascingTopBottom = `${BcCommonConstants.PREFIX_LIB}-my-3`;
        if (!slide.classList.contains(pascingBetweenSlides)) {
            slide.classList.add(pascingBetweenSlides);
        }
        if (!slide.classList.contains(pascingTopBottom)) {
            slide.classList.add(pascingTopBottom);
        }
    }
    setDimensions() {
        const list = this.mySelf.querySelector(`${BcCommonConstants.SECTION_TAG}.${CAROUSEL_LIST_CLASS}`);
        const itemsRowSlide = Array.from(this.mySelf.querySelectorAll(`*.${CAROUSEL_ROW_CLASS}`));
        let trackWidth = 0;
        this.getSlidesTrack();
        this.sliderWidth = list.clientWidth;
        this.slideWidth = Math.ceil(this.sliderWidth / this.options.slidesToShow);
        const items = this.mySelf.querySelectorAll(`.${CAROUSEL_ITEM_CLASS} > *`);
        if (this.options.variableWidth) {
            trackWidth = COROUSEL_TRACK_WIDTH * this.slideCount;
        }
        else if (this.options.gridSystem && this.options.items && this.options.items.length > 0) {
            this.options.items.forEach(item => {
                const el = this.mySelf.querySelector(`#slide-${item.uid} > *`);
                const offsetWidth = getOffsetWidth(el.parentElement);
                el.style.width = `${(this.slideWidth - offsetWidth)}px`;
                trackWidth += (this.slideWidth);
                this.slideOffset = offsetWidth;
            });
        }
        else if (this.options.gridSystem && itemsRowSlide) {
            itemsRowSlide.forEach((item, i) => {
                item.id = `slide-row-${i}`;
                const el = this.mySelf.querySelector(`#${item.id} > *`);
                const offsetWidth = getOffsetWidth(el.parentElement);
                el.style.width = `${(this.slideWidth - offsetWidth)}px`;
                trackWidth += (this.slideWidth);
                this.slideOffset = offsetWidth;
            });
        }
        else if (items && items.length > 0) {
            items.forEach((el, i) => {
                el.id = `slide-${i}`;
                const offsetWidth = getOffsetWidth(el.parentElement);
                el.style.width = `${(this.slideWidth - offsetWidth)}px`;
                trackWidth += (this.slideWidth);
                this.slideOffset = offsetWidth;
            });
        }
        this.slidesTrack.style.width = `${trackWidth}px`;
        this.slideTrackWidth = trackWidth;
    }
    setPosition() {
        this.setDimensions();
        this.setCSS(this.getLeftByIndex(this.currentSlide));
    }
    getLeftByIndex(slideIndex) {
        let targetLeft, targetSlide;
        this.slideOffset = 0;
        if (slideIndex + this.options.slidesToShow > this.slideCount) {
            this.slideOffset = ((slideIndex + this.options.slidesToShow) - this.slideCount) * this.slideWidth;
        }
        if (this.slideCount <= this.options.slidesToShow) {
            this.slideOffset = 0;
        }
        targetLeft = ((slideIndex * this.slideWidth) * -1) + this.slideOffset;
        if (this.options.variableWidth === true) {
            targetSlide = this.slidesElements[slideIndex];
            targetLeft = targetSlide ? targetSlide.offsetLeft * -1 : 0;
        }
        return targetLeft;
    }
    addArrows() {
        if (this.options.arrows && !this.options.arrowsInBullets) {
            this.getArrows();
            if (!this.mySelf.querySelector(`.${CAROUSEL_CONTAINER_TOP_BUTTON_CLASS}`) && !this.mySelf.querySelector(`.${CAROUSEL_CONTAINER_BOTTOM_BUTTON_CLASS}`)) {
                this.mySelf.prepend(this.prevArrow);
                this.mySelf.append(this.nextArrow);
            }
        }
    }
    getArrows() {
        this.prevArrow = this.getArrow(CAROUSEL_ARROW_PREV_CLASS, this.options.iconNamePrev);
        this.nextArrow = this.getArrow(CAROUSEL_ARROW_NEXT_CLASS, this.options.iconNameNext);
    }
    changeAttributeButton(className, item) {
        item.setAttribute(CAROUSEL_ARIA_HIDDEN, 'false');
        const contentItems = this.mySelf.querySelector(`.${CAROUSEL_LIST_CLASS}`);
        if (className === CAROUSEL_ARROW_PREV_CLASS) {
            item.setAttribute(CAROUSEL_ARIA_LABEL, CAROUSEL_TEXT_SLIDE_PREV);
        }
        else {
            item.setAttribute(CAROUSEL_ARIA_LABEL, CAROUSEL_TEXT_SLIDE_NEXT);
        }
        item.setAttribute(CAROUSEL_ARIA_CONTROLS, contentItems.id);
        item.tabIndex = "0";
        return item;
    }
    getArrow(className, iconName) {
        let button = this.mySelf.querySelector(`.${className}`);
        if (!button) {
            button = this.createArrow(className, iconName);
        }
        else {
            button = this.changeAttributeButton(className, button);
        }
        return button;
    }
    createArrow(className, iconName) {
        const button = createElement({
            element: BcCommonConstants.DIV_TAG,
            classList: [CAROUSEL_ARROW_CLASS, className],
            children: [
                createElement({
                    element: BcCommonConstants.I_TAG,
                    classList: [BcCommonConstants.ICONS_CLASS],
                    innerText: iconName,
                }),
            ]
        });
        return this.changeAttributeButton(className, button);
    }
    updateArrows() {
        if (this.options.arrows && this.slideCount > this.options.slidesToShow && !this.options.infinity) {
            this.getArrows();
            this.hideArrows(false);
            if (this.currentSlide === 0) {
                this.hideElement(this.prevArrow, true);
                this.hideElement(this.nextArrow, false);
            }
            else if (this.currentSlide >= this.slideCount - this.options.slidesToShow) {
                this.hideElement(this.prevArrow, false);
                this.hideElement(this.nextArrow, true);
            }
        }
        if (this.options.sliderPagination) {
            this.pageNumber = `${this.currentSlide + 1}/${this.slideCount}`;
            this.createNumberPaginator();
        }
    }
    hideArrows(hide) {
        this.hideElement(this.prevArrow, hide);
        this.hideElement(this.nextArrow, hide);
    }
    setConfiguration() {
        this.setConfig({
            speed: this.options.swipeSpeed,
            contentItemsClass: CAROUSEL_TRACK_CLASS,
            sliderClass: CAROUSEL_CLASS,
            onMoving: this.onSwipe.bind(this),
            step: this.options.slidesToScroll * this.slideWidth,
            infinity: this.options.infinity,
        });
    }
    onLeftClick() {
        this.pauseAutoPlay();
        this.moveSliderToLeft(true);
        this.getValidLeft(this.target, true);
    }
    onRightClick() {
        this.pauseAutoPlay();
        this.moveSliderToLeft(false);
        this.getValidLeft(this.target, true);
    }
    onSwipe(newLeft) {
        this.getValidLeft(newLeft, true);
    }
}

const BC_HEADER_CLASS = `${BcCommonConstants.PREFIX_LIB}-header`;
const BC_HEADER_DROPDOWN_CONTENT = `${BcCommonConstants.PREFIX_LIB}-dropdown-content`;
const BC_HEADER_MOBILE = `${BcCommonConstants.PREFIX_LIB}-header-mobile`;
const BC_HEADER_DROPDOWN_CUSTOM = `${BcCommonConstants.PREFIX_LIB}-dropdown-custom`;
const BC_HEADER_BRAND = `${BcCommonConstants.PREFIX_LIB}-header-brand`;
const BC_HEADER_BRAND_LOGO = `${BcCommonConstants.PREFIX_LIB}-header-brand-logo`;
const BC_HEADER_NAV_ITEM = `${BcCommonConstants.PREFIX_LIB}-header-nav-item`;
const BC_HEADER_NAV = `${BcCommonConstants.PREFIX_LIB}-header-nav`;
const BC_HEADER_NAV_ICON_MOBILE = `${BcCommonConstants.PREFIX_LIB}-icon-mobile`;
const BC_HEADER_CHANNEL = `${BcCommonConstants.PREFIX_LIB}-header-channel`;
const BC_HEADER_LOGO = `${BcCommonConstants.PREFIX_LIB}-md`;
const BC_HEADER_DROPDOW_TOGGLE = `${BcCommonConstants.PREFIX_LIB}-dropdown`;
const BC_HEADER_BRAND_TOGGLE = `${BC_HEADER_BRAND}_menu-toggle`;
const BC_HEADER_TOGGLE = `${BcCommonConstants.PREFIX_LIB}-dropdown-toggle`;
const BC_HEADER_TOGGLE_ACTIVE = `${BcCommonConstants.PREFIX_LIB}-dropdown-toggle-active`;
const BC_HEADER_FLOAT_MENU_ = `${BcCommonConstants.PREFIX_LIB}-header-float-menu`;
const BC_HADER_CUSTOM_EVENT = 'headerDropdownChanged';
const BC_HEADER_LOGOUT_BUTTON_CLASS = `${BcCommonConstants.PREFIX_LIB}-header-nav-item_logout`;
const BC_HEADER_NOT_LOGOUT_CLASS = `${BcCommonConstants.PREFIX_LIB}-header-not-logout`;
const BC_LINK = `${BcCommonConstants.PREFIX_LIB}-link`;
const BC_HEADER_FLOAT_MENU = `bc-float-menu-toggle`;

class BcHeaderBehavior extends BcDefaultBehavior {
    constructor() {
        super();
        this.dropdowns = [];
        this.dropdownsContents = [];
        this.dropdownActive = null;
        this.menuButton = null;
        this.communicationWithMenu = true;
    }
    static setUpAll() {
        const headerElements = Array.from(document.querySelectorAll(`header[class^='${BC_HEADER_CLASS}']`));
        const elements = [];
        for (const headerElement of headerElements) {
            const bcHeaderBehavior = new BcHeaderBehavior();
            bcHeaderBehavior.setElement(headerElement);
            bcHeaderBehavior.setUp();
            elements.push(bcHeaderBehavior);
        }
        return elements;
    }
    _setUp() {
        window.addEventListener(BcCommonConstants.EVENT_MEMU_ITEMS, () => {
            this.removeLogoutBtn();
        });
        this.addEventForOption();
        this.getMenuButton();
        this.accessibility();
        if (this.communicationWithMenu) {
            this.addEvents();
        }
        else {
            this.menuButton['style'].display = 'none';
        }
    }
    setFocus() {
        const brandContainer = this.mySelf.querySelector(`.${BC_HEADER_BRAND}`);
        const headerNav = this.mySelf.querySelector(`.${BC_HEADER_NAV}`);
        const logoMobile = this.mySelf.querySelector(`.${BC_HEADER_NAV_ICON_MOBILE}`);
        if (brandContainer) {
            const menuIcon = this.menuButton;
            const channel = this.mySelf.querySelector(`.${BC_HEADER_CHANNEL}`);
            const brandLogo = this.mySelf.querySelector(`.${BC_HEADER_BRAND_LOGO}`);
            const items = headerNav.querySelectorAll(`.${BC_HEADER_NAV_ITEM}`);
            const elements = [menuIcon, brandLogo, channel, logoMobile];
            const navArray = Array.from(items);
            elements.forEach((i) => {
                addFocusable(i, { tabindex: String(0) });
            });
            navArray.forEach(element => {
                addFocusable(element, { tabindex: String(-1) });
            });
            const floatMenu = this.mySelf.querySelector(`.${BC_HEADER_FLOAT_MENU}`);
            if (floatMenu) {
                floatMenu.classList.add(`${BC_HEADER_FLOAT_MENU_}`);
            }
        }
    }
    getMenuButton() {
        const brandContainer = this.mySelf.querySelector(`.${BC_HEADER_BRAND}`);
        if (brandContainer !== null) {
            this.menuButton = brandContainer.querySelector(`.${BC_HEADER_BRAND_TOGGLE}`);
        }
    }
    accessibility() {
        this.setFocus();
        const dropdown = this.mySelf.querySelectorAll(`.${BC_HEADER_DROPDOWN_CUSTOM}`);
        if (dropdown) {
            const toggle = this.mySelf.querySelector(`.${BC_HEADER_TOGGLE}`);
            dropdown.forEach(element => {
                this.setkeyBoard(element, toggle);
            });
            this.setFocus();
        }
    }
    setkeyBoard(element, toggle) {
        element.addEventListener(BcCommonConstants.EVENT_KEY_UP, (event) => {
            if (event.key === BcCommonConstants.KEY_EVENT_ENTER || event.key === BcCommonConstants.KEY_EVENT_SPACE) {
                toggle.click();
            }
        });
    }
    toggleSidebarMenu() {
        const toggleEvent = new CustomEvent(BcCommonConstants.EVENT_HEADER_TOGGLE_MENU);
        window.dispatchEvent(toggleEvent);
    }
    addMenuButtonEvent() {
        this.menuButton !== null && this.menuButton.addEventListener(BcCommonConstants.EVENT_CLICK, () => {
            this.toggleSidebarMenu();
        });
    }
    removeLogoutBtn() {
        const logoutBtn = this.mySelf.querySelector(`.${BC_HEADER_LOGOUT_BUTTON_CLASS}`);
        if (logoutBtn) {
            logoutBtn.remove();
            this.mySelf.classList.add(BC_HEADER_NOT_LOGOUT_CLASS);
        }
    }
    menuItemOpened() {
        window.addEventListener(BcCommonConstants.EVENT_MENU_ITEM_OPENED, (event) => {
            if (event.detail.itemStatus !== null) {
                this.mySelf.style.zIndex = '1';
            }
            else {
                this.mySelf.style.zIndex = '999';
            }
        });
    }
    addEvents() {
        this.iAmHere();
        this.addMenuButtonEvent();
        this.menuItemOpened();
    }
    iAmHere() {
        const exist = new CustomEvent(BcCommonConstants.EVENT_HEADER_EXIST);
        window.dispatchEvent(exist);
    }
    addEventForOption(fn) {
        for (let i = 0; i < this.dropdownsContents.length; i++) {
            const optionsUl = this.dropdownsContents[i].children[0];
            for (let j = 0; j < optionsUl.children.length; j++) {
                const optionLi = optionsUl.children[j];
                this.optionListener(optionLi, optionsUl);
            }
        }
    }
    optionListener(optionLi, optionsUl) {
        if (!optionLi.getAttribute("listener")) {
            optionLi.addEventListener(BcCommonConstants.EVENT_CLICK, () => {
                this.addEventClick(optionsUl, optionLi);
            }, true);
        }
        optionLi.setAttribute('listener', BcCommonConstants.EVENT_CLICK);
    }
    addEventClick(optionsUl, optionLi) {
        const parentDropdown = optionsUl.closest(`.${BC_HEADER_DROPDOWN_CUSTOM}`);
        this.updateHeaderItemText(parentDropdown, optionLi);
    }
    updateHeaderItemText(parent, option) {
        const text = parent.querySelector(BcCommonConstants.P_TAG);
        const subText = parent.querySelector(BcCommonConstants.SMALL);
        text.textContent = option.querySelector(BcCommonConstants.P_TAG).textContent;
        if (subText) {
            subText.textContent = option.querySelector(BcCommonConstants.SMALL).textContent;
        }
        const itemChanged = new CustomEvent(BC_HADER_CUSTOM_EVENT, {
            detail: subText != null ? { text: text.textContent, subText: subText.textContent } : { text: text.textContent },
        });
        window.dispatchEvent(itemChanged);
    }
}

const BC_PAGE_HEADER_SELECTOR = `${BcCommonConstants.PREFIX_LIB}-page-header`;
const BC_PAGE_HEADER_BREADCRUMB_SELECTOR = `${BcCommonConstants.PREFIX_LIB}-breadcrumb`;
const BC_PAGE_MAX_ITEMS_BREADCRUMB_VISIBLE = 3;
const BC_PAGE_HEADER_BACK_BUTTON = `${BcCommonConstants.PREFIX_LIB}-page-header-back-button`;
const BC_PAGE_HEADER_BUTTONS_RIGHT = `${BcCommonConstants.PREFIX_LIB}-page-header-icon`;

class BcPageHeaderBehavior extends BcDefaultBehavior {
    constructor() {
        super();
    }
    /**
   * Metodo para implementación nativa
   * @static
   * @return {*}  {BcPageHeaderBehavior[]}
   * @memberof BcPageHeaderBehavior
   */
    static setUpAll() {
        const pageHeaderElements = Array.from(document.querySelectorAll(`div[class~='${BC_PAGE_HEADER_SELECTOR}']`));
        const elements = [];
        for (const element of pageHeaderElements) {
            const bcPageHeaderBehavior = new BcPageHeaderBehavior();
            bcPageHeaderBehavior.setElement(element);
            bcPageHeaderBehavior.setUp();
            elements.push(bcPageHeaderBehavior);
        }
        return elements;
    }
    _setUp() {
        this.selectElements();
        this.addListeners();
    }
    /**
     * Agrega evento click al boton back
     * @memberof BcPageHeaderBehavior
     */
    addListeners() {
        this.bcPageHeaderBackButton.addEventListener(BcCommonConstants.EVENT_CLICK, () => {
            window.history.back();
        });
    }
    /**
     * Selecciona los elementos html
     * @memberof BcPageHeaderBehavior
     */
    selectElements() {
        this.bcPageHeaderBackButton = this.mySelf.querySelector(`.${BC_PAGE_HEADER_SELECTOR} .${BC_PAGE_HEADER_BACK_BUTTON}`);
        this.bcPageHeaderBreadcrumb = this.mySelf.querySelector(`.${BC_PAGE_HEADER_SELECTOR} .${BC_PAGE_HEADER_BREADCRUMB_SELECTOR}`);
        this.bcPageHeaderBreadcrumbList = this.mySelf.querySelector(`.${BC_PAGE_HEADER_SELECTOR} .${BC_PAGE_HEADER_BREADCRUMB_SELECTOR} ol`);
        this.bcPageHeaderBreadcrumbItems = Array.from(this.mySelf.querySelectorAll(`.${BC_PAGE_HEADER_SELECTOR} .${BC_PAGE_HEADER_BREADCRUMB_SELECTOR} ol li`));
        this.bcPageHeaderButtonsRight = Array.from(this.mySelf.querySelectorAll(`.${BC_PAGE_HEADER_SELECTOR} .${BC_PAGE_HEADER_BUTTONS_RIGHT}`));
        this.bcPageHeaderCountBreadcrumbItems = this.bcPageHeaderBreadcrumbItems.length;
    }
}

const BC_CIRCLE_LOADING = `${BcCommonConstants.PREFIX_LIB}-circle-loading`;
const BC_CIRCLE_LOADING_ACTIVE = `${BcCommonConstants.PREFIX_LIB}-circle-loading-active`;
const BC_CIRCLE_LOADING_ARIA_LABEL = `${BcCommonConstants.PREFIX_LIB}-circle-loading-aria-label`;
const BC_CIRCLE_LOADING_LOADER_ICON = `${BcCommonConstants.PREFIX_LIB}-circle-loading-loader-icon`;
const VISIBLE_CIRCLE_LOADING = `VISIBLE`;
const HIDDEN_CIRCLE_LOADING = `HIDDEN`;
const ARIA_LIVE_CIRCLE_LOADING = `aria-live`;
const POLITE_CIRCLE_LOADING = `polite`;
const STYLE_CIRCLE_LOADING = `style`;
const SPEED_LOADER_LOADING = `speedloader`;
const ANIMATION_DURATION_CIRCLE_LOADING = `animation-duration`;

class BcCircleLoadingBehavior extends BcDefaultBehavior {
    constructor() {
        super();
        this.speedLoader = '0.5';
    }
    static setUpAll() {
        const circleLoadingElements = Array.from(document.querySelectorAll(`.${BC_CIRCLE_LOADING}`));
        const elements = [];
        for (const circleLoadingElement of circleLoadingElements) {
            const element = circleLoadingElement;
            const bcCircleLoadingBehavior = new BcCircleLoadingBehavior();
            bcCircleLoadingBehavior.setElement(element);
            bcCircleLoadingBehavior.setUp();
            elements.push(bcCircleLoadingBehavior);
        }
        return elements;
    }
    _setUp() {
        this.circleLoadingState = HIDDEN_CIRCLE_LOADING;
        this.accessibility();
        this.updateSpeedLoader();
    }
    /**
   * Configura la accesibilidad del circle loading agregando la propiedad aria-live="polite".
   * @memberof BcCircleLoadingBehavior
   */
    accessibility() {
        this.getAccessibilityLabel();
        this.bcAccessibilityLabel.setAttribute(ARIA_LIVE_CIRCLE_LOADING, POLITE_CIRCLE_LOADING);
    }
    /**
   * Obtiene el label de usabilidad en el circle loading mediante querySelector.
   * @memberof BcCircleLoadingBehavior
   */
    getAccessibilityLabel() {
        this.bcAccessibilityLabel = this.mySelf.querySelector(`.${BC_CIRCLE_LOADING_ARIA_LABEL}`);
    }
    /**
   * Actualiza la velocidad del loader para el componente circle loading tomando la prop speedloader
   * @memberof BcCircleLoadingBehavior
   */
    updateSpeedLoader() {
        this.speedLoader = this.mySelf.getAttribute(SPEED_LOADER_LOADING) || this.speedLoader;
        const lodaerIcon = this.mySelf.querySelector(`.${BC_CIRCLE_LOADING_LOADER_ICON}`);
        if (lodaerIcon) {
            lodaerIcon.setAttribute(STYLE_CIRCLE_LOADING, `${ANIMATION_DURATION_CIRCLE_LOADING}: ${this.speedLoader}s;`);
        }
    }
    toggleVisibility() {
        if (this.circleLoadingState == VISIBLE_CIRCLE_LOADING) {
            this.mySelf.classList.add(BC_CIRCLE_LOADING_ACTIVE);
        }
        else {
            this.mySelf.classList.remove(BC_CIRCLE_LOADING_ACTIVE);
        }
    }
    /**
   * Muestra el circle loading y actualiza el estado
   * @memberof bcCircleLoadingBehavior
   */
    showCircleLoading() {
        this.circleLoadingState = VISIBLE_CIRCLE_LOADING;
        this.toggleVisibility();
    }
    /**
   * Oculta el circle loading y actualiza el estado
   * @memberof bcCircleLoadingBehavior
   */
    hideCircleLoading() {
        this.circleLoadingState = HIDDEN_CIRCLE_LOADING;
        this.toggleVisibility();
    }
}

const BC_MENU_GLOBAL_CLASS = `${BcCommonConstants.PREFIX_LIB}-menu-global-container`;
const BC_MENU_CONTENT_CLASS = `${BcCommonConstants.PREFIX_LIB}-content`;
const BC_MENU_TABS_VERTICAL = `${BcCommonConstants.PREFIX_LIB}-menu-tabs-vertical`;
const BC_MENU_TABS_VERTICAL_MENU = `${BC_MENU_TABS_VERTICAL}-container`;
const BC_MENU_TABS_VERTICAL_TITLE = `${BC_MENU_TABS_VERTICAL}-title`;
const BC_MENU_TABS_VERTICAL_ITEM = `${BC_MENU_TABS_VERTICAL}-item`;
const BC_MENU_TABS_VERTICAL_ITEM_ACTIVE = `${BC_MENU_TABS_VERTICAL_ITEM}-active`;
const BC_MENU_TABS_VERTICAL_ITEM_TARGET = `target`;
const BC_MENU_TABS_VERTICAL_INDICATOR = `${BC_MENU_TABS_VERTICAL}-indicator`;
const BC_MENU_TABS_VERTICAL_CONTAINER_PADDING = 8;
const BC_MENU_TABS_VERTICAL_SCROLL_ANIMATION = 'smooth';
const TABLET_WIDTH = 768;
const BC_MENU_TABS_VERTICAL_TITLE_LABEL = 'Contenido. Nivel de encabezado 5.';
const BC_MENU_TABS_VERTICAL_MENU_ROLE = 'navigation';
const BC_MENU_TABS_VERTICAL_ITEM_ROLE = 'listitem';

class BcMenuTabsVerticalBehavior extends BcDefaultBehavior {
    constructor() {
        super();
        this._itemsElements = [];
        this._items = [];
        this._scrollListener = () => this.setActiveItem(this.changeActiveMenuItemWithScroll());
    }
    /**
     * Retorna un listado de objetos que contienen titulo y ID de los elementos
     * HTML a resaltar por el menú.
     * @memberof BcMenuTabsVerticalBehavior
     * @returns Listado de elementos del menú.
     */
    get items() {
        return this._items;
    }
    /**
     * Retorna un objeto que contiene titulo y ID del elemento HTML actualmente activo en el menú.
     * @memberof BcMenuTabsVerticalBehavior
     * @returns Elemento activo del menú.
     */
    get activeItem() {
        return this._items.find((item) => item.itemText === this._activeItem.textContent &&
            item.itemTargetID === this._activeItem.dataset.target);
    }
    _setUp() {
        this.loadMenuContainer();
        this.loadIndicator();
        this.loadMenuItems();
        this.loadAccessibility();
    }
    loadMenuContainer() {
        const menuContainerElement = this.mySelf.querySelector(`.${BC_MENU_TABS_VERTICAL_MENU}`);
        if (menuContainerElement) {
            this._menuContainer = menuContainerElement;
        }
        const bdsMenuContent = document.querySelector(`.${BC_MENU_GLOBAL_CLASS} .${BC_MENU_CONTENT_CLASS}`);
        if (bdsMenuContent) {
            bdsMenuContent.removeEventListener(BcCommonConstants.EVENT_SCROLL, this._scrollListener);
            bdsMenuContent.addEventListener(BcCommonConstants.EVENT_SCROLL, this._scrollListener);
        }
        else {
            document.removeEventListener(BcCommonConstants.EVENT_SCROLL, this._scrollListener);
            document.addEventListener(BcCommonConstants.EVENT_SCROLL, this._scrollListener);
        }
    }
    loadIndicator() {
        const indicatorElement = this.mySelf.querySelector(`.${BC_MENU_TABS_VERTICAL_INDICATOR}`);
        if (indicatorElement) {
            this._indicator = indicatorElement;
        }
    }
    loadMenuItems() {
        const itemElements = this.mySelf.querySelectorAll(`.${BC_MENU_TABS_VERTICAL_ITEM}`);
        itemElements.forEach((item, index) => {
            if (index === 0) {
                this.setActiveItem(item);
            }
            const itemTargetID = item.dataset[BC_MENU_TABS_VERTICAL_ITEM_TARGET];
            const itemText = item.textContent;
            if (itemTargetID && itemText) {
                item.addEventListener(BcCommonConstants.EVENT_CLICK, () => document.getElementById(itemTargetID)?.scrollIntoView({ behavior: BC_MENU_TABS_VERTICAL_SCROLL_ANIMATION }));
                this._items.push({ itemTargetID, itemText });
            }
            this._itemsElements.push(item);
        });
    }
    setActiveItem(menuItem) {
        if (this._activeItem !== menuItem) {
            if (this._activeItem) {
                this._activeItem.classList.remove(`${BC_MENU_TABS_VERTICAL_ITEM_ACTIVE}`);
            }
            menuItem.classList.add(`${BC_MENU_TABS_VERTICAL_ITEM_ACTIVE}`);
            this.updateIndicatorStyle(menuItem);
            this._activeItem = menuItem;
        }
    }
    updateIndicatorStyle(menuItem) {
        const itemHeight = menuItem.offsetHeight;
        const itemTop = menuItem.offsetTop - BC_MENU_TABS_VERTICAL_CONTAINER_PADDING;
        if (this._indicator != null) {
            this._indicator.style.height = `${itemHeight}px`;
            this._indicator.style.transform = `translateY(${itemTop}px)`;
        }
    }
    changeActiveMenuItemWithScroll() {
        let activeItem = this._activeItem;
        if (this.mySelf.parentElement && this.mySelf.parentElement.getBoundingClientRect().bottom === window.innerHeight) {
            activeItem = this._itemsElements[this._items.length - 1];
        }
        else {
            this._items.forEach((item, index) => {
                const contentElement = document.getElementById(item.itemTargetID);
                if (contentElement) {
                    const elementTopPosition = contentElement.getBoundingClientRect().top;
                    const contentContainerTopPosition = this._menuContainer.getBoundingClientRect().top;
                    if ((window.innerWidth < TABLET_WIDTH && elementTopPosition <= 0) ||
                        elementTopPosition <= contentContainerTopPosition) {
                        activeItem = this._itemsElements[index];
                    }
                }
            });
        }
        return activeItem;
    }
    loadAccessibility() {
        const title = this._menuContainer.querySelector(`h5.${BC_MENU_TABS_VERTICAL_TITLE}`);
        if (title) {
            addFocusable(title, {
                tabindex: '0',
                label: BC_MENU_TABS_VERTICAL_TITLE_LABEL,
                role: BC_MENU_TABS_VERTICAL_MENU_ROLE,
            });
        }
        this._itemsElements.forEach((item, index) => {
            addFocusable(item, {
                tabindex: '0',
                label: `${item.textContent}, item ${index + 1} de ${this._itemsElements.length}, enlace.`,
                role: BC_MENU_TABS_VERTICAL_ITEM_ROLE,
            });
            item.addEventListener(BcCommonConstants.EVENT_KEY_UP, (event) => {
                if (event.key === BcCommonConstants.KEY_EVENT_ENTER) {
                    item.click();
                }
            });
        });
    }
}

const SEARCH_ARROW_CLASS = `${BcCommonConstants.PREFIX_LIB}-search-button-expanded`;
const SEARCH_ADVANCED_ACTIVE_CLASS = `${BcCommonConstants.PREFIX_LIB}-content-advanced-search-active`;
const SEARCH_ADVANCED_CLASS = `${BcCommonConstants.PREFIX_LIB}-content-advanced-search`;
const SEARCH_BUTTON_CLASS = `${BcCommonConstants.PREFIX_LIB}-search-button`;
const SEARCH_INPUT_SELECT_CLASS = `${BcCommonConstants.PREFIX_LIB}-input-select`;
const SEARCH_CONTENT_FORM = `content-form-search`;
const SEARCH_CONTENT_SHOW_RESULT_CLASS = `${BcCommonConstants.PREFIX_LIB}-content-show-result`;
const SEARCH_CLEAR_CLASS = `${BcCommonConstants.PREFIX_LIB}-search-clear`;
const SEARCH_RESULT_NULL_CLASS = `${BcCommonConstants.PREFIX_LIB}-search-result-null`;
const SEARCH_CLEAR_SHOW_CLASS = `${BcCommonConstants.PREFIX_LIB}-search-clear-show`;
const SEARCH_SHOW_IMAGE_CLASS = `${BcCommonConstants.PREFIX_LIB}-search-show-image`;
const SEARCH_INPUT_DATE_CLASS = `${BcCommonConstants.PREFIX_LIB}-input-date`;
const SEARCH_INPUT_DATE_RANGE_CLASS = `${BcCommonConstants.PREFIX_LIB}-input-date-range`;
const SEARCH_INPUTS = `${BcCommonConstants.PREFIX_LIB}-search-input`;
const SEARCH_CONTENT_ELEMENT_CLASS = `${BcCommonConstants.PREFIX_LIB}-content-element`;
const SEARCH_CONTENT = `${BcCommonConstants.PREFIX_LIB}-search-content`;
const SEARCH_ADVANCE_MOBILE_CLASS = `${BcCommonConstants.PREFIX_LIB}-search-advance-mobile`;
const SEARCH_CLASS = `${BcCommonConstants.PREFIX_LIB}-search`;
const SEARCH_CONTENT_ELEMENT_TWO_CLASS = `${BcCommonConstants.PREFIX_LIB}-search-content-element-two`;
const GROUP_SEARCH_SUFIX = `${BcCommonConstants.PREFIX_LIB}-search`;
const INPUT_ACTIVE_SEARCH_CLASS = `${BcCommonConstants.PREFIX_LIB}-active`;
const SEARCH_INPUT_CHECKBOX = 'checkbox';
const SEARCH_INPUT_SELECT = 'select';
const SEARCH_SPAN = 'span';
const SEARCH_D_NONE = `${BcCommonConstants.PREFIX_LIB}-d-none`;
const SEARCH_NUMBER_ZERO = 0;
const SEARCH_NUMBER_FIVE_HUNDRED = 500;
const SEARCH_NUMBER_BREAKPOINT_MD = 769;

class BcSearchBehavior extends BcDefaultBehavior {
    constructor() {
        super();
        /** Creando una matriz vacía.
         * @memberof BcSearchBehavior */
        this.resultFilter = [];
        /** Creando una matriz vacía.
         * @memberof BcSearchBehavior */
        this.inputsContentsMemory = [];
        this.jsObjt = {};
        this.jsDates = {};
        this.keyObjtValue = {};
        this.objectArrayItem = [];
        this.stringFilters = '';
    }
    /**
     * Seteo de elementos.
     * @memberof BcSearchBehavior
     */
    setItems(value) {
        this.objectArrayItem = value;
    }
    _setUp() {
        this.setInputsObjectSearch(ZERO_NUMBER);
        this.setListenerButtonSearchClick();
        this.toggleDropDownAdvancedSearch();
        this.toggleKeyAdvancedSearch();
        this.setInputSelectInSearch();
        this.clearSearch();
        this.initInputBehavior();
        this.closeAdvancedSearch();
        this.hideElements();
        addFocusable(this.mySelf);
    }
    /**
     * Selecciona el dropdown y registra el evento click que activa/desactiva la búsqueda avanzada.
     * @memberof BcSearchBehavior
     */
    toggleDropDownAdvancedSearch() {
        const dropDown = this.mySelf.querySelector(`${BcCommonConstants.DIV_TAG}[class^="${SEARCH_ARROW_CLASS}"]`);
        const contentAdvanceSearch = this.mySelf.querySelector(`.${SEARCH_ADVANCED_CLASS}`);
        const iconDropDown = this.mySelf.querySelector(`.${SEARCH_ARROW_CLASS} .${BcCommonConstants.ICONS_CLASS}`);
        dropDown.addEventListener(BcCommonConstants.EVENT_CLICK, () => {
            if (contentAdvanceSearch.classList.contains(`${SEARCH_ADVANCED_ACTIVE_CLASS}`)) {
                contentAdvanceSearch.classList.remove(`${SEARCH_ADVANCED_ACTIVE_CLASS}`);
                iconDropDown.textContent = BcCommonConstants.ICON_ARROW_DOWN;
            }
            else {
                this.openAdvancedSearch();
            }
        });
    }
    toggleKeyAdvancedSearch() {
        const dropDown = this.mySelf.querySelector(`${BcCommonConstants.DIV_TAG}[class^="${SEARCH_ARROW_CLASS}"]`);
        const contentAdvanceSearch = this.mySelf.querySelector(`.${SEARCH_ADVANCED_CLASS}`);
        const iconDropDown = this.mySelf.querySelector(`.${SEARCH_ARROW_CLASS} .${BcCommonConstants.ICONS_CLASS}`);
        dropDown.addEventListener(BcCommonConstants.EVENT_KEY_DOWN, (event) => {
            if (event.key === BcCommonConstants.KEY_EVENT_ENTER || event.code === BcCommonConstants.KEY_EVENT_SPACE) {
                if (contentAdvanceSearch.classList.contains(`${SEARCH_ADVANCED_ACTIVE_CLASS}`)) {
                    contentAdvanceSearch.classList.remove(`${SEARCH_ADVANCED_ACTIVE_CLASS}`);
                    iconDropDown.textContent = BcCommonConstants.ICON_ARROW_DOWN;
                }
                else {
                    this.openAdvancedSearch();
                }
            }
        });
    }
    /**
      * open advanced search.
      * @memberof BcSearchBehavior
      */
    openAdvancedSearch() {
        const contentAdvanceSearch = this.mySelf.querySelector(`.${SEARCH_ADVANCED_CLASS}`);
        const iconDropDown = this.mySelf.querySelector(`.${SEARCH_ARROW_CLASS} .${BcCommonConstants.ICONS_CLASS}`);
        contentAdvanceSearch.classList.add(`${SEARCH_ADVANCED_ACTIVE_CLASS}`);
        iconDropDown.textContent = BcCommonConstants.ICON_ARROW_UP;
    }
    /**
     * Configura para cerrar la busqueda avanzada al hacer click fuera del elemento o con la tecla escape.
     * @memberof BcSearchBehavior
     */
    closeAdvancedSearch() {
        const contentAdvanceSearch = this.mySelf.querySelector(`.${SEARCH_ADVANCED_CLASS}`);
        const iconDropDown = this.mySelf.querySelector(`.${SEARCH_ARROW_CLASS} .${BcCommonConstants.ICONS_CLASS}`);
        window.addEventListener(BcCommonConstants.EVENT_KEY_DOWN, (event) => {
            if (event.key === BcCommonConstants.KEY_EVENT_ESCAPE) {
                contentAdvanceSearch.classList.remove(`${SEARCH_ADVANCED_ACTIVE_CLASS}`);
                iconDropDown.textContent = BcCommonConstants.ICON_ARROW_DOWN;
            }
        });
        document.addEventListener(BcCommonConstants.EVENT_CLICK, (event) => {
            if (!event.target.closest(`.${SEARCH_CLASS}`) &&
                contentAdvanceSearch.classList.contains(`${SEARCH_ADVANCED_ACTIVE_CLASS}`)) {
                contentAdvanceSearch.classList.remove(`${SEARCH_ADVANCED_ACTIVE_CLASS}`);
                iconDropDown.textContent = BcCommonConstants.ICON_ARROW_DOWN;
            }
        });
    }
    /**
     * Configura evento click del botón de búsqueda.
     * @memberof BcSearchBehavior
     */
    setListenerButtonSearchClick() {
        const input = this.mySelf.querySelectorAll(`.${SEARCH_BUTTON_CLASS}`);
        for (const inputValues of input) {
            inputValues.addEventListener(BcCommonConstants.EVENT_CLICK, async () => {
                this.searchObject();
            });
        }
    }
    /**
     * Busca los elementos input y lee sus estados para obtener los parámetros de la búsqueda.
     * @memberof BcSearchBehavior
     */
    async searchObject() {
        const inputValue = this.mySelf.querySelectorAll(BcCommonConstants.INPUT_TAG);
        let bandButton = false;
        this.stringFilters = '';
        this.jsObjt = {};
        this.jsDates = {};
        bandButton = this.searchObjectIterate(inputValue, bandButton);
        this.resultFilter = [];
        this.query = { ...this.jsObjt, ...this.jsDates };
        if (this.preSearchFunction) {
            await this.preSearchFunction(this.query);
        }
        const hasTextInputs = (Object.keys(this.jsObjt).length && this.objectArrayItem.length > ZERO_NUMBER);
        const hasDateInputs = (Object.keys(this.jsDates).length && this.objectArrayItem.length > ZERO_NUMBER);
        if (hasDateInputs) {
            for (const value of this.objectArrayItem) {
                this.dataDateSearch(value);
            }
            if (hasTextInputs) {
                const resultTextFilters = [];
                for (const value of this.objectArrayItem) {
                    const responseFilter = this.dataSearch(value, this.jsObjt);
                    if (responseFilter) {
                        resultTextFilters.push(value);
                    }
                }
                this.resultFilter = resultTextFilters.filter((element) => this.resultFilter.includes(element));
            }
            this.verifyOutputFuctionSearch(this.resultFilter);
            this.verifyContentInObjectResult();
            this.enableOrDisableButtonSearch(bandButton);
            this.setValueInput(this.jsObjt);
        }
        else if (hasTextInputs) {
            for (const value of this.objectArrayItem) {
                const responseFilter = this.dataSearch(value, this.jsObjt);
                if (responseFilter) {
                    this.resultFilter.push(value);
                }
            }
            this.verifyOutputFuctionSearch(this.resultFilter);
            this.verifyContentInObjectResult();
            this.enableOrDisableButtonSearch(bandButton);
            this.setValueInput(this.jsObjt);
        }
        else {
            this.verifyOutputFuctionSearch(this.resultFilter);
        }
    }
    dataDateSearch(data) {
        const keys = Object.keys(this.jsDates);
        keys.forEach(key => {
            const ValueKey = Object.getOwnPropertyDescriptor(data, key);
            if (ValueKey) {
                const date1String = this.jsDates[key].date1;
                const date2String = this.jsDates[key].date2;
                if (this.pushDateIfIsInRange(ValueKey.value, date1String, date2String)) {
                    this.resultFilter.push(data);
                }
            }
        });
    }
    pushDateIfIsInRange(validateDate, minDate, Maxdate) {
        const dateValue = new Date(validateDate);
        const date1 = new Date(minDate);
        const date2 = new Date(Maxdate);
        if (dateValue >= date1 && dateValue <= date2) {
            return true;
        }
        return false;
    }
    /**
     * Si se define la función de salida, llame a la función de salida con el filtro de resultado como
     * argumento y, a continuación, llame a la función de verificar el contenido en el resultado del
     * objeto.
     * @param resultFilter - este es el objeto que se devuelve de la búsqueda.
     */
    verifyOutputFuctionSearch(resultFilter) {
        this.resultFilter['query'] = { ...this.jsObjt, ...this.jsDates };
        if (this.outputFunction) {
            this.outputFunction(resultFilter);
            this.verifyContentInObjectResult();
        }
    }
    /**
     * Elimina todos los hijos de un div y luego elimina la imagen de fondo del div.
     */
    verifyContentInObjectResult() {
        const clearSelector = this.mySelf.querySelector(`.${SEARCH_CLEAR_CLASS}`);
        const result = this.mySelf.querySelector(`.${SEARCH_CONTENT_SHOW_RESULT_CLASS}`);
        const divAttributes = this.mySelf.querySelectorAll(`.${SEARCH_RESULT_NULL_CLASS} ${BcCommonConstants.DIV_TAG}`);
        if (Object.keys(this.jsObjt).length > SEARCH_NUMBER_ZERO || Object.keys(this.jsDates).length > SEARCH_NUMBER_ZERO) {
            this.showQuantityItems(this.resultFilter.length);
        }
        else {
            clearSelector.classList.remove(`${SEARCH_CLEAR_SHOW_CLASS}`);
            while (result.firstChild) {
                result.removeChild(result.firstChild);
            }
            this.removeDivAttributeImage(divAttributes);
        }
    }
    /**
     * Elimina la clase "buscar-mostrar-imagen" de todos los divs con la clase "buscar-mostrar-imagen".
     * @param divAttributes - Colección HTML
     */
    removeDivAttributeImage(divAttributes) {
        for (const divAttribute of divAttributes) {
            divAttribute.classList.remove(`${SEARCH_SHOW_IMAGE_CLASS}`);
        }
    }
    /**
     * "Si el botón existe, es verdadero, deshabilite el botón; de lo contrario,
     * habilítelo".
     * @param bandButton - booleano
     */
    enableOrDisableButtonSearch(bandButton) {
        const buttonSearch = this.mySelf.querySelector(`.${SEARCH_BUTTON_CLASS} ${BcCommonConstants.BUTTON_TAG}`);
        if (!!buttonSearch) {
            if (bandButton) {
                buttonSearch.disabled = BcCommonConstants.FALSE;
            }
            else {
                buttonSearch.disabled = BcCommonConstants.TRUE;
            }
        }
    }
    /**
     * Itera sobre una matriz de objetos, y si el objeto tiene una propiedad de tipo
     * "SEARCH_INPUT_CHECKBOX", llama a la función verificar Entradas Comprobadas y Datos Empujados; de
     * lo contrario, llama a la función verificar Entradas de Valores y Datos Empujados.
     * @param {any} inputValue - cualquiera =&gt; esta es una matriz de objetos que contiene los datos
     * que necesito iterar.
     * @param {boolean} bandButton - booleano = falso;
     * @returns Un valor booleano.
     */
    searchObjectIterate(inputValue, bandButton) {
        let booleanbutton = bandButton;
        for (const inputValues of inputValue) {
            if (inputValues.type === SEARCH_INPUT_CHECKBOX) {
                this.verifyCheckedInputsAndPushedData(inputValues);
            }
            else {
                this.verifyValuesInputsAndPushedData(inputValues);
            }
            if (this.stringFilters) {
                booleanbutton = BcCommonConstants.TRUE;
            }
        }
        return booleanbutton;
    }
    /**
     * Si la entrada está marcada, inserte el valor en la matriz.
     * @param inputValues - {nombre: "", valor: "", comprobado: verdadero}
     */
    verifyCheckedInputsAndPushedData(inputValues) {
        if (inputValues.checked) {
            if (this.jsObjt.hasOwnProperty(inputValues.name)) {
                this.jsObjt[inputValues.name].push(inputValues.value);
                this.stringFilters += inputValues.value + ',';
            }
            else {
                this.jsObjt[inputValues.name] = [];
                this.jsObjt[inputValues.name].push(inputValues.value);
                this.stringFilters += inputValues.value + ',';
            }
        }
    }
    /**
     * Toma un objeto inputValues, verifica si tiene un valor y, si lo tiene, lo agrega al objeto jsObjt
     * y la cadena stringFilters.
     * @param inputValues - es el elemento de entrada
     */
    verifyValuesInputsAndPushedData(inputValues) {
        if (inputValues.value) {
            if (inputValues.hasAttribute('dateType')) {
                this.findDateRangeValues(inputValues);
            }
            else {
                if (inputValues.parentElement.classList.contains('bc-input-select')) {
                    this.findInputSelectValues(inputValues);
                }
                else {
                    this.jsObjt[inputValues.name] = inputValues.value;
                    if (inputValues.dataset.value) {
                        this.jsObjt[inputValues.dataset.value] = inputValues.value;
                    }
                    this.stringFilters += inputValues.value + ',';
                }
            }
        }
    }
    findInputSelectValues(inputValues) {
        const value = this.setDataSelect[inputValues.parentElement.id].value;
        this.jsObjt[inputValues.name] = value;
        if (inputValues.dataset.value) {
            this.jsObjt[inputValues.dataset.value] = value;
        }
        this.stringFilters += inputValues.value + ',';
    }
    findDateRangeValues(inputValues) {
        if (this.jsDates[inputValues.name] === undefined) {
            this.jsDates[inputValues.name] = { date1: inputValues.value, date2: '' };
        }
        else {
            this.jsDates[inputValues.name].date2 = inputValues.value;
        }
        this.stringFilters += inputValues.value + ',';
    }
    /**
     * Busca los input y registra el evento click, asociando la función searchObject en cada uno de ellos.
     * @memberof BcSearchBehavior
     */
    setInputsObjectSearch(timeEject) {
        const inputs = this.mySelf.querySelectorAll(BcCommonConstants.INPUT_TAG);
        const inputSelects = this.mySelf.querySelectorAll(`.${SEARCH_INPUT_SELECT_CLASS}`);
        const inputDates = this.mySelf.querySelectorAll(`.${SEARCH_INPUT_DATE_CLASS}`);
        const inputDatesRange = this.mySelf.querySelectorAll(`.${SEARCH_INPUT_DATE_RANGE_CLASS}`);
        this.createInputDate(inputDates);
        this.createInputDateRange(inputDatesRange);
        this.createInputSelect(inputSelects);
        this.listenerElementInput(inputs, timeEject);
    }
    /**
     * Crea un componente de fecha de entrada y, si la fecha de entrada tiene una identificación,
     * configura el componente.
     * @param inputDates - HTMLColecciónDe&lt;Elemento&gt;
     */
    createInputDate(inputDates) {
        for (const inputDate of inputDates) {
            setTimeout(() => {
                const inputDateComponent = new BcInputDateBehavior();
                let inputDateId = false;
                if (!!this.setIdDates) {
                    inputDateId = this.setIdDates.id.includes(inputDate.id);
                }
                if (!!inputDate.id && inputDateId) {
                    inputDateComponent.setElement(inputDate);
                    inputDateComponent.output = () => {
                        this.searchObject();
                    };
                    inputDateComponent.setUp();
                }
            }, SEARCH_NUMBER_ZERO);
        }
    }
    /**
     * Crea un componente de fecha de entrada y, si la fecha de entrada tiene una identificación,
     * configura el componente.
     * @param inputDates - HTMLColección;Element;
     */
    createInputDateRange(inputDates) {
        for (const inputDate of inputDates) {
            setTimeout(() => {
                const inputDateRangeComponent = new BcInputDateRangeBehavior();
                let inputDateId = false;
                if (!!this.setIdDatesRange) {
                    inputDateId = this.setIdDatesRange.id.includes(inputDate.id);
                }
                if (!!inputDate.id && inputDateId) {
                    inputDateRangeComponent.setElement(inputDate);
                    inputDateRangeComponent.output = () => {
                        this.searchObject();
                    };
                    inputDateRangeComponent.setUp();
                }
            }, SEARCH_NUMBER_ZERO);
        }
    }
    /**
     * Esta función crea un componente de selección y establece el valor del componente de selección en
     * el valor del objeto.
     * @param inputSelects - es una matriz de elementos HTML
     */
    createInputSelect(inputSelects) {
        for (const inputSelect of inputSelects) {
            setTimeout(() => {
                const selectComponent = new BcInputSelectBehavior();
                const inputSelectId = this.setDataSelect[inputSelect.id];
                if (!!inputSelectId) {
                    selectComponent.setElement(inputSelect);
                    selectComponent.setItems(inputSelectId.items);
                    selectComponent.outputFunction = (data) => {
                        this.setDataSelect[inputSelect.id].value = data;
                        this.setDataSelect[inputSelect.id].typeSelect = SEARCH_INPUT_SELECT;
                        this.searchObject();
                    };
                    selectComponent.setUp();
                }
            }, SEARCH_NUMBER_ZERO);
        }
    }
    /**
     * Esta función agrega un detector de eventos a cada elemento de entrada en la matriz de entradas y,
     * cuando se activa el evento, llama a la función antirrebote, que llama a la función searchObject.
     * @param inputs - una matriz de elementos de entrada
     * @param timeEject - numero = SEARCH_NUMBER_FIVE_HUNDRED;
     */
    listenerElementInput(inputs, timeEject) {
        for (const input of inputs) {
            input.addEventListener(BcCommonConstants.EVENT_INPUT, this.debounce(() => {
                this.searchObject();
            }, timeEject || SEARCH_NUMBER_FIVE_HUNDRED));
        }
    }
    /**
     * La función de rebote utiliza un temporizador para realizar un seguimiento del tiempo de espera. El
     * temporizador se almacena en la variable timerId.
     * @param callback - La función a ejecutar.
     * @param wait - El número de milisegundos a esperar antes de llamar a la devolución de llamada.
     * @returns Una función que admite una devolución de llamada y un tiempo de espera.
     */
    debounce(callback, wait) {
        let timerId;
        return (...args) => {
            clearTimeout(timerId);
            timerId = setTimeout(() => {
                callback(...args);
            }, wait);
        };
    }
    /**
     * Realiza la asiganacion de los datos del select al ser seleccionado.
     * @param setData
     * @memberof BcSearchBehavior
     */
    setInputsElementSelect(setData) {
        this.setDataSelect = setData;
    }
    /**
     * Realiza la Asignación de los datos del input date al ser seleccionado.
     * @param setId
     * @memberof BcSearchBehavior
     */
    setInputsDateId(setId) {
        this.setIdDates = setId;
    }
    /**
     * Realiza la Asignación de los datos del input date al ser seleccionado.
     * @param setId
     * @memberof BcSearchBehavior
     */
    setInputsDateRangeId(setId) {
        this.setIdDatesRange = setId;
    }
    /**
     * Realiza la búsqueda de los datos a partir de los filtros retorna un true o false de acuerdo a los datos encontrados .
     * @param user
     * @param filter
     * @returns {boolean} booleanResult (true si hay resultados, false en caso contrario)
     * @memberof BcSearchBehavior
     */
    dataSearch(user, filter) {
        let booleanResult = BcCommonConstants.FALSE;
        const keys = Object.keys(filter);
        keys.forEach(key => {
            if (filter[key].length) {
                return (booleanResult = this.verifyFilterSearchReturn(filter, key, user, booleanResult));
            }
        });
        return booleanResult;
    }
    /**
     * Realiza la búsqueda de los datos a partir de los filtros y verifica si hay o no resultados.
     * @param filter
     * @param key
     * @param user
     * @param booleanResult
     * @returns {boolean} booleanResult (true si hay resultados, false en caso contrario)
     * @memberof BcSearchBehavior
     */
    verifyFilterSearchReturn(filter, key, user, booleanResult) {
        booleanResult = this.dataSearchIsNotArray(key, booleanResult, user, filter);
        return booleanResult;
    }
    /**
     * Si los datos del usuario no son una matriz, compruebe si los datos del usuario están incluidos en
     * los datos del filtro.
     * @param {string} key - cadena - la clave del objeto
     * @param {boolean} booleanResult - booleano: este es el resultado de la búsqueda.
     * @param {any} user - es el objeto que se busca
     * @param {any} filter - {
     * @returns un valor booleano.
     */
    dataSearchIsNotArray(key, booleanResult, user, filter) {
        const objData = this.mySelf.querySelectorAll(`.${BcCommonConstants.INPUT_TAG}[name=${key}]`);
        if (objData.length && objData[SEARCH_NUMBER_ZERO].dataset.value) {
            booleanResult = String(user[objData[SEARCH_NUMBER_ZERO].dataset.value])
                .toUpperCase()
                .includes(filter[key].toUpperCase());
            if (!booleanResult) {
                booleanResult = String(user[key]).toUpperCase().includes(filter[key].toUpperCase());
            }
        }
        else {
            if (user[key] && filter[key]) {
                let currentProperties = [];
                for (const keyFilter in filter) {
                    currentProperties = currentProperties.concat(keyFilter);
                    if (currentProperties.length > 1) {
                        let filterSeveralInputs = [];
                        for (let index = 0; index < currentProperties.length; index++) {
                            filterSeveralInputs = filterSeveralInputs.concat(this.searchDataInput(user, currentProperties, filter, index));
                            booleanResult = !filterSeveralInputs.includes(false);
                        }
                    }
                    else {
                        booleanResult = this.searchDataInput(user, currentProperties, filter, 0);
                    }
                }
            }
        }
        return booleanResult;
    }
    /**
    * Retorna el valor de la búsqueda del search
    * @memberof BcCardSelectBehavior
    */
    searchDataInput(user, currentProperties, filter, position) {
        const filterData = filter[currentProperties[position]];
        return typeof (filterData) === 'string'
            ? String(user[currentProperties[position]]).toUpperCase().includes(filterData.toUpperCase())
            : String(filterData).toUpperCase().includes(user[currentProperties[position]].toUpperCase());
    }
    /**
     * Retorna el valor de la búsqueda del search
     * @memberof BcCardSelectBehavior
    searchDataSeveralInputs(user: any, currentProperties: string[], filter: any, position: number): boolean {
     */
    setValueInput(jsObjt) {
        this.keyObjtValue = jsObjt;
        return this.keyObjtValue;
    }
    /**
     * Busca los inputs mediante la selección de los div con la clase input-select.
     * @memberof BcSearchBehavior
     */
    setInputSelectInSearch() {
        const selectElement = this.mySelf.querySelectorAll(BcCommonConstants.DIV_TAG);
        for (const div of selectElement) {
            if (div.classList.contains(`${SEARCH_INPUT_SELECT_CLASS}`)) {
                const selectComponent = new BcInputSelectBehavior();
                selectComponent.setElement(div);
                selectComponent.outputFunction = () => {
                    this.searchObject();
                };
                selectComponent.setUp();
            }
        }
    }
    /**
     * Genera el html para mostrar los resultados de la búsqueda.
     * @param value
     * @memberof BcSearchBehavior
     */
    showQuantityItems(value) {
        const result = this.mySelf.querySelector(`.${SEARCH_CONTENT_SHOW_RESULT_CLASS}`);
        const clearSelector = this.mySelf.querySelector(`.${SEARCH_CLEAR_CLASS}`);
        const divAttributes = this.mySelf.querySelectorAll(`.${SEARCH_RESULT_NULL_CLASS} ${BcCommonConstants.DIV_TAG}`);
        let text;
        if (value === BcCommonConstants.UNDEFINED) {
            while (result.firstChild) {
                result.removeChild(result.firstChild);
            }
            clearSelector.classList.remove(`${SEARCH_CLEAR_SHOW_CLASS}`);
        }
        else if (value) {
            text = `Mostrando ${value} resultados para: ${this.stringFilters}`;
            this.changeTextResult(result, text, clearSelector);
        }
        else {
            text = `Mostrando 0 resultados para: ${this.stringFilters} `;
            this.changeTextResult(result, text, clearSelector);
        }
        this.removeOrAddAtributesDiv(value, divAttributes);
    }
    /**
     * Si el valor es falso, agregue la clase al div. Si el valor es verdadero, elimine la clase del div.
     * @param value - booleano
     * @param divAttributes - es una matriz de divs
     */
    removeOrAddAtributesDiv(value, divAttributes) {
        if (!value) {
            for (const divAttribute of divAttributes) {
                divAttribute.classList.add(`${SEARCH_SHOW_IMAGE_CLASS}`);
            }
        }
        else {
            this.removeDivAttributeImage(divAttributes);
        }
    }
    /**
     * Asignacion de valores encontrados.
     * @memberof BcSearchBehavior
     */
    changeTextResult(result, text, clearSelector) {
        const span = document.createElement(SEARCH_SPAN);
        while (result.firstChild) {
            result.removeChild(result.firstChild);
        }
        span.textContent = text;
        result.appendChild(span);
        clearSelector.classList.add(`${SEARCH_CLEAR_SHOW_CLASS}`);
    }
    /**
     * Limpia los resultados de la búsqueda y resetea los inputs.
     * @memberof BcSearchBehavior
     */
    clearSearch() {
        const result = this.mySelf.querySelector(`.${SEARCH_CONTENT_SHOW_RESULT_CLASS}`);
        const linkClean = this.mySelf.querySelector(`.${SEARCH_CLEAR_CLASS}`);
        const divAttributes = this.mySelf.querySelectorAll(`.${SEARCH_RESULT_NULL_CLASS} ${BcCommonConstants.DIV_TAG}`);
        linkClean &&
            linkClean.addEventListener(BcCommonConstants.EVENT_CLICK, () => {
                this.cleanValidation(result, linkClean, divAttributes);
            });
        addFocusable(linkClean, { tabindex: '0' });
        linkClean &&
            linkClean.addEventListener(BcCommonConstants.EVENT_KEY_UP, (event) => {
                if (event.key === BcCommonConstants.KEY_EVENT_SPACE ||
                    event.key === BcCommonConstants.KEY_EVENT_ENTER ||
                    event.key === ' ') {
                    this.cleanValidation(result, linkClean, divAttributes);
                }
            });
    }
    cleanValidation(result, linkClean, divAttributes) {
        this.jsObjt = {};
        this.jsDates = {};
        const inputValues = this.mySelf.querySelectorAll(`${BcCommonConstants.INPUT_TAG}`);
        const buttonSearch = this.mySelf.querySelector(`.${SEARCH_BUTTON_CLASS} ${BcCommonConstants.BUTTON_TAG}`);
        while (result.firstChild) {
            result.removeChild(result.firstChild);
        }
        linkClean.classList.remove(`${SEARCH_CLEAR_SHOW_CLASS}`);
        buttonSearch.disabled = BcCommonConstants.TRUE;
        for (const inputValue of inputValues) {
            if (inputValue.type === SEARCH_INPUT_CHECKBOX) {
                this.cleanInputsCheckSearch(inputValue);
            }
            else {
                if (inputValue.value) {
                    this.cleanInputsSearch(inputValue);
                }
            }
        }
        this.removeDivAttributeImage(divAttributes);
        this.resultFilter = [];
    }
    /**
     * Si el valor de entrada está marcado, configúrelo en falso.
     * @param inputValue - el elemento de entrada
     */
    cleanInputsCheckSearch(inputValue) {
        if (inputValue.checked) {
            inputValue.checked = BcCommonConstants.FALSE;
        }
    }
    /**
     * Elimina la clase de la entrada y elimina todas las opciones de la entrada.
     * @param inputValue - el elemento de entrada
     */
    cleanInputsSearch(inputValue) {
        for (const classInput of inputValue.classList) {
            if (classInput == `${INPUT_ACTIVE_SEARCH_CLASS}`) {
                inputValue.classList.remove(`${INPUT_ACTIVE_SEARCH_CLASS}`);
            }
        }
        for (let i = 0; i < inputValue.length; i++) {
            if (inputValue.options[i].value) {
                inputValue.remove(i);
            }
        }
        inputValue.value = '';
    }
    /**
     * Esta función oculta elementos en la página cuando se cambia el tamaño de la pantalla.
     */
    hideElements() {
        this.resizeSettings();
        window.addEventListener(BcCommonConstants.EVENT_RESIZE, () => {
            this.resizeSettings();
        });
    }
    /**
     * Toma el tamaño de la pantalla y se adapta a ella
     */
    resizeSettings() {
        const widthPage = window.innerWidth;
        const contentInputsBase = this.mySelf.querySelector(`.${SEARCH_CONTENT}`);
        const searchIconLupa = contentInputsBase.querySelector(`.${SEARCH_BUTTON_CLASS}`);
        const contentInputs = contentInputsBase.querySelectorAll(`:scope > ${BcCommonConstants.DIV_TAG}[class*="${SEARCH_INPUTS}"], :scope >*> ${BcCommonConstants.DIV_TAG}[class*="${SEARCH_INPUTS}"]`);
        const contentAdvanceSearch = this.mySelf.querySelector(`.${SEARCH_ADVANCED_CLASS}`);
        const contentAdvancedMobile = contentAdvanceSearch.querySelector(`${BcCommonConstants.DIV_TAG}[class="${SEARCH_CONTENT_FORM}"]`);
        if (widthPage <= SEARCH_NUMBER_BREAKPOINT_MD) {
            this.createCloneInput(contentInputs, contentAdvancedMobile);
        }
        else {
            this.deleteCloneInput(contentAdvancedMobile, searchIconLupa);
        }
    }
    /**
     * "Para cada elemento en la matriz contentInputs, si el índice es mayor que cero, inserte el
     * elemento y su nodo principal en la matriz inputContentsMemory, elimine el elemento de su nodo
     * principal y agregue el elemento al elemento contentAdvancedMobile".</code >
     * @param contentInputs - es una matriz de entradas
     * @param contentAdvancedMobile - es el div que contendrá las entradas clonadas
     */
    createCloneInput(contentInputs, contentAdvancedMobile) {
        contentInputs.forEach((element1, index) => {
            if (index > SEARCH_NUMBER_ZERO) {
                const parentNodes = element1.parentNode;
                this.inputsContentsMemory.push({
                    element: element1,
                    parent: parentNodes,
                });
                parentNodes.removeChild(element1);
                contentAdvancedMobile?.appendChild(element1);
            }
        });
    }
    /**
     * Esta función elimina las entradas de clonación que se crearon en la función anterior.
     * @param contentAdvancedMobile - es el div que contiene las entradas
     * @param searchIconLupa - es el icono que esta en la barra de busqueda
     */
    deleteCloneInput(contentAdvancedMobile, searchIconLupa) {
        const tempInpustMemoryCopy = [...this.inputsContentsMemory];
        for (let i = SEARCH_NUMBER_ZERO; i < tempInpustMemoryCopy.length; i++) {
            const elementContent = tempInpustMemoryCopy[i];
            contentAdvancedMobile?.removeChild(elementContent.element);
            this.inputsContentsMemory.splice(i, 1);
            if (!!searchIconLupa) {
                if (searchIconLupa.parentNode == elementContent.parent) {
                    elementContent.parent.insertBefore(elementContent.element, searchIconLupa);
                }
                else {
                    elementContent.parent.appendChild(elementContent.element);
                }
            }
        }
    }
    /**
     * Esta función se utiliza para inicializar el comportamiento de entrada del componente.
     */
    initInputBehavior() {
        const inputs = this.mySelf.querySelectorAll(BcCommonConstants.INPUT_TAG);
        for (let i = SEARCH_NUMBER_ZERO; i < inputs.length; i++) {
            this.inputBehavior = new BcInputBehavior();
            const element = inputs[i];
            this.inputBehavior.setElement(element);
            this.inputBehavior.setUp();
        }
    }
}

const ACTIVE = 'active';
const ICON_REMOVE_ITEM = 'error';
const ICON_ADD_FILTER = 'plus';
const ATTRIBUTE_ADD_ICON = 'iconadd';
const ATTRIBUTE_DELETE_ICON = 'icondelete';
const BC_CLASS_NAME_ICON = 'bc-icon';
const ATTRIBUTE_WIDTH_TAG = 'widthTag';
const FLOAT_MENU = `${BcCommonConstants.PREFIX_LIB}-float-menu`;
const BC_CLASS_NAME_COMPONENT = `${BcCommonConstants.PREFIX_LIB}-tag`;
const BC_CLASS_NAME_CONTENT = `${BC_CLASS_NAME_COMPONENT}-content`;
const ICON_TAG_TOGGLE = `${BcCommonConstants.PREFIX_LIB}-icon-tag-toggle`;
const BC_CONTAINER_CHECKBOX = `${BcCommonConstants.PREFIX_LIB}-container-checkbox`;
const BC_CLASS_MENU_FLOAT_OPTION = `${FLOAT_MENU}-option`;
const BC_CLASS_MENU_FLOAT_TEXT = `${FLOAT_MENU}-main-text`;
const BC_CLASS_MENU_FLOAT_TOGGLE = `${FLOAT_MENU}-toggle`;
const BC_CLASS_MENU_FLOAT_CONTENT_ACTIVE = `${FLOAT_MENU}-content-active`;
const BC_CLASS_NAME_FILTER_ACTIVE = `${BC_CLASS_NAME_COMPONENT}-filter-${ACTIVE}`;
const BC_CLASS_NAME_FILTER = `${BC_CLASS_NAME_COMPONENT}-filter`;
const BC_CLASS_NAME_FILTER_DISABLED = `${BC_CLASS_NAME_COMPONENT}-filter-disabled`;

class BcTagBehavior extends BcDefaultBehavior {
    constructor() {
        super();
    }
    static setUpAll() {
        const tagButtonElements = Array.from(document.querySelectorAll(`div[class~='${BC_CLASS_NAME_CONTENT}']`));
        const elements = [];
        for (let i = 0; i < tagButtonElements.length; i++) {
            const element = tagButtonElements[i];
            const bc = new BcTagBehavior();
            bc.setElement(element);
            bc.setUp();
            elements.push(bc);
        }
        return elements;
    }
    _setUp() {
        this.setWidthtag();
        super._setUp();
        this.createItems();
        this.addIconFilter();
        this.addFiltersListeners();
        this.addToggleListener();
        this.addListenerWIndow();
        if (this.mySelf.getAttribute('selectionTag') == 'true') {
            BcFloatMenuBehavior.setUpAll();
        }
    }
    addToggleListener() {
        const menuToggle = this.mySelf.getElementsByClassName('bc-float-menu-toggle')[0];
        const iconTag = this.mySelf.getElementsByClassName(ICON_TAG_TOGGLE)[0];
        menuToggle.addEventListener(BcCommonConstants.EVENT_CLICK, () => {
            setTimeout(() => {
                if (this.mySelf.getElementsByClassName(BC_CLASS_MENU_FLOAT_CONTENT_ACTIVE).length > 0) {
                    iconTag.innerHTML = BcCommonConstants.ICON_ARROW_UP;
                }
                else {
                    iconTag.innerHTML = BcCommonConstants.ICON_ARROW_DOWN;
                }
            });
        });
    }
    addListenerWIndow() {
        const iconTag = this.mySelf.getElementsByClassName(ICON_TAG_TOGGLE)[0];
        window.addEventListener(BcCommonConstants.EVENT_CLICK, (event) => {
            const isToggleElement = event.target.className.includes(BC_CLASS_MENU_FLOAT_TOGGLE);
            const isMainElement = event.target.className.includes(BC_CLASS_MENU_FLOAT_OPTION);
            const checkbox = event.target.className.includes(BC_CONTAINER_CHECKBOX);
            setTimeout(() => {
                if (this.mySelf.getElementsByClassName(BC_CLASS_MENU_FLOAT_CONTENT_ACTIVE).length == 0 && !isToggleElement && !isMainElement && !checkbox) {
                    iconTag.innerHTML = BcCommonConstants.ICON_ARROW_DOWN;
                }
            });
        });
    }
    setWidthtag() {
        this.tagElement = this.mySelf;
        if (this.mySelf.getAttribute(ATTRIBUTE_WIDTH_TAG)) {
            this.widthTag = parseInt(this.mySelf.getAttribute(ATTRIBUTE_WIDTH_TAG));
            this.tagElement.style.width = this.widthTag + 'px';
        }
        else {
            this.tagElement.style.width = 'auto';
        }
    }
    addFiltersListeners() {
        this.eventClick();
        this.eventKeyPress();
    }
    tagSelected() {
        const buttonSelected = this.mySelf;
        if (buttonSelected.firstElementChild.classList.contains(BC_CLASS_NAME_FILTER)) {
            buttonSelected.firstElementChild.classList.toggle(BC_CLASS_NAME_FILTER_ACTIVE);
            if (buttonSelected.firstElementChild.classList.contains(BC_CLASS_NAME_FILTER_ACTIVE)) {
                this.tagActive();
            }
            else {
                this.tagNoActive();
            }
        }
    }
    tagActive() {
        const buttonSelected = this.mySelf;
        buttonSelected.firstElementChild.setAttribute(BcCommonConstants.ARIA_CURRENT, 'true');
        if (buttonSelected.firstElementChild.getAttribute(ATTRIBUTE_DELETE_ICON) !== 'false') {
            if (buttonSelected.firstElementChild.getAttribute(ATTRIBUTE_ADD_ICON) !== 'false') {
                buttonSelected.firstElementChild.lastElementChild.innerHTML = ICON_REMOVE_ITEM;
            }
            else {
                this.createIcon(ICON_REMOVE_ITEM, buttonSelected.firstElementChild.lastElementChild);
            }
        }
    }
    tagNoActive() {
        const buttonSelected = this.mySelf;
        buttonSelected.firstElementChild.setAttribute(BcCommonConstants.ARIA_CURRENT, 'false');
        if (buttonSelected.firstElementChild.getAttribute(ATTRIBUTE_ADD_ICON) !== 'false') {
            buttonSelected.firstElementChild.lastElementChild.innerHTML = ICON_ADD_FILTER;
        }
        else {
            if (buttonSelected.firstElementChild.getAttribute(ATTRIBUTE_DELETE_ICON) !== 'false') {
                buttonSelected.firstElementChild.lastElementChild.remove();
            }
        }
    }
    eventClick() {
        const buttonSelected = this.mySelf;
        buttonSelected.addEventListener(BcCommonConstants.EVENT_CLICK, (e) => {
            this.tagSelected();
        });
    }
    eventKeyPress() {
        const buttonSelected = this.mySelf;
        buttonSelected.addEventListener(BcCommonConstants.EVENT_KEY_PRESS, (e) => {
            const clickEnter = e.code === BcCommonConstants.KEY_EVENT_ENTER;
            const clickSpace = e.code === BcCommonConstants.KEY_EVENT_SPACE;
            if (clickEnter || clickSpace) {
                this.tagSelected();
            }
        });
    }
    listenerSelectOption() {
        const elementLi = this.mySelf.querySelectorAll(BcCommonConstants.LI_TAG);
        elementLi.forEach(element => {
            element.addEventListener(BcCommonConstants.EVENT_CLICK, (e) => {
                this.selectOption(e);
            });
            element.addEventListener(BcCommonConstants.EVENT_KEY_PRESS, (e) => {
                const clickEnter = e.code === BcCommonConstants.KEY_EVENT_ENTER;
                const clickSpace = e.code === BcCommonConstants.KEY_EVENT_SPACE;
                if (clickEnter || clickSpace) {
                    this.selectOption(e);
                }
            });
        });
    }
    selectOption(e) {
        const iconTag = this.mySelf.getElementsByClassName(ICON_TAG_TOGGLE)[0];
        const valueSelected = e.currentTarget.getAttribute('data-value');
        const valueText = e.target.lastElementChild.lastElementChild.innerHTML;
        this.outputFunction(this.addValueObject(valueSelected));
        if (this.mySelf.getAttribute('showOptionSelected') == 'true') {
            this.changeValueSelected(valueText);
        }
        iconTag.innerHTML = BcCommonConstants.ICON_ARROW_DOWN;
    }
    changeValueSelected(value) {
        const selected = this.mySelf.querySelector(BcCommonConstants.P_TAG);
        const textOptionSelected = selected;
        textOptionSelected.innerText = value;
    }
    addValueObject(data) {
        return {
            idElement: this.mySelf.id,
            value: data
        };
    }
    createItems() {
        const existsLiItem = this.validateItemsExists();
        if (!existsLiItem) {
            if (this.itemsConfig) {
                const itemsList = [];
                for (const itemObj of this.itemsConfig) {
                    const index = this.itemsConfig.indexOf(itemObj);
                    let li = null;
                    li = this.itemsConfig[index];
                    itemsList.push(li);
                }
                this.updateItemCreate(itemsList);
            }
        }
        else {
            this.listenerSelectOption();
        }
    }
    addIconFilter() {
        const buttonFilter = this.mySelf;
        const buttonType = this.mySelf.firstElementChild.classList;
        const buttonDefault = buttonType.contains(BC_CLASS_NAME_FILTER);
        const buttonDisable = buttonType.contains(BC_CLASS_NAME_FILTER_DISABLED);
        if (buttonDefault || buttonDisable) {
            if (buttonFilter.firstElementChild.getAttribute(ATTRIBUTE_ADD_ICON) !== 'false') {
                const tagElement = this.mySelf.firstElementChild.lastElementChild;
                this.createIcon(ICON_ADD_FILTER, tagElement);
            }
        }
    }
    createIcon(icon, tagElement) {
        const el = document.createElement("em");
        el.classList.add(BC_CLASS_NAME_ICON);
        el.classList.add('bc-xs');
        if (icon == ICON_REMOVE_ITEM) {
            el.tabIndex = 0;
        }
        el.innerHTML = icon;
        this.insertAfter(el, tagElement);
    }
    insertAfter(newNode, referenceNode) {
        referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
    }
    daleteICon(icon) {
        icon.remove();
    }
    validateItemsExists() {
        return this.mySelf.querySelectorAll(BcCommonConstants.LI_TAG).length;
    }
    /**
     * En caso de tener elementos para la lista llama a esta funcion para realizar el seteo
     * @memberof BcTagBehavior
     */
    setItems(items) {
        this.itemsConfig = items;
    }
    updateItemCreate(arrData) {
        const content = this.mySelf.querySelector(BcCommonConstants.UL_TAG);
        content.innerHTML = '';
        for (const item of arrData) {
            const liElementCreate = createElement({
                element: BcCommonConstants.LI_TAG,
                classList: [BC_CLASS_MENU_FLOAT_OPTION],
                props: { tabindex: 0 },
                children: [
                    createElement({
                        element: BcCommonConstants.EM_TAG,
                        innerText: item.iconName,
                        classList: [BC_CLASS_NAME_ICON, 'bc-sm']
                    }),
                    createElement({
                        element: BcCommonConstants.HREF_TAG,
                        children: [
                            createElement({
                                element: BcCommonConstants.SPAN_TAG,
                                classList: [BC_CLASS_MENU_FLOAT_TEXT],
                                innerText: item.spanText,
                            })
                        ],
                    })
                ]
            });
            liElementCreate.dataset.value = item.value;
            content.appendChild(liElementCreate);
        }
        this.listenerSelectOption();
    }
}

const BC_EXPANSION_PANEL_SELECTOR = `${BcCommonConstants.PREFIX_LIB}-expansion-panel`;
const BC_EXPANSION_PANEL_HEADER_SELECTOR = `${BcCommonConstants.PREFIX_LIB}-expansion-panel-header`;
const BC_EXPANSION_PANEL_CONTENT_SELECTOR = `${BcCommonConstants.PREFIX_LIB}-expansion-panel-content`;
const BC_EXPANSION_PANEL_CONTENT_WRAPPER_SELECTOR = `${BcCommonConstants.PREFIX_LIB}-expansion-panel-content-wrapper`;
const BC_EXPANSION_PANEL_FOOTER_SELECTOR = `${BcCommonConstants.PREFIX_LIB}-expansion-panel-footer`;
const BC_EXPANSION_PANEL_FOOTER_ICON_SELECTOR = `${BcCommonConstants.PREFIX_LIB}-expansion-footer-icon`;
const BC_EXPANSION_ICON_DOWN = `arrow-angle-double-dow`;
const BC_EXPANSION_ICON_UP = `arrow-angle-double-up`;

class BcExpansionPanelBehavior extends BcDefaultBehavior {
    constructor() {
        super();
        this.bcCallBacksEvents = {
            expanded: null,
            contracted: null
        };
    }
    /**
  * Metodo para implementación nativa
  * @return {*}  {bcExpansionPanelBehavior[]}
  * @memberof bcExpansionPanelBehavior
  */
    static setUpAll() {
        const expansionPanelElements = Array.from(document.querySelectorAll(`div[class~='${BC_EXPANSION_PANEL_SELECTOR}']`));
        const elements = [];
        for (const element of expansionPanelElements) {
            const bcExpansionPanelBehavior = new BcExpansionPanelBehavior();
            bcExpansionPanelBehavior.setElement(element);
            bcExpansionPanelBehavior.setUp();
            elements.push(bcExpansionPanelBehavior);
        }
        return elements;
    }
    _setUp() {
        this.selectElements();
        this.addListeners();
        this.setDefaultValues();
    }
    /**
     * Selecciona los elementos html
     * @memberof BcExpansionPanelBehavior
     */
    selectElements() {
        this.bcExpansionPanelHeaderElement = this.mySelf.querySelector(`.${BC_EXPANSION_PANEL_HEADER_SELECTOR}`);
        this.bcExpansionPanelContentElement = this.mySelf.querySelector(`div[class~='${BC_EXPANSION_PANEL_CONTENT_SELECTOR}']`);
        this.bcExpansionPanelContentWrapperElement = this.mySelf.querySelector(`div[class~='${BC_EXPANSION_PANEL_CONTENT_SELECTOR}'] .${BC_EXPANSION_PANEL_CONTENT_WRAPPER_SELECTOR}`);
        this.bcExpansionPanelFooterElement = this.mySelf.querySelector(`div[class~='${BC_EXPANSION_PANEL_FOOTER_SELECTOR}']`);
        this.bcExpansionPanelFooterIconElement = this.bcExpansionPanelFooterElement.querySelector(`em[class~='${BC_EXPANSION_PANEL_FOOTER_ICON_SELECTOR}']`);
    }
    /**
     * Añade valores inciale a los elementos
     * @memberof BcExpansionPanelBehavior
     */
    setDefaultValues() {
        const idContentElement = `${BC_EXPANSION_PANEL_CONTENT_SELECTOR}-${this.mySelf.getAttribute('id')}`;
        this.bcExpansionPanelContentElement.setAttribute('id', idContentElement);
        changeAriaControlsValue(this.bcExpansionPanelFooterIconElement, idContentElement);
    }
    /**
     * Añade los eventos a los elementos
     * @memberof BcExpansionPanelBehavior
     */
    addListeners() {
        this.bcExpansionPanelFooterElement.addEventListener(BcCommonConstants.EVENT_CLICK, this.toogleExpandedContent.bind(this));
    }
    /**
     * Expande o contrae el espansion panel
     * @memberof BcExpansionPanelBehavior
     */
    toogleExpandedContent() {
        if (this.bcExpansionPanelContentElement.classList.contains(`${BC_EXPANSION_PANEL_SELECTOR}-content-expanded`)) {
            return this.contractContent();
        }
        return this.expandContent();
    }
    /**
    * Contrae el espansion panel
    * @memberof BcExpansionPanelBehavior
    */
    contractContent() {
        this.bcExpansionPanelContentElement.classList.remove(`${BC_EXPANSION_PANEL_SELECTOR}-content-expanded`);
        this.bcExpansionPanelContentWrapperElement.style.opacity = '0';
        this.bcExpansionPanelFooterIconElement.innerHTML = BC_EXPANSION_ICON_DOWN;
        changeAriaExpandedValue(this.bcExpansionPanelContentElement, false);
        return this.bcCallBacksEvents.contracted ? this.bcCallBacksEvents.contracted() : undefined;
    }
    /**
     * Expande el espansion panel
     * @memberof BcExpansionPanelBehavior
     */
    expandContent() {
        this.bcExpansionPanelContentElement.classList.add(`${BC_EXPANSION_PANEL_SELECTOR}-content-expanded`);
        this.bcExpansionPanelFooterIconElement.innerHTML = BC_EXPANSION_ICON_UP;
        this.bcExpansionPanelContentWrapperElement.style.opacity = '1';
        changeAriaExpandedValue(this.bcExpansionPanelContentElement, true);
        return this.bcCallBacksEvents.expanded ? this.bcCallBacksEvents.expanded() : undefined;
    }
    /**
     * Registra los eventos de expandir y/o
     * contraer
     * @memberof BcExpansionPanelBehavior
     */
    on(eventText, callback) {
        this.bcCallBacksEvents[eventText] = callback;
    }
}

class BcTableConstansts {
}
BcTableConstansts.TABLE_CONTAINER_CLASS = `${BcCommonConstants.PREFIX_LIB}-table-container`;
BcTableConstansts.TABLE_CLASS = `${BcCommonConstants.PREFIX_LIB}-table`;
BcTableConstansts.TABLE_SELECTION_CLASS = `${BcCommonConstants.PREFIX_LIB}-table-selection`;
BcTableConstansts.TABLE_SELECTION_RADIO_CLASS = `${BcCommonConstants.PREFIX_LIB}-table-selection-radio`;
BcTableConstansts.TABLE_SORT_CLASS = `${BcCommonConstants.PREFIX_LIB}-table-sort`;
BcTableConstansts.TABLE_CELL_ACTION_DROPDOWN_CLASS = `${BcCommonConstants.PREFIX_LIB}-table-action-cell-dropdown`;
BcTableConstansts.TABLE_CELL_ACTION_INLINE_CLASS = `${BcCommonConstants.PREFIX_LIB}-table-action-cell-inline`;
BcTableConstansts.TABLE_ROW_ACTION_CLASS = `${BcCommonConstants.PREFIX_LIB}-table-row-action`;
BcTableConstansts.TABLE_NOT_HIDE_PAGINATORS_CLASS = `${BcCommonConstants.PREFIX_LIB}-table-not-hide-paginators`;
BcTableConstansts.TABLE_THEAD_SELECTABLE = `${BcCommonConstants.PREFIX_LIB}-table-thead-selectable`;
BcTableConstansts.TABLE_CELL_ACTION_DROPDOWN_CLASS_HTML = `${BcCommonConstants.PREFIX_LIB}-table-action-cell-dropdown-html`;
BcTableConstansts.TABLE_ROW_CLASS = `tr`;
BcTableConstansts.TABLE_TH_CLASS = `th`;
BcTableConstansts.TABLE_TD_CLASS = `td`;
BcTableConstansts.TABLE_TBODY_CLASS = `tbody`;
BcTableConstansts.TABLE_CHECKBOX_SELECTOR = `checkbox`;
BcTableConstansts.TABLE_MASTER_CHECKBOX_CLASS = `${BcCommonConstants.PREFIX_LIB}-table-master-checkbox'`;
BcTableConstansts.TABLE_SELECTED_CLASS = `${BcCommonConstants.PREFIX_LIB}-selected`;
BcTableConstansts.TABLE_HEADER_TOP_CLASS = `${BcCommonConstants.PREFIX_LIB}-table-header-top`;
BcTableConstansts.TABLE_HEAD_CLASS = `thead`;
BcTableConstansts.TABLE_FOOTER_CLASS = `${BcCommonConstants.PREFIX_LIB}-table-footer`;
BcTableConstansts.TABLE_FOOTER_SUBCONTAINER = `${BcCommonConstants.PREFIX_LIB}-table-footer-subcontainer`;
BcTableConstansts.TABLE_FOOTER_CONTAINER = `${BcCommonConstants.PREFIX_LIB}-table-footer-container`;
BcTableConstansts.TABLE_PAGINATOR_CONTAINER = `${BcCommonConstants.PREFIX_LIB}-table-paginator-container`;
BcTableConstansts.TABLE_HEADER_TOP_SELECTION_CLASS = `${BcCommonConstants.PREFIX_LIB}-selection`;
BcTableConstansts.TABLE_RIGHT_CONTAINER_CLASS = `${BcCommonConstants.PREFIX_LIB}-table-header-top-right-container`;
BcTableConstansts.TABLE_ACTION_CONTAINER_CLASS = `${BcCommonConstants.PREFIX_LIB}-table-actions-container`;
BcTableConstansts.TABLE_ACTION_BUTTON_CLASS = `${BcCommonConstants.PREFIX_LIB}-table-selection-action-button`;
BcTableConstansts.TABLE_SELECTION_COUNTER_CLASS = `${BcCommonConstants.PREFIX_LIB}-selection-counter`;
BcTableConstansts.TABLE_SELECTION_REMOVE_CLASS = `${BcCommonConstants.PREFIX_LIB}-selection-remove`;
BcTableConstansts.TABLE_SELECTION_ACTION_BUTTON_CLASS = `${BcCommonConstants.PREFIX_LIB}-table-selection-action-button`;
BcTableConstansts.TABLE_SETTING_BODY_CLASS = `${BcCommonConstants.PREFIX_LIB}-table-setting-body`;
BcTableConstansts.TABLE_SETTING_FOOTER_CLASS = `${BcCommonConstants.PREFIX_LIB}-table-setting-footer`;
BcTableConstansts.TABLE_PAGINATOR_MOBILE = `${BcCommonConstants.PREFIX_LIB}-paginator-mobile`;
BcTableConstansts.TABLE_DISPLAY_NONE = `none`;
BcTableConstansts.TABLE_DISPLAY_CELL = `table-cell`;
BcTableConstansts.TABLE_CHECBOX_CELL_CLASS = `${BcCommonConstants.PREFIX_LIB}-table-checkbox-cell`;
BcTableConstansts.TABLE_CHECBOX_CONTAINER_CLASS = `${BcCommonConstants.PREFIX_LIB}-container-checkbox`;
BcTableConstansts.TABLE_ACTION_COLUMN_CLASS = `${BcCommonConstants.PREFIX_LIB}-table-action-column`;
BcTableConstansts.TABLE_ACTION_CELL_CLASS = `${BcCommonConstants.PREFIX_LIB}-table-action-cell`;
BcTableConstansts.TABLE_SORT_ICON_CLASS = `${BcCommonConstants.PREFIX_LIB}-sort-icon`;
BcTableConstansts.TABLE_SORT_ICON_HOVER_CLASS = `${BcCommonConstants.PREFIX_LIB}-sort-icon-hover`;
BcTableConstansts.TABLE_HEADER_ACTIONS_CLASS = `${BcCommonConstants.PREFIX_LIB}-table-header-actions`;
BcTableConstansts.TABLE_EXTRA_ROW_CLASS = `${BcCommonConstants.PREFIX_LIB}-table-extra-info-row`;
BcTableConstansts.TABLE_EXTRA = `${BcCommonConstants.PREFIX_LIB}-table-extra`;
BcTableConstansts.TABLE_EXTRA_ROW_CONTENT_CLASS = `${BcCommonConstants.PREFIX_LIB}-table-extra-info-row-content`;
BcTableConstansts.TABLE_EXTRA_ROW_CONTENT_ACTIONS_CLASS = `${BcCommonConstants.PREFIX_LIB}-table-extra-info-row-content-actions`;
BcTableConstansts.TABLE_EXTRA_ROW_ACTIVE_CLASS = `${BcCommonConstants.PREFIX_LIB}-table-extra-info-row-active`;
BcTableConstansts.TABLE_ACTION_TOGGLE_CLASS = `${BcCommonConstants.PREFIX_LIB}-table-action-toggle`;
BcTableConstansts.TABLE_HIDDEN_CLASS = `${BcCommonConstants.PREFIX_LIB}-hidden`;
BcTableConstansts.TABLE_BORDER_CLASS = `${BcCommonConstants.PREFIX_LIB}-border-cell`;
BcTableConstansts.TABLE_SHADOW_CLASS = `${BcCommonConstants.PREFIX_LIB}-shadow-03`;
BcTableConstansts.TABLE_NONE_CLASS = `${BcCommonConstants.PREFIX_LIB}-none`;
BcTableConstansts.TABLE_FAVORITE_COLUMN_CLASS = `${BcCommonConstants.PREFIX_LIB}-table-favorite-column`;
BcTableConstansts.TABLE_FAVORITE_CELL_CLASS = `${BcCommonConstants.PREFIX_LIB}-table-favorite-cell`;
BcTableConstansts.TABLE_DROPDOWN_CLASS = `${BcCommonConstants.PREFIX_LIB}-dropdown`;
BcTableConstansts.TABLE_DROPDOWN_ITEM_CLASS = `${BcCommonConstants.PREFIX_LIB}-dropdown-item`;
BcTableConstansts.TABLE_DROPDOWN_SETTINGS_CLASS = `${BcCommonConstants.PREFIX_LIB}-table-dropdown-setting`;
BcTableConstansts.TABLE_HEADER_TITLE_CLASS = `${BcCommonConstants.PREFIX_LIB}-table-header-top-title`;
BcTableConstansts.TABLE_TEMP_CLASS = `${BcCommonConstants.PREFIX_LIB}-temp`;
BcTableConstansts.TABLE_SETTING_CLASS = `${BcCommonConstants.PREFIX_LIB}-table-with-setting`;
BcTableConstansts.TABLE_SCROLL_CLASS = `${BcCommonConstants.PREFIX_LIB}-table-scroll`;
BcTableConstansts.TABLE_CONTENT_CLASS = `${BcCommonConstants.PREFIX_LIB}-table-content`;
BcTableConstansts.TABLE_FIXED_COLUMN_CLASS = `${BcCommonConstants.PREFIX_LIB}-table-fixed-column`;
BcTableConstansts.TABLE_BUTTON_FIXER = `${BcCommonConstants.PREFIX_LIB}-button-fixer`;
BcTableConstansts.TABLE_FIXED_COLUMN_LEFT_CLASS = `${BcCommonConstants.PREFIX_LIB}-table-fixed-column-left`;
BcTableConstansts.TABLE_FIXED_CELL_CLASS = `${BcCommonConstants.PREFIX_LIB}-table-fixed-cell`;
BcTableConstansts.TABLE_FIXED_ACTION_CELL_CLASS = `${BcCommonConstants.PREFIX_LIB}-table-fixed-action-cell`;
BcTableConstansts.TABLE_TEXT_CELL_CLASS = `${BcCommonConstants.PREFIX_LIB}-table-text-cell`;
BcTableConstansts.TABLE_PAGINATOR = `${BcCommonConstants.PREFIX_LIB}-paginator`;
BcTableConstansts.TABLE_DROPDOWN_CONTENT = `${BcCommonConstants.PREFIX_LIB}-dropdown-content`;
BcTableConstansts.TABLE_DROPDOWN_TOGGLE_CLASSS = `${BcCommonConstants.PREFIX_LIB}-dropdown-toggle`;
BcTableConstansts.TABLE_EMPTY_ACCORDION = `${BcCommonConstants.PREFIX_LIB}-table-empy-accordion`;
BcTableConstansts.TABLE_SUBCONTAINER = `${BcCommonConstants.PREFIX_LIB}-table-subcontainer`;
BcTableConstansts.TABLE_DROPDOWN = `myTableDropdown`;
BcTableConstansts.TABLE_DROPDOWN_TOGGLE = `myTableDropdownToggle`;
BcTableConstansts.TABLE_HOVER_ICON_CLASS = `exchange`;
BcTableConstansts.TABLE_SMALL_BREAK_POINT = '575';
BcTableConstansts.TABLE_MEDIUM_BREAK_POINT = '992';
BcTableConstansts.TABLE_LARGE_BREAK_POINT = '1024';
BcTableConstansts.TABLE_EXTRALARGE_BREAK_POINT = '1280';
BcTableConstansts.TABLE_NUMBER_0 = '0';
BcTableConstansts.TABLE_NUMBER_1 = '1';
BcTableConstansts.TABLE_NUMBER_2 = '2';
BcTableConstansts.TABLE_NUMBER_3 = '3';
BcTableConstansts.TABLE_NUMBER_4 = '4';
BcTableConstansts.TABLE_NUMBER_6 = '6';
BcTableConstansts.TABLE_NUMBER_8 = '8';
BcTableConstansts.TABLE_NUMBER_10 = '10';
class BcTableConstanstsSpec {
}
BcTableConstanstsSpec.tableHTML = `
  <div class="bc-table-container" id="myTable">
  <div class="bc-table-header-top">
    <h6 class="bc-table-header-top-title">Título</h6>
    <div class="bc-table-header-top-right-container">
      <div class="bc-table-actions-container">
        <div class="bc-table-paginator-container">
          <nav class="bc-paginator" id="full" role="navigation" aria-label="paginador" totalregisters="300"
            perpage="5" multiple="5" typepaginator="full"></nav>
        </div></div></div></div>
  <div class="bc-table-content">
    <table class="bc-table bc-table-sort bc-table-selection bc-table-action-cell-dropdown ">
      <thead><tr>
          <th>nombre de cuenta</th>
          <th table-column-width="200px">Ultimo movimiento</th>
          <th class="bc-table-number-column">Saldo en canje</th>
          <th class="bc-table-number-column">Saldo total</th>
          <th class="bc-table-number-column">Saldo disponible</th>
          <th class="bc-table-number-column">Saldo disponible 2</th>
          <th class="bc-table-number-column">Columna extra 1</th>
          <th class="bc-table-number-column">Columna extra 2</th>
          <th class="bc-table-number-column">Columna extra 3</th>
          <th class="bc-table-number-column">Columna extra 4</th>
          <th class="bc-table-number-column">Columna extra 5</th>
        </tr></thead>
      <tbody><tr>
          <td class="bc-table-text-cell">Cuenta 1 va a ser el ejemplo de tamaño maximo para esta ocación pongamos algo
            más grande</td>
          <td>21/12/2020</td>
          <td class="bc-table-number-cell">$ 10.000.00,00 canje</td>
          <td class="bc-table-number-cell">0 total</td>
          <td class="bc-table-number-cell bc-total-cell">$ 7.000.000,00 dis</td>
          <td class="bc-table-number-cell bc-total-cell">$ 20.000.000,00 dis2</td>
          <td class="bc-table-number-cell">Valor extra 1 row 1</td>
          <td class="bc-table-number-cell">Valor extra 1 row 2</td>
          <td class="bc-table-number-cell">Valor extra 1 row 3</td>
          <td class="bc-table-number-cell">Valor extra 1 row 4</td>
          <td class="bc-table-content-cell">
            <div class="bc-progress-container" data-background="false">
              <progress value="80" max="100"></progress></div>
          </td></tr>
        <tr>
          <td class="bc-table-text-cell">Cuenta 1 va a ser el ejemplo de tamaño maximo para esta ocación pongamos algo
            más grande</td>
          <td>21/12/2020</td>
          <td class="bc-table-number-cell">$ 10.000.00,00 canje</td>
          <td class="bc-table-number-cell">0 total</td>
          <td class="bc-table-number-cell bc-total-cell">$ 7.000.000,00 dis</td>
          <td class="bc-table-number-cell bc-total-cell">$ 20.000.000,00 dis2</td>
          <td class="bc-table-number-cell">Valor extra 1 row 1</td>
          <td class="bc-table-number-cell">Valor extra 1 row 2</td>
          <td class="bc-table-number-cell">Valor extra 1 row 3</td>
          <td class="bc-table-number-cell">Valor extra 1 row 4</td>
          <td class="bc-table-content-cell">
            <div class="bc-progress-container" data-background="false">
              <progress value="80" max="100"></progress></div></td></tr><tr>
          <td class="bc-table-text-cell">Cuenta 1 va a ser el ejemplo de tamaño maximo para esta ocación pongamos algo
            más grande</td>
          <td>21/12/2020</td>
          <td class="bc-table-number-cell">$ 10.000.00,00 canje</td>
          <td class="bc-table-number-cell">0 total</td>
          <td class="bc-table-number-cell bc-total-cell">$ 7.000.000,00 dis</td>
          <td class="bc-table-number-cell bc-total-cell">$ 20.000.000,00 dis2</td>
          <td class="bc-table-number-cell">Valor extra 1 row 1</td>
          <td class="bc-table-number-cell">Valor extra 1 row 2</td>
          <td class="bc-table-number-cell">Valor extra 1 row 3</td>
          <td class="bc-table-number-cell">Valor extra 1 row 4</td>
          <td class="bc-table-content-cell">
            <div class="bc-progress-container" data-background="false">
              <progress value="80" max="100"></progress></div></td>
        </tr><tr>
          <td class="bc-table-text-cell">Cuenta 1 va a ser el ejemplo de tamaño maximo para esta ocación pongamos algo
            más grande</td>
          <td>21/12/2020</td>
          <td class="bc-table-number-cell">$ 10.000.00,00 canje</td>
          <td class="bc-table-number-cell">0 total</td>
          <td class="bc-table-number-cell bc-total-cell">$ 7.000.000,00 dis</td>
          <td class="bc-table-number-cell bc-total-cell">$ 20.000.000,00 dis2</td>
          <td class="bc-table-number-cell">Valor extra 1 row 1</td>
          <td class="bc-table-number-cell">Valor extra 1 row 2</td>
          <td class="bc-table-number-cell">Valor extra 1 row 3</td>
          <td class="bc-table-number-cell">Valor extra 1 row 4</td>
          <td class="bc-table-content-cell">
            <div class="bc-progress-container" data-background="false">
              <progress value="80" max="100"></progress></div></td></tr></tbody></table></div>
  <div class="bc-table-footer">
    <div class="bc-table-footer-container">
      <div class="bc-table-footer-total-container">
        <div class="bc-table-footer-total-column">
          <p class="bc-table-footer-total-column-title">Total saldo disponible</p>
          <h6 class="bc-table-footer-total-column-value">COP $10.000.00,00</h6></div>
        <div class="bc-table-footer-total-column">
          <p class="bc-table-footer-total-column-title">Total saldo consolidado</p>
          <h6 class="bc-table-footer-total-column-value">COP $10.000.00,00</h6></div>
        <div class="bc-table-footer-total-column">
          <p class="bc-table-footer-total-column-title">Total saldo consolidado</p>
          <h6 class="bc-table-footer-total-column-value">COP $10.000.00,00</h6></div>
        <div class="bc-table-footer-total-column">
          <p class="bc-table-footer-total-column-title">Total saldo consolidado</p>
          <h6 class="bc-table-footer-total-column-value">COP $10.000.00,00</h6>
        </div>
      </div>
      <div class="bc-table-footer-subcontainer">
        <div class="bc-table-actions-container">
          <div class="bc-table-paginator-container">
            <nav class="bc-paginator" id="full_2" role="navigation" aria-label="paginador" totalregisters="300"
              perpage="5" multiple="5" typepaginator="full"></nav></div></div></div></div></div></div>
`;
BcTableConstanstsSpec.tableHTMLDropdown = `
  <div class="bc-table-header-top">
      <h6 class="bc-table-header-top-title">Título</h6>
      <div class="bc-table-header-top-right-container">
          <div class="bc-table-actions-container">
              <div class="bc-table-paginator-container">
                  <nav class="bc-paginator" id="full" role="navigation" aria-label="paginador" totalregisters="300" perpage="5" multiple="5" typepaginator="full"></nav>
              </div>
          </div>
      </div>
  </div>
  <div class="bc-table-content">
      <table class="bc-table bc-table-sort bc-table-selection">
          <thead>
              <tr>
                  <th>Nombre cuenta</th>
                  <th>Ultimo movimiento</th>
                  <th class="bc-table-number-column">Saldo en canje</th>
                  <th class="bc-table-number-column">Saldo total</th>
                  <th class="bc-table-number-column">Saldo disponible</th>
                  <th class="bc-table-number-column">Saldo disponible 2</th>
                  <th class="bc-table-action-column"></th>
              </tr>
          </thead>
          <tbody>
              <tr>
                  <td>Cuenta 1</td>
                  <td>21/12/2020</td>
                  <td class="bc-table-number-cell">$ 10.000.00,00 canje</td>
                  <td class="bc-table-number-cell">0 total</td>
                  <td class="bc-table-number-cell bc-total-cell">$ 7.000.000,00 dis</td>
                  <td class="bc-table-number-cell bc-total-cell">$ 20.000.000,00 dis2</td>
                  <td class="bc-table-action-cell">
                      <div class="bc-dropdown" id="myTableDropdown1"> <em class="bc-dropdown-toggle bc-icon bc-sm" aria-controls="myTableDropdownToggle1">secondary-menu</em>
                          <div class="bc-dropdown-content" id="myTableDropdownToggle1">
                              <ul>
                                  <li class="bc-dropdown-item"><a class="bc-link" id="lockOption" onclick="optionClick(event)" aria-action-id="lock">
                                    <em class="bc-icon bc-sm">lock</em><span>Bloquear</span>
                                    </a>
                                  </li>
                                  <li class="bc-dropdown-item"><a class="bc-link" id="removeOption" onclick="optionClick(event)" aria-action-id="remove">
                                    <em class="bc-icon bc-sm">remove</em><span>Eliminar</span></a>
                                  </li></ul></div></div></td></tr><tr>
                  <td>Cuenta 2</td>
                  <td>22/12/2020</td>
                  <td class="bc-table-number-cell">$ 10.000.00,00 canje</td>
                  <td class="bc-table-number-cell">0 total</td>
                  <td class="bc-table-number-cell bc-total-cell">$ 7.000.000,00 dis</td>
                  <td class="bc-table-number-cell bc-total-cell">$ 20.000.000,00 dis2</td>
                  <td class="bc-table-action-cell">
                      <div class="bc-dropdown" id="myTableDropdown2"> <em class="bc-dropdown-toggle bc-icon bc-sm" aria-controls="myTableDropdownToggle2">secondary-menu</em>
                          <div class="bc-dropdown-content" id="myTableDropdownToggle2"><ul>
                                  <li class="bc-dropdown-item"><a class="bc-link" id="lockOption" onclick="optionClick(event)" aria-action-id="lock">
                                    <em class="bc-icon bc-sm">lock</em><span>Bloquear</span>
                                    </a>
                                  </li>
                                  <li class="bc-dropdown-item"><a class="bc-link" id="removeOption" onclick="optionClick(event)" aria-action-id="remove">
                                    <em class="bc-icon bc-sm">remove</em><span>Eliminar</span>
                                    </a>
                                  </li>
                              </ul>
                          </div>
                      </div>
                  </td>
              </tr>
              <tr>
                  <td>Cuenta 3</td>
                  <td>23/12/2020</td>
                  <td class="bc-table-number-cell">$ 10.000.00,00 canje</td>
                  <td class="bc-table-number-cell">0 total</td>
                  <td class="bc-table-number-cell bc-total-cell">$ 7.000.000,00 dis</td>
                  <td class="bc-table-number-cell bc-total-cell">$ 20.000.000,00 dis2</td>
                  <td class="bc-table-action-cell">
                      <div class="bc-dropdown" id="myTableDropdown3"> <em class="bc-dropdown-toggle bc-icon bc-sm" aria-controls="myTableDropdownToggle3">secondary-menu</em>
                          <div class="bc-dropdown-content" id="myTableDropdownToggle3">
                              <ul>
                                  <li class="bc-dropdown-item"><a class="bc-link" id="lockOption" onclick="optionClick(event)" aria-action-id="lock">
                                    <em class="bc-icon bc-sm">lock</em><span>Bloquear</span></a>
                                  </li>
                                  <li class="bc-dropdown-item"><a class="bc-link" id="removeOption" onclick="optionClick(event)" aria-action-id="remove">
                                    <em class="bc-icon bc-sm">remove</em><span>Eliminar</span></a>
                                  </li>
                              </ul>
                          </div>
                      </div>
                  </td>
              </tr>
              <tr>
                  <td>Cuenta 4</td>
                  <td>24/12/2020</td>
                  <td class="bc-table-number-cell">$ 10.000.00,00 canje</td>
                  <td class="bc-table-number-cell">0 total</td>
                  <td class="bc-table-number-cell bc-total-cell">$ 7.000.000,00 dis</td>
                  <td class="bc-table-number-cell bc-total-cell">$ 20.000.000,00 dis2</td>
                  <td class="bc-table-action-cell">
                      <div class="bc-dropdown" id="myTableDropdown4"> <em class="bc-dropdown-toggle bc-icon bc-sm" aria-controls="myTableDropdownToggle4">secondary-menu</em>
                          <div class="bc-dropdown-content" id="myTableDropdownToggle4">
                              <ul>
                                  <li class="bc-dropdown-item"><a class="bc-link" id="lockOption" onclick="optionClick(event)" aria-action-id="lock">
                                    <em class="bc-icon bc-sm">lock</em><span>Bloquear</span></a>
                                  </li>
                                  <li class="bc-dropdown-item"><a class="bc-link" id="removeOption" onclick="optionClick(event)" aria-action-id="remove">
                                    <em class="bc-icon bc-sm">remove</em><span>Eliminar</span></a>
                                  </li>
                              </ul>
                          </div>
                      </div>
                  </td>
              </tr>
              <tr>
                  <td>Cuenta 5</td>
                  <td>25/12/2020</td>
                  <td class="bc-table-number-cell">$ 10.000.00,00 canje</td>
                  <td class="bc-table-number-cell">0 total</td>
                  <td class="bc-table-number-cell bc-total-cell">$ 7.000.000,00 dis</td>
                  <td class="bc-table-number-cell bc-total-cell">$ 20.000.000,00 dis2</td>
                  <td class="bc-table-action-cell">
                      <div class="bc-dropdown" id="myTableDropdown5"> <em class="bc-dropdown-toggle bc-icon bc-sm" aria-controls="myTableDropdownToggle5">secondary-menu</em>
                          <div class="bc-dropdown-content" id="myTableDropdownToggle5">
                              <ul>
                                  <li class="bc-dropdown-item"><a class="bc-link" id="lockOption" onclick="optionClick(event)" aria-action-id="lock">
                                    <em class="bc-icon bc-sm">lock</em><span>Bloquear</span></a>
                                  </li>
                                  <li class="bc-dropdown-item"><a class="bc-link" id="removeOption" onclick="optionClick(event)" aria-action-id="remove">
                                    <em class="bc-icon bc-sm">remove</em><span>Eliminar</span></a>
                                  </li>
                              </ul>
                          </div>
                      </div>
                  </td>
              </tr>
          </tbody>
      </table>
  </div>
  <div class="bc-table-footer">
      <div class="bc-table-footer-container">
          <div class="bc-table-footer-total-container">
              <div class="bc-table-footer-total-column">
                  <p class="bc-table-footer-total-column-title">Total saldo disponible</p>
                  <h6 class="bc-table-footer-total-column-value">COP $10.000.00,00</h6>
              </div>
              <div class="bc-table-footer-total-column">
                  <p class="bc-table-footer-total-column-title">Total saldo consolidado</p>
                  <h6 class="bc-table-footer-total-column-value">COP $10.000.00,00</h6>
              </div>
              <div class="bc-table-footer-total-column">
                  <p class="bc-table-footer-total-column-title">Total saldo consolidado</p>
                  <h6 class="bc-table-footer-total-column-value">COP $10.000.00,00</h6>
              </div>
              <div class="bc-table-footer-total-column">
                  <p class="bc-table-footer-total-column-title">Total saldo consolidado</p>
                  <h6 class="bc-table-footer-total-column-value">COP $10.000.00,00</h6>
              </div>
          </div>
          <div class="bc-table-footer-subcontainer">
              <div class="bc-table-actions-container">
                  <div class="bc-table-paginator-container">
                      <nav class="bc-paginator" id="full_2" role="navigation" aria-label="paginador" totalregisters="300" perpage="5" multiple="5" typepaginator="full"></nav>
                  </div>
              </div>
          </div>
      </div>
  </div>
  `;
BcTableConstanstsSpec.tableHTMLInline = `
  <div class="bc-table-container" id="myTable">
  <div class="bc-table-header-top">
    <h6 class="bc-table-header-top-title">Título</h6>
    <div class="bc-table-header-top-right-container">
      <div class="bc-table-actions-container">
        <div class="bc-table-paginator-container">
          <nav class="bc-paginator" id="full" role="navigation" aria-label="paginador" totalregisters="300"
            perpage="5" multiple="5" typepaginator="full"></nav>
        </div>
      </div>
    </div>
  </div>
  <div class="bc-table-content">
    <table class="bc-table bc-table-sort bc-table-selection bc-table-action-cell-inline ">
      <thead>
        <tr>
          <th>nombre de cuenta</th>
          <th table-column-width="200px">Ultimo movimiento</th>
          <th class="bc-table-number-column">Saldo en canje</th>
          <th class="bc-table-number-column">Saldo total</th>
          <th class="bc-table-number-column">Saldo disponible</th>
          <th class="bc-table-number-column">Saldo disponible 2</th>
          <th class="bc-table-number-column">Columna extra 1</th>
          <th class="bc-table-number-column">Columna extra 2</th>
          <th class="bc-table-number-column">Columna extra 3</th>
          <th class="bc-table-number-column">Columna extra 4</th>
          <th class="bc-table-number-column">Columna extra 5</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td class="bc-table-text-cell">Cuenta 1 va a ser el ejemplo de tamaño maximo para esta ocación pongamos algo
            más grande</td>
          <td>21/12/2020</td>
          <td class="bc-table-number-cell">$ 10.000.00,00 canje</td>
          <td class="bc-table-number-cell">0 total</td>
          <td class="bc-table-number-cell bc-total-cell">$ 7.000.000,00 dis</td>
          <td class="bc-table-number-cell bc-total-cell">$ 20.000.000,00 dis2</td>
          <td class="bc-table-number-cell">Valor extra 1 row 1</td>
          <td class="bc-table-number-cell">Valor extra 1 row 2</td>
          <td class="bc-table-number-cell">Valor extra 1 row 3</td>
          <td class="bc-table-number-cell">Valor extra 1 row 4</td>
          <td class="bc-table-content-cell">
            <div class="bc-progress-container" data-background="false">
              <progress value="80" max="100">
              </progress>
            </div>
          </td>

        </tr>
        <tr>
          <td class="bc-table-text-cell">Cuenta 1 va a ser el ejemplo de tamaño maximo para esta ocación pongamos algo
            más grande</td>
          <td>21/12/2020</td>
          <td class="bc-table-number-cell">$ 10.000.00,00 canje</td>
          <td class="bc-table-number-cell">0 total</td>
          <td class="bc-table-number-cell bc-total-cell">$ 7.000.000,00 dis</td>
          <td class="bc-table-number-cell bc-total-cell">$ 20.000.000,00 dis2</td>
          <td class="bc-table-number-cell">Valor extra 1 row 1</td>
          <td class="bc-table-number-cell">Valor extra 1 row 2</td>
          <td class="bc-table-number-cell">Valor extra 1 row 3</td>
          <td class="bc-table-number-cell">Valor extra 1 row 4</td>
          <td class="bc-table-content-cell">
            <div class="bc-progress-container" data-background="false">
              <progress value="80" max="100">
              </progress>
            </div>
          </td>

        </tr>
        <tr>
          <td class="bc-table-text-cell">Cuenta 1 va a ser el ejemplo de tamaño maximo para esta ocación pongamos algo
            más grande</td>
          <td>21/12/2020</td>
          <td class="bc-table-number-cell">$ 10.000.00,00 canje</td>
          <td class="bc-table-number-cell">0 total</td>
          <td class="bc-table-number-cell bc-total-cell">$ 7.000.000,00 dis</td>
          <td class="bc-table-number-cell bc-total-cell">$ 20.000.000,00 dis2</td>
          <td class="bc-table-number-cell">Valor extra 1 row 1</td>
          <td class="bc-table-number-cell">Valor extra 1 row 2</td>
          <td class="bc-table-number-cell">Valor extra 1 row 3</td>
          <td class="bc-table-number-cell">Valor extra 1 row 4</td>
          <td class="bc-table-content-cell">
            <div class="bc-progress-container" data-background="false">
              <progress value="80" max="100">
              </progress>
            </div>
          </td>

        </tr>
        <tr>
          <td class="bc-table-text-cell">Cuenta 1 va a ser el ejemplo de tamaño maximo para esta ocación pongamos algo
            más grande</td>
          <td>21/12/2020</td>
          <td class="bc-table-number-cell">$ 10.000.00,00 canje</td>
          <td class="bc-table-number-cell">0 total</td>
          <td class="bc-table-number-cell bc-total-cell">$ 7.000.000,00 dis</td>
          <td class="bc-table-number-cell bc-total-cell">$ 20.000.000,00 dis2</td>
          <td class="bc-table-number-cell">Valor extra 1 row 1</td>
          <td class="bc-table-number-cell">Valor extra 1 row 2</td>
          <td class="bc-table-number-cell">Valor extra 1 row 3</td>
          <td class="bc-table-number-cell">Valor extra 1 row 4</td>
          <td class="bc-table-content-cell">
            <div class="bc-progress-container" data-background="false">
              <progress value="80" max="100">
              </progress>
            </div>
          </td>

        </tr>
      </tbody>
    </table>
  </div>
  <div class="bc-table-footer">
    <div class="bc-table-footer-container">
      <div class="bc-table-footer-total-container">
        <div class="bc-table-footer-total-column">
          <p class="bc-table-footer-total-column-title">Total saldo disponible</p>
          <h6 class="bc-table-footer-total-column-value">COP $10.000.00,00</h6>
        </div>
        <div class="bc-table-footer-total-column">
          <p class="bc-table-footer-total-column-title">Total saldo consolidado</p>
          <h6 class="bc-table-footer-total-column-value">COP $10.000.00,00</h6>
        </div>
        <div class="bc-table-footer-total-column">
          <p class="bc-table-footer-total-column-title">Total saldo consolidado</p>
          <h6 class="bc-table-footer-total-column-value">COP $10.000.00,00</h6>
        </div>
        <div class="bc-table-footer-total-column">
          <p class="bc-table-footer-total-column-title">Total saldo consolidado</p>
          <h6 class="bc-table-footer-total-column-value">COP $10.000.00,00</h6>
        </div>
      </div>
      <div class="bc-table-footer-subcontainer">
        <div class="bc-table-actions-container">
          <div class="bc-table-paginator-container">
            <nav class="bc-paginator" id="full_2" role="navigation" aria-label="paginador" totalregisters="300"
              perpage="5" multiple="5" typepaginator="full"></nav>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
  `;
BcTableConstanstsSpec.tableHTMLEmpyAccordion = `
  <div class="bc-table-container" id="myTable">
  <div class="bc-table-header-top">
    <h6 class="bc-table-header-top-title">Título</h6>
    <div class="bc-table-header-top-right-container">
      <div class="bc-table-actions-container">
        <div class="bc-table-paginator-container">
          <nav class="bc-paginator" id="full" role="navigation" aria-label="paginador" totalregisters="300"
            perpage="5" multiple="5" typepaginator="full"></nav>
        </div>
      </div>
    </div>
  </div>
  <div class="bc-table-content">
    <table class="bc-table bc-table-sort bc-table-selection bc-table-action-cell-dropdown bc-table-empy-accordion">
      <thead>
        <tr>
          <th>nombre de cuenta</th>
          <th table-column-width="200px">Ultimo movimiento</th>
          <th class="bc-table-number-column">Saldo en canje</th>
          <th class="bc-table-number-column">Saldo total</th>
          <th class="bc-table-number-column">Saldo disponible</th>
          <th class="bc-table-number-column">Saldo disponible 2</th>
          <th class="bc-table-number-column">Columna extra 1</th>
          <th class="bc-table-number-column">Columna extra 2</th>
          <th class="bc-table-number-column">Columna extra 3</th>
          <th class="bc-table-number-column">Columna extra 4</th>
          <th class="bc-table-number-column">Columna extra 5</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td class="bc-table-text-cell">Cuenta 1 va a ser el ejemplo de tamaño maximo para esta ocación pongamos algo
            más grande</td>
          <td>21/12/2020</td>
          <td class="bc-table-number-cell">$ 10.000.00,00 canje</td>
          <td class="bc-table-number-cell">0 total</td>
          <td class="bc-table-number-cell bc-total-cell">$ 7.000.000,00 dis</td>
          <td class="bc-table-number-cell bc-total-cell">$ 20.000.000,00 dis2</td>
          <td class="bc-table-number-cell">Valor extra 1 row 1</td>
          <td class="bc-table-number-cell">Valor extra 1 row 2</td>
          <td class="bc-table-number-cell">Valor extra 1 row 3</td>
          <td class="bc-table-number-cell">Valor extra 1 row 4</td>
          <td class="bc-table-content-cell">
            <div class="bc-progress-container" data-background="false">
              <progress value="80" max="100">
              </progress>
            </div>
          </td>

        </tr>
        <tr class="bc-table-extra-info-row">
          <td >
            <div class="bc-table-extra-info-row-content">
              <div>
                <label>Holi para</label>
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <td class="bc-table-text-cell">Cuenta 1 va a ser el ejemplo de tamaño maximo para esta ocación pongamos algo
            más grande</td>
          <td>21/12/2020</td>
          <td class="bc-table-number-cell">$ 10.000.00,00 canje</td>
          <td class="bc-table-number-cell">0 total</td>
          <td class="bc-table-number-cell bc-total-cell">$ 7.000.000,00 dis</td>
          <td class="bc-table-number-cell bc-total-cell">$ 20.000.000,00 dis2</td>
          <td class="bc-table-number-cell">Valor extra 1 row 1</td>
          <td class="bc-table-number-cell">Valor extra 1 row 2</td>
          <td class="bc-table-number-cell">Valor extra 1 row 3</td>
          <td class="bc-table-number-cell">Valor extra 1 row 4</td>
          <td class="bc-table-content-cell">
            <div class="bc-progress-container" data-background="false">
              <progress value="80" max="100">
              </progress>
            </div>
          </td>

        </tr>
        <tr class="bc-table-extra-info-row">
          <td >
            <div class="bc-table-extra-info-row-content">
              <div>
                <label>Holi mundo</label>
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <td class="bc-table-text-cell">Cuenta 1 va a ser el ejemplo de tamaño maximo para esta ocación pongamos algo
            más grande</td>
          <td>21/12/2020</td>
          <td class="bc-table-number-cell">$ 10.000.00,00 canje</td>
          <td class="bc-table-number-cell">0 total</td>
          <td class="bc-table-number-cell bc-total-cell">$ 7.000.000,00 dis</td>
          <td class="bc-table-number-cell bc-total-cell">$ 20.000.000,00 dis2</td>
          <td class="bc-table-number-cell">Valor extra 1 row 1</td>
          <td class="bc-table-number-cell">Valor extra 1 row 2</td>
          <td class="bc-table-number-cell">Valor extra 1 row 3</td>
          <td class="bc-table-number-cell">Valor extra 1 row 4</td>
          <td class="bc-table-content-cell">
            <div class="bc-progress-container" data-background="false">
              <progress value="80" max="100">
              </progress>
            </div>
          </td>

        </tr>
        <tr class="bc-table-extra-info-row">
          <td >
            <div class="bc-table-extra-info-row-content">
              <div>
                <label>Holi ejemplo</label>
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <td class="bc-table-text-cell">Cuenta 1 va a ser el ejemplo de tamaño maximo para esta ocación pongamos algo
            más grande</td>
          <td>21/12/2020</td>
          <td class="bc-table-number-cell">$ 10.000.00,00 canje</td>
          <td class="bc-table-number-cell">0 total</td>
          <td class="bc-table-number-cell bc-total-cell">$ 7.000.000,00 dis</td>
          <td class="bc-table-number-cell bc-total-cell">$ 20.000.000,00 dis2</td>
          <td class="bc-table-number-cell">Valor extra 1 row 1</td>
          <td class="bc-table-number-cell">Valor extra 1 row 2</td>
          <td class="bc-table-number-cell">Valor extra 1 row 3</td>
          <td class="bc-table-number-cell">Valor extra 1 row 4</td>
          <td class="bc-table-content-cell">
            <div class="bc-progress-container" data-background="false">
              <progress value="80" max="100">
              </progress>
            </div>
          </td>

        </tr>
        <tr class="bc-table-extra-info-row">
          <td >
            <div class="bc-table-extra-info-row-content">
              <div>
                <label>Holi mundo</label>
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <td class="bc-table-text-cell">Cuenta 1 va a ser el ejemplo de tamaño maximo para esta ocación pongamos algo
            más grande</td>
          <td>21/12/2020</td>
          <td class="bc-table-number-cell">$ 10.000.00,00 canje</td>
          <td class="bc-table-number-cell">0 total</td>
          <td class="bc-table-number-cell bc-total-cell">$ 7.000.000,00 dis</td>
          <td class="bc-table-number-cell bc-total-cell">$ 20.000.000,00 dis2</td>
          <td class="bc-table-number-cell">Valor extra 1 row 1</td>
          <td class="bc-table-number-cell">Valor extra 1 row 2</td>
          <td class="bc-table-number-cell">Valor extra 1 row 3</td>
          <td class="bc-table-number-cell">Valor extra 1 row 4</td>
          <td class="bc-table-content-cell">
            <div class="bc-progress-container" data-background="false">
              <progress value="80" max="100">
              </progress>
            </div>
          </td>

        </tr>
        <tr class="bc-table-extra-info-row">
          <td >
            <div class="bc-table-extra-info-row-content">
              <div>
                <label>Holi esto</label>
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <td class="bc-table-text-cell">Cuenta 1 va a ser el ejemplo de tamaño maximo para esta ocación pongamos algo
            más grande</td>
          <td>21/12/2020</td>
          <td class="bc-table-number-cell">$ 10.000.00,00 canje</td>
          <td class="bc-table-number-cell">0 total</td>
          <td class="bc-table-number-cell bc-total-cell">$ 7.000.000,00 dis</td>
          <td class="bc-table-number-cell bc-total-cell">$ 20.000.000,00 dis2</td>
          <td class="bc-table-number-cell">Valor extra 1 row 1</td>
          <td class="bc-table-number-cell">Valor extra 1 row 2</td>
          <td class="bc-table-number-cell">Valor extra 1 row 3</td>
          <td class="bc-table-number-cell">Valor extra 1 row 4</td>
          <td class="bc-table-content-cell">
            <div class="bc-progress-container" data-background="false">
              <progress value="80" max="100">
              </progress>
            </div>
          </td>

        </tr>
        <tr class="bc-table-extra-info-row">
          <td >
            <div class="bc-table-extra-info-row-content">
              <div>
                <label>Holi es</label>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="bc-table-footer">
    <div class="bc-table-footer-container">
      <div class="bc-table-footer-total-container">
        <div class="bc-table-footer-total-column">
          <p class="bc-table-footer-total-column-title">Total saldo disponible</p>
          <h6 class="bc-table-footer-total-column-value">COP $10.000.00,00</h6>
        </div>
        <div class="bc-table-footer-total-column">
          <p class="bc-table-footer-total-column-title">Total saldo consolidado</p>
          <h6 class="bc-table-footer-total-column-value">COP $10.000.00,00</h6>
        </div>
        <div class="bc-table-footer-total-column">
          <p class="bc-table-footer-total-column-title">Total saldo consolidado</p>
          <h6 class="bc-table-footer-total-column-value">COP $10.000.00,00</h6>
        </div>
        <div class="bc-table-footer-total-column">
          <p class="bc-table-footer-total-column-title">Total saldo consolidado</p>
          <h6 class="bc-table-footer-total-column-value">COP $10.000.00,00</h6>
        </div>
      </div>
      <div class="bc-table-footer-subcontainer">
        <div class="bc-table-actions-container">
          <div class="bc-table-paginator-container">
            <nav class="bc-paginator" id="full_2" role="navigation" aria-label="paginador" totalregisters="300"
              perpage="5" multiple="5" typepaginator="full"></nav>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
  `;

class BcTableConstansts2 {
}
BcTableConstansts2.TABLE_FIXED_COLUMN_CLASS = `${BcCommonConstants.PREFIX_LIB}-table-fixed-column`;
BcTableConstansts2.TABLE_FIXED_CONTAINER_CLASS = `${BcCommonConstants.PREFIX_LIB}-table-fixed-column-container`;
BcTableConstansts2.TABLE_FIXED_ACTION_CONTAINER_CLASS = `${BcCommonConstants.PREFIX_LIB}-table-fixed-action-column-container`;
BcTableConstansts2.TABLE_SCROLL_CLASS = `${BcCommonConstants.PREFIX_LIB}-table-scroll`;
BcTableConstansts2.TABLE_SORT_EVENT = `BcTableSortEvent`;
class BcTableConstanstsSpec2 {
}
BcTableConstanstsSpec2.tableHTMLScroll = `
  <div class="bc-table-header-top">
    <h6 class="bc-table-header-top-title">Título</h6>
    <div class="bc-table-header-top-right-container">
        <div class="bc-table-actions-container">
            <div class="bc-table-paginator-container">
                <nav class="bc-paginator" id="full" role="navigation" aria-label="paginador" totalregisters="300" perpage="5" multiple="5" typepaginator="full"></nav>
            </div>
        </div>
    </div>
  </div>
  <div class="bc-table-content">
    <table class="bc-table bc-table-sort bc-table-selection bc-table-scroll">
        <thead>
            <tr>
                <th class="bc-table-fixed-column-left">
                <label class="bc-container-checkbox">
                     <input type="checkbox" class="bc-table-master-checkbox'">
                        <span class="bc-checkbox"></span>
                </label>Name</th>
                <th class="bc-table-checkbox-cell"><label class="bc-container-checkbox"><input type="checkbox" /><span class="bc-checkbox"></span></label></th>
                <th>Nombre cuenta</th>
                <th>Ultimo movimiento</th>
                <th class="bc-table-number-column">Saldo en canje</th>
                <th class="bc-table-number-column">Saldo total</th>
                <th class="bc-table-number-column">Saldo disponible</th>
                <th class="bc-table-number-column">Saldo disponible 2</th>
                <th class="bc-table-number-column">Columna extra 1</th>
                <th class="bc-table-number-column">Columna extra 2</th>
                <th class="bc-table-number-column">Columna extra 3</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td class="bc-table-checkbox-cell"><label class="bc-container-checkbox"><input type="checkbox" /><span class="bc-checkbox"></span></label></td>
                <td>Cuenta 1</td>
                <td>21/12/2020</td>
                <td class="bc-table-number-cell">$ 10.000.00,00 canje</td>
                <td class="bc-table-number-cell">0 total</td>
                <td class="bc-table-number-cell bc-total-cell">$ 7.000.000,00 dis</td>
                <td class="bc-table-number-cell bc-total-cell">$ 20.000.000,00 dis2</td>
                <td class="bc-table-number-cell">Valor extra 1 row 1</td>
                <td class="bc-table-number-cell">Valor extra 2 row 1</td>
                <td class="bc-table-number-cell"> <label class="bc-tag bc-tag-success">TAG 1</label></td>
            </tr>
            <tr>
                <td class="bc-table-checkbox-cell"><label class="bc-container-checkbox"><input type="checkbox" /><span class="bc-checkbox"></span></label></td>
                <td>Cuenta 2</td>
                <td>22/12/2020</td>
                <td class="bc-table-number-cell">$ 10.000.00,00 canje</td>
                <td class="bc-table-number-cell">0 total</td>
                <td class="bc-table-number-cell bc-total-cell">$ 7.000.000,00 dis</td>
                <td class="bc-table-number-cell bc-total-cell">$ 20.000.000,00 dis2</td>
                <td class="bc-table-number-cell">Valor extra 1 row 2</td>
                <td class="bc-table-number-cell">Valor extra 2 row 2</td>
                <td class="bc-table-number-cell"> <label class="bc-tag bc-tag-success">TAG 2</label></td>
            </tr>
            <tr>
                <td class="bc-table-checkbox-cell"><label class="bc-container-checkbox"><input type="checkbox" /><span class="bc-checkbox"></span></label></td>
                <td>Cuenta 3</td>
                <td>23/12/2020</td>
                <td class="bc-table-number-cell">$ 10.000.00,00 canje</td>
                <td class="bc-table-number-cell">0 total</td>
                <td class="bc-table-number-cell bc-total-cell">$ 7.000.000,00 dis</td>
                <td class="bc-table-number-cell bc-total-cell">$ 20.000.000,00 dis2</td>
                <td class="bc-table-number-cell">Valor extra 1 row 3</td>
                <td class="bc-table-number-cell">Valor extra 2 row 3</td>
                <td class="bc-table-number-cell"> <label class="bc-tag bc-tag-success">TAG 3</label></td>
            </tr>
            <tr>
                <td class="bc-table-checkbox-cell"><label class="bc-container-checkbox"><input type="checkbox" /><span class="bc-checkbox"></span></label></td>
                <td>Cuenta 4</td>
                <td>24/12/2020</td>
                <td class="bc-table-number-cell">$ 10.000.00,00 canje</td>
                <td class="bc-table-number-cell">0 total</td>
                <td class="bc-table-number-cell bc-total-cell">$ 7.000.000,00 dis</td>
                <td class="bc-table-number-cell bc-total-cell">$ 20.000.000,00 dis2</td>
                <td class="bc-table-number-cell">Valor extra 1 row 4</td>
                <td class="bc-table-number-cell">Valor extra 2 row 4</td>
                <td class="bc-table-number-cell"> <label class="bc-tag bc-tag-success">TAG 4</label></td>
            </tr>
            <tr>
                <td class="bc-table-checkbox-cell"><label class="bc-container-checkbox"><input type="checkbox" /><span class="bc-checkbox"></span></label></td>
                <td>Cuenta 5</td>
                <td>25/12/2020</td>
                <td class="bc-table-number-cell">$ 10.000.00,00 canje</td>
                <td class="bc-table-number-cell">0 total</td>
                <td class="bc-table-number-cell bc-total-cell">$ 7.000.000,00 dis</td>
                <td class="bc-table-number-cell bc-total-cell">$ 20.000.000,00 dis2</td>
                <td class="bc-table-number-cell">Valor extra 1 row 5</td>
                <td class="bc-table-number-cell">Valor extra 2 row 5</td>
                <td class="bc-table-number-cell"> <label class="bc-tag bc-tag-success">TAG 5</label></td>
            </tr>
        </tbody>
    </table>
  </div>
  <div class="bc-table-footer">
    <div class="bc-table-footer-container">
        <div class="bc-table-footer-total-container">
            <div class="bc-table-footer-total-column">
                <p class="bc-table-footer-total-column-title">Total saldo disponible</p>
                <h6 class="bc-table-footer-total-column-value">COP $10.000.00,00</h6>
            </div>
            <div class="bc-table-footer-total-column">
                <p class="bc-table-footer-total-column-title">Total saldo consolidado</p>
                <h6 class="bc-table-footer-total-column-value">COP $10.000.00,00</h6>
            </div>
            <div class="bc-table-footer-total-column">
                <p class="bc-table-footer-total-column-title">Total saldo consolidado</p>
                <h6 class="bc-table-footer-total-column-value">COP $10.000.00,00</h6>
            </div>
            <div class="bc-table-footer-total-column">
                <p class="bc-table-footer-total-column-title">Total saldo consolidado</p>
                <h6 class="bc-table-footer-total-column-value">COP $10.000.00,00</h6>
            </div>
        </div>
        <div class="bc-table-footer-subcontainer">
            <div class="bc-table-actions-container">
                <div class="bc-table-paginator-container">
                    <nav class="bc-paginator" id="full_2" role="navigation" aria-label="paginador" totalregisters="300" perpage="5" multiple="5" typepaginator="full"></nav>
                </div>
            </div>
        </div>
    </div>
  </div>
	`;
BcTableConstanstsSpec2.tableHTMLScrollNoDropdown = `
  <div class="bc-table-header-top">
      <h6 class="bc-table-header-top-title">Título</h6>
      <div class="bc-table-header-top-right-container">
          <div class="bc-table-actions-container">
              <div class="bc-table-paginator-container">
                  <nav class="bc-paginator" id="full" role="navigation" aria-label="paginador" totalregisters="300" perpage="5" multiple="5" typepaginator="full"></nav>
              </div>
          </div>
      </div>
  </div>
  <div class="bc-table-content">
      <table class="bc-table bc-table-sort bc-table-selection bc-table-scroll">
          <thead>
              <tr>
                  <th class="bc-table-checkbox-cell"><label class="bc-container-checkbox"><input type="checkbox" /><span class="bc-checkbox"></span></label></th>
                  <th>Nombre cuenta</th>
                  <th>Ultimo movimiento</th>
                  <th class="bc-table-number-column">Saldo en canje</th>
                  <th class="bc-table-number-column">Saldo total</th>
                  <th class="bc-table-number-column">Saldo disponible</th>
                  <th class="bc-table-number-column">Saldo disponible 2</th>
                  <th class="bc-table-action-column"></th>
              </tr>
          </thead>
          <tbody>
              <tr>
                  <td class="bc-table-checkbox-cell"><label class="bc-container-checkbox"><input type="checkbox" /><span class="bc-checkbox"></span></label></td>
                  <td>Cuenta 1</td>
                  <td>21/12/2020</td>
                  <td class="bc-table-number-cell">$ 10.000.00,00 canje</td>
                  <td class="bc-table-number-cell">0 total</td>
                  <td class="bc-table-number-cell bc-total-cell">$ 7.000.000,00 dis</td>
                  <td class="bc-table-number-cell bc-total-cell">$ 20.000.000,00 dis2</td>
                  <td class="bc-table-action-cell">
                      <div class="bc-dropdown" id="myTableDropdown1"> <em class="bc-dropdown-toggle bc-icon bc-sm" aria-controls="myTableDropdownToggle1">secondary-menu</em>
                          <div class="bc-dropdown-content" id="myTableDropdownToggle1">
                              <ul>
                                  <li class="bc-dropdown-item"><a class="bc-link" id="lockOption" onclick="optionClick(event)" aria-action-id="lock"><em class="bc-icon bc-sm">lock</em><span>Bloquear</span></a></li>
                                  <li class="bc-dropdown-item"><a class="bc-link" id="removeOption" onclick="optionClick(event)" aria-action-id="remove"><em class="bc-icon bc-sm">remove</em><span>Eliminar</span></a></li>
                              </ul>
                          </div>
                      </div>
                  </td>
              </tr>
              <tr>
                  <td class="bc-table-checkbox-cell"><label class="bc-container-checkbox"><input type="checkbox" /><span class="bc-checkbox"></span></label></td>
                  <td>Cuenta 2</td>
                  <td>22/12/2020</td>
                  <td class="bc-table-number-cell">$ 10.000.00,00 canje</td>
                  <td class="bc-table-number-cell">0 total</td>
                  <td class="bc-table-number-cell bc-total-cell">$ 7.000.000,00 dis</td>
                  <td class="bc-table-number-cell bc-total-cell">$ 20.000.000,00 dis2</td>
                  <td class="bc-table-action-cell">
                      <div class="bc-dropdown" id="myTableDropdown2"> <em class="bc-dropdown-toggle bc-icon bc-sm" aria-controls="myTableDropdownToggle2">secondary-menu</em>
                          <div class="bc-dropdown-content" id="myTableDropdownToggle2">
                              <ul>
                                  <li class="bc-dropdown-item"><a class="bc-link" id="lockOption" onclick="optionClick(event)" aria-action-id="lock">
                                    <em class="bc-icon bc-sm">lock</em><span>Bloquear</span></a>
                                  </li>
                                  <li class="bc-dropdown-item"><a class="bc-link" id="removeOption" onclick="optionClick(event)" aria-action-id="remove">
                                    <em class="bc-icon bc-sm">remove</em><span>Eliminar</span></a>
                                  </li>
                              </ul>
                          </div>
                      </div>
                  </td>
              </tr>
              <tr>
                  <td class="bc-table-checkbox-cell"><label class="bc-container-checkbox"><input type="checkbox" /><span class="bc-checkbox"></span></label></td>
                  <td>Cuenta 3</td>
                  <td>23/12/2020</td>
                  <td class="bc-table-number-cell">$ 10.000.00,00 canje</td>
                  <td class="bc-table-number-cell">0 total</td>
                  <td class="bc-table-number-cell bc-total-cell">$ 7.000.000,00 dis</td>
                  <td class="bc-table-number-cell bc-total-cell">$ 20.000.000,00 dis2</td>
                  <td class="bc-table-action-cell">
                      <div class="bc-dropdown" id="myTableDropdown3"> <em class="bc-dropdown-toggle bc-icon bc-sm" aria-controls="myTableDropdownToggle3">secondary-menu</em>
                          <div class="bc-dropdown-content" id="myTableDropdownToggle3">
                              <ul>
                                  <li class="bc-dropdown-item"><a class="bc-link" id="lockOption" onclick="optionClick(event)" aria-action-id="lock">
                                    <em class="bc-icon bc-sm">lock</em><span>Bloquear</span></a>
                                  </li>
                                  <li class="bc-dropdown-item"><a class="bc-link" id="removeOption" onclick="optionClick(event)" aria-action-id="remove">
                                    <em class="bc-icon bc-sm">remove</em><span>Eliminar</span></a>
                                  </li>
                              </ul>
                          </div>
                      </div>
                  </td>
              </tr>
              <tr>
                  <td class="bc-table-checkbox-cell"><label class="bc-container-checkbox"><input type="checkbox" /><span class="bc-checkbox"></span></label></td>
                  <td>Cuenta 4</td>
                  <td>24/12/2020</td>
                  <td class="bc-table-number-cell">$ 10.000.00,00 canje</td>
                  <td class="bc-table-number-cell">0 total</td>
                  <td class="bc-table-number-cell bc-total-cell">$ 7.000.000,00 dis</td>
                  <td class="bc-table-number-cell bc-total-cell">$ 20.000.000,00 dis2</td>
                  <td class="bc-table-action-cell">
                      <div class="bc-dropdown" id="myTableDropdown4"> <em class="bc-dropdown-toggle bc-icon bc-sm" aria-controls="myTableDropdownToggle4">secondary-menu</em>
                          <div class="bc-dropdown-content" id="myTableDropdownToggle4">
                              <ul>
                                  <li class="bc-dropdown-item"><a class="bc-link" id="lockOption" onclick="optionClick(event)" aria-action-id="lock">
                                    <em class="bc-icon bc-sm">lock</em><span>Bloquear</span></a>
                                  </li>
                                  <li class="bc-dropdown-item"><a class="bc-link" id="removeOption" onclick="optionClick(event)" aria-action-id="remove">
                                    <em class="bc-icon bc-sm">remove</em><span>Eliminar</span></a>
                                  </li>
                              </ul>
                          </div>
                      </div>
                  </td>
              </tr>
              <tr>
                  <td class="bc-table-checkbox-cell"><label class="bc-container-checkbox"><input type="checkbox" /><span class="bc-checkbox"></span></label></td>
                  <td>Cuenta 5</td>
                  <td>25/12/2020</td>
                  <td class="bc-table-number-cell">$ 10.000.00,00 canje</td>
                  <td class="bc-table-number-cell">0 total</td>
                  <td class="bc-table-number-cell bc-total-cell">$ 7.000.000,00 dis</td>
                  <td class="bc-table-number-cell bc-total-cell">$ 20.000.000,00 dis2</td>
                  <td class="bc-table-action-cell">
                      <div class="bc-dropdown" id="myTableDropdown5"> <em class="bc-dropdown-toggle bc-icon bc-sm" aria-controls="myTableDropdownToggle5">secondary-menu</em>
                          <div class="bc-dropdown-content" id="myTableDropdownToggle5">
                              <ul>
                                  <li class="bc-dropdown-item"><a class="bc-link" id="lockOption" onclick="optionClick(event)" aria-action-id="lock">
                                    <em class="bc-icon bc-sm">lock</em><span>Bloquear</span></a>
                                  </li>
                                  <li class="bc-dropdown-item"><a class="bc-link" id="removeOption" onclick="optionClick(event)" aria-action-id="remove">
                                    <em class="bc-icon bc-sm">remove</em><span>Eliminar</span></a>
                                  </li>
                              </ul>
                          </div>
                      </div>
                  </td>
              </tr>
          </tbody>
      </table>
  </div>
  <div class="bc-table-footer">
      <div class="bc-table-footer-container">
          <div class="bc-table-footer-total-container">
              <div class="bc-table-footer-total-column">
                  <p class="bc-table-footer-total-column-title">Total saldo disponible</p>
                  <h6 class="bc-table-footer-total-column-value">COP $10.000.00,00</h6>
              </div>
              <div class="bc-table-footer-total-column">
                  <p class="bc-table-footer-total-column-title">Total saldo consolidado</p>
                  <h6 class="bc-table-footer-total-column-value">COP $10.000.00,00</h6>
              </div>
              <div class="bc-table-footer-total-column">
                  <p class="bc-table-footer-total-column-title">Total saldo consolidado</p>
                  <h6 class="bc-table-footer-total-column-value">COP $10.000.00,00</h6>
              </div>
              <div class="bc-table-footer-total-column">
                  <p class="bc-table-footer-total-column-title">Total saldo consolidado</p>
                  <h6 class="bc-table-footer-total-column-value">COP $10.000.00,00</h6>
              </div>
          </div>
          <div class="bc-table-footer-subcontainer">
              <div class="bc-table-actions-container">
                  <div class="bc-table-paginator-container">
                      <nav class="bc-paginator" id="full_2" role="navigation" aria-label="paginador" totalregisters="300" perpage="5" multiple="5" typepaginator="full"></nav>
                  </div>
              </div>
          </div>
      </div>
  </div>
	`;

class BcTableBaseBehavior extends BcDefaultBehavior {
    constructor() {
        super();
        this.isSelectionTable = false;
        this.isSelectionTableRadio = false;
        this.isSortTable = false;
        this.isCellActionDropdownHtml = false;
        this.isCellActionDropdown = false;
        this.isCellActionInline = false;
        this.isRowAction = false;
        this.isNotHidePaginator = false;
        this.rowsIndexSelected = [];
        this.selectedRowsElement = [];
        this.dropdowns = [];
        this.columnsData = [];
        this.checkboxcells = [];
        this.hasSelectionItems = false;
        this.paginatorsTable = [];
        this.angularFunction = null;
        this.dropdownsOptions = [];
    }
    static setUpAll() {
        const tableElements = Array.from(document.querySelectorAll(`div[class~='${BcTableConstansts.TABLE_CONTAINER_CLASS}']`));
        const elements = [];
        for (const element of tableElements) {
            const behavior = new BcTableBaseBehavior();
            behavior.setElement(element);
            behavior.setUp();
            elements.push(behavior);
        }
        return elements;
    }
    _setUp() {
        this.getElements();
        this.setColumnId();
        this.getColumnsTitle();
        this.addTooltipToCells();
        this.setCustomWidthColumns();
        this.isSelectionTable = this.table.classList.contains(`${BcTableConstansts.TABLE_SELECTION_CLASS}`);
        this.isSelectionTableRadio = this.table.classList.contains(`${BcTableConstansts.TABLE_SELECTION_RADIO_CLASS}`);
        this.isSortTable = this.table.classList.contains(`${BcTableConstansts.TABLE_SORT_CLASS}`);
        this.isCellActionDropdownHtml = this.table.classList.contains(`${BcTableConstansts.TABLE_CELL_ACTION_DROPDOWN_CLASS_HTML}`);
        this.isCellActionDropdown = this.table.classList.contains(`${BcTableConstansts.TABLE_CELL_ACTION_DROPDOWN_CLASS}`);
        this.isCellActionInline = this.table.classList.contains(`${BcTableConstansts.TABLE_CELL_ACTION_INLINE_CLASS}`);
        this.isRowAction = this.table.classList.contains(`${BcTableConstansts.TABLE_ROW_ACTION_CLASS}`);
        this.isNotHidePaginator = this.table.classList.contains(`${BcTableConstansts.TABLE_NOT_HIDE_PAGINATORS_CLASS}`);
        this.validateTableVariants();
        this.setAccessibility();
        this.addFocusableTable();
        this.addAriaLabels();
    }
    /**
     * Se obtienen los elementos base
     *
     * @memberof BcTableBaseBehavior
     */
    getElements() {
        this.table = this.mySelf.querySelector(`[class~='${BcTableConstansts.TABLE_CLASS}']`);
        this.tbody = Array.from(this.table.getElementsByTagName(BcTableConstansts.TABLE_TBODY_CLASS))[0];
        this.rows = Array.from(this.table.querySelectorAll(`${BcTableConstansts.TABLE_ROW_CLASS}:not(.${BcTableConstansts.TABLE_EXTRA_ROW_CLASS})`));
        this.paginatorsTable = Array.from(this.mySelf.querySelectorAll(`div[class*="${BcTableConstansts.TABLE_PAGINATOR_CONTAINER}"]`));
        this.columns = Array.from(this.table.querySelectorAll(BcTableConstansts.TABLE_TH_CLASS));
        this.headerTop = this.mySelf.querySelector(`[class~='${BcTableConstansts.TABLE_HEADER_TOP_CLASS}']`);
        this.footer = this.mySelf.querySelector(`[class~='${BcTableConstansts.TABLE_FOOTER_CLASS}']`);
        this.headTable = Array.from(this.table.getElementsByTagName(BcTableConstansts.TABLE_HEAD_CLASS));
        this.tableId = this.mySelf.getAttribute('id');
        this.isSelectionTable = this.table.classList.contains(BcTableConstansts.TABLE_SELECTION_CLASS);
        this.cells = Array.from(this.table.getElementsByTagName(BcTableConstansts.TABLE_TD_CLASS));
    }
    /**
     * Se agregan los eventos los checkbox
     *
     * @memberof BcTableBaseBehavior
     */
    addCheckboxEvent() {
        const masterCheckbox = this.rows[0].querySelector(`input[type="${BcTableConstansts.TABLE_CHECKBOX_SELECTOR}"]`);
        masterCheckbox.classList.add(`${BcTableConstansts.TABLE_MASTER_CHECKBOX_CLASS}`);
        const checkboxEvent = (checkbox, index) => {
            checkbox.addEventListener(BcCommonConstants.EVENT_CHANGE, (event, _index = index) => {
                const rowSelected = checkbox.closest(BcTableConstansts.TABLE_ROW_CLASS);
                checkbox[BcCommonConstants.CHECKED] = event.target[BcCommonConstants.CHECKED];
                this.selectUnSelectRow(rowSelected, _index);
                this.changeHeaderTopType();
                if (this.selectedRowsElement.length === 0) {
                    this.removeElementsForSelection();
                }
                else {
                    this.insertElementsForSelection();
                    this.updateCounterSelectedRows();
                }
                masterCheckbox[BcCommonConstants.CHECKED] = this.validateAllSelection();
            });
        };
        if (masterCheckbox) {
            masterCheckbox.addEventListener(BcCommonConstants.EVENT_CHANGE, (event) => {
                this.rows = Array.from(this.table.querySelectorAll(`${BcTableConstansts.TABLE_ROW_CLASS}:not(.${BcTableConstansts.TABLE_EXTRA_ROW_CLASS})`));
                masterCheckbox[BcCommonConstants.CHECKED] || event.target[BcCommonConstants.CHECKED] ? this.selectAllRows() : this.clearSelection();
            });
        }
        if (this.headTable) {
            this.headTable[0].classList.add(BcTableConstansts.TABLE_THEAD_SELECTABLE);
        }
        this.setEventToCheckbox(checkboxEvent);
    }
    validateTableVariants() {
        if (this.isCellActionInline) {
            this.createCellActions(BcTableConstansts.TABLE_CELL_ACTION_INLINE_CLASS);
        }
        if (this.isRowAction) {
            this.addRowEvent(this.tableRowAction);
        }
        if (this.isCellActionDropdown) {
            this.createCellActions(BcTableConstansts.TABLE_ACTION_CELL_CLASS);
            this.initRowDropdowns();
            window.addEventListener(_DROPDOWN_OPENED_EVENT, (dropdownId) => {
                this.closeOtherDropdowns(dropdownId.detail);
            });
        }
        if (this.isCellActionDropdownHtml) {
            this.initRowDropdownsHtml();
            window.addEventListener(_DROPDOWN_OPENED_EVENT, (dropdownId) => {
                this.closeOtherDropdowns(dropdownId.detail);
            });
        }
        if (this.isSelectionTable) {
            this.createSelectableElement();
            this.addCheckboxEvent();
        }
        if (this.isSortTable) {
            this.sortColumn();
            this.addHoverIconClass();
        }
        if (window.innerWidth <= Number(BcTableConstansts.TABLE_MEDIUM_BREAK_POINT)) {
            this.resizeEventForPaginator();
        }
        window.addEventListener('resize', () => {
            this.resizeEventForPaginator();
        });
    }
    /**
     * agrega el evento a cada de checkbox
     *
     * @private
     * @param {(checkbox: Element, index: number) => void} checkboxEvent
     * @memberof BcTableBaseBehavior
     */
    setEventToCheckbox(checkboxEvent) {
        for (let i = 1; i < this.rows.length; i++) {
            const row = this.rows[i];
            const checkbox = row.querySelector(`input[type="${BcTableConstansts.TABLE_CHECKBOX_SELECTOR}"]`);
            if (checkbox) {
                checkboxEvent(checkbox, i);
            }
        }
    }
    /**
     * Se setean las acciones que van en en la cabecera
     *
     * @param {Array<BcTableActionButton>} actions Acciones seteadas por el usuario
     * @memberof BcTableBaseBehavior
     */
    setSelectionAction(actions) {
        this.tableActions = actions;
    }
    /**
     * Se setean las acciones que van a accionarse en cada row
     *
     * @param {Array<BcTableActionRow>} actions Acciones seteadas por el usuario
     * @memberof BcTableBaseBehavior
     */
    setRowAction(action) {
        this.tableRowAction = action;
    }
    /**
     * Se setean las acciones que van en el dropdown o en el inline
     *
     * @param {Array<BcTableOptionMenu>} actions Acciones seteadas por el usuario
     * @memberof BcTableBaseBehavior
     */
    setActionCell(actions) {
        this.tableActionCell = actions;
    }
    /**
     * Se crean las acciones en la cabecera de la tabla
     *
     * @private
     * @param {Element} rightContainer contenedor del paginador
     * @memberof BcTableBaseBehavior
     */
    createTableActions(rightContainer) {
        const divElement = document.createElement(BcCommonConstants.DIV_TAG);
        divElement.classList.add(BcTableConstansts.TABLE_HEADER_ACTIONS_CLASS);
        for (const action of this.tableActions) {
            if (action.variant == BcCommonConstants.TAG_TAG) {
                const actionButton = document.createElement(BcCommonConstants.DIV_TAG);
                actionButton.classList.add(BcCommonConstants.TAG_CLASS, BcTableConstansts.TABLE_SELECTION_ACTION_BUTTON_CLASS);
                actionButton.innerHTML = ` <i class="bc-icon bc-xs bc-mx-1">${action.icon}</i>
        <p class="bc-mx-1">${action.text}</p>`;
                this.addButtonEvent(actionButton, action);
                divElement.appendChild(actionButton);
            }
            else {
                let btnType = BcCommonConstants.BTN_PRIMARY_CLASS;
                if (action.variant == 'terciary') {
                    btnType = BcCommonConstants.BTN_TERCIARY_CLASS;
                }
                const actionButton = document.createElement(BcCommonConstants.BUTTON_TAG);
                actionButton.classList.add(btnType, BcCommonConstants.BUTTON_SMALL_CLASS, BcTableConstansts.TABLE_SELECTION_ACTION_BUTTON_CLASS);
                actionButton.innerHTML = `<em class="bc-icon bc-sm">${action.icon}</em> ${action.text}`;
                this.addButtonEvent(actionButton, action);
                divElement.appendChild(actionButton);
            }
        }
        this.headerTop.insertBefore(divElement, rightContainer);
    }
    /**
     * se agrega el evento que dispara la funcion del usuario al botón de la cabecera
     *
     * @private
     * @param {HTMLButtonElement} buttonElement Botón el evento
     * @param {BcTableActionButton} actionButton Acción
     * @memberof BcTableBaseBehavior
     */
    addButtonEvent(buttonElement, actionButton) {
        buttonElement.addEventListener(BcCommonConstants.EVENT_CLICK, () => {
            if (this.angularFunction !== null) {
                this.angularFunction({ rowSelectedIndex: this.rowsIndexSelected, actionId: actionButton.id });
            }
            if (actionButton.action) {
                actionButton.action({ rowSelectedIndex: this.rowsIndexSelected, actionId: actionButton.id });
            }
            this.clearSelection();
        });
    }
    /**
     * se agrega el evento que dispara la funcion de las acciones inline
     * y las acciones de los dropdowns de cada celda
     *
     * @private
     * @param {HTMLButtonElement} buttonElement Botón el evento
     * @param {BcTableActionButton} actionButton Acción
     * @memberof BcTableBaseBehavior
     */
    addCellEvent(buttonElement, actionButton, index) {
        buttonElement.addEventListener(BcCommonConstants.EVENT_CLICK, () => {
            if (actionButton.action) {
                actionButton.action({ rowIndex: index, actionId: actionButton.id });
            }
        });
    }
    /**
     * se agrega envento de row cuando el usuario desea activarlo ignorando los checkbox
     * los inputs y los iconos
     *
     * @private
     * @param {BcTableActionRow} actionRow Acción
     * @memberof BcTableBaseBehavior
     */
    addRowEvent(actionRow) {
        for (let index = 1; index < this.rows.length; index++) {
            this.rows[index].addEventListener(BcCommonConstants.EVENT_CLICK, function (event) {
                const currentEvnt = event.target;
                if (currentEvnt.tagName.toLowerCase() !== BcCommonConstants.INPUT_TAG
                    && !currentEvnt.classList.contains(BcCommonConstants.ICONS_CLASS)
                    && !currentEvnt.classList.contains(BcCommonConstants.CHECKBOX_CLASS)) {
                    if (actionRow.action) {
                        actionRow.action({ rowIndex: index, actionId: actionRow.id });
                    }
                }
            });
        }
    }
    /**
     * Selecciona o deselecciona una fila y la agrega a los array
     *
     * @private
     * @param {Element} row Fila
     * @param {number} index Indice de la fila
     * @memberof BcTableBaseBehavior
     */
    selectUnSelectRow(row, index) {
        this.toggleSelectedClassRow(row);
        if (!this.selectedRowsElement.includes(row)) {
            this.selectedRowsElement.push(row);
            this.rowsIndexSelected.push(index);
        }
        else {
            this.selectedRowsElement.splice(this.selectedRowsElement.indexOf(row), 1);
            this.rowsIndexSelected.splice(this.rowsIndexSelected.indexOf(index), 1);
        }
    }
    /**
     * Agrega el icono de ordenamiento que se muestra con el hover
     * a las columnas exeptuando a la del checkbox
     */
    addHoverIconClass() {
        for (const element of this.columns) {
            if (!element.querySelector(`*[class*="${BcTableConstansts.TABLE_SORT_ICON_CLASS}"]`)) {
                const iconElement = document.createElement(BcCommonConstants.EM_TAG);
                iconElement.classList.add(BcCommonConstants.ICONS_CLASS, BcCommonConstants.ICON_XS_CLASS, BcTableConstansts.TABLE_SORT_ICON_HOVER_CLASS, BcTableConstansts.TABLE_HIDDEN_CLASS);
                iconElement.innerHTML = 'exchange';
                if (!element.classList.contains(BcTableConstansts.TABLE_CHECBOX_CELL_CLASS)) {
                    element.appendChild(iconElement);
                }
            }
        }
    }
    /**
     * se agrega el tooltip a los elementos que tengan la clase para
     * mostrar los elementos para ver los preview
     * @private
     * @memberof BcTableBaseBehavior
     */
    addTooltipToCells() {
        for (const element of this.cells) {
            if (element.classList.contains(BcTableConstansts.TABLE_TEXT_CELL_CLASS)) {
                element.classList.add(BcCommonConstants.BC_TOOLTIP_CLASS);
                element.setAttribute(BcCommonConstants.BC_TOOLTIP_TEXT, element.innerHTML);
            }
        }
    }
    /**
     * alterna la clase de seleccion de la fila
     *
     * @private
     * @param {Element} row Fila
     * @memberof BcTableBaseBehavior
     */
    toggleSelectedClassRow(row) {
        const extra = row.nextElementSibling;
        if (!(row.classList.contains(BcTableConstansts.TABLE_SELECTED_CLASS) &&
            extra &&
            extra.classList.contains(BcTableConstansts.TABLE_EXTRA_ROW_ACTIVE_CLASS))) {
            row.classList.toggle(BcTableConstansts.TABLE_SELECTED_CLASS);
        }
    }
    /**
     * actualiza la clase del header de normal a modo selección y vice versa
     *
     * @private
     * @memberof BcTableBaseBehavior
     */
    changeHeaderTopType() {
        if (this.selectedRowsElement.length === 0) {
            this.headerTop.classList.remove(BcTableConstansts.TABLE_HEADER_TOP_SELECTION_CLASS);
            !this.isNotHidePaginator && this.showPaginatorWhenRowIsNoSelected();
        }
        else {
            this.headerTop.classList.add(BcTableConstansts.TABLE_HEADER_TOP_SELECTION_CLASS);
            !this.isNotHidePaginator && this.hidePaginatorWhenRowIsSelected();
        }
    }
    /**
     * crea e inserta los elementos para mostrar la filas seleccionadas en el header
     *
     * @private
     * @memberof BcTableBaseBehavior
     */
    insertElementsForSelection() {
        const rightContainer = this.headerTop.querySelector(`[class~='${BcTableConstansts.TABLE_RIGHT_CONTAINER_CLASS}']`);
        const actionContainer = rightContainer.querySelector(`[class~='${BcTableConstansts.TABLE_ACTION_CONTAINER_CLASS}']`);
        const actionButtonElement = this.headerTop.querySelector(`[class~='${BcTableConstansts.TABLE_ACTION_BUTTON_CLASS}']`);
        const counter = document.createElement(BcCommonConstants.SMALL);
        counter.classList.add(BcTableConstansts.TABLE_SELECTION_COUNTER_CLASS);
        counter.innerText = '0 elementos seleccionados';
        const unselectLink = document.createElement('a');
        unselectLink.classList.add(BcCommonConstants.BC_LINK_CLASS, BcTableConstansts.TABLE_SELECTION_REMOVE_CLASS);
        unselectLink.innerHTML = 'Borrar selección';
        unselectLink.addEventListener(BcCommonConstants.EVENT_CLICK, () => {
            this.clearSelection();
        });
        if (!actionButtonElement) {
            this.createTableActions(rightContainer);
            actionContainer.appendChild(counter);
            actionContainer.appendChild(unselectLink);
        }
    }
    /**
     * Elimina los elementos que muestran la filas seleccionadas en el header
     *
     * @private
     * @memberof BcTableBaseBehavior
     */
    removeElementsForSelection() {
        const actionContainer = this.headerTop.querySelector(`[class~='${BcTableConstansts.TABLE_HEADER_ACTIONS_CLASS}']`);
        const counter = this.headerTop.querySelector(`[class~='${BcTableConstansts.TABLE_SELECTION_COUNTER_CLASS}']`);
        const unselectLink = this.headerTop.querySelector(`[class~='${BcTableConstansts.TABLE_SELECTION_REMOVE_CLASS}']`);
        if (actionContainer) {
            actionContainer.remove();
        }
        if (counter) {
            counter.remove();
        }
        if (unselectLink) {
            unselectLink.remove();
        }
    }
    /**
     * Selecciona todas las filas, disparando el evento en las que no estan aun checkeadas
     *
     * @private
     * @memberof BcTableBaseBehavior
     */
    selectAllRows() {
        for (let i = 1; i < this.rows.length; i++) {
            const row = this.rows[i];
            const checkbox = row.querySelector(`input[type="${BcTableConstansts.TABLE_CHECKBOX_SELECTOR}"]`);
            if (checkbox && !checkbox.checked) {
                const event = new Event(BcCommonConstants.EVENT_CHANGE);
                checkbox.dispatchEvent(event);
                checkbox[BcCommonConstants.CHECKED] = true;
            }
        }
    }
    /**
     * Deselecciona todas las filas cambian el chekbox a false
     *
     * @private
     * @memberof BcTableBaseBehavior
     */
    clearSelection() {
        this.selectedRowsElement = [];
        this.rowsIndexSelected = [];
        this.removeElementsForSelection();
        this.changeHeaderTopType();
        for (const row of this.rows) {
            row.classList.remove(BcTableConstansts.TABLE_SELECTED_CLASS);
            const checkbox = row.querySelector(`input[type="${BcTableConstansts.TABLE_CHECKBOX_SELECTOR}"]`);
            if (checkbox) {
                checkbox[BcCommonConstants.CHECKED] = false;
            }
        }
    }
    /**
     * actualiza el contador de la filas seleccionadas que está en el header
     *
     * @private
     * @memberof BcTableBaseBehavior
     */
    updateCounterSelectedRows() {
        const counter = this.headerTop.querySelector(`[class~='${BcTableConstansts.TABLE_SELECTION_COUNTER_CLASS}']`);
        counter.innerHTML = `${this.selectedRowsElement.length} ${this.selectedRowsElement.length > 1 ? 'filas seleccionadas' : 'fila seleccionada'}`;
    }
    /**
     * valida si todas la filas estan seleccionadas o no
     *
     * @return {*}  {boolean}
     * @memberof BcTableBaseBehavior
     */
    validateAllSelection() {
        if (this.rows.length - 1 !== this.selectedRowsElement.length) {
            return false;
        }
        return true;
    }
    /**
     * inicializar dropdown en la tabla
     *
     * @param {Element} element
     * @param {boolean} [isStatic]
     * @return {*}  {BcDropdownBehavior}
     * @memberof BcTableBaseBehavior
     */
    initDropdown(element, isStatic) {
        const config = {
            isPopUp: true,
            static: isStatic ? isStatic : false,
        };
        const dropBehavior = new BcDropdownBehavior();
        dropBehavior.setElement(element);
        dropBehavior.setConfig(config);
        dropBehavior.setUp();
        return dropBehavior;
    }
    /**
     * se inicializa el dropdown por cada fila
     *
     * @private
     * @memberof BcTableBaseBehavior
     */
    initRowDropdowns() {
        for (let i = 1; i < this.rows.length; i++) {
            const row = this.rows[i];
            const actionCell = row.querySelector(`.${BcTableConstansts.TABLE_ACTION_CELL_CLASS}`);
            const dropdown = actionCell && actionCell.querySelector(`.${BcCommonConstants.BC_DROPDOWN_CLASS}`);
            if (dropdown !== null) {
                dropdown.setAttribute('id', BcTableConstansts.TABLE_DROPDOWN + i.toString());
                dropdown.querySelector(`.${BcTableConstansts.TABLE_DROPDOWN_CONTENT}`)?.setAttribute('id', BcTableConstansts.TABLE_DROPDOWN_TOGGLE + i.toString());
                dropdown.querySelector(`.${BcTableConstansts.TABLE_DROPDOWN_TOGGLE_CLASSS}`)?.setAttribute(BcCommonConstants.ARIA_CONTROL, BcTableConstansts.TABLE_DROPDOWN_TOGGLE + i.toString());
                const dropBehavior = this.initDropdown(dropdown);
                this.dropdowns.push(dropBehavior);
            }
        }
    }
    /**
     * se inicializa el dropdown por cada fila
     *
     * @private
     * @memberof BcTableBaseBehavior
     */
    initRowDropdownsHtml() {
        for (let i = 1; i < this.rows.length; i++) {
            const row = this.rows[i];
            const actionCell = row.querySelector(`.${BcTableConstansts.TABLE_ACTION_CELL_CLASS}`);
            const dropdown = actionCell && actionCell.querySelector(`.${BcCommonConstants.BC_DROPDOWN_CLASS}`);
            if (dropdown !== null) {
                const dropBehavior = this.initDropdown(dropdown);
                this.dropdowns.push(dropBehavior);
            }
        }
    }
    /**
     * cerrar dropdown cuando otro se abre
     *
     * @private
     * @param {string} noCloseId
     * @memberof BcTableBaseBehavior
     */
    closeOtherDropdowns(noCloseId) {
        for (const dropdown of this.dropdowns) {
            if (dropdown.idContent !== noCloseId && !dropdown.config.static) {
                dropdown.closeDropdown();
            }
        }
    }
    /**
     * se ordenan las columnas de ascendente/descendente
     *
     * @private
     * @memberof BcTableBaseBehavior
     */
    sortColumn() {
        const tbody = this.table.querySelector('tbody');
        this.columns.forEach((column) => {
            if (!column.classList.contains(BcTableConstansts.TABLE_CHECBOX_CELL_CLASS) &&
                !column.classList.contains(BcTableConstansts.TABLE_ACTION_COLUMN_CLASS)) {
                this.addColumnSortEvent(column, tbody);
            }
        });
    }
    /**
     * se agrega el evento click a los header de la columna para ordenar
     *
     * @private
     * @param {Element} column
     * @param {HTMLTableSectionElement} tbody
     * @memberof BcTableBaseBehavior
     */
    addColumnSortEvent(column, tbody) {
        column.addEventListener(BcCommonConstants.EVENT_CLICK, () => {
            this.columnSortEvent(column, tbody);
        });
        column.addEventListener(BcCommonConstants.EVENT_KEY_DOWN, (event) => {
            if (event.code == BcCommonConstants.KEY_EVENT_SPACE || event.key == BcCommonConstants.KEY_EVENT_ENTER) {
                this.columnSortEvent(column, tbody);
            }
        });
    }
    columnSortEvent(column, tbody) {
        this.addSortIcon(column);
        Array.from(tbody.querySelectorAll(`tr:not([class*="${BcTableConstansts.TABLE_EXTRA}"])`))
            .sort(this.comparer(Array.from(column.parentNode.children).indexOf(column), (this.asc = !this.asc)))
            .forEach((tr) => tbody.appendChild(tr));
        if (!this.table.classList.contains(BcTableConstansts2.TABLE_SCROLL_CLASS)) {
            window.dispatchEvent(new CustomEvent(BcTableConstansts2.TABLE_SORT_EVENT));
        }
    }
    /**
     * se agrega el icono de flecha dependiento del tipo de ordamiento (asc/desc)
     *
     * @private
     * @param {*} column
     * @memberof BcTableBaseBehavior
     */
    addSortIcon(column) {
        for (const colum of this.columns) {
            const icon = colum.querySelector(`.${BcTableConstansts.TABLE_SORT_ICON_CLASS}`);
            const iconHover = colum.querySelector(`.${BcTableConstansts.TABLE_SORT_ICON_HOVER_CLASS}`);
            if (icon) {
                icon.remove();
            }
            if (iconHover) {
                iconHover.remove();
            }
        }
        const iconElement = document.createElement(BcCommonConstants.EM_TAG);
        iconElement.classList.add(BcCommonConstants.ICONS_CLASS, BcCommonConstants.ICON_XS_CLASS, BcTableConstansts.TABLE_SORT_ICON_CLASS);
        iconElement.innerText = this.asc ? BcCommonConstants.BC_ARROW_DOWN_ICON : BcCommonConstants.BC_ARROW_UP_ICON;
        column.appendChild(iconElement);
        this.addHoverIconClass();
    }
    /**
     * se obtiene los valores la celda de la fila
     *
     * @private
     * @param {IRowContent} tr
     * @param {(string | number)} idx
     * @return {*}  {*}
     * @memberof BcTableBaseBehavior
     */
    getCellValue(tr, idx) {
        return tr.children[idx]?.['innerText'] || tr.children[idx].textContent;
    }
    /**
     * se compraran los valores de las celdas para ser ordenados
     *
     * @private
     * @param {number} idx
     * @param {boolean} asc
     * @return {*}  {*}
     * @memberof BcTableBaseBehavior
     */
    comparer(idx, asc) {
        return (a, b) => ((v1, v2) => (this.validateType(v1, v2) ? v1 - v2 : v1.toString().localeCompare(v2)))(this.getCellValue(asc ? a : b, idx), this.getCellValue(asc ? b : a, idx));
    }
    /**
     * se valida el tipo de dato del la celda
     *
     * @private
     * @param {*} v1
     * @param {*} v2
     * @return {*}
     * @memberof BcTableBaseBehavior
     */
    validateType(v1, v2) {
        return v1 !== '' && v2 !== '' && !isNaN(v1) && !isNaN(v2);
    }
    /**
     * se crea el contenedor para el dropdown o el inline de cada row
     * @param cellClass
     */
    createCellActions(cellClass) {
        this.removeActionTh();
        let element;
        for (let index = 0; index < this.rows.length; index++) {
            if (index == 0) {
                element = document.createElement(BcTableConstansts.TABLE_TH_CLASS);
                element.classList.add(BcTableConstansts.TABLE_ACTION_COLUMN_CLASS);
                this.rows[index].appendChild(element);
            }
            else {
                element = document.createElement(BcTableConstansts.TABLE_TD_CLASS);
                this.rows[index].appendChild(element);
                addFocusable(element, { tabindex: '0' });
                if (this.isCellActionInline && this.tableActionCell.length <= Number(BcTableConstansts.TABLE_NUMBER_3)) {
                    element.classList.add(cellClass);
                    this.createInlineCellActions(element, index);
                }
                else {
                    element.classList.add(BcTableConstansts.TABLE_ACTION_CELL_CLASS);
                    this.createDropdownCellActions(element, index);
                }
            }
        }
    }
    /**
     * creación de las acciones in line para cada row
     * @param element
     */
    createInlineCellActions(element, index) {
        for (let j = 0; j < this.tableActionCell.length; j++) {
            const btnElement = document.createElement(BcCommonConstants.BUTTON_TAG);
            addFocusable(btnElement, { tabindex: '0' });
            btnElement.classList.add(BcCommonConstants.BC_BUTTON_ICON_CLASS, BcCommonConstants.BC_TOOLTIP_CLASS);
            btnElement.setAttribute(BcCommonConstants.BC_TOOLTIP_TEXT, this.tableActionCell[j].text);
            btnElement.innerHTML += `<em class="bc-icon bc-sm">${this.tableActionCell[j].icon}</em>`;
            this.addCellEvent(btnElement, this.tableActionCell[j], index);
            element.appendChild(btnElement);
        }
    }
    /**
     * Creación del dropdown para cada row
     * @param element
     */
    createDropdownCellActions(element, index) {
        const dropdownElement = document.createElement(BcCommonConstants.DIV_TAG);
        dropdownElement.classList.add(BcCommonConstants.BC_DROPDOWN_CLASS);
        dropdownElement.innerHTML += `<em class="bc-dropdown-toggle bc-icon bc-sm">secondary-menu</em>
                   <div class="bc-dropdown-content">
                     <ul> </ul></div>`;
        element.appendChild(dropdownElement);
        for (let j = 0; j < this.tableActionCell.length; j++) {
            let dropdownOptionElement = document.createElement('li');
            addFocusable(dropdownOptionElement, { tabindex: '0' });
            dropdownOptionElement.classList.add('bc-dropdown-item');
            dropdownOptionElement.innerHTML += `<a class="bc-link" id="${this.tableActionCell[j].icon}Option"
                             aria-action-id="${this.tableActionCell[j].icon}">
                             <em class="bc-icon bc-sm">${this.tableActionCell[j].icon}</em>
                             <span>${this.tableActionCell[j].text}</span></a>`;
            dropdownElement.getElementsByTagName('ul')[0].appendChild(dropdownOptionElement);
            this.addCellEvent(dropdownOptionElement, this.tableActionCell[j], index);
        }
    }
    /**
     * Se reposiciona el paginador segun la resolución
     *
     * @memberof BcTableBaseBehavior
     */
    resizeEventForPaginator() {
        if (window.innerWidth <= Number(BcTableConstansts.TABLE_MEDIUM_BREAK_POINT)) {
            !this.inMobileSize && this.movePaginatorDown();
            this.inMobileSize = true;
        }
        else {
            this.removeMobileClassPag();
            this.inMobileSize = false;
        }
    }
    /**
     * Se mueve el paginador al contenedor de abajo
     * si el contenedor no existe, este se crea y luego se mueve el pagiandor
     *
     * @private
     * @memberof BcTableBaseBehavior
     */
    movePaginatorDown() {
        const paginatorContainers = Array.from(this.mySelf.querySelectorAll(`.${BcTableConstansts.TABLE_PAGINATOR_CONTAINER}`));
        const paginatorContainerBellow = paginatorContainers[paginatorContainers.length - Number(BcTableConstansts.TABLE_NUMBER_1)];
        const paginator = this.mySelf.querySelectorAll(`.${BcTableConstansts.TABLE_PAGINATOR}`);
        if (paginator.length === Number(BcTableConstansts.TABLE_NUMBER_1)) {
            paginator[BcTableConstansts.TABLE_NUMBER_0].classList.add(BcTableConstansts.TABLE_PAGINATOR_MOBILE);
            paginatorContainerBellow.appendChild(paginator[BcTableConstansts.TABLE_NUMBER_0]);
        }
        else if (paginator.length === Number(BcTableConstansts.TABLE_NUMBER_2)) {
            if (!paginator[BcTableConstansts.TABLE_NUMBER_0].classList.contains(BcTableConstansts.TABLE_PAGINATOR_MOBILE) &&
                !paginator[BcTableConstansts.TABLE_NUMBER_1].classList.contains(BcTableConstansts.TABLE_PAGINATOR_MOBILE)) {
                paginator[BcTableConstansts.TABLE_NUMBER_0].classList.add(BcTableConstansts.TABLE_PAGINATOR_MOBILE);
                paginatorContainerBellow.appendChild(paginator[BcTableConstansts.TABLE_NUMBER_0]);
            }
        }
    }
    /**
     * Se remueve la clase del paginador que tenia cuando estaba en mobile
     *
     * @private
     * @memberof BcTableBaseBehavior
     */
    removeMobileClassPag() {
        const paginatorMobile = this.mySelf.querySelector(`*[class*="${BcTableConstansts.TABLE_PAGINATOR_MOBILE}"]`);
        if (paginatorMobile !== null) {
            paginatorMobile.classList.remove(BcTableConstansts.TABLE_PAGINATOR_MOBILE);
            const paginatorContainer = this.headerTop.querySelector(`.${BcTableConstansts.TABLE_PAGINATOR_CONTAINER}`);
            paginatorContainer !== null && paginatorContainer.appendChild(paginatorMobile);
        }
        const paginators = this.mySelf.querySelectorAll(`nav[class*="${BcTableConstansts.TABLE_PAGINATOR}"]`);
        if (paginators.length <= Number(BcTableConstansts.TABLE_NUMBER_1)) {
            const subcontainer = this.mySelf.querySelector(`.${BcTableConstansts.TABLE_FOOTER_SUBCONTAINER}`);
            subcontainer !== null && subcontainer.remove();
        }
    }
    /**
     * Se asgina el id a cada columna en el thead
     *
     * @private
     * @memberof BcTableBaseBehavior
     */
    setColumnId() {
        for (let i = Number(BcTableConstansts.TABLE_NUMBER_0); i < this.columns.length; i++) {
            const column = this.columns[i];
            column.setAttribute('id', `${this.tableId}_column_${i}`);
        }
    }
    /**
     * Se obtienen los títulos de cada columna y su id
     *
     * @private
     * @memberof BcTableBaseBehavior
     */
    getColumnsTitle() {
        for (const column of this.columns) {
            let columnName = column['textContent'].split(/\n/)[0];
            columnName = columnName.replace(/exchange/g, '');
            if (columnName !== '' && columnName.length > 0) {
                this.columnsData.push({
                    id: column.getAttribute('id'),
                    name: columnName,
                });
            }
        }
    }
    /**
     * Se setea el custom width de las columnas para que sea personalizable
     * para cada usuario, las columnas que no tengan ese tamaño personaliazble
     * usaran el tamaño restante y se acomodarán
     * @private
     * @memberof BcTableBaseBehavior
     */
    setCustomWidthColumns() {
        for (let index = 0; index < this.columns.length; index++) {
            const customWidth = this.columns[index].getAttribute('table-column-width');
            if (customWidth) {
                this.columns[index].setAttribute('width', customWidth);
            }
        }
    }
    /**
     * Metodo para la creación de los checkbox cuando la tabla es seleccionable
     */
    createSelectableElement() {
        this.removeCheckboxes();
        if (!this.hasSelectionItems) {
            for (let index = 0; index < this.rows.length; index++) {
                let type = 'td';
                let ariamessage = 'Seleccionar fila, no seleccionado, casilla de verificación.';
                if (index === 0) {
                    type = 'th';
                    ariamessage = 'Seleccionar todas las filas, no seleccionado, casilla de verificación.';
                }
                const checkboxElement = document.createElement(type);
                checkboxElement.classList.add(BcTableConstansts.TABLE_CHECBOX_CELL_CLASS);
                checkboxElement.innerHTML += `<label class="bc-container-checkbox"><input type="checkbox"/><span class="bc-checkbox"></span></label>`;
                addFocusable(checkboxElement, { tabindex: '0' });
                checkboxElement.setAttribute(BcCommonConstants.ARIA_LABEL, ariamessage);
                this.rows[index].prepend(checkboxElement);
            }
        }
        this.hasSelectionItems = true;
    }
    removeCheckboxes() {
        this.checkboxcells = Array.from(this.table.querySelectorAll(`[class~=${BcTableConstansts.TABLE_CHECBOX_CELL_CLASS}]`));
        for (const checkboxElm of this.checkboxcells) {
            checkboxElm.remove();
        }
    }
    removeActionTh() {
        this.checkboxcells = Array.from(this.table.querySelectorAll(`[class~=${BcTableConstansts.TABLE_ACTION_COLUMN_CLASS}`));
        for (const checkboxElm of this.checkboxcells) {
            checkboxElm.remove();
        }
    }
    /**
    * Metodo que permite obtener el current table
    * @param {number} index
    * @memberof BcAccordionBehavior
    */
    getCurrentElement(index) {
        return this.rows[index];
    }
    /**
     * Accesibilidad de foco y soporte por teclado.
     * @memberof BcAccordionBehavior
     */
    setAccessibility() {
        this.rows.forEach((element, index) => {
            this.addScreenReader(element, index);
        });
    }
    /**
     * Verifica que tecla ha sido activada por el usuario en el componente
     * @param {number} index
     * @memberof BcAccordionBehavior
     */
    addScreenReader(element, index) {
        element.addEventListener(BcCommonConstants.EVENT_KEY_UP, (event) => {
            if (event.key === BcCommonConstants.KEY_EVENT_ARROW_DOWN) {
                this.focusNext(index);
            }
            else if (event.key === BcCommonConstants.KEY_EVENT_ARROW_UP) {
                this.focusBack(index);
            }
            else if (event.key === BcCommonConstants.KEY_EVENT_HOME) {
                this.focusHomeEnd(index, true);
            }
            else if (event.key === BcCommonConstants.KEY_EVENT_END || event.key === BcCommonConstants.KEY_EVENT_PAGE_DOWN) {
                this.focusHomeEnd(index);
            }
        });
    }
    /**
     * Metodo que permite enfocar el ultimo y el primer row de la tabla
     * @param {number} index
     * @memberof BcAccordionBehavior
     */
    focusHomeEnd(index, key = false) {
        if (this.getCurrentElement(index) !== null) {
            this.getCurrentElement(index).classList.remove(BcCommonConstants.OUTLINE_ELEMENT);
            if (key) {
                index = 0;
            }
            else {
                index = this.rows.length - 1;
            }
            this.getCurrentElement(index).classList.add(BcCommonConstants.OUTLINE_ELEMENT);
            this.getCurrentElement(index).focus();
        }
    }
    /**
     * Metodo que permite enfocar el siguiente row
     * @param {number} index
     * @memberof BcAccordionBehavior
     */
    focusNext(index) {
        if (this.getCurrentElement(index) !== null) {
            this.getCurrentElement(index).classList.remove(BcCommonConstants.OUTLINE_ELEMENT);
            if (index < this.rows.length - 1) {
                index++;
            }
            else {
                index = 0;
            }
            this.getCurrentElement(index).classList.add(BcCommonConstants.OUTLINE_ELEMENT);
            this.getCurrentElement(index).focus();
        }
    }
    /**
    * Metodo que permite enfocar el anterior row
    * @param {number} index
    * @memberof BcAccordionBehavior
    */
    focusBack(index) {
        if (this.getCurrentElement(index) !== null) {
            this.getCurrentElement(index).classList.remove(BcCommonConstants.OUTLINE_ELEMENT);
            if (index > 0) {
                index--;
            }
            else {
                index = this.rows.length - 1;
            }
            this.getCurrentElement(index).classList.add(BcCommonConstants.OUTLINE_ELEMENT);
            this.getCurrentElement(index).focus();
        }
    }
    addFocusableTable() {
        for (const column of this.columns) {
            if (!column.classList.contains(BcTableConstansts.TABLE_HIDDEN_CLASS)) {
                addFocusable(column, { tabindex: '0' });
            }
        }
        for (const row of this.rows) {
            if (!row.classList.contains(BcTableConstansts.TABLE_EXTRA_ROW_CLASS)) {
                addFocusable(row, { tabindex: '0' });
            }
        }
    }
    hidePaginatorWhenRowIsSelected() {
        for (const paginator of this.paginatorsTable) {
            paginator.classList.add(BcTableConstansts.TABLE_HIDDEN_CLASS);
        }
    }
    showPaginatorWhenRowIsNoSelected() {
        for (const paginator of this.paginatorsTable) {
            paginator.classList.remove(BcTableConstansts.TABLE_HIDDEN_CLASS);
        }
    }
    addAriaLabels() {
        const topTitle = this.headerTop.querySelector(`[class~='${BcTableConstansts.TABLE_HEADER_TITLE_CLASS}']`);
        this.mySelf.setAttribute(BcCommonConstants.ARIA_LABEL, topTitle?.innerHTML + ', tabla, ' + this.rows.length + ' filas, ' + this.columns.length + ' columnas');
        topTitle?.setAttribute(BcCommonConstants.ARIA_LABEL, topTitle.innerHTML);
    }
    /**
     * se obtienen los eventos de las opciones del dropdown por fila
     *
     * @memberof BcTableBaseBehavior
     */
    getListenersHmtl() {
        for (const row of Array.from(this.rows)) {
            const dropdown = row.querySelector(`*[class^="${BcCommonConstants.BC_DROPDOWN_CLASS}"]`);
            const optionsList = dropdown ? dropdown.querySelectorAll(BcCommonConstants.HREF_TAG) : null;
            const options = [];
            if (optionsList !== null) {
                for (const option of Array.from(optionsList)) {
                    const id = option.getAttribute(BcCommonConstants.ARIA_ACTION_ID);
                    const icon = option.querySelector(BcCommonConstants.EM_TAG).innerText;
                    const text = option.querySelector(BcCommonConstants.SPAN_TAG).innerText;
                    const action = option.onclick;
                    options.push({ id: id, icon: icon, text: text, action: action });
                }
                this.dropdownsOptions.push(options);
            }
        }
    }
    closeCurrentExtraInfoRow() {
        const extraRows = Array.from(this.table.querySelectorAll(`tr[class*="${BcTableConstansts.TABLE_EXTRA_ROW_ACTIVE_CLASS}"]`));
        for (const row of extraRows) {
            row.classList.replace(BcTableConstansts.TABLE_EXTRA_ROW_ACTIVE_CLASS, BcTableConstansts.TABLE_EXTRA_ROW_CLASS);
        }
    }
}

class BcTableAccordionBehavior extends BcTableBaseBehavior {
    constructor() {
        super();
        this.favoriteColumnsIndex = [];
        this.hasDropdowns = false;
        this.hasInlineOptions = false;
        this.customMobileLabel = '';
        this.hasEmpyAccordion = false;
        setTimeout(() => {
            this.validateHasEmpyAccordion();
            this.validateTableHasDropdown();
            this.setRowLimit();
            this.executeHideForMobile();
            this.windoResizeEvent();
            this.listenSortEvent();
            this.setActionColumnListener();
            this.addAriaAccordionTable();
        });
    }
    /**
     * Se define la cantidad de columnas a mostrar segun la resolución
     *
     * @private
     * @memberof BcTableAccordionBehavior
     */
    setRowLimit() {
        const width = window.innerWidth;
        if (width <= Number(BcTableConstansts.TABLE_SMALL_BREAK_POINT)) {
            this.limitColumnNumber = Number(BcTableConstansts.TABLE_NUMBER_0);
            this.favoriteColumnsIndex = this.getFavoriteColumns();
            this.addAriaAccordionTable();
        }
        else if (width > Number(BcTableConstansts.TABLE_SMALL_BREAK_POINT) && width < Number(BcTableConstansts.TABLE_LARGE_BREAK_POINT)) {
            this.limitColumnNumber = Number(BcTableConstansts.TABLE_NUMBER_4);
        }
        else if (width >= Number(BcTableConstansts.TABLE_LARGE_BREAK_POINT) &&
            width < Number(BcTableConstansts.TABLE_EXTRALARGE_BREAK_POINT)) {
            this.limitColumnNumber = Number(BcTableConstansts.TABLE_NUMBER_6);
        }
        else {
            this.limitColumnNumber = Number(BcTableConstansts.TABLE_NUMBER_8);
        }
        if (this.limitColumnNumber !== this.limitColumnNumberBackup) {
            this.limitColumnNumberBackup = this.limitColumnNumber;
            this.structureExtraColumns();
            this.addAriaAccordionTable();
        }
    }
    /**
     * Se crea toda la estructura de las filas extras (acordeones)
     *
     * @memberof BcTableAccordionBehavior
     */
    structureExtraColumns() {
        if (this.hasEmpyAccordion) {
            this.structureExtraColumnsEmpy();
        }
        else {
            this.removeExtraRows();
            const extraData = window.innerWidth <= Number(BcTableConstansts.TABLE_SMALL_BREAK_POINT)
                ? this.formatExtraDataForMobile()
                : this.formatExtraData();
            if (Object.keys(extraData[0]).length > 0) {
                for (let i = 1; i < this.rows.length; i++) {
                    const row = this.rows[i];
                    const extraRow = document.createElement('tr');
                    extraRow.classList.add(BcTableConstansts.TABLE_EXTRA_ROW_CLASS);
                    const tdElement = document.createElement('td');
                    const extraContent = `<div class="bc-table-extra-info-row-content"></div>`;
                    tdElement.innerHTML = extraContent;
                    this.buildListExtraData(tdElement, extraData[i - 1]);
                    extraRow.appendChild(tdElement);
                    this.table.querySelector('tbody').insertBefore(extraRow, row.nextElementSibling);
                }
                this.hiddeUnusedColumns();
                this.removeToogleColumn();
                this.addToggleColumn();
                this.setColspanForExtraRow();
                this.hasDropdowns && this.createOptionBtnByDropdownHtml();
            }
            else {
                this.showColumns();
            }
            this.showActionConlumn();
        }
    }
    /**
   * Se crea toda la estructura de las filas extras (acordeones)
   *
   * @memberof BcTableAccordionBehavior
   */
    structureExtraColumnsEmpy() {
        window.innerWidth <= Number(BcTableConstansts.TABLE_SMALL_BREAK_POINT)
            ? this.formatExtraDataForMobile()
            : this.formatExtraData();
        this.formatExtraDataForMobile();
        this.hiddeUnusedColumns();
        this.removeToogleColumn();
        this.addToggleColumn();
        this.setColspanForExtraRow();
    }
    /**
     * Se remueven las filas extras
     *
     * @memberof BcTableAccordionBehavior
     */
    removeExtraRows() {
        const extraRows = this.table.querySelectorAll(`tr[class*="bc-table-extra"]`);
        extraRows.forEach((row) => {
            row.remove();
        });
    }
    /**
     * Se formatea la data de las columnas que no se visualizan segun  el limitador
     * Esta info es la que se muestra en la fila extras (acordeon)
     *
     * @return {*}  {Array<any>}
     * @memberof BcTableAccordionBehavior
     */
    formatExtraData() {
        const extraArrayData = [];
        const rows = [...this.rows].splice(1, this.rows.length - 1);
        const starter = this.isSelectionTable ? 1 : 0;
        for (const row of rows) {
            const extraData = {};
            for (let i = this.limitColumnNumber + starter; i <= row.children.length; i++) {
                const cell = row.children[i];
                if (this.columnsData[i - starter] && cell) {
                    extraData[this.columnsData[i - starter].name] = cell.innerHTML;
                }
            }
            extraArrayData.push(extraData);
        }
        return extraArrayData;
    }
    /**
     * Se formatea la data de las columnas que no se visualizan segun  el limitador y las colmunas favoritas
     * Esta info es la que se muestra en la fila extras (acordeon) en mobile
     *
     * @return {*}  {Array<any>}
     * @memberof BcTableAccordionBehavior
     */
    formatExtraDataForMobile() {
        const extraArrayData = [];
        const rows = [...this.rows].splice(1, this.rows.length - Number(BcTableConstansts.TABLE_NUMBER_1));
        const starter = this.isSelectionTable ? Number(BcTableConstansts.TABLE_NUMBER_1) : Number(BcTableConstansts.TABLE_NUMBER_0);
        for (const row of rows) {
            const extraData = {};
            for (let i = starter; i < this.columns.length; i++) {
                const cell = row.children[i];
                if (this.columnsData[i - starter] && !this.favoriteColumnsIndex.includes(i) && cell !== undefined) {
                    extraData[this.columnsData[i - starter].name] = cell.innerHTML;
                }
            }
            extraArrayData.push(extraData);
        }
        setTimeout(() => {
            this.addFavoriteOrderIndex(this.rows);
        });
        return extraArrayData;
    }
    /**
     * Se crea la lista de la info en la fila extra
     *
     * @param {Element} el
     * @param {{}} dataObj
     * @memberof BcTableAccordionBehavior
     */
    buildListExtraData(el, dataObj) {
        const list = el.querySelector(BcCommonConstants.DIV_TAG);
        for (const data in dataObj) {
            const item = document.createElement(BcCommonConstants.DIV_TAG);
            item.className = "bc-table-extra-info-row-content-info bc-row";
            const html = `<div class="bc-col-6">${data}</div> <div class="bc-col-6">${dataObj[data]}</div>`;
            item.innerHTML = html;
            list.appendChild(item);
        }
    }
    /**
     * Se ocultan las colmunas que no se muestras teniendo en cuenta el limitador
     *
     * @memberof BcTableAccordionBehavior
     */
    hiddeUnusedColumns() {
        this.showColumns();
        const limit = this.isSelectionTable ? this.limitColumnNumber + 1 : this.limitColumnNumber;
        for (const row of this.rows) {
            for (let i = limit; i < row.children.length; i++) {
                const cell = row.children[i];
                cell.classList.add(BcTableConstansts.TABLE_HIDDEN_CLASS);
            }
            if (!this.selectedRowsElement.includes(row)) {
                row.classList.remove(BcTableConstansts.TABLE_SELECTED_CLASS);
            }
        }
    }
    /**
     * Se muestras las columnas, removiendo la clase bc-hidden
     *
     * @memberof BcTableAccordionBehavior
     */
    showColumns() {
        const start = this.isSelectionTable ? 1 : 0;
        for (const row of this.rows) {
            for (let i = start; i < this.limitColumnNumber + 1; i++) {
                const cell = row.children[i];
                if (cell) {
                    cell.classList.remove(BcTableConstansts.TABLE_HIDDEN_CLASS);
                }
            }
        }
        this.showActionConlumn();
    }
    /**
     * Remueve la columna donde se encuentra el icono para abrir/cerrar la acordeón por fila
     *
     * @memberof BcTableAccordionBehavior
     */
    removeToogleColumn() {
        for (const row of this.rows) {
            const toggle = row.querySelector(`.${BcTableConstansts.TABLE_ACTION_TOGGLE_CLASS}`);
            if (toggle) {
                toggle.remove();
            }
        }
    }
    /**
     * Agrega la columna donde se encuentra el icono para abrir/cerrar la acordeón por fila
     *
     * @memberof BcTableAccordionBehavior
     */
    addToggleColumn() {
        const firstCell = document.createElement('th');
        firstCell.classList.add(BcTableConstansts.TABLE_ACTION_COLUMN_CLASS, BcTableConstansts.TABLE_ACTION_TOGGLE_CLASS);
        firstCell.setAttribute('id', this.columns[this.columns.length - 1].getAttribute('id') + '_1');
        this.rows[0].appendChild(firstCell);
        for (let i = 1; i < this.rows.length; i++) {
            const row = this.rows[i];
            const extraCell = document.createElement('td');
            addFocusable(extraCell, { tabindex: '0' });
            extraCell.classList.add(BcTableConstansts.TABLE_ACTION_CELL_CLASS, BcTableConstansts.TABLE_ACTION_TOGGLE_CLASS);
            extraCell.innerHTML = `<em class="bc-icon bc-sm">arrow2-down</em>`;
            this.toggleExtraRowEvent(extraCell.querySelector('em'), row);
            row.appendChild(extraCell);
        }
    }
    /**
     * Evento que permite abrir/cerrar la fila extra
     *
     * @param {Element} button
     * @param {Element} row
     * @memberof BcTableAccordionBehavior
     */
    toggleExtraRowEvent(button, row) {
        button.addEventListener(BcCommonConstants.EVENT_CLICK, () => {
            this.activeToggle(button, row);
        });
    }
    activeToggle(button, row) {
        const extraRow = row.nextElementSibling;
        if (!extraRow.classList.contains(BcTableConstansts.TABLE_EXTRA_ROW_ACTIVE_CLASS)) {
            extraRow.classList.replace(BcTableConstansts.TABLE_EXTRA_ROW_CLASS, BcTableConstansts.TABLE_EXTRA_ROW_ACTIVE_CLASS);
            row.classList.add(BcTableConstansts.TABLE_SELECTED_CLASS);
            button['style'].transform = 'rotate(180deg)';
        }
        else {
            extraRow.classList.replace(BcTableConstansts.TABLE_EXTRA_ROW_ACTIVE_CLASS, BcTableConstansts.TABLE_EXTRA_ROW_CLASS);
            if (!this.selectedRowsElement.includes(row)) {
                row.classList.remove(BcTableConstansts.TABLE_SELECTED_CLASS);
            }
            button['style'].transform = 'rotate(0deg)';
        }
    }
    /**
     * Se setea el colspan para la fila extra
     *
     * @memberof BcTableAccordionBehavior
     */
    setColspanForExtraRow() {
        const extraRows = this.mySelf.querySelectorAll(`.${BcTableConstansts.TABLE_EXTRA_ROW_CLASS}`);
        const colspan = this.getColspanNumber();
        for (const row of Array.from(extraRows)) {
            row.firstElementChild.setAttribute('colspan', String(colspan));
        }
    }
    /**
     * Se obtiene el valor del colspan segun la cantidad de filas visibles
     *
     * @return {*}  {number}
     * @memberof BcTableAccordionBehavior
     */
    getColspanNumber() {
        const columns = this.getColums();
        let colspan = 0;
        for (const column of columns) {
            if (column.className.indexOf(BcTableConstansts.TABLE_HIDDEN_CLASS) === -1) {
                colspan++;
            }
        }
        return colspan;
    }
    /**
     * Se obtienen las columnas
     *
     * @return {*}  {Element[]}
     * @memberof BcTableAccordionBehavior
     */
    getColums() {
        const columns = this.mySelf.querySelectorAll(BcTableConstansts.TABLE_TH_CLASS);
        return Array.from(columns);
    }
    /**
     * Muestra la columna de acción en casi de tener acciones
     * Es se muestra según la resolución y el limitador de columnas
     *
     * @memberof BcTableAccordionBehavior
     */
    showActionConlumn() {
        for (const row of this.rows) {
            const lastCell = row.querySelector(`*[class*="-action"]`);
            if (lastCell &&
                ((this.columnsData.length <= this.limitColumnNumber &&
                    window.innerWidth >= Number(BcTableConstansts.TABLE_LARGE_BREAK_POINT)) ||
                    (this.columnsData.length <= this.limitColumnNumber &&
                        window.innerWidth < Number(BcTableConstansts.TABLE_MEDIUM_BREAK_POINT)))) {
                this.removeExtraRows();
                this.removeToogleColumn();
                lastCell.classList.remove(BcTableConstansts.TABLE_HIDDEN_CLASS);
            }
        }
    }
    /**
     * Evento de resize para recalcular
     *
     * @private
     * @memberof BcTableAccordionBehavior
     */
    windoResizeEvent() {
        window.addEventListener('resize', () => {
            this.setRowLimit();
            this.executeHideForMobile();
        });
    }
    /**
     * Obtiene las columnas favoritas
     *
     * @return {*}  {Array<number>}
     * @memberof BcTableAccordionBehavior
     */
    getFavoriteColumns() {
        let favoriteColumns = [];
        for (let i = 0; i < this.columns.length; i++) {
            const column = this.columns[i];
            if (column.classList.contains(BcTableConstansts.TABLE_FAVORITE_COLUMN_CLASS)) {
                favoriteColumns.push(i);
            }
        }
        if (favoriteColumns.length === 0) {
            favoriteColumns = this.setAutoFavorites();
        }
        return favoriteColumns;
    }
    /**
     * Setea valores por defecto para columnas favoritas
     * esto en caso de que el usuario no haya seteado alguna
     *
     * @return {*}  {number[]}
     * @memberof BcTableAccordionBehavior
     */
    setAutoFavorites() {
        let favorites = [Number(BcTableConstansts.TABLE_NUMBER_0), Number(BcTableConstansts.TABLE_NUMBER_1), Number(BcTableConstansts.TABLE_NUMBER_2)];
        if (this.isSelectionTable) {
            favorites = [Number(BcTableConstansts.TABLE_NUMBER_1), Number(BcTableConstansts.TABLE_NUMBER_2), Number(BcTableConstansts.TABLE_NUMBER_3)];
        }
        return favorites;
    }
    /**
     * Se esucha el evento de ordenar para rehacer las filas extras y su información
     *
     * @memberof BcTableAccordionBehavior
     */
    listenSortEvent() {
        window.addEventListener(BcTableConstansts2.TABLE_SORT_EVENT, () => {
            this.removeExtraRows();
            this.structureExtraColumns();
        });
    }
    /**
     * Se ocultan las columnas en mobile
     *
     * @memberof BcTableAccordionBehavior
     */
    executeHideForMobile() {
        if (window.innerWidth <= Number(BcTableConstansts.TABLE_SMALL_BREAK_POINT)) {
            this.hideColumnsInMobile();
            if (this.customMobileLabel != '') {
                this.createCustomCell();
            }
        }
    }
    /**
     * Se ocultan las columnas en mobile tiniendo en cuenta las columnas favoritas
     *
     * @memberof BcTableAccordionBehavior
     */
    hideColumnsInMobile() {
        this.favoriteColumnsIndex = this.getFavoriteColumns();
        this.validMaxFavoriteColumns();
        const columConditionNumber = Number(BcTableConstansts.TABLE_NUMBER_3);
        if (this.favoriteColumnsIndex.length > 0 && this.favoriteColumnsIndex.length <= columConditionNumber) {
            for (const row of this.rows) {
                for (let i = 0; i < row.children.length; i++) {
                    const cell = row.children[i];
                    this.addRemoveHideForMobile(cell, i);
                }
            }
        }
    }
    /**
     * Se valida la cantidad de columnas favoritas seteadas por el usuario
     * máximo se pueden 3
     *
     * @memberof BcTableAccordionBehavior
     */
    validMaxFavoriteColumns() {
        const columConditionNumber = Number(BcTableConstansts.TABLE_NUMBER_3);
        if (this.favoriteColumnsIndex.length > columConditionNumber) {
            this.favoriteColumnsIndex = this.favoriteColumnsIndex.splice(0, columConditionNumber);
        }
    }
    /**
     * Agrega las clases para poder mostrar las columnas favoritas en mobile
     *
     * @param {Element} cell
     * @param {number} i
     * @memberof BcTableAccordionBehavior
     */
    addRemoveHideForMobile(cell, i) {
        if (!this.favoriteColumnsIndex.includes(i)) {
            if (cell.className.indexOf('checkbox') === -1 && cell.className.indexOf('action') === -1) {
                cell.classList.add(BcTableConstansts.TABLE_HIDDEN_CLASS);
            }
        }
        else if (cell.classList.contains(BcTableConstansts.TABLE_HIDDEN_CLASS)) {
            cell.classList.remove(BcTableConstansts.TABLE_HIDDEN_CLASS);
            cell.classList.add(BcTableConstansts.TABLE_FAVORITE_CELL_CLASS);
        }
    }
    /**
     * Se agrega el orden a las filas favoritas para luego mostrarlas correctamente en mobile
     *
     * @param {Element[]} rows
     * @memberof BcTableAccordionBehavior
     */
    addFavoriteOrderIndex(rows) {
        for (const row of rows) {
            const favorites = row.querySelectorAll(`.${BcTableConstansts.TABLE_FAVORITE_CELL_CLASS}`);
            favorites.forEach((fav, index) => {
                const newClass = `bc-order-${index + Number(BcTableConstansts.TABLE_NUMBER_1)}`;
                if (!fav.classList.contains(newClass)) {
                    fav.classList.add(newClass);
                }
            });
        }
    }
    /**
     * Se valida si la tabla tiene dropdowns por filas
     *
     * @memberof BcTableAccordionBehavior
     */
    validateTableHasDropdown() {
        if (this.rows[1] && this.rows[1].querySelector('*[class^="bc-dropdown"]') !== null) {
            this.hasDropdowns = true;
        }
        else if (this.rows[1].querySelector('*[class^="bc-table-action-cell-inline"]') !== null) {
            this.hasDropdowns = true;
        }
    }
    validateHasEmpyAccordion() {
        if (this.table.classList.contains(BcTableConstansts.TABLE_EMPTY_ACCORDION)) {
            this.hasEmpyAccordion = true;
        }
    }
    /**
     * Se crean los botones segun las opciones de los dropdowns para se insertados en las filas extras
     *
     * @memberof BcTableAccordionBehavior
     */
    createOptionBtnByDropdownHtml() {
        this.getListenersHmtl();
        for (let i = 1; i < this.rows.length; i++) {
            const row = this.rows[i];
            const extraRow = row.nextElementSibling;
            const options = this.dropdownsOptions[i - 1];
            if (extraRow !== null) {
                const contentContainer = extraRow.querySelector(`.${BcTableConstansts.TABLE_EXTRA_ROW_CONTENT_CLASS}`);
                const optionContainer = document.createElement(BcCommonConstants.DIV_TAG);
                optionContainer.classList.add(BcTableConstansts.TABLE_EXTRA_ROW_CONTENT_ACTIONS_CLASS);
                for (const option of Array.from(options)) {
                    const button = document.createElement(BcCommonConstants.BUTTON_TAG);
                    button.classList.add(BcCommonConstants.BTN_TERCIARY_CLASS, BcCommonConstants.BUTTON_SMALL_CLASS);
                    const html = `<em class="bc-icon bc-sm">${option.icon}</em> ${option.text}`;
                    button.innerHTML = html;
                    this.addEventSigleButton(option, button, i);
                    optionContainer.appendChild(button);
                }
                contentContainer.appendChild(optionContainer);
            }
        }
    }
    /**
     * Se agrega el evento del la opción del dropdown al boton creado en la fila extra
     *
     * @private
     * @param {BcTableOptionMenu} option
     * @param {Element} button
     * @param {number} index
     * @memberof BcTableAccordionBehavior
     */
    addEventSigleButton(option, button, index) {
        button.addEventListener(BcCommonConstants.EVENT_CLICK, () => {
            option.action !== null && option.action({ optionId: option.id, rowIndex: index });
        });
    }
    /**
     * Se setea el label que se va a mostrar en la versión mobile
     * @param customMobileLabel
     */
    setCustomMobileLabel(customMobileLabel) {
        this.customMobileLabel = customMobileLabel;
    }
    /**
     * Se crea el elemento td para el custom label de mobile
     */
    createCustomCell() {
        this.removeCustomCell();
        const rows = this.tbody.getElementsByTagName(BcCommonConstants.TR_TAG);
        for (let index = 0; index < rows.length; index++) {
            const customCol = document.createElement(BcCommonConstants.TD_TAG);
            customCol.classList.add(BcTableConstansts.TABLE_FAVORITE_CELL_CLASS, 'bc-order-4', BcCommonConstants.CUSTOM_CELL);
            customCol.innerHTML = this.customMobileLabel;
            if (!rows[index].classList.contains(BcTableConstansts.TABLE_EXTRA_ROW_CLASS)) {
                rows[index].appendChild(customCol);
            }
        }
    }
    /**
     * Se remueven los custom label creados
     */
    removeCustomCell() {
        this.getElements();
        for (const element of this.cells) {
            if (element.classList.contains(BcCommonConstants.CUSTOM_CELL)) {
                element.remove();
            }
        }
    }
    setActionColumnListener() {
        this.actionCells = Array.from(this.mySelf.querySelectorAll(`td[class*="${BcTableConstansts.TABLE_ACTION_CELL_CLASS}"]`));
        for (const cell of this.actionCells) {
            cell.addEventListener('keydown', (event) => {
                if (event.code == BcCommonConstants.KEY_EVENT_SPACE || event.key == BcCommonConstants.KEY_EVENT_ENTER) {
                    if (cell.classList.contains(BcTableConstansts.TABLE_ACTION_TOGGLE_CLASS)) {
                        const newCell = cell.childNodes[0];
                        newCell.click();
                    }
                    else if (!this.isCellActionInline) {
                        const newCell = cell.childNodes[0].childNodes[0];
                        newCell.click();
                    }
                    else {
                        const newCell = cell.childNodes[0];
                        newCell.click();
                    }
                }
            });
        }
    }
    addAriaLabelsColumns() {
        const currentCols = Array.from(this.table.querySelectorAll('th:not(.bc-hidden):not(.bc-table-checkbox-cell)'));
        for (let index = 0; index < currentCols.length; index++) {
            const newCol = currentCols[index];
            currentCols[index].setAttribute(BcCommonConstants.ARIA_LABEL, newCol.innerText +
                ', encabezado de columna, fila 0 de ' + this.rows.length +
                ', columna ' + index + ' de ' + currentCols.length);
            if (currentCols[index].querySelector(`em[class*="bc-sort-icon-hover"]`)) {
                const hoverIcon = currentCols[index].querySelector(`em[class*="bc-sort-icon-hover"]`);
                hoverIcon?.setAttribute(BcCommonConstants.ARIA_LABEL, 'ordenar por ' + newCol.innerText);
                hoverIcon?.setAttribute('role', 'button');
            }
        }
    }
    addAriaLabelsRows() {
        let currentRows = Array.from(this.tbody.querySelectorAll('tr:not(.bc-table-extra-info-row)'));
        for (let index = 0; index < currentRows.length; index++) {
            let newRow = currentRows[index].querySelectorAll('td:not(.bc-hidden):not(.bc-table-checkbox-cell):not(.bc-table-action-cell)');
            for (let j = 0; j < newRow.length; j++) {
                const newCell = newRow[j];
                newCell.setAttribute('aria-label', newCell.innerText + ' fila '
                    + (index + 1) + ' de ' + (currentRows.length + 1) + ', columna ' + (j + 1) + ' de ' + (newRow.length));
            }
        }
    }
    addAriaAccordionTable() {
        this.addAriaLabelsRows();
        this.addAriaLabelsColumns();
    }
}

class BcTableScrollBehavior extends BcTableBaseBehavior {
    constructor() {
        super();
        this.currentFixedColumnIndex = 0;
        this.stater = 0;
        this.visibleColumnsId = [];
        this.settingDropdownBehavior = null;
        this.columnsVisibiltyStatus = [];
        this.newFixedColumnId = '';
        setTimeout(() => {
            this.stater = this.isSelectionTable ? 1 : 0;
            this.buildFixedContent();
            this.setActionColumnListener();
        });
        window.addEventListener(_DROPDOWN_DISCARDED_EVENT, (dropdownId) => {
            dropdownId.detail === `${this.tableId}DropdownSetting` && this.resetDropdownSetting(dropdownId);
        });
        window.addEventListener(_DROPDOWN_CLOSED_EVENT, (dropdownId) => {
            dropdownId.detail === `${this.tableId}DropdownSetting` && this.resetDropdownSetting(dropdownId);
        });
    }
    /**
     * Se resetea la info del dropdown de configuración
     *
     * @private
     * @param {*} dropdownId
     * @memberof BcTableScrollBehavior
     */
    resetDropdownSetting(dropdownId) {
        this.columnsVisibiltyStatus = [];
        this.undoColumnSelection();
        this.resetBodyOverflow(dropdownId);
    }
    /**
     * Se crea el contenido de las columnas fijas
     *
     * @private
     * @memberof BcTableScrollBehavior
     */
    buildFixedContent() {
        this.mySelf.classList.add(BcTableConstansts.TABLE_SCROLL_CLASS);
        this.getElements();
        this.getFixedColumnIndex();
        this.setFixedCellClass();
        this.moveTableToDiv();
        if (this.settingDropdownBehavior && this.settingDropdownBehavior.getMySelf() !== null) {
            this.settingDropdownBehavior.getMySelf().remove();
            this.settingDropdownBehavior = null;
        }
        this.buildSettingDropdown();
        this.addEventSettingCheckbox();
        this.addSortEventLeftFixedColumn();
        this.validateHeigthOfCells();
        this.addRezise();
    }
    /**
     * Evento resize si cambia el tamaño de la pantalla
     *
     * @memberof BcTableScrollBehavior
     */
    addRezise() {
        window.addEventListener('resize', () => {
            this.validateScroll();
            this.validateHeigthOfCells();
        });
    }
    validateHeigthOfCells() {
        this.rows.forEach(row => {
            const cells = Array.from(row.children);
            const celda = cells.filter(cell => cell.classList.length == 1 && !cell.classList.contains(BcTableConstansts.TABLE_FIXED_CELL_CLASS))[0];
            let fixedCell;
            fixedCell = cells.filter(cell => cell.classList.contains(BcTableConstansts.TABLE_FIXED_COLUMN_LEFT_CLASS))[0];
            if (fixedCell) {
                if (fixedCell.clientHeight < celda.clientHeight) {
                    fixedCell.style.height = `${celda.clientHeight}px`;
                }
            }
        });
    }
    /**
     * Valida las celdas, el tamaño del contenido y la tabla para agregar las clases del borde para la celda fija
     *
     * @memberof BcTableScrollBehavior
     */
    validateScroll() {
        const table = this.mySelf.getElementsByClassName(BcTableConstansts.TABLE_CONTENT_CLASS)[0];
        const contentTable = this.mySelf.getElementsByTagName('table')[0];
        const fixedCells = this.mySelf.getElementsByClassName(BcTableConstansts.TABLE_FIXED_COLUMN_LEFT_CLASS);
        const validateWidth = (contentTable.offsetWidth - table.offsetWidth) > 0;
        for (let i = 0; i < fixedCells.length; i++) {
            if (validateWidth) {
                fixedCells[i].classList.add(BcTableConstansts.TABLE_SHADOW_CLASS);
                fixedCells[i].classList.add(BcTableConstansts.TABLE_BORDER_CLASS);
            }
            else {
                fixedCells[i].classList.remove(BcTableConstansts.TABLE_SHADOW_CLASS);
                fixedCells[i].classList.remove(BcTableConstansts.TABLE_BORDER_CLASS);
            }
        }
    }
    /**
     * Se obtiene el indice de la columan fija setea por el usuario
     * por defecto se setea 0 o 1 (si la tabla tiene checkbox)
     *
     * @memberof BcTableScrollBehavior
     */
    getFixedColumnIndex() {
        let index = this.isSelectionTable ? 1 : 0;
        for (let i = 0; i < this.columns.length; i++) {
            const column = this.columns[i];
            if (column.classList.contains(BcTableConstansts.TABLE_FIXED_COLUMN_CLASS)) {
                index = i;
            }
        }
        if (index <= 1 && !this.columns[index].classList.contains(BcTableConstansts.TABLE_FIXED_COLUMN_CLASS)) {
            this.columns[index].classList.add(BcTableConstansts.TABLE_FIXED_COLUMN_CLASS);
        }
        this.currentFixedColumnIndex = index;
    }
    addSortEventLeftFixedColumn() {
        const fixedColumnLeft = this.mySelf.querySelector(`${BcCommonConstants.TH_TAG}.${BcTableConstansts.TABLE_FIXED_COLUMN_LEFT_CLASS}`);
        fixedColumnLeft.addEventListener(BcCommonConstants.EVENT_CLICK, () => {
            const hiddenFixedColumn = this.mySelf.querySelector(`${BcCommonConstants.TH_TAG}.${BcTableConstansts.TABLE_FIXED_COLUMN_CLASS}`);
            const icon = fixedColumnLeft.querySelector(`.${BcTableConstansts.TABLE_SORT_ICON_CLASS}`);
            if (icon) {
                icon.remove();
            }
            hiddenFixedColumn.click();
            this.addSortIcon(fixedColumnLeft);
        });
    }
    /**
     * Se sete la clase para las celdas que correspoden a la columna fija
     *
     * @memberof BcTableScrollBehavior
     */
    setFixedCellClass() {
        const actionColumn = this.rows[0].children[this.rows[0].children.length - 1];
        actionColumn !== null && actionColumn.classList.add(`${BcTableConstansts.TABLE_FIXED_ACTION_CELL_CLASS}`);
        for (let i = 1; i < this.rows.length; i++) {
            const row = this.rows[i];
            const lastChild = row.children[row.children.length - 1];
            const fixedCell = row.children[this.currentFixedColumnIndex];
            fixedCell.classList.add(`${BcTableConstansts.TABLE_FIXED_CELL_CLASS}`);
            const isAction = lastChild.classList.contains(`${BcTableConstansts.TABLE_ACTION_CELL_CLASS}`);
            const hasDropdown = lastChild.querySelector('.bc-dropdown');
            if (isAction && hasDropdown) {
                lastChild.classList.add(`${BcTableConstansts.TABLE_FIXED_ACTION_CELL_CLASS}`);
            }
            const isActionInline = lastChild.classList.contains(`${BcTableConstansts.TABLE_CELL_ACTION_INLINE_CLASS}`);
            const hasBtn = lastChild.querySelector('.bc-button-icon');
            if (isActionInline && hasBtn) {
                lastChild.classList.add(`${BcTableConstansts.TABLE_FIXED_ACTION_CELL_CLASS}`);
            }
        }
        this.createFixedLeftColumn();
    }
    /**
     * Mueve la tabla un subcontainer
     *
     * @memberof BcTableScrollBehavior
     */
    moveTableToDiv() {
        const content = this.mySelf.querySelector(`.${BcTableConstansts.TABLE_CONTENT_CLASS}`);
        let subcontainer = this.mySelf.querySelector(`.${BcTableConstansts.TABLE_SUBCONTAINER}`);
        if (!subcontainer) {
            subcontainer = document.createElement(BcCommonConstants.DIV_TAG);
            subcontainer.classList.add(BcTableConstansts.TABLE_SUBCONTAINER);
        }
        subcontainer.appendChild(this.table);
        content.appendChild(subcontainer);
    }
    /**
     * Crea la columna fija de la izquierda para
     * Se tiene en cuenta si la tabla tiene checkbox
     *
     * @memberof BcTableScrollBehavior
     */
    createFixedLeftColumn() {
        const masterCheckbox = null;
        const validateLeftColumn = document.getElementsByClassName(BcTableConstansts.TABLE_FIXED_COLUMN_LEFT_CLASS);
        if (validateLeftColumn.length > 1) {
            this.resetFixedColumn(false);
        }
        for (let i = 0; i < this.rows.length; i++) {
            const row = this.rows[i];
            const fixedCell = row.querySelector(`.${i === 0 ? BcTableConstansts.TABLE_FIXED_COLUMN_CLASS : BcTableConstansts.TABLE_FIXED_CELL_CLASS}`);
            if (fixedCell !== null) {
                if (fixedCell.querySelector(`[class~='bc-sort-icon-hover']`)) {
                    fixedCell.querySelector(`[class~='bc-sort-icon-hover']`)?.remove();
                }
            }
            else {
                break;
            }
            const newFixedCell = this.createCellByType(i);
            if (this.isSelectionTable) {
                const checkboxCell = row.querySelector(`.${BcTableConstansts.TABLE_CHECBOX_CELL_CLASS}`);
                const checkbox = checkboxCell.querySelector(`.${BcTableConstansts.TABLE_CHECBOX_CONTAINER_CLASS}`);
                const checkboxClone = checkbox.cloneNode(true);
                const chk = checkboxClone.querySelector(`input[type="${BcTableConstansts.TABLE_CHECKBOX_SELECTOR}"]`);
                chk[BcCommonConstants.CHECKED] = false;
                newFixedCell.appendChild(checkboxClone);
                newFixedCell.append(fixedCell.textContent);
                checkboxCell.classList.add(BcTableConstansts.TABLE_HIDDEN_CLASS);
                if (!checkbox.classList.contains(BcTableConstansts.TABLE_MASTER_CHECKBOX_CLASS)) {
                    this.addEventToCloneChk(checkboxClone, checkbox, masterCheckbox);
                }
            }
            else {
                newFixedCell.innerHTML = fixedCell.innerHTML;
            }
            row.insertBefore(newFixedCell, row.firstChild);
        }
        this.validateScroll();
        this.validateCellsWithHeader();
    }
    /**
      * Valida las celdas de la tabla con las del header para verificar que esten ocultas si corresponde
      *
      * @memberof BcTableScrollBehavior
    */
    validateCellsWithHeader() {
        for (let j = 1; j < this.rows.length; j++) {
            const cells = this.rows[j].children;
            for (let i = 1; i < cells.length - 1; i++) {
                if (!cells[i].classList.contains(BcTableConstansts.TABLE_HIDDEN_CLASS)
                    && this.columns[i - 1].classList.contains(BcTableConstansts.TABLE_HIDDEN_CLASS)) {
                    cells[i].classList.add(BcTableConstansts.TABLE_HIDDEN_CLASS);
                }
                else if (cells[i].classList.contains(BcTableConstansts.TABLE_HIDDEN_CLASS)
                    && !this.columns[i - 1].classList.contains(BcTableConstansts.TABLE_HIDDEN_CLASS)) {
                    cells[i].classList.remove(BcTableConstansts.TABLE_HIDDEN_CLASS);
                }
            }
        }
    }
    /**
       * Crea la celda según el tipo y agrega sus respectivas clases
       *
       * @param {number} index
       * @return {*}  {Element}
       * @memberof BcTableScrollBehavior
       */
    createCellByType(index) {
        const fixedTD = document.createElement(index === 0 ? BcTableConstansts.TABLE_TH_CLASS : BcTableConstansts.TABLE_TD_CLASS);
        fixedTD.classList.add(BcTableConstansts.TABLE_FIXED_COLUMN_LEFT_CLASS);
        return fixedTD;
    }
    /**
     * Crea el dropdown de configuración
     *
     * @memberof BcTableScrollBehavior
     */
    buildSettingDropdown() {
        const html = `
     <em class="bc-icon bc-sm bc-dropdown-toggle" aria-controls="${this.tableId}DropdownSetting">settings</em>
       <div class="bc-dropdown-content" id="${this.tableId}DropdownSetting">
        <div class="bc-table-setting-header">
               <h6>Configurar tabla</h6>
               <p>Puedes fijar una columna a la izquierda
               de la tabla y mostrar / ocultar columnas</p>
               <em class="bc-icon bc-xs bc-dropdown-close-button">error</em>
        </div>
        <div class="bc-table-setting-body"></div>
        <div class="bc-table-setting-footer">
               <button class="bc-button-primary bc-button-small">Aplicar</button>
       </div>
     </div>`;
        const dropdown = document.createElement(BcCommonConstants.DIV_TAG);
        dropdown.classList.add(BcCommonConstants.BC_DROPDOWN_CLASS, BcCommonConstants.BC_DROPDOWN_CUSTOM_CLASS, BcCommonConstants.BC_DROPDOWN_UNDISMISS_CLASS, 'bc-table-dropdown-setting');
        dropdown.innerHTML = html;
        let actionContainer = this.headerTop.querySelector(`[class~='${BcTableConstansts.TABLE_ACTION_CONTAINER_CLASS}']`);
        actionContainer = this.validateActionContainer(actionContainer);
        const settingBody = dropdown.querySelector(`[class=${BcTableConstansts.TABLE_SETTING_BODY_CLASS}]`);
        const columnList = this.buildColumnList();
        settingBody.appendChild(columnList);
        if (actionContainer.lastElementChild !== null
            && !actionContainer.lastElementChild.classList.contains('bc-dropdown')) {
            actionContainer.appendChild(dropdown);
        }
        this.settingDropdownBehavior = this.initDropdown(dropdown, true);
        this.addButtonSettingEvent();
    }
    /**
     * Valida si existe o no el contender de acciones para agregar el dropdown de configuración
     *
     * @private
     * @param {Element} actionContainer
     * @return {*}  {Element}
     * @memberof BcTableScrollBehavior
     */
    validateActionContainer(actionContainer) {
        if (actionContainer !== null) {
            return actionContainer;
        }
        else {
            const rightContainer = document.createElement(BcCommonConstants.DIV_TAG);
            rightContainer.classList.add(BcTableConstansts.TABLE_RIGHT_CONTAINER_CLASS);
            const actionsContainer = document.createElement(BcCommonConstants.DIV_TAG);
            actionsContainer.classList.add(BcTableConstansts.TABLE_ACTION_CONTAINER_CLASS);
            rightContainer.appendChild(actionsContainer);
            this.headerTop.appendChild(rightContainer);
            return actionsContainer;
        }
    }
    /**
     * Crea la lista con las columnas de la tabla y agrega el pin y los checkboxes
     * con sus eventos para fijar, mostrar/ocultar
     *
     * @private
     * @return {*}  {Element}
     * @memberof BcTableScrollBehavior
     */
    buildColumnList() {
        this.getVisibleColumns();
        const element = document.createElement('ul');
        for (const column of this.columnsData) {
            const li = document.createElement('li');
            const idArray = column.id.split('_');
            const fixed = idArray[idArray.length - 1] === String(this.currentFixedColumnIndex - 1);
            const html = `
         <small>${column.name}</small>
         <div class="bc-table-setting-actions">
         <em class="bc-icon bc-button-fixer" id="thumbtack_${column.id}" tabindex="0">thumbtack</em>
         <label class="bc-container-checkbox"><input type="checkbox" tabindex="0"
            id="check_${column.id}" name="name_${column.id}" value="${column.name}"
            ${this.visibleColumnsId.includes(column.id) && 'checked="true"'}
            ${fixed ? 'disabled' : ''}>
            <span class="bc-checkbox"></span>
         </label>
         </div>
   `;
            li.innerHTML = html;
            fixed && li.classList.add(BcTableConstansts2.TABLE_FIXED_COLUMN_CLASS);
            const thumbtack = li.querySelector(`*[class~="bc-button-fixer"]`);
            setTimeout(() => {
                this.addThumbtackEvent(thumbtack);
            });
            element.appendChild(li);
        }
        return element;
    }
    /**
     * Obtiene las columnas visibles
     *
     * @memberof BcTableScrollBehavior
     */
    getVisibleColumns() {
        this.visibleColumnsId = [];
        const columns = Array.from(this.mySelf.querySelectorAll(BcCommonConstants.TH_TAG));
        for (const column of columns) {
            if (!column.classList.contains(BcTableConstansts.TABLE_CHECBOX_CELL_CLASS) &&
                !column.classList.contains(BcTableConstansts.TABLE_ACTION_COLUMN_CLASS) &&
                !column.classList.contains(BcTableConstansts.TABLE_FIXED_COLUMN_LEFT_CLASS) &&
                (column.classList.contains(BcTableConstansts2.TABLE_FIXED_COLUMN_CLASS) ||
                    !column.classList.contains(BcTableConstansts.TABLE_HIDDEN_CLASS))) {
                this.visibleColumnsId.push(column.getAttribute('id'));
            }
        }
    }
    /**
     * Se agrega el evento al pin por cada item la lista del dropdown de configuración
     * este evento permite fijar una columna la parte izquierda
     *
     * @param {Element} thumbtack
     * @memberof BcTableScrollBehavior
     */
    addThumbtackEvent(thumbtack) {
        thumbtack.addEventListener(BcCommonConstants.EVENT_CLICK, () => {
            const dropdownSetting = this.settingDropdownBehavior.getMySelf();
            const list = Array.from(dropdownSetting.querySelectorAll('ul li'));
            for (const item of list) {
                const _thumbtack = item.querySelector(`*[class~="bc-button-fixer"]`);
                _thumbtack.closest('li').classList.remove(BcTableConstansts2.TABLE_FIXED_COLUMN_CLASS);
            }
            const liParent = thumbtack.closest('li');
            liParent.classList.add(BcTableConstansts2.TABLE_FIXED_COLUMN_CLASS);
            liParent.querySelector(`input[type="${BcTableConstansts.TABLE_CHECKBOX_SELECTOR}"]`)[BcCommonConstants.CHECKED] = true;
            if (liParent.classList.contains(BcTableConstansts2.TABLE_FIXED_COLUMN_CLASS)) {
                this.newFixedColumnId = thumbtack.getAttribute('id');
            }
        });
    }
    /**
     * Se agrega el evento al botón aceptar del dropdown de configuración
     *
     * @memberof BcTableScrollBehavior
     */
    addButtonSettingEvent() {
        const dropdownSetting = this.mySelf.querySelector(`[id="${this.tableId}DropdownSetting"]`).parentElement;
        const settingFooter = dropdownSetting.querySelector(`[class=${BcTableConstansts.TABLE_SETTING_FOOTER_CLASS}]`);
        const acceptButton = settingFooter.querySelector(`[class~=${BcCommonConstants.BTN_PRIMARY_CLASS}]`);
        acceptButton.addEventListener(BcCommonConstants.EVENT_CLICK, (event) => {
            event.preventDefault();
            event.stopPropagation();
            for (const column of this.columnsVisibiltyStatus) {
                if (!column.fixed) {
                    this.hideShowColumn(column.id, column.visible);
                    this.hideShowCell(column.id, column.visible);
                }
            }
            this.settingDropdownBehavior.closeDropdown();
            this.newFixedColumnId !== '' && this.updateFixedColumn();
            this.resetFixedColumn(true);
        });
    }
    /**
     * Se agrega el evento al checkbox por cada item la lista del dropdown de configuración
     * este evento permite ocultar/mostrar las columnas
     *
     * @memberof BcTableScrollBehavior
     */
    addEventSettingCheckbox() {
        const dropdownSetting = this.mySelf.querySelector(`[id="${this.tableId}DropdownSetting"]`).parentElement;
        const settingBody = dropdownSetting.querySelector(`[class=${BcTableConstansts.TABLE_SETTING_BODY_CLASS}]`);
        const checkboxes = Array.from(settingBody.querySelectorAll(`input[type="${BcTableConstansts.TABLE_CHECKBOX_SELECTOR}"]`));
        for (const checkbox of checkboxes) {
            this.setChangeEventCheckbox(checkbox);
        }
    }
    /**
     * Se agrega el evento al checkbox
     *
     * @private
     * @param {Element} checkbox
     * @memberof BcTableScrollBehavior
     */
    setChangeEventCheckbox(checkbox) {
        checkbox.addEventListener(BcCommonConstants.EVENT_CHANGE, () => {
            this.prepareColumnList();
        });
    }
    /**
     * Prepara la lista de las columnas con sus estados (fija, visible/oculta)
     * para luego se aplicada por el botón aceptar
     *
     * @memberof BcTableScrollBehavior
     */
    prepareColumnList() {
        const dropdownSetting = this.mySelf.querySelector(`[id="${this.tableId}DropdownSetting"]`).parentElement;
        const settingBody = dropdownSetting.querySelector(`[class=${BcTableConstansts.TABLE_SETTING_BODY_CLASS}]`);
        const checkboxes = Array.from(settingBody.querySelectorAll(`input[type="${BcTableConstansts.TABLE_CHECKBOX_SELECTOR}"]`));
        this.columnsVisibiltyStatus = [];
        for (const checkbox of checkboxes) {
            this.columnsVisibiltyStatus.push({
                id: checkbox.getAttribute('id'),
                visible: checkbox[BcCommonConstants.CHECKED],
                fixed: checkbox.closest('li').classList.contains(BcTableConstansts2.TABLE_FIXED_COLUMN_CLASS),
            });
        }
    }
    /**
     * Oculta/muestra las columnas según los checkbox en el dropdown de configuración
     *
     * @param {string} id
     * @param {boolean} checked
     * @memberof BcTableScrollBehavior
     */
    hideShowColumn(id, checked) {
        const columnId = id.indexOf('check_') !== -1 ? id.split('check_')[1] : id;
        for (const column of this.columns) {
            if (column.getAttribute('id') === columnId) {
                if (checked) {
                    column.classList.remove('bc-hidden');
                }
                else {
                    column.classList.add('bc-hidden');
                }
            }
        }
    }
    /**
     * Oculta/muestra las celdas de la columan fija según los checkbox en el dropdown de configuración
     *
     * @param {string} columnId
     * @param {boolean} visible
     * @memberof BcTableScrollBehavior
     */
    hideShowCell(columnId, visible) {
        const array = columnId.split('_');
        const index = Number(array[array.length - 1]);
        const increaseSelectionType = 2;
        const increase = this.isSelectionTable ? increaseSelectionType : 1;
        this.rows = Array.from(this.table.querySelectorAll(`${BcTableConstansts.TABLE_ROW_CLASS}`));
        for (let i = 1; i < this.rows.length; i++) {
            const row = this.rows[i];
            const child = row.children[index + increase];
            if (!visible) {
                child.classList.add('bc-hidden');
            }
            else if (!child.classList.contains(BcTableConstansts.TABLE_FIXED_COLUMN_LEFT_CLASS) || !child.classList.contains(BcTableConstansts.TABLE_FIXED_CELL_CLASS)) {
                child.classList.remove('bc-hidden');
            }
        }
    }
    /**
     * Actualiza la columna fija segun la seleccionada en el dropdown de configuración
     *
     * @memberof BcTableScrollBehavior
     */
    updateFixedColumn() {
        const columnId = this.newFixedColumnId.split('thumbtack_')[1];
        const idArray = columnId.split('_');
        const columnIndex = idArray[idArray.length - 1];
        const columns = Array.from(this.mySelf.querySelectorAll(BcCommonConstants.TH_TAG));
        if (columnIndex !== String(this.currentFixedColumnIndex)) {
            for (const column of columns) {
                column.classList.contains(BcTableConstansts2.TABLE_FIXED_COLUMN_CLASS) && column.classList.remove(BcTableConstansts2.TABLE_FIXED_COLUMN_CLASS, 'bc-hidden');
                columnId === column.getAttribute('id') && column.classList.add(BcTableConstansts2.TABLE_FIXED_COLUMN_CLASS);
            }
            this.getFixedColumnIndex();
            this.newFixedColumnId = '';
        }
    }
    /**
     * Resetea la columna fija a la izquierda para poder crear otra
     *
     * @memberof BcTableScrollBehavior
     * @param {Boolean} reBuildContent
     */
    resetFixedColumn(reBuildContent) {
        for (const row of this.rows) {
            const fixedCell = row.querySelector(`.${BcTableConstansts.TABLE_FIXED_COLUMN_LEFT_CLASS}`);
            fixedCell !== null && fixedCell.remove();
            for (const cell of Array.from(row.children)) {
                cell.classList.remove(BcTableConstansts.TABLE_FIXED_CELL_CLASS);
            }
        }
        if (reBuildContent) {
            if (!this.isSelectionTable) {
                this.verifyColumnsHidden();
            }
            this.buildFixedContent();
        }
    }
    /**
     * Verifica que no existan columnas con visible en false que les falte la clase hidden
     *
     * @memberof BcTableScrollBehavior
     */
    verifyColumnsHidden() {
        const rowForValidation = this.rows[1];
        const validatorFixedCell = this.validateFixedCell(rowForValidation);
        for (let i = 0; i < this.columns.length; i++) {
            const column = this.columns[i];
            if (!column.classList.contains(BcTableConstansts.TABLE_ACTION_COLUMN_CLASS)) {
                const visibleColumn = this.validateContaintHiddenClass(i, rowForValidation.children[i], validatorFixedCell);
                this.addHiddenClass(visibleColumn, column);
            }
        }
    }
    /**
     * Devuelve si existe o no una columna fija en las celdas
     *
     * @memberof BcTableScrollBehavior
     * @param {Boolean} rowForValidation Primera fila de celdas correctas
     */
    validateFixedCell(rowForValidation) {
        let existFixedCell;
        const firstRow = rowForValidation.children;
        for (const column of firstRow) {
            if (column.classList.contains(BcTableConstansts.TABLE_FIXED_COLUMN_LEFT_CLASS)) {
                existFixedCell = true;
                break;
            }
            else {
                existFixedCell = false;
            }
        }
        return existFixedCell ? 0 : -1;
    }
    /**
       * Valida si la columna actual tiene o no la clase Hidden
       *
       * @private
       * @param {number} index
       * @param {Element} children
       * @param {number} validatorFixedCell
       * @memberof BcTableScrollBehavior
       */
    validateContaintHiddenClass(index, children, validatorFixedCell) {
        if (index > validatorFixedCell && index <= this.columns.length - 1) {
            return children.classList.contains(BcTableConstansts.TABLE_HIDDEN_CLASS) ? false : true;
        }
    }
    /**
         * Agrega la clase hidden si no es visible y no contiene bc-hidden en la lista
         *
         * @private
         * @param {boolean} visibleColumn
         * @param {Element} column
         * @memberof BcTableScrollBehavior
         */
    addHiddenClass(visibleColumn, column) {
        if (!visibleColumn && !column.classList.contains(BcTableConstansts.TABLE_HIDDEN_CLASS)) {
            column.classList.add(BcTableConstansts.TABLE_HIDDEN_CLASS);
        }
    }
    /**
     * Agrega los evento de los checkboxes de selección por cada fila
     * clona los eventos y se los agrega a los creados en la columna fija de la izquierda
     *
     * @private
     * @param {Node} checkboxClone
     * @param {Element} checkbox
     * @param {*} masterCheckbox
     * @memberof BcTableScrollBehavior
     */
    addEventToCloneChk(checkboxClone, checkbox, masterCheckbox) {
        const inputCheckbox = checkboxClone.querySelector(`input[type="checkbox"]`);
        inputCheckbox.addEventListener(BcCommonConstants.EVENT_CHANGE, (event) => {
            event.stopPropagation();
            event.preventDefault();
            checkbox['click']();
            if (event.target !== null) {
                this.setCheckboxValue(checkbox, event);
            }
            else {
                setTimeout(() => {
                    this.setCheckboxValue(checkbox, event); // revisar esto con el angular
                });
            }
            const firstCellFixed = this.table.querySelector('.bc-table-fixed-column-left');
            const masterCheckboxClone = firstCellFixed.querySelector(`input[type="${BcTableConstansts.TABLE_CHECKBOX_SELECTOR}"]`);
            masterCheckboxClone[BcCommonConstants.CHECKED] = this.validateAllSelection();
        });
    }
    /**
     * Actaliza el valor del checkbox
     *
     * @private
     * @param {Element} checkbox
     * @param {Event} event
     * @memberof BcTableScrollBehavior
     */
    setCheckboxValue(checkbox, event) {
        checkbox[BcCommonConstants.CHECKED] = event.target[BcCommonConstants.CHECKED];
    }
    /**
     * Resetea el scroll del body
     *
     * @param {*} dropdownId
     * @memberof BcTableScrollBehavior
     */
    resetBodyOverflow(dropdownId) {
        if (dropdownId.detail === `${this.tableId}DropdownSetting`) {
            document.querySelector('body')['style'].overflow = 'auto';
        }
    }
    /**
     * Deshace los cambios hechos por el usuario en el dropdown de configuración
     * esto ocurre cuando cierra o descarta el dropdown, es decir, no le da aceptar
     * Visibilidad
     *
     * @memberof BcTableScrollBehavior
     */
    undoColumnSelection() {
        this.getVisibleColumns();
        const dropdownSetting = this.headerTop.querySelector(`*[class~="${BcCommonConstants.BC_DROPDOWN_UNDISMISS_CLASS}"]`);
        const list = dropdownSetting !== null ? Array.from(dropdownSetting.querySelectorAll('ul li')) : [];
        for (const item of list) {
            const checkbox = item.querySelector(`input[type="${BcTableConstansts.TABLE_CHECKBOX_SELECTOR}"]`);
            const id = checkbox.getAttribute('id').split('check_');
            if (this.visibleColumnsId.includes(id[1])) {
                checkbox[BcCommonConstants.CHECKED] = true;
            }
            else {
                checkbox[BcCommonConstants.CHECKED] = false;
            }
        }
        dropdownSetting !== null && this.undoFixedColumn();
    }
    /**
     * Deshace los cambios hechos por el usuario en el dropdown de configuración
     * esto ocurre cuando cierra o descarta el dropdown, es decir, no le da aceptar
     * Columna Fija
     *
     * @memberof BcTableScrollBehavior
     */
    undoFixedColumn() {
        const dropdownSetting = this.mySelf.querySelector(`.${BcTableConstansts.TABLE_DROPDOWN_SETTINGS_CLASS}`);
        const thumbtacks = Array.from(dropdownSetting.querySelectorAll(`.${BcTableConstansts.TABLE_BUTTON_FIXER}`));
        for (const thumbtack of thumbtacks) {
            const idArray = thumbtack.getAttribute('id').split('_');
            const isFixed = idArray[idArray.length - 1] === String(this.currentFixedColumnIndex);
            if (isFixed) {
                thumbtack.closest('li').classList.add(BcTableConstansts2.TABLE_FIXED_COLUMN_CLASS);
            }
            else {
                thumbtack.closest('li').classList.remove(BcTableConstansts2.TABLE_FIXED_COLUMN_CLASS);
            }
        }
    }
    /**
     * Permite volver a ocultar las celdas de columna fija, en caso de que no lo estén
     *
     * @memberof BcTableScrollBehavior
     */
    hiddeCellByColumn() {
        for (const comlun of this.columns) {
            if (comlun.classList.contains(BcTableConstansts.TABLE_HIDDEN_CLASS)) {
                this.hideShowCell(comlun.getAttribute('id'), false);
            }
        }
    }
    setActionColumnListener() {
        this.actionCells = Array.from(this.mySelf.querySelectorAll(`td[class*="${BcTableConstansts.TABLE_ACTION_CELL_CLASS}"]`));
        for (const cell of this.actionCells) {
            cell.addEventListener('keydown', (event) => {
                if (event.code == BcCommonConstants.KEY_EVENT_SPACE || event.key == BcCommonConstants.KEY_EVENT_ENTER) {
                    if (!this.isCellActionInline) {
                        const newCell = cell.childNodes[0].childNodes[0];
                        newCell.click();
                    }
                    else {
                        const newCell = cell.childNodes[0];
                        newCell.click();
                    }
                }
            });
        }
    }
}

const PLANNER_NAME = `planner`;
const PLANNER_NAMESPACE = `${BcCommonConstants.PREFIX_LIB}-${PLANNER_NAME}`;
const MODAL_CALENDAR_NAME = 'modal-planner';
const MODAL_CALENDAR_NAMESPACE = `${BcCommonConstants.PREFIX_LIB}-${MODAL_CALENDAR_NAME}`;
const MODAL_TWO = 2;
const PLANNER_DAY = `${PLANNER_NAMESPACE}-day`;
const PLANNER_HEADER = `${PLANNER_NAMESPACE}-header`;
const PLANNER_TOP = `${PLANNER_NAMESPACE}-top`;
const PLANNER_WEEK = `${PLANNER_NAMESPACE}-week`;
const PLANNER_MONTHS = `${PLANNER_NAMESPACE}-months`;
const PLANNER_YEARS = `${PLANNER_NAMESPACE}-years`;
const MONTHS = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
const DAYS = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];

class BcPlannerBehavior extends BcDefaultBehavior {
    constructor() {
        super();
        this.items = [];
        this.bcPlannerNextMonthButton = `${PLANNER_NAMESPACE}-btn-next-month`;
        this.bcPlannerPreviousMonthButton = `${PLANNER_NAMESPACE}-btn-previous-month`;
        this.bcPlannerNextYearButton = `${PLANNER_NAMESPACE}-btn-next-year`;
        this.bcPlannerPreviousYearButton = `${PLANNER_NAMESPACE}-btn-previous-year`;
        this.bcPlannerDate = new Date();
        this.bcPlannerToday = this.bcPlannerDate.getDate();
        this.bcPlannerYear = this.bcPlannerDate.getFullYear();
        this.bcPlannerMonth = this.bcPlannerDate.getMonth();
        this.timeOut = 0;
    }
    static setUpAll() {
        const plannerElements = Array.from(document.querySelectorAll(`.${PLANNER_NAMESPACE}`));
        const elements = [];
        for (let i = 0; i < plannerElements.length; i++) {
            const element = plannerElements[i];
            const bcPlannerBehavior = new BcPlannerBehavior();
            bcPlannerBehavior.setElement(element);
            bcPlannerBehavior.setUp();
            elements.push(bcPlannerBehavior);
        }
        return elements;
    }
    _setUp() {
        try {
            this.createHeadersAndPaginator();
            this.setUpDateVariables(new Date());
        }
        catch (error) {
            this.isReady = false;
        }
    }
    initModal() {
        this.modalListPlus = new BcModalBehavior();
        this.modalListPlus.setId('modalPlanner1');
        this.modalListPlus.setUp();
    }
    setUpDateVariables(date) {
        this.bcPlannerDate = new Date(date);
        this.bcPlannerToday = date.getDate();
        this.bcPlannerYear = date.getFullYear();
        this.setYearText();
        this.bcPlannerMonth = date.getMonth();
        this.setMonth(date.getMonth());
        this.setMonthText();
        this.createDaysOfMonth();
        this.listeners();
    }
    createHeadersAndPaginator() {
        const html = `
    ${this.getPlannerTemplate()}
    ${this.getPlannerTop()}
    ${this.getPlannerHeader()}
    `;
        const element = this.mySelf;
        element.innerHTML += html;
        element.addEventListener('mouseover', () => {
            this.initModal();
            element.removeEventListener('mouseover', () => {
                this.initModal();
            });
        });
    }
    getPlannerTemplate() {
        return `<article class="bc-modal ${PLANNER_NAMESPACE}-modal" id="modalPlanner1" role='dialog' id='exampleModal' aria-labelledby="idModalLabel" aria-modal="true">
              <label class="bc-modal-close" for=""></label>
              <section class="bc-modal-container" customwidth="large" titlealign="" buttonalignment="horizontal" typeicon="" iscancellable="false">
                <div class="bc-modal-close-button-container">
                  <button class="bc-direction-row bc-icon bc-modal-close-button" aria-label="Close">error</button>
                </div>
                <div class="bc-modal-illustration"></div>
                <section class="bc-modal-title bc-direction-row">
                    <h4 id="idModalLabel" class="modal-title-label">T&iacute;tulo</h4>
                </section>
                <section class="bc-modal-content">
                    <div modalcontent="">
                      <div class="${MODAL_CALENDAR_NAMESPACE}-content"></div>
                    </div>
                </section>
                <section class="bc-modal-button-container bc-justify-content-center">
                  <button bc-button sizebutton="small" class="bc-button-primary bc-button-small bc-w-25" tabindex="0">CERRAR</button>
                  <button bc-button sizebutton="small" class="bc-button-secondary bc-button-small bc-w-25" tabindex="0">CERRAR</button>
                </section>
                <section class="bc-modal-footer"></section>
          </section>
        </article>`;
    }
    getPlannerHeader() {
        return `<div class="${PLANNER_HEADER}">
                <div>Lunes</div>
                <div>Martes</div>
                <div>Miercoles</div>
                <div>Jueves</div>
                <div>Viernes</div>
                <div>Sabado</div>
                <div>Domingo</div>
            </div>`;
    }
    getPlannerTop() {
        return `<div  class="${PLANNER_TOP}">
              <div class="${PLANNER_TOP}-paginator">
                  <div class="${PLANNER_MONTHS}"><a class="${PLANNER_NAMESPACE}-btn-previous-month"><em class="bc-icon">arrow2-left</em></a>
                      <h5 class="${PLANNER_NAMESPACE}-month"></h5><a class="${PLANNER_NAMESPACE}-btn-next-month"><em class="bc-icon">arrow2-right</em></a>
                  </div>
                  <div class="${PLANNER_YEARS}"><a class="${PLANNER_NAMESPACE}-btn-previous-year"><em class="bc-icon">arrow2-left</em></a>
                      <h5 class="${PLANNER_NAMESPACE}-year"></h5><a class="${PLANNER_NAMESPACE}-btn-next-year"><em class="bc-icon">arrow2-right</em></a>
                  </div>
              </div>
              <div class="${PLANNER_TOP}-items">

              </div>
            </div>`;
    }
    createWeeks(weeks) {
        const element = this.mySelf;
        while (element.lastElementChild.classList[0] == `${PLANNER_WEEK}`) {
            element.removeChild(element.lastElementChild);
        }
        for (const week of weeks) {
            const weekHtml = this.createHtmlWeeek(week);
            element.innerHTML += weekHtml;
        }
    }
    createHtmlWeeek(week) {
        let htmlWeek = ``;
        htmlWeek = htmlWeek + `<div class="${PLANNER_WEEK}">`;
        for (const day of week.dates) {
            htmlWeek =
                htmlWeek +
                    `<div id="bc_planner_view_day_${this.whatMonthorYearBelong(week, day, false)}_${this.whatMonthorYearBelong(week, day, true)}_${day}"
      class="${PLANNER_DAY}  ${this.addOpacityDay(week, day)}">
        <div class="${PLANNER_DAY}-items">

        </div>
        <p class="${PLANNER_DAY}-number ${this.addClassToday(week, day)}">${day}</p>
      </div>`;
        }
        htmlWeek = htmlWeek + `</div>`;
        return htmlWeek;
    }
    addOpacityDay(week, day) {
        if (day >= week.start && day <= week.end) {
            return '';
        }
        return `${PLANNER_DAY}-number-opacity`;
    }
    addClassToday(week, day) {
        const today = new Date();
        if (day >= week.start && day <= week.end) {
            if (day == today.getDate() && this.getMonth() == today.getMonth() && this.getYear() == today.getFullYear()) {
                return `${PLANNER_NAMESPACE}-today-number`;
            }
        }
        return '';
    }
    whatMonthorYearBelong(week, day, isM) {
        const firstDayOfMonth = new Date(this.bcPlannerYear, this.bcPlannerMonth, 1);
        const lastDate = new Date(this.bcPlannerYear, this.bcPlannerMonth + 1, 0);
        let newMonth = this.bcPlannerMonth;
        let newDate = new Date(this.bcPlannerDate);
        if (day >= week.start && day <= week.end) {
            return isM ? newMonth : newDate.getFullYear();
        }
        else {
            if (firstDayOfMonth.getDate() == week.start) {
                newMonth -= 1;
                newDate = new Date(newDate.setMonth(newMonth));
                return isM ? newDate.getMonth() : newDate.getFullYear();
            }
            else if (lastDate.getDate() == week.end) {
                newMonth += 1;
                newDate = new Date(newDate.setMonth(newMonth));
                return isM ? newDate.getMonth() : newDate.getFullYear();
            }
        }
        return isM ? newMonth : newDate.getFullYear();
    }
    getWeeksInMonth() {
        const weeks = [], firstDate = new Date(this.bcPlannerYear, this.bcPlannerMonth, 1), lastDate = new Date(this.bcPlannerYear, this.bcPlannerMonth + 1, 0), numDays = lastDate.getDate();
        const dayOffWeek = 6;
        let dayOfWeekCounter = firstDate.getDay() + (firstDate.getDay() == 0 ? dayOffWeek : -1);
        for (let date = 1; date <= numDays; date++) {
            if (dayOfWeekCounter === 0 || weeks.length === 0) {
                weeks.push([]);
            }
            weeks[weeks.length - 1].push(date);
            const defaultDayOfWeekCounter = 7;
            dayOfWeekCounter = (dayOfWeekCounter + 1) % defaultDayOfWeekCounter;
        }
        return weeks
            .filter((w) => !!w.length)
            .map((w) => ({
            start: w[0],
            end: w[w.length - 1],
            dates: w,
        }));
    }
    createDaysOfMonth() {
        const weeks = this.getWeeksInMonth();
        const dayDefault = 7;
        if (weeks[0].dates.length < dayDefault) {
            const days = dayDefault - weeks[0].dates.length;
            const lastDaysPreviousMonth = [];
            for (let i = 1; i <= days; i++) {
                const firstDayOfMonth = new Date(this.bcPlannerYear, this.bcPlannerMonth, 1);
                const numberDay = new Date(firstDayOfMonth.setDate(1 - i)).getDate();
                lastDaysPreviousMonth.unshift(numberDay);
            }
            weeks[0].dates.unshift(...lastDaysPreviousMonth);
        }
        if (weeks[weeks.length - 1].dates.length < dayDefault) {
            const days = dayDefault - weeks[weeks.length - 1].dates.length;
            const moreDaysNextMonth = [];
            for (let i = 1; i <= days; i++) {
                const lastDayOfMonth = new Date(this.bcPlannerYear, this.bcPlannerMonth + 1, 0);
                const numberDay = new Date(lastDayOfMonth.setDate(i)).getDate();
                moreDaysNextMonth.push(numberDay);
            }
            weeks[weeks.length - 1].dates.push(...moreDaysNextMonth);
        }
        this.createWeeks(weeks);
    }
    getFirstElementByClassName(className) {
        const elements = this.mySelf.getElementsByClassName(className);
        if (elements.length > 0) {
            return elements[0];
        }
        return null;
    }
    setMonthText() {
        const element = this.getFirstElementByClassName(`${PLANNER_NAMESPACE}-month`);
        if (element) {
            element.innerText = this.getMonthName(this.bcPlannerMonth);
        }
    }
    setYearText() {
        const element = this.getFirstElementByClassName(`${PLANNER_NAMESPACE}-year`);
        if (element) {
            element.innerText = this.getYear();
        }
    }
    setClickNextMonthBtnListener() {
        const element = this.getFirstElementByClassName(this.bcPlannerNextMonthButton);
        if (element) {
            element.removeEventListener('click', (e) => this.nextMonth());
            element.addEventListener('click', (e) => this.nextMonth());
        }
    }
    setClickPreviousMonthBtnListener() {
        const element = this.getFirstElementByClassName(this.bcPlannerPreviousMonthButton);
        if (element) {
            element.removeEventListener('click', (e) => this.previousMonth());
            element.addEventListener('click', (e) => this.previousMonth());
        }
    }
    setClickNextYearBtnListener() {
        const element = this.getFirstElementByClassName(this.bcPlannerNextYearButton);
        if (element) {
            element.removeEventListener('click', (e) => this.nextYear());
            element.addEventListener('click', (e) => this.nextYear());
        }
    }
    setClickPreviousYearBtnListener() {
        const element = this.getFirstElementByClassName(this.bcPlannerPreviousYearButton);
        if (element) {
            element.removeEventListener('click', (e) => this.previousYear());
            element.addEventListener('click', (e) => this.previousYear());
        }
    }
    getMonth() {
        return this.bcPlannerMonth;
    }
    setMonth(Month) {
        this.bcPlannerMonth = Month;
    }
    getMonthName(month) {
        return MONTHS[month];
    }
    getDayName(day) {
        return DAYS[day];
    }
    getYear() {
        return this.bcPlannerYear;
    }
    getToday() {
        return this.bcPlannerToday;
    }
    listeners() {
        this.setClickNextMonthBtnListener();
        this.setClickPreviousMonthBtnListener();
        this.setClickNextYearBtnListener();
        this.setClickPreviousYearBtnListener();
    }
    nextMonth() {
        const newMonth = this.bcPlannerMonth + 1;
        const newDate = new Date(this.bcPlannerDate.setMonth(newMonth));
        this.setUpDateVariables(newDate);
        this.changesEmitEvent('nextMonth');
    }
    previousMonth() {
        const newMonth = this.bcPlannerMonth - 1;
        const newDate = new Date(this.bcPlannerDate.setMonth(newMonth));
        this.setUpDateVariables(newDate);
        this.changesEmitEvent('previousMonth');
    }
    nextYear() {
        const newYear = this.bcPlannerYear + 1;
        const newDate = new Date(this.bcPlannerDate.setFullYear(newYear));
        this.setUpDateVariables(newDate);
        this.changesEmitEvent('nextYear');
    }
    previousYear() {
        const newYear = this.bcPlannerYear - 1;
        const newDate = new Date(this.bcPlannerDate.setFullYear(newYear));
        this.setUpDateVariables(newDate);
        this.changesEmitEvent('previousYear');
    }
    /**
     * Asigna la lista de actividades a items y las actualiza en el calendario
     * @param {Array<IBcPlannerItem>} _items
     * @memberof BcPlannerBehavior
     */
    setItems(_items) {
        this.items = _items;
        const dates = this.listUnique(JSON.parse(JSON.stringify(_items)), 'date');
        dates.forEach((element) => {
            this.refreshItemsHtml(new Date(element));
            this.orderItemHtml(new Date(element));
        });
    }
    refreshItemsHtml(date) {
        const _items = JSON.parse(JSON.stringify(this.getItemsxDate(date)));
        _items.forEach((element) => {
            const _date = new Date(element.date);
            const dayElement = document.getElementById(`bc_planner_view_day_${_date.getFullYear()}_${_date.getMonth()}_${_date.getDate()}`);
            if (dayElement) {
                dayElement.firstElementChild.innerHTML = '';
            }
        });
    }
    listUnique(List, Column) {
        const uniques = List.map((data) => data[Column]);
        return uniques.filter((x, i, a) => x && a.indexOf(x) === i).sort();
    }
    setItemHtml(item) {
        const html = this.buildItemHtml(item, `${PLANNER_DAY}-item`);
        const date = new Date(item.date);
        item.date = date;
        const dayElement = document.getElementById(`bc_planner_view_day_${date.getFullYear()}_${date.getMonth()}_${date.getDate()}`);
        if (dayElement) {
            dayElement.firstElementChild.innerHTML += html;
        }
    }
    addEventsItem(Items) {
        Items.forEach((item) => {
            if (item.preview) {
                this.eventPreview(item);
            }
        });
    }
    eventPreview(item) {
        const date = new Date(item.date);
        item.date = date;
        const dayElement = document.getElementById(`bc_planner_view_day_${date.getFullYear()}_${date.getMonth()}_${date.getDate()}`);
        if (dayElement) {
            const elements = dayElement.firstElementChild.querySelectorAll(`p[class$=id_${item.id}]`);
            this.addEvent('click', elements[0], item, 0);
        }
    }
    buildItemHtml(item, nameClass) {
        const color = item.color ? `style="color:${item.color};"` : ``;
        const icon = item.icon ? `<em class="bc-icon" ${color}>${item.icon}</em>` : ``;
        return `<p class="${nameClass} id_${item.id}">
                  ${icon}
                  ${item.title}
                </p>
    `;
    }
    setItemPlus(item, date) {
        const html = `<p class="${PLANNER_DAY}-item ${PLANNER_NAMESPACE}-item-plus">
                   +${item}
                </p>
    `;
        const dayElement = document.getElementById(`bc_planner_view_day_${date.getFullYear()}_${date.getMonth()}_${date.getDate()}`);
        if (dayElement) {
            dayElement.firstElementChild.innerHTML += html;
            const plusE = dayElement.firstElementChild.getElementsByClassName(`${PLANNER_NAMESPACE}-item-plus`)[0];
            plusE.removeEventListener('click', (event) => {
                this.openModalPlanner(date);
            });
            plusE.addEventListener('click', (event) => {
                this.openModalPlanner(date);
            });
        }
    }
    closeModal() {
        this.modalListPlus.closeModal();
    }
    openModalPlanner(date) {
        const Items = this.getItemsxDate(date);
        this.modalListPlus.openModal();
        const modal = this.modalListPlus.getMySelf();
        const thisModal = this.mySelf.querySelector('#modalPlanner1');
        this.mySelf.replaceChild(modal, thisModal);
        this.modifyModal(this.items[0], 1);
        const parent = this.mySelf.querySelector(`div[class=${MODAL_CALENDAR_NAMESPACE}-content]`);
        parent.innerHTML = '';
        Items.forEach((item) => {
            const htmlItem = this.buildItemModalHtml(item, 'bc-modal-planner-item');
            parent.innerHTML += htmlItem;
        });
        this.addEventsEm(Items);
    }
    addEventsEm(Items) {
        Items.forEach((item) => {
            if (item.preview) {
                const em = this.getFirstElementByClassName(`${item.preview.id}`);
                this.addEvent('click', em, item, MODAL_TWO);
            }
        });
    }
    addEvent(_event, elemento, item, op) {
        elemento.removeEventListener(_event, () => {
            this.openModalPreview(item, op);
        });
        elemento.addEventListener(_event, () => {
            this.openModalPreview(item, op);
        });
    }
    buildItemModalHtml(item, nameClass) {
        const color = item.color ? `style="color:${item.color};"` : ``;
        const icon = item.icon ? `<em class="bc-icon" ${color}>${item.icon}</em>` : ``;
        const iconAction = item.preview ? `<em class="bc-icon bc-pointer ${item.preview.id}" >arrow2-right</em>` : ``;
        return `
    <div class="bc-card ${nameClass}">
     ${icon}
      <div class="bc-card-body">
        <p class="bc-card-subtitle bc-align-left">${item.title}</p>
        <p class="bc-card-subtitle-number bc-align-left">${item.text}</p>
      </div>
      ${iconAction}
    </div>`;
    }
    openModalPreview(item, op) {
        this.modalListPlus.openModal();
        const modal = this.modalListPlus.getMySelf();
        const thisModal = this.mySelf.querySelector('#modalPlanner1');
        this.mySelf.replaceChild(modal, thisModal);
        this.modifyModal(item, op);
        const parent = this.mySelf.querySelector(`div[class=${MODAL_CALENDAR_NAMESPACE}-content]`);
        parent.innerHTML = '';
        item.preview.items.forEach((_item) => {
            const htmlItem = this.buildPreviewModalHtml(_item, 'bc-modal-planner-preview');
            parent.innerHTML += htmlItem;
        });
    }
    modifyModal(item, _modal) {
        const childcontainer = document.querySelector('div[class^=bc-modal-button-container]');
        if (childcontainer) {
            const btn = childcontainer.getElementsByTagName('button')[0];
            const btn2 = childcontainer.getElementsByTagName('button')[1];
            if (_modal == 1) {
                this.mModal1(item, btn, btn2);
            }
            else if (_modal == MODAL_TWO || _modal == 0) {
                this.mModal2(item, btn, btn2, _modal);
            }
        }
    }
    mModal1(item, btn, btn2) {
        const title = document.querySelector('div[class^=bc-modal-title]');
        title.firstElementChild.innerHTML =
            this.getDayName(item.date.getDay()) +
                ' ' +
                item.date.getDate() +
                ' de ' +
                this.getMonthName(item.date.getMonth()) +
                ' del ' +
                item.date.getFullYear();
        if (btn) {
            btn.style.display = 'none';
        }
        if (btn2) {
            btn2.innerText = 'CERRAR';
            btn2.classList.replace('bc-button-secondary', 'bc-button-primary');
            btn2.removeEventListener('click', () => {
                this.closeModal();
            });
            btn2.addEventListener('click', () => {
                this.closeModal();
            });
        }
    }
    mModal2(item, btn, btn2, _modal) {
        const title = document.querySelector('div[class^=bc-modal-title]');
        title.firstElementChild.innerHTML = 'Detalle del evento';
        if (btn) {
            btn.style.display = 'inline-block';
            btn.innerText = item.preview.actionText;
            btn.classList.replace('bc-w-25', 'bc-w-50');
            btn.removeEventListener('click', () => {
                this.valueEmitEvent(item);
            });
            btn.addEventListener('click', () => {
                this.valueEmitEvent(item);
            });
        }
        if (btn2) {
            btn2.innerText = 'REGRESAR';
            btn2.classList.replace('bc-button-primary', 'bc-button-secondary');
            if (_modal == MODAL_TWO) {
                btn2.removeEventListener('click', () => {
                    this.openModalPlanner(item.date);
                });
                btn2.addEventListener('click', () => {
                    this.openModalPlanner(item.date);
                });
            }
            else {
                btn2.removeEventListener('click', () => {
                    this.closeModal();
                });
                btn2.addEventListener('click', () => {
                    this.closeModal();
                });
            }
        }
    }
    buildPreviewModalHtml(item, nameClass) {
        return `
    <div class="${nameClass}">
        <p class="small bc-align-left">${item.title}</p>
        <p class="bc-align-left">${item.text}</p>
    </div>`;
    }
    setForitemHtml(_items, _length) {
        for (let i = 0; i < _length; i++) {
            this.setItemHtml(_items[i]);
        }
    }
    orderItemHtml(date) {
        const _items = JSON.parse(JSON.stringify(this.getItemsxDate(date)));
        const twoItems = 2;
        const threeItems = 3;
        const fourItems = 4;
        const sixteen = 16;
        const thirty = 30;
        const thirtyFive = 35;
        let numplus = 0;
        if (_items.length > 1) {
            numplus = this.moreOneitem(_items, thirty, numplus, twoItems, threeItems, fourItems, sixteen);
        }
        else if (_items.length == 1) {
            if (_items[0].title.length > thirtyFive) {
                _items[0].title = _items[0].title.slice(0, thirtyFive) + '...';
                this.setItemHtml(_items[0]);
                numplus = 1;
            }
            else {
                this.setItemHtml(_items[0]);
            }
        }
        if (numplus > 0) {
            this.setItemPlus(numplus.toString(), new Date(_items[0].date));
        }
        this.addEventsItem(_items);
    }
    moreOneitem(_items, thirty, numplus, twoItems, threeItems, fourItems, sixteen) {
        if (_items[0].title.length > thirty) {
            _items[0].title = _items[0].title.slice(0, thirty) + '...';
            this.setItemHtml(_items[0]);
            numplus = _items.length - 1;
        }
        else if (_items.length == twoItems) {
            numplus = this.thowItems(_items, thirty, numplus);
            this.setForitemHtml(_items, _items.length);
        }
        else if (_items.length == threeItems) {
            numplus = this.threeItems(_items, thirty, numplus);
            this.setForitemHtml(_items, _items.length - (numplus > 0 ? 1 : 0));
        }
        else if (_items.length >= fourItems) {
            numplus = this.fourOrMoreItems(_items, fourItems, threeItems, sixteen, numplus);
        }
        return numplus;
    }
    fourOrMoreItems(_items, fourItems, threeItems, sixteen, numplus) {
        if (_items.length == fourItems && _items[threeItems].title.length > sixteen) {
            this.setForitemHtml(_items, _items.length - 1);
            numplus = 1;
        }
        else if (_items.length == fourItems && _items[threeItems].title.length <= sixteen) {
            this.setForitemHtml(_items, _items.length);
        }
        else if (_items.length > fourItems) {
            this.setForitemHtml(_items, fourItems);
        }
        return numplus;
    }
    threeItems(_items, thirty, numplus) {
        if (_items[0].title.length > thirty) {
            _items[0].title = _items[0].title.slice(0, thirty) + '...';
            numplus = _items.length;
        }
        if (_items[1].title.length > thirty) {
            _items[1].title = _items[1].title.slice(0, thirty) + '...';
            numplus = _items.length;
        }
        return numplus;
    }
    thowItems(_items, thirty, numplus) {
        if (_items[0].title.length > thirty) {
            _items[0].title = _items[0].title.slice(0, thirty) + '...';
            numplus = _items.length;
        }
        if (_items[1].title.length > thirty) {
            _items[1].title = _items[1].title.slice(0, thirty) + '...';
            numplus = _items.length;
        }
        return numplus;
    }
    /**
     * Permite guardar los ítems creados en el calendario
     * @param {any} value
     * @memberof BcPlannerBehavior
     */
    setItemsTop(_items) {
        const topElement = this.mySelf.querySelector(`.${PLANNER_TOP}-items`);
        if (topElement) {
            topElement.innerHTML = '';
            _items.forEach((_item) => {
                this.setItemTopHtml(_item, topElement);
            });
        }
    }
    setItemTopHtml(item, topElement) {
        const color = item.color ? `style="color:${item.color} ;"` : ``;
        const icon = item.icon ? `<em class="bc-icon" ${color}>${item.icon}</em>` : ``;
        const html = `<p class="${PLANNER_TOP}-item">
                 ${icon}
                 ${item.title}
                </p>
    `;
        if (topElement) {
            topElement.innerHTML += html;
        }
    }
    getItems() {
        return this.items;
    }
    getItemsxDate(date) {
        return this.items.filter((a) => {
            if (a.date.getMonth() == date.getMonth() &&
                a.date.getFullYear() == date.getFullYear() &&
                a.date.getDate() == date.getDate()) {
                return true;
            }
            return false;
        });
    }
    getItem(id) {
        const result = this.items.filter((i) => i.id == id);
        if (result.length > 0) {
            return result[0];
        }
        return null;
    }
    changesEmitEvent(action) {
        const values = {
            action: action,
            monthValue: this.getMonth(),
            yearValue: this.getYear(),
        };
        if (this.outputChanges) {
            this.outputChanges(values);
        }
    }
    valueEmitEvent(item) {
        if (this.outputValues) {
            this.outputValues(item.preview.dataReturn);
        }
    }
}

function toNodeList(arrayOfNodes) {
    const fragment = document.createDocumentFragment();
    arrayOfNodes.forEach(function (item) {
        fragment.appendChild(item.cloneNode(true));
    });
    return fragment.childNodes;
}

/**
 * Generated bundle index. Do not edit.
 */

export { ACCORDION_CONTENT_CLASS, ACTIVE_CLASS, ACTIVE_STATE, ARROW_BUTTONS, AVATAR_PUFFY, AVATAR_SMALL, BC_AVATAR_NULL_SRC, BC_EXPANSION_ICON_DOWN, BC_EXPANSION_ICON_UP, BC_EXPANSION_PANEL_CONTENT_SELECTOR, BC_EXPANSION_PANEL_CONTENT_WRAPPER_SELECTOR, BC_EXPANSION_PANEL_FOOTER_ICON_SELECTOR, BC_EXPANSION_PANEL_FOOTER_SELECTOR, BC_EXPANSION_PANEL_HEADER_SELECTOR, BC_EXPANSION_PANEL_SELECTOR, BC_PAGE_HEADER_BACK_BUTTON, BC_PAGE_HEADER_BREADCRUMB_SELECTOR, BC_PAGE_HEADER_BUTTONS_RIGHT, BC_PAGE_HEADER_SELECTOR, BC_PAGE_MAX_ITEMS_BREADCRUMB_VISIBLE, BC_TOOLTIP_ARROW_CLASS, BC_TOOLTIP_BUTTON_BOTTOM, BC_TOOLTIP_BUTTON_CLASS, BC_TOOLTIP_BUTTON_CLASS_TYPE, BC_TOOLTIP_BUTTON_CLOSE_CLASS, BC_TOOLTIP_BUTTON_LEFT, BC_TOOLTIP_BUTTON_RIGHT, BC_TOOLTIP_BUTTON_TEXT_ATTRIBUTE, BC_TOOLTIP_BUTTON_TOP, BC_TOOLTIP_CONTAINER_SELECTOR, BC_TOOLTIP_DIVIDER_CLASS, BC_TOOLTIP_EIGHT, BC_TOOLTIP_PARENT_ELEMENT_CLASS, BC_TOOLTIP_POSITION_ATTRIBUTE, BC_TOOLTIP_SELECTOR, BC_TOOLTIP_TEXT_ATTRIBUTE, BC_TOOLTIP_TITLE_ATTRIBUTE, BC_TOOLTIP_TWO, BcAccordionBehavior, BcAlertBehavior, BcAvatarBehavior, BcBadgeBehavior, BcButtonGroupBehavior, BcCalendarBehavior, BcCalendarRangeBehavior, BcCardAuthenticationBehavior, BcCardPrimaryBehavior, BcCardProductBehavior, BcCardSelectBehavior, BcCardTdcBehavior, BcCardType, BcCarouselBehavior, BcCheckboxBehavior, BcCheckboxConstants, BcCircleLoadingBehavior, BcCoachMarkBehavior, BcCommonConstants, BcDefaultBehavior, BcDropdownBehavior, BcExpansionPanelBehavior, BcFileDownloadBehavior, BcFloatMenuBehavior, BcFooterBehavior, BcHTMLSanitizer, BcHeaderBehavior, BcInlineAlertBehavior, BcInputBehavior, BcInputCreateBehavior, BcInputCurrencyBehavior, BcInputDateBehavior, BcInputDateRangeBehavior, BcInputFileBehavior, BcInputNumberBehavior, BcInputSelectBehavior, BcInputTokenBehavior, BcListBehavior, BcListRowBehavior, BcMenuBehavior, BcMenuGenerator, BcMenuTabsVerticalBehavior, BcModalBehavior, BcNotificationBehavior, BcOffCanvasBehavior, BcPageHeaderBehavior, BcPaginatorBehavior, BcPlannerBehavior, BcPopOverBehavior, BcProgressBarBehavior, BcScrollerBehavior, BcSearchBehavior, BcSidebarBehavior, BcSkipLinkBehavior, BcSliderBehavior, BcSliderDoubleBehavior, BcStepperBehavior, BcTableAccordionBehavior, BcTableBaseBehavior, BcTableConstansts, BcTableConstanstsSpec, BcTableScrollBehavior, BcTabsGroupBehavior, BcTagBehavior, BcTooltipBehavior, BcTotalValueBehavior, COLLAPSED_STATE, COMMON_CONSTANTS_NUMBERS, CardPrimaryType, DAYS, ELEMENT_AVATAR_CLASS, ELEMENT_IS_INVALID, FIVE_LENGTH, FORM_FIELD, FOUR_LENGTH, HIDE_CLASS, ICON, ICONS_LEFT, ICONS_RIGHT, ICON_LEFT, ICON_LEFT_ERROR, ICON_RIGHT, ICON_RIGHT_ERROR, ICON_VALID, ID_NOT_FOUND, INPUT, INPUT_AREA, INPUT_ERROR, INPUT_SUCCESS, INPUT_VALID, INVALID_FEEDBACK, LEFT, MEDIUM_WIDTH, METHOD_NOT_IMPLEMENTED, MIN_WIDTH, MODAL_CALENDAR_NAME, MODAL_CALENDAR_NAMESPACE, MODAL_TWO, MOLECULA, MONTHS, NEXT_CLASS, NOT_LABELS_ERROR, NOT_LABEL_HEADER_ERROR, ONE_HUNDRED, OPEN_STATE, OUTLINE_ELEMENT_CLASS, PLANNER_DAY, PLANNER_HEADER, PLANNER_MONTHS, PLANNER_NAME, PLANNER_NAMESPACE, PLANNER_TOP, PLANNER_WEEK, PLANNER_YEARS, PREV_CLASS, SIX_LENGTH, SPAN_INFO, SRC_TAG, SVG_DEFAULT, TAB_BODY_CLASS, TAB_CLASS, TAB_CONTAINER_CLASS, TAB_CONTENT_CLASS, TAB_HEADER_CLASS, ThemeCircles, VALID_FEEBACK, _ICON_LEFT, _ICON_RIGHT, addFocusable, addFocusableAttributes, changeAriaControlsValue, changeAriaExpandedValue, createElement, getId, isMobileDevice, replaceClass, toArray, toNodeList };
